
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

      var $parcel$global = globalThis;
    
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequireba3e"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequireba3e"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("btLjt", function(module, exports) {

$parcel$export(module.exports, "Fragment", () => $85b71a846da59dfb$export$ffb0004e005737fa, (v) => $85b71a846da59dfb$export$ffb0004e005737fa = v);
$parcel$export(module.exports, "jsx", () => $85b71a846da59dfb$export$34b9dba7ce09269b, (v) => $85b71a846da59dfb$export$34b9dba7ce09269b = v);
$parcel$export(module.exports, "jsxs", () => $85b71a846da59dfb$export$25062201e9e25d76, (v) => $85b71a846da59dfb$export$25062201e9e25d76 = v);
/**
 * @license React
 * react-jsx-runtime.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $85b71a846da59dfb$export$ffb0004e005737fa;
var $85b71a846da59dfb$export$34b9dba7ce09269b;
var $85b71a846da59dfb$export$25062201e9e25d76;
"use strict";

var $cWbtJ = parcelRequire("cWbtJ");
var $85b71a846da59dfb$var$k = Symbol.for("react.element"), $85b71a846da59dfb$var$l = Symbol.for("react.fragment"), $85b71a846da59dfb$var$m = Object.prototype.hasOwnProperty, $85b71a846da59dfb$var$n = $cWbtJ.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner, $85b71a846da59dfb$var$p = {
    key: !0,
    ref: !0,
    __self: !0,
    __source: !0
};
function $85b71a846da59dfb$var$q(c, a, g) {
    var b, d = {}, e = null, h = null;
    void 0 !== g && (e = "" + g);
    void 0 !== a.key && (e = "" + a.key);
    void 0 !== a.ref && (h = a.ref);
    for(b in a)$85b71a846da59dfb$var$m.call(a, b) && !$85b71a846da59dfb$var$p.hasOwnProperty(b) && (d[b] = a[b]);
    if (c && c.defaultProps) for(b in a = c.defaultProps, a)void 0 === d[b] && (d[b] = a[b]);
    return {
        $$typeof: $85b71a846da59dfb$var$k,
        type: c,
        key: e,
        ref: h,
        props: d,
        _owner: $85b71a846da59dfb$var$n.current
    };
}
$85b71a846da59dfb$export$ffb0004e005737fa = $85b71a846da59dfb$var$l;
$85b71a846da59dfb$export$34b9dba7ce09269b = $85b71a846da59dfb$var$q;
$85b71a846da59dfb$export$25062201e9e25d76 = $85b71a846da59dfb$var$q;

});
parcelRegister("cWbtJ", function(module, exports) {
"use strict";

module.exports = (parcelRequire("cFGGe"));

});
parcelRegister("cFGGe", function(module, exports) {

$parcel$export(module.exports, "Children", () => $939a6bc5bef1f0c7$export$dca3b0875bd9a954, (v) => $939a6bc5bef1f0c7$export$dca3b0875bd9a954 = v);
$parcel$export(module.exports, "Component", () => $939a6bc5bef1f0c7$export$16fa2f45be04daa8, (v) => $939a6bc5bef1f0c7$export$16fa2f45be04daa8 = v);
$parcel$export(module.exports, "Fragment", () => $939a6bc5bef1f0c7$export$ffb0004e005737fa, (v) => $939a6bc5bef1f0c7$export$ffb0004e005737fa = v);
$parcel$export(module.exports, "Profiler", () => $939a6bc5bef1f0c7$export$e2c29f18771995cb, (v) => $939a6bc5bef1f0c7$export$e2c29f18771995cb = v);
$parcel$export(module.exports, "PureComponent", () => $939a6bc5bef1f0c7$export$221d75b3f55bb0bd, (v) => $939a6bc5bef1f0c7$export$221d75b3f55bb0bd = v);
$parcel$export(module.exports, "StrictMode", () => $939a6bc5bef1f0c7$export$5f8d39834fd61797, (v) => $939a6bc5bef1f0c7$export$5f8d39834fd61797 = v);
$parcel$export(module.exports, "Suspense", () => $939a6bc5bef1f0c7$export$74bf444e3cd11ea5, (v) => $939a6bc5bef1f0c7$export$74bf444e3cd11ea5 = v);
$parcel$export(module.exports, "__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED", () => $939a6bc5bef1f0c7$export$ae55be85d98224ed, (v) => $939a6bc5bef1f0c7$export$ae55be85d98224ed = v);
$parcel$export(module.exports, "act", () => $939a6bc5bef1f0c7$export$3ba232387fd5d6dd, (v) => $939a6bc5bef1f0c7$export$3ba232387fd5d6dd = v);
$parcel$export(module.exports, "cloneElement", () => $939a6bc5bef1f0c7$export$e530037191fcd5d7, (v) => $939a6bc5bef1f0c7$export$e530037191fcd5d7 = v);
$parcel$export(module.exports, "createContext", () => $939a6bc5bef1f0c7$export$fd42f52fd3ae1109, (v) => $939a6bc5bef1f0c7$export$fd42f52fd3ae1109 = v);
$parcel$export(module.exports, "createElement", () => $939a6bc5bef1f0c7$export$c8a8987d4410bf2d, (v) => $939a6bc5bef1f0c7$export$c8a8987d4410bf2d = v);
$parcel$export(module.exports, "createFactory", () => $939a6bc5bef1f0c7$export$d38cd72104c1f0e9, (v) => $939a6bc5bef1f0c7$export$d38cd72104c1f0e9 = v);
$parcel$export(module.exports, "createRef", () => $939a6bc5bef1f0c7$export$7d1e3a5e95ceca43, (v) => $939a6bc5bef1f0c7$export$7d1e3a5e95ceca43 = v);
$parcel$export(module.exports, "forwardRef", () => $939a6bc5bef1f0c7$export$257a8862b851cb5b, (v) => $939a6bc5bef1f0c7$export$257a8862b851cb5b = v);
$parcel$export(module.exports, "isValidElement", () => $939a6bc5bef1f0c7$export$a8257692ac88316c, (v) => $939a6bc5bef1f0c7$export$a8257692ac88316c = v);
$parcel$export(module.exports, "lazy", () => $939a6bc5bef1f0c7$export$488013bae63b21da, (v) => $939a6bc5bef1f0c7$export$488013bae63b21da = v);
$parcel$export(module.exports, "memo", () => $939a6bc5bef1f0c7$export$7c73462e0d25e514, (v) => $939a6bc5bef1f0c7$export$7c73462e0d25e514 = v);
$parcel$export(module.exports, "startTransition", () => $939a6bc5bef1f0c7$export$7568632d0d33d16d, (v) => $939a6bc5bef1f0c7$export$7568632d0d33d16d = v);
$parcel$export(module.exports, "unstable_act", () => $939a6bc5bef1f0c7$export$88948ce120ea2619, (v) => $939a6bc5bef1f0c7$export$88948ce120ea2619 = v);
$parcel$export(module.exports, "useCallback", () => $939a6bc5bef1f0c7$export$35808ee640e87ca7, (v) => $939a6bc5bef1f0c7$export$35808ee640e87ca7 = v);
$parcel$export(module.exports, "useContext", () => $939a6bc5bef1f0c7$export$fae74005e78b1a27, (v) => $939a6bc5bef1f0c7$export$fae74005e78b1a27 = v);
$parcel$export(module.exports, "useDebugValue", () => $939a6bc5bef1f0c7$export$dc8fbce3eb94dc1e, (v) => $939a6bc5bef1f0c7$export$dc8fbce3eb94dc1e = v);
$parcel$export(module.exports, "useDeferredValue", () => $939a6bc5bef1f0c7$export$6a7bc4e911dc01cf, (v) => $939a6bc5bef1f0c7$export$6a7bc4e911dc01cf = v);
$parcel$export(module.exports, "useEffect", () => $939a6bc5bef1f0c7$export$6d9c69b0de29b591, (v) => $939a6bc5bef1f0c7$export$6d9c69b0de29b591 = v);
$parcel$export(module.exports, "useId", () => $939a6bc5bef1f0c7$export$f680877a34711e37, (v) => $939a6bc5bef1f0c7$export$f680877a34711e37 = v);
$parcel$export(module.exports, "useImperativeHandle", () => $939a6bc5bef1f0c7$export$d5a552a76deda3c2, (v) => $939a6bc5bef1f0c7$export$d5a552a76deda3c2 = v);
$parcel$export(module.exports, "useInsertionEffect", () => $939a6bc5bef1f0c7$export$aaabe4eda9ed9969, (v) => $939a6bc5bef1f0c7$export$aaabe4eda9ed9969 = v);
$parcel$export(module.exports, "useLayoutEffect", () => $939a6bc5bef1f0c7$export$e5c5a5f917a5871c, (v) => $939a6bc5bef1f0c7$export$e5c5a5f917a5871c = v);
$parcel$export(module.exports, "useMemo", () => $939a6bc5bef1f0c7$export$1538c33de8887b59, (v) => $939a6bc5bef1f0c7$export$1538c33de8887b59 = v);
$parcel$export(module.exports, "useReducer", () => $939a6bc5bef1f0c7$export$13e3392192263954, (v) => $939a6bc5bef1f0c7$export$13e3392192263954 = v);
$parcel$export(module.exports, "useRef", () => $939a6bc5bef1f0c7$export$b8f5890fc79d6aca, (v) => $939a6bc5bef1f0c7$export$b8f5890fc79d6aca = v);
$parcel$export(module.exports, "useState", () => $939a6bc5bef1f0c7$export$60241385465d0a34, (v) => $939a6bc5bef1f0c7$export$60241385465d0a34 = v);
$parcel$export(module.exports, "useSyncExternalStore", () => $939a6bc5bef1f0c7$export$306c0aa65ff9ec16, (v) => $939a6bc5bef1f0c7$export$306c0aa65ff9ec16 = v);
$parcel$export(module.exports, "useTransition", () => $939a6bc5bef1f0c7$export$7b286972b8d8ccbf, (v) => $939a6bc5bef1f0c7$export$7b286972b8d8ccbf = v);
$parcel$export(module.exports, "version", () => $939a6bc5bef1f0c7$export$83d89fbfd8236492, (v) => $939a6bc5bef1f0c7$export$83d89fbfd8236492 = v);
/**
 * @license React
 * react.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $939a6bc5bef1f0c7$export$dca3b0875bd9a954;
var $939a6bc5bef1f0c7$export$16fa2f45be04daa8;
var $939a6bc5bef1f0c7$export$ffb0004e005737fa;
var $939a6bc5bef1f0c7$export$e2c29f18771995cb;
var $939a6bc5bef1f0c7$export$221d75b3f55bb0bd;
var $939a6bc5bef1f0c7$export$5f8d39834fd61797;
var $939a6bc5bef1f0c7$export$74bf444e3cd11ea5;
var $939a6bc5bef1f0c7$export$ae55be85d98224ed;
var $939a6bc5bef1f0c7$export$3ba232387fd5d6dd;
var $939a6bc5bef1f0c7$export$e530037191fcd5d7;
var $939a6bc5bef1f0c7$export$fd42f52fd3ae1109;
var $939a6bc5bef1f0c7$export$c8a8987d4410bf2d;
var $939a6bc5bef1f0c7$export$d38cd72104c1f0e9;
var $939a6bc5bef1f0c7$export$7d1e3a5e95ceca43;
var $939a6bc5bef1f0c7$export$257a8862b851cb5b;
var $939a6bc5bef1f0c7$export$a8257692ac88316c;
var $939a6bc5bef1f0c7$export$488013bae63b21da;
var $939a6bc5bef1f0c7$export$7c73462e0d25e514;
var $939a6bc5bef1f0c7$export$7568632d0d33d16d;
var $939a6bc5bef1f0c7$export$88948ce120ea2619;
var $939a6bc5bef1f0c7$export$35808ee640e87ca7;
var $939a6bc5bef1f0c7$export$fae74005e78b1a27;
var $939a6bc5bef1f0c7$export$dc8fbce3eb94dc1e;
var $939a6bc5bef1f0c7$export$6a7bc4e911dc01cf;
var $939a6bc5bef1f0c7$export$6d9c69b0de29b591;
var $939a6bc5bef1f0c7$export$f680877a34711e37;
var $939a6bc5bef1f0c7$export$d5a552a76deda3c2;
var $939a6bc5bef1f0c7$export$aaabe4eda9ed9969;
var $939a6bc5bef1f0c7$export$e5c5a5f917a5871c;
var $939a6bc5bef1f0c7$export$1538c33de8887b59;
var $939a6bc5bef1f0c7$export$13e3392192263954;
var $939a6bc5bef1f0c7$export$b8f5890fc79d6aca;
var $939a6bc5bef1f0c7$export$60241385465d0a34;
var $939a6bc5bef1f0c7$export$306c0aa65ff9ec16;
var $939a6bc5bef1f0c7$export$7b286972b8d8ccbf;
var $939a6bc5bef1f0c7$export$83d89fbfd8236492;
"use strict";
var $939a6bc5bef1f0c7$var$l = Symbol.for("react.element"), $939a6bc5bef1f0c7$var$n = Symbol.for("react.portal"), $939a6bc5bef1f0c7$var$p = Symbol.for("react.fragment"), $939a6bc5bef1f0c7$var$q = Symbol.for("react.strict_mode"), $939a6bc5bef1f0c7$var$r = Symbol.for("react.profiler"), $939a6bc5bef1f0c7$var$t = Symbol.for("react.provider"), $939a6bc5bef1f0c7$var$u = Symbol.for("react.context"), $939a6bc5bef1f0c7$var$v = Symbol.for("react.forward_ref"), $939a6bc5bef1f0c7$var$w = Symbol.for("react.suspense"), $939a6bc5bef1f0c7$var$x = Symbol.for("react.memo"), $939a6bc5bef1f0c7$var$y = Symbol.for("react.lazy"), $939a6bc5bef1f0c7$var$z = Symbol.iterator;
function $939a6bc5bef1f0c7$var$A(a) {
    if (null === a || "object" !== typeof a) return null;
    a = $939a6bc5bef1f0c7$var$z && a[$939a6bc5bef1f0c7$var$z] || a["@@iterator"];
    return "function" === typeof a ? a : null;
}
var $939a6bc5bef1f0c7$var$B = {
    isMounted: function() {
        return !1;
    },
    enqueueForceUpdate: function() {},
    enqueueReplaceState: function() {},
    enqueueSetState: function() {}
}, $939a6bc5bef1f0c7$var$C = Object.assign, $939a6bc5bef1f0c7$var$D = {};
function $939a6bc5bef1f0c7$var$E(a, b, e) {
    this.props = a;
    this.context = b;
    this.refs = $939a6bc5bef1f0c7$var$D;
    this.updater = e || $939a6bc5bef1f0c7$var$B;
}
$939a6bc5bef1f0c7$var$E.prototype.isReactComponent = {};
$939a6bc5bef1f0c7$var$E.prototype.setState = function(a, b) {
    if ("object" !== typeof a && "function" !== typeof a && null != a) throw Error("setState(...): takes an object of state variables to update or a function which returns an object of state variables.");
    this.updater.enqueueSetState(this, a, b, "setState");
};
$939a6bc5bef1f0c7$var$E.prototype.forceUpdate = function(a) {
    this.updater.enqueueForceUpdate(this, a, "forceUpdate");
};
function $939a6bc5bef1f0c7$var$F() {}
$939a6bc5bef1f0c7$var$F.prototype = $939a6bc5bef1f0c7$var$E.prototype;
function $939a6bc5bef1f0c7$var$G(a, b, e) {
    this.props = a;
    this.context = b;
    this.refs = $939a6bc5bef1f0c7$var$D;
    this.updater = e || $939a6bc5bef1f0c7$var$B;
}
var $939a6bc5bef1f0c7$var$H = $939a6bc5bef1f0c7$var$G.prototype = new $939a6bc5bef1f0c7$var$F;
$939a6bc5bef1f0c7$var$H.constructor = $939a6bc5bef1f0c7$var$G;
$939a6bc5bef1f0c7$var$C($939a6bc5bef1f0c7$var$H, $939a6bc5bef1f0c7$var$E.prototype);
$939a6bc5bef1f0c7$var$H.isPureReactComponent = !0;
var $939a6bc5bef1f0c7$var$I = Array.isArray, $939a6bc5bef1f0c7$var$J = Object.prototype.hasOwnProperty, $939a6bc5bef1f0c7$var$K = {
    current: null
}, $939a6bc5bef1f0c7$var$L = {
    key: !0,
    ref: !0,
    __self: !0,
    __source: !0
};
function $939a6bc5bef1f0c7$var$M(a, b, e) {
    var d, c = {}, k = null, h = null;
    if (null != b) for(d in void 0 !== b.ref && (h = b.ref), void 0 !== b.key && (k = "" + b.key), b)$939a6bc5bef1f0c7$var$J.call(b, d) && !$939a6bc5bef1f0c7$var$L.hasOwnProperty(d) && (c[d] = b[d]);
    var g = arguments.length - 2;
    if (1 === g) c.children = e;
    else if (1 < g) {
        for(var f = Array(g), m = 0; m < g; m++)f[m] = arguments[m + 2];
        c.children = f;
    }
    if (a && a.defaultProps) for(d in g = a.defaultProps, g)void 0 === c[d] && (c[d] = g[d]);
    return {
        $$typeof: $939a6bc5bef1f0c7$var$l,
        type: a,
        key: k,
        ref: h,
        props: c,
        _owner: $939a6bc5bef1f0c7$var$K.current
    };
}
function $939a6bc5bef1f0c7$var$N(a, b) {
    return {
        $$typeof: $939a6bc5bef1f0c7$var$l,
        type: a.type,
        key: b,
        ref: a.ref,
        props: a.props,
        _owner: a._owner
    };
}
function $939a6bc5bef1f0c7$var$O(a) {
    return "object" === typeof a && null !== a && a.$$typeof === $939a6bc5bef1f0c7$var$l;
}
function $939a6bc5bef1f0c7$var$escape(a) {
    var b = {
        "=": "=0",
        ":": "=2"
    };
    return "$" + a.replace(/[=:]/g, function(a) {
        return b[a];
    });
}
var $939a6bc5bef1f0c7$var$P = /\/+/g;
function $939a6bc5bef1f0c7$var$Q(a, b) {
    return "object" === typeof a && null !== a && null != a.key ? $939a6bc5bef1f0c7$var$escape("" + a.key) : b.toString(36);
}
function $939a6bc5bef1f0c7$var$R(a, b, e, d, c) {
    var k = typeof a;
    if ("undefined" === k || "boolean" === k) a = null;
    var h = !1;
    if (null === a) h = !0;
    else switch(k){
        case "string":
        case "number":
            h = !0;
            break;
        case "object":
            switch(a.$$typeof){
                case $939a6bc5bef1f0c7$var$l:
                case $939a6bc5bef1f0c7$var$n:
                    h = !0;
            }
    }
    if (h) return h = a, c = c(h), a = "" === d ? "." + $939a6bc5bef1f0c7$var$Q(h, 0) : d, $939a6bc5bef1f0c7$var$I(c) ? (e = "", null != a && (e = a.replace($939a6bc5bef1f0c7$var$P, "$&/") + "/"), $939a6bc5bef1f0c7$var$R(c, b, e, "", function(a) {
        return a;
    })) : null != c && ($939a6bc5bef1f0c7$var$O(c) && (c = $939a6bc5bef1f0c7$var$N(c, e + (!c.key || h && h.key === c.key ? "" : ("" + c.key).replace($939a6bc5bef1f0c7$var$P, "$&/") + "/") + a)), b.push(c)), 1;
    h = 0;
    d = "" === d ? "." : d + ":";
    if ($939a6bc5bef1f0c7$var$I(a)) for(var g = 0; g < a.length; g++){
        k = a[g];
        var f = d + $939a6bc5bef1f0c7$var$Q(k, g);
        h += $939a6bc5bef1f0c7$var$R(k, b, e, f, c);
    }
    else if (f = $939a6bc5bef1f0c7$var$A(a), "function" === typeof f) for(a = f.call(a), g = 0; !(k = a.next()).done;)k = k.value, f = d + $939a6bc5bef1f0c7$var$Q(k, g++), h += $939a6bc5bef1f0c7$var$R(k, b, e, f, c);
    else if ("object" === k) throw b = String(a), Error("Objects are not valid as a React child (found: " + ("[object Object]" === b ? "object with keys {" + Object.keys(a).join(", ") + "}" : b) + "). If you meant to render a collection of children, use an array instead.");
    return h;
}
function $939a6bc5bef1f0c7$var$S(a, b, e) {
    if (null == a) return a;
    var d = [], c = 0;
    $939a6bc5bef1f0c7$var$R(a, d, "", "", function(a) {
        return b.call(e, a, c++);
    });
    return d;
}
function $939a6bc5bef1f0c7$var$T(a) {
    if (-1 === a._status) {
        var b = a._result;
        b = b();
        b.then(function(b) {
            if (0 === a._status || -1 === a._status) a._status = 1, a._result = b;
        }, function(b) {
            if (0 === a._status || -1 === a._status) a._status = 2, a._result = b;
        });
        -1 === a._status && (a._status = 0, a._result = b);
    }
    if (1 === a._status) return a._result.default;
    throw a._result;
}
var $939a6bc5bef1f0c7$var$U = {
    current: null
}, $939a6bc5bef1f0c7$var$V = {
    transition: null
}, $939a6bc5bef1f0c7$var$W = {
    ReactCurrentDispatcher: $939a6bc5bef1f0c7$var$U,
    ReactCurrentBatchConfig: $939a6bc5bef1f0c7$var$V,
    ReactCurrentOwner: $939a6bc5bef1f0c7$var$K
};
function $939a6bc5bef1f0c7$var$X() {
    throw Error("act(...) is not supported in production builds of React.");
}
$939a6bc5bef1f0c7$export$dca3b0875bd9a954 = {
    map: $939a6bc5bef1f0c7$var$S,
    forEach: function(a, b, e) {
        $939a6bc5bef1f0c7$var$S(a, function() {
            b.apply(this, arguments);
        }, e);
    },
    count: function(a) {
        var b = 0;
        $939a6bc5bef1f0c7$var$S(a, function() {
            b++;
        });
        return b;
    },
    toArray: function(a) {
        return $939a6bc5bef1f0c7$var$S(a, function(a) {
            return a;
        }) || [];
    },
    only: function(a) {
        if (!$939a6bc5bef1f0c7$var$O(a)) throw Error("React.Children.only expected to receive a single React element child.");
        return a;
    }
};
$939a6bc5bef1f0c7$export$16fa2f45be04daa8 = $939a6bc5bef1f0c7$var$E;
$939a6bc5bef1f0c7$export$ffb0004e005737fa = $939a6bc5bef1f0c7$var$p;
$939a6bc5bef1f0c7$export$e2c29f18771995cb = $939a6bc5bef1f0c7$var$r;
$939a6bc5bef1f0c7$export$221d75b3f55bb0bd = $939a6bc5bef1f0c7$var$G;
$939a6bc5bef1f0c7$export$5f8d39834fd61797 = $939a6bc5bef1f0c7$var$q;
$939a6bc5bef1f0c7$export$74bf444e3cd11ea5 = $939a6bc5bef1f0c7$var$w;
$939a6bc5bef1f0c7$export$ae55be85d98224ed = $939a6bc5bef1f0c7$var$W;
$939a6bc5bef1f0c7$export$3ba232387fd5d6dd = $939a6bc5bef1f0c7$var$X;
$939a6bc5bef1f0c7$export$e530037191fcd5d7 = function(a, b, e) {
    if (null === a || void 0 === a) throw Error("React.cloneElement(...): The argument must be a React element, but you passed " + a + ".");
    var d = $939a6bc5bef1f0c7$var$C({}, a.props), c = a.key, k = a.ref, h = a._owner;
    if (null != b) {
        void 0 !== b.ref && (k = b.ref, h = $939a6bc5bef1f0c7$var$K.current);
        void 0 !== b.key && (c = "" + b.key);
        if (a.type && a.type.defaultProps) var g = a.type.defaultProps;
        for(f in b)$939a6bc5bef1f0c7$var$J.call(b, f) && !$939a6bc5bef1f0c7$var$L.hasOwnProperty(f) && (d[f] = void 0 === b[f] && void 0 !== g ? g[f] : b[f]);
    }
    var f = arguments.length - 2;
    if (1 === f) d.children = e;
    else if (1 < f) {
        g = Array(f);
        for(var m = 0; m < f; m++)g[m] = arguments[m + 2];
        d.children = g;
    }
    return {
        $$typeof: $939a6bc5bef1f0c7$var$l,
        type: a.type,
        key: c,
        ref: k,
        props: d,
        _owner: h
    };
};
$939a6bc5bef1f0c7$export$fd42f52fd3ae1109 = function(a) {
    a = {
        $$typeof: $939a6bc5bef1f0c7$var$u,
        _currentValue: a,
        _currentValue2: a,
        _threadCount: 0,
        Provider: null,
        Consumer: null,
        _defaultValue: null,
        _globalName: null
    };
    a.Provider = {
        $$typeof: $939a6bc5bef1f0c7$var$t,
        _context: a
    };
    return a.Consumer = a;
};
$939a6bc5bef1f0c7$export$c8a8987d4410bf2d = $939a6bc5bef1f0c7$var$M;
$939a6bc5bef1f0c7$export$d38cd72104c1f0e9 = function(a) {
    var b = $939a6bc5bef1f0c7$var$M.bind(null, a);
    b.type = a;
    return b;
};
$939a6bc5bef1f0c7$export$7d1e3a5e95ceca43 = function() {
    return {
        current: null
    };
};
$939a6bc5bef1f0c7$export$257a8862b851cb5b = function(a) {
    return {
        $$typeof: $939a6bc5bef1f0c7$var$v,
        render: a
    };
};
$939a6bc5bef1f0c7$export$a8257692ac88316c = $939a6bc5bef1f0c7$var$O;
$939a6bc5bef1f0c7$export$488013bae63b21da = function(a) {
    return {
        $$typeof: $939a6bc5bef1f0c7$var$y,
        _payload: {
            _status: -1,
            _result: a
        },
        _init: $939a6bc5bef1f0c7$var$T
    };
};
$939a6bc5bef1f0c7$export$7c73462e0d25e514 = function(a, b) {
    return {
        $$typeof: $939a6bc5bef1f0c7$var$x,
        type: a,
        compare: void 0 === b ? null : b
    };
};
$939a6bc5bef1f0c7$export$7568632d0d33d16d = function(a) {
    var b = $939a6bc5bef1f0c7$var$V.transition;
    $939a6bc5bef1f0c7$var$V.transition = {};
    try {
        a();
    } finally{
        $939a6bc5bef1f0c7$var$V.transition = b;
    }
};
$939a6bc5bef1f0c7$export$88948ce120ea2619 = $939a6bc5bef1f0c7$var$X;
$939a6bc5bef1f0c7$export$35808ee640e87ca7 = function(a, b) {
    return $939a6bc5bef1f0c7$var$U.current.useCallback(a, b);
};
$939a6bc5bef1f0c7$export$fae74005e78b1a27 = function(a) {
    return $939a6bc5bef1f0c7$var$U.current.useContext(a);
};
$939a6bc5bef1f0c7$export$dc8fbce3eb94dc1e = function() {};
$939a6bc5bef1f0c7$export$6a7bc4e911dc01cf = function(a) {
    return $939a6bc5bef1f0c7$var$U.current.useDeferredValue(a);
};
$939a6bc5bef1f0c7$export$6d9c69b0de29b591 = function(a, b) {
    return $939a6bc5bef1f0c7$var$U.current.useEffect(a, b);
};
$939a6bc5bef1f0c7$export$f680877a34711e37 = function() {
    return $939a6bc5bef1f0c7$var$U.current.useId();
};
$939a6bc5bef1f0c7$export$d5a552a76deda3c2 = function(a, b, e) {
    return $939a6bc5bef1f0c7$var$U.current.useImperativeHandle(a, b, e);
};
$939a6bc5bef1f0c7$export$aaabe4eda9ed9969 = function(a, b) {
    return $939a6bc5bef1f0c7$var$U.current.useInsertionEffect(a, b);
};
$939a6bc5bef1f0c7$export$e5c5a5f917a5871c = function(a, b) {
    return $939a6bc5bef1f0c7$var$U.current.useLayoutEffect(a, b);
};
$939a6bc5bef1f0c7$export$1538c33de8887b59 = function(a, b) {
    return $939a6bc5bef1f0c7$var$U.current.useMemo(a, b);
};
$939a6bc5bef1f0c7$export$13e3392192263954 = function(a, b, e) {
    return $939a6bc5bef1f0c7$var$U.current.useReducer(a, b, e);
};
$939a6bc5bef1f0c7$export$b8f5890fc79d6aca = function(a) {
    return $939a6bc5bef1f0c7$var$U.current.useRef(a);
};
$939a6bc5bef1f0c7$export$60241385465d0a34 = function(a) {
    return $939a6bc5bef1f0c7$var$U.current.useState(a);
};
$939a6bc5bef1f0c7$export$306c0aa65ff9ec16 = function(a, b, e) {
    return $939a6bc5bef1f0c7$var$U.current.useSyncExternalStore(a, b, e);
};
$939a6bc5bef1f0c7$export$7b286972b8d8ccbf = function() {
    return $939a6bc5bef1f0c7$var$U.current.useTransition();
};
$939a6bc5bef1f0c7$export$83d89fbfd8236492 = "18.3.1";

});



parcelRegister("hd0Er", function(module, exports) {

$parcel$export(module.exports, "__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED", () => $c87427e8b303c517$export$ae55be85d98224ed, (v) => $c87427e8b303c517$export$ae55be85d98224ed = v);
$parcel$export(module.exports, "createPortal", () => $c87427e8b303c517$export$d39a5bbd09211389, (v) => $c87427e8b303c517$export$d39a5bbd09211389 = v);
$parcel$export(module.exports, "createRoot", () => $c87427e8b303c517$export$882461b6382ed46c, (v) => $c87427e8b303c517$export$882461b6382ed46c = v);
$parcel$export(module.exports, "findDOMNode", () => $c87427e8b303c517$export$466bfc07425424d5, (v) => $c87427e8b303c517$export$466bfc07425424d5 = v);
$parcel$export(module.exports, "flushSync", () => $c87427e8b303c517$export$cd75ccfd720a3cd4, (v) => $c87427e8b303c517$export$cd75ccfd720a3cd4 = v);
$parcel$export(module.exports, "hydrate", () => $c87427e8b303c517$export$fa8d919ba61d84db, (v) => $c87427e8b303c517$export$fa8d919ba61d84db = v);
$parcel$export(module.exports, "hydrateRoot", () => $c87427e8b303c517$export$757ceba2d55c277e, (v) => $c87427e8b303c517$export$757ceba2d55c277e = v);
$parcel$export(module.exports, "render", () => $c87427e8b303c517$export$b3890eb0ae9dca99, (v) => $c87427e8b303c517$export$b3890eb0ae9dca99 = v);
$parcel$export(module.exports, "unmountComponentAtNode", () => $c87427e8b303c517$export$502457920280e6be, (v) => $c87427e8b303c517$export$502457920280e6be = v);
$parcel$export(module.exports, "unstable_batchedUpdates", () => $c87427e8b303c517$export$c78a37762a8d58e1, (v) => $c87427e8b303c517$export$c78a37762a8d58e1 = v);
$parcel$export(module.exports, "unstable_renderSubtreeIntoContainer", () => $c87427e8b303c517$export$dc54d992c10e8a18, (v) => $c87427e8b303c517$export$dc54d992c10e8a18 = v);
$parcel$export(module.exports, "version", () => $c87427e8b303c517$export$83d89fbfd8236492, (v) => $c87427e8b303c517$export$83d89fbfd8236492 = v);
/**
 * @license React
 * react-dom.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ /*
 Modernizr 3.0.0pre (Custom Build) | MIT
*/ var $c87427e8b303c517$export$ae55be85d98224ed;
var $c87427e8b303c517$export$d39a5bbd09211389;
var $c87427e8b303c517$export$882461b6382ed46c;
var $c87427e8b303c517$export$466bfc07425424d5;
var $c87427e8b303c517$export$cd75ccfd720a3cd4;
var $c87427e8b303c517$export$fa8d919ba61d84db;
var $c87427e8b303c517$export$757ceba2d55c277e;
var $c87427e8b303c517$export$b3890eb0ae9dca99;
var $c87427e8b303c517$export$502457920280e6be;
var $c87427e8b303c517$export$c78a37762a8d58e1;
var $c87427e8b303c517$export$dc54d992c10e8a18;
var $c87427e8b303c517$export$83d89fbfd8236492;
"use strict";

var $cWbtJ = parcelRequire("cWbtJ");

var $iI65C = parcelRequire("iI65C");
function $c87427e8b303c517$var$p(a) {
    for(var b = "https://reactjs.org/docs/error-decoder.html?invariant=" + a, c = 1; c < arguments.length; c++)b += "&args[]=" + encodeURIComponent(arguments[c]);
    return "Minified React error #" + a + "; visit " + b + " for the full message or use the non-minified dev environment for full errors and additional helpful warnings.";
}
var $c87427e8b303c517$var$da = new Set, $c87427e8b303c517$var$ea = {};
function $c87427e8b303c517$var$fa(a, b) {
    $c87427e8b303c517$var$ha(a, b);
    $c87427e8b303c517$var$ha(a + "Capture", b);
}
function $c87427e8b303c517$var$ha(a, b) {
    $c87427e8b303c517$var$ea[a] = b;
    for(a = 0; a < b.length; a++)$c87427e8b303c517$var$da.add(b[a]);
}
var $c87427e8b303c517$var$ia = !("undefined" === typeof window || "undefined" === typeof window.document || "undefined" === typeof window.document.createElement), $c87427e8b303c517$var$ja = Object.prototype.hasOwnProperty, $c87427e8b303c517$var$ka = /^[:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD][:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD\-.0-9\u00B7\u0300-\u036F\u203F-\u2040]*$/, $c87427e8b303c517$var$la = {}, $c87427e8b303c517$var$ma = {};
function $c87427e8b303c517$var$oa(a) {
    if ($c87427e8b303c517$var$ja.call($c87427e8b303c517$var$ma, a)) return !0;
    if ($c87427e8b303c517$var$ja.call($c87427e8b303c517$var$la, a)) return !1;
    if ($c87427e8b303c517$var$ka.test(a)) return $c87427e8b303c517$var$ma[a] = !0;
    $c87427e8b303c517$var$la[a] = !0;
    return !1;
}
function $c87427e8b303c517$var$pa(a, b, c, d) {
    if (null !== c && 0 === c.type) return !1;
    switch(typeof b){
        case "function":
        case "symbol":
            return !0;
        case "boolean":
            if (d) return !1;
            if (null !== c) return !c.acceptsBooleans;
            a = a.toLowerCase().slice(0, 5);
            return "data-" !== a && "aria-" !== a;
        default:
            return !1;
    }
}
function $c87427e8b303c517$var$qa(a, b, c, d) {
    if (null === b || "undefined" === typeof b || $c87427e8b303c517$var$pa(a, b, c, d)) return !0;
    if (d) return !1;
    if (null !== c) switch(c.type){
        case 3:
            return !b;
        case 4:
            return !1 === b;
        case 5:
            return isNaN(b);
        case 6:
            return isNaN(b) || 1 > b;
    }
    return !1;
}
function $c87427e8b303c517$var$v(a, b, c, d, e, f, g) {
    this.acceptsBooleans = 2 === b || 3 === b || 4 === b;
    this.attributeName = d;
    this.attributeNamespace = e;
    this.mustUseProperty = c;
    this.propertyName = a;
    this.type = b;
    this.sanitizeURL = f;
    this.removeEmptyString = g;
}
var $c87427e8b303c517$var$z = {};
"children dangerouslySetInnerHTML defaultValue defaultChecked innerHTML suppressContentEditableWarning suppressHydrationWarning style".split(" ").forEach(function(a) {
    $c87427e8b303c517$var$z[a] = new $c87427e8b303c517$var$v(a, 0, !1, a, null, !1, !1);
});
[
    [
        "acceptCharset",
        "accept-charset"
    ],
    [
        "className",
        "class"
    ],
    [
        "htmlFor",
        "for"
    ],
    [
        "httpEquiv",
        "http-equiv"
    ]
].forEach(function(a) {
    var b = a[0];
    $c87427e8b303c517$var$z[b] = new $c87427e8b303c517$var$v(b, 1, !1, a[1], null, !1, !1);
});
[
    "contentEditable",
    "draggable",
    "spellCheck",
    "value"
].forEach(function(a) {
    $c87427e8b303c517$var$z[a] = new $c87427e8b303c517$var$v(a, 2, !1, a.toLowerCase(), null, !1, !1);
});
[
    "autoReverse",
    "externalResourcesRequired",
    "focusable",
    "preserveAlpha"
].forEach(function(a) {
    $c87427e8b303c517$var$z[a] = new $c87427e8b303c517$var$v(a, 2, !1, a, null, !1, !1);
});
"allowFullScreen async autoFocus autoPlay controls default defer disabled disablePictureInPicture disableRemotePlayback formNoValidate hidden loop noModule noValidate open playsInline readOnly required reversed scoped seamless itemScope".split(" ").forEach(function(a) {
    $c87427e8b303c517$var$z[a] = new $c87427e8b303c517$var$v(a, 3, !1, a.toLowerCase(), null, !1, !1);
});
[
    "checked",
    "multiple",
    "muted",
    "selected"
].forEach(function(a) {
    $c87427e8b303c517$var$z[a] = new $c87427e8b303c517$var$v(a, 3, !0, a, null, !1, !1);
});
[
    "capture",
    "download"
].forEach(function(a) {
    $c87427e8b303c517$var$z[a] = new $c87427e8b303c517$var$v(a, 4, !1, a, null, !1, !1);
});
[
    "cols",
    "rows",
    "size",
    "span"
].forEach(function(a) {
    $c87427e8b303c517$var$z[a] = new $c87427e8b303c517$var$v(a, 6, !1, a, null, !1, !1);
});
[
    "rowSpan",
    "start"
].forEach(function(a) {
    $c87427e8b303c517$var$z[a] = new $c87427e8b303c517$var$v(a, 5, !1, a.toLowerCase(), null, !1, !1);
});
var $c87427e8b303c517$var$ra = /[\-:]([a-z])/g;
function $c87427e8b303c517$var$sa(a) {
    return a[1].toUpperCase();
}
"accent-height alignment-baseline arabic-form baseline-shift cap-height clip-path clip-rule color-interpolation color-interpolation-filters color-profile color-rendering dominant-baseline enable-background fill-opacity fill-rule flood-color flood-opacity font-family font-size font-size-adjust font-stretch font-style font-variant font-weight glyph-name glyph-orientation-horizontal glyph-orientation-vertical horiz-adv-x horiz-origin-x image-rendering letter-spacing lighting-color marker-end marker-mid marker-start overline-position overline-thickness paint-order panose-1 pointer-events rendering-intent shape-rendering stop-color stop-opacity strikethrough-position strikethrough-thickness stroke-dasharray stroke-dashoffset stroke-linecap stroke-linejoin stroke-miterlimit stroke-opacity stroke-width text-anchor text-decoration text-rendering underline-position underline-thickness unicode-bidi unicode-range units-per-em v-alphabetic v-hanging v-ideographic v-mathematical vector-effect vert-adv-y vert-origin-x vert-origin-y word-spacing writing-mode xmlns:xlink x-height".split(" ").forEach(function(a) {
    var b = a.replace($c87427e8b303c517$var$ra, $c87427e8b303c517$var$sa);
    $c87427e8b303c517$var$z[b] = new $c87427e8b303c517$var$v(b, 1, !1, a, null, !1, !1);
});
"xlink:actuate xlink:arcrole xlink:role xlink:show xlink:title xlink:type".split(" ").forEach(function(a) {
    var b = a.replace($c87427e8b303c517$var$ra, $c87427e8b303c517$var$sa);
    $c87427e8b303c517$var$z[b] = new $c87427e8b303c517$var$v(b, 1, !1, a, "http://www.w3.org/1999/xlink", !1, !1);
});
[
    "xml:base",
    "xml:lang",
    "xml:space"
].forEach(function(a) {
    var b = a.replace($c87427e8b303c517$var$ra, $c87427e8b303c517$var$sa);
    $c87427e8b303c517$var$z[b] = new $c87427e8b303c517$var$v(b, 1, !1, a, "http://www.w3.org/XML/1998/namespace", !1, !1);
});
[
    "tabIndex",
    "crossOrigin"
].forEach(function(a) {
    $c87427e8b303c517$var$z[a] = new $c87427e8b303c517$var$v(a, 1, !1, a.toLowerCase(), null, !1, !1);
});
$c87427e8b303c517$var$z.xlinkHref = new $c87427e8b303c517$var$v("xlinkHref", 1, !1, "xlink:href", "http://www.w3.org/1999/xlink", !0, !1);
[
    "src",
    "href",
    "action",
    "formAction"
].forEach(function(a) {
    $c87427e8b303c517$var$z[a] = new $c87427e8b303c517$var$v(a, 1, !1, a.toLowerCase(), null, !0, !0);
});
function $c87427e8b303c517$var$ta(a, b, c, d) {
    var e = $c87427e8b303c517$var$z.hasOwnProperty(b) ? $c87427e8b303c517$var$z[b] : null;
    if (null !== e ? 0 !== e.type : d || !(2 < b.length) || "o" !== b[0] && "O" !== b[0] || "n" !== b[1] && "N" !== b[1]) $c87427e8b303c517$var$qa(b, c, e, d) && (c = null), d || null === e ? $c87427e8b303c517$var$oa(b) && (null === c ? a.removeAttribute(b) : a.setAttribute(b, "" + c)) : e.mustUseProperty ? a[e.propertyName] = null === c ? 3 === e.type ? !1 : "" : c : (b = e.attributeName, d = e.attributeNamespace, null === c ? a.removeAttribute(b) : (e = e.type, c = 3 === e || 4 === e && !0 === c ? "" : "" + c, d ? a.setAttributeNS(d, b, c) : a.setAttribute(b, c)));
}
var $c87427e8b303c517$var$ua = $cWbtJ.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED, $c87427e8b303c517$var$va = Symbol.for("react.element"), $c87427e8b303c517$var$wa = Symbol.for("react.portal"), $c87427e8b303c517$var$ya = Symbol.for("react.fragment"), $c87427e8b303c517$var$za = Symbol.for("react.strict_mode"), $c87427e8b303c517$var$Aa = Symbol.for("react.profiler"), $c87427e8b303c517$var$Ba = Symbol.for("react.provider"), $c87427e8b303c517$var$Ca = Symbol.for("react.context"), $c87427e8b303c517$var$Da = Symbol.for("react.forward_ref"), $c87427e8b303c517$var$Ea = Symbol.for("react.suspense"), $c87427e8b303c517$var$Fa = Symbol.for("react.suspense_list"), $c87427e8b303c517$var$Ga = Symbol.for("react.memo"), $c87427e8b303c517$var$Ha = Symbol.for("react.lazy");
Symbol.for("react.scope");
Symbol.for("react.debug_trace_mode");
var $c87427e8b303c517$var$Ia = Symbol.for("react.offscreen");
Symbol.for("react.legacy_hidden");
Symbol.for("react.cache");
Symbol.for("react.tracing_marker");
var $c87427e8b303c517$var$Ja = Symbol.iterator;
function $c87427e8b303c517$var$Ka(a) {
    if (null === a || "object" !== typeof a) return null;
    a = $c87427e8b303c517$var$Ja && a[$c87427e8b303c517$var$Ja] || a["@@iterator"];
    return "function" === typeof a ? a : null;
}
var $c87427e8b303c517$var$A = Object.assign, $c87427e8b303c517$var$La;
function $c87427e8b303c517$var$Ma(a) {
    if (void 0 === $c87427e8b303c517$var$La) try {
        throw Error();
    } catch (c) {
        var b = c.stack.trim().match(/\n( *(at )?)/);
        $c87427e8b303c517$var$La = b && b[1] || "";
    }
    return "\n" + $c87427e8b303c517$var$La + a;
}
var $c87427e8b303c517$var$Na = !1;
function $c87427e8b303c517$var$Oa(a, b) {
    if (!a || $c87427e8b303c517$var$Na) return "";
    $c87427e8b303c517$var$Na = !0;
    var c = Error.prepareStackTrace;
    Error.prepareStackTrace = void 0;
    try {
        if (b) {
            if (b = function() {
                throw Error();
            }, Object.defineProperty(b.prototype, "props", {
                set: function() {
                    throw Error();
                }
            }), "object" === typeof Reflect && Reflect.construct) {
                try {
                    Reflect.construct(b, []);
                } catch (l) {
                    var d = l;
                }
                Reflect.construct(a, [], b);
            } else {
                try {
                    b.call();
                } catch (l) {
                    d = l;
                }
                a.call(b.prototype);
            }
        } else {
            try {
                throw Error();
            } catch (l) {
                d = l;
            }
            a();
        }
    } catch (l) {
        if (l && d && "string" === typeof l.stack) {
            for(var e = l.stack.split("\n"), f = d.stack.split("\n"), g = e.length - 1, h = f.length - 1; 1 <= g && 0 <= h && e[g] !== f[h];)h--;
            for(; 1 <= g && 0 <= h; g--, h--)if (e[g] !== f[h]) {
                if (1 !== g || 1 !== h) {
                    do if (g--, h--, 0 > h || e[g] !== f[h]) {
                        var k = "\n" + e[g].replace(" at new ", " at ");
                        a.displayName && k.includes("<anonymous>") && (k = k.replace("<anonymous>", a.displayName));
                        return k;
                    }
                    while (1 <= g && 0 <= h);
                }
                break;
            }
        }
    } finally{
        $c87427e8b303c517$var$Na = !1, Error.prepareStackTrace = c;
    }
    return (a = a ? a.displayName || a.name : "") ? $c87427e8b303c517$var$Ma(a) : "";
}
function $c87427e8b303c517$var$Pa(a) {
    switch(a.tag){
        case 5:
            return $c87427e8b303c517$var$Ma(a.type);
        case 16:
            return $c87427e8b303c517$var$Ma("Lazy");
        case 13:
            return $c87427e8b303c517$var$Ma("Suspense");
        case 19:
            return $c87427e8b303c517$var$Ma("SuspenseList");
        case 0:
        case 2:
        case 15:
            return a = $c87427e8b303c517$var$Oa(a.type, !1), a;
        case 11:
            return a = $c87427e8b303c517$var$Oa(a.type.render, !1), a;
        case 1:
            return a = $c87427e8b303c517$var$Oa(a.type, !0), a;
        default:
            return "";
    }
}
function $c87427e8b303c517$var$Qa(a) {
    if (null == a) return null;
    if ("function" === typeof a) return a.displayName || a.name || null;
    if ("string" === typeof a) return a;
    switch(a){
        case $c87427e8b303c517$var$ya:
            return "Fragment";
        case $c87427e8b303c517$var$wa:
            return "Portal";
        case $c87427e8b303c517$var$Aa:
            return "Profiler";
        case $c87427e8b303c517$var$za:
            return "StrictMode";
        case $c87427e8b303c517$var$Ea:
            return "Suspense";
        case $c87427e8b303c517$var$Fa:
            return "SuspenseList";
    }
    if ("object" === typeof a) switch(a.$$typeof){
        case $c87427e8b303c517$var$Ca:
            return (a.displayName || "Context") + ".Consumer";
        case $c87427e8b303c517$var$Ba:
            return (a._context.displayName || "Context") + ".Provider";
        case $c87427e8b303c517$var$Da:
            var b = a.render;
            a = a.displayName;
            a || (a = b.displayName || b.name || "", a = "" !== a ? "ForwardRef(" + a + ")" : "ForwardRef");
            return a;
        case $c87427e8b303c517$var$Ga:
            return b = a.displayName || null, null !== b ? b : $c87427e8b303c517$var$Qa(a.type) || "Memo";
        case $c87427e8b303c517$var$Ha:
            b = a._payload;
            a = a._init;
            try {
                return $c87427e8b303c517$var$Qa(a(b));
            } catch (c) {}
    }
    return null;
}
function $c87427e8b303c517$var$Ra(a) {
    var b = a.type;
    switch(a.tag){
        case 24:
            return "Cache";
        case 9:
            return (b.displayName || "Context") + ".Consumer";
        case 10:
            return (b._context.displayName || "Context") + ".Provider";
        case 18:
            return "DehydratedFragment";
        case 11:
            return a = b.render, a = a.displayName || a.name || "", b.displayName || ("" !== a ? "ForwardRef(" + a + ")" : "ForwardRef");
        case 7:
            return "Fragment";
        case 5:
            return b;
        case 4:
            return "Portal";
        case 3:
            return "Root";
        case 6:
            return "Text";
        case 16:
            return $c87427e8b303c517$var$Qa(b);
        case 8:
            return b === $c87427e8b303c517$var$za ? "StrictMode" : "Mode";
        case 22:
            return "Offscreen";
        case 12:
            return "Profiler";
        case 21:
            return "Scope";
        case 13:
            return "Suspense";
        case 19:
            return "SuspenseList";
        case 25:
            return "TracingMarker";
        case 1:
        case 0:
        case 17:
        case 2:
        case 14:
        case 15:
            if ("function" === typeof b) return b.displayName || b.name || null;
            if ("string" === typeof b) return b;
    }
    return null;
}
function $c87427e8b303c517$var$Sa(a) {
    switch(typeof a){
        case "boolean":
        case "number":
        case "string":
        case "undefined":
            return a;
        case "object":
            return a;
        default:
            return "";
    }
}
function $c87427e8b303c517$var$Ta(a) {
    var b = a.type;
    return (a = a.nodeName) && "input" === a.toLowerCase() && ("checkbox" === b || "radio" === b);
}
function $c87427e8b303c517$var$Ua(a) {
    var b = $c87427e8b303c517$var$Ta(a) ? "checked" : "value", c = Object.getOwnPropertyDescriptor(a.constructor.prototype, b), d = "" + a[b];
    if (!a.hasOwnProperty(b) && "undefined" !== typeof c && "function" === typeof c.get && "function" === typeof c.set) {
        var e = c.get, f = c.set;
        Object.defineProperty(a, b, {
            configurable: !0,
            get: function() {
                return e.call(this);
            },
            set: function(a) {
                d = "" + a;
                f.call(this, a);
            }
        });
        Object.defineProperty(a, b, {
            enumerable: c.enumerable
        });
        return {
            getValue: function() {
                return d;
            },
            setValue: function(a) {
                d = "" + a;
            },
            stopTracking: function() {
                a._valueTracker = null;
                delete a[b];
            }
        };
    }
}
function $c87427e8b303c517$var$Va(a) {
    a._valueTracker || (a._valueTracker = $c87427e8b303c517$var$Ua(a));
}
function $c87427e8b303c517$var$Wa(a) {
    if (!a) return !1;
    var b = a._valueTracker;
    if (!b) return !0;
    var c = b.getValue();
    var d = "";
    a && (d = $c87427e8b303c517$var$Ta(a) ? a.checked ? "true" : "false" : a.value);
    a = d;
    return a !== c ? (b.setValue(a), !0) : !1;
}
function $c87427e8b303c517$var$Xa(a) {
    a = a || ("undefined" !== typeof document ? document : void 0);
    if ("undefined" === typeof a) return null;
    try {
        return a.activeElement || a.body;
    } catch (b) {
        return a.body;
    }
}
function $c87427e8b303c517$var$Ya(a, b) {
    var c = b.checked;
    return $c87427e8b303c517$var$A({}, b, {
        defaultChecked: void 0,
        defaultValue: void 0,
        value: void 0,
        checked: null != c ? c : a._wrapperState.initialChecked
    });
}
function $c87427e8b303c517$var$Za(a, b) {
    var c = null == b.defaultValue ? "" : b.defaultValue, d = null != b.checked ? b.checked : b.defaultChecked;
    c = $c87427e8b303c517$var$Sa(null != b.value ? b.value : c);
    a._wrapperState = {
        initialChecked: d,
        initialValue: c,
        controlled: "checkbox" === b.type || "radio" === b.type ? null != b.checked : null != b.value
    };
}
function $c87427e8b303c517$var$ab(a, b) {
    b = b.checked;
    null != b && $c87427e8b303c517$var$ta(a, "checked", b, !1);
}
function $c87427e8b303c517$var$bb(a, b) {
    $c87427e8b303c517$var$ab(a, b);
    var c = $c87427e8b303c517$var$Sa(b.value), d = b.type;
    if (null != c) {
        if ("number" === d) {
            if (0 === c && "" === a.value || a.value != c) a.value = "" + c;
        } else a.value !== "" + c && (a.value = "" + c);
    } else if ("submit" === d || "reset" === d) {
        a.removeAttribute("value");
        return;
    }
    b.hasOwnProperty("value") ? $c87427e8b303c517$var$cb(a, b.type, c) : b.hasOwnProperty("defaultValue") && $c87427e8b303c517$var$cb(a, b.type, $c87427e8b303c517$var$Sa(b.defaultValue));
    null == b.checked && null != b.defaultChecked && (a.defaultChecked = !!b.defaultChecked);
}
function $c87427e8b303c517$var$db(a, b, c) {
    if (b.hasOwnProperty("value") || b.hasOwnProperty("defaultValue")) {
        var d = b.type;
        if (!("submit" !== d && "reset" !== d || void 0 !== b.value && null !== b.value)) return;
        b = "" + a._wrapperState.initialValue;
        c || b === a.value || (a.value = b);
        a.defaultValue = b;
    }
    c = a.name;
    "" !== c && (a.name = "");
    a.defaultChecked = !!a._wrapperState.initialChecked;
    "" !== c && (a.name = c);
}
function $c87427e8b303c517$var$cb(a, b, c) {
    if ("number" !== b || $c87427e8b303c517$var$Xa(a.ownerDocument) !== a) null == c ? a.defaultValue = "" + a._wrapperState.initialValue : a.defaultValue !== "" + c && (a.defaultValue = "" + c);
}
var $c87427e8b303c517$var$eb = Array.isArray;
function $c87427e8b303c517$var$fb(a, b, c, d) {
    a = a.options;
    if (b) {
        b = {};
        for(var e = 0; e < c.length; e++)b["$" + c[e]] = !0;
        for(c = 0; c < a.length; c++)e = b.hasOwnProperty("$" + a[c].value), a[c].selected !== e && (a[c].selected = e), e && d && (a[c].defaultSelected = !0);
    } else {
        c = "" + $c87427e8b303c517$var$Sa(c);
        b = null;
        for(e = 0; e < a.length; e++){
            if (a[e].value === c) {
                a[e].selected = !0;
                d && (a[e].defaultSelected = !0);
                return;
            }
            null !== b || a[e].disabled || (b = a[e]);
        }
        null !== b && (b.selected = !0);
    }
}
function $c87427e8b303c517$var$gb(a, b) {
    if (null != b.dangerouslySetInnerHTML) throw Error($c87427e8b303c517$var$p(91));
    return $c87427e8b303c517$var$A({}, b, {
        value: void 0,
        defaultValue: void 0,
        children: "" + a._wrapperState.initialValue
    });
}
function $c87427e8b303c517$var$hb(a, b) {
    var c = b.value;
    if (null == c) {
        c = b.children;
        b = b.defaultValue;
        if (null != c) {
            if (null != b) throw Error($c87427e8b303c517$var$p(92));
            if ($c87427e8b303c517$var$eb(c)) {
                if (1 < c.length) throw Error($c87427e8b303c517$var$p(93));
                c = c[0];
            }
            b = c;
        }
        null == b && (b = "");
        c = b;
    }
    a._wrapperState = {
        initialValue: $c87427e8b303c517$var$Sa(c)
    };
}
function $c87427e8b303c517$var$ib(a, b) {
    var c = $c87427e8b303c517$var$Sa(b.value), d = $c87427e8b303c517$var$Sa(b.defaultValue);
    null != c && (c = "" + c, c !== a.value && (a.value = c), null == b.defaultValue && a.defaultValue !== c && (a.defaultValue = c));
    null != d && (a.defaultValue = "" + d);
}
function $c87427e8b303c517$var$jb(a) {
    var b = a.textContent;
    b === a._wrapperState.initialValue && "" !== b && null !== b && (a.value = b);
}
function $c87427e8b303c517$var$kb(a) {
    switch(a){
        case "svg":
            return "http://www.w3.org/2000/svg";
        case "math":
            return "http://www.w3.org/1998/Math/MathML";
        default:
            return "http://www.w3.org/1999/xhtml";
    }
}
function $c87427e8b303c517$var$lb(a, b) {
    return null == a || "http://www.w3.org/1999/xhtml" === a ? $c87427e8b303c517$var$kb(b) : "http://www.w3.org/2000/svg" === a && "foreignObject" === b ? "http://www.w3.org/1999/xhtml" : a;
}
var $c87427e8b303c517$var$mb, $c87427e8b303c517$var$nb = function(a) {
    return "undefined" !== typeof MSApp && MSApp.execUnsafeLocalFunction ? function(b, c, d, e) {
        MSApp.execUnsafeLocalFunction(function() {
            return a(b, c, d, e);
        });
    } : a;
}(function(a, b) {
    if ("http://www.w3.org/2000/svg" !== a.namespaceURI || "innerHTML" in a) a.innerHTML = b;
    else {
        $c87427e8b303c517$var$mb = $c87427e8b303c517$var$mb || document.createElement("div");
        $c87427e8b303c517$var$mb.innerHTML = "<svg>" + b.valueOf().toString() + "</svg>";
        for(b = $c87427e8b303c517$var$mb.firstChild; a.firstChild;)a.removeChild(a.firstChild);
        for(; b.firstChild;)a.appendChild(b.firstChild);
    }
});
function $c87427e8b303c517$var$ob(a, b) {
    if (b) {
        var c = a.firstChild;
        if (c && c === a.lastChild && 3 === c.nodeType) {
            c.nodeValue = b;
            return;
        }
    }
    a.textContent = b;
}
var $c87427e8b303c517$var$pb = {
    animationIterationCount: !0,
    aspectRatio: !0,
    borderImageOutset: !0,
    borderImageSlice: !0,
    borderImageWidth: !0,
    boxFlex: !0,
    boxFlexGroup: !0,
    boxOrdinalGroup: !0,
    columnCount: !0,
    columns: !0,
    flex: !0,
    flexGrow: !0,
    flexPositive: !0,
    flexShrink: !0,
    flexNegative: !0,
    flexOrder: !0,
    gridArea: !0,
    gridRow: !0,
    gridRowEnd: !0,
    gridRowSpan: !0,
    gridRowStart: !0,
    gridColumn: !0,
    gridColumnEnd: !0,
    gridColumnSpan: !0,
    gridColumnStart: !0,
    fontWeight: !0,
    lineClamp: !0,
    lineHeight: !0,
    opacity: !0,
    order: !0,
    orphans: !0,
    tabSize: !0,
    widows: !0,
    zIndex: !0,
    zoom: !0,
    fillOpacity: !0,
    floodOpacity: !0,
    stopOpacity: !0,
    strokeDasharray: !0,
    strokeDashoffset: !0,
    strokeMiterlimit: !0,
    strokeOpacity: !0,
    strokeWidth: !0
}, $c87427e8b303c517$var$qb = [
    "Webkit",
    "ms",
    "Moz",
    "O"
];
Object.keys($c87427e8b303c517$var$pb).forEach(function(a) {
    $c87427e8b303c517$var$qb.forEach(function(b) {
        b = b + a.charAt(0).toUpperCase() + a.substring(1);
        $c87427e8b303c517$var$pb[b] = $c87427e8b303c517$var$pb[a];
    });
});
function $c87427e8b303c517$var$rb(a, b, c) {
    return null == b || "boolean" === typeof b || "" === b ? "" : c || "number" !== typeof b || 0 === b || $c87427e8b303c517$var$pb.hasOwnProperty(a) && $c87427e8b303c517$var$pb[a] ? ("" + b).trim() : b + "px";
}
function $c87427e8b303c517$var$sb(a, b) {
    a = a.style;
    for(var c in b)if (b.hasOwnProperty(c)) {
        var d = 0 === c.indexOf("--"), e = $c87427e8b303c517$var$rb(c, b[c], d);
        "float" === c && (c = "cssFloat");
        d ? a.setProperty(c, e) : a[c] = e;
    }
}
var $c87427e8b303c517$var$tb = $c87427e8b303c517$var$A({
    menuitem: !0
}, {
    area: !0,
    base: !0,
    br: !0,
    col: !0,
    embed: !0,
    hr: !0,
    img: !0,
    input: !0,
    keygen: !0,
    link: !0,
    meta: !0,
    param: !0,
    source: !0,
    track: !0,
    wbr: !0
});
function $c87427e8b303c517$var$ub(a, b) {
    if (b) {
        if ($c87427e8b303c517$var$tb[a] && (null != b.children || null != b.dangerouslySetInnerHTML)) throw Error($c87427e8b303c517$var$p(137, a));
        if (null != b.dangerouslySetInnerHTML) {
            if (null != b.children) throw Error($c87427e8b303c517$var$p(60));
            if ("object" !== typeof b.dangerouslySetInnerHTML || !("__html" in b.dangerouslySetInnerHTML)) throw Error($c87427e8b303c517$var$p(61));
        }
        if (null != b.style && "object" !== typeof b.style) throw Error($c87427e8b303c517$var$p(62));
    }
}
function $c87427e8b303c517$var$vb(a, b) {
    if (-1 === a.indexOf("-")) return "string" === typeof b.is;
    switch(a){
        case "annotation-xml":
        case "color-profile":
        case "font-face":
        case "font-face-src":
        case "font-face-uri":
        case "font-face-format":
        case "font-face-name":
        case "missing-glyph":
            return !1;
        default:
            return !0;
    }
}
var $c87427e8b303c517$var$wb = null;
function $c87427e8b303c517$var$xb(a) {
    a = a.target || a.srcElement || window;
    a.correspondingUseElement && (a = a.correspondingUseElement);
    return 3 === a.nodeType ? a.parentNode : a;
}
var $c87427e8b303c517$var$yb = null, $c87427e8b303c517$var$zb = null, $c87427e8b303c517$var$Ab = null;
function $c87427e8b303c517$var$Bb(a) {
    if (a = $c87427e8b303c517$var$Cb(a)) {
        if ("function" !== typeof $c87427e8b303c517$var$yb) throw Error($c87427e8b303c517$var$p(280));
        var b = a.stateNode;
        b && (b = $c87427e8b303c517$var$Db(b), $c87427e8b303c517$var$yb(a.stateNode, a.type, b));
    }
}
function $c87427e8b303c517$var$Eb(a) {
    $c87427e8b303c517$var$zb ? $c87427e8b303c517$var$Ab ? $c87427e8b303c517$var$Ab.push(a) : $c87427e8b303c517$var$Ab = [
        a
    ] : $c87427e8b303c517$var$zb = a;
}
function $c87427e8b303c517$var$Fb() {
    if ($c87427e8b303c517$var$zb) {
        var a = $c87427e8b303c517$var$zb, b = $c87427e8b303c517$var$Ab;
        $c87427e8b303c517$var$Ab = $c87427e8b303c517$var$zb = null;
        $c87427e8b303c517$var$Bb(a);
        if (b) for(a = 0; a < b.length; a++)$c87427e8b303c517$var$Bb(b[a]);
    }
}
function $c87427e8b303c517$var$Gb(a, b) {
    return a(b);
}
function $c87427e8b303c517$var$Hb() {}
var $c87427e8b303c517$var$Ib = !1;
function $c87427e8b303c517$var$Jb(a, b, c) {
    if ($c87427e8b303c517$var$Ib) return a(b, c);
    $c87427e8b303c517$var$Ib = !0;
    try {
        return $c87427e8b303c517$var$Gb(a, b, c);
    } finally{
        if ($c87427e8b303c517$var$Ib = !1, null !== $c87427e8b303c517$var$zb || null !== $c87427e8b303c517$var$Ab) $c87427e8b303c517$var$Hb(), $c87427e8b303c517$var$Fb();
    }
}
function $c87427e8b303c517$var$Kb(a, b) {
    var c = a.stateNode;
    if (null === c) return null;
    var d = $c87427e8b303c517$var$Db(c);
    if (null === d) return null;
    c = d[b];
    a: switch(b){
        case "onClick":
        case "onClickCapture":
        case "onDoubleClick":
        case "onDoubleClickCapture":
        case "onMouseDown":
        case "onMouseDownCapture":
        case "onMouseMove":
        case "onMouseMoveCapture":
        case "onMouseUp":
        case "onMouseUpCapture":
        case "onMouseEnter":
            (d = !d.disabled) || (a = a.type, d = !("button" === a || "input" === a || "select" === a || "textarea" === a));
            a = !d;
            break a;
        default:
            a = !1;
    }
    if (a) return null;
    if (c && "function" !== typeof c) throw Error($c87427e8b303c517$var$p(231, b, typeof c));
    return c;
}
var $c87427e8b303c517$var$Lb = !1;
if ($c87427e8b303c517$var$ia) try {
    var $c87427e8b303c517$var$Mb = {};
    Object.defineProperty($c87427e8b303c517$var$Mb, "passive", {
        get: function() {
            $c87427e8b303c517$var$Lb = !0;
        }
    });
    window.addEventListener("test", $c87427e8b303c517$var$Mb, $c87427e8b303c517$var$Mb);
    window.removeEventListener("test", $c87427e8b303c517$var$Mb, $c87427e8b303c517$var$Mb);
} catch (a) {
    $c87427e8b303c517$var$Lb = !1;
}
function $c87427e8b303c517$var$Nb(a, b, c, d, e, f, g, h, k) {
    var l = Array.prototype.slice.call(arguments, 3);
    try {
        b.apply(c, l);
    } catch (m) {
        this.onError(m);
    }
}
var $c87427e8b303c517$var$Ob = !1, $c87427e8b303c517$var$Pb = null, $c87427e8b303c517$var$Qb = !1, $c87427e8b303c517$var$Rb = null, $c87427e8b303c517$var$Sb = {
    onError: function(a) {
        $c87427e8b303c517$var$Ob = !0;
        $c87427e8b303c517$var$Pb = a;
    }
};
function $c87427e8b303c517$var$Tb(a, b, c, d, e, f, g, h, k) {
    $c87427e8b303c517$var$Ob = !1;
    $c87427e8b303c517$var$Pb = null;
    $c87427e8b303c517$var$Nb.apply($c87427e8b303c517$var$Sb, arguments);
}
function $c87427e8b303c517$var$Ub(a, b, c, d, e, f, g, h, k) {
    $c87427e8b303c517$var$Tb.apply(this, arguments);
    if ($c87427e8b303c517$var$Ob) {
        if ($c87427e8b303c517$var$Ob) {
            var l = $c87427e8b303c517$var$Pb;
            $c87427e8b303c517$var$Ob = !1;
            $c87427e8b303c517$var$Pb = null;
        } else throw Error($c87427e8b303c517$var$p(198));
        $c87427e8b303c517$var$Qb || ($c87427e8b303c517$var$Qb = !0, $c87427e8b303c517$var$Rb = l);
    }
}
function $c87427e8b303c517$var$Vb(a) {
    var b = a, c = a;
    if (a.alternate) for(; b.return;)b = b.return;
    else {
        a = b;
        do b = a, 0 !== (b.flags & 4098) && (c = b.return), a = b.return;
        while (a);
    }
    return 3 === b.tag ? c : null;
}
function $c87427e8b303c517$var$Wb(a) {
    if (13 === a.tag) {
        var b = a.memoizedState;
        null === b && (a = a.alternate, null !== a && (b = a.memoizedState));
        if (null !== b) return b.dehydrated;
    }
    return null;
}
function $c87427e8b303c517$var$Xb(a) {
    if ($c87427e8b303c517$var$Vb(a) !== a) throw Error($c87427e8b303c517$var$p(188));
}
function $c87427e8b303c517$var$Yb(a) {
    var b = a.alternate;
    if (!b) {
        b = $c87427e8b303c517$var$Vb(a);
        if (null === b) throw Error($c87427e8b303c517$var$p(188));
        return b !== a ? null : a;
    }
    for(var c = a, d = b;;){
        var e = c.return;
        if (null === e) break;
        var f = e.alternate;
        if (null === f) {
            d = e.return;
            if (null !== d) {
                c = d;
                continue;
            }
            break;
        }
        if (e.child === f.child) {
            for(f = e.child; f;){
                if (f === c) return $c87427e8b303c517$var$Xb(e), a;
                if (f === d) return $c87427e8b303c517$var$Xb(e), b;
                f = f.sibling;
            }
            throw Error($c87427e8b303c517$var$p(188));
        }
        if (c.return !== d.return) c = e, d = f;
        else {
            for(var g = !1, h = e.child; h;){
                if (h === c) {
                    g = !0;
                    c = e;
                    d = f;
                    break;
                }
                if (h === d) {
                    g = !0;
                    d = e;
                    c = f;
                    break;
                }
                h = h.sibling;
            }
            if (!g) {
                for(h = f.child; h;){
                    if (h === c) {
                        g = !0;
                        c = f;
                        d = e;
                        break;
                    }
                    if (h === d) {
                        g = !0;
                        d = f;
                        c = e;
                        break;
                    }
                    h = h.sibling;
                }
                if (!g) throw Error($c87427e8b303c517$var$p(189));
            }
        }
        if (c.alternate !== d) throw Error($c87427e8b303c517$var$p(190));
    }
    if (3 !== c.tag) throw Error($c87427e8b303c517$var$p(188));
    return c.stateNode.current === c ? a : b;
}
function $c87427e8b303c517$var$Zb(a) {
    a = $c87427e8b303c517$var$Yb(a);
    return null !== a ? $c87427e8b303c517$var$$b(a) : null;
}
function $c87427e8b303c517$var$$b(a) {
    if (5 === a.tag || 6 === a.tag) return a;
    for(a = a.child; null !== a;){
        var b = $c87427e8b303c517$var$$b(a);
        if (null !== b) return b;
        a = a.sibling;
    }
    return null;
}
var $c87427e8b303c517$var$ac = $iI65C.unstable_scheduleCallback, $c87427e8b303c517$var$bc = $iI65C.unstable_cancelCallback, $c87427e8b303c517$var$cc = $iI65C.unstable_shouldYield, $c87427e8b303c517$var$dc = $iI65C.unstable_requestPaint, $c87427e8b303c517$var$B = $iI65C.unstable_now, $c87427e8b303c517$var$ec = $iI65C.unstable_getCurrentPriorityLevel, $c87427e8b303c517$var$fc = $iI65C.unstable_ImmediatePriority, $c87427e8b303c517$var$gc = $iI65C.unstable_UserBlockingPriority, $c87427e8b303c517$var$hc = $iI65C.unstable_NormalPriority, $c87427e8b303c517$var$ic = $iI65C.unstable_LowPriority, $c87427e8b303c517$var$jc = $iI65C.unstable_IdlePriority, $c87427e8b303c517$var$kc = null, $c87427e8b303c517$var$lc = null;
function $c87427e8b303c517$var$mc(a) {
    if ($c87427e8b303c517$var$lc && "function" === typeof $c87427e8b303c517$var$lc.onCommitFiberRoot) try {
        $c87427e8b303c517$var$lc.onCommitFiberRoot($c87427e8b303c517$var$kc, a, void 0, 128 === (a.current.flags & 128));
    } catch (b) {}
}
var $c87427e8b303c517$var$oc = Math.clz32 ? Math.clz32 : $c87427e8b303c517$var$nc, $c87427e8b303c517$var$pc = Math.log, $c87427e8b303c517$var$qc = Math.LN2;
function $c87427e8b303c517$var$nc(a) {
    a >>>= 0;
    return 0 === a ? 32 : 31 - ($c87427e8b303c517$var$pc(a) / $c87427e8b303c517$var$qc | 0) | 0;
}
var $c87427e8b303c517$var$rc = 64, $c87427e8b303c517$var$sc = 4194304;
function $c87427e8b303c517$var$tc(a) {
    switch(a & -a){
        case 1:
            return 1;
        case 2:
            return 2;
        case 4:
            return 4;
        case 8:
            return 8;
        case 16:
            return 16;
        case 32:
            return 32;
        case 64:
        case 128:
        case 256:
        case 512:
        case 1024:
        case 2048:
        case 4096:
        case 8192:
        case 16384:
        case 32768:
        case 65536:
        case 131072:
        case 262144:
        case 524288:
        case 1048576:
        case 2097152:
            return a & 4194240;
        case 4194304:
        case 8388608:
        case 16777216:
        case 33554432:
        case 67108864:
            return a & 130023424;
        case 134217728:
            return 134217728;
        case 268435456:
            return 268435456;
        case 536870912:
            return 536870912;
        case 1073741824:
            return 1073741824;
        default:
            return a;
    }
}
function $c87427e8b303c517$var$uc(a, b) {
    var c = a.pendingLanes;
    if (0 === c) return 0;
    var d = 0, e = a.suspendedLanes, f = a.pingedLanes, g = c & 268435455;
    if (0 !== g) {
        var h = g & ~e;
        0 !== h ? d = $c87427e8b303c517$var$tc(h) : (f &= g, 0 !== f && (d = $c87427e8b303c517$var$tc(f)));
    } else g = c & ~e, 0 !== g ? d = $c87427e8b303c517$var$tc(g) : 0 !== f && (d = $c87427e8b303c517$var$tc(f));
    if (0 === d) return 0;
    if (0 !== b && b !== d && 0 === (b & e) && (e = d & -d, f = b & -b, e >= f || 16 === e && 0 !== (f & 4194240))) return b;
    0 !== (d & 4) && (d |= c & 16);
    b = a.entangledLanes;
    if (0 !== b) for(a = a.entanglements, b &= d; 0 < b;)c = 31 - $c87427e8b303c517$var$oc(b), e = 1 << c, d |= a[c], b &= ~e;
    return d;
}
function $c87427e8b303c517$var$vc(a, b) {
    switch(a){
        case 1:
        case 2:
        case 4:
            return b + 250;
        case 8:
        case 16:
        case 32:
        case 64:
        case 128:
        case 256:
        case 512:
        case 1024:
        case 2048:
        case 4096:
        case 8192:
        case 16384:
        case 32768:
        case 65536:
        case 131072:
        case 262144:
        case 524288:
        case 1048576:
        case 2097152:
            return b + 5E3;
        case 4194304:
        case 8388608:
        case 16777216:
        case 33554432:
        case 67108864:
            return -1;
        case 134217728:
        case 268435456:
        case 536870912:
        case 1073741824:
            return -1;
        default:
            return -1;
    }
}
function $c87427e8b303c517$var$wc(a, b) {
    for(var c = a.suspendedLanes, d = a.pingedLanes, e = a.expirationTimes, f = a.pendingLanes; 0 < f;){
        var g = 31 - $c87427e8b303c517$var$oc(f), h = 1 << g, k = e[g];
        if (-1 === k) {
            if (0 === (h & c) || 0 !== (h & d)) e[g] = $c87427e8b303c517$var$vc(h, b);
        } else k <= b && (a.expiredLanes |= h);
        f &= ~h;
    }
}
function $c87427e8b303c517$var$xc(a) {
    a = a.pendingLanes & -1073741825;
    return 0 !== a ? a : a & 1073741824 ? 1073741824 : 0;
}
function $c87427e8b303c517$var$yc() {
    var a = $c87427e8b303c517$var$rc;
    $c87427e8b303c517$var$rc <<= 1;
    0 === ($c87427e8b303c517$var$rc & 4194240) && ($c87427e8b303c517$var$rc = 64);
    return a;
}
function $c87427e8b303c517$var$zc(a) {
    for(var b = [], c = 0; 31 > c; c++)b.push(a);
    return b;
}
function $c87427e8b303c517$var$Ac(a, b, c) {
    a.pendingLanes |= b;
    536870912 !== b && (a.suspendedLanes = 0, a.pingedLanes = 0);
    a = a.eventTimes;
    b = 31 - $c87427e8b303c517$var$oc(b);
    a[b] = c;
}
function $c87427e8b303c517$var$Bc(a, b) {
    var c = a.pendingLanes & ~b;
    a.pendingLanes = b;
    a.suspendedLanes = 0;
    a.pingedLanes = 0;
    a.expiredLanes &= b;
    a.mutableReadLanes &= b;
    a.entangledLanes &= b;
    b = a.entanglements;
    var d = a.eventTimes;
    for(a = a.expirationTimes; 0 < c;){
        var e = 31 - $c87427e8b303c517$var$oc(c), f = 1 << e;
        b[e] = 0;
        d[e] = -1;
        a[e] = -1;
        c &= ~f;
    }
}
function $c87427e8b303c517$var$Cc(a, b) {
    var c = a.entangledLanes |= b;
    for(a = a.entanglements; c;){
        var d = 31 - $c87427e8b303c517$var$oc(c), e = 1 << d;
        e & b | a[d] & b && (a[d] |= b);
        c &= ~e;
    }
}
var $c87427e8b303c517$var$C = 0;
function $c87427e8b303c517$var$Dc(a) {
    a &= -a;
    return 1 < a ? 4 < a ? 0 !== (a & 268435455) ? 16 : 536870912 : 4 : 1;
}
var $c87427e8b303c517$var$Ec, $c87427e8b303c517$var$Fc, $c87427e8b303c517$var$Gc, $c87427e8b303c517$var$Hc, $c87427e8b303c517$var$Ic, $c87427e8b303c517$var$Jc = !1, $c87427e8b303c517$var$Kc = [], $c87427e8b303c517$var$Lc = null, $c87427e8b303c517$var$Mc = null, $c87427e8b303c517$var$Nc = null, $c87427e8b303c517$var$Oc = new Map, $c87427e8b303c517$var$Pc = new Map, $c87427e8b303c517$var$Qc = [], $c87427e8b303c517$var$Rc = "mousedown mouseup touchcancel touchend touchstart auxclick dblclick pointercancel pointerdown pointerup dragend dragstart drop compositionend compositionstart keydown keypress keyup input textInput copy cut paste click change contextmenu reset submit".split(" ");
function $c87427e8b303c517$var$Sc(a, b) {
    switch(a){
        case "focusin":
        case "focusout":
            $c87427e8b303c517$var$Lc = null;
            break;
        case "dragenter":
        case "dragleave":
            $c87427e8b303c517$var$Mc = null;
            break;
        case "mouseover":
        case "mouseout":
            $c87427e8b303c517$var$Nc = null;
            break;
        case "pointerover":
        case "pointerout":
            $c87427e8b303c517$var$Oc.delete(b.pointerId);
            break;
        case "gotpointercapture":
        case "lostpointercapture":
            $c87427e8b303c517$var$Pc.delete(b.pointerId);
    }
}
function $c87427e8b303c517$var$Tc(a, b, c, d, e, f) {
    if (null === a || a.nativeEvent !== f) return a = {
        blockedOn: b,
        domEventName: c,
        eventSystemFlags: d,
        nativeEvent: f,
        targetContainers: [
            e
        ]
    }, null !== b && (b = $c87427e8b303c517$var$Cb(b), null !== b && $c87427e8b303c517$var$Fc(b)), a;
    a.eventSystemFlags |= d;
    b = a.targetContainers;
    null !== e && -1 === b.indexOf(e) && b.push(e);
    return a;
}
function $c87427e8b303c517$var$Uc(a, b, c, d, e) {
    switch(b){
        case "focusin":
            return $c87427e8b303c517$var$Lc = $c87427e8b303c517$var$Tc($c87427e8b303c517$var$Lc, a, b, c, d, e), !0;
        case "dragenter":
            return $c87427e8b303c517$var$Mc = $c87427e8b303c517$var$Tc($c87427e8b303c517$var$Mc, a, b, c, d, e), !0;
        case "mouseover":
            return $c87427e8b303c517$var$Nc = $c87427e8b303c517$var$Tc($c87427e8b303c517$var$Nc, a, b, c, d, e), !0;
        case "pointerover":
            var f = e.pointerId;
            $c87427e8b303c517$var$Oc.set(f, $c87427e8b303c517$var$Tc($c87427e8b303c517$var$Oc.get(f) || null, a, b, c, d, e));
            return !0;
        case "gotpointercapture":
            return f = e.pointerId, $c87427e8b303c517$var$Pc.set(f, $c87427e8b303c517$var$Tc($c87427e8b303c517$var$Pc.get(f) || null, a, b, c, d, e)), !0;
    }
    return !1;
}
function $c87427e8b303c517$var$Vc(a) {
    var b = $c87427e8b303c517$var$Wc(a.target);
    if (null !== b) {
        var c = $c87427e8b303c517$var$Vb(b);
        if (null !== c) {
            if (b = c.tag, 13 === b) {
                if (b = $c87427e8b303c517$var$Wb(c), null !== b) {
                    a.blockedOn = b;
                    $c87427e8b303c517$var$Ic(a.priority, function() {
                        $c87427e8b303c517$var$Gc(c);
                    });
                    return;
                }
            } else if (3 === b && c.stateNode.current.memoizedState.isDehydrated) {
                a.blockedOn = 3 === c.tag ? c.stateNode.containerInfo : null;
                return;
            }
        }
    }
    a.blockedOn = null;
}
function $c87427e8b303c517$var$Xc(a) {
    if (null !== a.blockedOn) return !1;
    for(var b = a.targetContainers; 0 < b.length;){
        var c = $c87427e8b303c517$var$Yc(a.domEventName, a.eventSystemFlags, b[0], a.nativeEvent);
        if (null === c) {
            c = a.nativeEvent;
            var d = new c.constructor(c.type, c);
            $c87427e8b303c517$var$wb = d;
            c.target.dispatchEvent(d);
            $c87427e8b303c517$var$wb = null;
        } else return b = $c87427e8b303c517$var$Cb(c), null !== b && $c87427e8b303c517$var$Fc(b), a.blockedOn = c, !1;
        b.shift();
    }
    return !0;
}
function $c87427e8b303c517$var$Zc(a, b, c) {
    $c87427e8b303c517$var$Xc(a) && c.delete(b);
}
function $c87427e8b303c517$var$$c() {
    $c87427e8b303c517$var$Jc = !1;
    null !== $c87427e8b303c517$var$Lc && $c87427e8b303c517$var$Xc($c87427e8b303c517$var$Lc) && ($c87427e8b303c517$var$Lc = null);
    null !== $c87427e8b303c517$var$Mc && $c87427e8b303c517$var$Xc($c87427e8b303c517$var$Mc) && ($c87427e8b303c517$var$Mc = null);
    null !== $c87427e8b303c517$var$Nc && $c87427e8b303c517$var$Xc($c87427e8b303c517$var$Nc) && ($c87427e8b303c517$var$Nc = null);
    $c87427e8b303c517$var$Oc.forEach($c87427e8b303c517$var$Zc);
    $c87427e8b303c517$var$Pc.forEach($c87427e8b303c517$var$Zc);
}
function $c87427e8b303c517$var$ad(a, b) {
    a.blockedOn === b && (a.blockedOn = null, $c87427e8b303c517$var$Jc || ($c87427e8b303c517$var$Jc = !0, $iI65C.unstable_scheduleCallback($iI65C.unstable_NormalPriority, $c87427e8b303c517$var$$c)));
}
function $c87427e8b303c517$var$bd(a) {
    function b(b) {
        return $c87427e8b303c517$var$ad(b, a);
    }
    if (0 < $c87427e8b303c517$var$Kc.length) {
        $c87427e8b303c517$var$ad($c87427e8b303c517$var$Kc[0], a);
        for(var c = 1; c < $c87427e8b303c517$var$Kc.length; c++){
            var d = $c87427e8b303c517$var$Kc[c];
            d.blockedOn === a && (d.blockedOn = null);
        }
    }
    null !== $c87427e8b303c517$var$Lc && $c87427e8b303c517$var$ad($c87427e8b303c517$var$Lc, a);
    null !== $c87427e8b303c517$var$Mc && $c87427e8b303c517$var$ad($c87427e8b303c517$var$Mc, a);
    null !== $c87427e8b303c517$var$Nc && $c87427e8b303c517$var$ad($c87427e8b303c517$var$Nc, a);
    $c87427e8b303c517$var$Oc.forEach(b);
    $c87427e8b303c517$var$Pc.forEach(b);
    for(c = 0; c < $c87427e8b303c517$var$Qc.length; c++)d = $c87427e8b303c517$var$Qc[c], d.blockedOn === a && (d.blockedOn = null);
    for(; 0 < $c87427e8b303c517$var$Qc.length && (c = $c87427e8b303c517$var$Qc[0], null === c.blockedOn);)$c87427e8b303c517$var$Vc(c), null === c.blockedOn && $c87427e8b303c517$var$Qc.shift();
}
var $c87427e8b303c517$var$cd = $c87427e8b303c517$var$ua.ReactCurrentBatchConfig, $c87427e8b303c517$var$dd = !0;
function $c87427e8b303c517$var$ed(a, b, c, d) {
    var e = $c87427e8b303c517$var$C, f = $c87427e8b303c517$var$cd.transition;
    $c87427e8b303c517$var$cd.transition = null;
    try {
        $c87427e8b303c517$var$C = 1, $c87427e8b303c517$var$fd(a, b, c, d);
    } finally{
        $c87427e8b303c517$var$C = e, $c87427e8b303c517$var$cd.transition = f;
    }
}
function $c87427e8b303c517$var$gd(a, b, c, d) {
    var e = $c87427e8b303c517$var$C, f = $c87427e8b303c517$var$cd.transition;
    $c87427e8b303c517$var$cd.transition = null;
    try {
        $c87427e8b303c517$var$C = 4, $c87427e8b303c517$var$fd(a, b, c, d);
    } finally{
        $c87427e8b303c517$var$C = e, $c87427e8b303c517$var$cd.transition = f;
    }
}
function $c87427e8b303c517$var$fd(a, b, c, d) {
    if ($c87427e8b303c517$var$dd) {
        var e = $c87427e8b303c517$var$Yc(a, b, c, d);
        if (null === e) $c87427e8b303c517$var$hd(a, b, d, $c87427e8b303c517$var$id, c), $c87427e8b303c517$var$Sc(a, d);
        else if ($c87427e8b303c517$var$Uc(e, a, b, c, d)) d.stopPropagation();
        else if ($c87427e8b303c517$var$Sc(a, d), b & 4 && -1 < $c87427e8b303c517$var$Rc.indexOf(a)) {
            for(; null !== e;){
                var f = $c87427e8b303c517$var$Cb(e);
                null !== f && $c87427e8b303c517$var$Ec(f);
                f = $c87427e8b303c517$var$Yc(a, b, c, d);
                null === f && $c87427e8b303c517$var$hd(a, b, d, $c87427e8b303c517$var$id, c);
                if (f === e) break;
                e = f;
            }
            null !== e && d.stopPropagation();
        } else $c87427e8b303c517$var$hd(a, b, d, null, c);
    }
}
var $c87427e8b303c517$var$id = null;
function $c87427e8b303c517$var$Yc(a, b, c, d) {
    $c87427e8b303c517$var$id = null;
    a = $c87427e8b303c517$var$xb(d);
    a = $c87427e8b303c517$var$Wc(a);
    if (null !== a) {
        if (b = $c87427e8b303c517$var$Vb(a), null === b) a = null;
        else if (c = b.tag, 13 === c) {
            a = $c87427e8b303c517$var$Wb(b);
            if (null !== a) return a;
            a = null;
        } else if (3 === c) {
            if (b.stateNode.current.memoizedState.isDehydrated) return 3 === b.tag ? b.stateNode.containerInfo : null;
            a = null;
        } else b !== a && (a = null);
    }
    $c87427e8b303c517$var$id = a;
    return null;
}
function $c87427e8b303c517$var$jd(a) {
    switch(a){
        case "cancel":
        case "click":
        case "close":
        case "contextmenu":
        case "copy":
        case "cut":
        case "auxclick":
        case "dblclick":
        case "dragend":
        case "dragstart":
        case "drop":
        case "focusin":
        case "focusout":
        case "input":
        case "invalid":
        case "keydown":
        case "keypress":
        case "keyup":
        case "mousedown":
        case "mouseup":
        case "paste":
        case "pause":
        case "play":
        case "pointercancel":
        case "pointerdown":
        case "pointerup":
        case "ratechange":
        case "reset":
        case "resize":
        case "seeked":
        case "submit":
        case "touchcancel":
        case "touchend":
        case "touchstart":
        case "volumechange":
        case "change":
        case "selectionchange":
        case "textInput":
        case "compositionstart":
        case "compositionend":
        case "compositionupdate":
        case "beforeblur":
        case "afterblur":
        case "beforeinput":
        case "blur":
        case "fullscreenchange":
        case "focus":
        case "hashchange":
        case "popstate":
        case "select":
        case "selectstart":
            return 1;
        case "drag":
        case "dragenter":
        case "dragexit":
        case "dragleave":
        case "dragover":
        case "mousemove":
        case "mouseout":
        case "mouseover":
        case "pointermove":
        case "pointerout":
        case "pointerover":
        case "scroll":
        case "toggle":
        case "touchmove":
        case "wheel":
        case "mouseenter":
        case "mouseleave":
        case "pointerenter":
        case "pointerleave":
            return 4;
        case "message":
            switch($c87427e8b303c517$var$ec()){
                case $c87427e8b303c517$var$fc:
                    return 1;
                case $c87427e8b303c517$var$gc:
                    return 4;
                case $c87427e8b303c517$var$hc:
                case $c87427e8b303c517$var$ic:
                    return 16;
                case $c87427e8b303c517$var$jc:
                    return 536870912;
                default:
                    return 16;
            }
        default:
            return 16;
    }
}
var $c87427e8b303c517$var$kd = null, $c87427e8b303c517$var$ld = null, $c87427e8b303c517$var$md = null;
function $c87427e8b303c517$var$nd() {
    if ($c87427e8b303c517$var$md) return $c87427e8b303c517$var$md;
    var a, b = $c87427e8b303c517$var$ld, c = b.length, d, e = "value" in $c87427e8b303c517$var$kd ? $c87427e8b303c517$var$kd.value : $c87427e8b303c517$var$kd.textContent, f = e.length;
    for(a = 0; a < c && b[a] === e[a]; a++);
    var g = c - a;
    for(d = 1; d <= g && b[c - d] === e[f - d]; d++);
    return $c87427e8b303c517$var$md = e.slice(a, 1 < d ? 1 - d : void 0);
}
function $c87427e8b303c517$var$od(a) {
    var b = a.keyCode;
    "charCode" in a ? (a = a.charCode, 0 === a && 13 === b && (a = 13)) : a = b;
    10 === a && (a = 13);
    return 32 <= a || 13 === a ? a : 0;
}
function $c87427e8b303c517$var$pd() {
    return !0;
}
function $c87427e8b303c517$var$qd() {
    return !1;
}
function $c87427e8b303c517$var$rd(a) {
    function b(b, d, e, f, g) {
        this._reactName = b;
        this._targetInst = e;
        this.type = d;
        this.nativeEvent = f;
        this.target = g;
        this.currentTarget = null;
        for(var c in a)a.hasOwnProperty(c) && (b = a[c], this[c] = b ? b(f) : f[c]);
        this.isDefaultPrevented = (null != f.defaultPrevented ? f.defaultPrevented : !1 === f.returnValue) ? $c87427e8b303c517$var$pd : $c87427e8b303c517$var$qd;
        this.isPropagationStopped = $c87427e8b303c517$var$qd;
        return this;
    }
    $c87427e8b303c517$var$A(b.prototype, {
        preventDefault: function() {
            this.defaultPrevented = !0;
            var a = this.nativeEvent;
            a && (a.preventDefault ? a.preventDefault() : "unknown" !== typeof a.returnValue && (a.returnValue = !1), this.isDefaultPrevented = $c87427e8b303c517$var$pd);
        },
        stopPropagation: function() {
            var a = this.nativeEvent;
            a && (a.stopPropagation ? a.stopPropagation() : "unknown" !== typeof a.cancelBubble && (a.cancelBubble = !0), this.isPropagationStopped = $c87427e8b303c517$var$pd);
        },
        persist: function() {},
        isPersistent: $c87427e8b303c517$var$pd
    });
    return b;
}
var $c87427e8b303c517$var$sd = {
    eventPhase: 0,
    bubbles: 0,
    cancelable: 0,
    timeStamp: function(a) {
        return a.timeStamp || Date.now();
    },
    defaultPrevented: 0,
    isTrusted: 0
}, $c87427e8b303c517$var$td = $c87427e8b303c517$var$rd($c87427e8b303c517$var$sd), $c87427e8b303c517$var$ud = $c87427e8b303c517$var$A({}, $c87427e8b303c517$var$sd, {
    view: 0,
    detail: 0
}), $c87427e8b303c517$var$vd = $c87427e8b303c517$var$rd($c87427e8b303c517$var$ud), $c87427e8b303c517$var$wd, $c87427e8b303c517$var$xd, $c87427e8b303c517$var$yd, $c87427e8b303c517$var$Ad = $c87427e8b303c517$var$A({}, $c87427e8b303c517$var$ud, {
    screenX: 0,
    screenY: 0,
    clientX: 0,
    clientY: 0,
    pageX: 0,
    pageY: 0,
    ctrlKey: 0,
    shiftKey: 0,
    altKey: 0,
    metaKey: 0,
    getModifierState: $c87427e8b303c517$var$zd,
    button: 0,
    buttons: 0,
    relatedTarget: function(a) {
        return void 0 === a.relatedTarget ? a.fromElement === a.srcElement ? a.toElement : a.fromElement : a.relatedTarget;
    },
    movementX: function(a) {
        if ("movementX" in a) return a.movementX;
        a !== $c87427e8b303c517$var$yd && ($c87427e8b303c517$var$yd && "mousemove" === a.type ? ($c87427e8b303c517$var$wd = a.screenX - $c87427e8b303c517$var$yd.screenX, $c87427e8b303c517$var$xd = a.screenY - $c87427e8b303c517$var$yd.screenY) : $c87427e8b303c517$var$xd = $c87427e8b303c517$var$wd = 0, $c87427e8b303c517$var$yd = a);
        return $c87427e8b303c517$var$wd;
    },
    movementY: function(a) {
        return "movementY" in a ? a.movementY : $c87427e8b303c517$var$xd;
    }
}), $c87427e8b303c517$var$Bd = $c87427e8b303c517$var$rd($c87427e8b303c517$var$Ad), $c87427e8b303c517$var$Cd = $c87427e8b303c517$var$A({}, $c87427e8b303c517$var$Ad, {
    dataTransfer: 0
}), $c87427e8b303c517$var$Dd = $c87427e8b303c517$var$rd($c87427e8b303c517$var$Cd), $c87427e8b303c517$var$Ed = $c87427e8b303c517$var$A({}, $c87427e8b303c517$var$ud, {
    relatedTarget: 0
}), $c87427e8b303c517$var$Fd = $c87427e8b303c517$var$rd($c87427e8b303c517$var$Ed), $c87427e8b303c517$var$Gd = $c87427e8b303c517$var$A({}, $c87427e8b303c517$var$sd, {
    animationName: 0,
    elapsedTime: 0,
    pseudoElement: 0
}), $c87427e8b303c517$var$Hd = $c87427e8b303c517$var$rd($c87427e8b303c517$var$Gd), $c87427e8b303c517$var$Id = $c87427e8b303c517$var$A({}, $c87427e8b303c517$var$sd, {
    clipboardData: function(a) {
        return "clipboardData" in a ? a.clipboardData : window.clipboardData;
    }
}), $c87427e8b303c517$var$Jd = $c87427e8b303c517$var$rd($c87427e8b303c517$var$Id), $c87427e8b303c517$var$Kd = $c87427e8b303c517$var$A({}, $c87427e8b303c517$var$sd, {
    data: 0
}), $c87427e8b303c517$var$Ld = $c87427e8b303c517$var$rd($c87427e8b303c517$var$Kd), $c87427e8b303c517$var$Md = {
    Esc: "Escape",
    Spacebar: " ",
    Left: "ArrowLeft",
    Up: "ArrowUp",
    Right: "ArrowRight",
    Down: "ArrowDown",
    Del: "Delete",
    Win: "OS",
    Menu: "ContextMenu",
    Apps: "ContextMenu",
    Scroll: "ScrollLock",
    MozPrintableKey: "Unidentified"
}, $c87427e8b303c517$var$Nd = {
    8: "Backspace",
    9: "Tab",
    12: "Clear",
    13: "Enter",
    16: "Shift",
    17: "Control",
    18: "Alt",
    19: "Pause",
    20: "CapsLock",
    27: "Escape",
    32: " ",
    33: "PageUp",
    34: "PageDown",
    35: "End",
    36: "Home",
    37: "ArrowLeft",
    38: "ArrowUp",
    39: "ArrowRight",
    40: "ArrowDown",
    45: "Insert",
    46: "Delete",
    112: "F1",
    113: "F2",
    114: "F3",
    115: "F4",
    116: "F5",
    117: "F6",
    118: "F7",
    119: "F8",
    120: "F9",
    121: "F10",
    122: "F11",
    123: "F12",
    144: "NumLock",
    145: "ScrollLock",
    224: "Meta"
}, $c87427e8b303c517$var$Od = {
    Alt: "altKey",
    Control: "ctrlKey",
    Meta: "metaKey",
    Shift: "shiftKey"
};
function $c87427e8b303c517$var$Pd(a) {
    var b = this.nativeEvent;
    return b.getModifierState ? b.getModifierState(a) : (a = $c87427e8b303c517$var$Od[a]) ? !!b[a] : !1;
}
function $c87427e8b303c517$var$zd() {
    return $c87427e8b303c517$var$Pd;
}
var $c87427e8b303c517$var$Qd = $c87427e8b303c517$var$A({}, $c87427e8b303c517$var$ud, {
    key: function(a) {
        if (a.key) {
            var b = $c87427e8b303c517$var$Md[a.key] || a.key;
            if ("Unidentified" !== b) return b;
        }
        return "keypress" === a.type ? (a = $c87427e8b303c517$var$od(a), 13 === a ? "Enter" : String.fromCharCode(a)) : "keydown" === a.type || "keyup" === a.type ? $c87427e8b303c517$var$Nd[a.keyCode] || "Unidentified" : "";
    },
    code: 0,
    location: 0,
    ctrlKey: 0,
    shiftKey: 0,
    altKey: 0,
    metaKey: 0,
    repeat: 0,
    locale: 0,
    getModifierState: $c87427e8b303c517$var$zd,
    charCode: function(a) {
        return "keypress" === a.type ? $c87427e8b303c517$var$od(a) : 0;
    },
    keyCode: function(a) {
        return "keydown" === a.type || "keyup" === a.type ? a.keyCode : 0;
    },
    which: function(a) {
        return "keypress" === a.type ? $c87427e8b303c517$var$od(a) : "keydown" === a.type || "keyup" === a.type ? a.keyCode : 0;
    }
}), $c87427e8b303c517$var$Rd = $c87427e8b303c517$var$rd($c87427e8b303c517$var$Qd), $c87427e8b303c517$var$Sd = $c87427e8b303c517$var$A({}, $c87427e8b303c517$var$Ad, {
    pointerId: 0,
    width: 0,
    height: 0,
    pressure: 0,
    tangentialPressure: 0,
    tiltX: 0,
    tiltY: 0,
    twist: 0,
    pointerType: 0,
    isPrimary: 0
}), $c87427e8b303c517$var$Td = $c87427e8b303c517$var$rd($c87427e8b303c517$var$Sd), $c87427e8b303c517$var$Ud = $c87427e8b303c517$var$A({}, $c87427e8b303c517$var$ud, {
    touches: 0,
    targetTouches: 0,
    changedTouches: 0,
    altKey: 0,
    metaKey: 0,
    ctrlKey: 0,
    shiftKey: 0,
    getModifierState: $c87427e8b303c517$var$zd
}), $c87427e8b303c517$var$Vd = $c87427e8b303c517$var$rd($c87427e8b303c517$var$Ud), $c87427e8b303c517$var$Wd = $c87427e8b303c517$var$A({}, $c87427e8b303c517$var$sd, {
    propertyName: 0,
    elapsedTime: 0,
    pseudoElement: 0
}), $c87427e8b303c517$var$Xd = $c87427e8b303c517$var$rd($c87427e8b303c517$var$Wd), $c87427e8b303c517$var$Yd = $c87427e8b303c517$var$A({}, $c87427e8b303c517$var$Ad, {
    deltaX: function(a) {
        return "deltaX" in a ? a.deltaX : "wheelDeltaX" in a ? -a.wheelDeltaX : 0;
    },
    deltaY: function(a) {
        return "deltaY" in a ? a.deltaY : "wheelDeltaY" in a ? -a.wheelDeltaY : "wheelDelta" in a ? -a.wheelDelta : 0;
    },
    deltaZ: 0,
    deltaMode: 0
}), $c87427e8b303c517$var$Zd = $c87427e8b303c517$var$rd($c87427e8b303c517$var$Yd), $c87427e8b303c517$var$$d = [
    9,
    13,
    27,
    32
], $c87427e8b303c517$var$ae = $c87427e8b303c517$var$ia && "CompositionEvent" in window, $c87427e8b303c517$var$be = null;
$c87427e8b303c517$var$ia && "documentMode" in document && ($c87427e8b303c517$var$be = document.documentMode);
var $c87427e8b303c517$var$ce = $c87427e8b303c517$var$ia && "TextEvent" in window && !$c87427e8b303c517$var$be, $c87427e8b303c517$var$de = $c87427e8b303c517$var$ia && (!$c87427e8b303c517$var$ae || $c87427e8b303c517$var$be && 8 < $c87427e8b303c517$var$be && 11 >= $c87427e8b303c517$var$be), $c87427e8b303c517$var$ee = String.fromCharCode(32), $c87427e8b303c517$var$fe = !1;
function $c87427e8b303c517$var$ge(a, b) {
    switch(a){
        case "keyup":
            return -1 !== $c87427e8b303c517$var$$d.indexOf(b.keyCode);
        case "keydown":
            return 229 !== b.keyCode;
        case "keypress":
        case "mousedown":
        case "focusout":
            return !0;
        default:
            return !1;
    }
}
function $c87427e8b303c517$var$he(a) {
    a = a.detail;
    return "object" === typeof a && "data" in a ? a.data : null;
}
var $c87427e8b303c517$var$ie = !1;
function $c87427e8b303c517$var$je(a, b) {
    switch(a){
        case "compositionend":
            return $c87427e8b303c517$var$he(b);
        case "keypress":
            if (32 !== b.which) return null;
            $c87427e8b303c517$var$fe = !0;
            return $c87427e8b303c517$var$ee;
        case "textInput":
            return a = b.data, a === $c87427e8b303c517$var$ee && $c87427e8b303c517$var$fe ? null : a;
        default:
            return null;
    }
}
function $c87427e8b303c517$var$ke(a, b) {
    if ($c87427e8b303c517$var$ie) return "compositionend" === a || !$c87427e8b303c517$var$ae && $c87427e8b303c517$var$ge(a, b) ? (a = $c87427e8b303c517$var$nd(), $c87427e8b303c517$var$md = $c87427e8b303c517$var$ld = $c87427e8b303c517$var$kd = null, $c87427e8b303c517$var$ie = !1, a) : null;
    switch(a){
        case "paste":
            return null;
        case "keypress":
            if (!(b.ctrlKey || b.altKey || b.metaKey) || b.ctrlKey && b.altKey) {
                if (b.char && 1 < b.char.length) return b.char;
                if (b.which) return String.fromCharCode(b.which);
            }
            return null;
        case "compositionend":
            return $c87427e8b303c517$var$de && "ko" !== b.locale ? null : b.data;
        default:
            return null;
    }
}
var $c87427e8b303c517$var$le = {
    color: !0,
    date: !0,
    datetime: !0,
    "datetime-local": !0,
    email: !0,
    month: !0,
    number: !0,
    password: !0,
    range: !0,
    search: !0,
    tel: !0,
    text: !0,
    time: !0,
    url: !0,
    week: !0
};
function $c87427e8b303c517$var$me(a) {
    var b = a && a.nodeName && a.nodeName.toLowerCase();
    return "input" === b ? !!$c87427e8b303c517$var$le[a.type] : "textarea" === b ? !0 : !1;
}
function $c87427e8b303c517$var$ne(a, b, c, d) {
    $c87427e8b303c517$var$Eb(d);
    b = $c87427e8b303c517$var$oe(b, "onChange");
    0 < b.length && (c = new $c87427e8b303c517$var$td("onChange", "change", null, c, d), a.push({
        event: c,
        listeners: b
    }));
}
var $c87427e8b303c517$var$pe = null, $c87427e8b303c517$var$qe = null;
function $c87427e8b303c517$var$re(a) {
    $c87427e8b303c517$var$se(a, 0);
}
function $c87427e8b303c517$var$te(a) {
    var b = $c87427e8b303c517$var$ue(a);
    if ($c87427e8b303c517$var$Wa(b)) return a;
}
function $c87427e8b303c517$var$ve(a, b) {
    if ("change" === a) return b;
}
var $c87427e8b303c517$var$we = !1;
if ($c87427e8b303c517$var$ia) {
    var $c87427e8b303c517$var$xe;
    if ($c87427e8b303c517$var$ia) {
        var $c87427e8b303c517$var$ye = "oninput" in document;
        if (!$c87427e8b303c517$var$ye) {
            var $c87427e8b303c517$var$ze = document.createElement("div");
            $c87427e8b303c517$var$ze.setAttribute("oninput", "return;");
            $c87427e8b303c517$var$ye = "function" === typeof $c87427e8b303c517$var$ze.oninput;
        }
        $c87427e8b303c517$var$xe = $c87427e8b303c517$var$ye;
    } else $c87427e8b303c517$var$xe = !1;
    $c87427e8b303c517$var$we = $c87427e8b303c517$var$xe && (!document.documentMode || 9 < document.documentMode);
}
function $c87427e8b303c517$var$Ae() {
    $c87427e8b303c517$var$pe && ($c87427e8b303c517$var$pe.detachEvent("onpropertychange", $c87427e8b303c517$var$Be), $c87427e8b303c517$var$qe = $c87427e8b303c517$var$pe = null);
}
function $c87427e8b303c517$var$Be(a) {
    if ("value" === a.propertyName && $c87427e8b303c517$var$te($c87427e8b303c517$var$qe)) {
        var b = [];
        $c87427e8b303c517$var$ne(b, $c87427e8b303c517$var$qe, a, $c87427e8b303c517$var$xb(a));
        $c87427e8b303c517$var$Jb($c87427e8b303c517$var$re, b);
    }
}
function $c87427e8b303c517$var$Ce(a, b, c) {
    "focusin" === a ? ($c87427e8b303c517$var$Ae(), $c87427e8b303c517$var$pe = b, $c87427e8b303c517$var$qe = c, $c87427e8b303c517$var$pe.attachEvent("onpropertychange", $c87427e8b303c517$var$Be)) : "focusout" === a && $c87427e8b303c517$var$Ae();
}
function $c87427e8b303c517$var$De(a) {
    if ("selectionchange" === a || "keyup" === a || "keydown" === a) return $c87427e8b303c517$var$te($c87427e8b303c517$var$qe);
}
function $c87427e8b303c517$var$Ee(a, b) {
    if ("click" === a) return $c87427e8b303c517$var$te(b);
}
function $c87427e8b303c517$var$Fe(a, b) {
    if ("input" === a || "change" === a) return $c87427e8b303c517$var$te(b);
}
function $c87427e8b303c517$var$Ge(a, b) {
    return a === b && (0 !== a || 1 / a === 1 / b) || a !== a && b !== b;
}
var $c87427e8b303c517$var$He = "function" === typeof Object.is ? Object.is : $c87427e8b303c517$var$Ge;
function $c87427e8b303c517$var$Ie(a, b) {
    if ($c87427e8b303c517$var$He(a, b)) return !0;
    if ("object" !== typeof a || null === a || "object" !== typeof b || null === b) return !1;
    var c = Object.keys(a), d = Object.keys(b);
    if (c.length !== d.length) return !1;
    for(d = 0; d < c.length; d++){
        var e = c[d];
        if (!$c87427e8b303c517$var$ja.call(b, e) || !$c87427e8b303c517$var$He(a[e], b[e])) return !1;
    }
    return !0;
}
function $c87427e8b303c517$var$Je(a) {
    for(; a && a.firstChild;)a = a.firstChild;
    return a;
}
function $c87427e8b303c517$var$Ke(a, b) {
    var c = $c87427e8b303c517$var$Je(a);
    a = 0;
    for(var d; c;){
        if (3 === c.nodeType) {
            d = a + c.textContent.length;
            if (a <= b && d >= b) return {
                node: c,
                offset: b - a
            };
            a = d;
        }
        a: {
            for(; c;){
                if (c.nextSibling) {
                    c = c.nextSibling;
                    break a;
                }
                c = c.parentNode;
            }
            c = void 0;
        }
        c = $c87427e8b303c517$var$Je(c);
    }
}
function $c87427e8b303c517$var$Le(a, b) {
    return a && b ? a === b ? !0 : a && 3 === a.nodeType ? !1 : b && 3 === b.nodeType ? $c87427e8b303c517$var$Le(a, b.parentNode) : "contains" in a ? a.contains(b) : a.compareDocumentPosition ? !!(a.compareDocumentPosition(b) & 16) : !1 : !1;
}
function $c87427e8b303c517$var$Me() {
    for(var a = window, b = $c87427e8b303c517$var$Xa(); b instanceof a.HTMLIFrameElement;){
        try {
            var c = "string" === typeof b.contentWindow.location.href;
        } catch (d) {
            c = !1;
        }
        if (c) a = b.contentWindow;
        else break;
        b = $c87427e8b303c517$var$Xa(a.document);
    }
    return b;
}
function $c87427e8b303c517$var$Ne(a) {
    var b = a && a.nodeName && a.nodeName.toLowerCase();
    return b && ("input" === b && ("text" === a.type || "search" === a.type || "tel" === a.type || "url" === a.type || "password" === a.type) || "textarea" === b || "true" === a.contentEditable);
}
function $c87427e8b303c517$var$Oe(a) {
    var b = $c87427e8b303c517$var$Me(), c = a.focusedElem, d = a.selectionRange;
    if (b !== c && c && c.ownerDocument && $c87427e8b303c517$var$Le(c.ownerDocument.documentElement, c)) {
        if (null !== d && $c87427e8b303c517$var$Ne(c)) {
            if (b = d.start, a = d.end, void 0 === a && (a = b), "selectionStart" in c) c.selectionStart = b, c.selectionEnd = Math.min(a, c.value.length);
            else if (a = (b = c.ownerDocument || document) && b.defaultView || window, a.getSelection) {
                a = a.getSelection();
                var e = c.textContent.length, f = Math.min(d.start, e);
                d = void 0 === d.end ? f : Math.min(d.end, e);
                !a.extend && f > d && (e = d, d = f, f = e);
                e = $c87427e8b303c517$var$Ke(c, f);
                var g = $c87427e8b303c517$var$Ke(c, d);
                e && g && (1 !== a.rangeCount || a.anchorNode !== e.node || a.anchorOffset !== e.offset || a.focusNode !== g.node || a.focusOffset !== g.offset) && (b = b.createRange(), b.setStart(e.node, e.offset), a.removeAllRanges(), f > d ? (a.addRange(b), a.extend(g.node, g.offset)) : (b.setEnd(g.node, g.offset), a.addRange(b)));
            }
        }
        b = [];
        for(a = c; a = a.parentNode;)1 === a.nodeType && b.push({
            element: a,
            left: a.scrollLeft,
            top: a.scrollTop
        });
        "function" === typeof c.focus && c.focus();
        for(c = 0; c < b.length; c++)a = b[c], a.element.scrollLeft = a.left, a.element.scrollTop = a.top;
    }
}
var $c87427e8b303c517$var$Pe = $c87427e8b303c517$var$ia && "documentMode" in document && 11 >= document.documentMode, $c87427e8b303c517$var$Qe = null, $c87427e8b303c517$var$Re = null, $c87427e8b303c517$var$Se = null, $c87427e8b303c517$var$Te = !1;
function $c87427e8b303c517$var$Ue(a, b, c) {
    var d = c.window === c ? c.document : 9 === c.nodeType ? c : c.ownerDocument;
    $c87427e8b303c517$var$Te || null == $c87427e8b303c517$var$Qe || $c87427e8b303c517$var$Qe !== $c87427e8b303c517$var$Xa(d) || (d = $c87427e8b303c517$var$Qe, "selectionStart" in d && $c87427e8b303c517$var$Ne(d) ? d = {
        start: d.selectionStart,
        end: d.selectionEnd
    } : (d = (d.ownerDocument && d.ownerDocument.defaultView || window).getSelection(), d = {
        anchorNode: d.anchorNode,
        anchorOffset: d.anchorOffset,
        focusNode: d.focusNode,
        focusOffset: d.focusOffset
    }), $c87427e8b303c517$var$Se && $c87427e8b303c517$var$Ie($c87427e8b303c517$var$Se, d) || ($c87427e8b303c517$var$Se = d, d = $c87427e8b303c517$var$oe($c87427e8b303c517$var$Re, "onSelect"), 0 < d.length && (b = new $c87427e8b303c517$var$td("onSelect", "select", null, b, c), a.push({
        event: b,
        listeners: d
    }), b.target = $c87427e8b303c517$var$Qe)));
}
function $c87427e8b303c517$var$Ve(a, b) {
    var c = {};
    c[a.toLowerCase()] = b.toLowerCase();
    c["Webkit" + a] = "webkit" + b;
    c["Moz" + a] = "moz" + b;
    return c;
}
var $c87427e8b303c517$var$We = {
    animationend: $c87427e8b303c517$var$Ve("Animation", "AnimationEnd"),
    animationiteration: $c87427e8b303c517$var$Ve("Animation", "AnimationIteration"),
    animationstart: $c87427e8b303c517$var$Ve("Animation", "AnimationStart"),
    transitionend: $c87427e8b303c517$var$Ve("Transition", "TransitionEnd")
}, $c87427e8b303c517$var$Xe = {}, $c87427e8b303c517$var$Ye = {};
$c87427e8b303c517$var$ia && ($c87427e8b303c517$var$Ye = document.createElement("div").style, "AnimationEvent" in window || (delete $c87427e8b303c517$var$We.animationend.animation, delete $c87427e8b303c517$var$We.animationiteration.animation, delete $c87427e8b303c517$var$We.animationstart.animation), "TransitionEvent" in window || delete $c87427e8b303c517$var$We.transitionend.transition);
function $c87427e8b303c517$var$Ze(a) {
    if ($c87427e8b303c517$var$Xe[a]) return $c87427e8b303c517$var$Xe[a];
    if (!$c87427e8b303c517$var$We[a]) return a;
    var b = $c87427e8b303c517$var$We[a], c;
    for(c in b)if (b.hasOwnProperty(c) && c in $c87427e8b303c517$var$Ye) return $c87427e8b303c517$var$Xe[a] = b[c];
    return a;
}
var $c87427e8b303c517$var$$e = $c87427e8b303c517$var$Ze("animationend"), $c87427e8b303c517$var$af = $c87427e8b303c517$var$Ze("animationiteration"), $c87427e8b303c517$var$bf = $c87427e8b303c517$var$Ze("animationstart"), $c87427e8b303c517$var$cf = $c87427e8b303c517$var$Ze("transitionend"), $c87427e8b303c517$var$df = new Map, $c87427e8b303c517$var$ef = "abort auxClick cancel canPlay canPlayThrough click close contextMenu copy cut drag dragEnd dragEnter dragExit dragLeave dragOver dragStart drop durationChange emptied encrypted ended error gotPointerCapture input invalid keyDown keyPress keyUp load loadedData loadedMetadata loadStart lostPointerCapture mouseDown mouseMove mouseOut mouseOver mouseUp paste pause play playing pointerCancel pointerDown pointerMove pointerOut pointerOver pointerUp progress rateChange reset resize seeked seeking stalled submit suspend timeUpdate touchCancel touchEnd touchStart volumeChange scroll toggle touchMove waiting wheel".split(" ");
function $c87427e8b303c517$var$ff(a, b) {
    $c87427e8b303c517$var$df.set(a, b);
    $c87427e8b303c517$var$fa(b, [
        a
    ]);
}
for(var $c87427e8b303c517$var$gf = 0; $c87427e8b303c517$var$gf < $c87427e8b303c517$var$ef.length; $c87427e8b303c517$var$gf++){
    var $c87427e8b303c517$var$hf = $c87427e8b303c517$var$ef[$c87427e8b303c517$var$gf], $c87427e8b303c517$var$jf = $c87427e8b303c517$var$hf.toLowerCase(), $c87427e8b303c517$var$kf = $c87427e8b303c517$var$hf[0].toUpperCase() + $c87427e8b303c517$var$hf.slice(1);
    $c87427e8b303c517$var$ff($c87427e8b303c517$var$jf, "on" + $c87427e8b303c517$var$kf);
}
$c87427e8b303c517$var$ff($c87427e8b303c517$var$$e, "onAnimationEnd");
$c87427e8b303c517$var$ff($c87427e8b303c517$var$af, "onAnimationIteration");
$c87427e8b303c517$var$ff($c87427e8b303c517$var$bf, "onAnimationStart");
$c87427e8b303c517$var$ff("dblclick", "onDoubleClick");
$c87427e8b303c517$var$ff("focusin", "onFocus");
$c87427e8b303c517$var$ff("focusout", "onBlur");
$c87427e8b303c517$var$ff($c87427e8b303c517$var$cf, "onTransitionEnd");
$c87427e8b303c517$var$ha("onMouseEnter", [
    "mouseout",
    "mouseover"
]);
$c87427e8b303c517$var$ha("onMouseLeave", [
    "mouseout",
    "mouseover"
]);
$c87427e8b303c517$var$ha("onPointerEnter", [
    "pointerout",
    "pointerover"
]);
$c87427e8b303c517$var$ha("onPointerLeave", [
    "pointerout",
    "pointerover"
]);
$c87427e8b303c517$var$fa("onChange", "change click focusin focusout input keydown keyup selectionchange".split(" "));
$c87427e8b303c517$var$fa("onSelect", "focusout contextmenu dragend focusin keydown keyup mousedown mouseup selectionchange".split(" "));
$c87427e8b303c517$var$fa("onBeforeInput", [
    "compositionend",
    "keypress",
    "textInput",
    "paste"
]);
$c87427e8b303c517$var$fa("onCompositionEnd", "compositionend focusout keydown keypress keyup mousedown".split(" "));
$c87427e8b303c517$var$fa("onCompositionStart", "compositionstart focusout keydown keypress keyup mousedown".split(" "));
$c87427e8b303c517$var$fa("onCompositionUpdate", "compositionupdate focusout keydown keypress keyup mousedown".split(" "));
var $c87427e8b303c517$var$lf = "abort canplay canplaythrough durationchange emptied encrypted ended error loadeddata loadedmetadata loadstart pause play playing progress ratechange resize seeked seeking stalled suspend timeupdate volumechange waiting".split(" "), $c87427e8b303c517$var$mf = new Set("cancel close invalid load scroll toggle".split(" ").concat($c87427e8b303c517$var$lf));
function $c87427e8b303c517$var$nf(a, b, c) {
    var d = a.type || "unknown-event";
    a.currentTarget = c;
    $c87427e8b303c517$var$Ub(d, b, void 0, a);
    a.currentTarget = null;
}
function $c87427e8b303c517$var$se(a, b) {
    b = 0 !== (b & 4);
    for(var c = 0; c < a.length; c++){
        var d = a[c], e = d.event;
        d = d.listeners;
        a: {
            var f = void 0;
            if (b) for(var g = d.length - 1; 0 <= g; g--){
                var h = d[g], k = h.instance, l = h.currentTarget;
                h = h.listener;
                if (k !== f && e.isPropagationStopped()) break a;
                $c87427e8b303c517$var$nf(e, h, l);
                f = k;
            }
            else for(g = 0; g < d.length; g++){
                h = d[g];
                k = h.instance;
                l = h.currentTarget;
                h = h.listener;
                if (k !== f && e.isPropagationStopped()) break a;
                $c87427e8b303c517$var$nf(e, h, l);
                f = k;
            }
        }
    }
    if ($c87427e8b303c517$var$Qb) throw a = $c87427e8b303c517$var$Rb, $c87427e8b303c517$var$Qb = !1, $c87427e8b303c517$var$Rb = null, a;
}
function $c87427e8b303c517$var$D(a, b) {
    var c = b[$c87427e8b303c517$var$of];
    void 0 === c && (c = b[$c87427e8b303c517$var$of] = new Set);
    var d = a + "__bubble";
    c.has(d) || ($c87427e8b303c517$var$pf(b, a, 2, !1), c.add(d));
}
function $c87427e8b303c517$var$qf(a, b, c) {
    var d = 0;
    b && (d |= 4);
    $c87427e8b303c517$var$pf(c, a, d, b);
}
var $c87427e8b303c517$var$rf = "_reactListening" + Math.random().toString(36).slice(2);
function $c87427e8b303c517$var$sf(a) {
    if (!a[$c87427e8b303c517$var$rf]) {
        a[$c87427e8b303c517$var$rf] = !0;
        $c87427e8b303c517$var$da.forEach(function(b) {
            "selectionchange" !== b && ($c87427e8b303c517$var$mf.has(b) || $c87427e8b303c517$var$qf(b, !1, a), $c87427e8b303c517$var$qf(b, !0, a));
        });
        var b = 9 === a.nodeType ? a : a.ownerDocument;
        null === b || b[$c87427e8b303c517$var$rf] || (b[$c87427e8b303c517$var$rf] = !0, $c87427e8b303c517$var$qf("selectionchange", !1, b));
    }
}
function $c87427e8b303c517$var$pf(a, b, c, d) {
    switch($c87427e8b303c517$var$jd(b)){
        case 1:
            var e = $c87427e8b303c517$var$ed;
            break;
        case 4:
            e = $c87427e8b303c517$var$gd;
            break;
        default:
            e = $c87427e8b303c517$var$fd;
    }
    c = e.bind(null, b, c, a);
    e = void 0;
    !$c87427e8b303c517$var$Lb || "touchstart" !== b && "touchmove" !== b && "wheel" !== b || (e = !0);
    d ? void 0 !== e ? a.addEventListener(b, c, {
        capture: !0,
        passive: e
    }) : a.addEventListener(b, c, !0) : void 0 !== e ? a.addEventListener(b, c, {
        passive: e
    }) : a.addEventListener(b, c, !1);
}
function $c87427e8b303c517$var$hd(a, b, c, d, e) {
    var f = d;
    if (0 === (b & 1) && 0 === (b & 2) && null !== d) a: for(;;){
        if (null === d) return;
        var g = d.tag;
        if (3 === g || 4 === g) {
            var h = d.stateNode.containerInfo;
            if (h === e || 8 === h.nodeType && h.parentNode === e) break;
            if (4 === g) for(g = d.return; null !== g;){
                var k = g.tag;
                if (3 === k || 4 === k) {
                    if (k = g.stateNode.containerInfo, k === e || 8 === k.nodeType && k.parentNode === e) return;
                }
                g = g.return;
            }
            for(; null !== h;){
                g = $c87427e8b303c517$var$Wc(h);
                if (null === g) return;
                k = g.tag;
                if (5 === k || 6 === k) {
                    d = f = g;
                    continue a;
                }
                h = h.parentNode;
            }
        }
        d = d.return;
    }
    $c87427e8b303c517$var$Jb(function() {
        var d = f, e = $c87427e8b303c517$var$xb(c), g = [];
        a: {
            var h = $c87427e8b303c517$var$df.get(a);
            if (void 0 !== h) {
                var k = $c87427e8b303c517$var$td, n = a;
                switch(a){
                    case "keypress":
                        if (0 === $c87427e8b303c517$var$od(c)) break a;
                    case "keydown":
                    case "keyup":
                        k = $c87427e8b303c517$var$Rd;
                        break;
                    case "focusin":
                        n = "focus";
                        k = $c87427e8b303c517$var$Fd;
                        break;
                    case "focusout":
                        n = "blur";
                        k = $c87427e8b303c517$var$Fd;
                        break;
                    case "beforeblur":
                    case "afterblur":
                        k = $c87427e8b303c517$var$Fd;
                        break;
                    case "click":
                        if (2 === c.button) break a;
                    case "auxclick":
                    case "dblclick":
                    case "mousedown":
                    case "mousemove":
                    case "mouseup":
                    case "mouseout":
                    case "mouseover":
                    case "contextmenu":
                        k = $c87427e8b303c517$var$Bd;
                        break;
                    case "drag":
                    case "dragend":
                    case "dragenter":
                    case "dragexit":
                    case "dragleave":
                    case "dragover":
                    case "dragstart":
                    case "drop":
                        k = $c87427e8b303c517$var$Dd;
                        break;
                    case "touchcancel":
                    case "touchend":
                    case "touchmove":
                    case "touchstart":
                        k = $c87427e8b303c517$var$Vd;
                        break;
                    case $c87427e8b303c517$var$$e:
                    case $c87427e8b303c517$var$af:
                    case $c87427e8b303c517$var$bf:
                        k = $c87427e8b303c517$var$Hd;
                        break;
                    case $c87427e8b303c517$var$cf:
                        k = $c87427e8b303c517$var$Xd;
                        break;
                    case "scroll":
                        k = $c87427e8b303c517$var$vd;
                        break;
                    case "wheel":
                        k = $c87427e8b303c517$var$Zd;
                        break;
                    case "copy":
                    case "cut":
                    case "paste":
                        k = $c87427e8b303c517$var$Jd;
                        break;
                    case "gotpointercapture":
                    case "lostpointercapture":
                    case "pointercancel":
                    case "pointerdown":
                    case "pointermove":
                    case "pointerout":
                    case "pointerover":
                    case "pointerup":
                        k = $c87427e8b303c517$var$Td;
                }
                var t = 0 !== (b & 4), J = !t && "scroll" === a, x = t ? null !== h ? h + "Capture" : null : h;
                t = [];
                for(var w = d, u; null !== w;){
                    u = w;
                    var F = u.stateNode;
                    5 === u.tag && null !== F && (u = F, null !== x && (F = $c87427e8b303c517$var$Kb(w, x), null != F && t.push($c87427e8b303c517$var$tf(w, F, u))));
                    if (J) break;
                    w = w.return;
                }
                0 < t.length && (h = new k(h, n, null, c, e), g.push({
                    event: h,
                    listeners: t
                }));
            }
        }
        if (0 === (b & 7)) {
            a: {
                h = "mouseover" === a || "pointerover" === a;
                k = "mouseout" === a || "pointerout" === a;
                if (h && c !== $c87427e8b303c517$var$wb && (n = c.relatedTarget || c.fromElement) && ($c87427e8b303c517$var$Wc(n) || n[$c87427e8b303c517$var$uf])) break a;
                if (k || h) {
                    h = e.window === e ? e : (h = e.ownerDocument) ? h.defaultView || h.parentWindow : window;
                    if (k) {
                        if (n = c.relatedTarget || c.toElement, k = d, n = n ? $c87427e8b303c517$var$Wc(n) : null, null !== n && (J = $c87427e8b303c517$var$Vb(n), n !== J || 5 !== n.tag && 6 !== n.tag)) n = null;
                    } else k = null, n = d;
                    if (k !== n) {
                        t = $c87427e8b303c517$var$Bd;
                        F = "onMouseLeave";
                        x = "onMouseEnter";
                        w = "mouse";
                        if ("pointerout" === a || "pointerover" === a) t = $c87427e8b303c517$var$Td, F = "onPointerLeave", x = "onPointerEnter", w = "pointer";
                        J = null == k ? h : $c87427e8b303c517$var$ue(k);
                        u = null == n ? h : $c87427e8b303c517$var$ue(n);
                        h = new t(F, w + "leave", k, c, e);
                        h.target = J;
                        h.relatedTarget = u;
                        F = null;
                        $c87427e8b303c517$var$Wc(e) === d && (t = new t(x, w + "enter", n, c, e), t.target = u, t.relatedTarget = J, F = t);
                        J = F;
                        if (k && n) b: {
                            t = k;
                            x = n;
                            w = 0;
                            for(u = t; u; u = $c87427e8b303c517$var$vf(u))w++;
                            u = 0;
                            for(F = x; F; F = $c87427e8b303c517$var$vf(F))u++;
                            for(; 0 < w - u;)t = $c87427e8b303c517$var$vf(t), w--;
                            for(; 0 < u - w;)x = $c87427e8b303c517$var$vf(x), u--;
                            for(; w--;){
                                if (t === x || null !== x && t === x.alternate) break b;
                                t = $c87427e8b303c517$var$vf(t);
                                x = $c87427e8b303c517$var$vf(x);
                            }
                            t = null;
                        }
                        else t = null;
                        null !== k && $c87427e8b303c517$var$wf(g, h, k, t, !1);
                        null !== n && null !== J && $c87427e8b303c517$var$wf(g, J, n, t, !0);
                    }
                }
            }
            a: {
                h = d ? $c87427e8b303c517$var$ue(d) : window;
                k = h.nodeName && h.nodeName.toLowerCase();
                if ("select" === k || "input" === k && "file" === h.type) var na = $c87427e8b303c517$var$ve;
                else if ($c87427e8b303c517$var$me(h)) {
                    if ($c87427e8b303c517$var$we) na = $c87427e8b303c517$var$Fe;
                    else {
                        na = $c87427e8b303c517$var$De;
                        var xa = $c87427e8b303c517$var$Ce;
                    }
                } else (k = h.nodeName) && "input" === k.toLowerCase() && ("checkbox" === h.type || "radio" === h.type) && (na = $c87427e8b303c517$var$Ee);
                if (na && (na = na(a, d))) {
                    $c87427e8b303c517$var$ne(g, na, c, e);
                    break a;
                }
                xa && xa(a, h, d);
                "focusout" === a && (xa = h._wrapperState) && xa.controlled && "number" === h.type && $c87427e8b303c517$var$cb(h, "number", h.value);
            }
            xa = d ? $c87427e8b303c517$var$ue(d) : window;
            switch(a){
                case "focusin":
                    if ($c87427e8b303c517$var$me(xa) || "true" === xa.contentEditable) $c87427e8b303c517$var$Qe = xa, $c87427e8b303c517$var$Re = d, $c87427e8b303c517$var$Se = null;
                    break;
                case "focusout":
                    $c87427e8b303c517$var$Se = $c87427e8b303c517$var$Re = $c87427e8b303c517$var$Qe = null;
                    break;
                case "mousedown":
                    $c87427e8b303c517$var$Te = !0;
                    break;
                case "contextmenu":
                case "mouseup":
                case "dragend":
                    $c87427e8b303c517$var$Te = !1;
                    $c87427e8b303c517$var$Ue(g, c, e);
                    break;
                case "selectionchange":
                    if ($c87427e8b303c517$var$Pe) break;
                case "keydown":
                case "keyup":
                    $c87427e8b303c517$var$Ue(g, c, e);
            }
            var $a;
            if ($c87427e8b303c517$var$ae) b: {
                switch(a){
                    case "compositionstart":
                        var ba = "onCompositionStart";
                        break b;
                    case "compositionend":
                        ba = "onCompositionEnd";
                        break b;
                    case "compositionupdate":
                        ba = "onCompositionUpdate";
                        break b;
                }
                ba = void 0;
            }
            else $c87427e8b303c517$var$ie ? $c87427e8b303c517$var$ge(a, c) && (ba = "onCompositionEnd") : "keydown" === a && 229 === c.keyCode && (ba = "onCompositionStart");
            ba && ($c87427e8b303c517$var$de && "ko" !== c.locale && ($c87427e8b303c517$var$ie || "onCompositionStart" !== ba ? "onCompositionEnd" === ba && $c87427e8b303c517$var$ie && ($a = $c87427e8b303c517$var$nd()) : ($c87427e8b303c517$var$kd = e, $c87427e8b303c517$var$ld = "value" in $c87427e8b303c517$var$kd ? $c87427e8b303c517$var$kd.value : $c87427e8b303c517$var$kd.textContent, $c87427e8b303c517$var$ie = !0)), xa = $c87427e8b303c517$var$oe(d, ba), 0 < xa.length && (ba = new $c87427e8b303c517$var$Ld(ba, a, null, c, e), g.push({
                event: ba,
                listeners: xa
            }), $a ? ba.data = $a : ($a = $c87427e8b303c517$var$he(c), null !== $a && (ba.data = $a))));
            if ($a = $c87427e8b303c517$var$ce ? $c87427e8b303c517$var$je(a, c) : $c87427e8b303c517$var$ke(a, c)) d = $c87427e8b303c517$var$oe(d, "onBeforeInput"), 0 < d.length && (e = new $c87427e8b303c517$var$Ld("onBeforeInput", "beforeinput", null, c, e), g.push({
                event: e,
                listeners: d
            }), e.data = $a);
        }
        $c87427e8b303c517$var$se(g, b);
    });
}
function $c87427e8b303c517$var$tf(a, b, c) {
    return {
        instance: a,
        listener: b,
        currentTarget: c
    };
}
function $c87427e8b303c517$var$oe(a, b) {
    for(var c = b + "Capture", d = []; null !== a;){
        var e = a, f = e.stateNode;
        5 === e.tag && null !== f && (e = f, f = $c87427e8b303c517$var$Kb(a, c), null != f && d.unshift($c87427e8b303c517$var$tf(a, f, e)), f = $c87427e8b303c517$var$Kb(a, b), null != f && d.push($c87427e8b303c517$var$tf(a, f, e)));
        a = a.return;
    }
    return d;
}
function $c87427e8b303c517$var$vf(a) {
    if (null === a) return null;
    do a = a.return;
    while (a && 5 !== a.tag);
    return a ? a : null;
}
function $c87427e8b303c517$var$wf(a, b, c, d, e) {
    for(var f = b._reactName, g = []; null !== c && c !== d;){
        var h = c, k = h.alternate, l = h.stateNode;
        if (null !== k && k === d) break;
        5 === h.tag && null !== l && (h = l, e ? (k = $c87427e8b303c517$var$Kb(c, f), null != k && g.unshift($c87427e8b303c517$var$tf(c, k, h))) : e || (k = $c87427e8b303c517$var$Kb(c, f), null != k && g.push($c87427e8b303c517$var$tf(c, k, h))));
        c = c.return;
    }
    0 !== g.length && a.push({
        event: b,
        listeners: g
    });
}
var $c87427e8b303c517$var$xf = /\r\n?/g, $c87427e8b303c517$var$yf = /\u0000|\uFFFD/g;
function $c87427e8b303c517$var$zf(a) {
    return ("string" === typeof a ? a : "" + a).replace($c87427e8b303c517$var$xf, "\n").replace($c87427e8b303c517$var$yf, "");
}
function $c87427e8b303c517$var$Af(a, b, c) {
    b = $c87427e8b303c517$var$zf(b);
    if ($c87427e8b303c517$var$zf(a) !== b && c) throw Error($c87427e8b303c517$var$p(425));
}
function $c87427e8b303c517$var$Bf() {}
var $c87427e8b303c517$var$Cf = null, $c87427e8b303c517$var$Df = null;
function $c87427e8b303c517$var$Ef(a, b) {
    return "textarea" === a || "noscript" === a || "string" === typeof b.children || "number" === typeof b.children || "object" === typeof b.dangerouslySetInnerHTML && null !== b.dangerouslySetInnerHTML && null != b.dangerouslySetInnerHTML.__html;
}
var $c87427e8b303c517$var$Ff = "function" === typeof setTimeout ? setTimeout : void 0, $c87427e8b303c517$var$Gf = "function" === typeof clearTimeout ? clearTimeout : void 0, $c87427e8b303c517$var$Hf = "function" === typeof Promise ? Promise : void 0, $c87427e8b303c517$var$Jf = "function" === typeof queueMicrotask ? queueMicrotask : "undefined" !== typeof $c87427e8b303c517$var$Hf ? function(a) {
    return $c87427e8b303c517$var$Hf.resolve(null).then(a).catch($c87427e8b303c517$var$If);
} : $c87427e8b303c517$var$Ff;
function $c87427e8b303c517$var$If(a) {
    setTimeout(function() {
        throw a;
    });
}
function $c87427e8b303c517$var$Kf(a, b) {
    var c = b, d = 0;
    do {
        var e = c.nextSibling;
        a.removeChild(c);
        if (e && 8 === e.nodeType) {
            if (c = e.data, "/$" === c) {
                if (0 === d) {
                    a.removeChild(e);
                    $c87427e8b303c517$var$bd(b);
                    return;
                }
                d--;
            } else "$" !== c && "$?" !== c && "$!" !== c || d++;
        }
        c = e;
    }while (c);
    $c87427e8b303c517$var$bd(b);
}
function $c87427e8b303c517$var$Lf(a) {
    for(; null != a; a = a.nextSibling){
        var b = a.nodeType;
        if (1 === b || 3 === b) break;
        if (8 === b) {
            b = a.data;
            if ("$" === b || "$!" === b || "$?" === b) break;
            if ("/$" === b) return null;
        }
    }
    return a;
}
function $c87427e8b303c517$var$Mf(a) {
    a = a.previousSibling;
    for(var b = 0; a;){
        if (8 === a.nodeType) {
            var c = a.data;
            if ("$" === c || "$!" === c || "$?" === c) {
                if (0 === b) return a;
                b--;
            } else "/$" === c && b++;
        }
        a = a.previousSibling;
    }
    return null;
}
var $c87427e8b303c517$var$Nf = Math.random().toString(36).slice(2), $c87427e8b303c517$var$Of = "__reactFiber$" + $c87427e8b303c517$var$Nf, $c87427e8b303c517$var$Pf = "__reactProps$" + $c87427e8b303c517$var$Nf, $c87427e8b303c517$var$uf = "__reactContainer$" + $c87427e8b303c517$var$Nf, $c87427e8b303c517$var$of = "__reactEvents$" + $c87427e8b303c517$var$Nf, $c87427e8b303c517$var$Qf = "__reactListeners$" + $c87427e8b303c517$var$Nf, $c87427e8b303c517$var$Rf = "__reactHandles$" + $c87427e8b303c517$var$Nf;
function $c87427e8b303c517$var$Wc(a) {
    var b = a[$c87427e8b303c517$var$Of];
    if (b) return b;
    for(var c = a.parentNode; c;){
        if (b = c[$c87427e8b303c517$var$uf] || c[$c87427e8b303c517$var$Of]) {
            c = b.alternate;
            if (null !== b.child || null !== c && null !== c.child) for(a = $c87427e8b303c517$var$Mf(a); null !== a;){
                if (c = a[$c87427e8b303c517$var$Of]) return c;
                a = $c87427e8b303c517$var$Mf(a);
            }
            return b;
        }
        a = c;
        c = a.parentNode;
    }
    return null;
}
function $c87427e8b303c517$var$Cb(a) {
    a = a[$c87427e8b303c517$var$Of] || a[$c87427e8b303c517$var$uf];
    return !a || 5 !== a.tag && 6 !== a.tag && 13 !== a.tag && 3 !== a.tag ? null : a;
}
function $c87427e8b303c517$var$ue(a) {
    if (5 === a.tag || 6 === a.tag) return a.stateNode;
    throw Error($c87427e8b303c517$var$p(33));
}
function $c87427e8b303c517$var$Db(a) {
    return a[$c87427e8b303c517$var$Pf] || null;
}
var $c87427e8b303c517$var$Sf = [], $c87427e8b303c517$var$Tf = -1;
function $c87427e8b303c517$var$Uf(a) {
    return {
        current: a
    };
}
function $c87427e8b303c517$var$E(a) {
    0 > $c87427e8b303c517$var$Tf || (a.current = $c87427e8b303c517$var$Sf[$c87427e8b303c517$var$Tf], $c87427e8b303c517$var$Sf[$c87427e8b303c517$var$Tf] = null, $c87427e8b303c517$var$Tf--);
}
function $c87427e8b303c517$var$G(a, b) {
    $c87427e8b303c517$var$Tf++;
    $c87427e8b303c517$var$Sf[$c87427e8b303c517$var$Tf] = a.current;
    a.current = b;
}
var $c87427e8b303c517$var$Vf = {}, $c87427e8b303c517$var$H = $c87427e8b303c517$var$Uf($c87427e8b303c517$var$Vf), $c87427e8b303c517$var$Wf = $c87427e8b303c517$var$Uf(!1), $c87427e8b303c517$var$Xf = $c87427e8b303c517$var$Vf;
function $c87427e8b303c517$var$Yf(a, b) {
    var c = a.type.contextTypes;
    if (!c) return $c87427e8b303c517$var$Vf;
    var d = a.stateNode;
    if (d && d.__reactInternalMemoizedUnmaskedChildContext === b) return d.__reactInternalMemoizedMaskedChildContext;
    var e = {}, f;
    for(f in c)e[f] = b[f];
    d && (a = a.stateNode, a.__reactInternalMemoizedUnmaskedChildContext = b, a.__reactInternalMemoizedMaskedChildContext = e);
    return e;
}
function $c87427e8b303c517$var$Zf(a) {
    a = a.childContextTypes;
    return null !== a && void 0 !== a;
}
function $c87427e8b303c517$var$$f() {
    $c87427e8b303c517$var$E($c87427e8b303c517$var$Wf);
    $c87427e8b303c517$var$E($c87427e8b303c517$var$H);
}
function $c87427e8b303c517$var$ag(a, b, c) {
    if ($c87427e8b303c517$var$H.current !== $c87427e8b303c517$var$Vf) throw Error($c87427e8b303c517$var$p(168));
    $c87427e8b303c517$var$G($c87427e8b303c517$var$H, b);
    $c87427e8b303c517$var$G($c87427e8b303c517$var$Wf, c);
}
function $c87427e8b303c517$var$bg(a, b, c) {
    var d = a.stateNode;
    b = b.childContextTypes;
    if ("function" !== typeof d.getChildContext) return c;
    d = d.getChildContext();
    for(var e in d)if (!(e in b)) throw Error($c87427e8b303c517$var$p(108, $c87427e8b303c517$var$Ra(a) || "Unknown", e));
    return $c87427e8b303c517$var$A({}, c, d);
}
function $c87427e8b303c517$var$cg(a) {
    a = (a = a.stateNode) && a.__reactInternalMemoizedMergedChildContext || $c87427e8b303c517$var$Vf;
    $c87427e8b303c517$var$Xf = $c87427e8b303c517$var$H.current;
    $c87427e8b303c517$var$G($c87427e8b303c517$var$H, a);
    $c87427e8b303c517$var$G($c87427e8b303c517$var$Wf, $c87427e8b303c517$var$Wf.current);
    return !0;
}
function $c87427e8b303c517$var$dg(a, b, c) {
    var d = a.stateNode;
    if (!d) throw Error($c87427e8b303c517$var$p(169));
    c ? (a = $c87427e8b303c517$var$bg(a, b, $c87427e8b303c517$var$Xf), d.__reactInternalMemoizedMergedChildContext = a, $c87427e8b303c517$var$E($c87427e8b303c517$var$Wf), $c87427e8b303c517$var$E($c87427e8b303c517$var$H), $c87427e8b303c517$var$G($c87427e8b303c517$var$H, a)) : $c87427e8b303c517$var$E($c87427e8b303c517$var$Wf);
    $c87427e8b303c517$var$G($c87427e8b303c517$var$Wf, c);
}
var $c87427e8b303c517$var$eg = null, $c87427e8b303c517$var$fg = !1, $c87427e8b303c517$var$gg = !1;
function $c87427e8b303c517$var$hg(a) {
    null === $c87427e8b303c517$var$eg ? $c87427e8b303c517$var$eg = [
        a
    ] : $c87427e8b303c517$var$eg.push(a);
}
function $c87427e8b303c517$var$ig(a) {
    $c87427e8b303c517$var$fg = !0;
    $c87427e8b303c517$var$hg(a);
}
function $c87427e8b303c517$var$jg() {
    if (!$c87427e8b303c517$var$gg && null !== $c87427e8b303c517$var$eg) {
        $c87427e8b303c517$var$gg = !0;
        var a = 0, b = $c87427e8b303c517$var$C;
        try {
            var c = $c87427e8b303c517$var$eg;
            for($c87427e8b303c517$var$C = 1; a < c.length; a++){
                var d = c[a];
                do d = d(!0);
                while (null !== d);
            }
            $c87427e8b303c517$var$eg = null;
            $c87427e8b303c517$var$fg = !1;
        } catch (e) {
            throw null !== $c87427e8b303c517$var$eg && ($c87427e8b303c517$var$eg = $c87427e8b303c517$var$eg.slice(a + 1)), $c87427e8b303c517$var$ac($c87427e8b303c517$var$fc, $c87427e8b303c517$var$jg), e;
        } finally{
            $c87427e8b303c517$var$C = b, $c87427e8b303c517$var$gg = !1;
        }
    }
    return null;
}
var $c87427e8b303c517$var$kg = [], $c87427e8b303c517$var$lg = 0, $c87427e8b303c517$var$mg = null, $c87427e8b303c517$var$ng = 0, $c87427e8b303c517$var$og = [], $c87427e8b303c517$var$pg = 0, $c87427e8b303c517$var$qg = null, $c87427e8b303c517$var$rg = 1, $c87427e8b303c517$var$sg = "";
function $c87427e8b303c517$var$tg(a, b) {
    $c87427e8b303c517$var$kg[$c87427e8b303c517$var$lg++] = $c87427e8b303c517$var$ng;
    $c87427e8b303c517$var$kg[$c87427e8b303c517$var$lg++] = $c87427e8b303c517$var$mg;
    $c87427e8b303c517$var$mg = a;
    $c87427e8b303c517$var$ng = b;
}
function $c87427e8b303c517$var$ug(a, b, c) {
    $c87427e8b303c517$var$og[$c87427e8b303c517$var$pg++] = $c87427e8b303c517$var$rg;
    $c87427e8b303c517$var$og[$c87427e8b303c517$var$pg++] = $c87427e8b303c517$var$sg;
    $c87427e8b303c517$var$og[$c87427e8b303c517$var$pg++] = $c87427e8b303c517$var$qg;
    $c87427e8b303c517$var$qg = a;
    var d = $c87427e8b303c517$var$rg;
    a = $c87427e8b303c517$var$sg;
    var e = 32 - $c87427e8b303c517$var$oc(d) - 1;
    d &= ~(1 << e);
    c += 1;
    var f = 32 - $c87427e8b303c517$var$oc(b) + e;
    if (30 < f) {
        var g = e - e % 5;
        f = (d & (1 << g) - 1).toString(32);
        d >>= g;
        e -= g;
        $c87427e8b303c517$var$rg = 1 << 32 - $c87427e8b303c517$var$oc(b) + e | c << e | d;
        $c87427e8b303c517$var$sg = f + a;
    } else $c87427e8b303c517$var$rg = 1 << f | c << e | d, $c87427e8b303c517$var$sg = a;
}
function $c87427e8b303c517$var$vg(a) {
    null !== a.return && ($c87427e8b303c517$var$tg(a, 1), $c87427e8b303c517$var$ug(a, 1, 0));
}
function $c87427e8b303c517$var$wg(a) {
    for(; a === $c87427e8b303c517$var$mg;)$c87427e8b303c517$var$mg = $c87427e8b303c517$var$kg[--$c87427e8b303c517$var$lg], $c87427e8b303c517$var$kg[$c87427e8b303c517$var$lg] = null, $c87427e8b303c517$var$ng = $c87427e8b303c517$var$kg[--$c87427e8b303c517$var$lg], $c87427e8b303c517$var$kg[$c87427e8b303c517$var$lg] = null;
    for(; a === $c87427e8b303c517$var$qg;)$c87427e8b303c517$var$qg = $c87427e8b303c517$var$og[--$c87427e8b303c517$var$pg], $c87427e8b303c517$var$og[$c87427e8b303c517$var$pg] = null, $c87427e8b303c517$var$sg = $c87427e8b303c517$var$og[--$c87427e8b303c517$var$pg], $c87427e8b303c517$var$og[$c87427e8b303c517$var$pg] = null, $c87427e8b303c517$var$rg = $c87427e8b303c517$var$og[--$c87427e8b303c517$var$pg], $c87427e8b303c517$var$og[$c87427e8b303c517$var$pg] = null;
}
var $c87427e8b303c517$var$xg = null, $c87427e8b303c517$var$yg = null, $c87427e8b303c517$var$I = !1, $c87427e8b303c517$var$zg = null;
function $c87427e8b303c517$var$Ag(a, b) {
    var c = $c87427e8b303c517$var$Bg(5, null, null, 0);
    c.elementType = "DELETED";
    c.stateNode = b;
    c.return = a;
    b = a.deletions;
    null === b ? (a.deletions = [
        c
    ], a.flags |= 16) : b.push(c);
}
function $c87427e8b303c517$var$Cg(a, b) {
    switch(a.tag){
        case 5:
            var c = a.type;
            b = 1 !== b.nodeType || c.toLowerCase() !== b.nodeName.toLowerCase() ? null : b;
            return null !== b ? (a.stateNode = b, $c87427e8b303c517$var$xg = a, $c87427e8b303c517$var$yg = $c87427e8b303c517$var$Lf(b.firstChild), !0) : !1;
        case 6:
            return b = "" === a.pendingProps || 3 !== b.nodeType ? null : b, null !== b ? (a.stateNode = b, $c87427e8b303c517$var$xg = a, $c87427e8b303c517$var$yg = null, !0) : !1;
        case 13:
            return b = 8 !== b.nodeType ? null : b, null !== b ? (c = null !== $c87427e8b303c517$var$qg ? {
                id: $c87427e8b303c517$var$rg,
                overflow: $c87427e8b303c517$var$sg
            } : null, a.memoizedState = {
                dehydrated: b,
                treeContext: c,
                retryLane: 1073741824
            }, c = $c87427e8b303c517$var$Bg(18, null, null, 0), c.stateNode = b, c.return = a, a.child = c, $c87427e8b303c517$var$xg = a, $c87427e8b303c517$var$yg = null, !0) : !1;
        default:
            return !1;
    }
}
function $c87427e8b303c517$var$Dg(a) {
    return 0 !== (a.mode & 1) && 0 === (a.flags & 128);
}
function $c87427e8b303c517$var$Eg(a) {
    if ($c87427e8b303c517$var$I) {
        var b = $c87427e8b303c517$var$yg;
        if (b) {
            var c = b;
            if (!$c87427e8b303c517$var$Cg(a, b)) {
                if ($c87427e8b303c517$var$Dg(a)) throw Error($c87427e8b303c517$var$p(418));
                b = $c87427e8b303c517$var$Lf(c.nextSibling);
                var d = $c87427e8b303c517$var$xg;
                b && $c87427e8b303c517$var$Cg(a, b) ? $c87427e8b303c517$var$Ag(d, c) : (a.flags = a.flags & -4097 | 2, $c87427e8b303c517$var$I = !1, $c87427e8b303c517$var$xg = a);
            }
        } else {
            if ($c87427e8b303c517$var$Dg(a)) throw Error($c87427e8b303c517$var$p(418));
            a.flags = a.flags & -4097 | 2;
            $c87427e8b303c517$var$I = !1;
            $c87427e8b303c517$var$xg = a;
        }
    }
}
function $c87427e8b303c517$var$Fg(a) {
    for(a = a.return; null !== a && 5 !== a.tag && 3 !== a.tag && 13 !== a.tag;)a = a.return;
    $c87427e8b303c517$var$xg = a;
}
function $c87427e8b303c517$var$Gg(a) {
    if (a !== $c87427e8b303c517$var$xg) return !1;
    if (!$c87427e8b303c517$var$I) return $c87427e8b303c517$var$Fg(a), $c87427e8b303c517$var$I = !0, !1;
    var b;
    (b = 3 !== a.tag) && !(b = 5 !== a.tag) && (b = a.type, b = "head" !== b && "body" !== b && !$c87427e8b303c517$var$Ef(a.type, a.memoizedProps));
    if (b && (b = $c87427e8b303c517$var$yg)) {
        if ($c87427e8b303c517$var$Dg(a)) throw $c87427e8b303c517$var$Hg(), Error($c87427e8b303c517$var$p(418));
        for(; b;)$c87427e8b303c517$var$Ag(a, b), b = $c87427e8b303c517$var$Lf(b.nextSibling);
    }
    $c87427e8b303c517$var$Fg(a);
    if (13 === a.tag) {
        a = a.memoizedState;
        a = null !== a ? a.dehydrated : null;
        if (!a) throw Error($c87427e8b303c517$var$p(317));
        a: {
            a = a.nextSibling;
            for(b = 0; a;){
                if (8 === a.nodeType) {
                    var c = a.data;
                    if ("/$" === c) {
                        if (0 === b) {
                            $c87427e8b303c517$var$yg = $c87427e8b303c517$var$Lf(a.nextSibling);
                            break a;
                        }
                        b--;
                    } else "$" !== c && "$!" !== c && "$?" !== c || b++;
                }
                a = a.nextSibling;
            }
            $c87427e8b303c517$var$yg = null;
        }
    } else $c87427e8b303c517$var$yg = $c87427e8b303c517$var$xg ? $c87427e8b303c517$var$Lf(a.stateNode.nextSibling) : null;
    return !0;
}
function $c87427e8b303c517$var$Hg() {
    for(var a = $c87427e8b303c517$var$yg; a;)a = $c87427e8b303c517$var$Lf(a.nextSibling);
}
function $c87427e8b303c517$var$Ig() {
    $c87427e8b303c517$var$yg = $c87427e8b303c517$var$xg = null;
    $c87427e8b303c517$var$I = !1;
}
function $c87427e8b303c517$var$Jg(a) {
    null === $c87427e8b303c517$var$zg ? $c87427e8b303c517$var$zg = [
        a
    ] : $c87427e8b303c517$var$zg.push(a);
}
var $c87427e8b303c517$var$Kg = $c87427e8b303c517$var$ua.ReactCurrentBatchConfig;
function $c87427e8b303c517$var$Lg(a, b, c) {
    a = c.ref;
    if (null !== a && "function" !== typeof a && "object" !== typeof a) {
        if (c._owner) {
            c = c._owner;
            if (c) {
                if (1 !== c.tag) throw Error($c87427e8b303c517$var$p(309));
                var d = c.stateNode;
            }
            if (!d) throw Error($c87427e8b303c517$var$p(147, a));
            var e = d, f = "" + a;
            if (null !== b && null !== b.ref && "function" === typeof b.ref && b.ref._stringRef === f) return b.ref;
            b = function(a) {
                var b = e.refs;
                null === a ? delete b[f] : b[f] = a;
            };
            b._stringRef = f;
            return b;
        }
        if ("string" !== typeof a) throw Error($c87427e8b303c517$var$p(284));
        if (!c._owner) throw Error($c87427e8b303c517$var$p(290, a));
    }
    return a;
}
function $c87427e8b303c517$var$Mg(a, b) {
    a = Object.prototype.toString.call(b);
    throw Error($c87427e8b303c517$var$p(31, "[object Object]" === a ? "object with keys {" + Object.keys(b).join(", ") + "}" : a));
}
function $c87427e8b303c517$var$Ng(a) {
    var b = a._init;
    return b(a._payload);
}
function $c87427e8b303c517$var$Og(a) {
    function b(b, c) {
        if (a) {
            var d = b.deletions;
            null === d ? (b.deletions = [
                c
            ], b.flags |= 16) : d.push(c);
        }
    }
    function c(c, d) {
        if (!a) return null;
        for(; null !== d;)b(c, d), d = d.sibling;
        return null;
    }
    function d(a, b) {
        for(a = new Map; null !== b;)null !== b.key ? a.set(b.key, b) : a.set(b.index, b), b = b.sibling;
        return a;
    }
    function e(a, b) {
        a = $c87427e8b303c517$var$Pg(a, b);
        a.index = 0;
        a.sibling = null;
        return a;
    }
    function f(b, c, d) {
        b.index = d;
        if (!a) return b.flags |= 1048576, c;
        d = b.alternate;
        if (null !== d) return d = d.index, d < c ? (b.flags |= 2, c) : d;
        b.flags |= 2;
        return c;
    }
    function g(b) {
        a && null === b.alternate && (b.flags |= 2);
        return b;
    }
    function h(a, b, c, d) {
        if (null === b || 6 !== b.tag) return b = $c87427e8b303c517$var$Qg(c, a.mode, d), b.return = a, b;
        b = e(b, c);
        b.return = a;
        return b;
    }
    function k(a, b, c, d) {
        var f = c.type;
        if (f === $c87427e8b303c517$var$ya) return m(a, b, c.props.children, d, c.key);
        if (null !== b && (b.elementType === f || "object" === typeof f && null !== f && f.$$typeof === $c87427e8b303c517$var$Ha && $c87427e8b303c517$var$Ng(f) === b.type)) return d = e(b, c.props), d.ref = $c87427e8b303c517$var$Lg(a, b, c), d.return = a, d;
        d = $c87427e8b303c517$var$Rg(c.type, c.key, c.props, null, a.mode, d);
        d.ref = $c87427e8b303c517$var$Lg(a, b, c);
        d.return = a;
        return d;
    }
    function l(a, b, c, d) {
        if (null === b || 4 !== b.tag || b.stateNode.containerInfo !== c.containerInfo || b.stateNode.implementation !== c.implementation) return b = $c87427e8b303c517$var$Sg(c, a.mode, d), b.return = a, b;
        b = e(b, c.children || []);
        b.return = a;
        return b;
    }
    function m(a, b, c, d, f) {
        if (null === b || 7 !== b.tag) return b = $c87427e8b303c517$var$Tg(c, a.mode, d, f), b.return = a, b;
        b = e(b, c);
        b.return = a;
        return b;
    }
    function q(a, b, c) {
        if ("string" === typeof b && "" !== b || "number" === typeof b) return b = $c87427e8b303c517$var$Qg("" + b, a.mode, c), b.return = a, b;
        if ("object" === typeof b && null !== b) {
            switch(b.$$typeof){
                case $c87427e8b303c517$var$va:
                    return c = $c87427e8b303c517$var$Rg(b.type, b.key, b.props, null, a.mode, c), c.ref = $c87427e8b303c517$var$Lg(a, null, b), c.return = a, c;
                case $c87427e8b303c517$var$wa:
                    return b = $c87427e8b303c517$var$Sg(b, a.mode, c), b.return = a, b;
                case $c87427e8b303c517$var$Ha:
                    var d = b._init;
                    return q(a, d(b._payload), c);
            }
            if ($c87427e8b303c517$var$eb(b) || $c87427e8b303c517$var$Ka(b)) return b = $c87427e8b303c517$var$Tg(b, a.mode, c, null), b.return = a, b;
            $c87427e8b303c517$var$Mg(a, b);
        }
        return null;
    }
    function r(a, b, c, d) {
        var e = null !== b ? b.key : null;
        if ("string" === typeof c && "" !== c || "number" === typeof c) return null !== e ? null : h(a, b, "" + c, d);
        if ("object" === typeof c && null !== c) {
            switch(c.$$typeof){
                case $c87427e8b303c517$var$va:
                    return c.key === e ? k(a, b, c, d) : null;
                case $c87427e8b303c517$var$wa:
                    return c.key === e ? l(a, b, c, d) : null;
                case $c87427e8b303c517$var$Ha:
                    return e = c._init, r(a, b, e(c._payload), d);
            }
            if ($c87427e8b303c517$var$eb(c) || $c87427e8b303c517$var$Ka(c)) return null !== e ? null : m(a, b, c, d, null);
            $c87427e8b303c517$var$Mg(a, c);
        }
        return null;
    }
    function y(a, b, c, d, e) {
        if ("string" === typeof d && "" !== d || "number" === typeof d) return a = a.get(c) || null, h(b, a, "" + d, e);
        if ("object" === typeof d && null !== d) {
            switch(d.$$typeof){
                case $c87427e8b303c517$var$va:
                    return a = a.get(null === d.key ? c : d.key) || null, k(b, a, d, e);
                case $c87427e8b303c517$var$wa:
                    return a = a.get(null === d.key ? c : d.key) || null, l(b, a, d, e);
                case $c87427e8b303c517$var$Ha:
                    var f = d._init;
                    return y(a, b, c, f(d._payload), e);
            }
            if ($c87427e8b303c517$var$eb(d) || $c87427e8b303c517$var$Ka(d)) return a = a.get(c) || null, m(b, a, d, e, null);
            $c87427e8b303c517$var$Mg(b, d);
        }
        return null;
    }
    function n(e, g, h, k) {
        for(var l = null, m = null, u = g, w = g = 0, x = null; null !== u && w < h.length; w++){
            u.index > w ? (x = u, u = null) : x = u.sibling;
            var n = r(e, u, h[w], k);
            if (null === n) {
                null === u && (u = x);
                break;
            }
            a && u && null === n.alternate && b(e, u);
            g = f(n, g, w);
            null === m ? l = n : m.sibling = n;
            m = n;
            u = x;
        }
        if (w === h.length) return c(e, u), $c87427e8b303c517$var$I && $c87427e8b303c517$var$tg(e, w), l;
        if (null === u) {
            for(; w < h.length; w++)u = q(e, h[w], k), null !== u && (g = f(u, g, w), null === m ? l = u : m.sibling = u, m = u);
            $c87427e8b303c517$var$I && $c87427e8b303c517$var$tg(e, w);
            return l;
        }
        for(u = d(e, u); w < h.length; w++)x = y(u, e, w, h[w], k), null !== x && (a && null !== x.alternate && u.delete(null === x.key ? w : x.key), g = f(x, g, w), null === m ? l = x : m.sibling = x, m = x);
        a && u.forEach(function(a) {
            return b(e, a);
        });
        $c87427e8b303c517$var$I && $c87427e8b303c517$var$tg(e, w);
        return l;
    }
    function t(e, g, h, k) {
        var l = $c87427e8b303c517$var$Ka(h);
        if ("function" !== typeof l) throw Error($c87427e8b303c517$var$p(150));
        h = l.call(h);
        if (null == h) throw Error($c87427e8b303c517$var$p(151));
        for(var u = l = null, m = g, w = g = 0, x = null, n = h.next(); null !== m && !n.done; w++, n = h.next()){
            m.index > w ? (x = m, m = null) : x = m.sibling;
            var t = r(e, m, n.value, k);
            if (null === t) {
                null === m && (m = x);
                break;
            }
            a && m && null === t.alternate && b(e, m);
            g = f(t, g, w);
            null === u ? l = t : u.sibling = t;
            u = t;
            m = x;
        }
        if (n.done) return c(e, m), $c87427e8b303c517$var$I && $c87427e8b303c517$var$tg(e, w), l;
        if (null === m) {
            for(; !n.done; w++, n = h.next())n = q(e, n.value, k), null !== n && (g = f(n, g, w), null === u ? l = n : u.sibling = n, u = n);
            $c87427e8b303c517$var$I && $c87427e8b303c517$var$tg(e, w);
            return l;
        }
        for(m = d(e, m); !n.done; w++, n = h.next())n = y(m, e, w, n.value, k), null !== n && (a && null !== n.alternate && m.delete(null === n.key ? w : n.key), g = f(n, g, w), null === u ? l = n : u.sibling = n, u = n);
        a && m.forEach(function(a) {
            return b(e, a);
        });
        $c87427e8b303c517$var$I && $c87427e8b303c517$var$tg(e, w);
        return l;
    }
    function J(a, d, f, h) {
        "object" === typeof f && null !== f && f.type === $c87427e8b303c517$var$ya && null === f.key && (f = f.props.children);
        if ("object" === typeof f && null !== f) {
            switch(f.$$typeof){
                case $c87427e8b303c517$var$va:
                    a: {
                        for(var k = f.key, l = d; null !== l;){
                            if (l.key === k) {
                                k = f.type;
                                if (k === $c87427e8b303c517$var$ya) {
                                    if (7 === l.tag) {
                                        c(a, l.sibling);
                                        d = e(l, f.props.children);
                                        d.return = a;
                                        a = d;
                                        break a;
                                    }
                                } else if (l.elementType === k || "object" === typeof k && null !== k && k.$$typeof === $c87427e8b303c517$var$Ha && $c87427e8b303c517$var$Ng(k) === l.type) {
                                    c(a, l.sibling);
                                    d = e(l, f.props);
                                    d.ref = $c87427e8b303c517$var$Lg(a, l, f);
                                    d.return = a;
                                    a = d;
                                    break a;
                                }
                                c(a, l);
                                break;
                            } else b(a, l);
                            l = l.sibling;
                        }
                        f.type === $c87427e8b303c517$var$ya ? (d = $c87427e8b303c517$var$Tg(f.props.children, a.mode, h, f.key), d.return = a, a = d) : (h = $c87427e8b303c517$var$Rg(f.type, f.key, f.props, null, a.mode, h), h.ref = $c87427e8b303c517$var$Lg(a, d, f), h.return = a, a = h);
                    }
                    return g(a);
                case $c87427e8b303c517$var$wa:
                    a: {
                        for(l = f.key; null !== d;){
                            if (d.key === l) {
                                if (4 === d.tag && d.stateNode.containerInfo === f.containerInfo && d.stateNode.implementation === f.implementation) {
                                    c(a, d.sibling);
                                    d = e(d, f.children || []);
                                    d.return = a;
                                    a = d;
                                    break a;
                                } else {
                                    c(a, d);
                                    break;
                                }
                            } else b(a, d);
                            d = d.sibling;
                        }
                        d = $c87427e8b303c517$var$Sg(f, a.mode, h);
                        d.return = a;
                        a = d;
                    }
                    return g(a);
                case $c87427e8b303c517$var$Ha:
                    return l = f._init, J(a, d, l(f._payload), h);
            }
            if ($c87427e8b303c517$var$eb(f)) return n(a, d, f, h);
            if ($c87427e8b303c517$var$Ka(f)) return t(a, d, f, h);
            $c87427e8b303c517$var$Mg(a, f);
        }
        return "string" === typeof f && "" !== f || "number" === typeof f ? (f = "" + f, null !== d && 6 === d.tag ? (c(a, d.sibling), d = e(d, f), d.return = a, a = d) : (c(a, d), d = $c87427e8b303c517$var$Qg(f, a.mode, h), d.return = a, a = d), g(a)) : c(a, d);
    }
    return J;
}
var $c87427e8b303c517$var$Ug = $c87427e8b303c517$var$Og(!0), $c87427e8b303c517$var$Vg = $c87427e8b303c517$var$Og(!1), $c87427e8b303c517$var$Wg = $c87427e8b303c517$var$Uf(null), $c87427e8b303c517$var$Xg = null, $c87427e8b303c517$var$Yg = null, $c87427e8b303c517$var$Zg = null;
function $c87427e8b303c517$var$$g() {
    $c87427e8b303c517$var$Zg = $c87427e8b303c517$var$Yg = $c87427e8b303c517$var$Xg = null;
}
function $c87427e8b303c517$var$ah(a) {
    var b = $c87427e8b303c517$var$Wg.current;
    $c87427e8b303c517$var$E($c87427e8b303c517$var$Wg);
    a._currentValue = b;
}
function $c87427e8b303c517$var$bh(a, b, c) {
    for(; null !== a;){
        var d = a.alternate;
        (a.childLanes & b) !== b ? (a.childLanes |= b, null !== d && (d.childLanes |= b)) : null !== d && (d.childLanes & b) !== b && (d.childLanes |= b);
        if (a === c) break;
        a = a.return;
    }
}
function $c87427e8b303c517$var$ch(a, b) {
    $c87427e8b303c517$var$Xg = a;
    $c87427e8b303c517$var$Zg = $c87427e8b303c517$var$Yg = null;
    a = a.dependencies;
    null !== a && null !== a.firstContext && (0 !== (a.lanes & b) && ($c87427e8b303c517$var$dh = !0), a.firstContext = null);
}
function $c87427e8b303c517$var$eh(a) {
    var b = a._currentValue;
    if ($c87427e8b303c517$var$Zg !== a) {
        if (a = {
            context: a,
            memoizedValue: b,
            next: null
        }, null === $c87427e8b303c517$var$Yg) {
            if (null === $c87427e8b303c517$var$Xg) throw Error($c87427e8b303c517$var$p(308));
            $c87427e8b303c517$var$Yg = a;
            $c87427e8b303c517$var$Xg.dependencies = {
                lanes: 0,
                firstContext: a
            };
        } else $c87427e8b303c517$var$Yg = $c87427e8b303c517$var$Yg.next = a;
    }
    return b;
}
var $c87427e8b303c517$var$fh = null;
function $c87427e8b303c517$var$gh(a) {
    null === $c87427e8b303c517$var$fh ? $c87427e8b303c517$var$fh = [
        a
    ] : $c87427e8b303c517$var$fh.push(a);
}
function $c87427e8b303c517$var$hh(a, b, c, d) {
    var e = b.interleaved;
    null === e ? (c.next = c, $c87427e8b303c517$var$gh(b)) : (c.next = e.next, e.next = c);
    b.interleaved = c;
    return $c87427e8b303c517$var$ih(a, d);
}
function $c87427e8b303c517$var$ih(a, b) {
    a.lanes |= b;
    var c = a.alternate;
    null !== c && (c.lanes |= b);
    c = a;
    for(a = a.return; null !== a;)a.childLanes |= b, c = a.alternate, null !== c && (c.childLanes |= b), c = a, a = a.return;
    return 3 === c.tag ? c.stateNode : null;
}
var $c87427e8b303c517$var$jh = !1;
function $c87427e8b303c517$var$kh(a) {
    a.updateQueue = {
        baseState: a.memoizedState,
        firstBaseUpdate: null,
        lastBaseUpdate: null,
        shared: {
            pending: null,
            interleaved: null,
            lanes: 0
        },
        effects: null
    };
}
function $c87427e8b303c517$var$lh(a, b) {
    a = a.updateQueue;
    b.updateQueue === a && (b.updateQueue = {
        baseState: a.baseState,
        firstBaseUpdate: a.firstBaseUpdate,
        lastBaseUpdate: a.lastBaseUpdate,
        shared: a.shared,
        effects: a.effects
    });
}
function $c87427e8b303c517$var$mh(a, b) {
    return {
        eventTime: a,
        lane: b,
        tag: 0,
        payload: null,
        callback: null,
        next: null
    };
}
function $c87427e8b303c517$var$nh(a, b, c) {
    var d = a.updateQueue;
    if (null === d) return null;
    d = d.shared;
    if (0 !== ($c87427e8b303c517$var$K & 2)) {
        var e = d.pending;
        null === e ? b.next = b : (b.next = e.next, e.next = b);
        d.pending = b;
        return $c87427e8b303c517$var$ih(a, c);
    }
    e = d.interleaved;
    null === e ? (b.next = b, $c87427e8b303c517$var$gh(d)) : (b.next = e.next, e.next = b);
    d.interleaved = b;
    return $c87427e8b303c517$var$ih(a, c);
}
function $c87427e8b303c517$var$oh(a, b, c) {
    b = b.updateQueue;
    if (null !== b && (b = b.shared, 0 !== (c & 4194240))) {
        var d = b.lanes;
        d &= a.pendingLanes;
        c |= d;
        b.lanes = c;
        $c87427e8b303c517$var$Cc(a, c);
    }
}
function $c87427e8b303c517$var$ph(a, b) {
    var c = a.updateQueue, d = a.alternate;
    if (null !== d && (d = d.updateQueue, c === d)) {
        var e = null, f = null;
        c = c.firstBaseUpdate;
        if (null !== c) {
            do {
                var g = {
                    eventTime: c.eventTime,
                    lane: c.lane,
                    tag: c.tag,
                    payload: c.payload,
                    callback: c.callback,
                    next: null
                };
                null === f ? e = f = g : f = f.next = g;
                c = c.next;
            }while (null !== c);
            null === f ? e = f = b : f = f.next = b;
        } else e = f = b;
        c = {
            baseState: d.baseState,
            firstBaseUpdate: e,
            lastBaseUpdate: f,
            shared: d.shared,
            effects: d.effects
        };
        a.updateQueue = c;
        return;
    }
    a = c.lastBaseUpdate;
    null === a ? c.firstBaseUpdate = b : a.next = b;
    c.lastBaseUpdate = b;
}
function $c87427e8b303c517$var$qh(a, b, c, d) {
    var e = a.updateQueue;
    $c87427e8b303c517$var$jh = !1;
    var f = e.firstBaseUpdate, g = e.lastBaseUpdate, h = e.shared.pending;
    if (null !== h) {
        e.shared.pending = null;
        var k = h, l = k.next;
        k.next = null;
        null === g ? f = l : g.next = l;
        g = k;
        var m = a.alternate;
        null !== m && (m = m.updateQueue, h = m.lastBaseUpdate, h !== g && (null === h ? m.firstBaseUpdate = l : h.next = l, m.lastBaseUpdate = k));
    }
    if (null !== f) {
        var q = e.baseState;
        g = 0;
        m = l = k = null;
        h = f;
        do {
            var r = h.lane, y = h.eventTime;
            if ((d & r) === r) {
                null !== m && (m = m.next = {
                    eventTime: y,
                    lane: 0,
                    tag: h.tag,
                    payload: h.payload,
                    callback: h.callback,
                    next: null
                });
                a: {
                    var n = a, t = h;
                    r = b;
                    y = c;
                    switch(t.tag){
                        case 1:
                            n = t.payload;
                            if ("function" === typeof n) {
                                q = n.call(y, q, r);
                                break a;
                            }
                            q = n;
                            break a;
                        case 3:
                            n.flags = n.flags & -65537 | 128;
                        case 0:
                            n = t.payload;
                            r = "function" === typeof n ? n.call(y, q, r) : n;
                            if (null === r || void 0 === r) break a;
                            q = $c87427e8b303c517$var$A({}, q, r);
                            break a;
                        case 2:
                            $c87427e8b303c517$var$jh = !0;
                    }
                }
                null !== h.callback && 0 !== h.lane && (a.flags |= 64, r = e.effects, null === r ? e.effects = [
                    h
                ] : r.push(h));
            } else y = {
                eventTime: y,
                lane: r,
                tag: h.tag,
                payload: h.payload,
                callback: h.callback,
                next: null
            }, null === m ? (l = m = y, k = q) : m = m.next = y, g |= r;
            h = h.next;
            if (null === h) {
                if (h = e.shared.pending, null === h) break;
                else r = h, h = r.next, r.next = null, e.lastBaseUpdate = r, e.shared.pending = null;
            }
        }while (1);
        null === m && (k = q);
        e.baseState = k;
        e.firstBaseUpdate = l;
        e.lastBaseUpdate = m;
        b = e.shared.interleaved;
        if (null !== b) {
            e = b;
            do g |= e.lane, e = e.next;
            while (e !== b);
        } else null === f && (e.shared.lanes = 0);
        $c87427e8b303c517$var$rh |= g;
        a.lanes = g;
        a.memoizedState = q;
    }
}
function $c87427e8b303c517$var$sh(a, b, c) {
    a = b.effects;
    b.effects = null;
    if (null !== a) for(b = 0; b < a.length; b++){
        var d = a[b], e = d.callback;
        if (null !== e) {
            d.callback = null;
            d = c;
            if ("function" !== typeof e) throw Error($c87427e8b303c517$var$p(191, e));
            e.call(d);
        }
    }
}
var $c87427e8b303c517$var$th = {}, $c87427e8b303c517$var$uh = $c87427e8b303c517$var$Uf($c87427e8b303c517$var$th), $c87427e8b303c517$var$vh = $c87427e8b303c517$var$Uf($c87427e8b303c517$var$th), $c87427e8b303c517$var$wh = $c87427e8b303c517$var$Uf($c87427e8b303c517$var$th);
function $c87427e8b303c517$var$xh(a) {
    if (a === $c87427e8b303c517$var$th) throw Error($c87427e8b303c517$var$p(174));
    return a;
}
function $c87427e8b303c517$var$yh(a, b) {
    $c87427e8b303c517$var$G($c87427e8b303c517$var$wh, b);
    $c87427e8b303c517$var$G($c87427e8b303c517$var$vh, a);
    $c87427e8b303c517$var$G($c87427e8b303c517$var$uh, $c87427e8b303c517$var$th);
    a = b.nodeType;
    switch(a){
        case 9:
        case 11:
            b = (b = b.documentElement) ? b.namespaceURI : $c87427e8b303c517$var$lb(null, "");
            break;
        default:
            a = 8 === a ? b.parentNode : b, b = a.namespaceURI || null, a = a.tagName, b = $c87427e8b303c517$var$lb(b, a);
    }
    $c87427e8b303c517$var$E($c87427e8b303c517$var$uh);
    $c87427e8b303c517$var$G($c87427e8b303c517$var$uh, b);
}
function $c87427e8b303c517$var$zh() {
    $c87427e8b303c517$var$E($c87427e8b303c517$var$uh);
    $c87427e8b303c517$var$E($c87427e8b303c517$var$vh);
    $c87427e8b303c517$var$E($c87427e8b303c517$var$wh);
}
function $c87427e8b303c517$var$Ah(a) {
    $c87427e8b303c517$var$xh($c87427e8b303c517$var$wh.current);
    var b = $c87427e8b303c517$var$xh($c87427e8b303c517$var$uh.current);
    var c = $c87427e8b303c517$var$lb(b, a.type);
    b !== c && ($c87427e8b303c517$var$G($c87427e8b303c517$var$vh, a), $c87427e8b303c517$var$G($c87427e8b303c517$var$uh, c));
}
function $c87427e8b303c517$var$Bh(a) {
    $c87427e8b303c517$var$vh.current === a && ($c87427e8b303c517$var$E($c87427e8b303c517$var$uh), $c87427e8b303c517$var$E($c87427e8b303c517$var$vh));
}
var $c87427e8b303c517$var$L = $c87427e8b303c517$var$Uf(0);
function $c87427e8b303c517$var$Ch(a) {
    for(var b = a; null !== b;){
        if (13 === b.tag) {
            var c = b.memoizedState;
            if (null !== c && (c = c.dehydrated, null === c || "$?" === c.data || "$!" === c.data)) return b;
        } else if (19 === b.tag && void 0 !== b.memoizedProps.revealOrder) {
            if (0 !== (b.flags & 128)) return b;
        } else if (null !== b.child) {
            b.child.return = b;
            b = b.child;
            continue;
        }
        if (b === a) break;
        for(; null === b.sibling;){
            if (null === b.return || b.return === a) return null;
            b = b.return;
        }
        b.sibling.return = b.return;
        b = b.sibling;
    }
    return null;
}
var $c87427e8b303c517$var$Dh = [];
function $c87427e8b303c517$var$Eh() {
    for(var a = 0; a < $c87427e8b303c517$var$Dh.length; a++)$c87427e8b303c517$var$Dh[a]._workInProgressVersionPrimary = null;
    $c87427e8b303c517$var$Dh.length = 0;
}
var $c87427e8b303c517$var$Fh = $c87427e8b303c517$var$ua.ReactCurrentDispatcher, $c87427e8b303c517$var$Gh = $c87427e8b303c517$var$ua.ReactCurrentBatchConfig, $c87427e8b303c517$var$Hh = 0, $c87427e8b303c517$var$M = null, $c87427e8b303c517$var$N = null, $c87427e8b303c517$var$O = null, $c87427e8b303c517$var$Ih = !1, $c87427e8b303c517$var$Jh = !1, $c87427e8b303c517$var$Kh = 0, $c87427e8b303c517$var$Lh = 0;
function $c87427e8b303c517$var$P() {
    throw Error($c87427e8b303c517$var$p(321));
}
function $c87427e8b303c517$var$Mh(a, b) {
    if (null === b) return !1;
    for(var c = 0; c < b.length && c < a.length; c++)if (!$c87427e8b303c517$var$He(a[c], b[c])) return !1;
    return !0;
}
function $c87427e8b303c517$var$Nh(a, b, c, d, e, f) {
    $c87427e8b303c517$var$Hh = f;
    $c87427e8b303c517$var$M = b;
    b.memoizedState = null;
    b.updateQueue = null;
    b.lanes = 0;
    $c87427e8b303c517$var$Fh.current = null === a || null === a.memoizedState ? $c87427e8b303c517$var$Oh : $c87427e8b303c517$var$Ph;
    a = c(d, e);
    if ($c87427e8b303c517$var$Jh) {
        f = 0;
        do {
            $c87427e8b303c517$var$Jh = !1;
            $c87427e8b303c517$var$Kh = 0;
            if (25 <= f) throw Error($c87427e8b303c517$var$p(301));
            f += 1;
            $c87427e8b303c517$var$O = $c87427e8b303c517$var$N = null;
            b.updateQueue = null;
            $c87427e8b303c517$var$Fh.current = $c87427e8b303c517$var$Qh;
            a = c(d, e);
        }while ($c87427e8b303c517$var$Jh);
    }
    $c87427e8b303c517$var$Fh.current = $c87427e8b303c517$var$Rh;
    b = null !== $c87427e8b303c517$var$N && null !== $c87427e8b303c517$var$N.next;
    $c87427e8b303c517$var$Hh = 0;
    $c87427e8b303c517$var$O = $c87427e8b303c517$var$N = $c87427e8b303c517$var$M = null;
    $c87427e8b303c517$var$Ih = !1;
    if (b) throw Error($c87427e8b303c517$var$p(300));
    return a;
}
function $c87427e8b303c517$var$Sh() {
    var a = 0 !== $c87427e8b303c517$var$Kh;
    $c87427e8b303c517$var$Kh = 0;
    return a;
}
function $c87427e8b303c517$var$Th() {
    var a = {
        memoizedState: null,
        baseState: null,
        baseQueue: null,
        queue: null,
        next: null
    };
    null === $c87427e8b303c517$var$O ? $c87427e8b303c517$var$M.memoizedState = $c87427e8b303c517$var$O = a : $c87427e8b303c517$var$O = $c87427e8b303c517$var$O.next = a;
    return $c87427e8b303c517$var$O;
}
function $c87427e8b303c517$var$Uh() {
    if (null === $c87427e8b303c517$var$N) {
        var a = $c87427e8b303c517$var$M.alternate;
        a = null !== a ? a.memoizedState : null;
    } else a = $c87427e8b303c517$var$N.next;
    var b = null === $c87427e8b303c517$var$O ? $c87427e8b303c517$var$M.memoizedState : $c87427e8b303c517$var$O.next;
    if (null !== b) $c87427e8b303c517$var$O = b, $c87427e8b303c517$var$N = a;
    else {
        if (null === a) throw Error($c87427e8b303c517$var$p(310));
        $c87427e8b303c517$var$N = a;
        a = {
            memoizedState: $c87427e8b303c517$var$N.memoizedState,
            baseState: $c87427e8b303c517$var$N.baseState,
            baseQueue: $c87427e8b303c517$var$N.baseQueue,
            queue: $c87427e8b303c517$var$N.queue,
            next: null
        };
        null === $c87427e8b303c517$var$O ? $c87427e8b303c517$var$M.memoizedState = $c87427e8b303c517$var$O = a : $c87427e8b303c517$var$O = $c87427e8b303c517$var$O.next = a;
    }
    return $c87427e8b303c517$var$O;
}
function $c87427e8b303c517$var$Vh(a, b) {
    return "function" === typeof b ? b(a) : b;
}
function $c87427e8b303c517$var$Wh(a) {
    var b = $c87427e8b303c517$var$Uh(), c = b.queue;
    if (null === c) throw Error($c87427e8b303c517$var$p(311));
    c.lastRenderedReducer = a;
    var d = $c87427e8b303c517$var$N, e = d.baseQueue, f = c.pending;
    if (null !== f) {
        if (null !== e) {
            var g = e.next;
            e.next = f.next;
            f.next = g;
        }
        d.baseQueue = e = f;
        c.pending = null;
    }
    if (null !== e) {
        f = e.next;
        d = d.baseState;
        var h = g = null, k = null, l = f;
        do {
            var m = l.lane;
            if (($c87427e8b303c517$var$Hh & m) === m) null !== k && (k = k.next = {
                lane: 0,
                action: l.action,
                hasEagerState: l.hasEagerState,
                eagerState: l.eagerState,
                next: null
            }), d = l.hasEagerState ? l.eagerState : a(d, l.action);
            else {
                var q = {
                    lane: m,
                    action: l.action,
                    hasEagerState: l.hasEagerState,
                    eagerState: l.eagerState,
                    next: null
                };
                null === k ? (h = k = q, g = d) : k = k.next = q;
                $c87427e8b303c517$var$M.lanes |= m;
                $c87427e8b303c517$var$rh |= m;
            }
            l = l.next;
        }while (null !== l && l !== f);
        null === k ? g = d : k.next = h;
        $c87427e8b303c517$var$He(d, b.memoizedState) || ($c87427e8b303c517$var$dh = !0);
        b.memoizedState = d;
        b.baseState = g;
        b.baseQueue = k;
        c.lastRenderedState = d;
    }
    a = c.interleaved;
    if (null !== a) {
        e = a;
        do f = e.lane, $c87427e8b303c517$var$M.lanes |= f, $c87427e8b303c517$var$rh |= f, e = e.next;
        while (e !== a);
    } else null === e && (c.lanes = 0);
    return [
        b.memoizedState,
        c.dispatch
    ];
}
function $c87427e8b303c517$var$Xh(a) {
    var b = $c87427e8b303c517$var$Uh(), c = b.queue;
    if (null === c) throw Error($c87427e8b303c517$var$p(311));
    c.lastRenderedReducer = a;
    var d = c.dispatch, e = c.pending, f = b.memoizedState;
    if (null !== e) {
        c.pending = null;
        var g = e = e.next;
        do f = a(f, g.action), g = g.next;
        while (g !== e);
        $c87427e8b303c517$var$He(f, b.memoizedState) || ($c87427e8b303c517$var$dh = !0);
        b.memoizedState = f;
        null === b.baseQueue && (b.baseState = f);
        c.lastRenderedState = f;
    }
    return [
        f,
        d
    ];
}
function $c87427e8b303c517$var$Yh() {}
function $c87427e8b303c517$var$Zh(a, b) {
    var c = $c87427e8b303c517$var$M, d = $c87427e8b303c517$var$Uh(), e = b(), f = !$c87427e8b303c517$var$He(d.memoizedState, e);
    f && (d.memoizedState = e, $c87427e8b303c517$var$dh = !0);
    d = d.queue;
    $c87427e8b303c517$var$$h($c87427e8b303c517$var$ai.bind(null, c, d, a), [
        a
    ]);
    if (d.getSnapshot !== b || f || null !== $c87427e8b303c517$var$O && $c87427e8b303c517$var$O.memoizedState.tag & 1) {
        c.flags |= 2048;
        $c87427e8b303c517$var$bi(9, $c87427e8b303c517$var$ci.bind(null, c, d, e, b), void 0, null);
        if (null === $c87427e8b303c517$var$Q) throw Error($c87427e8b303c517$var$p(349));
        0 !== ($c87427e8b303c517$var$Hh & 30) || $c87427e8b303c517$var$di(c, b, e);
    }
    return e;
}
function $c87427e8b303c517$var$di(a, b, c) {
    a.flags |= 16384;
    a = {
        getSnapshot: b,
        value: c
    };
    b = $c87427e8b303c517$var$M.updateQueue;
    null === b ? (b = {
        lastEffect: null,
        stores: null
    }, $c87427e8b303c517$var$M.updateQueue = b, b.stores = [
        a
    ]) : (c = b.stores, null === c ? b.stores = [
        a
    ] : c.push(a));
}
function $c87427e8b303c517$var$ci(a, b, c, d) {
    b.value = c;
    b.getSnapshot = d;
    $c87427e8b303c517$var$ei(b) && $c87427e8b303c517$var$fi(a);
}
function $c87427e8b303c517$var$ai(a, b, c) {
    return c(function() {
        $c87427e8b303c517$var$ei(b) && $c87427e8b303c517$var$fi(a);
    });
}
function $c87427e8b303c517$var$ei(a) {
    var b = a.getSnapshot;
    a = a.value;
    try {
        var c = b();
        return !$c87427e8b303c517$var$He(a, c);
    } catch (d) {
        return !0;
    }
}
function $c87427e8b303c517$var$fi(a) {
    var b = $c87427e8b303c517$var$ih(a, 1);
    null !== b && $c87427e8b303c517$var$gi(b, a, 1, -1);
}
function $c87427e8b303c517$var$hi(a) {
    var b = $c87427e8b303c517$var$Th();
    "function" === typeof a && (a = a());
    b.memoizedState = b.baseState = a;
    a = {
        pending: null,
        interleaved: null,
        lanes: 0,
        dispatch: null,
        lastRenderedReducer: $c87427e8b303c517$var$Vh,
        lastRenderedState: a
    };
    b.queue = a;
    a = a.dispatch = $c87427e8b303c517$var$ii.bind(null, $c87427e8b303c517$var$M, a);
    return [
        b.memoizedState,
        a
    ];
}
function $c87427e8b303c517$var$bi(a, b, c, d) {
    a = {
        tag: a,
        create: b,
        destroy: c,
        deps: d,
        next: null
    };
    b = $c87427e8b303c517$var$M.updateQueue;
    null === b ? (b = {
        lastEffect: null,
        stores: null
    }, $c87427e8b303c517$var$M.updateQueue = b, b.lastEffect = a.next = a) : (c = b.lastEffect, null === c ? b.lastEffect = a.next = a : (d = c.next, c.next = a, a.next = d, b.lastEffect = a));
    return a;
}
function $c87427e8b303c517$var$ji() {
    return $c87427e8b303c517$var$Uh().memoizedState;
}
function $c87427e8b303c517$var$ki(a, b, c, d) {
    var e = $c87427e8b303c517$var$Th();
    $c87427e8b303c517$var$M.flags |= a;
    e.memoizedState = $c87427e8b303c517$var$bi(1 | b, c, void 0, void 0 === d ? null : d);
}
function $c87427e8b303c517$var$li(a, b, c, d) {
    var e = $c87427e8b303c517$var$Uh();
    d = void 0 === d ? null : d;
    var f = void 0;
    if (null !== $c87427e8b303c517$var$N) {
        var g = $c87427e8b303c517$var$N.memoizedState;
        f = g.destroy;
        if (null !== d && $c87427e8b303c517$var$Mh(d, g.deps)) {
            e.memoizedState = $c87427e8b303c517$var$bi(b, c, f, d);
            return;
        }
    }
    $c87427e8b303c517$var$M.flags |= a;
    e.memoizedState = $c87427e8b303c517$var$bi(1 | b, c, f, d);
}
function $c87427e8b303c517$var$mi(a, b) {
    return $c87427e8b303c517$var$ki(8390656, 8, a, b);
}
function $c87427e8b303c517$var$$h(a, b) {
    return $c87427e8b303c517$var$li(2048, 8, a, b);
}
function $c87427e8b303c517$var$ni(a, b) {
    return $c87427e8b303c517$var$li(4, 2, a, b);
}
function $c87427e8b303c517$var$oi(a, b) {
    return $c87427e8b303c517$var$li(4, 4, a, b);
}
function $c87427e8b303c517$var$pi(a, b) {
    if ("function" === typeof b) return a = a(), b(a), function() {
        b(null);
    };
    if (null !== b && void 0 !== b) return a = a(), b.current = a, function() {
        b.current = null;
    };
}
function $c87427e8b303c517$var$qi(a, b, c) {
    c = null !== c && void 0 !== c ? c.concat([
        a
    ]) : null;
    return $c87427e8b303c517$var$li(4, 4, $c87427e8b303c517$var$pi.bind(null, b, a), c);
}
function $c87427e8b303c517$var$ri() {}
function $c87427e8b303c517$var$si(a, b) {
    var c = $c87427e8b303c517$var$Uh();
    b = void 0 === b ? null : b;
    var d = c.memoizedState;
    if (null !== d && null !== b && $c87427e8b303c517$var$Mh(b, d[1])) return d[0];
    c.memoizedState = [
        a,
        b
    ];
    return a;
}
function $c87427e8b303c517$var$ti(a, b) {
    var c = $c87427e8b303c517$var$Uh();
    b = void 0 === b ? null : b;
    var d = c.memoizedState;
    if (null !== d && null !== b && $c87427e8b303c517$var$Mh(b, d[1])) return d[0];
    a = a();
    c.memoizedState = [
        a,
        b
    ];
    return a;
}
function $c87427e8b303c517$var$ui(a, b, c) {
    if (0 === ($c87427e8b303c517$var$Hh & 21)) return a.baseState && (a.baseState = !1, $c87427e8b303c517$var$dh = !0), a.memoizedState = c;
    $c87427e8b303c517$var$He(c, b) || (c = $c87427e8b303c517$var$yc(), $c87427e8b303c517$var$M.lanes |= c, $c87427e8b303c517$var$rh |= c, a.baseState = !0);
    return b;
}
function $c87427e8b303c517$var$vi(a, b) {
    var c = $c87427e8b303c517$var$C;
    $c87427e8b303c517$var$C = 0 !== c && 4 > c ? c : 4;
    a(!0);
    var d = $c87427e8b303c517$var$Gh.transition;
    $c87427e8b303c517$var$Gh.transition = {};
    try {
        a(!1), b();
    } finally{
        $c87427e8b303c517$var$C = c, $c87427e8b303c517$var$Gh.transition = d;
    }
}
function $c87427e8b303c517$var$wi() {
    return $c87427e8b303c517$var$Uh().memoizedState;
}
function $c87427e8b303c517$var$xi(a, b, c) {
    var d = $c87427e8b303c517$var$yi(a);
    c = {
        lane: d,
        action: c,
        hasEagerState: !1,
        eagerState: null,
        next: null
    };
    if ($c87427e8b303c517$var$zi(a)) $c87427e8b303c517$var$Ai(b, c);
    else if (c = $c87427e8b303c517$var$hh(a, b, c, d), null !== c) {
        var e = $c87427e8b303c517$var$R();
        $c87427e8b303c517$var$gi(c, a, d, e);
        $c87427e8b303c517$var$Bi(c, b, d);
    }
}
function $c87427e8b303c517$var$ii(a, b, c) {
    var d = $c87427e8b303c517$var$yi(a), e = {
        lane: d,
        action: c,
        hasEagerState: !1,
        eagerState: null,
        next: null
    };
    if ($c87427e8b303c517$var$zi(a)) $c87427e8b303c517$var$Ai(b, e);
    else {
        var f = a.alternate;
        if (0 === a.lanes && (null === f || 0 === f.lanes) && (f = b.lastRenderedReducer, null !== f)) try {
            var g = b.lastRenderedState, h = f(g, c);
            e.hasEagerState = !0;
            e.eagerState = h;
            if ($c87427e8b303c517$var$He(h, g)) {
                var k = b.interleaved;
                null === k ? (e.next = e, $c87427e8b303c517$var$gh(b)) : (e.next = k.next, k.next = e);
                b.interleaved = e;
                return;
            }
        } catch (l) {} finally{}
        c = $c87427e8b303c517$var$hh(a, b, e, d);
        null !== c && (e = $c87427e8b303c517$var$R(), $c87427e8b303c517$var$gi(c, a, d, e), $c87427e8b303c517$var$Bi(c, b, d));
    }
}
function $c87427e8b303c517$var$zi(a) {
    var b = a.alternate;
    return a === $c87427e8b303c517$var$M || null !== b && b === $c87427e8b303c517$var$M;
}
function $c87427e8b303c517$var$Ai(a, b) {
    $c87427e8b303c517$var$Jh = $c87427e8b303c517$var$Ih = !0;
    var c = a.pending;
    null === c ? b.next = b : (b.next = c.next, c.next = b);
    a.pending = b;
}
function $c87427e8b303c517$var$Bi(a, b, c) {
    if (0 !== (c & 4194240)) {
        var d = b.lanes;
        d &= a.pendingLanes;
        c |= d;
        b.lanes = c;
        $c87427e8b303c517$var$Cc(a, c);
    }
}
var $c87427e8b303c517$var$Rh = {
    readContext: $c87427e8b303c517$var$eh,
    useCallback: $c87427e8b303c517$var$P,
    useContext: $c87427e8b303c517$var$P,
    useEffect: $c87427e8b303c517$var$P,
    useImperativeHandle: $c87427e8b303c517$var$P,
    useInsertionEffect: $c87427e8b303c517$var$P,
    useLayoutEffect: $c87427e8b303c517$var$P,
    useMemo: $c87427e8b303c517$var$P,
    useReducer: $c87427e8b303c517$var$P,
    useRef: $c87427e8b303c517$var$P,
    useState: $c87427e8b303c517$var$P,
    useDebugValue: $c87427e8b303c517$var$P,
    useDeferredValue: $c87427e8b303c517$var$P,
    useTransition: $c87427e8b303c517$var$P,
    useMutableSource: $c87427e8b303c517$var$P,
    useSyncExternalStore: $c87427e8b303c517$var$P,
    useId: $c87427e8b303c517$var$P,
    unstable_isNewReconciler: !1
}, $c87427e8b303c517$var$Oh = {
    readContext: $c87427e8b303c517$var$eh,
    useCallback: function(a, b) {
        $c87427e8b303c517$var$Th().memoizedState = [
            a,
            void 0 === b ? null : b
        ];
        return a;
    },
    useContext: $c87427e8b303c517$var$eh,
    useEffect: $c87427e8b303c517$var$mi,
    useImperativeHandle: function(a, b, c) {
        c = null !== c && void 0 !== c ? c.concat([
            a
        ]) : null;
        return $c87427e8b303c517$var$ki(4194308, 4, $c87427e8b303c517$var$pi.bind(null, b, a), c);
    },
    useLayoutEffect: function(a, b) {
        return $c87427e8b303c517$var$ki(4194308, 4, a, b);
    },
    useInsertionEffect: function(a, b) {
        return $c87427e8b303c517$var$ki(4, 2, a, b);
    },
    useMemo: function(a, b) {
        var c = $c87427e8b303c517$var$Th();
        b = void 0 === b ? null : b;
        a = a();
        c.memoizedState = [
            a,
            b
        ];
        return a;
    },
    useReducer: function(a, b, c) {
        var d = $c87427e8b303c517$var$Th();
        b = void 0 !== c ? c(b) : b;
        d.memoizedState = d.baseState = b;
        a = {
            pending: null,
            interleaved: null,
            lanes: 0,
            dispatch: null,
            lastRenderedReducer: a,
            lastRenderedState: b
        };
        d.queue = a;
        a = a.dispatch = $c87427e8b303c517$var$xi.bind(null, $c87427e8b303c517$var$M, a);
        return [
            d.memoizedState,
            a
        ];
    },
    useRef: function(a) {
        var b = $c87427e8b303c517$var$Th();
        a = {
            current: a
        };
        return b.memoizedState = a;
    },
    useState: $c87427e8b303c517$var$hi,
    useDebugValue: $c87427e8b303c517$var$ri,
    useDeferredValue: function(a) {
        return $c87427e8b303c517$var$Th().memoizedState = a;
    },
    useTransition: function() {
        var a = $c87427e8b303c517$var$hi(!1), b = a[0];
        a = $c87427e8b303c517$var$vi.bind(null, a[1]);
        $c87427e8b303c517$var$Th().memoizedState = a;
        return [
            b,
            a
        ];
    },
    useMutableSource: function() {},
    useSyncExternalStore: function(a, b, c) {
        var d = $c87427e8b303c517$var$M, e = $c87427e8b303c517$var$Th();
        if ($c87427e8b303c517$var$I) {
            if (void 0 === c) throw Error($c87427e8b303c517$var$p(407));
            c = c();
        } else {
            c = b();
            if (null === $c87427e8b303c517$var$Q) throw Error($c87427e8b303c517$var$p(349));
            0 !== ($c87427e8b303c517$var$Hh & 30) || $c87427e8b303c517$var$di(d, b, c);
        }
        e.memoizedState = c;
        var f = {
            value: c,
            getSnapshot: b
        };
        e.queue = f;
        $c87427e8b303c517$var$mi($c87427e8b303c517$var$ai.bind(null, d, f, a), [
            a
        ]);
        d.flags |= 2048;
        $c87427e8b303c517$var$bi(9, $c87427e8b303c517$var$ci.bind(null, d, f, c, b), void 0, null);
        return c;
    },
    useId: function() {
        var a = $c87427e8b303c517$var$Th(), b = $c87427e8b303c517$var$Q.identifierPrefix;
        if ($c87427e8b303c517$var$I) {
            var c = $c87427e8b303c517$var$sg;
            var d = $c87427e8b303c517$var$rg;
            c = (d & ~(1 << 32 - $c87427e8b303c517$var$oc(d) - 1)).toString(32) + c;
            b = ":" + b + "R" + c;
            c = $c87427e8b303c517$var$Kh++;
            0 < c && (b += "H" + c.toString(32));
            b += ":";
        } else c = $c87427e8b303c517$var$Lh++, b = ":" + b + "r" + c.toString(32) + ":";
        return a.memoizedState = b;
    },
    unstable_isNewReconciler: !1
}, $c87427e8b303c517$var$Ph = {
    readContext: $c87427e8b303c517$var$eh,
    useCallback: $c87427e8b303c517$var$si,
    useContext: $c87427e8b303c517$var$eh,
    useEffect: $c87427e8b303c517$var$$h,
    useImperativeHandle: $c87427e8b303c517$var$qi,
    useInsertionEffect: $c87427e8b303c517$var$ni,
    useLayoutEffect: $c87427e8b303c517$var$oi,
    useMemo: $c87427e8b303c517$var$ti,
    useReducer: $c87427e8b303c517$var$Wh,
    useRef: $c87427e8b303c517$var$ji,
    useState: function() {
        return $c87427e8b303c517$var$Wh($c87427e8b303c517$var$Vh);
    },
    useDebugValue: $c87427e8b303c517$var$ri,
    useDeferredValue: function(a) {
        var b = $c87427e8b303c517$var$Uh();
        return $c87427e8b303c517$var$ui(b, $c87427e8b303c517$var$N.memoizedState, a);
    },
    useTransition: function() {
        var a = $c87427e8b303c517$var$Wh($c87427e8b303c517$var$Vh)[0], b = $c87427e8b303c517$var$Uh().memoizedState;
        return [
            a,
            b
        ];
    },
    useMutableSource: $c87427e8b303c517$var$Yh,
    useSyncExternalStore: $c87427e8b303c517$var$Zh,
    useId: $c87427e8b303c517$var$wi,
    unstable_isNewReconciler: !1
}, $c87427e8b303c517$var$Qh = {
    readContext: $c87427e8b303c517$var$eh,
    useCallback: $c87427e8b303c517$var$si,
    useContext: $c87427e8b303c517$var$eh,
    useEffect: $c87427e8b303c517$var$$h,
    useImperativeHandle: $c87427e8b303c517$var$qi,
    useInsertionEffect: $c87427e8b303c517$var$ni,
    useLayoutEffect: $c87427e8b303c517$var$oi,
    useMemo: $c87427e8b303c517$var$ti,
    useReducer: $c87427e8b303c517$var$Xh,
    useRef: $c87427e8b303c517$var$ji,
    useState: function() {
        return $c87427e8b303c517$var$Xh($c87427e8b303c517$var$Vh);
    },
    useDebugValue: $c87427e8b303c517$var$ri,
    useDeferredValue: function(a) {
        var b = $c87427e8b303c517$var$Uh();
        return null === $c87427e8b303c517$var$N ? b.memoizedState = a : $c87427e8b303c517$var$ui(b, $c87427e8b303c517$var$N.memoizedState, a);
    },
    useTransition: function() {
        var a = $c87427e8b303c517$var$Xh($c87427e8b303c517$var$Vh)[0], b = $c87427e8b303c517$var$Uh().memoizedState;
        return [
            a,
            b
        ];
    },
    useMutableSource: $c87427e8b303c517$var$Yh,
    useSyncExternalStore: $c87427e8b303c517$var$Zh,
    useId: $c87427e8b303c517$var$wi,
    unstable_isNewReconciler: !1
};
function $c87427e8b303c517$var$Ci(a, b) {
    if (a && a.defaultProps) {
        b = $c87427e8b303c517$var$A({}, b);
        a = a.defaultProps;
        for(var c in a)void 0 === b[c] && (b[c] = a[c]);
        return b;
    }
    return b;
}
function $c87427e8b303c517$var$Di(a, b, c, d) {
    b = a.memoizedState;
    c = c(d, b);
    c = null === c || void 0 === c ? b : $c87427e8b303c517$var$A({}, b, c);
    a.memoizedState = c;
    0 === a.lanes && (a.updateQueue.baseState = c);
}
var $c87427e8b303c517$var$Ei = {
    isMounted: function(a) {
        return (a = a._reactInternals) ? $c87427e8b303c517$var$Vb(a) === a : !1;
    },
    enqueueSetState: function(a, b, c) {
        a = a._reactInternals;
        var d = $c87427e8b303c517$var$R(), e = $c87427e8b303c517$var$yi(a), f = $c87427e8b303c517$var$mh(d, e);
        f.payload = b;
        void 0 !== c && null !== c && (f.callback = c);
        b = $c87427e8b303c517$var$nh(a, f, e);
        null !== b && ($c87427e8b303c517$var$gi(b, a, e, d), $c87427e8b303c517$var$oh(b, a, e));
    },
    enqueueReplaceState: function(a, b, c) {
        a = a._reactInternals;
        var d = $c87427e8b303c517$var$R(), e = $c87427e8b303c517$var$yi(a), f = $c87427e8b303c517$var$mh(d, e);
        f.tag = 1;
        f.payload = b;
        void 0 !== c && null !== c && (f.callback = c);
        b = $c87427e8b303c517$var$nh(a, f, e);
        null !== b && ($c87427e8b303c517$var$gi(b, a, e, d), $c87427e8b303c517$var$oh(b, a, e));
    },
    enqueueForceUpdate: function(a, b) {
        a = a._reactInternals;
        var c = $c87427e8b303c517$var$R(), d = $c87427e8b303c517$var$yi(a), e = $c87427e8b303c517$var$mh(c, d);
        e.tag = 2;
        void 0 !== b && null !== b && (e.callback = b);
        b = $c87427e8b303c517$var$nh(a, e, d);
        null !== b && ($c87427e8b303c517$var$gi(b, a, d, c), $c87427e8b303c517$var$oh(b, a, d));
    }
};
function $c87427e8b303c517$var$Fi(a, b, c, d, e, f, g) {
    a = a.stateNode;
    return "function" === typeof a.shouldComponentUpdate ? a.shouldComponentUpdate(d, f, g) : b.prototype && b.prototype.isPureReactComponent ? !$c87427e8b303c517$var$Ie(c, d) || !$c87427e8b303c517$var$Ie(e, f) : !0;
}
function $c87427e8b303c517$var$Gi(a, b, c) {
    var d = !1, e = $c87427e8b303c517$var$Vf;
    var f = b.contextType;
    "object" === typeof f && null !== f ? f = $c87427e8b303c517$var$eh(f) : (e = $c87427e8b303c517$var$Zf(b) ? $c87427e8b303c517$var$Xf : $c87427e8b303c517$var$H.current, d = b.contextTypes, f = (d = null !== d && void 0 !== d) ? $c87427e8b303c517$var$Yf(a, e) : $c87427e8b303c517$var$Vf);
    b = new b(c, f);
    a.memoizedState = null !== b.state && void 0 !== b.state ? b.state : null;
    b.updater = $c87427e8b303c517$var$Ei;
    a.stateNode = b;
    b._reactInternals = a;
    d && (a = a.stateNode, a.__reactInternalMemoizedUnmaskedChildContext = e, a.__reactInternalMemoizedMaskedChildContext = f);
    return b;
}
function $c87427e8b303c517$var$Hi(a, b, c, d) {
    a = b.state;
    "function" === typeof b.componentWillReceiveProps && b.componentWillReceiveProps(c, d);
    "function" === typeof b.UNSAFE_componentWillReceiveProps && b.UNSAFE_componentWillReceiveProps(c, d);
    b.state !== a && $c87427e8b303c517$var$Ei.enqueueReplaceState(b, b.state, null);
}
function $c87427e8b303c517$var$Ii(a, b, c, d) {
    var e = a.stateNode;
    e.props = c;
    e.state = a.memoizedState;
    e.refs = {};
    $c87427e8b303c517$var$kh(a);
    var f = b.contextType;
    "object" === typeof f && null !== f ? e.context = $c87427e8b303c517$var$eh(f) : (f = $c87427e8b303c517$var$Zf(b) ? $c87427e8b303c517$var$Xf : $c87427e8b303c517$var$H.current, e.context = $c87427e8b303c517$var$Yf(a, f));
    e.state = a.memoizedState;
    f = b.getDerivedStateFromProps;
    "function" === typeof f && ($c87427e8b303c517$var$Di(a, b, f, c), e.state = a.memoizedState);
    "function" === typeof b.getDerivedStateFromProps || "function" === typeof e.getSnapshotBeforeUpdate || "function" !== typeof e.UNSAFE_componentWillMount && "function" !== typeof e.componentWillMount || (b = e.state, "function" === typeof e.componentWillMount && e.componentWillMount(), "function" === typeof e.UNSAFE_componentWillMount && e.UNSAFE_componentWillMount(), b !== e.state && $c87427e8b303c517$var$Ei.enqueueReplaceState(e, e.state, null), $c87427e8b303c517$var$qh(a, c, e, d), e.state = a.memoizedState);
    "function" === typeof e.componentDidMount && (a.flags |= 4194308);
}
function $c87427e8b303c517$var$Ji(a, b) {
    try {
        var c = "", d = b;
        do c += $c87427e8b303c517$var$Pa(d), d = d.return;
        while (d);
        var e = c;
    } catch (f) {
        e = "\nError generating stack: " + f.message + "\n" + f.stack;
    }
    return {
        value: a,
        source: b,
        stack: e,
        digest: null
    };
}
function $c87427e8b303c517$var$Ki(a, b, c) {
    return {
        value: a,
        source: null,
        stack: null != c ? c : null,
        digest: null != b ? b : null
    };
}
function $c87427e8b303c517$var$Li(a, b) {
    try {
        console.error(b.value);
    } catch (c) {
        setTimeout(function() {
            throw c;
        });
    }
}
var $c87427e8b303c517$var$Mi = "function" === typeof WeakMap ? WeakMap : Map;
function $c87427e8b303c517$var$Ni(a, b, c) {
    c = $c87427e8b303c517$var$mh(-1, c);
    c.tag = 3;
    c.payload = {
        element: null
    };
    var d = b.value;
    c.callback = function() {
        $c87427e8b303c517$var$Oi || ($c87427e8b303c517$var$Oi = !0, $c87427e8b303c517$var$Pi = d);
        $c87427e8b303c517$var$Li(a, b);
    };
    return c;
}
function $c87427e8b303c517$var$Qi(a, b, c) {
    c = $c87427e8b303c517$var$mh(-1, c);
    c.tag = 3;
    var d = a.type.getDerivedStateFromError;
    if ("function" === typeof d) {
        var e = b.value;
        c.payload = function() {
            return d(e);
        };
        c.callback = function() {
            $c87427e8b303c517$var$Li(a, b);
        };
    }
    var f = a.stateNode;
    null !== f && "function" === typeof f.componentDidCatch && (c.callback = function() {
        $c87427e8b303c517$var$Li(a, b);
        "function" !== typeof d && (null === $c87427e8b303c517$var$Ri ? $c87427e8b303c517$var$Ri = new Set([
            this
        ]) : $c87427e8b303c517$var$Ri.add(this));
        var c = b.stack;
        this.componentDidCatch(b.value, {
            componentStack: null !== c ? c : ""
        });
    });
    return c;
}
function $c87427e8b303c517$var$Si(a, b, c) {
    var d = a.pingCache;
    if (null === d) {
        d = a.pingCache = new $c87427e8b303c517$var$Mi;
        var e = new Set;
        d.set(b, e);
    } else e = d.get(b), void 0 === e && (e = new Set, d.set(b, e));
    e.has(c) || (e.add(c), a = $c87427e8b303c517$var$Ti.bind(null, a, b, c), b.then(a, a));
}
function $c87427e8b303c517$var$Ui(a) {
    do {
        var b;
        if (b = 13 === a.tag) b = a.memoizedState, b = null !== b ? null !== b.dehydrated ? !0 : !1 : !0;
        if (b) return a;
        a = a.return;
    }while (null !== a);
    return null;
}
function $c87427e8b303c517$var$Vi(a, b, c, d, e) {
    if (0 === (a.mode & 1)) return a === b ? a.flags |= 65536 : (a.flags |= 128, c.flags |= 131072, c.flags &= -52805, 1 === c.tag && (null === c.alternate ? c.tag = 17 : (b = $c87427e8b303c517$var$mh(-1, 1), b.tag = 2, $c87427e8b303c517$var$nh(c, b, 1))), c.lanes |= 1), a;
    a.flags |= 65536;
    a.lanes = e;
    return a;
}
var $c87427e8b303c517$var$Wi = $c87427e8b303c517$var$ua.ReactCurrentOwner, $c87427e8b303c517$var$dh = !1;
function $c87427e8b303c517$var$Xi(a, b, c, d) {
    b.child = null === a ? $c87427e8b303c517$var$Vg(b, null, c, d) : $c87427e8b303c517$var$Ug(b, a.child, c, d);
}
function $c87427e8b303c517$var$Yi(a, b, c, d, e) {
    c = c.render;
    var f = b.ref;
    $c87427e8b303c517$var$ch(b, e);
    d = $c87427e8b303c517$var$Nh(a, b, c, d, f, e);
    c = $c87427e8b303c517$var$Sh();
    if (null !== a && !$c87427e8b303c517$var$dh) return b.updateQueue = a.updateQueue, b.flags &= -2053, a.lanes &= ~e, $c87427e8b303c517$var$Zi(a, b, e);
    $c87427e8b303c517$var$I && c && $c87427e8b303c517$var$vg(b);
    b.flags |= 1;
    $c87427e8b303c517$var$Xi(a, b, d, e);
    return b.child;
}
function $c87427e8b303c517$var$$i(a, b, c, d, e) {
    if (null === a) {
        var f = c.type;
        if ("function" === typeof f && !$c87427e8b303c517$var$aj(f) && void 0 === f.defaultProps && null === c.compare && void 0 === c.defaultProps) return b.tag = 15, b.type = f, $c87427e8b303c517$var$bj(a, b, f, d, e);
        a = $c87427e8b303c517$var$Rg(c.type, null, d, b, b.mode, e);
        a.ref = b.ref;
        a.return = b;
        return b.child = a;
    }
    f = a.child;
    if (0 === (a.lanes & e)) {
        var g = f.memoizedProps;
        c = c.compare;
        c = null !== c ? c : $c87427e8b303c517$var$Ie;
        if (c(g, d) && a.ref === b.ref) return $c87427e8b303c517$var$Zi(a, b, e);
    }
    b.flags |= 1;
    a = $c87427e8b303c517$var$Pg(f, d);
    a.ref = b.ref;
    a.return = b;
    return b.child = a;
}
function $c87427e8b303c517$var$bj(a, b, c, d, e) {
    if (null !== a) {
        var f = a.memoizedProps;
        if ($c87427e8b303c517$var$Ie(f, d) && a.ref === b.ref) {
            if ($c87427e8b303c517$var$dh = !1, b.pendingProps = d = f, 0 !== (a.lanes & e)) 0 !== (a.flags & 131072) && ($c87427e8b303c517$var$dh = !0);
            else return b.lanes = a.lanes, $c87427e8b303c517$var$Zi(a, b, e);
        }
    }
    return $c87427e8b303c517$var$cj(a, b, c, d, e);
}
function $c87427e8b303c517$var$dj(a, b, c) {
    var d = b.pendingProps, e = d.children, f = null !== a ? a.memoizedState : null;
    if ("hidden" === d.mode) {
        if (0 === (b.mode & 1)) b.memoizedState = {
            baseLanes: 0,
            cachePool: null,
            transitions: null
        }, $c87427e8b303c517$var$G($c87427e8b303c517$var$ej, $c87427e8b303c517$var$fj), $c87427e8b303c517$var$fj |= c;
        else {
            if (0 === (c & 1073741824)) return a = null !== f ? f.baseLanes | c : c, b.lanes = b.childLanes = 1073741824, b.memoizedState = {
                baseLanes: a,
                cachePool: null,
                transitions: null
            }, b.updateQueue = null, $c87427e8b303c517$var$G($c87427e8b303c517$var$ej, $c87427e8b303c517$var$fj), $c87427e8b303c517$var$fj |= a, null;
            b.memoizedState = {
                baseLanes: 0,
                cachePool: null,
                transitions: null
            };
            d = null !== f ? f.baseLanes : c;
            $c87427e8b303c517$var$G($c87427e8b303c517$var$ej, $c87427e8b303c517$var$fj);
            $c87427e8b303c517$var$fj |= d;
        }
    } else null !== f ? (d = f.baseLanes | c, b.memoizedState = null) : d = c, $c87427e8b303c517$var$G($c87427e8b303c517$var$ej, $c87427e8b303c517$var$fj), $c87427e8b303c517$var$fj |= d;
    $c87427e8b303c517$var$Xi(a, b, e, c);
    return b.child;
}
function $c87427e8b303c517$var$gj(a, b) {
    var c = b.ref;
    if (null === a && null !== c || null !== a && a.ref !== c) b.flags |= 512, b.flags |= 2097152;
}
function $c87427e8b303c517$var$cj(a, b, c, d, e) {
    var f = $c87427e8b303c517$var$Zf(c) ? $c87427e8b303c517$var$Xf : $c87427e8b303c517$var$H.current;
    f = $c87427e8b303c517$var$Yf(b, f);
    $c87427e8b303c517$var$ch(b, e);
    c = $c87427e8b303c517$var$Nh(a, b, c, d, f, e);
    d = $c87427e8b303c517$var$Sh();
    if (null !== a && !$c87427e8b303c517$var$dh) return b.updateQueue = a.updateQueue, b.flags &= -2053, a.lanes &= ~e, $c87427e8b303c517$var$Zi(a, b, e);
    $c87427e8b303c517$var$I && d && $c87427e8b303c517$var$vg(b);
    b.flags |= 1;
    $c87427e8b303c517$var$Xi(a, b, c, e);
    return b.child;
}
function $c87427e8b303c517$var$hj(a, b, c, d, e) {
    if ($c87427e8b303c517$var$Zf(c)) {
        var f = !0;
        $c87427e8b303c517$var$cg(b);
    } else f = !1;
    $c87427e8b303c517$var$ch(b, e);
    if (null === b.stateNode) $c87427e8b303c517$var$ij(a, b), $c87427e8b303c517$var$Gi(b, c, d), $c87427e8b303c517$var$Ii(b, c, d, e), d = !0;
    else if (null === a) {
        var g = b.stateNode, h = b.memoizedProps;
        g.props = h;
        var k = g.context, l = c.contextType;
        "object" === typeof l && null !== l ? l = $c87427e8b303c517$var$eh(l) : (l = $c87427e8b303c517$var$Zf(c) ? $c87427e8b303c517$var$Xf : $c87427e8b303c517$var$H.current, l = $c87427e8b303c517$var$Yf(b, l));
        var m = c.getDerivedStateFromProps, q = "function" === typeof m || "function" === typeof g.getSnapshotBeforeUpdate;
        q || "function" !== typeof g.UNSAFE_componentWillReceiveProps && "function" !== typeof g.componentWillReceiveProps || (h !== d || k !== l) && $c87427e8b303c517$var$Hi(b, g, d, l);
        $c87427e8b303c517$var$jh = !1;
        var r = b.memoizedState;
        g.state = r;
        $c87427e8b303c517$var$qh(b, d, g, e);
        k = b.memoizedState;
        h !== d || r !== k || $c87427e8b303c517$var$Wf.current || $c87427e8b303c517$var$jh ? ("function" === typeof m && ($c87427e8b303c517$var$Di(b, c, m, d), k = b.memoizedState), (h = $c87427e8b303c517$var$jh || $c87427e8b303c517$var$Fi(b, c, h, d, r, k, l)) ? (q || "function" !== typeof g.UNSAFE_componentWillMount && "function" !== typeof g.componentWillMount || ("function" === typeof g.componentWillMount && g.componentWillMount(), "function" === typeof g.UNSAFE_componentWillMount && g.UNSAFE_componentWillMount()), "function" === typeof g.componentDidMount && (b.flags |= 4194308)) : ("function" === typeof g.componentDidMount && (b.flags |= 4194308), b.memoizedProps = d, b.memoizedState = k), g.props = d, g.state = k, g.context = l, d = h) : ("function" === typeof g.componentDidMount && (b.flags |= 4194308), d = !1);
    } else {
        g = b.stateNode;
        $c87427e8b303c517$var$lh(a, b);
        h = b.memoizedProps;
        l = b.type === b.elementType ? h : $c87427e8b303c517$var$Ci(b.type, h);
        g.props = l;
        q = b.pendingProps;
        r = g.context;
        k = c.contextType;
        "object" === typeof k && null !== k ? k = $c87427e8b303c517$var$eh(k) : (k = $c87427e8b303c517$var$Zf(c) ? $c87427e8b303c517$var$Xf : $c87427e8b303c517$var$H.current, k = $c87427e8b303c517$var$Yf(b, k));
        var y = c.getDerivedStateFromProps;
        (m = "function" === typeof y || "function" === typeof g.getSnapshotBeforeUpdate) || "function" !== typeof g.UNSAFE_componentWillReceiveProps && "function" !== typeof g.componentWillReceiveProps || (h !== q || r !== k) && $c87427e8b303c517$var$Hi(b, g, d, k);
        $c87427e8b303c517$var$jh = !1;
        r = b.memoizedState;
        g.state = r;
        $c87427e8b303c517$var$qh(b, d, g, e);
        var n = b.memoizedState;
        h !== q || r !== n || $c87427e8b303c517$var$Wf.current || $c87427e8b303c517$var$jh ? ("function" === typeof y && ($c87427e8b303c517$var$Di(b, c, y, d), n = b.memoizedState), (l = $c87427e8b303c517$var$jh || $c87427e8b303c517$var$Fi(b, c, l, d, r, n, k) || !1) ? (m || "function" !== typeof g.UNSAFE_componentWillUpdate && "function" !== typeof g.componentWillUpdate || ("function" === typeof g.componentWillUpdate && g.componentWillUpdate(d, n, k), "function" === typeof g.UNSAFE_componentWillUpdate && g.UNSAFE_componentWillUpdate(d, n, k)), "function" === typeof g.componentDidUpdate && (b.flags |= 4), "function" === typeof g.getSnapshotBeforeUpdate && (b.flags |= 1024)) : ("function" !== typeof g.componentDidUpdate || h === a.memoizedProps && r === a.memoizedState || (b.flags |= 4), "function" !== typeof g.getSnapshotBeforeUpdate || h === a.memoizedProps && r === a.memoizedState || (b.flags |= 1024), b.memoizedProps = d, b.memoizedState = n), g.props = d, g.state = n, g.context = k, d = l) : ("function" !== typeof g.componentDidUpdate || h === a.memoizedProps && r === a.memoizedState || (b.flags |= 4), "function" !== typeof g.getSnapshotBeforeUpdate || h === a.memoizedProps && r === a.memoizedState || (b.flags |= 1024), d = !1);
    }
    return $c87427e8b303c517$var$jj(a, b, c, d, f, e);
}
function $c87427e8b303c517$var$jj(a, b, c, d, e, f) {
    $c87427e8b303c517$var$gj(a, b);
    var g = 0 !== (b.flags & 128);
    if (!d && !g) return e && $c87427e8b303c517$var$dg(b, c, !1), $c87427e8b303c517$var$Zi(a, b, f);
    d = b.stateNode;
    $c87427e8b303c517$var$Wi.current = b;
    var h = g && "function" !== typeof c.getDerivedStateFromError ? null : d.render();
    b.flags |= 1;
    null !== a && g ? (b.child = $c87427e8b303c517$var$Ug(b, a.child, null, f), b.child = $c87427e8b303c517$var$Ug(b, null, h, f)) : $c87427e8b303c517$var$Xi(a, b, h, f);
    b.memoizedState = d.state;
    e && $c87427e8b303c517$var$dg(b, c, !0);
    return b.child;
}
function $c87427e8b303c517$var$kj(a) {
    var b = a.stateNode;
    b.pendingContext ? $c87427e8b303c517$var$ag(a, b.pendingContext, b.pendingContext !== b.context) : b.context && $c87427e8b303c517$var$ag(a, b.context, !1);
    $c87427e8b303c517$var$yh(a, b.containerInfo);
}
function $c87427e8b303c517$var$lj(a, b, c, d, e) {
    $c87427e8b303c517$var$Ig();
    $c87427e8b303c517$var$Jg(e);
    b.flags |= 256;
    $c87427e8b303c517$var$Xi(a, b, c, d);
    return b.child;
}
var $c87427e8b303c517$var$mj = {
    dehydrated: null,
    treeContext: null,
    retryLane: 0
};
function $c87427e8b303c517$var$nj(a) {
    return {
        baseLanes: a,
        cachePool: null,
        transitions: null
    };
}
function $c87427e8b303c517$var$oj(a, b, c) {
    var d = b.pendingProps, e = $c87427e8b303c517$var$L.current, f = !1, g = 0 !== (b.flags & 128), h;
    (h = g) || (h = null !== a && null === a.memoizedState ? !1 : 0 !== (e & 2));
    if (h) f = !0, b.flags &= -129;
    else if (null === a || null !== a.memoizedState) e |= 1;
    $c87427e8b303c517$var$G($c87427e8b303c517$var$L, e & 1);
    if (null === a) {
        $c87427e8b303c517$var$Eg(b);
        a = b.memoizedState;
        if (null !== a && (a = a.dehydrated, null !== a)) return 0 === (b.mode & 1) ? b.lanes = 1 : "$!" === a.data ? b.lanes = 8 : b.lanes = 1073741824, null;
        g = d.children;
        a = d.fallback;
        return f ? (d = b.mode, f = b.child, g = {
            mode: "hidden",
            children: g
        }, 0 === (d & 1) && null !== f ? (f.childLanes = 0, f.pendingProps = g) : f = $c87427e8b303c517$var$pj(g, d, 0, null), a = $c87427e8b303c517$var$Tg(a, d, c, null), f.return = b, a.return = b, f.sibling = a, b.child = f, b.child.memoizedState = $c87427e8b303c517$var$nj(c), b.memoizedState = $c87427e8b303c517$var$mj, a) : $c87427e8b303c517$var$qj(b, g);
    }
    e = a.memoizedState;
    if (null !== e && (h = e.dehydrated, null !== h)) return $c87427e8b303c517$var$rj(a, b, g, d, h, e, c);
    if (f) {
        f = d.fallback;
        g = b.mode;
        e = a.child;
        h = e.sibling;
        var k = {
            mode: "hidden",
            children: d.children
        };
        0 === (g & 1) && b.child !== e ? (d = b.child, d.childLanes = 0, d.pendingProps = k, b.deletions = null) : (d = $c87427e8b303c517$var$Pg(e, k), d.subtreeFlags = e.subtreeFlags & 14680064);
        null !== h ? f = $c87427e8b303c517$var$Pg(h, f) : (f = $c87427e8b303c517$var$Tg(f, g, c, null), f.flags |= 2);
        f.return = b;
        d.return = b;
        d.sibling = f;
        b.child = d;
        d = f;
        f = b.child;
        g = a.child.memoizedState;
        g = null === g ? $c87427e8b303c517$var$nj(c) : {
            baseLanes: g.baseLanes | c,
            cachePool: null,
            transitions: g.transitions
        };
        f.memoizedState = g;
        f.childLanes = a.childLanes & ~c;
        b.memoizedState = $c87427e8b303c517$var$mj;
        return d;
    }
    f = a.child;
    a = f.sibling;
    d = $c87427e8b303c517$var$Pg(f, {
        mode: "visible",
        children: d.children
    });
    0 === (b.mode & 1) && (d.lanes = c);
    d.return = b;
    d.sibling = null;
    null !== a && (c = b.deletions, null === c ? (b.deletions = [
        a
    ], b.flags |= 16) : c.push(a));
    b.child = d;
    b.memoizedState = null;
    return d;
}
function $c87427e8b303c517$var$qj(a, b) {
    b = $c87427e8b303c517$var$pj({
        mode: "visible",
        children: b
    }, a.mode, 0, null);
    b.return = a;
    return a.child = b;
}
function $c87427e8b303c517$var$sj(a, b, c, d) {
    null !== d && $c87427e8b303c517$var$Jg(d);
    $c87427e8b303c517$var$Ug(b, a.child, null, c);
    a = $c87427e8b303c517$var$qj(b, b.pendingProps.children);
    a.flags |= 2;
    b.memoizedState = null;
    return a;
}
function $c87427e8b303c517$var$rj(a, b, c, d, e, f, g) {
    if (c) {
        if (b.flags & 256) return b.flags &= -257, d = $c87427e8b303c517$var$Ki(Error($c87427e8b303c517$var$p(422))), $c87427e8b303c517$var$sj(a, b, g, d);
        if (null !== b.memoizedState) return b.child = a.child, b.flags |= 128, null;
        f = d.fallback;
        e = b.mode;
        d = $c87427e8b303c517$var$pj({
            mode: "visible",
            children: d.children
        }, e, 0, null);
        f = $c87427e8b303c517$var$Tg(f, e, g, null);
        f.flags |= 2;
        d.return = b;
        f.return = b;
        d.sibling = f;
        b.child = d;
        0 !== (b.mode & 1) && $c87427e8b303c517$var$Ug(b, a.child, null, g);
        b.child.memoizedState = $c87427e8b303c517$var$nj(g);
        b.memoizedState = $c87427e8b303c517$var$mj;
        return f;
    }
    if (0 === (b.mode & 1)) return $c87427e8b303c517$var$sj(a, b, g, null);
    if ("$!" === e.data) {
        d = e.nextSibling && e.nextSibling.dataset;
        if (d) var h = d.dgst;
        d = h;
        f = Error($c87427e8b303c517$var$p(419));
        d = $c87427e8b303c517$var$Ki(f, d, void 0);
        return $c87427e8b303c517$var$sj(a, b, g, d);
    }
    h = 0 !== (g & a.childLanes);
    if ($c87427e8b303c517$var$dh || h) {
        d = $c87427e8b303c517$var$Q;
        if (null !== d) {
            switch(g & -g){
                case 4:
                    e = 2;
                    break;
                case 16:
                    e = 8;
                    break;
                case 64:
                case 128:
                case 256:
                case 512:
                case 1024:
                case 2048:
                case 4096:
                case 8192:
                case 16384:
                case 32768:
                case 65536:
                case 131072:
                case 262144:
                case 524288:
                case 1048576:
                case 2097152:
                case 4194304:
                case 8388608:
                case 16777216:
                case 33554432:
                case 67108864:
                    e = 32;
                    break;
                case 536870912:
                    e = 268435456;
                    break;
                default:
                    e = 0;
            }
            e = 0 !== (e & (d.suspendedLanes | g)) ? 0 : e;
            0 !== e && e !== f.retryLane && (f.retryLane = e, $c87427e8b303c517$var$ih(a, e), $c87427e8b303c517$var$gi(d, a, e, -1));
        }
        $c87427e8b303c517$var$tj();
        d = $c87427e8b303c517$var$Ki(Error($c87427e8b303c517$var$p(421)));
        return $c87427e8b303c517$var$sj(a, b, g, d);
    }
    if ("$?" === e.data) return b.flags |= 128, b.child = a.child, b = $c87427e8b303c517$var$uj.bind(null, a), e._reactRetry = b, null;
    a = f.treeContext;
    $c87427e8b303c517$var$yg = $c87427e8b303c517$var$Lf(e.nextSibling);
    $c87427e8b303c517$var$xg = b;
    $c87427e8b303c517$var$I = !0;
    $c87427e8b303c517$var$zg = null;
    null !== a && ($c87427e8b303c517$var$og[$c87427e8b303c517$var$pg++] = $c87427e8b303c517$var$rg, $c87427e8b303c517$var$og[$c87427e8b303c517$var$pg++] = $c87427e8b303c517$var$sg, $c87427e8b303c517$var$og[$c87427e8b303c517$var$pg++] = $c87427e8b303c517$var$qg, $c87427e8b303c517$var$rg = a.id, $c87427e8b303c517$var$sg = a.overflow, $c87427e8b303c517$var$qg = b);
    b = $c87427e8b303c517$var$qj(b, d.children);
    b.flags |= 4096;
    return b;
}
function $c87427e8b303c517$var$vj(a, b, c) {
    a.lanes |= b;
    var d = a.alternate;
    null !== d && (d.lanes |= b);
    $c87427e8b303c517$var$bh(a.return, b, c);
}
function $c87427e8b303c517$var$wj(a, b, c, d, e) {
    var f = a.memoizedState;
    null === f ? a.memoizedState = {
        isBackwards: b,
        rendering: null,
        renderingStartTime: 0,
        last: d,
        tail: c,
        tailMode: e
    } : (f.isBackwards = b, f.rendering = null, f.renderingStartTime = 0, f.last = d, f.tail = c, f.tailMode = e);
}
function $c87427e8b303c517$var$xj(a, b, c) {
    var d = b.pendingProps, e = d.revealOrder, f = d.tail;
    $c87427e8b303c517$var$Xi(a, b, d.children, c);
    d = $c87427e8b303c517$var$L.current;
    if (0 !== (d & 2)) d = d & 1 | 2, b.flags |= 128;
    else {
        if (null !== a && 0 !== (a.flags & 128)) a: for(a = b.child; null !== a;){
            if (13 === a.tag) null !== a.memoizedState && $c87427e8b303c517$var$vj(a, c, b);
            else if (19 === a.tag) $c87427e8b303c517$var$vj(a, c, b);
            else if (null !== a.child) {
                a.child.return = a;
                a = a.child;
                continue;
            }
            if (a === b) break a;
            for(; null === a.sibling;){
                if (null === a.return || a.return === b) break a;
                a = a.return;
            }
            a.sibling.return = a.return;
            a = a.sibling;
        }
        d &= 1;
    }
    $c87427e8b303c517$var$G($c87427e8b303c517$var$L, d);
    if (0 === (b.mode & 1)) b.memoizedState = null;
    else switch(e){
        case "forwards":
            c = b.child;
            for(e = null; null !== c;)a = c.alternate, null !== a && null === $c87427e8b303c517$var$Ch(a) && (e = c), c = c.sibling;
            c = e;
            null === c ? (e = b.child, b.child = null) : (e = c.sibling, c.sibling = null);
            $c87427e8b303c517$var$wj(b, !1, e, c, f);
            break;
        case "backwards":
            c = null;
            e = b.child;
            for(b.child = null; null !== e;){
                a = e.alternate;
                if (null !== a && null === $c87427e8b303c517$var$Ch(a)) {
                    b.child = e;
                    break;
                }
                a = e.sibling;
                e.sibling = c;
                c = e;
                e = a;
            }
            $c87427e8b303c517$var$wj(b, !0, c, null, f);
            break;
        case "together":
            $c87427e8b303c517$var$wj(b, !1, null, null, void 0);
            break;
        default:
            b.memoizedState = null;
    }
    return b.child;
}
function $c87427e8b303c517$var$ij(a, b) {
    0 === (b.mode & 1) && null !== a && (a.alternate = null, b.alternate = null, b.flags |= 2);
}
function $c87427e8b303c517$var$Zi(a, b, c) {
    null !== a && (b.dependencies = a.dependencies);
    $c87427e8b303c517$var$rh |= b.lanes;
    if (0 === (c & b.childLanes)) return null;
    if (null !== a && b.child !== a.child) throw Error($c87427e8b303c517$var$p(153));
    if (null !== b.child) {
        a = b.child;
        c = $c87427e8b303c517$var$Pg(a, a.pendingProps);
        b.child = c;
        for(c.return = b; null !== a.sibling;)a = a.sibling, c = c.sibling = $c87427e8b303c517$var$Pg(a, a.pendingProps), c.return = b;
        c.sibling = null;
    }
    return b.child;
}
function $c87427e8b303c517$var$yj(a, b, c) {
    switch(b.tag){
        case 3:
            $c87427e8b303c517$var$kj(b);
            $c87427e8b303c517$var$Ig();
            break;
        case 5:
            $c87427e8b303c517$var$Ah(b);
            break;
        case 1:
            $c87427e8b303c517$var$Zf(b.type) && $c87427e8b303c517$var$cg(b);
            break;
        case 4:
            $c87427e8b303c517$var$yh(b, b.stateNode.containerInfo);
            break;
        case 10:
            var d = b.type._context, e = b.memoizedProps.value;
            $c87427e8b303c517$var$G($c87427e8b303c517$var$Wg, d._currentValue);
            d._currentValue = e;
            break;
        case 13:
            d = b.memoizedState;
            if (null !== d) {
                if (null !== d.dehydrated) return $c87427e8b303c517$var$G($c87427e8b303c517$var$L, $c87427e8b303c517$var$L.current & 1), b.flags |= 128, null;
                if (0 !== (c & b.child.childLanes)) return $c87427e8b303c517$var$oj(a, b, c);
                $c87427e8b303c517$var$G($c87427e8b303c517$var$L, $c87427e8b303c517$var$L.current & 1);
                a = $c87427e8b303c517$var$Zi(a, b, c);
                return null !== a ? a.sibling : null;
            }
            $c87427e8b303c517$var$G($c87427e8b303c517$var$L, $c87427e8b303c517$var$L.current & 1);
            break;
        case 19:
            d = 0 !== (c & b.childLanes);
            if (0 !== (a.flags & 128)) {
                if (d) return $c87427e8b303c517$var$xj(a, b, c);
                b.flags |= 128;
            }
            e = b.memoizedState;
            null !== e && (e.rendering = null, e.tail = null, e.lastEffect = null);
            $c87427e8b303c517$var$G($c87427e8b303c517$var$L, $c87427e8b303c517$var$L.current);
            if (d) break;
            else return null;
        case 22:
        case 23:
            return b.lanes = 0, $c87427e8b303c517$var$dj(a, b, c);
    }
    return $c87427e8b303c517$var$Zi(a, b, c);
}
var $c87427e8b303c517$var$zj, $c87427e8b303c517$var$Aj, $c87427e8b303c517$var$Bj, $c87427e8b303c517$var$Cj;
$c87427e8b303c517$var$zj = function(a, b) {
    for(var c = b.child; null !== c;){
        if (5 === c.tag || 6 === c.tag) a.appendChild(c.stateNode);
        else if (4 !== c.tag && null !== c.child) {
            c.child.return = c;
            c = c.child;
            continue;
        }
        if (c === b) break;
        for(; null === c.sibling;){
            if (null === c.return || c.return === b) return;
            c = c.return;
        }
        c.sibling.return = c.return;
        c = c.sibling;
    }
};
$c87427e8b303c517$var$Aj = function() {};
$c87427e8b303c517$var$Bj = function(a, b, c, d) {
    var e = a.memoizedProps;
    if (e !== d) {
        a = b.stateNode;
        $c87427e8b303c517$var$xh($c87427e8b303c517$var$uh.current);
        var f = null;
        switch(c){
            case "input":
                e = $c87427e8b303c517$var$Ya(a, e);
                d = $c87427e8b303c517$var$Ya(a, d);
                f = [];
                break;
            case "select":
                e = $c87427e8b303c517$var$A({}, e, {
                    value: void 0
                });
                d = $c87427e8b303c517$var$A({}, d, {
                    value: void 0
                });
                f = [];
                break;
            case "textarea":
                e = $c87427e8b303c517$var$gb(a, e);
                d = $c87427e8b303c517$var$gb(a, d);
                f = [];
                break;
            default:
                "function" !== typeof e.onClick && "function" === typeof d.onClick && (a.onclick = $c87427e8b303c517$var$Bf);
        }
        $c87427e8b303c517$var$ub(c, d);
        var g;
        c = null;
        for(l in e)if (!d.hasOwnProperty(l) && e.hasOwnProperty(l) && null != e[l]) {
            if ("style" === l) {
                var h = e[l];
                for(g in h)h.hasOwnProperty(g) && (c || (c = {}), c[g] = "");
            } else "dangerouslySetInnerHTML" !== l && "children" !== l && "suppressContentEditableWarning" !== l && "suppressHydrationWarning" !== l && "autoFocus" !== l && ($c87427e8b303c517$var$ea.hasOwnProperty(l) ? f || (f = []) : (f = f || []).push(l, null));
        }
        for(l in d){
            var k = d[l];
            h = null != e ? e[l] : void 0;
            if (d.hasOwnProperty(l) && k !== h && (null != k || null != h)) {
                if ("style" === l) {
                    if (h) {
                        for(g in h)!h.hasOwnProperty(g) || k && k.hasOwnProperty(g) || (c || (c = {}), c[g] = "");
                        for(g in k)k.hasOwnProperty(g) && h[g] !== k[g] && (c || (c = {}), c[g] = k[g]);
                    } else c || (f || (f = []), f.push(l, c)), c = k;
                } else "dangerouslySetInnerHTML" === l ? (k = k ? k.__html : void 0, h = h ? h.__html : void 0, null != k && h !== k && (f = f || []).push(l, k)) : "children" === l ? "string" !== typeof k && "number" !== typeof k || (f = f || []).push(l, "" + k) : "suppressContentEditableWarning" !== l && "suppressHydrationWarning" !== l && ($c87427e8b303c517$var$ea.hasOwnProperty(l) ? (null != k && "onScroll" === l && $c87427e8b303c517$var$D("scroll", a), f || h === k || (f = [])) : (f = f || []).push(l, k));
            }
        }
        c && (f = f || []).push("style", c);
        var l = f;
        if (b.updateQueue = l) b.flags |= 4;
    }
};
$c87427e8b303c517$var$Cj = function(a, b, c, d) {
    c !== d && (b.flags |= 4);
};
function $c87427e8b303c517$var$Dj(a, b) {
    if (!$c87427e8b303c517$var$I) switch(a.tailMode){
        case "hidden":
            b = a.tail;
            for(var c = null; null !== b;)null !== b.alternate && (c = b), b = b.sibling;
            null === c ? a.tail = null : c.sibling = null;
            break;
        case "collapsed":
            c = a.tail;
            for(var d = null; null !== c;)null !== c.alternate && (d = c), c = c.sibling;
            null === d ? b || null === a.tail ? a.tail = null : a.tail.sibling = null : d.sibling = null;
    }
}
function $c87427e8b303c517$var$S(a) {
    var b = null !== a.alternate && a.alternate.child === a.child, c = 0, d = 0;
    if (b) for(var e = a.child; null !== e;)c |= e.lanes | e.childLanes, d |= e.subtreeFlags & 14680064, d |= e.flags & 14680064, e.return = a, e = e.sibling;
    else for(e = a.child; null !== e;)c |= e.lanes | e.childLanes, d |= e.subtreeFlags, d |= e.flags, e.return = a, e = e.sibling;
    a.subtreeFlags |= d;
    a.childLanes = c;
    return b;
}
function $c87427e8b303c517$var$Ej(a, b, c) {
    var d = b.pendingProps;
    $c87427e8b303c517$var$wg(b);
    switch(b.tag){
        case 2:
        case 16:
        case 15:
        case 0:
        case 11:
        case 7:
        case 8:
        case 12:
        case 9:
        case 14:
            return $c87427e8b303c517$var$S(b), null;
        case 1:
            return $c87427e8b303c517$var$Zf(b.type) && $c87427e8b303c517$var$$f(), $c87427e8b303c517$var$S(b), null;
        case 3:
            d = b.stateNode;
            $c87427e8b303c517$var$zh();
            $c87427e8b303c517$var$E($c87427e8b303c517$var$Wf);
            $c87427e8b303c517$var$E($c87427e8b303c517$var$H);
            $c87427e8b303c517$var$Eh();
            d.pendingContext && (d.context = d.pendingContext, d.pendingContext = null);
            if (null === a || null === a.child) $c87427e8b303c517$var$Gg(b) ? b.flags |= 4 : null === a || a.memoizedState.isDehydrated && 0 === (b.flags & 256) || (b.flags |= 1024, null !== $c87427e8b303c517$var$zg && ($c87427e8b303c517$var$Fj($c87427e8b303c517$var$zg), $c87427e8b303c517$var$zg = null));
            $c87427e8b303c517$var$Aj(a, b);
            $c87427e8b303c517$var$S(b);
            return null;
        case 5:
            $c87427e8b303c517$var$Bh(b);
            var e = $c87427e8b303c517$var$xh($c87427e8b303c517$var$wh.current);
            c = b.type;
            if (null !== a && null != b.stateNode) $c87427e8b303c517$var$Bj(a, b, c, d, e), a.ref !== b.ref && (b.flags |= 512, b.flags |= 2097152);
            else {
                if (!d) {
                    if (null === b.stateNode) throw Error($c87427e8b303c517$var$p(166));
                    $c87427e8b303c517$var$S(b);
                    return null;
                }
                a = $c87427e8b303c517$var$xh($c87427e8b303c517$var$uh.current);
                if ($c87427e8b303c517$var$Gg(b)) {
                    d = b.stateNode;
                    c = b.type;
                    var f = b.memoizedProps;
                    d[$c87427e8b303c517$var$Of] = b;
                    d[$c87427e8b303c517$var$Pf] = f;
                    a = 0 !== (b.mode & 1);
                    switch(c){
                        case "dialog":
                            $c87427e8b303c517$var$D("cancel", d);
                            $c87427e8b303c517$var$D("close", d);
                            break;
                        case "iframe":
                        case "object":
                        case "embed":
                            $c87427e8b303c517$var$D("load", d);
                            break;
                        case "video":
                        case "audio":
                            for(e = 0; e < $c87427e8b303c517$var$lf.length; e++)$c87427e8b303c517$var$D($c87427e8b303c517$var$lf[e], d);
                            break;
                        case "source":
                            $c87427e8b303c517$var$D("error", d);
                            break;
                        case "img":
                        case "image":
                        case "link":
                            $c87427e8b303c517$var$D("error", d);
                            $c87427e8b303c517$var$D("load", d);
                            break;
                        case "details":
                            $c87427e8b303c517$var$D("toggle", d);
                            break;
                        case "input":
                            $c87427e8b303c517$var$Za(d, f);
                            $c87427e8b303c517$var$D("invalid", d);
                            break;
                        case "select":
                            d._wrapperState = {
                                wasMultiple: !!f.multiple
                            };
                            $c87427e8b303c517$var$D("invalid", d);
                            break;
                        case "textarea":
                            $c87427e8b303c517$var$hb(d, f), $c87427e8b303c517$var$D("invalid", d);
                    }
                    $c87427e8b303c517$var$ub(c, f);
                    e = null;
                    for(var g in f)if (f.hasOwnProperty(g)) {
                        var h = f[g];
                        "children" === g ? "string" === typeof h ? d.textContent !== h && (!0 !== f.suppressHydrationWarning && $c87427e8b303c517$var$Af(d.textContent, h, a), e = [
                            "children",
                            h
                        ]) : "number" === typeof h && d.textContent !== "" + h && (!0 !== f.suppressHydrationWarning && $c87427e8b303c517$var$Af(d.textContent, h, a), e = [
                            "children",
                            "" + h
                        ]) : $c87427e8b303c517$var$ea.hasOwnProperty(g) && null != h && "onScroll" === g && $c87427e8b303c517$var$D("scroll", d);
                    }
                    switch(c){
                        case "input":
                            $c87427e8b303c517$var$Va(d);
                            $c87427e8b303c517$var$db(d, f, !0);
                            break;
                        case "textarea":
                            $c87427e8b303c517$var$Va(d);
                            $c87427e8b303c517$var$jb(d);
                            break;
                        case "select":
                        case "option":
                            break;
                        default:
                            "function" === typeof f.onClick && (d.onclick = $c87427e8b303c517$var$Bf);
                    }
                    d = e;
                    b.updateQueue = d;
                    null !== d && (b.flags |= 4);
                } else {
                    g = 9 === e.nodeType ? e : e.ownerDocument;
                    "http://www.w3.org/1999/xhtml" === a && (a = $c87427e8b303c517$var$kb(c));
                    "http://www.w3.org/1999/xhtml" === a ? "script" === c ? (a = g.createElement("div"), a.innerHTML = "<script></script>", a = a.removeChild(a.firstChild)) : "string" === typeof d.is ? a = g.createElement(c, {
                        is: d.is
                    }) : (a = g.createElement(c), "select" === c && (g = a, d.multiple ? g.multiple = !0 : d.size && (g.size = d.size))) : a = g.createElementNS(a, c);
                    a[$c87427e8b303c517$var$Of] = b;
                    a[$c87427e8b303c517$var$Pf] = d;
                    $c87427e8b303c517$var$zj(a, b, !1, !1);
                    b.stateNode = a;
                    a: {
                        g = $c87427e8b303c517$var$vb(c, d);
                        switch(c){
                            case "dialog":
                                $c87427e8b303c517$var$D("cancel", a);
                                $c87427e8b303c517$var$D("close", a);
                                e = d;
                                break;
                            case "iframe":
                            case "object":
                            case "embed":
                                $c87427e8b303c517$var$D("load", a);
                                e = d;
                                break;
                            case "video":
                            case "audio":
                                for(e = 0; e < $c87427e8b303c517$var$lf.length; e++)$c87427e8b303c517$var$D($c87427e8b303c517$var$lf[e], a);
                                e = d;
                                break;
                            case "source":
                                $c87427e8b303c517$var$D("error", a);
                                e = d;
                                break;
                            case "img":
                            case "image":
                            case "link":
                                $c87427e8b303c517$var$D("error", a);
                                $c87427e8b303c517$var$D("load", a);
                                e = d;
                                break;
                            case "details":
                                $c87427e8b303c517$var$D("toggle", a);
                                e = d;
                                break;
                            case "input":
                                $c87427e8b303c517$var$Za(a, d);
                                e = $c87427e8b303c517$var$Ya(a, d);
                                $c87427e8b303c517$var$D("invalid", a);
                                break;
                            case "option":
                                e = d;
                                break;
                            case "select":
                                a._wrapperState = {
                                    wasMultiple: !!d.multiple
                                };
                                e = $c87427e8b303c517$var$A({}, d, {
                                    value: void 0
                                });
                                $c87427e8b303c517$var$D("invalid", a);
                                break;
                            case "textarea":
                                $c87427e8b303c517$var$hb(a, d);
                                e = $c87427e8b303c517$var$gb(a, d);
                                $c87427e8b303c517$var$D("invalid", a);
                                break;
                            default:
                                e = d;
                        }
                        $c87427e8b303c517$var$ub(c, e);
                        h = e;
                        for(f in h)if (h.hasOwnProperty(f)) {
                            var k = h[f];
                            "style" === f ? $c87427e8b303c517$var$sb(a, k) : "dangerouslySetInnerHTML" === f ? (k = k ? k.__html : void 0, null != k && $c87427e8b303c517$var$nb(a, k)) : "children" === f ? "string" === typeof k ? ("textarea" !== c || "" !== k) && $c87427e8b303c517$var$ob(a, k) : "number" === typeof k && $c87427e8b303c517$var$ob(a, "" + k) : "suppressContentEditableWarning" !== f && "suppressHydrationWarning" !== f && "autoFocus" !== f && ($c87427e8b303c517$var$ea.hasOwnProperty(f) ? null != k && "onScroll" === f && $c87427e8b303c517$var$D("scroll", a) : null != k && $c87427e8b303c517$var$ta(a, f, k, g));
                        }
                        switch(c){
                            case "input":
                                $c87427e8b303c517$var$Va(a);
                                $c87427e8b303c517$var$db(a, d, !1);
                                break;
                            case "textarea":
                                $c87427e8b303c517$var$Va(a);
                                $c87427e8b303c517$var$jb(a);
                                break;
                            case "option":
                                null != d.value && a.setAttribute("value", "" + $c87427e8b303c517$var$Sa(d.value));
                                break;
                            case "select":
                                a.multiple = !!d.multiple;
                                f = d.value;
                                null != f ? $c87427e8b303c517$var$fb(a, !!d.multiple, f, !1) : null != d.defaultValue && $c87427e8b303c517$var$fb(a, !!d.multiple, d.defaultValue, !0);
                                break;
                            default:
                                "function" === typeof e.onClick && (a.onclick = $c87427e8b303c517$var$Bf);
                        }
                        switch(c){
                            case "button":
                            case "input":
                            case "select":
                            case "textarea":
                                d = !!d.autoFocus;
                                break a;
                            case "img":
                                d = !0;
                                break a;
                            default:
                                d = !1;
                        }
                    }
                    d && (b.flags |= 4);
                }
                null !== b.ref && (b.flags |= 512, b.flags |= 2097152);
            }
            $c87427e8b303c517$var$S(b);
            return null;
        case 6:
            if (a && null != b.stateNode) $c87427e8b303c517$var$Cj(a, b, a.memoizedProps, d);
            else {
                if ("string" !== typeof d && null === b.stateNode) throw Error($c87427e8b303c517$var$p(166));
                c = $c87427e8b303c517$var$xh($c87427e8b303c517$var$wh.current);
                $c87427e8b303c517$var$xh($c87427e8b303c517$var$uh.current);
                if ($c87427e8b303c517$var$Gg(b)) {
                    d = b.stateNode;
                    c = b.memoizedProps;
                    d[$c87427e8b303c517$var$Of] = b;
                    if (f = d.nodeValue !== c) {
                        if (a = $c87427e8b303c517$var$xg, null !== a) switch(a.tag){
                            case 3:
                                $c87427e8b303c517$var$Af(d.nodeValue, c, 0 !== (a.mode & 1));
                                break;
                            case 5:
                                !0 !== a.memoizedProps.suppressHydrationWarning && $c87427e8b303c517$var$Af(d.nodeValue, c, 0 !== (a.mode & 1));
                        }
                    }
                    f && (b.flags |= 4);
                } else d = (9 === c.nodeType ? c : c.ownerDocument).createTextNode(d), d[$c87427e8b303c517$var$Of] = b, b.stateNode = d;
            }
            $c87427e8b303c517$var$S(b);
            return null;
        case 13:
            $c87427e8b303c517$var$E($c87427e8b303c517$var$L);
            d = b.memoizedState;
            if (null === a || null !== a.memoizedState && null !== a.memoizedState.dehydrated) {
                if ($c87427e8b303c517$var$I && null !== $c87427e8b303c517$var$yg && 0 !== (b.mode & 1) && 0 === (b.flags & 128)) $c87427e8b303c517$var$Hg(), $c87427e8b303c517$var$Ig(), b.flags |= 98560, f = !1;
                else if (f = $c87427e8b303c517$var$Gg(b), null !== d && null !== d.dehydrated) {
                    if (null === a) {
                        if (!f) throw Error($c87427e8b303c517$var$p(318));
                        f = b.memoizedState;
                        f = null !== f ? f.dehydrated : null;
                        if (!f) throw Error($c87427e8b303c517$var$p(317));
                        f[$c87427e8b303c517$var$Of] = b;
                    } else $c87427e8b303c517$var$Ig(), 0 === (b.flags & 128) && (b.memoizedState = null), b.flags |= 4;
                    $c87427e8b303c517$var$S(b);
                    f = !1;
                } else null !== $c87427e8b303c517$var$zg && ($c87427e8b303c517$var$Fj($c87427e8b303c517$var$zg), $c87427e8b303c517$var$zg = null), f = !0;
                if (!f) return b.flags & 65536 ? b : null;
            }
            if (0 !== (b.flags & 128)) return b.lanes = c, b;
            d = null !== d;
            d !== (null !== a && null !== a.memoizedState) && d && (b.child.flags |= 8192, 0 !== (b.mode & 1) && (null === a || 0 !== ($c87427e8b303c517$var$L.current & 1) ? 0 === $c87427e8b303c517$var$T && ($c87427e8b303c517$var$T = 3) : $c87427e8b303c517$var$tj()));
            null !== b.updateQueue && (b.flags |= 4);
            $c87427e8b303c517$var$S(b);
            return null;
        case 4:
            return $c87427e8b303c517$var$zh(), $c87427e8b303c517$var$Aj(a, b), null === a && $c87427e8b303c517$var$sf(b.stateNode.containerInfo), $c87427e8b303c517$var$S(b), null;
        case 10:
            return $c87427e8b303c517$var$ah(b.type._context), $c87427e8b303c517$var$S(b), null;
        case 17:
            return $c87427e8b303c517$var$Zf(b.type) && $c87427e8b303c517$var$$f(), $c87427e8b303c517$var$S(b), null;
        case 19:
            $c87427e8b303c517$var$E($c87427e8b303c517$var$L);
            f = b.memoizedState;
            if (null === f) return $c87427e8b303c517$var$S(b), null;
            d = 0 !== (b.flags & 128);
            g = f.rendering;
            if (null === g) {
                if (d) $c87427e8b303c517$var$Dj(f, !1);
                else {
                    if (0 !== $c87427e8b303c517$var$T || null !== a && 0 !== (a.flags & 128)) for(a = b.child; null !== a;){
                        g = $c87427e8b303c517$var$Ch(a);
                        if (null !== g) {
                            b.flags |= 128;
                            $c87427e8b303c517$var$Dj(f, !1);
                            d = g.updateQueue;
                            null !== d && (b.updateQueue = d, b.flags |= 4);
                            b.subtreeFlags = 0;
                            d = c;
                            for(c = b.child; null !== c;)f = c, a = d, f.flags &= 14680066, g = f.alternate, null === g ? (f.childLanes = 0, f.lanes = a, f.child = null, f.subtreeFlags = 0, f.memoizedProps = null, f.memoizedState = null, f.updateQueue = null, f.dependencies = null, f.stateNode = null) : (f.childLanes = g.childLanes, f.lanes = g.lanes, f.child = g.child, f.subtreeFlags = 0, f.deletions = null, f.memoizedProps = g.memoizedProps, f.memoizedState = g.memoizedState, f.updateQueue = g.updateQueue, f.type = g.type, a = g.dependencies, f.dependencies = null === a ? null : {
                                lanes: a.lanes,
                                firstContext: a.firstContext
                            }), c = c.sibling;
                            $c87427e8b303c517$var$G($c87427e8b303c517$var$L, $c87427e8b303c517$var$L.current & 1 | 2);
                            return b.child;
                        }
                        a = a.sibling;
                    }
                    null !== f.tail && $c87427e8b303c517$var$B() > $c87427e8b303c517$var$Gj && (b.flags |= 128, d = !0, $c87427e8b303c517$var$Dj(f, !1), b.lanes = 4194304);
                }
            } else {
                if (!d) {
                    if (a = $c87427e8b303c517$var$Ch(g), null !== a) {
                        if (b.flags |= 128, d = !0, c = a.updateQueue, null !== c && (b.updateQueue = c, b.flags |= 4), $c87427e8b303c517$var$Dj(f, !0), null === f.tail && "hidden" === f.tailMode && !g.alternate && !$c87427e8b303c517$var$I) return $c87427e8b303c517$var$S(b), null;
                    } else 2 * $c87427e8b303c517$var$B() - f.renderingStartTime > $c87427e8b303c517$var$Gj && 1073741824 !== c && (b.flags |= 128, d = !0, $c87427e8b303c517$var$Dj(f, !1), b.lanes = 4194304);
                }
                f.isBackwards ? (g.sibling = b.child, b.child = g) : (c = f.last, null !== c ? c.sibling = g : b.child = g, f.last = g);
            }
            if (null !== f.tail) return b = f.tail, f.rendering = b, f.tail = b.sibling, f.renderingStartTime = $c87427e8b303c517$var$B(), b.sibling = null, c = $c87427e8b303c517$var$L.current, $c87427e8b303c517$var$G($c87427e8b303c517$var$L, d ? c & 1 | 2 : c & 1), b;
            $c87427e8b303c517$var$S(b);
            return null;
        case 22:
        case 23:
            return $c87427e8b303c517$var$Hj(), d = null !== b.memoizedState, null !== a && null !== a.memoizedState !== d && (b.flags |= 8192), d && 0 !== (b.mode & 1) ? 0 !== ($c87427e8b303c517$var$fj & 1073741824) && ($c87427e8b303c517$var$S(b), b.subtreeFlags & 6 && (b.flags |= 8192)) : $c87427e8b303c517$var$S(b), null;
        case 24:
            return null;
        case 25:
            return null;
    }
    throw Error($c87427e8b303c517$var$p(156, b.tag));
}
function $c87427e8b303c517$var$Ij(a, b) {
    $c87427e8b303c517$var$wg(b);
    switch(b.tag){
        case 1:
            return $c87427e8b303c517$var$Zf(b.type) && $c87427e8b303c517$var$$f(), a = b.flags, a & 65536 ? (b.flags = a & -65537 | 128, b) : null;
        case 3:
            return $c87427e8b303c517$var$zh(), $c87427e8b303c517$var$E($c87427e8b303c517$var$Wf), $c87427e8b303c517$var$E($c87427e8b303c517$var$H), $c87427e8b303c517$var$Eh(), a = b.flags, 0 !== (a & 65536) && 0 === (a & 128) ? (b.flags = a & -65537 | 128, b) : null;
        case 5:
            return $c87427e8b303c517$var$Bh(b), null;
        case 13:
            $c87427e8b303c517$var$E($c87427e8b303c517$var$L);
            a = b.memoizedState;
            if (null !== a && null !== a.dehydrated) {
                if (null === b.alternate) throw Error($c87427e8b303c517$var$p(340));
                $c87427e8b303c517$var$Ig();
            }
            a = b.flags;
            return a & 65536 ? (b.flags = a & -65537 | 128, b) : null;
        case 19:
            return $c87427e8b303c517$var$E($c87427e8b303c517$var$L), null;
        case 4:
            return $c87427e8b303c517$var$zh(), null;
        case 10:
            return $c87427e8b303c517$var$ah(b.type._context), null;
        case 22:
        case 23:
            return $c87427e8b303c517$var$Hj(), null;
        case 24:
            return null;
        default:
            return null;
    }
}
var $c87427e8b303c517$var$Jj = !1, $c87427e8b303c517$var$U = !1, $c87427e8b303c517$var$Kj = "function" === typeof WeakSet ? WeakSet : Set, $c87427e8b303c517$var$V = null;
function $c87427e8b303c517$var$Lj(a, b) {
    var c = a.ref;
    if (null !== c) {
        if ("function" === typeof c) try {
            c(null);
        } catch (d) {
            $c87427e8b303c517$var$W(a, b, d);
        }
        else c.current = null;
    }
}
function $c87427e8b303c517$var$Mj(a, b, c) {
    try {
        c();
    } catch (d) {
        $c87427e8b303c517$var$W(a, b, d);
    }
}
var $c87427e8b303c517$var$Nj = !1;
function $c87427e8b303c517$var$Oj(a, b) {
    $c87427e8b303c517$var$Cf = $c87427e8b303c517$var$dd;
    a = $c87427e8b303c517$var$Me();
    if ($c87427e8b303c517$var$Ne(a)) {
        if ("selectionStart" in a) var c = {
            start: a.selectionStart,
            end: a.selectionEnd
        };
        else a: {
            c = (c = a.ownerDocument) && c.defaultView || window;
            var d = c.getSelection && c.getSelection();
            if (d && 0 !== d.rangeCount) {
                c = d.anchorNode;
                var e = d.anchorOffset, f = d.focusNode;
                d = d.focusOffset;
                try {
                    c.nodeType, f.nodeType;
                } catch (F) {
                    c = null;
                    break a;
                }
                var g = 0, h = -1, k = -1, l = 0, m = 0, q = a, r = null;
                b: for(;;){
                    for(var y;;){
                        q !== c || 0 !== e && 3 !== q.nodeType || (h = g + e);
                        q !== f || 0 !== d && 3 !== q.nodeType || (k = g + d);
                        3 === q.nodeType && (g += q.nodeValue.length);
                        if (null === (y = q.firstChild)) break;
                        r = q;
                        q = y;
                    }
                    for(;;){
                        if (q === a) break b;
                        r === c && ++l === e && (h = g);
                        r === f && ++m === d && (k = g);
                        if (null !== (y = q.nextSibling)) break;
                        q = r;
                        r = q.parentNode;
                    }
                    q = y;
                }
                c = -1 === h || -1 === k ? null : {
                    start: h,
                    end: k
                };
            } else c = null;
        }
        c = c || {
            start: 0,
            end: 0
        };
    } else c = null;
    $c87427e8b303c517$var$Df = {
        focusedElem: a,
        selectionRange: c
    };
    $c87427e8b303c517$var$dd = !1;
    for($c87427e8b303c517$var$V = b; null !== $c87427e8b303c517$var$V;)if (b = $c87427e8b303c517$var$V, a = b.child, 0 !== (b.subtreeFlags & 1028) && null !== a) a.return = b, $c87427e8b303c517$var$V = a;
    else for(; null !== $c87427e8b303c517$var$V;){
        b = $c87427e8b303c517$var$V;
        try {
            var n = b.alternate;
            if (0 !== (b.flags & 1024)) switch(b.tag){
                case 0:
                case 11:
                case 15:
                    break;
                case 1:
                    if (null !== n) {
                        var t = n.memoizedProps, J = n.memoizedState, x = b.stateNode, w = x.getSnapshotBeforeUpdate(b.elementType === b.type ? t : $c87427e8b303c517$var$Ci(b.type, t), J);
                        x.__reactInternalSnapshotBeforeUpdate = w;
                    }
                    break;
                case 3:
                    var u = b.stateNode.containerInfo;
                    1 === u.nodeType ? u.textContent = "" : 9 === u.nodeType && u.documentElement && u.removeChild(u.documentElement);
                    break;
                case 5:
                case 6:
                case 4:
                case 17:
                    break;
                default:
                    throw Error($c87427e8b303c517$var$p(163));
            }
        } catch (F) {
            $c87427e8b303c517$var$W(b, b.return, F);
        }
        a = b.sibling;
        if (null !== a) {
            a.return = b.return;
            $c87427e8b303c517$var$V = a;
            break;
        }
        $c87427e8b303c517$var$V = b.return;
    }
    n = $c87427e8b303c517$var$Nj;
    $c87427e8b303c517$var$Nj = !1;
    return n;
}
function $c87427e8b303c517$var$Pj(a, b, c) {
    var d = b.updateQueue;
    d = null !== d ? d.lastEffect : null;
    if (null !== d) {
        var e = d = d.next;
        do {
            if ((e.tag & a) === a) {
                var f = e.destroy;
                e.destroy = void 0;
                void 0 !== f && $c87427e8b303c517$var$Mj(b, c, f);
            }
            e = e.next;
        }while (e !== d);
    }
}
function $c87427e8b303c517$var$Qj(a, b) {
    b = b.updateQueue;
    b = null !== b ? b.lastEffect : null;
    if (null !== b) {
        var c = b = b.next;
        do {
            if ((c.tag & a) === a) {
                var d = c.create;
                c.destroy = d();
            }
            c = c.next;
        }while (c !== b);
    }
}
function $c87427e8b303c517$var$Rj(a) {
    var b = a.ref;
    if (null !== b) {
        var c = a.stateNode;
        switch(a.tag){
            case 5:
                a = c;
                break;
            default:
                a = c;
        }
        "function" === typeof b ? b(a) : b.current = a;
    }
}
function $c87427e8b303c517$var$Sj(a) {
    var b = a.alternate;
    null !== b && (a.alternate = null, $c87427e8b303c517$var$Sj(b));
    a.child = null;
    a.deletions = null;
    a.sibling = null;
    5 === a.tag && (b = a.stateNode, null !== b && (delete b[$c87427e8b303c517$var$Of], delete b[$c87427e8b303c517$var$Pf], delete b[$c87427e8b303c517$var$of], delete b[$c87427e8b303c517$var$Qf], delete b[$c87427e8b303c517$var$Rf]));
    a.stateNode = null;
    a.return = null;
    a.dependencies = null;
    a.memoizedProps = null;
    a.memoizedState = null;
    a.pendingProps = null;
    a.stateNode = null;
    a.updateQueue = null;
}
function $c87427e8b303c517$var$Tj(a) {
    return 5 === a.tag || 3 === a.tag || 4 === a.tag;
}
function $c87427e8b303c517$var$Uj(a) {
    a: for(;;){
        for(; null === a.sibling;){
            if (null === a.return || $c87427e8b303c517$var$Tj(a.return)) return null;
            a = a.return;
        }
        a.sibling.return = a.return;
        for(a = a.sibling; 5 !== a.tag && 6 !== a.tag && 18 !== a.tag;){
            if (a.flags & 2) continue a;
            if (null === a.child || 4 === a.tag) continue a;
            else a.child.return = a, a = a.child;
        }
        if (!(a.flags & 2)) return a.stateNode;
    }
}
function $c87427e8b303c517$var$Vj(a, b, c) {
    var d = a.tag;
    if (5 === d || 6 === d) a = a.stateNode, b ? 8 === c.nodeType ? c.parentNode.insertBefore(a, b) : c.insertBefore(a, b) : (8 === c.nodeType ? (b = c.parentNode, b.insertBefore(a, c)) : (b = c, b.appendChild(a)), c = c._reactRootContainer, null !== c && void 0 !== c || null !== b.onclick || (b.onclick = $c87427e8b303c517$var$Bf));
    else if (4 !== d && (a = a.child, null !== a)) for($c87427e8b303c517$var$Vj(a, b, c), a = a.sibling; null !== a;)$c87427e8b303c517$var$Vj(a, b, c), a = a.sibling;
}
function $c87427e8b303c517$var$Wj(a, b, c) {
    var d = a.tag;
    if (5 === d || 6 === d) a = a.stateNode, b ? c.insertBefore(a, b) : c.appendChild(a);
    else if (4 !== d && (a = a.child, null !== a)) for($c87427e8b303c517$var$Wj(a, b, c), a = a.sibling; null !== a;)$c87427e8b303c517$var$Wj(a, b, c), a = a.sibling;
}
var $c87427e8b303c517$var$X = null, $c87427e8b303c517$var$Xj = !1;
function $c87427e8b303c517$var$Yj(a, b, c) {
    for(c = c.child; null !== c;)$c87427e8b303c517$var$Zj(a, b, c), c = c.sibling;
}
function $c87427e8b303c517$var$Zj(a, b, c) {
    if ($c87427e8b303c517$var$lc && "function" === typeof $c87427e8b303c517$var$lc.onCommitFiberUnmount) try {
        $c87427e8b303c517$var$lc.onCommitFiberUnmount($c87427e8b303c517$var$kc, c);
    } catch (h) {}
    switch(c.tag){
        case 5:
            $c87427e8b303c517$var$U || $c87427e8b303c517$var$Lj(c, b);
        case 6:
            var d = $c87427e8b303c517$var$X, e = $c87427e8b303c517$var$Xj;
            $c87427e8b303c517$var$X = null;
            $c87427e8b303c517$var$Yj(a, b, c);
            $c87427e8b303c517$var$X = d;
            $c87427e8b303c517$var$Xj = e;
            null !== $c87427e8b303c517$var$X && ($c87427e8b303c517$var$Xj ? (a = $c87427e8b303c517$var$X, c = c.stateNode, 8 === a.nodeType ? a.parentNode.removeChild(c) : a.removeChild(c)) : $c87427e8b303c517$var$X.removeChild(c.stateNode));
            break;
        case 18:
            null !== $c87427e8b303c517$var$X && ($c87427e8b303c517$var$Xj ? (a = $c87427e8b303c517$var$X, c = c.stateNode, 8 === a.nodeType ? $c87427e8b303c517$var$Kf(a.parentNode, c) : 1 === a.nodeType && $c87427e8b303c517$var$Kf(a, c), $c87427e8b303c517$var$bd(a)) : $c87427e8b303c517$var$Kf($c87427e8b303c517$var$X, c.stateNode));
            break;
        case 4:
            d = $c87427e8b303c517$var$X;
            e = $c87427e8b303c517$var$Xj;
            $c87427e8b303c517$var$X = c.stateNode.containerInfo;
            $c87427e8b303c517$var$Xj = !0;
            $c87427e8b303c517$var$Yj(a, b, c);
            $c87427e8b303c517$var$X = d;
            $c87427e8b303c517$var$Xj = e;
            break;
        case 0:
        case 11:
        case 14:
        case 15:
            if (!$c87427e8b303c517$var$U && (d = c.updateQueue, null !== d && (d = d.lastEffect, null !== d))) {
                e = d = d.next;
                do {
                    var f = e, g = f.destroy;
                    f = f.tag;
                    void 0 !== g && (0 !== (f & 2) ? $c87427e8b303c517$var$Mj(c, b, g) : 0 !== (f & 4) && $c87427e8b303c517$var$Mj(c, b, g));
                    e = e.next;
                }while (e !== d);
            }
            $c87427e8b303c517$var$Yj(a, b, c);
            break;
        case 1:
            if (!$c87427e8b303c517$var$U && ($c87427e8b303c517$var$Lj(c, b), d = c.stateNode, "function" === typeof d.componentWillUnmount)) try {
                d.props = c.memoizedProps, d.state = c.memoizedState, d.componentWillUnmount();
            } catch (h) {
                $c87427e8b303c517$var$W(c, b, h);
            }
            $c87427e8b303c517$var$Yj(a, b, c);
            break;
        case 21:
            $c87427e8b303c517$var$Yj(a, b, c);
            break;
        case 22:
            c.mode & 1 ? ($c87427e8b303c517$var$U = (d = $c87427e8b303c517$var$U) || null !== c.memoizedState, $c87427e8b303c517$var$Yj(a, b, c), $c87427e8b303c517$var$U = d) : $c87427e8b303c517$var$Yj(a, b, c);
            break;
        default:
            $c87427e8b303c517$var$Yj(a, b, c);
    }
}
function $c87427e8b303c517$var$ak(a) {
    var b = a.updateQueue;
    if (null !== b) {
        a.updateQueue = null;
        var c = a.stateNode;
        null === c && (c = a.stateNode = new $c87427e8b303c517$var$Kj);
        b.forEach(function(b) {
            var d = $c87427e8b303c517$var$bk.bind(null, a, b);
            c.has(b) || (c.add(b), b.then(d, d));
        });
    }
}
function $c87427e8b303c517$var$ck(a, b) {
    var c = b.deletions;
    if (null !== c) for(var d = 0; d < c.length; d++){
        var e = c[d];
        try {
            var f = a, g = b, h = g;
            a: for(; null !== h;){
                switch(h.tag){
                    case 5:
                        $c87427e8b303c517$var$X = h.stateNode;
                        $c87427e8b303c517$var$Xj = !1;
                        break a;
                    case 3:
                        $c87427e8b303c517$var$X = h.stateNode.containerInfo;
                        $c87427e8b303c517$var$Xj = !0;
                        break a;
                    case 4:
                        $c87427e8b303c517$var$X = h.stateNode.containerInfo;
                        $c87427e8b303c517$var$Xj = !0;
                        break a;
                }
                h = h.return;
            }
            if (null === $c87427e8b303c517$var$X) throw Error($c87427e8b303c517$var$p(160));
            $c87427e8b303c517$var$Zj(f, g, e);
            $c87427e8b303c517$var$X = null;
            $c87427e8b303c517$var$Xj = !1;
            var k = e.alternate;
            null !== k && (k.return = null);
            e.return = null;
        } catch (l) {
            $c87427e8b303c517$var$W(e, b, l);
        }
    }
    if (b.subtreeFlags & 12854) for(b = b.child; null !== b;)$c87427e8b303c517$var$dk(b, a), b = b.sibling;
}
function $c87427e8b303c517$var$dk(a, b) {
    var c = a.alternate, d = a.flags;
    switch(a.tag){
        case 0:
        case 11:
        case 14:
        case 15:
            $c87427e8b303c517$var$ck(b, a);
            $c87427e8b303c517$var$ek(a);
            if (d & 4) {
                try {
                    $c87427e8b303c517$var$Pj(3, a, a.return), $c87427e8b303c517$var$Qj(3, a);
                } catch (t) {
                    $c87427e8b303c517$var$W(a, a.return, t);
                }
                try {
                    $c87427e8b303c517$var$Pj(5, a, a.return);
                } catch (t) {
                    $c87427e8b303c517$var$W(a, a.return, t);
                }
            }
            break;
        case 1:
            $c87427e8b303c517$var$ck(b, a);
            $c87427e8b303c517$var$ek(a);
            d & 512 && null !== c && $c87427e8b303c517$var$Lj(c, c.return);
            break;
        case 5:
            $c87427e8b303c517$var$ck(b, a);
            $c87427e8b303c517$var$ek(a);
            d & 512 && null !== c && $c87427e8b303c517$var$Lj(c, c.return);
            if (a.flags & 32) {
                var e = a.stateNode;
                try {
                    $c87427e8b303c517$var$ob(e, "");
                } catch (t) {
                    $c87427e8b303c517$var$W(a, a.return, t);
                }
            }
            if (d & 4 && (e = a.stateNode, null != e)) {
                var f = a.memoizedProps, g = null !== c ? c.memoizedProps : f, h = a.type, k = a.updateQueue;
                a.updateQueue = null;
                if (null !== k) try {
                    "input" === h && "radio" === f.type && null != f.name && $c87427e8b303c517$var$ab(e, f);
                    $c87427e8b303c517$var$vb(h, g);
                    var l = $c87427e8b303c517$var$vb(h, f);
                    for(g = 0; g < k.length; g += 2){
                        var m = k[g], q = k[g + 1];
                        "style" === m ? $c87427e8b303c517$var$sb(e, q) : "dangerouslySetInnerHTML" === m ? $c87427e8b303c517$var$nb(e, q) : "children" === m ? $c87427e8b303c517$var$ob(e, q) : $c87427e8b303c517$var$ta(e, m, q, l);
                    }
                    switch(h){
                        case "input":
                            $c87427e8b303c517$var$bb(e, f);
                            break;
                        case "textarea":
                            $c87427e8b303c517$var$ib(e, f);
                            break;
                        case "select":
                            var r = e._wrapperState.wasMultiple;
                            e._wrapperState.wasMultiple = !!f.multiple;
                            var y = f.value;
                            null != y ? $c87427e8b303c517$var$fb(e, !!f.multiple, y, !1) : r !== !!f.multiple && (null != f.defaultValue ? $c87427e8b303c517$var$fb(e, !!f.multiple, f.defaultValue, !0) : $c87427e8b303c517$var$fb(e, !!f.multiple, f.multiple ? [] : "", !1));
                    }
                    e[$c87427e8b303c517$var$Pf] = f;
                } catch (t) {
                    $c87427e8b303c517$var$W(a, a.return, t);
                }
            }
            break;
        case 6:
            $c87427e8b303c517$var$ck(b, a);
            $c87427e8b303c517$var$ek(a);
            if (d & 4) {
                if (null === a.stateNode) throw Error($c87427e8b303c517$var$p(162));
                e = a.stateNode;
                f = a.memoizedProps;
                try {
                    e.nodeValue = f;
                } catch (t) {
                    $c87427e8b303c517$var$W(a, a.return, t);
                }
            }
            break;
        case 3:
            $c87427e8b303c517$var$ck(b, a);
            $c87427e8b303c517$var$ek(a);
            if (d & 4 && null !== c && c.memoizedState.isDehydrated) try {
                $c87427e8b303c517$var$bd(b.containerInfo);
            } catch (t) {
                $c87427e8b303c517$var$W(a, a.return, t);
            }
            break;
        case 4:
            $c87427e8b303c517$var$ck(b, a);
            $c87427e8b303c517$var$ek(a);
            break;
        case 13:
            $c87427e8b303c517$var$ck(b, a);
            $c87427e8b303c517$var$ek(a);
            e = a.child;
            e.flags & 8192 && (f = null !== e.memoizedState, e.stateNode.isHidden = f, !f || null !== e.alternate && null !== e.alternate.memoizedState || ($c87427e8b303c517$var$fk = $c87427e8b303c517$var$B()));
            d & 4 && $c87427e8b303c517$var$ak(a);
            break;
        case 22:
            m = null !== c && null !== c.memoizedState;
            a.mode & 1 ? ($c87427e8b303c517$var$U = (l = $c87427e8b303c517$var$U) || m, $c87427e8b303c517$var$ck(b, a), $c87427e8b303c517$var$U = l) : $c87427e8b303c517$var$ck(b, a);
            $c87427e8b303c517$var$ek(a);
            if (d & 8192) {
                l = null !== a.memoizedState;
                if ((a.stateNode.isHidden = l) && !m && 0 !== (a.mode & 1)) for($c87427e8b303c517$var$V = a, m = a.child; null !== m;){
                    for(q = $c87427e8b303c517$var$V = m; null !== $c87427e8b303c517$var$V;){
                        r = $c87427e8b303c517$var$V;
                        y = r.child;
                        switch(r.tag){
                            case 0:
                            case 11:
                            case 14:
                            case 15:
                                $c87427e8b303c517$var$Pj(4, r, r.return);
                                break;
                            case 1:
                                $c87427e8b303c517$var$Lj(r, r.return);
                                var n = r.stateNode;
                                if ("function" === typeof n.componentWillUnmount) {
                                    d = r;
                                    c = r.return;
                                    try {
                                        b = d, n.props = b.memoizedProps, n.state = b.memoizedState, n.componentWillUnmount();
                                    } catch (t) {
                                        $c87427e8b303c517$var$W(d, c, t);
                                    }
                                }
                                break;
                            case 5:
                                $c87427e8b303c517$var$Lj(r, r.return);
                                break;
                            case 22:
                                if (null !== r.memoizedState) {
                                    $c87427e8b303c517$var$gk(q);
                                    continue;
                                }
                        }
                        null !== y ? (y.return = r, $c87427e8b303c517$var$V = y) : $c87427e8b303c517$var$gk(q);
                    }
                    m = m.sibling;
                }
                a: for(m = null, q = a;;){
                    if (5 === q.tag) {
                        if (null === m) {
                            m = q;
                            try {
                                e = q.stateNode, l ? (f = e.style, "function" === typeof f.setProperty ? f.setProperty("display", "none", "important") : f.display = "none") : (h = q.stateNode, k = q.memoizedProps.style, g = void 0 !== k && null !== k && k.hasOwnProperty("display") ? k.display : null, h.style.display = $c87427e8b303c517$var$rb("display", g));
                            } catch (t) {
                                $c87427e8b303c517$var$W(a, a.return, t);
                            }
                        }
                    } else if (6 === q.tag) {
                        if (null === m) try {
                            q.stateNode.nodeValue = l ? "" : q.memoizedProps;
                        } catch (t) {
                            $c87427e8b303c517$var$W(a, a.return, t);
                        }
                    } else if ((22 !== q.tag && 23 !== q.tag || null === q.memoizedState || q === a) && null !== q.child) {
                        q.child.return = q;
                        q = q.child;
                        continue;
                    }
                    if (q === a) break a;
                    for(; null === q.sibling;){
                        if (null === q.return || q.return === a) break a;
                        m === q && (m = null);
                        q = q.return;
                    }
                    m === q && (m = null);
                    q.sibling.return = q.return;
                    q = q.sibling;
                }
            }
            break;
        case 19:
            $c87427e8b303c517$var$ck(b, a);
            $c87427e8b303c517$var$ek(a);
            d & 4 && $c87427e8b303c517$var$ak(a);
            break;
        case 21:
            break;
        default:
            $c87427e8b303c517$var$ck(b, a), $c87427e8b303c517$var$ek(a);
    }
}
function $c87427e8b303c517$var$ek(a) {
    var b = a.flags;
    if (b & 2) {
        try {
            a: {
                for(var c = a.return; null !== c;){
                    if ($c87427e8b303c517$var$Tj(c)) {
                        var d = c;
                        break a;
                    }
                    c = c.return;
                }
                throw Error($c87427e8b303c517$var$p(160));
            }
            switch(d.tag){
                case 5:
                    var e = d.stateNode;
                    d.flags & 32 && ($c87427e8b303c517$var$ob(e, ""), d.flags &= -33);
                    var f = $c87427e8b303c517$var$Uj(a);
                    $c87427e8b303c517$var$Wj(a, f, e);
                    break;
                case 3:
                case 4:
                    var g = d.stateNode.containerInfo, h = $c87427e8b303c517$var$Uj(a);
                    $c87427e8b303c517$var$Vj(a, h, g);
                    break;
                default:
                    throw Error($c87427e8b303c517$var$p(161));
            }
        } catch (k) {
            $c87427e8b303c517$var$W(a, a.return, k);
        }
        a.flags &= -3;
    }
    b & 4096 && (a.flags &= -4097);
}
function $c87427e8b303c517$var$hk(a, b, c) {
    $c87427e8b303c517$var$V = a;
    $c87427e8b303c517$var$ik(a, b, c);
}
function $c87427e8b303c517$var$ik(a, b, c) {
    for(var d = 0 !== (a.mode & 1); null !== $c87427e8b303c517$var$V;){
        var e = $c87427e8b303c517$var$V, f = e.child;
        if (22 === e.tag && d) {
            var g = null !== e.memoizedState || $c87427e8b303c517$var$Jj;
            if (!g) {
                var h = e.alternate, k = null !== h && null !== h.memoizedState || $c87427e8b303c517$var$U;
                h = $c87427e8b303c517$var$Jj;
                var l = $c87427e8b303c517$var$U;
                $c87427e8b303c517$var$Jj = g;
                if (($c87427e8b303c517$var$U = k) && !l) for($c87427e8b303c517$var$V = e; null !== $c87427e8b303c517$var$V;)g = $c87427e8b303c517$var$V, k = g.child, 22 === g.tag && null !== g.memoizedState ? $c87427e8b303c517$var$jk(e) : null !== k ? (k.return = g, $c87427e8b303c517$var$V = k) : $c87427e8b303c517$var$jk(e);
                for(; null !== f;)$c87427e8b303c517$var$V = f, $c87427e8b303c517$var$ik(f, b, c), f = f.sibling;
                $c87427e8b303c517$var$V = e;
                $c87427e8b303c517$var$Jj = h;
                $c87427e8b303c517$var$U = l;
            }
            $c87427e8b303c517$var$kk(a, b, c);
        } else 0 !== (e.subtreeFlags & 8772) && null !== f ? (f.return = e, $c87427e8b303c517$var$V = f) : $c87427e8b303c517$var$kk(a, b, c);
    }
}
function $c87427e8b303c517$var$kk(a) {
    for(; null !== $c87427e8b303c517$var$V;){
        var b = $c87427e8b303c517$var$V;
        if (0 !== (b.flags & 8772)) {
            var c = b.alternate;
            try {
                if (0 !== (b.flags & 8772)) switch(b.tag){
                    case 0:
                    case 11:
                    case 15:
                        $c87427e8b303c517$var$U || $c87427e8b303c517$var$Qj(5, b);
                        break;
                    case 1:
                        var d = b.stateNode;
                        if (b.flags & 4 && !$c87427e8b303c517$var$U) {
                            if (null === c) d.componentDidMount();
                            else {
                                var e = b.elementType === b.type ? c.memoizedProps : $c87427e8b303c517$var$Ci(b.type, c.memoizedProps);
                                d.componentDidUpdate(e, c.memoizedState, d.__reactInternalSnapshotBeforeUpdate);
                            }
                        }
                        var f = b.updateQueue;
                        null !== f && $c87427e8b303c517$var$sh(b, f, d);
                        break;
                    case 3:
                        var g = b.updateQueue;
                        if (null !== g) {
                            c = null;
                            if (null !== b.child) switch(b.child.tag){
                                case 5:
                                    c = b.child.stateNode;
                                    break;
                                case 1:
                                    c = b.child.stateNode;
                            }
                            $c87427e8b303c517$var$sh(b, g, c);
                        }
                        break;
                    case 5:
                        var h = b.stateNode;
                        if (null === c && b.flags & 4) {
                            c = h;
                            var k = b.memoizedProps;
                            switch(b.type){
                                case "button":
                                case "input":
                                case "select":
                                case "textarea":
                                    k.autoFocus && c.focus();
                                    break;
                                case "img":
                                    k.src && (c.src = k.src);
                            }
                        }
                        break;
                    case 6:
                        break;
                    case 4:
                        break;
                    case 12:
                        break;
                    case 13:
                        if (null === b.memoizedState) {
                            var l = b.alternate;
                            if (null !== l) {
                                var m = l.memoizedState;
                                if (null !== m) {
                                    var q = m.dehydrated;
                                    null !== q && $c87427e8b303c517$var$bd(q);
                                }
                            }
                        }
                        break;
                    case 19:
                    case 17:
                    case 21:
                    case 22:
                    case 23:
                    case 25:
                        break;
                    default:
                        throw Error($c87427e8b303c517$var$p(163));
                }
                $c87427e8b303c517$var$U || b.flags & 512 && $c87427e8b303c517$var$Rj(b);
            } catch (r) {
                $c87427e8b303c517$var$W(b, b.return, r);
            }
        }
        if (b === a) {
            $c87427e8b303c517$var$V = null;
            break;
        }
        c = b.sibling;
        if (null !== c) {
            c.return = b.return;
            $c87427e8b303c517$var$V = c;
            break;
        }
        $c87427e8b303c517$var$V = b.return;
    }
}
function $c87427e8b303c517$var$gk(a) {
    for(; null !== $c87427e8b303c517$var$V;){
        var b = $c87427e8b303c517$var$V;
        if (b === a) {
            $c87427e8b303c517$var$V = null;
            break;
        }
        var c = b.sibling;
        if (null !== c) {
            c.return = b.return;
            $c87427e8b303c517$var$V = c;
            break;
        }
        $c87427e8b303c517$var$V = b.return;
    }
}
function $c87427e8b303c517$var$jk(a) {
    for(; null !== $c87427e8b303c517$var$V;){
        var b = $c87427e8b303c517$var$V;
        try {
            switch(b.tag){
                case 0:
                case 11:
                case 15:
                    var c = b.return;
                    try {
                        $c87427e8b303c517$var$Qj(4, b);
                    } catch (k) {
                        $c87427e8b303c517$var$W(b, c, k);
                    }
                    break;
                case 1:
                    var d = b.stateNode;
                    if ("function" === typeof d.componentDidMount) {
                        var e = b.return;
                        try {
                            d.componentDidMount();
                        } catch (k) {
                            $c87427e8b303c517$var$W(b, e, k);
                        }
                    }
                    var f = b.return;
                    try {
                        $c87427e8b303c517$var$Rj(b);
                    } catch (k) {
                        $c87427e8b303c517$var$W(b, f, k);
                    }
                    break;
                case 5:
                    var g = b.return;
                    try {
                        $c87427e8b303c517$var$Rj(b);
                    } catch (k) {
                        $c87427e8b303c517$var$W(b, g, k);
                    }
            }
        } catch (k) {
            $c87427e8b303c517$var$W(b, b.return, k);
        }
        if (b === a) {
            $c87427e8b303c517$var$V = null;
            break;
        }
        var h = b.sibling;
        if (null !== h) {
            h.return = b.return;
            $c87427e8b303c517$var$V = h;
            break;
        }
        $c87427e8b303c517$var$V = b.return;
    }
}
var $c87427e8b303c517$var$lk = Math.ceil, $c87427e8b303c517$var$mk = $c87427e8b303c517$var$ua.ReactCurrentDispatcher, $c87427e8b303c517$var$nk = $c87427e8b303c517$var$ua.ReactCurrentOwner, $c87427e8b303c517$var$ok = $c87427e8b303c517$var$ua.ReactCurrentBatchConfig, $c87427e8b303c517$var$K = 0, $c87427e8b303c517$var$Q = null, $c87427e8b303c517$var$Y = null, $c87427e8b303c517$var$Z = 0, $c87427e8b303c517$var$fj = 0, $c87427e8b303c517$var$ej = $c87427e8b303c517$var$Uf(0), $c87427e8b303c517$var$T = 0, $c87427e8b303c517$var$pk = null, $c87427e8b303c517$var$rh = 0, $c87427e8b303c517$var$qk = 0, $c87427e8b303c517$var$rk = 0, $c87427e8b303c517$var$sk = null, $c87427e8b303c517$var$tk = null, $c87427e8b303c517$var$fk = 0, $c87427e8b303c517$var$Gj = Infinity, $c87427e8b303c517$var$uk = null, $c87427e8b303c517$var$Oi = !1, $c87427e8b303c517$var$Pi = null, $c87427e8b303c517$var$Ri = null, $c87427e8b303c517$var$vk = !1, $c87427e8b303c517$var$wk = null, $c87427e8b303c517$var$xk = 0, $c87427e8b303c517$var$yk = 0, $c87427e8b303c517$var$zk = null, $c87427e8b303c517$var$Ak = -1, $c87427e8b303c517$var$Bk = 0;
function $c87427e8b303c517$var$R() {
    return 0 !== ($c87427e8b303c517$var$K & 6) ? $c87427e8b303c517$var$B() : -1 !== $c87427e8b303c517$var$Ak ? $c87427e8b303c517$var$Ak : $c87427e8b303c517$var$Ak = $c87427e8b303c517$var$B();
}
function $c87427e8b303c517$var$yi(a) {
    if (0 === (a.mode & 1)) return 1;
    if (0 !== ($c87427e8b303c517$var$K & 2) && 0 !== $c87427e8b303c517$var$Z) return $c87427e8b303c517$var$Z & -$c87427e8b303c517$var$Z;
    if (null !== $c87427e8b303c517$var$Kg.transition) return 0 === $c87427e8b303c517$var$Bk && ($c87427e8b303c517$var$Bk = $c87427e8b303c517$var$yc()), $c87427e8b303c517$var$Bk;
    a = $c87427e8b303c517$var$C;
    if (0 !== a) return a;
    a = window.event;
    a = void 0 === a ? 16 : $c87427e8b303c517$var$jd(a.type);
    return a;
}
function $c87427e8b303c517$var$gi(a, b, c, d) {
    if (50 < $c87427e8b303c517$var$yk) throw $c87427e8b303c517$var$yk = 0, $c87427e8b303c517$var$zk = null, Error($c87427e8b303c517$var$p(185));
    $c87427e8b303c517$var$Ac(a, c, d);
    if (0 === ($c87427e8b303c517$var$K & 2) || a !== $c87427e8b303c517$var$Q) a === $c87427e8b303c517$var$Q && (0 === ($c87427e8b303c517$var$K & 2) && ($c87427e8b303c517$var$qk |= c), 4 === $c87427e8b303c517$var$T && $c87427e8b303c517$var$Ck(a, $c87427e8b303c517$var$Z)), $c87427e8b303c517$var$Dk(a, d), 1 === c && 0 === $c87427e8b303c517$var$K && 0 === (b.mode & 1) && ($c87427e8b303c517$var$Gj = $c87427e8b303c517$var$B() + 500, $c87427e8b303c517$var$fg && $c87427e8b303c517$var$jg());
}
function $c87427e8b303c517$var$Dk(a, b) {
    var c = a.callbackNode;
    $c87427e8b303c517$var$wc(a, b);
    var d = $c87427e8b303c517$var$uc(a, a === $c87427e8b303c517$var$Q ? $c87427e8b303c517$var$Z : 0);
    if (0 === d) null !== c && $c87427e8b303c517$var$bc(c), a.callbackNode = null, a.callbackPriority = 0;
    else if (b = d & -d, a.callbackPriority !== b) {
        null != c && $c87427e8b303c517$var$bc(c);
        if (1 === b) 0 === a.tag ? $c87427e8b303c517$var$ig($c87427e8b303c517$var$Ek.bind(null, a)) : $c87427e8b303c517$var$hg($c87427e8b303c517$var$Ek.bind(null, a)), $c87427e8b303c517$var$Jf(function() {
            0 === ($c87427e8b303c517$var$K & 6) && $c87427e8b303c517$var$jg();
        }), c = null;
        else {
            switch($c87427e8b303c517$var$Dc(d)){
                case 1:
                    c = $c87427e8b303c517$var$fc;
                    break;
                case 4:
                    c = $c87427e8b303c517$var$gc;
                    break;
                case 16:
                    c = $c87427e8b303c517$var$hc;
                    break;
                case 536870912:
                    c = $c87427e8b303c517$var$jc;
                    break;
                default:
                    c = $c87427e8b303c517$var$hc;
            }
            c = $c87427e8b303c517$var$Fk(c, $c87427e8b303c517$var$Gk.bind(null, a));
        }
        a.callbackPriority = b;
        a.callbackNode = c;
    }
}
function $c87427e8b303c517$var$Gk(a, b) {
    $c87427e8b303c517$var$Ak = -1;
    $c87427e8b303c517$var$Bk = 0;
    if (0 !== ($c87427e8b303c517$var$K & 6)) throw Error($c87427e8b303c517$var$p(327));
    var c = a.callbackNode;
    if ($c87427e8b303c517$var$Hk() && a.callbackNode !== c) return null;
    var d = $c87427e8b303c517$var$uc(a, a === $c87427e8b303c517$var$Q ? $c87427e8b303c517$var$Z : 0);
    if (0 === d) return null;
    if (0 !== (d & 30) || 0 !== (d & a.expiredLanes) || b) b = $c87427e8b303c517$var$Ik(a, d);
    else {
        b = d;
        var e = $c87427e8b303c517$var$K;
        $c87427e8b303c517$var$K |= 2;
        var f = $c87427e8b303c517$var$Jk();
        if ($c87427e8b303c517$var$Q !== a || $c87427e8b303c517$var$Z !== b) $c87427e8b303c517$var$uk = null, $c87427e8b303c517$var$Gj = $c87427e8b303c517$var$B() + 500, $c87427e8b303c517$var$Kk(a, b);
        for(;;)try {
            $c87427e8b303c517$var$Lk();
            break;
        } catch (h) {
            $c87427e8b303c517$var$Mk(a, h);
        }
        $c87427e8b303c517$var$$g();
        $c87427e8b303c517$var$mk.current = f;
        $c87427e8b303c517$var$K = e;
        null !== $c87427e8b303c517$var$Y ? b = 0 : ($c87427e8b303c517$var$Q = null, $c87427e8b303c517$var$Z = 0, b = $c87427e8b303c517$var$T);
    }
    if (0 !== b) {
        2 === b && (e = $c87427e8b303c517$var$xc(a), 0 !== e && (d = e, b = $c87427e8b303c517$var$Nk(a, e)));
        if (1 === b) throw c = $c87427e8b303c517$var$pk, $c87427e8b303c517$var$Kk(a, 0), $c87427e8b303c517$var$Ck(a, d), $c87427e8b303c517$var$Dk(a, $c87427e8b303c517$var$B()), c;
        if (6 === b) $c87427e8b303c517$var$Ck(a, d);
        else {
            e = a.current.alternate;
            if (0 === (d & 30) && !$c87427e8b303c517$var$Ok(e) && (b = $c87427e8b303c517$var$Ik(a, d), 2 === b && (f = $c87427e8b303c517$var$xc(a), 0 !== f && (d = f, b = $c87427e8b303c517$var$Nk(a, f))), 1 === b)) throw c = $c87427e8b303c517$var$pk, $c87427e8b303c517$var$Kk(a, 0), $c87427e8b303c517$var$Ck(a, d), $c87427e8b303c517$var$Dk(a, $c87427e8b303c517$var$B()), c;
            a.finishedWork = e;
            a.finishedLanes = d;
            switch(b){
                case 0:
                case 1:
                    throw Error($c87427e8b303c517$var$p(345));
                case 2:
                    $c87427e8b303c517$var$Pk(a, $c87427e8b303c517$var$tk, $c87427e8b303c517$var$uk);
                    break;
                case 3:
                    $c87427e8b303c517$var$Ck(a, d);
                    if ((d & 130023424) === d && (b = $c87427e8b303c517$var$fk + 500 - $c87427e8b303c517$var$B(), 10 < b)) {
                        if (0 !== $c87427e8b303c517$var$uc(a, 0)) break;
                        e = a.suspendedLanes;
                        if ((e & d) !== d) {
                            $c87427e8b303c517$var$R();
                            a.pingedLanes |= a.suspendedLanes & e;
                            break;
                        }
                        a.timeoutHandle = $c87427e8b303c517$var$Ff($c87427e8b303c517$var$Pk.bind(null, a, $c87427e8b303c517$var$tk, $c87427e8b303c517$var$uk), b);
                        break;
                    }
                    $c87427e8b303c517$var$Pk(a, $c87427e8b303c517$var$tk, $c87427e8b303c517$var$uk);
                    break;
                case 4:
                    $c87427e8b303c517$var$Ck(a, d);
                    if ((d & 4194240) === d) break;
                    b = a.eventTimes;
                    for(e = -1; 0 < d;){
                        var g = 31 - $c87427e8b303c517$var$oc(d);
                        f = 1 << g;
                        g = b[g];
                        g > e && (e = g);
                        d &= ~f;
                    }
                    d = e;
                    d = $c87427e8b303c517$var$B() - d;
                    d = (120 > d ? 120 : 480 > d ? 480 : 1080 > d ? 1080 : 1920 > d ? 1920 : 3E3 > d ? 3E3 : 4320 > d ? 4320 : 1960 * $c87427e8b303c517$var$lk(d / 1960)) - d;
                    if (10 < d) {
                        a.timeoutHandle = $c87427e8b303c517$var$Ff($c87427e8b303c517$var$Pk.bind(null, a, $c87427e8b303c517$var$tk, $c87427e8b303c517$var$uk), d);
                        break;
                    }
                    $c87427e8b303c517$var$Pk(a, $c87427e8b303c517$var$tk, $c87427e8b303c517$var$uk);
                    break;
                case 5:
                    $c87427e8b303c517$var$Pk(a, $c87427e8b303c517$var$tk, $c87427e8b303c517$var$uk);
                    break;
                default:
                    throw Error($c87427e8b303c517$var$p(329));
            }
        }
    }
    $c87427e8b303c517$var$Dk(a, $c87427e8b303c517$var$B());
    return a.callbackNode === c ? $c87427e8b303c517$var$Gk.bind(null, a) : null;
}
function $c87427e8b303c517$var$Nk(a, b) {
    var c = $c87427e8b303c517$var$sk;
    a.current.memoizedState.isDehydrated && ($c87427e8b303c517$var$Kk(a, b).flags |= 256);
    a = $c87427e8b303c517$var$Ik(a, b);
    2 !== a && (b = $c87427e8b303c517$var$tk, $c87427e8b303c517$var$tk = c, null !== b && $c87427e8b303c517$var$Fj(b));
    return a;
}
function $c87427e8b303c517$var$Fj(a) {
    null === $c87427e8b303c517$var$tk ? $c87427e8b303c517$var$tk = a : $c87427e8b303c517$var$tk.push.apply($c87427e8b303c517$var$tk, a);
}
function $c87427e8b303c517$var$Ok(a) {
    for(var b = a;;){
        if (b.flags & 16384) {
            var c = b.updateQueue;
            if (null !== c && (c = c.stores, null !== c)) for(var d = 0; d < c.length; d++){
                var e = c[d], f = e.getSnapshot;
                e = e.value;
                try {
                    if (!$c87427e8b303c517$var$He(f(), e)) return !1;
                } catch (g) {
                    return !1;
                }
            }
        }
        c = b.child;
        if (b.subtreeFlags & 16384 && null !== c) c.return = b, b = c;
        else {
            if (b === a) break;
            for(; null === b.sibling;){
                if (null === b.return || b.return === a) return !0;
                b = b.return;
            }
            b.sibling.return = b.return;
            b = b.sibling;
        }
    }
    return !0;
}
function $c87427e8b303c517$var$Ck(a, b) {
    b &= ~$c87427e8b303c517$var$rk;
    b &= ~$c87427e8b303c517$var$qk;
    a.suspendedLanes |= b;
    a.pingedLanes &= ~b;
    for(a = a.expirationTimes; 0 < b;){
        var c = 31 - $c87427e8b303c517$var$oc(b), d = 1 << c;
        a[c] = -1;
        b &= ~d;
    }
}
function $c87427e8b303c517$var$Ek(a) {
    if (0 !== ($c87427e8b303c517$var$K & 6)) throw Error($c87427e8b303c517$var$p(327));
    $c87427e8b303c517$var$Hk();
    var b = $c87427e8b303c517$var$uc(a, 0);
    if (0 === (b & 1)) return $c87427e8b303c517$var$Dk(a, $c87427e8b303c517$var$B()), null;
    var c = $c87427e8b303c517$var$Ik(a, b);
    if (0 !== a.tag && 2 === c) {
        var d = $c87427e8b303c517$var$xc(a);
        0 !== d && (b = d, c = $c87427e8b303c517$var$Nk(a, d));
    }
    if (1 === c) throw c = $c87427e8b303c517$var$pk, $c87427e8b303c517$var$Kk(a, 0), $c87427e8b303c517$var$Ck(a, b), $c87427e8b303c517$var$Dk(a, $c87427e8b303c517$var$B()), c;
    if (6 === c) throw Error($c87427e8b303c517$var$p(345));
    a.finishedWork = a.current.alternate;
    a.finishedLanes = b;
    $c87427e8b303c517$var$Pk(a, $c87427e8b303c517$var$tk, $c87427e8b303c517$var$uk);
    $c87427e8b303c517$var$Dk(a, $c87427e8b303c517$var$B());
    return null;
}
function $c87427e8b303c517$var$Qk(a, b) {
    var c = $c87427e8b303c517$var$K;
    $c87427e8b303c517$var$K |= 1;
    try {
        return a(b);
    } finally{
        $c87427e8b303c517$var$K = c, 0 === $c87427e8b303c517$var$K && ($c87427e8b303c517$var$Gj = $c87427e8b303c517$var$B() + 500, $c87427e8b303c517$var$fg && $c87427e8b303c517$var$jg());
    }
}
function $c87427e8b303c517$var$Rk(a) {
    null !== $c87427e8b303c517$var$wk && 0 === $c87427e8b303c517$var$wk.tag && 0 === ($c87427e8b303c517$var$K & 6) && $c87427e8b303c517$var$Hk();
    var b = $c87427e8b303c517$var$K;
    $c87427e8b303c517$var$K |= 1;
    var c = $c87427e8b303c517$var$ok.transition, d = $c87427e8b303c517$var$C;
    try {
        if ($c87427e8b303c517$var$ok.transition = null, $c87427e8b303c517$var$C = 1, a) return a();
    } finally{
        $c87427e8b303c517$var$C = d, $c87427e8b303c517$var$ok.transition = c, $c87427e8b303c517$var$K = b, 0 === ($c87427e8b303c517$var$K & 6) && $c87427e8b303c517$var$jg();
    }
}
function $c87427e8b303c517$var$Hj() {
    $c87427e8b303c517$var$fj = $c87427e8b303c517$var$ej.current;
    $c87427e8b303c517$var$E($c87427e8b303c517$var$ej);
}
function $c87427e8b303c517$var$Kk(a, b) {
    a.finishedWork = null;
    a.finishedLanes = 0;
    var c = a.timeoutHandle;
    -1 !== c && (a.timeoutHandle = -1, $c87427e8b303c517$var$Gf(c));
    if (null !== $c87427e8b303c517$var$Y) for(c = $c87427e8b303c517$var$Y.return; null !== c;){
        var d = c;
        $c87427e8b303c517$var$wg(d);
        switch(d.tag){
            case 1:
                d = d.type.childContextTypes;
                null !== d && void 0 !== d && $c87427e8b303c517$var$$f();
                break;
            case 3:
                $c87427e8b303c517$var$zh();
                $c87427e8b303c517$var$E($c87427e8b303c517$var$Wf);
                $c87427e8b303c517$var$E($c87427e8b303c517$var$H);
                $c87427e8b303c517$var$Eh();
                break;
            case 5:
                $c87427e8b303c517$var$Bh(d);
                break;
            case 4:
                $c87427e8b303c517$var$zh();
                break;
            case 13:
                $c87427e8b303c517$var$E($c87427e8b303c517$var$L);
                break;
            case 19:
                $c87427e8b303c517$var$E($c87427e8b303c517$var$L);
                break;
            case 10:
                $c87427e8b303c517$var$ah(d.type._context);
                break;
            case 22:
            case 23:
                $c87427e8b303c517$var$Hj();
        }
        c = c.return;
    }
    $c87427e8b303c517$var$Q = a;
    $c87427e8b303c517$var$Y = a = $c87427e8b303c517$var$Pg(a.current, null);
    $c87427e8b303c517$var$Z = $c87427e8b303c517$var$fj = b;
    $c87427e8b303c517$var$T = 0;
    $c87427e8b303c517$var$pk = null;
    $c87427e8b303c517$var$rk = $c87427e8b303c517$var$qk = $c87427e8b303c517$var$rh = 0;
    $c87427e8b303c517$var$tk = $c87427e8b303c517$var$sk = null;
    if (null !== $c87427e8b303c517$var$fh) {
        for(b = 0; b < $c87427e8b303c517$var$fh.length; b++)if (c = $c87427e8b303c517$var$fh[b], d = c.interleaved, null !== d) {
            c.interleaved = null;
            var e = d.next, f = c.pending;
            if (null !== f) {
                var g = f.next;
                f.next = e;
                d.next = g;
            }
            c.pending = d;
        }
        $c87427e8b303c517$var$fh = null;
    }
    return a;
}
function $c87427e8b303c517$var$Mk(a, b) {
    do {
        var c = $c87427e8b303c517$var$Y;
        try {
            $c87427e8b303c517$var$$g();
            $c87427e8b303c517$var$Fh.current = $c87427e8b303c517$var$Rh;
            if ($c87427e8b303c517$var$Ih) {
                for(var d = $c87427e8b303c517$var$M.memoizedState; null !== d;){
                    var e = d.queue;
                    null !== e && (e.pending = null);
                    d = d.next;
                }
                $c87427e8b303c517$var$Ih = !1;
            }
            $c87427e8b303c517$var$Hh = 0;
            $c87427e8b303c517$var$O = $c87427e8b303c517$var$N = $c87427e8b303c517$var$M = null;
            $c87427e8b303c517$var$Jh = !1;
            $c87427e8b303c517$var$Kh = 0;
            $c87427e8b303c517$var$nk.current = null;
            if (null === c || null === c.return) {
                $c87427e8b303c517$var$T = 1;
                $c87427e8b303c517$var$pk = b;
                $c87427e8b303c517$var$Y = null;
                break;
            }
            a: {
                var f = a, g = c.return, h = c, k = b;
                b = $c87427e8b303c517$var$Z;
                h.flags |= 32768;
                if (null !== k && "object" === typeof k && "function" === typeof k.then) {
                    var l = k, m = h, q = m.tag;
                    if (0 === (m.mode & 1) && (0 === q || 11 === q || 15 === q)) {
                        var r = m.alternate;
                        r ? (m.updateQueue = r.updateQueue, m.memoizedState = r.memoizedState, m.lanes = r.lanes) : (m.updateQueue = null, m.memoizedState = null);
                    }
                    var y = $c87427e8b303c517$var$Ui(g);
                    if (null !== y) {
                        y.flags &= -257;
                        $c87427e8b303c517$var$Vi(y, g, h, f, b);
                        y.mode & 1 && $c87427e8b303c517$var$Si(f, l, b);
                        b = y;
                        k = l;
                        var n = b.updateQueue;
                        if (null === n) {
                            var t = new Set;
                            t.add(k);
                            b.updateQueue = t;
                        } else n.add(k);
                        break a;
                    } else {
                        if (0 === (b & 1)) {
                            $c87427e8b303c517$var$Si(f, l, b);
                            $c87427e8b303c517$var$tj();
                            break a;
                        }
                        k = Error($c87427e8b303c517$var$p(426));
                    }
                } else if ($c87427e8b303c517$var$I && h.mode & 1) {
                    var J = $c87427e8b303c517$var$Ui(g);
                    if (null !== J) {
                        0 === (J.flags & 65536) && (J.flags |= 256);
                        $c87427e8b303c517$var$Vi(J, g, h, f, b);
                        $c87427e8b303c517$var$Jg($c87427e8b303c517$var$Ji(k, h));
                        break a;
                    }
                }
                f = k = $c87427e8b303c517$var$Ji(k, h);
                4 !== $c87427e8b303c517$var$T && ($c87427e8b303c517$var$T = 2);
                null === $c87427e8b303c517$var$sk ? $c87427e8b303c517$var$sk = [
                    f
                ] : $c87427e8b303c517$var$sk.push(f);
                f = g;
                do {
                    switch(f.tag){
                        case 3:
                            f.flags |= 65536;
                            b &= -b;
                            f.lanes |= b;
                            var x = $c87427e8b303c517$var$Ni(f, k, b);
                            $c87427e8b303c517$var$ph(f, x);
                            break a;
                        case 1:
                            h = k;
                            var w = f.type, u = f.stateNode;
                            if (0 === (f.flags & 128) && ("function" === typeof w.getDerivedStateFromError || null !== u && "function" === typeof u.componentDidCatch && (null === $c87427e8b303c517$var$Ri || !$c87427e8b303c517$var$Ri.has(u)))) {
                                f.flags |= 65536;
                                b &= -b;
                                f.lanes |= b;
                                var F = $c87427e8b303c517$var$Qi(f, h, b);
                                $c87427e8b303c517$var$ph(f, F);
                                break a;
                            }
                    }
                    f = f.return;
                }while (null !== f);
            }
            $c87427e8b303c517$var$Sk(c);
        } catch (na) {
            b = na;
            $c87427e8b303c517$var$Y === c && null !== c && ($c87427e8b303c517$var$Y = c = c.return);
            continue;
        }
        break;
    }while (1);
}
function $c87427e8b303c517$var$Jk() {
    var a = $c87427e8b303c517$var$mk.current;
    $c87427e8b303c517$var$mk.current = $c87427e8b303c517$var$Rh;
    return null === a ? $c87427e8b303c517$var$Rh : a;
}
function $c87427e8b303c517$var$tj() {
    if (0 === $c87427e8b303c517$var$T || 3 === $c87427e8b303c517$var$T || 2 === $c87427e8b303c517$var$T) $c87427e8b303c517$var$T = 4;
    null === $c87427e8b303c517$var$Q || 0 === ($c87427e8b303c517$var$rh & 268435455) && 0 === ($c87427e8b303c517$var$qk & 268435455) || $c87427e8b303c517$var$Ck($c87427e8b303c517$var$Q, $c87427e8b303c517$var$Z);
}
function $c87427e8b303c517$var$Ik(a, b) {
    var c = $c87427e8b303c517$var$K;
    $c87427e8b303c517$var$K |= 2;
    var d = $c87427e8b303c517$var$Jk();
    if ($c87427e8b303c517$var$Q !== a || $c87427e8b303c517$var$Z !== b) $c87427e8b303c517$var$uk = null, $c87427e8b303c517$var$Kk(a, b);
    for(;;)try {
        $c87427e8b303c517$var$Tk();
        break;
    } catch (e) {
        $c87427e8b303c517$var$Mk(a, e);
    }
    $c87427e8b303c517$var$$g();
    $c87427e8b303c517$var$K = c;
    $c87427e8b303c517$var$mk.current = d;
    if (null !== $c87427e8b303c517$var$Y) throw Error($c87427e8b303c517$var$p(261));
    $c87427e8b303c517$var$Q = null;
    $c87427e8b303c517$var$Z = 0;
    return $c87427e8b303c517$var$T;
}
function $c87427e8b303c517$var$Tk() {
    for(; null !== $c87427e8b303c517$var$Y;)$c87427e8b303c517$var$Uk($c87427e8b303c517$var$Y);
}
function $c87427e8b303c517$var$Lk() {
    for(; null !== $c87427e8b303c517$var$Y && !$c87427e8b303c517$var$cc();)$c87427e8b303c517$var$Uk($c87427e8b303c517$var$Y);
}
function $c87427e8b303c517$var$Uk(a) {
    var b = $c87427e8b303c517$var$Vk(a.alternate, a, $c87427e8b303c517$var$fj);
    a.memoizedProps = a.pendingProps;
    null === b ? $c87427e8b303c517$var$Sk(a) : $c87427e8b303c517$var$Y = b;
    $c87427e8b303c517$var$nk.current = null;
}
function $c87427e8b303c517$var$Sk(a) {
    var b = a;
    do {
        var c = b.alternate;
        a = b.return;
        if (0 === (b.flags & 32768)) {
            if (c = $c87427e8b303c517$var$Ej(c, b, $c87427e8b303c517$var$fj), null !== c) {
                $c87427e8b303c517$var$Y = c;
                return;
            }
        } else {
            c = $c87427e8b303c517$var$Ij(c, b);
            if (null !== c) {
                c.flags &= 32767;
                $c87427e8b303c517$var$Y = c;
                return;
            }
            if (null !== a) a.flags |= 32768, a.subtreeFlags = 0, a.deletions = null;
            else {
                $c87427e8b303c517$var$T = 6;
                $c87427e8b303c517$var$Y = null;
                return;
            }
        }
        b = b.sibling;
        if (null !== b) {
            $c87427e8b303c517$var$Y = b;
            return;
        }
        $c87427e8b303c517$var$Y = b = a;
    }while (null !== b);
    0 === $c87427e8b303c517$var$T && ($c87427e8b303c517$var$T = 5);
}
function $c87427e8b303c517$var$Pk(a, b, c) {
    var d = $c87427e8b303c517$var$C, e = $c87427e8b303c517$var$ok.transition;
    try {
        $c87427e8b303c517$var$ok.transition = null, $c87427e8b303c517$var$C = 1, $c87427e8b303c517$var$Wk(a, b, c, d);
    } finally{
        $c87427e8b303c517$var$ok.transition = e, $c87427e8b303c517$var$C = d;
    }
    return null;
}
function $c87427e8b303c517$var$Wk(a, b, c, d) {
    do $c87427e8b303c517$var$Hk();
    while (null !== $c87427e8b303c517$var$wk);
    if (0 !== ($c87427e8b303c517$var$K & 6)) throw Error($c87427e8b303c517$var$p(327));
    c = a.finishedWork;
    var e = a.finishedLanes;
    if (null === c) return null;
    a.finishedWork = null;
    a.finishedLanes = 0;
    if (c === a.current) throw Error($c87427e8b303c517$var$p(177));
    a.callbackNode = null;
    a.callbackPriority = 0;
    var f = c.lanes | c.childLanes;
    $c87427e8b303c517$var$Bc(a, f);
    a === $c87427e8b303c517$var$Q && ($c87427e8b303c517$var$Y = $c87427e8b303c517$var$Q = null, $c87427e8b303c517$var$Z = 0);
    0 === (c.subtreeFlags & 2064) && 0 === (c.flags & 2064) || $c87427e8b303c517$var$vk || ($c87427e8b303c517$var$vk = !0, $c87427e8b303c517$var$Fk($c87427e8b303c517$var$hc, function() {
        $c87427e8b303c517$var$Hk();
        return null;
    }));
    f = 0 !== (c.flags & 15990);
    if (0 !== (c.subtreeFlags & 15990) || f) {
        f = $c87427e8b303c517$var$ok.transition;
        $c87427e8b303c517$var$ok.transition = null;
        var g = $c87427e8b303c517$var$C;
        $c87427e8b303c517$var$C = 1;
        var h = $c87427e8b303c517$var$K;
        $c87427e8b303c517$var$K |= 4;
        $c87427e8b303c517$var$nk.current = null;
        $c87427e8b303c517$var$Oj(a, c);
        $c87427e8b303c517$var$dk(c, a);
        $c87427e8b303c517$var$Oe($c87427e8b303c517$var$Df);
        $c87427e8b303c517$var$dd = !!$c87427e8b303c517$var$Cf;
        $c87427e8b303c517$var$Df = $c87427e8b303c517$var$Cf = null;
        a.current = c;
        $c87427e8b303c517$var$hk(c, a, e);
        $c87427e8b303c517$var$dc();
        $c87427e8b303c517$var$K = h;
        $c87427e8b303c517$var$C = g;
        $c87427e8b303c517$var$ok.transition = f;
    } else a.current = c;
    $c87427e8b303c517$var$vk && ($c87427e8b303c517$var$vk = !1, $c87427e8b303c517$var$wk = a, $c87427e8b303c517$var$xk = e);
    f = a.pendingLanes;
    0 === f && ($c87427e8b303c517$var$Ri = null);
    $c87427e8b303c517$var$mc(c.stateNode, d);
    $c87427e8b303c517$var$Dk(a, $c87427e8b303c517$var$B());
    if (null !== b) for(d = a.onRecoverableError, c = 0; c < b.length; c++)e = b[c], d(e.value, {
        componentStack: e.stack,
        digest: e.digest
    });
    if ($c87427e8b303c517$var$Oi) throw $c87427e8b303c517$var$Oi = !1, a = $c87427e8b303c517$var$Pi, $c87427e8b303c517$var$Pi = null, a;
    0 !== ($c87427e8b303c517$var$xk & 1) && 0 !== a.tag && $c87427e8b303c517$var$Hk();
    f = a.pendingLanes;
    0 !== (f & 1) ? a === $c87427e8b303c517$var$zk ? $c87427e8b303c517$var$yk++ : ($c87427e8b303c517$var$yk = 0, $c87427e8b303c517$var$zk = a) : $c87427e8b303c517$var$yk = 0;
    $c87427e8b303c517$var$jg();
    return null;
}
function $c87427e8b303c517$var$Hk() {
    if (null !== $c87427e8b303c517$var$wk) {
        var a = $c87427e8b303c517$var$Dc($c87427e8b303c517$var$xk), b = $c87427e8b303c517$var$ok.transition, c = $c87427e8b303c517$var$C;
        try {
            $c87427e8b303c517$var$ok.transition = null;
            $c87427e8b303c517$var$C = 16 > a ? 16 : a;
            if (null === $c87427e8b303c517$var$wk) var d = !1;
            else {
                a = $c87427e8b303c517$var$wk;
                $c87427e8b303c517$var$wk = null;
                $c87427e8b303c517$var$xk = 0;
                if (0 !== ($c87427e8b303c517$var$K & 6)) throw Error($c87427e8b303c517$var$p(331));
                var e = $c87427e8b303c517$var$K;
                $c87427e8b303c517$var$K |= 4;
                for($c87427e8b303c517$var$V = a.current; null !== $c87427e8b303c517$var$V;){
                    var f = $c87427e8b303c517$var$V, g = f.child;
                    if (0 !== ($c87427e8b303c517$var$V.flags & 16)) {
                        var h = f.deletions;
                        if (null !== h) {
                            for(var k = 0; k < h.length; k++){
                                var l = h[k];
                                for($c87427e8b303c517$var$V = l; null !== $c87427e8b303c517$var$V;){
                                    var m = $c87427e8b303c517$var$V;
                                    switch(m.tag){
                                        case 0:
                                        case 11:
                                        case 15:
                                            $c87427e8b303c517$var$Pj(8, m, f);
                                    }
                                    var q = m.child;
                                    if (null !== q) q.return = m, $c87427e8b303c517$var$V = q;
                                    else for(; null !== $c87427e8b303c517$var$V;){
                                        m = $c87427e8b303c517$var$V;
                                        var r = m.sibling, y = m.return;
                                        $c87427e8b303c517$var$Sj(m);
                                        if (m === l) {
                                            $c87427e8b303c517$var$V = null;
                                            break;
                                        }
                                        if (null !== r) {
                                            r.return = y;
                                            $c87427e8b303c517$var$V = r;
                                            break;
                                        }
                                        $c87427e8b303c517$var$V = y;
                                    }
                                }
                            }
                            var n = f.alternate;
                            if (null !== n) {
                                var t = n.child;
                                if (null !== t) {
                                    n.child = null;
                                    do {
                                        var J = t.sibling;
                                        t.sibling = null;
                                        t = J;
                                    }while (null !== t);
                                }
                            }
                            $c87427e8b303c517$var$V = f;
                        }
                    }
                    if (0 !== (f.subtreeFlags & 2064) && null !== g) g.return = f, $c87427e8b303c517$var$V = g;
                    else b: for(; null !== $c87427e8b303c517$var$V;){
                        f = $c87427e8b303c517$var$V;
                        if (0 !== (f.flags & 2048)) switch(f.tag){
                            case 0:
                            case 11:
                            case 15:
                                $c87427e8b303c517$var$Pj(9, f, f.return);
                        }
                        var x = f.sibling;
                        if (null !== x) {
                            x.return = f.return;
                            $c87427e8b303c517$var$V = x;
                            break b;
                        }
                        $c87427e8b303c517$var$V = f.return;
                    }
                }
                var w = a.current;
                for($c87427e8b303c517$var$V = w; null !== $c87427e8b303c517$var$V;){
                    g = $c87427e8b303c517$var$V;
                    var u = g.child;
                    if (0 !== (g.subtreeFlags & 2064) && null !== u) u.return = g, $c87427e8b303c517$var$V = u;
                    else b: for(g = w; null !== $c87427e8b303c517$var$V;){
                        h = $c87427e8b303c517$var$V;
                        if (0 !== (h.flags & 2048)) try {
                            switch(h.tag){
                                case 0:
                                case 11:
                                case 15:
                                    $c87427e8b303c517$var$Qj(9, h);
                            }
                        } catch (na) {
                            $c87427e8b303c517$var$W(h, h.return, na);
                        }
                        if (h === g) {
                            $c87427e8b303c517$var$V = null;
                            break b;
                        }
                        var F = h.sibling;
                        if (null !== F) {
                            F.return = h.return;
                            $c87427e8b303c517$var$V = F;
                            break b;
                        }
                        $c87427e8b303c517$var$V = h.return;
                    }
                }
                $c87427e8b303c517$var$K = e;
                $c87427e8b303c517$var$jg();
                if ($c87427e8b303c517$var$lc && "function" === typeof $c87427e8b303c517$var$lc.onPostCommitFiberRoot) try {
                    $c87427e8b303c517$var$lc.onPostCommitFiberRoot($c87427e8b303c517$var$kc, a);
                } catch (na) {}
                d = !0;
            }
            return d;
        } finally{
            $c87427e8b303c517$var$C = c, $c87427e8b303c517$var$ok.transition = b;
        }
    }
    return !1;
}
function $c87427e8b303c517$var$Xk(a, b, c) {
    b = $c87427e8b303c517$var$Ji(c, b);
    b = $c87427e8b303c517$var$Ni(a, b, 1);
    a = $c87427e8b303c517$var$nh(a, b, 1);
    b = $c87427e8b303c517$var$R();
    null !== a && ($c87427e8b303c517$var$Ac(a, 1, b), $c87427e8b303c517$var$Dk(a, b));
}
function $c87427e8b303c517$var$W(a, b, c) {
    if (3 === a.tag) $c87427e8b303c517$var$Xk(a, a, c);
    else for(; null !== b;){
        if (3 === b.tag) {
            $c87427e8b303c517$var$Xk(b, a, c);
            break;
        } else if (1 === b.tag) {
            var d = b.stateNode;
            if ("function" === typeof b.type.getDerivedStateFromError || "function" === typeof d.componentDidCatch && (null === $c87427e8b303c517$var$Ri || !$c87427e8b303c517$var$Ri.has(d))) {
                a = $c87427e8b303c517$var$Ji(c, a);
                a = $c87427e8b303c517$var$Qi(b, a, 1);
                b = $c87427e8b303c517$var$nh(b, a, 1);
                a = $c87427e8b303c517$var$R();
                null !== b && ($c87427e8b303c517$var$Ac(b, 1, a), $c87427e8b303c517$var$Dk(b, a));
                break;
            }
        }
        b = b.return;
    }
}
function $c87427e8b303c517$var$Ti(a, b, c) {
    var d = a.pingCache;
    null !== d && d.delete(b);
    b = $c87427e8b303c517$var$R();
    a.pingedLanes |= a.suspendedLanes & c;
    $c87427e8b303c517$var$Q === a && ($c87427e8b303c517$var$Z & c) === c && (4 === $c87427e8b303c517$var$T || 3 === $c87427e8b303c517$var$T && ($c87427e8b303c517$var$Z & 130023424) === $c87427e8b303c517$var$Z && 500 > $c87427e8b303c517$var$B() - $c87427e8b303c517$var$fk ? $c87427e8b303c517$var$Kk(a, 0) : $c87427e8b303c517$var$rk |= c);
    $c87427e8b303c517$var$Dk(a, b);
}
function $c87427e8b303c517$var$Yk(a, b) {
    0 === b && (0 === (a.mode & 1) ? b = 1 : (b = $c87427e8b303c517$var$sc, $c87427e8b303c517$var$sc <<= 1, 0 === ($c87427e8b303c517$var$sc & 130023424) && ($c87427e8b303c517$var$sc = 4194304)));
    var c = $c87427e8b303c517$var$R();
    a = $c87427e8b303c517$var$ih(a, b);
    null !== a && ($c87427e8b303c517$var$Ac(a, b, c), $c87427e8b303c517$var$Dk(a, c));
}
function $c87427e8b303c517$var$uj(a) {
    var b = a.memoizedState, c = 0;
    null !== b && (c = b.retryLane);
    $c87427e8b303c517$var$Yk(a, c);
}
function $c87427e8b303c517$var$bk(a, b) {
    var c = 0;
    switch(a.tag){
        case 13:
            var d = a.stateNode;
            var e = a.memoizedState;
            null !== e && (c = e.retryLane);
            break;
        case 19:
            d = a.stateNode;
            break;
        default:
            throw Error($c87427e8b303c517$var$p(314));
    }
    null !== d && d.delete(b);
    $c87427e8b303c517$var$Yk(a, c);
}
var $c87427e8b303c517$var$Vk;
$c87427e8b303c517$var$Vk = function(a, b, c) {
    if (null !== a) {
        if (a.memoizedProps !== b.pendingProps || $c87427e8b303c517$var$Wf.current) $c87427e8b303c517$var$dh = !0;
        else {
            if (0 === (a.lanes & c) && 0 === (b.flags & 128)) return $c87427e8b303c517$var$dh = !1, $c87427e8b303c517$var$yj(a, b, c);
            $c87427e8b303c517$var$dh = 0 !== (a.flags & 131072) ? !0 : !1;
        }
    } else $c87427e8b303c517$var$dh = !1, $c87427e8b303c517$var$I && 0 !== (b.flags & 1048576) && $c87427e8b303c517$var$ug(b, $c87427e8b303c517$var$ng, b.index);
    b.lanes = 0;
    switch(b.tag){
        case 2:
            var d = b.type;
            $c87427e8b303c517$var$ij(a, b);
            a = b.pendingProps;
            var e = $c87427e8b303c517$var$Yf(b, $c87427e8b303c517$var$H.current);
            $c87427e8b303c517$var$ch(b, c);
            e = $c87427e8b303c517$var$Nh(null, b, d, a, e, c);
            var f = $c87427e8b303c517$var$Sh();
            b.flags |= 1;
            "object" === typeof e && null !== e && "function" === typeof e.render && void 0 === e.$$typeof ? (b.tag = 1, b.memoizedState = null, b.updateQueue = null, $c87427e8b303c517$var$Zf(d) ? (f = !0, $c87427e8b303c517$var$cg(b)) : f = !1, b.memoizedState = null !== e.state && void 0 !== e.state ? e.state : null, $c87427e8b303c517$var$kh(b), e.updater = $c87427e8b303c517$var$Ei, b.stateNode = e, e._reactInternals = b, $c87427e8b303c517$var$Ii(b, d, a, c), b = $c87427e8b303c517$var$jj(null, b, d, !0, f, c)) : (b.tag = 0, $c87427e8b303c517$var$I && f && $c87427e8b303c517$var$vg(b), $c87427e8b303c517$var$Xi(null, b, e, c), b = b.child);
            return b;
        case 16:
            d = b.elementType;
            a: {
                $c87427e8b303c517$var$ij(a, b);
                a = b.pendingProps;
                e = d._init;
                d = e(d._payload);
                b.type = d;
                e = b.tag = $c87427e8b303c517$var$Zk(d);
                a = $c87427e8b303c517$var$Ci(d, a);
                switch(e){
                    case 0:
                        b = $c87427e8b303c517$var$cj(null, b, d, a, c);
                        break a;
                    case 1:
                        b = $c87427e8b303c517$var$hj(null, b, d, a, c);
                        break a;
                    case 11:
                        b = $c87427e8b303c517$var$Yi(null, b, d, a, c);
                        break a;
                    case 14:
                        b = $c87427e8b303c517$var$$i(null, b, d, $c87427e8b303c517$var$Ci(d.type, a), c);
                        break a;
                }
                throw Error($c87427e8b303c517$var$p(306, d, ""));
            }
            return b;
        case 0:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : $c87427e8b303c517$var$Ci(d, e), $c87427e8b303c517$var$cj(a, b, d, e, c);
        case 1:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : $c87427e8b303c517$var$Ci(d, e), $c87427e8b303c517$var$hj(a, b, d, e, c);
        case 3:
            a: {
                $c87427e8b303c517$var$kj(b);
                if (null === a) throw Error($c87427e8b303c517$var$p(387));
                d = b.pendingProps;
                f = b.memoizedState;
                e = f.element;
                $c87427e8b303c517$var$lh(a, b);
                $c87427e8b303c517$var$qh(b, d, null, c);
                var g = b.memoizedState;
                d = g.element;
                if (f.isDehydrated) {
                    if (f = {
                        element: d,
                        isDehydrated: !1,
                        cache: g.cache,
                        pendingSuspenseBoundaries: g.pendingSuspenseBoundaries,
                        transitions: g.transitions
                    }, b.updateQueue.baseState = f, b.memoizedState = f, b.flags & 256) {
                        e = $c87427e8b303c517$var$Ji(Error($c87427e8b303c517$var$p(423)), b);
                        b = $c87427e8b303c517$var$lj(a, b, d, c, e);
                        break a;
                    } else if (d !== e) {
                        e = $c87427e8b303c517$var$Ji(Error($c87427e8b303c517$var$p(424)), b);
                        b = $c87427e8b303c517$var$lj(a, b, d, c, e);
                        break a;
                    } else for($c87427e8b303c517$var$yg = $c87427e8b303c517$var$Lf(b.stateNode.containerInfo.firstChild), $c87427e8b303c517$var$xg = b, $c87427e8b303c517$var$I = !0, $c87427e8b303c517$var$zg = null, c = $c87427e8b303c517$var$Vg(b, null, d, c), b.child = c; c;)c.flags = c.flags & -3 | 4096, c = c.sibling;
                } else {
                    $c87427e8b303c517$var$Ig();
                    if (d === e) {
                        b = $c87427e8b303c517$var$Zi(a, b, c);
                        break a;
                    }
                    $c87427e8b303c517$var$Xi(a, b, d, c);
                }
                b = b.child;
            }
            return b;
        case 5:
            return $c87427e8b303c517$var$Ah(b), null === a && $c87427e8b303c517$var$Eg(b), d = b.type, e = b.pendingProps, f = null !== a ? a.memoizedProps : null, g = e.children, $c87427e8b303c517$var$Ef(d, e) ? g = null : null !== f && $c87427e8b303c517$var$Ef(d, f) && (b.flags |= 32), $c87427e8b303c517$var$gj(a, b), $c87427e8b303c517$var$Xi(a, b, g, c), b.child;
        case 6:
            return null === a && $c87427e8b303c517$var$Eg(b), null;
        case 13:
            return $c87427e8b303c517$var$oj(a, b, c);
        case 4:
            return $c87427e8b303c517$var$yh(b, b.stateNode.containerInfo), d = b.pendingProps, null === a ? b.child = $c87427e8b303c517$var$Ug(b, null, d, c) : $c87427e8b303c517$var$Xi(a, b, d, c), b.child;
        case 11:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : $c87427e8b303c517$var$Ci(d, e), $c87427e8b303c517$var$Yi(a, b, d, e, c);
        case 7:
            return $c87427e8b303c517$var$Xi(a, b, b.pendingProps, c), b.child;
        case 8:
            return $c87427e8b303c517$var$Xi(a, b, b.pendingProps.children, c), b.child;
        case 12:
            return $c87427e8b303c517$var$Xi(a, b, b.pendingProps.children, c), b.child;
        case 10:
            a: {
                d = b.type._context;
                e = b.pendingProps;
                f = b.memoizedProps;
                g = e.value;
                $c87427e8b303c517$var$G($c87427e8b303c517$var$Wg, d._currentValue);
                d._currentValue = g;
                if (null !== f) {
                    if ($c87427e8b303c517$var$He(f.value, g)) {
                        if (f.children === e.children && !$c87427e8b303c517$var$Wf.current) {
                            b = $c87427e8b303c517$var$Zi(a, b, c);
                            break a;
                        }
                    } else for(f = b.child, null !== f && (f.return = b); null !== f;){
                        var h = f.dependencies;
                        if (null !== h) {
                            g = f.child;
                            for(var k = h.firstContext; null !== k;){
                                if (k.context === d) {
                                    if (1 === f.tag) {
                                        k = $c87427e8b303c517$var$mh(-1, c & -c);
                                        k.tag = 2;
                                        var l = f.updateQueue;
                                        if (null !== l) {
                                            l = l.shared;
                                            var m = l.pending;
                                            null === m ? k.next = k : (k.next = m.next, m.next = k);
                                            l.pending = k;
                                        }
                                    }
                                    f.lanes |= c;
                                    k = f.alternate;
                                    null !== k && (k.lanes |= c);
                                    $c87427e8b303c517$var$bh(f.return, c, b);
                                    h.lanes |= c;
                                    break;
                                }
                                k = k.next;
                            }
                        } else if (10 === f.tag) g = f.type === b.type ? null : f.child;
                        else if (18 === f.tag) {
                            g = f.return;
                            if (null === g) throw Error($c87427e8b303c517$var$p(341));
                            g.lanes |= c;
                            h = g.alternate;
                            null !== h && (h.lanes |= c);
                            $c87427e8b303c517$var$bh(g, c, b);
                            g = f.sibling;
                        } else g = f.child;
                        if (null !== g) g.return = f;
                        else for(g = f; null !== g;){
                            if (g === b) {
                                g = null;
                                break;
                            }
                            f = g.sibling;
                            if (null !== f) {
                                f.return = g.return;
                                g = f;
                                break;
                            }
                            g = g.return;
                        }
                        f = g;
                    }
                }
                $c87427e8b303c517$var$Xi(a, b, e.children, c);
                b = b.child;
            }
            return b;
        case 9:
            return e = b.type, d = b.pendingProps.children, $c87427e8b303c517$var$ch(b, c), e = $c87427e8b303c517$var$eh(e), d = d(e), b.flags |= 1, $c87427e8b303c517$var$Xi(a, b, d, c), b.child;
        case 14:
            return d = b.type, e = $c87427e8b303c517$var$Ci(d, b.pendingProps), e = $c87427e8b303c517$var$Ci(d.type, e), $c87427e8b303c517$var$$i(a, b, d, e, c);
        case 15:
            return $c87427e8b303c517$var$bj(a, b, b.type, b.pendingProps, c);
        case 17:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : $c87427e8b303c517$var$Ci(d, e), $c87427e8b303c517$var$ij(a, b), b.tag = 1, $c87427e8b303c517$var$Zf(d) ? (a = !0, $c87427e8b303c517$var$cg(b)) : a = !1, $c87427e8b303c517$var$ch(b, c), $c87427e8b303c517$var$Gi(b, d, e), $c87427e8b303c517$var$Ii(b, d, e, c), $c87427e8b303c517$var$jj(null, b, d, !0, a, c);
        case 19:
            return $c87427e8b303c517$var$xj(a, b, c);
        case 22:
            return $c87427e8b303c517$var$dj(a, b, c);
    }
    throw Error($c87427e8b303c517$var$p(156, b.tag));
};
function $c87427e8b303c517$var$Fk(a, b) {
    return $c87427e8b303c517$var$ac(a, b);
}
function $c87427e8b303c517$var$$k(a, b, c, d) {
    this.tag = a;
    this.key = c;
    this.sibling = this.child = this.return = this.stateNode = this.type = this.elementType = null;
    this.index = 0;
    this.ref = null;
    this.pendingProps = b;
    this.dependencies = this.memoizedState = this.updateQueue = this.memoizedProps = null;
    this.mode = d;
    this.subtreeFlags = this.flags = 0;
    this.deletions = null;
    this.childLanes = this.lanes = 0;
    this.alternate = null;
}
function $c87427e8b303c517$var$Bg(a, b, c, d) {
    return new $c87427e8b303c517$var$$k(a, b, c, d);
}
function $c87427e8b303c517$var$aj(a) {
    a = a.prototype;
    return !(!a || !a.isReactComponent);
}
function $c87427e8b303c517$var$Zk(a) {
    if ("function" === typeof a) return $c87427e8b303c517$var$aj(a) ? 1 : 0;
    if (void 0 !== a && null !== a) {
        a = a.$$typeof;
        if (a === $c87427e8b303c517$var$Da) return 11;
        if (a === $c87427e8b303c517$var$Ga) return 14;
    }
    return 2;
}
function $c87427e8b303c517$var$Pg(a, b) {
    var c = a.alternate;
    null === c ? (c = $c87427e8b303c517$var$Bg(a.tag, b, a.key, a.mode), c.elementType = a.elementType, c.type = a.type, c.stateNode = a.stateNode, c.alternate = a, a.alternate = c) : (c.pendingProps = b, c.type = a.type, c.flags = 0, c.subtreeFlags = 0, c.deletions = null);
    c.flags = a.flags & 14680064;
    c.childLanes = a.childLanes;
    c.lanes = a.lanes;
    c.child = a.child;
    c.memoizedProps = a.memoizedProps;
    c.memoizedState = a.memoizedState;
    c.updateQueue = a.updateQueue;
    b = a.dependencies;
    c.dependencies = null === b ? null : {
        lanes: b.lanes,
        firstContext: b.firstContext
    };
    c.sibling = a.sibling;
    c.index = a.index;
    c.ref = a.ref;
    return c;
}
function $c87427e8b303c517$var$Rg(a, b, c, d, e, f) {
    var g = 2;
    d = a;
    if ("function" === typeof a) $c87427e8b303c517$var$aj(a) && (g = 1);
    else if ("string" === typeof a) g = 5;
    else a: switch(a){
        case $c87427e8b303c517$var$ya:
            return $c87427e8b303c517$var$Tg(c.children, e, f, b);
        case $c87427e8b303c517$var$za:
            g = 8;
            e |= 8;
            break;
        case $c87427e8b303c517$var$Aa:
            return a = $c87427e8b303c517$var$Bg(12, c, b, e | 2), a.elementType = $c87427e8b303c517$var$Aa, a.lanes = f, a;
        case $c87427e8b303c517$var$Ea:
            return a = $c87427e8b303c517$var$Bg(13, c, b, e), a.elementType = $c87427e8b303c517$var$Ea, a.lanes = f, a;
        case $c87427e8b303c517$var$Fa:
            return a = $c87427e8b303c517$var$Bg(19, c, b, e), a.elementType = $c87427e8b303c517$var$Fa, a.lanes = f, a;
        case $c87427e8b303c517$var$Ia:
            return $c87427e8b303c517$var$pj(c, e, f, b);
        default:
            if ("object" === typeof a && null !== a) switch(a.$$typeof){
                case $c87427e8b303c517$var$Ba:
                    g = 10;
                    break a;
                case $c87427e8b303c517$var$Ca:
                    g = 9;
                    break a;
                case $c87427e8b303c517$var$Da:
                    g = 11;
                    break a;
                case $c87427e8b303c517$var$Ga:
                    g = 14;
                    break a;
                case $c87427e8b303c517$var$Ha:
                    g = 16;
                    d = null;
                    break a;
            }
            throw Error($c87427e8b303c517$var$p(130, null == a ? a : typeof a, ""));
    }
    b = $c87427e8b303c517$var$Bg(g, c, b, e);
    b.elementType = a;
    b.type = d;
    b.lanes = f;
    return b;
}
function $c87427e8b303c517$var$Tg(a, b, c, d) {
    a = $c87427e8b303c517$var$Bg(7, a, d, b);
    a.lanes = c;
    return a;
}
function $c87427e8b303c517$var$pj(a, b, c, d) {
    a = $c87427e8b303c517$var$Bg(22, a, d, b);
    a.elementType = $c87427e8b303c517$var$Ia;
    a.lanes = c;
    a.stateNode = {
        isHidden: !1
    };
    return a;
}
function $c87427e8b303c517$var$Qg(a, b, c) {
    a = $c87427e8b303c517$var$Bg(6, a, null, b);
    a.lanes = c;
    return a;
}
function $c87427e8b303c517$var$Sg(a, b, c) {
    b = $c87427e8b303c517$var$Bg(4, null !== a.children ? a.children : [], a.key, b);
    b.lanes = c;
    b.stateNode = {
        containerInfo: a.containerInfo,
        pendingChildren: null,
        implementation: a.implementation
    };
    return b;
}
function $c87427e8b303c517$var$al(a, b, c, d, e) {
    this.tag = b;
    this.containerInfo = a;
    this.finishedWork = this.pingCache = this.current = this.pendingChildren = null;
    this.timeoutHandle = -1;
    this.callbackNode = this.pendingContext = this.context = null;
    this.callbackPriority = 0;
    this.eventTimes = $c87427e8b303c517$var$zc(0);
    this.expirationTimes = $c87427e8b303c517$var$zc(-1);
    this.entangledLanes = this.finishedLanes = this.mutableReadLanes = this.expiredLanes = this.pingedLanes = this.suspendedLanes = this.pendingLanes = 0;
    this.entanglements = $c87427e8b303c517$var$zc(0);
    this.identifierPrefix = d;
    this.onRecoverableError = e;
    this.mutableSourceEagerHydrationData = null;
}
function $c87427e8b303c517$var$bl(a, b, c, d, e, f, g, h, k) {
    a = new $c87427e8b303c517$var$al(a, b, c, h, k);
    1 === b ? (b = 1, !0 === f && (b |= 8)) : b = 0;
    f = $c87427e8b303c517$var$Bg(3, null, null, b);
    a.current = f;
    f.stateNode = a;
    f.memoizedState = {
        element: d,
        isDehydrated: c,
        cache: null,
        transitions: null,
        pendingSuspenseBoundaries: null
    };
    $c87427e8b303c517$var$kh(f);
    return a;
}
function $c87427e8b303c517$var$cl(a, b, c) {
    var d = 3 < arguments.length && void 0 !== arguments[3] ? arguments[3] : null;
    return {
        $$typeof: $c87427e8b303c517$var$wa,
        key: null == d ? null : "" + d,
        children: a,
        containerInfo: b,
        implementation: c
    };
}
function $c87427e8b303c517$var$dl(a) {
    if (!a) return $c87427e8b303c517$var$Vf;
    a = a._reactInternals;
    a: {
        if ($c87427e8b303c517$var$Vb(a) !== a || 1 !== a.tag) throw Error($c87427e8b303c517$var$p(170));
        var b = a;
        do {
            switch(b.tag){
                case 3:
                    b = b.stateNode.context;
                    break a;
                case 1:
                    if ($c87427e8b303c517$var$Zf(b.type)) {
                        b = b.stateNode.__reactInternalMemoizedMergedChildContext;
                        break a;
                    }
            }
            b = b.return;
        }while (null !== b);
        throw Error($c87427e8b303c517$var$p(171));
    }
    if (1 === a.tag) {
        var c = a.type;
        if ($c87427e8b303c517$var$Zf(c)) return $c87427e8b303c517$var$bg(a, c, b);
    }
    return b;
}
function $c87427e8b303c517$var$el(a, b, c, d, e, f, g, h, k) {
    a = $c87427e8b303c517$var$bl(c, d, !0, a, e, f, g, h, k);
    a.context = $c87427e8b303c517$var$dl(null);
    c = a.current;
    d = $c87427e8b303c517$var$R();
    e = $c87427e8b303c517$var$yi(c);
    f = $c87427e8b303c517$var$mh(d, e);
    f.callback = void 0 !== b && null !== b ? b : null;
    $c87427e8b303c517$var$nh(c, f, e);
    a.current.lanes = e;
    $c87427e8b303c517$var$Ac(a, e, d);
    $c87427e8b303c517$var$Dk(a, d);
    return a;
}
function $c87427e8b303c517$var$fl(a, b, c, d) {
    var e = b.current, f = $c87427e8b303c517$var$R(), g = $c87427e8b303c517$var$yi(e);
    c = $c87427e8b303c517$var$dl(c);
    null === b.context ? b.context = c : b.pendingContext = c;
    b = $c87427e8b303c517$var$mh(f, g);
    b.payload = {
        element: a
    };
    d = void 0 === d ? null : d;
    null !== d && (b.callback = d);
    a = $c87427e8b303c517$var$nh(e, b, g);
    null !== a && ($c87427e8b303c517$var$gi(a, e, g, f), $c87427e8b303c517$var$oh(a, e, g));
    return g;
}
function $c87427e8b303c517$var$gl(a) {
    a = a.current;
    if (!a.child) return null;
    switch(a.child.tag){
        case 5:
            return a.child.stateNode;
        default:
            return a.child.stateNode;
    }
}
function $c87427e8b303c517$var$hl(a, b) {
    a = a.memoizedState;
    if (null !== a && null !== a.dehydrated) {
        var c = a.retryLane;
        a.retryLane = 0 !== c && c < b ? c : b;
    }
}
function $c87427e8b303c517$var$il(a, b) {
    $c87427e8b303c517$var$hl(a, b);
    (a = a.alternate) && $c87427e8b303c517$var$hl(a, b);
}
function $c87427e8b303c517$var$jl() {
    return null;
}
var $c87427e8b303c517$var$kl = "function" === typeof reportError ? reportError : function(a) {
    console.error(a);
};
function $c87427e8b303c517$var$ll(a) {
    this._internalRoot = a;
}
$c87427e8b303c517$var$ml.prototype.render = $c87427e8b303c517$var$ll.prototype.render = function(a) {
    var b = this._internalRoot;
    if (null === b) throw Error($c87427e8b303c517$var$p(409));
    $c87427e8b303c517$var$fl(a, b, null, null);
};
$c87427e8b303c517$var$ml.prototype.unmount = $c87427e8b303c517$var$ll.prototype.unmount = function() {
    var a = this._internalRoot;
    if (null !== a) {
        this._internalRoot = null;
        var b = a.containerInfo;
        $c87427e8b303c517$var$Rk(function() {
            $c87427e8b303c517$var$fl(null, a, null, null);
        });
        b[$c87427e8b303c517$var$uf] = null;
    }
};
function $c87427e8b303c517$var$ml(a) {
    this._internalRoot = a;
}
$c87427e8b303c517$var$ml.prototype.unstable_scheduleHydration = function(a) {
    if (a) {
        var b = $c87427e8b303c517$var$Hc();
        a = {
            blockedOn: null,
            target: a,
            priority: b
        };
        for(var c = 0; c < $c87427e8b303c517$var$Qc.length && 0 !== b && b < $c87427e8b303c517$var$Qc[c].priority; c++);
        $c87427e8b303c517$var$Qc.splice(c, 0, a);
        0 === c && $c87427e8b303c517$var$Vc(a);
    }
};
function $c87427e8b303c517$var$nl(a) {
    return !(!a || 1 !== a.nodeType && 9 !== a.nodeType && 11 !== a.nodeType);
}
function $c87427e8b303c517$var$ol(a) {
    return !(!a || 1 !== a.nodeType && 9 !== a.nodeType && 11 !== a.nodeType && (8 !== a.nodeType || " react-mount-point-unstable " !== a.nodeValue));
}
function $c87427e8b303c517$var$pl() {}
function $c87427e8b303c517$var$ql(a, b, c, d, e) {
    if (e) {
        if ("function" === typeof d) {
            var f = d;
            d = function() {
                var a = $c87427e8b303c517$var$gl(g);
                f.call(a);
            };
        }
        var g = $c87427e8b303c517$var$el(b, d, a, 0, null, !1, !1, "", $c87427e8b303c517$var$pl);
        a._reactRootContainer = g;
        a[$c87427e8b303c517$var$uf] = g.current;
        $c87427e8b303c517$var$sf(8 === a.nodeType ? a.parentNode : a);
        $c87427e8b303c517$var$Rk();
        return g;
    }
    for(; e = a.lastChild;)a.removeChild(e);
    if ("function" === typeof d) {
        var h = d;
        d = function() {
            var a = $c87427e8b303c517$var$gl(k);
            h.call(a);
        };
    }
    var k = $c87427e8b303c517$var$bl(a, 0, !1, null, null, !1, !1, "", $c87427e8b303c517$var$pl);
    a._reactRootContainer = k;
    a[$c87427e8b303c517$var$uf] = k.current;
    $c87427e8b303c517$var$sf(8 === a.nodeType ? a.parentNode : a);
    $c87427e8b303c517$var$Rk(function() {
        $c87427e8b303c517$var$fl(b, k, c, d);
    });
    return k;
}
function $c87427e8b303c517$var$rl(a, b, c, d, e) {
    var f = c._reactRootContainer;
    if (f) {
        var g = f;
        if ("function" === typeof e) {
            var h = e;
            e = function() {
                var a = $c87427e8b303c517$var$gl(g);
                h.call(a);
            };
        }
        $c87427e8b303c517$var$fl(b, g, a, e);
    } else g = $c87427e8b303c517$var$ql(c, b, a, e, d);
    return $c87427e8b303c517$var$gl(g);
}
$c87427e8b303c517$var$Ec = function(a) {
    switch(a.tag){
        case 3:
            var b = a.stateNode;
            if (b.current.memoizedState.isDehydrated) {
                var c = $c87427e8b303c517$var$tc(b.pendingLanes);
                0 !== c && ($c87427e8b303c517$var$Cc(b, c | 1), $c87427e8b303c517$var$Dk(b, $c87427e8b303c517$var$B()), 0 === ($c87427e8b303c517$var$K & 6) && ($c87427e8b303c517$var$Gj = $c87427e8b303c517$var$B() + 500, $c87427e8b303c517$var$jg()));
            }
            break;
        case 13:
            $c87427e8b303c517$var$Rk(function() {
                var b = $c87427e8b303c517$var$ih(a, 1);
                if (null !== b) {
                    var c = $c87427e8b303c517$var$R();
                    $c87427e8b303c517$var$gi(b, a, 1, c);
                }
            }), $c87427e8b303c517$var$il(a, 1);
    }
};
$c87427e8b303c517$var$Fc = function(a) {
    if (13 === a.tag) {
        var b = $c87427e8b303c517$var$ih(a, 134217728);
        if (null !== b) {
            var c = $c87427e8b303c517$var$R();
            $c87427e8b303c517$var$gi(b, a, 134217728, c);
        }
        $c87427e8b303c517$var$il(a, 134217728);
    }
};
$c87427e8b303c517$var$Gc = function(a) {
    if (13 === a.tag) {
        var b = $c87427e8b303c517$var$yi(a), c = $c87427e8b303c517$var$ih(a, b);
        if (null !== c) {
            var d = $c87427e8b303c517$var$R();
            $c87427e8b303c517$var$gi(c, a, b, d);
        }
        $c87427e8b303c517$var$il(a, b);
    }
};
$c87427e8b303c517$var$Hc = function() {
    return $c87427e8b303c517$var$C;
};
$c87427e8b303c517$var$Ic = function(a, b) {
    var c = $c87427e8b303c517$var$C;
    try {
        return $c87427e8b303c517$var$C = a, b();
    } finally{
        $c87427e8b303c517$var$C = c;
    }
};
$c87427e8b303c517$var$yb = function(a, b, c) {
    switch(b){
        case "input":
            $c87427e8b303c517$var$bb(a, c);
            b = c.name;
            if ("radio" === c.type && null != b) {
                for(c = a; c.parentNode;)c = c.parentNode;
                c = c.querySelectorAll("input[name=" + JSON.stringify("" + b) + '][type="radio"]');
                for(b = 0; b < c.length; b++){
                    var d = c[b];
                    if (d !== a && d.form === a.form) {
                        var e = $c87427e8b303c517$var$Db(d);
                        if (!e) throw Error($c87427e8b303c517$var$p(90));
                        $c87427e8b303c517$var$Wa(d);
                        $c87427e8b303c517$var$bb(d, e);
                    }
                }
            }
            break;
        case "textarea":
            $c87427e8b303c517$var$ib(a, c);
            break;
        case "select":
            b = c.value, null != b && $c87427e8b303c517$var$fb(a, !!c.multiple, b, !1);
    }
};
$c87427e8b303c517$var$Gb = $c87427e8b303c517$var$Qk;
$c87427e8b303c517$var$Hb = $c87427e8b303c517$var$Rk;
var $c87427e8b303c517$var$sl = {
    usingClientEntryPoint: !1,
    Events: [
        $c87427e8b303c517$var$Cb,
        $c87427e8b303c517$var$ue,
        $c87427e8b303c517$var$Db,
        $c87427e8b303c517$var$Eb,
        $c87427e8b303c517$var$Fb,
        $c87427e8b303c517$var$Qk
    ]
}, $c87427e8b303c517$var$tl = {
    findFiberByHostInstance: $c87427e8b303c517$var$Wc,
    bundleType: 0,
    version: "18.3.1",
    rendererPackageName: "react-dom"
};
var $c87427e8b303c517$var$ul = {
    bundleType: $c87427e8b303c517$var$tl.bundleType,
    version: $c87427e8b303c517$var$tl.version,
    rendererPackageName: $c87427e8b303c517$var$tl.rendererPackageName,
    rendererConfig: $c87427e8b303c517$var$tl.rendererConfig,
    overrideHookState: null,
    overrideHookStateDeletePath: null,
    overrideHookStateRenamePath: null,
    overrideProps: null,
    overridePropsDeletePath: null,
    overridePropsRenamePath: null,
    setErrorHandler: null,
    setSuspenseHandler: null,
    scheduleUpdate: null,
    currentDispatcherRef: $c87427e8b303c517$var$ua.ReactCurrentDispatcher,
    findHostInstanceByFiber: function(a) {
        a = $c87427e8b303c517$var$Zb(a);
        return null === a ? null : a.stateNode;
    },
    findFiberByHostInstance: $c87427e8b303c517$var$tl.findFiberByHostInstance || $c87427e8b303c517$var$jl,
    findHostInstancesForRefresh: null,
    scheduleRefresh: null,
    scheduleRoot: null,
    setRefreshHandler: null,
    getCurrentFiber: null,
    reconcilerVersion: "18.3.1-next-f1338f8080-20240426"
};
if ("undefined" !== typeof __REACT_DEVTOOLS_GLOBAL_HOOK__) {
    var $c87427e8b303c517$var$vl = __REACT_DEVTOOLS_GLOBAL_HOOK__;
    if (!$c87427e8b303c517$var$vl.isDisabled && $c87427e8b303c517$var$vl.supportsFiber) try {
        $c87427e8b303c517$var$kc = $c87427e8b303c517$var$vl.inject($c87427e8b303c517$var$ul), $c87427e8b303c517$var$lc = $c87427e8b303c517$var$vl;
    } catch (a) {}
}
$c87427e8b303c517$export$ae55be85d98224ed = $c87427e8b303c517$var$sl;
$c87427e8b303c517$export$d39a5bbd09211389 = function(a, b) {
    var c = 2 < arguments.length && void 0 !== arguments[2] ? arguments[2] : null;
    if (!$c87427e8b303c517$var$nl(b)) throw Error($c87427e8b303c517$var$p(200));
    return $c87427e8b303c517$var$cl(a, b, null, c);
};
$c87427e8b303c517$export$882461b6382ed46c = function(a, b) {
    if (!$c87427e8b303c517$var$nl(a)) throw Error($c87427e8b303c517$var$p(299));
    var c = !1, d = "", e = $c87427e8b303c517$var$kl;
    null !== b && void 0 !== b && (!0 === b.unstable_strictMode && (c = !0), void 0 !== b.identifierPrefix && (d = b.identifierPrefix), void 0 !== b.onRecoverableError && (e = b.onRecoverableError));
    b = $c87427e8b303c517$var$bl(a, 1, !1, null, null, c, !1, d, e);
    a[$c87427e8b303c517$var$uf] = b.current;
    $c87427e8b303c517$var$sf(8 === a.nodeType ? a.parentNode : a);
    return new $c87427e8b303c517$var$ll(b);
};
$c87427e8b303c517$export$466bfc07425424d5 = function(a) {
    if (null == a) return null;
    if (1 === a.nodeType) return a;
    var b = a._reactInternals;
    if (void 0 === b) {
        if ("function" === typeof a.render) throw Error($c87427e8b303c517$var$p(188));
        a = Object.keys(a).join(",");
        throw Error($c87427e8b303c517$var$p(268, a));
    }
    a = $c87427e8b303c517$var$Zb(b);
    a = null === a ? null : a.stateNode;
    return a;
};
$c87427e8b303c517$export$cd75ccfd720a3cd4 = function(a) {
    return $c87427e8b303c517$var$Rk(a);
};
$c87427e8b303c517$export$fa8d919ba61d84db = function(a, b, c) {
    if (!$c87427e8b303c517$var$ol(b)) throw Error($c87427e8b303c517$var$p(200));
    return $c87427e8b303c517$var$rl(null, a, b, !0, c);
};
$c87427e8b303c517$export$757ceba2d55c277e = function(a, b, c) {
    if (!$c87427e8b303c517$var$nl(a)) throw Error($c87427e8b303c517$var$p(405));
    var d = null != c && c.hydratedSources || null, e = !1, f = "", g = $c87427e8b303c517$var$kl;
    null !== c && void 0 !== c && (!0 === c.unstable_strictMode && (e = !0), void 0 !== c.identifierPrefix && (f = c.identifierPrefix), void 0 !== c.onRecoverableError && (g = c.onRecoverableError));
    b = $c87427e8b303c517$var$el(b, null, a, 1, null != c ? c : null, e, !1, f, g);
    a[$c87427e8b303c517$var$uf] = b.current;
    $c87427e8b303c517$var$sf(a);
    if (d) for(a = 0; a < d.length; a++)c = d[a], e = c._getVersion, e = e(c._source), null == b.mutableSourceEagerHydrationData ? b.mutableSourceEagerHydrationData = [
        c,
        e
    ] : b.mutableSourceEagerHydrationData.push(c, e);
    return new $c87427e8b303c517$var$ml(b);
};
$c87427e8b303c517$export$b3890eb0ae9dca99 = function(a, b, c) {
    if (!$c87427e8b303c517$var$ol(b)) throw Error($c87427e8b303c517$var$p(200));
    return $c87427e8b303c517$var$rl(null, a, b, !1, c);
};
$c87427e8b303c517$export$502457920280e6be = function(a) {
    if (!$c87427e8b303c517$var$ol(a)) throw Error($c87427e8b303c517$var$p(40));
    return a._reactRootContainer ? ($c87427e8b303c517$var$Rk(function() {
        $c87427e8b303c517$var$rl(null, null, a, !1, function() {
            a._reactRootContainer = null;
            a[$c87427e8b303c517$var$uf] = null;
        });
    }), !0) : !1;
};
$c87427e8b303c517$export$c78a37762a8d58e1 = $c87427e8b303c517$var$Qk;
$c87427e8b303c517$export$dc54d992c10e8a18 = function(a, b, c, d) {
    if (!$c87427e8b303c517$var$ol(c)) throw Error($c87427e8b303c517$var$p(200));
    if (null == a || void 0 === a._reactInternals) throw Error($c87427e8b303c517$var$p(38));
    return $c87427e8b303c517$var$rl(a, b, c, !1, d);
};
$c87427e8b303c517$export$83d89fbfd8236492 = "18.3.1-next-f1338f8080-20240426";

});
parcelRegister("iI65C", function(module, exports) {
"use strict";

module.exports = (parcelRequire("3Y2rH"));

});
parcelRegister("3Y2rH", function(module, exports) {

$parcel$export(module.exports, "unstable_now", () => $2e38df5c34a8f85b$export$c4744153514ff05d, (v) => $2e38df5c34a8f85b$export$c4744153514ff05d = v);
$parcel$export(module.exports, "unstable_IdlePriority", () => $2e38df5c34a8f85b$export$3e506c1ccc9cc1a7, (v) => $2e38df5c34a8f85b$export$3e506c1ccc9cc1a7 = v);
$parcel$export(module.exports, "unstable_ImmediatePriority", () => $2e38df5c34a8f85b$export$e26fe2ed2fa76875, (v) => $2e38df5c34a8f85b$export$e26fe2ed2fa76875 = v);
$parcel$export(module.exports, "unstable_LowPriority", () => $2e38df5c34a8f85b$export$502329bbf4b505b1, (v) => $2e38df5c34a8f85b$export$502329bbf4b505b1 = v);
$parcel$export(module.exports, "unstable_NormalPriority", () => $2e38df5c34a8f85b$export$6e3807111c4874c4, (v) => $2e38df5c34a8f85b$export$6e3807111c4874c4 = v);
$parcel$export(module.exports, "unstable_Profiling", () => $2e38df5c34a8f85b$export$c27134553091fb3a, (v) => $2e38df5c34a8f85b$export$c27134553091fb3a = v);
$parcel$export(module.exports, "unstable_UserBlockingPriority", () => $2e38df5c34a8f85b$export$33ee1acdc04fd2a2, (v) => $2e38df5c34a8f85b$export$33ee1acdc04fd2a2 = v);
$parcel$export(module.exports, "unstable_cancelCallback", () => $2e38df5c34a8f85b$export$b00a404bbd5edef2, (v) => $2e38df5c34a8f85b$export$b00a404bbd5edef2 = v);
$parcel$export(module.exports, "unstable_continueExecution", () => $2e38df5c34a8f85b$export$8352ce38b91d0c62, (v) => $2e38df5c34a8f85b$export$8352ce38b91d0c62 = v);
$parcel$export(module.exports, "unstable_forceFrameRate", () => $2e38df5c34a8f85b$export$d66a1c1c77bd778b, (v) => $2e38df5c34a8f85b$export$d66a1c1c77bd778b = v);
$parcel$export(module.exports, "unstable_getCurrentPriorityLevel", () => $2e38df5c34a8f85b$export$d3dfb8e4810cb555, (v) => $2e38df5c34a8f85b$export$d3dfb8e4810cb555 = v);
$parcel$export(module.exports, "unstable_getFirstCallbackNode", () => $2e38df5c34a8f85b$export$839f9183b0465a69, (v) => $2e38df5c34a8f85b$export$839f9183b0465a69 = v);
$parcel$export(module.exports, "unstable_next", () => $2e38df5c34a8f85b$export$72fdf0e06517287b, (v) => $2e38df5c34a8f85b$export$72fdf0e06517287b = v);
$parcel$export(module.exports, "unstable_pauseExecution", () => $2e38df5c34a8f85b$export$4b844e58a3e414b4, (v) => $2e38df5c34a8f85b$export$4b844e58a3e414b4 = v);
$parcel$export(module.exports, "unstable_requestPaint", () => $2e38df5c34a8f85b$export$816d2913ae6b83b1, (v) => $2e38df5c34a8f85b$export$816d2913ae6b83b1 = v);
$parcel$export(module.exports, "unstable_runWithPriority", () => $2e38df5c34a8f85b$export$61bcfe829111a1d0, (v) => $2e38df5c34a8f85b$export$61bcfe829111a1d0 = v);
$parcel$export(module.exports, "unstable_scheduleCallback", () => $2e38df5c34a8f85b$export$7ee8c9beb337bc3f, (v) => $2e38df5c34a8f85b$export$7ee8c9beb337bc3f = v);
$parcel$export(module.exports, "unstable_shouldYield", () => $2e38df5c34a8f85b$export$b5836b71941fa3ed, (v) => $2e38df5c34a8f85b$export$b5836b71941fa3ed = v);
$parcel$export(module.exports, "unstable_wrapCallback", () => $2e38df5c34a8f85b$export$cf845f2c119da08a, (v) => $2e38df5c34a8f85b$export$cf845f2c119da08a = v);
/**
 * @license React
 * scheduler.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $2e38df5c34a8f85b$export$c4744153514ff05d;
var $2e38df5c34a8f85b$export$3e506c1ccc9cc1a7;
var $2e38df5c34a8f85b$export$e26fe2ed2fa76875;
var $2e38df5c34a8f85b$export$502329bbf4b505b1;
var $2e38df5c34a8f85b$export$6e3807111c4874c4;
var $2e38df5c34a8f85b$export$c27134553091fb3a;
var $2e38df5c34a8f85b$export$33ee1acdc04fd2a2;
var $2e38df5c34a8f85b$export$b00a404bbd5edef2;
var $2e38df5c34a8f85b$export$8352ce38b91d0c62;
var $2e38df5c34a8f85b$export$d66a1c1c77bd778b;
var $2e38df5c34a8f85b$export$d3dfb8e4810cb555;
var $2e38df5c34a8f85b$export$839f9183b0465a69;
var $2e38df5c34a8f85b$export$72fdf0e06517287b;
var $2e38df5c34a8f85b$export$4b844e58a3e414b4;
var $2e38df5c34a8f85b$export$816d2913ae6b83b1;
var $2e38df5c34a8f85b$export$61bcfe829111a1d0;
var $2e38df5c34a8f85b$export$7ee8c9beb337bc3f;
var $2e38df5c34a8f85b$export$b5836b71941fa3ed;
var $2e38df5c34a8f85b$export$cf845f2c119da08a;
"use strict";
function $2e38df5c34a8f85b$var$f(a, b) {
    var c = a.length;
    a.push(b);
    a: for(; 0 < c;){
        var d = c - 1 >>> 1, e = a[d];
        if (0 < $2e38df5c34a8f85b$var$g(e, b)) a[d] = b, a[c] = e, c = d;
        else break a;
    }
}
function $2e38df5c34a8f85b$var$h(a) {
    return 0 === a.length ? null : a[0];
}
function $2e38df5c34a8f85b$var$k(a) {
    if (0 === a.length) return null;
    var b = a[0], c = a.pop();
    if (c !== b) {
        a[0] = c;
        a: for(var d = 0, e = a.length, w = e >>> 1; d < w;){
            var m = 2 * (d + 1) - 1, C = a[m], n = m + 1, x = a[n];
            if (0 > $2e38df5c34a8f85b$var$g(C, c)) n < e && 0 > $2e38df5c34a8f85b$var$g(x, C) ? (a[d] = x, a[n] = c, d = n) : (a[d] = C, a[m] = c, d = m);
            else if (n < e && 0 > $2e38df5c34a8f85b$var$g(x, c)) a[d] = x, a[n] = c, d = n;
            else break a;
        }
    }
    return b;
}
function $2e38df5c34a8f85b$var$g(a, b) {
    var c = a.sortIndex - b.sortIndex;
    return 0 !== c ? c : a.id - b.id;
}
if ("object" === typeof performance && "function" === typeof performance.now) {
    var $2e38df5c34a8f85b$var$l = performance;
    $2e38df5c34a8f85b$export$c4744153514ff05d = function() {
        return $2e38df5c34a8f85b$var$l.now();
    };
} else {
    var $2e38df5c34a8f85b$var$p = Date, $2e38df5c34a8f85b$var$q = $2e38df5c34a8f85b$var$p.now();
    $2e38df5c34a8f85b$export$c4744153514ff05d = function() {
        return $2e38df5c34a8f85b$var$p.now() - $2e38df5c34a8f85b$var$q;
    };
}
var $2e38df5c34a8f85b$var$r = [], $2e38df5c34a8f85b$var$t = [], $2e38df5c34a8f85b$var$u = 1, $2e38df5c34a8f85b$var$v = null, $2e38df5c34a8f85b$var$y = 3, $2e38df5c34a8f85b$var$z = !1, $2e38df5c34a8f85b$var$A = !1, $2e38df5c34a8f85b$var$B = !1, $2e38df5c34a8f85b$var$D = "function" === typeof setTimeout ? setTimeout : null, $2e38df5c34a8f85b$var$E = "function" === typeof clearTimeout ? clearTimeout : null, $2e38df5c34a8f85b$var$F = "undefined" !== typeof setImmediate ? setImmediate : null;
"undefined" !== typeof navigator && void 0 !== navigator.scheduling && void 0 !== navigator.scheduling.isInputPending && navigator.scheduling.isInputPending.bind(navigator.scheduling);
function $2e38df5c34a8f85b$var$G(a) {
    for(var b = $2e38df5c34a8f85b$var$h($2e38df5c34a8f85b$var$t); null !== b;){
        if (null === b.callback) $2e38df5c34a8f85b$var$k($2e38df5c34a8f85b$var$t);
        else if (b.startTime <= a) $2e38df5c34a8f85b$var$k($2e38df5c34a8f85b$var$t), b.sortIndex = b.expirationTime, $2e38df5c34a8f85b$var$f($2e38df5c34a8f85b$var$r, b);
        else break;
        b = $2e38df5c34a8f85b$var$h($2e38df5c34a8f85b$var$t);
    }
}
function $2e38df5c34a8f85b$var$H(a) {
    $2e38df5c34a8f85b$var$B = !1;
    $2e38df5c34a8f85b$var$G(a);
    if (!$2e38df5c34a8f85b$var$A) {
        if (null !== $2e38df5c34a8f85b$var$h($2e38df5c34a8f85b$var$r)) $2e38df5c34a8f85b$var$A = !0, $2e38df5c34a8f85b$var$I($2e38df5c34a8f85b$var$J);
        else {
            var b = $2e38df5c34a8f85b$var$h($2e38df5c34a8f85b$var$t);
            null !== b && $2e38df5c34a8f85b$var$K($2e38df5c34a8f85b$var$H, b.startTime - a);
        }
    }
}
function $2e38df5c34a8f85b$var$J(a, b) {
    $2e38df5c34a8f85b$var$A = !1;
    $2e38df5c34a8f85b$var$B && ($2e38df5c34a8f85b$var$B = !1, $2e38df5c34a8f85b$var$E($2e38df5c34a8f85b$var$L), $2e38df5c34a8f85b$var$L = -1);
    $2e38df5c34a8f85b$var$z = !0;
    var c = $2e38df5c34a8f85b$var$y;
    try {
        $2e38df5c34a8f85b$var$G(b);
        for($2e38df5c34a8f85b$var$v = $2e38df5c34a8f85b$var$h($2e38df5c34a8f85b$var$r); null !== $2e38df5c34a8f85b$var$v && (!($2e38df5c34a8f85b$var$v.expirationTime > b) || a && !$2e38df5c34a8f85b$var$M());){
            var d = $2e38df5c34a8f85b$var$v.callback;
            if ("function" === typeof d) {
                $2e38df5c34a8f85b$var$v.callback = null;
                $2e38df5c34a8f85b$var$y = $2e38df5c34a8f85b$var$v.priorityLevel;
                var e = d($2e38df5c34a8f85b$var$v.expirationTime <= b);
                b = $2e38df5c34a8f85b$export$c4744153514ff05d();
                "function" === typeof e ? $2e38df5c34a8f85b$var$v.callback = e : $2e38df5c34a8f85b$var$v === $2e38df5c34a8f85b$var$h($2e38df5c34a8f85b$var$r) && $2e38df5c34a8f85b$var$k($2e38df5c34a8f85b$var$r);
                $2e38df5c34a8f85b$var$G(b);
            } else $2e38df5c34a8f85b$var$k($2e38df5c34a8f85b$var$r);
            $2e38df5c34a8f85b$var$v = $2e38df5c34a8f85b$var$h($2e38df5c34a8f85b$var$r);
        }
        if (null !== $2e38df5c34a8f85b$var$v) var w = !0;
        else {
            var m = $2e38df5c34a8f85b$var$h($2e38df5c34a8f85b$var$t);
            null !== m && $2e38df5c34a8f85b$var$K($2e38df5c34a8f85b$var$H, m.startTime - b);
            w = !1;
        }
        return w;
    } finally{
        $2e38df5c34a8f85b$var$v = null, $2e38df5c34a8f85b$var$y = c, $2e38df5c34a8f85b$var$z = !1;
    }
}
var $2e38df5c34a8f85b$var$N = !1, $2e38df5c34a8f85b$var$O = null, $2e38df5c34a8f85b$var$L = -1, $2e38df5c34a8f85b$var$P = 5, $2e38df5c34a8f85b$var$Q = -1;
function $2e38df5c34a8f85b$var$M() {
    return $2e38df5c34a8f85b$export$c4744153514ff05d() - $2e38df5c34a8f85b$var$Q < $2e38df5c34a8f85b$var$P ? !1 : !0;
}
function $2e38df5c34a8f85b$var$R() {
    if (null !== $2e38df5c34a8f85b$var$O) {
        var a = $2e38df5c34a8f85b$export$c4744153514ff05d();
        $2e38df5c34a8f85b$var$Q = a;
        var b = !0;
        try {
            b = $2e38df5c34a8f85b$var$O(!0, a);
        } finally{
            b ? $2e38df5c34a8f85b$var$S() : ($2e38df5c34a8f85b$var$N = !1, $2e38df5c34a8f85b$var$O = null);
        }
    } else $2e38df5c34a8f85b$var$N = !1;
}
var $2e38df5c34a8f85b$var$S;
if ("function" === typeof $2e38df5c34a8f85b$var$F) $2e38df5c34a8f85b$var$S = function() {
    $2e38df5c34a8f85b$var$F($2e38df5c34a8f85b$var$R);
};
else if ("undefined" !== typeof MessageChannel) {
    var $2e38df5c34a8f85b$var$T = new MessageChannel, $2e38df5c34a8f85b$var$U = $2e38df5c34a8f85b$var$T.port2;
    $2e38df5c34a8f85b$var$T.port1.onmessage = $2e38df5c34a8f85b$var$R;
    $2e38df5c34a8f85b$var$S = function() {
        $2e38df5c34a8f85b$var$U.postMessage(null);
    };
} else $2e38df5c34a8f85b$var$S = function() {
    $2e38df5c34a8f85b$var$D($2e38df5c34a8f85b$var$R, 0);
};
function $2e38df5c34a8f85b$var$I(a) {
    $2e38df5c34a8f85b$var$O = a;
    $2e38df5c34a8f85b$var$N || ($2e38df5c34a8f85b$var$N = !0, $2e38df5c34a8f85b$var$S());
}
function $2e38df5c34a8f85b$var$K(a, b) {
    $2e38df5c34a8f85b$var$L = $2e38df5c34a8f85b$var$D(function() {
        a($2e38df5c34a8f85b$export$c4744153514ff05d());
    }, b);
}
$2e38df5c34a8f85b$export$3e506c1ccc9cc1a7 = 5;
$2e38df5c34a8f85b$export$e26fe2ed2fa76875 = 1;
$2e38df5c34a8f85b$export$502329bbf4b505b1 = 4;
$2e38df5c34a8f85b$export$6e3807111c4874c4 = 3;
$2e38df5c34a8f85b$export$c27134553091fb3a = null;
$2e38df5c34a8f85b$export$33ee1acdc04fd2a2 = 2;
$2e38df5c34a8f85b$export$b00a404bbd5edef2 = function(a) {
    a.callback = null;
};
$2e38df5c34a8f85b$export$8352ce38b91d0c62 = function() {
    $2e38df5c34a8f85b$var$A || $2e38df5c34a8f85b$var$z || ($2e38df5c34a8f85b$var$A = !0, $2e38df5c34a8f85b$var$I($2e38df5c34a8f85b$var$J));
};
$2e38df5c34a8f85b$export$d66a1c1c77bd778b = function(a) {
    0 > a || 125 < a ? console.error("forceFrameRate takes a positive int between 0 and 125, forcing frame rates higher than 125 fps is not supported") : $2e38df5c34a8f85b$var$P = 0 < a ? Math.floor(1E3 / a) : 5;
};
$2e38df5c34a8f85b$export$d3dfb8e4810cb555 = function() {
    return $2e38df5c34a8f85b$var$y;
};
$2e38df5c34a8f85b$export$839f9183b0465a69 = function() {
    return $2e38df5c34a8f85b$var$h($2e38df5c34a8f85b$var$r);
};
$2e38df5c34a8f85b$export$72fdf0e06517287b = function(a) {
    switch($2e38df5c34a8f85b$var$y){
        case 1:
        case 2:
        case 3:
            var b = 3;
            break;
        default:
            b = $2e38df5c34a8f85b$var$y;
    }
    var c = $2e38df5c34a8f85b$var$y;
    $2e38df5c34a8f85b$var$y = b;
    try {
        return a();
    } finally{
        $2e38df5c34a8f85b$var$y = c;
    }
};
$2e38df5c34a8f85b$export$4b844e58a3e414b4 = function() {};
$2e38df5c34a8f85b$export$816d2913ae6b83b1 = function() {};
$2e38df5c34a8f85b$export$61bcfe829111a1d0 = function(a, b) {
    switch(a){
        case 1:
        case 2:
        case 3:
        case 4:
        case 5:
            break;
        default:
            a = 3;
    }
    var c = $2e38df5c34a8f85b$var$y;
    $2e38df5c34a8f85b$var$y = a;
    try {
        return b();
    } finally{
        $2e38df5c34a8f85b$var$y = c;
    }
};
$2e38df5c34a8f85b$export$7ee8c9beb337bc3f = function(a, b, c) {
    var d = $2e38df5c34a8f85b$export$c4744153514ff05d();
    "object" === typeof c && null !== c ? (c = c.delay, c = "number" === typeof c && 0 < c ? d + c : d) : c = d;
    switch(a){
        case 1:
            var e = -1;
            break;
        case 2:
            e = 250;
            break;
        case 5:
            e = 1073741823;
            break;
        case 4:
            e = 1E4;
            break;
        default:
            e = 5E3;
    }
    e = c + e;
    a = {
        id: $2e38df5c34a8f85b$var$u++,
        callback: b,
        priorityLevel: a,
        startTime: c,
        expirationTime: e,
        sortIndex: -1
    };
    c > d ? (a.sortIndex = c, $2e38df5c34a8f85b$var$f($2e38df5c34a8f85b$var$t, a), null === $2e38df5c34a8f85b$var$h($2e38df5c34a8f85b$var$r) && a === $2e38df5c34a8f85b$var$h($2e38df5c34a8f85b$var$t) && ($2e38df5c34a8f85b$var$B ? ($2e38df5c34a8f85b$var$E($2e38df5c34a8f85b$var$L), $2e38df5c34a8f85b$var$L = -1) : $2e38df5c34a8f85b$var$B = !0, $2e38df5c34a8f85b$var$K($2e38df5c34a8f85b$var$H, c - d))) : (a.sortIndex = e, $2e38df5c34a8f85b$var$f($2e38df5c34a8f85b$var$r, a), $2e38df5c34a8f85b$var$A || $2e38df5c34a8f85b$var$z || ($2e38df5c34a8f85b$var$A = !0, $2e38df5c34a8f85b$var$I($2e38df5c34a8f85b$var$J)));
    return a;
};
$2e38df5c34a8f85b$export$b5836b71941fa3ed = $2e38df5c34a8f85b$var$M;
$2e38df5c34a8f85b$export$cf845f2c119da08a = function(a) {
    var b = $2e38df5c34a8f85b$var$y;
    return function() {
        var c = $2e38df5c34a8f85b$var$y;
        $2e38df5c34a8f85b$var$y = b;
        try {
            return a.apply(this, arguments);
        } finally{
            $2e38df5c34a8f85b$var$y = c;
        }
    };
};

});



parcelRegister("jXDQW", function(module, exports) {

$parcel$export(module.exports, "renderToNodeStream", () => $e88270f38a9f2d30$export$307591e98609eddd, (v) => $e88270f38a9f2d30$export$307591e98609eddd = v);
$parcel$export(module.exports, "renderToStaticMarkup", () => $e88270f38a9f2d30$export$eb3a06aef9e6ee51, (v) => $e88270f38a9f2d30$export$eb3a06aef9e6ee51 = v);
$parcel$export(module.exports, "renderToStaticNodeStream", () => $e88270f38a9f2d30$export$b23711c915539651, (v) => $e88270f38a9f2d30$export$b23711c915539651 = v);
$parcel$export(module.exports, "renderToString", () => $e88270f38a9f2d30$export$80e7718417253a51, (v) => $e88270f38a9f2d30$export$80e7718417253a51 = v);
$parcel$export(module.exports, "version", () => $e88270f38a9f2d30$export$83d89fbfd8236492, (v) => $e88270f38a9f2d30$export$83d89fbfd8236492 = v);
/**
 * @license React
 * react-dom-server-legacy.browser.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $e88270f38a9f2d30$export$307591e98609eddd;
var $e88270f38a9f2d30$export$eb3a06aef9e6ee51;
var $e88270f38a9f2d30$export$b23711c915539651;
var $e88270f38a9f2d30$export$80e7718417253a51;
var $e88270f38a9f2d30$export$83d89fbfd8236492;
"use strict";

var $cWbtJ = parcelRequire("cWbtJ");
function $e88270f38a9f2d30$var$l(a) {
    for(var b = "https://reactjs.org/docs/error-decoder.html?invariant=" + a, c = 1; c < arguments.length; c++)b += "&args[]=" + encodeURIComponent(arguments[c]);
    return "Minified React error #" + a + "; visit " + b + " for the full message or use the non-minified dev environment for full errors and additional helpful warnings.";
}
var $e88270f38a9f2d30$var$p = Object.prototype.hasOwnProperty, $e88270f38a9f2d30$var$fa = /^[:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD][:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD\-.0-9\u00B7\u0300-\u036F\u203F-\u2040]*$/, $e88270f38a9f2d30$var$ha = {}, $e88270f38a9f2d30$var$ia = {};
function $e88270f38a9f2d30$var$ja(a) {
    if ($e88270f38a9f2d30$var$p.call($e88270f38a9f2d30$var$ia, a)) return !0;
    if ($e88270f38a9f2d30$var$p.call($e88270f38a9f2d30$var$ha, a)) return !1;
    if ($e88270f38a9f2d30$var$fa.test(a)) return $e88270f38a9f2d30$var$ia[a] = !0;
    $e88270f38a9f2d30$var$ha[a] = !0;
    return !1;
}
function $e88270f38a9f2d30$var$r(a, b, c, d, f, e, g) {
    this.acceptsBooleans = 2 === b || 3 === b || 4 === b;
    this.attributeName = d;
    this.attributeNamespace = f;
    this.mustUseProperty = c;
    this.propertyName = a;
    this.type = b;
    this.sanitizeURL = e;
    this.removeEmptyString = g;
}
var $e88270f38a9f2d30$var$t = {};
"children dangerouslySetInnerHTML defaultValue defaultChecked innerHTML suppressContentEditableWarning suppressHydrationWarning style".split(" ").forEach(function(a) {
    $e88270f38a9f2d30$var$t[a] = new $e88270f38a9f2d30$var$r(a, 0, !1, a, null, !1, !1);
});
[
    [
        "acceptCharset",
        "accept-charset"
    ],
    [
        "className",
        "class"
    ],
    [
        "htmlFor",
        "for"
    ],
    [
        "httpEquiv",
        "http-equiv"
    ]
].forEach(function(a) {
    var b = a[0];
    $e88270f38a9f2d30$var$t[b] = new $e88270f38a9f2d30$var$r(b, 1, !1, a[1], null, !1, !1);
});
[
    "contentEditable",
    "draggable",
    "spellCheck",
    "value"
].forEach(function(a) {
    $e88270f38a9f2d30$var$t[a] = new $e88270f38a9f2d30$var$r(a, 2, !1, a.toLowerCase(), null, !1, !1);
});
[
    "autoReverse",
    "externalResourcesRequired",
    "focusable",
    "preserveAlpha"
].forEach(function(a) {
    $e88270f38a9f2d30$var$t[a] = new $e88270f38a9f2d30$var$r(a, 2, !1, a, null, !1, !1);
});
"allowFullScreen async autoFocus autoPlay controls default defer disabled disablePictureInPicture disableRemotePlayback formNoValidate hidden loop noModule noValidate open playsInline readOnly required reversed scoped seamless itemScope".split(" ").forEach(function(a) {
    $e88270f38a9f2d30$var$t[a] = new $e88270f38a9f2d30$var$r(a, 3, !1, a.toLowerCase(), null, !1, !1);
});
[
    "checked",
    "multiple",
    "muted",
    "selected"
].forEach(function(a) {
    $e88270f38a9f2d30$var$t[a] = new $e88270f38a9f2d30$var$r(a, 3, !0, a, null, !1, !1);
});
[
    "capture",
    "download"
].forEach(function(a) {
    $e88270f38a9f2d30$var$t[a] = new $e88270f38a9f2d30$var$r(a, 4, !1, a, null, !1, !1);
});
[
    "cols",
    "rows",
    "size",
    "span"
].forEach(function(a) {
    $e88270f38a9f2d30$var$t[a] = new $e88270f38a9f2d30$var$r(a, 6, !1, a, null, !1, !1);
});
[
    "rowSpan",
    "start"
].forEach(function(a) {
    $e88270f38a9f2d30$var$t[a] = new $e88270f38a9f2d30$var$r(a, 5, !1, a.toLowerCase(), null, !1, !1);
});
var $e88270f38a9f2d30$var$ka = /[\-:]([a-z])/g;
function $e88270f38a9f2d30$var$la(a) {
    return a[1].toUpperCase();
}
"accent-height alignment-baseline arabic-form baseline-shift cap-height clip-path clip-rule color-interpolation color-interpolation-filters color-profile color-rendering dominant-baseline enable-background fill-opacity fill-rule flood-color flood-opacity font-family font-size font-size-adjust font-stretch font-style font-variant font-weight glyph-name glyph-orientation-horizontal glyph-orientation-vertical horiz-adv-x horiz-origin-x image-rendering letter-spacing lighting-color marker-end marker-mid marker-start overline-position overline-thickness paint-order panose-1 pointer-events rendering-intent shape-rendering stop-color stop-opacity strikethrough-position strikethrough-thickness stroke-dasharray stroke-dashoffset stroke-linecap stroke-linejoin stroke-miterlimit stroke-opacity stroke-width text-anchor text-decoration text-rendering underline-position underline-thickness unicode-bidi unicode-range units-per-em v-alphabetic v-hanging v-ideographic v-mathematical vector-effect vert-adv-y vert-origin-x vert-origin-y word-spacing writing-mode xmlns:xlink x-height".split(" ").forEach(function(a) {
    var b = a.replace($e88270f38a9f2d30$var$ka, $e88270f38a9f2d30$var$la);
    $e88270f38a9f2d30$var$t[b] = new $e88270f38a9f2d30$var$r(b, 1, !1, a, null, !1, !1);
});
"xlink:actuate xlink:arcrole xlink:role xlink:show xlink:title xlink:type".split(" ").forEach(function(a) {
    var b = a.replace($e88270f38a9f2d30$var$ka, $e88270f38a9f2d30$var$la);
    $e88270f38a9f2d30$var$t[b] = new $e88270f38a9f2d30$var$r(b, 1, !1, a, "http://www.w3.org/1999/xlink", !1, !1);
});
[
    "xml:base",
    "xml:lang",
    "xml:space"
].forEach(function(a) {
    var b = a.replace($e88270f38a9f2d30$var$ka, $e88270f38a9f2d30$var$la);
    $e88270f38a9f2d30$var$t[b] = new $e88270f38a9f2d30$var$r(b, 1, !1, a, "http://www.w3.org/XML/1998/namespace", !1, !1);
});
[
    "tabIndex",
    "crossOrigin"
].forEach(function(a) {
    $e88270f38a9f2d30$var$t[a] = new $e88270f38a9f2d30$var$r(a, 1, !1, a.toLowerCase(), null, !1, !1);
});
$e88270f38a9f2d30$var$t.xlinkHref = new $e88270f38a9f2d30$var$r("xlinkHref", 1, !1, "xlink:href", "http://www.w3.org/1999/xlink", !0, !1);
[
    "src",
    "href",
    "action",
    "formAction"
].forEach(function(a) {
    $e88270f38a9f2d30$var$t[a] = new $e88270f38a9f2d30$var$r(a, 1, !1, a.toLowerCase(), null, !0, !0);
});
var $e88270f38a9f2d30$var$u = {
    animationIterationCount: !0,
    aspectRatio: !0,
    borderImageOutset: !0,
    borderImageSlice: !0,
    borderImageWidth: !0,
    boxFlex: !0,
    boxFlexGroup: !0,
    boxOrdinalGroup: !0,
    columnCount: !0,
    columns: !0,
    flex: !0,
    flexGrow: !0,
    flexPositive: !0,
    flexShrink: !0,
    flexNegative: !0,
    flexOrder: !0,
    gridArea: !0,
    gridRow: !0,
    gridRowEnd: !0,
    gridRowSpan: !0,
    gridRowStart: !0,
    gridColumn: !0,
    gridColumnEnd: !0,
    gridColumnSpan: !0,
    gridColumnStart: !0,
    fontWeight: !0,
    lineClamp: !0,
    lineHeight: !0,
    opacity: !0,
    order: !0,
    orphans: !0,
    tabSize: !0,
    widows: !0,
    zIndex: !0,
    zoom: !0,
    fillOpacity: !0,
    floodOpacity: !0,
    stopOpacity: !0,
    strokeDasharray: !0,
    strokeDashoffset: !0,
    strokeMiterlimit: !0,
    strokeOpacity: !0,
    strokeWidth: !0
}, $e88270f38a9f2d30$var$ma = [
    "Webkit",
    "ms",
    "Moz",
    "O"
];
Object.keys($e88270f38a9f2d30$var$u).forEach(function(a) {
    $e88270f38a9f2d30$var$ma.forEach(function(b) {
        b = b + a.charAt(0).toUpperCase() + a.substring(1);
        $e88270f38a9f2d30$var$u[b] = $e88270f38a9f2d30$var$u[a];
    });
});
var $e88270f38a9f2d30$var$na = /["'&<>]/;
function $e88270f38a9f2d30$var$v(a) {
    if ("boolean" === typeof a || "number" === typeof a) return "" + a;
    a = "" + a;
    var b = $e88270f38a9f2d30$var$na.exec(a);
    if (b) {
        var c = "", d, f = 0;
        for(d = b.index; d < a.length; d++){
            switch(a.charCodeAt(d)){
                case 34:
                    b = "&quot;";
                    break;
                case 38:
                    b = "&amp;";
                    break;
                case 39:
                    b = "&#x27;";
                    break;
                case 60:
                    b = "&lt;";
                    break;
                case 62:
                    b = "&gt;";
                    break;
                default:
                    continue;
            }
            f !== d && (c += a.substring(f, d));
            f = d + 1;
            c += b;
        }
        a = f !== d ? c + a.substring(f, d) : c;
    }
    return a;
}
var $e88270f38a9f2d30$var$oa = /([A-Z])/g, $e88270f38a9f2d30$var$pa = /^ms-/, $e88270f38a9f2d30$var$qa = Array.isArray;
function $e88270f38a9f2d30$var$w(a, b) {
    return {
        insertionMode: a,
        selectedValue: b
    };
}
function $e88270f38a9f2d30$var$ra(a, b, c) {
    switch(b){
        case "select":
            return $e88270f38a9f2d30$var$w(1, null != c.value ? c.value : c.defaultValue);
        case "svg":
            return $e88270f38a9f2d30$var$w(2, null);
        case "math":
            return $e88270f38a9f2d30$var$w(3, null);
        case "foreignObject":
            return $e88270f38a9f2d30$var$w(1, null);
        case "table":
            return $e88270f38a9f2d30$var$w(4, null);
        case "thead":
        case "tbody":
        case "tfoot":
            return $e88270f38a9f2d30$var$w(5, null);
        case "colgroup":
            return $e88270f38a9f2d30$var$w(7, null);
        case "tr":
            return $e88270f38a9f2d30$var$w(6, null);
    }
    return 4 <= a.insertionMode || 0 === a.insertionMode ? $e88270f38a9f2d30$var$w(1, null) : a;
}
var $e88270f38a9f2d30$var$sa = new Map;
function $e88270f38a9f2d30$var$ta(a, b, c) {
    if ("object" !== typeof c) throw Error($e88270f38a9f2d30$var$l(62));
    b = !0;
    for(var d in c)if ($e88270f38a9f2d30$var$p.call(c, d)) {
        var f = c[d];
        if (null != f && "boolean" !== typeof f && "" !== f) {
            if (0 === d.indexOf("--")) {
                var e = $e88270f38a9f2d30$var$v(d);
                f = $e88270f38a9f2d30$var$v(("" + f).trim());
            } else {
                e = d;
                var g = $e88270f38a9f2d30$var$sa.get(e);
                void 0 !== g ? e = g : (g = $e88270f38a9f2d30$var$v(e.replace($e88270f38a9f2d30$var$oa, "-$1").toLowerCase().replace($e88270f38a9f2d30$var$pa, "-ms-")), $e88270f38a9f2d30$var$sa.set(e, g), e = g);
                f = "number" === typeof f ? 0 === f || $e88270f38a9f2d30$var$p.call($e88270f38a9f2d30$var$u, d) ? "" + f : f + "px" : $e88270f38a9f2d30$var$v(("" + f).trim());
            }
            b ? (b = !1, a.push(' style="', e, ":", f)) : a.push(";", e, ":", f);
        }
    }
    b || a.push('"');
}
function $e88270f38a9f2d30$var$x(a, b, c, d) {
    switch(c){
        case "style":
            $e88270f38a9f2d30$var$ta(a, b, d);
            return;
        case "defaultValue":
        case "defaultChecked":
        case "innerHTML":
        case "suppressContentEditableWarning":
        case "suppressHydrationWarning":
            return;
    }
    if (!(2 < c.length) || "o" !== c[0] && "O" !== c[0] || "n" !== c[1] && "N" !== c[1]) {
        if (b = $e88270f38a9f2d30$var$t.hasOwnProperty(c) ? $e88270f38a9f2d30$var$t[c] : null, null !== b) {
            switch(typeof d){
                case "function":
                case "symbol":
                    return;
                case "boolean":
                    if (!b.acceptsBooleans) return;
            }
            c = b.attributeName;
            switch(b.type){
                case 3:
                    d && a.push(" ", c, '=""');
                    break;
                case 4:
                    !0 === d ? a.push(" ", c, '=""') : !1 !== d && a.push(" ", c, '="', $e88270f38a9f2d30$var$v(d), '"');
                    break;
                case 5:
                    isNaN(d) || a.push(" ", c, '="', $e88270f38a9f2d30$var$v(d), '"');
                    break;
                case 6:
                    !isNaN(d) && 1 <= d && a.push(" ", c, '="', $e88270f38a9f2d30$var$v(d), '"');
                    break;
                default:
                    b.sanitizeURL && (d = "" + d), a.push(" ", c, '="', $e88270f38a9f2d30$var$v(d), '"');
            }
        } else if ($e88270f38a9f2d30$var$ja(c)) {
            switch(typeof d){
                case "function":
                case "symbol":
                    return;
                case "boolean":
                    if (b = c.toLowerCase().slice(0, 5), "data-" !== b && "aria-" !== b) return;
            }
            a.push(" ", c, '="', $e88270f38a9f2d30$var$v(d), '"');
        }
    }
}
function $e88270f38a9f2d30$var$y(a, b, c) {
    if (null != b) {
        if (null != c) throw Error($e88270f38a9f2d30$var$l(60));
        if ("object" !== typeof b || !("__html" in b)) throw Error($e88270f38a9f2d30$var$l(61));
        b = b.__html;
        null !== b && void 0 !== b && a.push("" + b);
    }
}
function $e88270f38a9f2d30$var$ua(a) {
    var b = "";
    $cWbtJ.Children.forEach(a, function(a) {
        null != a && (b += a);
    });
    return b;
}
function $e88270f38a9f2d30$var$va(a, b, c, d) {
    a.push($e88270f38a9f2d30$var$A(c));
    var f = c = null, e;
    for(e in b)if ($e88270f38a9f2d30$var$p.call(b, e)) {
        var g = b[e];
        if (null != g) switch(e){
            case "children":
                c = g;
                break;
            case "dangerouslySetInnerHTML":
                f = g;
                break;
            default:
                $e88270f38a9f2d30$var$x(a, d, e, g);
        }
    }
    a.push(">");
    $e88270f38a9f2d30$var$y(a, f, c);
    return "string" === typeof c ? (a.push($e88270f38a9f2d30$var$v(c)), null) : c;
}
var $e88270f38a9f2d30$var$wa = /^[a-zA-Z][a-zA-Z:_\.\-\d]*$/, $e88270f38a9f2d30$var$xa = new Map;
function $e88270f38a9f2d30$var$A(a) {
    var b = $e88270f38a9f2d30$var$xa.get(a);
    if (void 0 === b) {
        if (!$e88270f38a9f2d30$var$wa.test(a)) throw Error($e88270f38a9f2d30$var$l(65, a));
        b = "<" + a;
        $e88270f38a9f2d30$var$xa.set(a, b);
    }
    return b;
}
function $e88270f38a9f2d30$var$ya(a, b, c, d, f) {
    switch(b){
        case "select":
            a.push($e88270f38a9f2d30$var$A("select"));
            var e = null, g = null;
            for(n in c)if ($e88270f38a9f2d30$var$p.call(c, n)) {
                var h = c[n];
                if (null != h) switch(n){
                    case "children":
                        e = h;
                        break;
                    case "dangerouslySetInnerHTML":
                        g = h;
                        break;
                    case "defaultValue":
                    case "value":
                        break;
                    default:
                        $e88270f38a9f2d30$var$x(a, d, n, h);
                }
            }
            a.push(">");
            $e88270f38a9f2d30$var$y(a, g, e);
            return e;
        case "option":
            g = f.selectedValue;
            a.push($e88270f38a9f2d30$var$A("option"));
            var k = h = null, m = null;
            var n = null;
            for(e in c)if ($e88270f38a9f2d30$var$p.call(c, e)) {
                var q = c[e];
                if (null != q) switch(e){
                    case "children":
                        h = q;
                        break;
                    case "selected":
                        m = q;
                        break;
                    case "dangerouslySetInnerHTML":
                        n = q;
                        break;
                    case "value":
                        k = q;
                    default:
                        $e88270f38a9f2d30$var$x(a, d, e, q);
                }
            }
            if (null != g) {
                if (c = null !== k ? "" + k : $e88270f38a9f2d30$var$ua(h), $e88270f38a9f2d30$var$qa(g)) {
                    for(d = 0; d < g.length; d++)if ("" + g[d] === c) {
                        a.push(' selected=""');
                        break;
                    }
                } else "" + g === c && a.push(' selected=""');
            } else m && a.push(' selected=""');
            a.push(">");
            $e88270f38a9f2d30$var$y(a, n, h);
            return h;
        case "textarea":
            a.push($e88270f38a9f2d30$var$A("textarea"));
            n = g = e = null;
            for(h in c)if ($e88270f38a9f2d30$var$p.call(c, h) && (k = c[h], null != k)) switch(h){
                case "children":
                    n = k;
                    break;
                case "value":
                    e = k;
                    break;
                case "defaultValue":
                    g = k;
                    break;
                case "dangerouslySetInnerHTML":
                    throw Error($e88270f38a9f2d30$var$l(91));
                default:
                    $e88270f38a9f2d30$var$x(a, d, h, k);
            }
            null === e && null !== g && (e = g);
            a.push(">");
            if (null != n) {
                if (null != e) throw Error($e88270f38a9f2d30$var$l(92));
                if ($e88270f38a9f2d30$var$qa(n) && 1 < n.length) throw Error($e88270f38a9f2d30$var$l(93));
                e = "" + n;
            }
            "string" === typeof e && "\n" === e[0] && a.push("\n");
            null !== e && a.push($e88270f38a9f2d30$var$v("" + e));
            return null;
        case "input":
            a.push($e88270f38a9f2d30$var$A("input"));
            k = n = h = e = null;
            for(g in c)if ($e88270f38a9f2d30$var$p.call(c, g) && (m = c[g], null != m)) switch(g){
                case "children":
                case "dangerouslySetInnerHTML":
                    throw Error($e88270f38a9f2d30$var$l(399, "input"));
                case "defaultChecked":
                    k = m;
                    break;
                case "defaultValue":
                    h = m;
                    break;
                case "checked":
                    n = m;
                    break;
                case "value":
                    e = m;
                    break;
                default:
                    $e88270f38a9f2d30$var$x(a, d, g, m);
            }
            null !== n ? $e88270f38a9f2d30$var$x(a, d, "checked", n) : null !== k && $e88270f38a9f2d30$var$x(a, d, "checked", k);
            null !== e ? $e88270f38a9f2d30$var$x(a, d, "value", e) : null !== h && $e88270f38a9f2d30$var$x(a, d, "value", h);
            a.push("/>");
            return null;
        case "menuitem":
            a.push($e88270f38a9f2d30$var$A("menuitem"));
            for(var C in c)if ($e88270f38a9f2d30$var$p.call(c, C) && (e = c[C], null != e)) switch(C){
                case "children":
                case "dangerouslySetInnerHTML":
                    throw Error($e88270f38a9f2d30$var$l(400));
                default:
                    $e88270f38a9f2d30$var$x(a, d, C, e);
            }
            a.push(">");
            return null;
        case "title":
            a.push($e88270f38a9f2d30$var$A("title"));
            e = null;
            for(q in c)if ($e88270f38a9f2d30$var$p.call(c, q) && (g = c[q], null != g)) switch(q){
                case "children":
                    e = g;
                    break;
                case "dangerouslySetInnerHTML":
                    throw Error($e88270f38a9f2d30$var$l(434));
                default:
                    $e88270f38a9f2d30$var$x(a, d, q, g);
            }
            a.push(">");
            return e;
        case "listing":
        case "pre":
            a.push($e88270f38a9f2d30$var$A(b));
            g = e = null;
            for(k in c)if ($e88270f38a9f2d30$var$p.call(c, k) && (h = c[k], null != h)) switch(k){
                case "children":
                    e = h;
                    break;
                case "dangerouslySetInnerHTML":
                    g = h;
                    break;
                default:
                    $e88270f38a9f2d30$var$x(a, d, k, h);
            }
            a.push(">");
            if (null != g) {
                if (null != e) throw Error($e88270f38a9f2d30$var$l(60));
                if ("object" !== typeof g || !("__html" in g)) throw Error($e88270f38a9f2d30$var$l(61));
                c = g.__html;
                null !== c && void 0 !== c && ("string" === typeof c && 0 < c.length && "\n" === c[0] ? a.push("\n", c) : a.push("" + c));
            }
            "string" === typeof e && "\n" === e[0] && a.push("\n");
            return e;
        case "area":
        case "base":
        case "br":
        case "col":
        case "embed":
        case "hr":
        case "img":
        case "keygen":
        case "link":
        case "meta":
        case "param":
        case "source":
        case "track":
        case "wbr":
            a.push($e88270f38a9f2d30$var$A(b));
            for(var D in c)if ($e88270f38a9f2d30$var$p.call(c, D) && (e = c[D], null != e)) switch(D){
                case "children":
                case "dangerouslySetInnerHTML":
                    throw Error($e88270f38a9f2d30$var$l(399, b));
                default:
                    $e88270f38a9f2d30$var$x(a, d, D, e);
            }
            a.push("/>");
            return null;
        case "annotation-xml":
        case "color-profile":
        case "font-face":
        case "font-face-src":
        case "font-face-uri":
        case "font-face-format":
        case "font-face-name":
        case "missing-glyph":
            return $e88270f38a9f2d30$var$va(a, c, b, d);
        case "html":
            return 0 === f.insertionMode && a.push("<!DOCTYPE html>"), $e88270f38a9f2d30$var$va(a, c, b, d);
        default:
            if (-1 === b.indexOf("-") && "string" !== typeof c.is) return $e88270f38a9f2d30$var$va(a, c, b, d);
            a.push($e88270f38a9f2d30$var$A(b));
            g = e = null;
            for(m in c)if ($e88270f38a9f2d30$var$p.call(c, m) && (h = c[m], null != h)) switch(m){
                case "children":
                    e = h;
                    break;
                case "dangerouslySetInnerHTML":
                    g = h;
                    break;
                case "style":
                    $e88270f38a9f2d30$var$ta(a, d, h);
                    break;
                case "suppressContentEditableWarning":
                case "suppressHydrationWarning":
                    break;
                default:
                    $e88270f38a9f2d30$var$ja(m) && "function" !== typeof h && "symbol" !== typeof h && a.push(" ", m, '="', $e88270f38a9f2d30$var$v(h), '"');
            }
            a.push(">");
            $e88270f38a9f2d30$var$y(a, g, e);
            return e;
    }
}
function $e88270f38a9f2d30$var$za(a, b, c) {
    a.push('<!--$?--><template id="');
    if (null === c) throw Error($e88270f38a9f2d30$var$l(395));
    a.push(c);
    return a.push('"></template>');
}
function $e88270f38a9f2d30$var$Aa(a, b, c, d) {
    switch(c.insertionMode){
        case 0:
        case 1:
            return a.push('<div hidden id="'), a.push(b.segmentPrefix), b = d.toString(16), a.push(b), a.push('">');
        case 2:
            return a.push('<svg aria-hidden="true" style="display:none" id="'), a.push(b.segmentPrefix), b = d.toString(16), a.push(b), a.push('">');
        case 3:
            return a.push('<math aria-hidden="true" style="display:none" id="'), a.push(b.segmentPrefix), b = d.toString(16), a.push(b), a.push('">');
        case 4:
            return a.push('<table hidden id="'), a.push(b.segmentPrefix), b = d.toString(16), a.push(b), a.push('">');
        case 5:
            return a.push('<table hidden><tbody id="'), a.push(b.segmentPrefix), b = d.toString(16), a.push(b), a.push('">');
        case 6:
            return a.push('<table hidden><tr id="'), a.push(b.segmentPrefix), b = d.toString(16), a.push(b), a.push('">');
        case 7:
            return a.push('<table hidden><colgroup id="'), a.push(b.segmentPrefix), b = d.toString(16), a.push(b), a.push('">');
        default:
            throw Error($e88270f38a9f2d30$var$l(397));
    }
}
function $e88270f38a9f2d30$var$Ba(a, b) {
    switch(b.insertionMode){
        case 0:
        case 1:
            return a.push("</div>");
        case 2:
            return a.push("</svg>");
        case 3:
            return a.push("</math>");
        case 4:
            return a.push("</table>");
        case 5:
            return a.push("</tbody></table>");
        case 6:
            return a.push("</tr></table>");
        case 7:
            return a.push("</colgroup></table>");
        default:
            throw Error($e88270f38a9f2d30$var$l(397));
    }
}
var $e88270f38a9f2d30$var$Ca = /[<\u2028\u2029]/g;
function $e88270f38a9f2d30$var$Da(a) {
    return JSON.stringify(a).replace($e88270f38a9f2d30$var$Ca, function(a) {
        switch(a){
            case "<":
                return "\\u003c";
            case "\u2028":
                return "\\u2028";
            case "\u2029":
                return "\\u2029";
            default:
                throw Error("escapeJSStringsForInstructionScripts encountered a match it does not know how to replace. this means the match regex and the replacement characters are no longer in sync. This is a bug in React");
        }
    });
}
function $e88270f38a9f2d30$var$Ea(a, b) {
    b = void 0 === b ? "" : b;
    return {
        bootstrapChunks: [],
        startInlineScript: "<script>",
        placeholderPrefix: b + "P:",
        segmentPrefix: b + "S:",
        boundaryPrefix: b + "B:",
        idPrefix: b,
        nextSuspenseID: 0,
        sentCompleteSegmentFunction: !1,
        sentCompleteBoundaryFunction: !1,
        sentClientRenderFunction: !1,
        generateStaticMarkup: a
    };
}
function $e88270f38a9f2d30$var$Fa(a, b, c, d) {
    if (c.generateStaticMarkup) return a.push($e88270f38a9f2d30$var$v(b)), !1;
    "" === b ? a = d : (d && a.push("<!-- -->"), a.push($e88270f38a9f2d30$var$v(b)), a = !0);
    return a;
}
var $e88270f38a9f2d30$var$B = Object.assign, $e88270f38a9f2d30$var$Ga = Symbol.for("react.element"), $e88270f38a9f2d30$var$Ha = Symbol.for("react.portal"), $e88270f38a9f2d30$var$Ia = Symbol.for("react.fragment"), $e88270f38a9f2d30$var$Ja = Symbol.for("react.strict_mode"), $e88270f38a9f2d30$var$Ka = Symbol.for("react.profiler"), $e88270f38a9f2d30$var$La = Symbol.for("react.provider"), $e88270f38a9f2d30$var$Ma = Symbol.for("react.context"), $e88270f38a9f2d30$var$Na = Symbol.for("react.forward_ref"), $e88270f38a9f2d30$var$Oa = Symbol.for("react.suspense"), $e88270f38a9f2d30$var$Pa = Symbol.for("react.suspense_list"), $e88270f38a9f2d30$var$Qa = Symbol.for("react.memo"), $e88270f38a9f2d30$var$Ra = Symbol.for("react.lazy"), $e88270f38a9f2d30$var$Sa = Symbol.for("react.scope"), $e88270f38a9f2d30$var$Ta = Symbol.for("react.debug_trace_mode"), $e88270f38a9f2d30$var$Ua = Symbol.for("react.legacy_hidden"), $e88270f38a9f2d30$var$Va = Symbol.for("react.default_value"), $e88270f38a9f2d30$var$Wa = Symbol.iterator;
function $e88270f38a9f2d30$var$Xa(a) {
    if (null == a) return null;
    if ("function" === typeof a) return a.displayName || a.name || null;
    if ("string" === typeof a) return a;
    switch(a){
        case $e88270f38a9f2d30$var$Ia:
            return "Fragment";
        case $e88270f38a9f2d30$var$Ha:
            return "Portal";
        case $e88270f38a9f2d30$var$Ka:
            return "Profiler";
        case $e88270f38a9f2d30$var$Ja:
            return "StrictMode";
        case $e88270f38a9f2d30$var$Oa:
            return "Suspense";
        case $e88270f38a9f2d30$var$Pa:
            return "SuspenseList";
    }
    if ("object" === typeof a) switch(a.$$typeof){
        case $e88270f38a9f2d30$var$Ma:
            return (a.displayName || "Context") + ".Consumer";
        case $e88270f38a9f2d30$var$La:
            return (a._context.displayName || "Context") + ".Provider";
        case $e88270f38a9f2d30$var$Na:
            var b = a.render;
            a = a.displayName;
            a || (a = b.displayName || b.name || "", a = "" !== a ? "ForwardRef(" + a + ")" : "ForwardRef");
            return a;
        case $e88270f38a9f2d30$var$Qa:
            return b = a.displayName || null, null !== b ? b : $e88270f38a9f2d30$var$Xa(a.type) || "Memo";
        case $e88270f38a9f2d30$var$Ra:
            b = a._payload;
            a = a._init;
            try {
                return $e88270f38a9f2d30$var$Xa(a(b));
            } catch (c) {}
    }
    return null;
}
var $e88270f38a9f2d30$var$Ya = {};
function $e88270f38a9f2d30$var$Za(a, b) {
    a = a.contextTypes;
    if (!a) return $e88270f38a9f2d30$var$Ya;
    var c = {}, d;
    for(d in a)c[d] = b[d];
    return c;
}
var $e88270f38a9f2d30$var$E = null;
function $e88270f38a9f2d30$var$F(a, b) {
    if (a !== b) {
        a.context._currentValue2 = a.parentValue;
        a = a.parent;
        var c = b.parent;
        if (null === a) {
            if (null !== c) throw Error($e88270f38a9f2d30$var$l(401));
        } else {
            if (null === c) throw Error($e88270f38a9f2d30$var$l(401));
            $e88270f38a9f2d30$var$F(a, c);
        }
        b.context._currentValue2 = b.value;
    }
}
function $e88270f38a9f2d30$var$$a(a) {
    a.context._currentValue2 = a.parentValue;
    a = a.parent;
    null !== a && $e88270f38a9f2d30$var$$a(a);
}
function $e88270f38a9f2d30$var$ab(a) {
    var b = a.parent;
    null !== b && $e88270f38a9f2d30$var$ab(b);
    a.context._currentValue2 = a.value;
}
function $e88270f38a9f2d30$var$bb(a, b) {
    a.context._currentValue2 = a.parentValue;
    a = a.parent;
    if (null === a) throw Error($e88270f38a9f2d30$var$l(402));
    a.depth === b.depth ? $e88270f38a9f2d30$var$F(a, b) : $e88270f38a9f2d30$var$bb(a, b);
}
function $e88270f38a9f2d30$var$cb(a, b) {
    var c = b.parent;
    if (null === c) throw Error($e88270f38a9f2d30$var$l(402));
    a.depth === c.depth ? $e88270f38a9f2d30$var$F(a, c) : $e88270f38a9f2d30$var$cb(a, c);
    b.context._currentValue2 = b.value;
}
function $e88270f38a9f2d30$var$G(a) {
    var b = $e88270f38a9f2d30$var$E;
    b !== a && (null === b ? $e88270f38a9f2d30$var$ab(a) : null === a ? $e88270f38a9f2d30$var$$a(b) : b.depth === a.depth ? $e88270f38a9f2d30$var$F(b, a) : b.depth > a.depth ? $e88270f38a9f2d30$var$bb(b, a) : $e88270f38a9f2d30$var$cb(b, a), $e88270f38a9f2d30$var$E = a);
}
var $e88270f38a9f2d30$var$db = {
    isMounted: function() {
        return !1;
    },
    enqueueSetState: function(a, b) {
        a = a._reactInternals;
        null !== a.queue && a.queue.push(b);
    },
    enqueueReplaceState: function(a, b) {
        a = a._reactInternals;
        a.replace = !0;
        a.queue = [
            b
        ];
    },
    enqueueForceUpdate: function() {}
};
function $e88270f38a9f2d30$var$eb(a, b, c, d) {
    var f = void 0 !== a.state ? a.state : null;
    a.updater = $e88270f38a9f2d30$var$db;
    a.props = c;
    a.state = f;
    var e = {
        queue: [],
        replace: !1
    };
    a._reactInternals = e;
    var g = b.contextType;
    a.context = "object" === typeof g && null !== g ? g._currentValue2 : d;
    g = b.getDerivedStateFromProps;
    "function" === typeof g && (g = g(c, f), f = null === g || void 0 === g ? f : $e88270f38a9f2d30$var$B({}, f, g), a.state = f);
    if ("function" !== typeof b.getDerivedStateFromProps && "function" !== typeof a.getSnapshotBeforeUpdate && ("function" === typeof a.UNSAFE_componentWillMount || "function" === typeof a.componentWillMount)) {
        if (b = a.state, "function" === typeof a.componentWillMount && a.componentWillMount(), "function" === typeof a.UNSAFE_componentWillMount && a.UNSAFE_componentWillMount(), b !== a.state && $e88270f38a9f2d30$var$db.enqueueReplaceState(a, a.state, null), null !== e.queue && 0 < e.queue.length) {
            if (b = e.queue, g = e.replace, e.queue = null, e.replace = !1, g && 1 === b.length) a.state = b[0];
            else {
                e = g ? b[0] : a.state;
                f = !0;
                for(g = g ? 1 : 0; g < b.length; g++){
                    var h = b[g];
                    h = "function" === typeof h ? h.call(a, e, c, d) : h;
                    null != h && (f ? (f = !1, e = $e88270f38a9f2d30$var$B({}, e, h)) : $e88270f38a9f2d30$var$B(e, h));
                }
                a.state = e;
            }
        } else e.queue = null;
    }
}
var $e88270f38a9f2d30$var$fb = {
    id: 1,
    overflow: ""
};
function $e88270f38a9f2d30$var$gb(a, b, c) {
    var d = a.id;
    a = a.overflow;
    var f = 32 - $e88270f38a9f2d30$var$H(d) - 1;
    d &= ~(1 << f);
    c += 1;
    var e = 32 - $e88270f38a9f2d30$var$H(b) + f;
    if (30 < e) {
        var g = f - f % 5;
        e = (d & (1 << g) - 1).toString(32);
        d >>= g;
        f -= g;
        return {
            id: 1 << 32 - $e88270f38a9f2d30$var$H(b) + f | c << f | d,
            overflow: e + a
        };
    }
    return {
        id: 1 << e | c << f | d,
        overflow: a
    };
}
var $e88270f38a9f2d30$var$H = Math.clz32 ? Math.clz32 : $e88270f38a9f2d30$var$hb, $e88270f38a9f2d30$var$ib = Math.log, $e88270f38a9f2d30$var$jb = Math.LN2;
function $e88270f38a9f2d30$var$hb(a) {
    a >>>= 0;
    return 0 === a ? 32 : 31 - ($e88270f38a9f2d30$var$ib(a) / $e88270f38a9f2d30$var$jb | 0) | 0;
}
function $e88270f38a9f2d30$var$kb(a, b) {
    return a === b && (0 !== a || 1 / a === 1 / b) || a !== a && b !== b;
}
var $e88270f38a9f2d30$var$lb = "function" === typeof Object.is ? Object.is : $e88270f38a9f2d30$var$kb, $e88270f38a9f2d30$var$I = null, $e88270f38a9f2d30$var$ob = null, $e88270f38a9f2d30$var$J = null, $e88270f38a9f2d30$var$K = null, $e88270f38a9f2d30$var$L = !1, $e88270f38a9f2d30$var$M = !1, $e88270f38a9f2d30$var$N = 0, $e88270f38a9f2d30$var$O = null, $e88270f38a9f2d30$var$P = 0;
function $e88270f38a9f2d30$var$Q() {
    if (null === $e88270f38a9f2d30$var$I) throw Error($e88270f38a9f2d30$var$l(321));
    return $e88270f38a9f2d30$var$I;
}
function $e88270f38a9f2d30$var$pb() {
    if (0 < $e88270f38a9f2d30$var$P) throw Error($e88270f38a9f2d30$var$l(312));
    return {
        memoizedState: null,
        queue: null,
        next: null
    };
}
function $e88270f38a9f2d30$var$qb() {
    null === $e88270f38a9f2d30$var$K ? null === $e88270f38a9f2d30$var$J ? ($e88270f38a9f2d30$var$L = !1, $e88270f38a9f2d30$var$J = $e88270f38a9f2d30$var$K = $e88270f38a9f2d30$var$pb()) : ($e88270f38a9f2d30$var$L = !0, $e88270f38a9f2d30$var$K = $e88270f38a9f2d30$var$J) : null === $e88270f38a9f2d30$var$K.next ? ($e88270f38a9f2d30$var$L = !1, $e88270f38a9f2d30$var$K = $e88270f38a9f2d30$var$K.next = $e88270f38a9f2d30$var$pb()) : ($e88270f38a9f2d30$var$L = !0, $e88270f38a9f2d30$var$K = $e88270f38a9f2d30$var$K.next);
    return $e88270f38a9f2d30$var$K;
}
function $e88270f38a9f2d30$var$rb() {
    $e88270f38a9f2d30$var$ob = $e88270f38a9f2d30$var$I = null;
    $e88270f38a9f2d30$var$M = !1;
    $e88270f38a9f2d30$var$J = null;
    $e88270f38a9f2d30$var$P = 0;
    $e88270f38a9f2d30$var$K = $e88270f38a9f2d30$var$O = null;
}
function $e88270f38a9f2d30$var$sb(a, b) {
    return "function" === typeof b ? b(a) : b;
}
function $e88270f38a9f2d30$var$tb(a, b, c) {
    $e88270f38a9f2d30$var$I = $e88270f38a9f2d30$var$Q();
    $e88270f38a9f2d30$var$K = $e88270f38a9f2d30$var$qb();
    if ($e88270f38a9f2d30$var$L) {
        var d = $e88270f38a9f2d30$var$K.queue;
        b = d.dispatch;
        if (null !== $e88270f38a9f2d30$var$O && (c = $e88270f38a9f2d30$var$O.get(d), void 0 !== c)) {
            $e88270f38a9f2d30$var$O.delete(d);
            d = $e88270f38a9f2d30$var$K.memoizedState;
            do d = a(d, c.action), c = c.next;
            while (null !== c);
            $e88270f38a9f2d30$var$K.memoizedState = d;
            return [
                d,
                b
            ];
        }
        return [
            $e88270f38a9f2d30$var$K.memoizedState,
            b
        ];
    }
    a = a === $e88270f38a9f2d30$var$sb ? "function" === typeof b ? b() : b : void 0 !== c ? c(b) : b;
    $e88270f38a9f2d30$var$K.memoizedState = a;
    a = $e88270f38a9f2d30$var$K.queue = {
        last: null,
        dispatch: null
    };
    a = a.dispatch = $e88270f38a9f2d30$var$ub.bind(null, $e88270f38a9f2d30$var$I, a);
    return [
        $e88270f38a9f2d30$var$K.memoizedState,
        a
    ];
}
function $e88270f38a9f2d30$var$vb(a, b) {
    $e88270f38a9f2d30$var$I = $e88270f38a9f2d30$var$Q();
    $e88270f38a9f2d30$var$K = $e88270f38a9f2d30$var$qb();
    b = void 0 === b ? null : b;
    if (null !== $e88270f38a9f2d30$var$K) {
        var c = $e88270f38a9f2d30$var$K.memoizedState;
        if (null !== c && null !== b) {
            var d = c[1];
            a: if (null === d) d = !1;
            else {
                for(var f = 0; f < d.length && f < b.length; f++)if (!$e88270f38a9f2d30$var$lb(b[f], d[f])) {
                    d = !1;
                    break a;
                }
                d = !0;
            }
            if (d) return c[0];
        }
    }
    a = a();
    $e88270f38a9f2d30$var$K.memoizedState = [
        a,
        b
    ];
    return a;
}
function $e88270f38a9f2d30$var$ub(a, b, c) {
    if (25 <= $e88270f38a9f2d30$var$P) throw Error($e88270f38a9f2d30$var$l(301));
    if (a === $e88270f38a9f2d30$var$I) {
        if ($e88270f38a9f2d30$var$M = !0, a = {
            action: c,
            next: null
        }, null === $e88270f38a9f2d30$var$O && ($e88270f38a9f2d30$var$O = new Map), c = $e88270f38a9f2d30$var$O.get(b), void 0 === c) $e88270f38a9f2d30$var$O.set(b, a);
        else {
            for(b = c; null !== b.next;)b = b.next;
            b.next = a;
        }
    }
}
function $e88270f38a9f2d30$var$wb() {
    throw Error($e88270f38a9f2d30$var$l(394));
}
function $e88270f38a9f2d30$var$R() {}
var $e88270f38a9f2d30$var$xb = {
    readContext: function(a) {
        return a._currentValue2;
    },
    useContext: function(a) {
        $e88270f38a9f2d30$var$Q();
        return a._currentValue2;
    },
    useMemo: $e88270f38a9f2d30$var$vb,
    useReducer: $e88270f38a9f2d30$var$tb,
    useRef: function(a) {
        $e88270f38a9f2d30$var$I = $e88270f38a9f2d30$var$Q();
        $e88270f38a9f2d30$var$K = $e88270f38a9f2d30$var$qb();
        var b = $e88270f38a9f2d30$var$K.memoizedState;
        return null === b ? (a = {
            current: a
        }, $e88270f38a9f2d30$var$K.memoizedState = a) : b;
    },
    useState: function(a) {
        return $e88270f38a9f2d30$var$tb($e88270f38a9f2d30$var$sb, a);
    },
    useInsertionEffect: $e88270f38a9f2d30$var$R,
    useLayoutEffect: function() {},
    useCallback: function(a, b) {
        return $e88270f38a9f2d30$var$vb(function() {
            return a;
        }, b);
    },
    useImperativeHandle: $e88270f38a9f2d30$var$R,
    useEffect: $e88270f38a9f2d30$var$R,
    useDebugValue: $e88270f38a9f2d30$var$R,
    useDeferredValue: function(a) {
        $e88270f38a9f2d30$var$Q();
        return a;
    },
    useTransition: function() {
        $e88270f38a9f2d30$var$Q();
        return [
            !1,
            $e88270f38a9f2d30$var$wb
        ];
    },
    useId: function() {
        var a = $e88270f38a9f2d30$var$ob.treeContext;
        var b = a.overflow;
        a = a.id;
        a = (a & ~(1 << 32 - $e88270f38a9f2d30$var$H(a) - 1)).toString(32) + b;
        var c = $e88270f38a9f2d30$var$S;
        if (null === c) throw Error($e88270f38a9f2d30$var$l(404));
        b = $e88270f38a9f2d30$var$N++;
        a = ":" + c.idPrefix + "R" + a;
        0 < b && (a += "H" + b.toString(32));
        return a + ":";
    },
    useMutableSource: function(a, b) {
        $e88270f38a9f2d30$var$Q();
        return b(a._source);
    },
    useSyncExternalStore: function(a, b, c) {
        if (void 0 === c) throw Error($e88270f38a9f2d30$var$l(407));
        return c();
    }
}, $e88270f38a9f2d30$var$S = null, $e88270f38a9f2d30$var$yb = $cWbtJ.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentDispatcher;
function $e88270f38a9f2d30$var$zb(a) {
    console.error(a);
    return null;
}
function $e88270f38a9f2d30$var$T() {}
function $e88270f38a9f2d30$var$Ab(a, b, c, d, f, e, g, h, k) {
    var m = [], n = new Set;
    b = {
        destination: null,
        responseState: b,
        progressiveChunkSize: void 0 === d ? 12800 : d,
        status: 0,
        fatalError: null,
        nextSegmentId: 0,
        allPendingTasks: 0,
        pendingRootTasks: 0,
        completedRootSegment: null,
        abortableTasks: n,
        pingedTasks: m,
        clientRenderedBoundaries: [],
        completedBoundaries: [],
        partialBoundaries: [],
        onError: void 0 === f ? $e88270f38a9f2d30$var$zb : f,
        onAllReady: void 0 === e ? $e88270f38a9f2d30$var$T : e,
        onShellReady: void 0 === g ? $e88270f38a9f2d30$var$T : g,
        onShellError: void 0 === h ? $e88270f38a9f2d30$var$T : h,
        onFatalError: void 0 === k ? $e88270f38a9f2d30$var$T : k
    };
    c = $e88270f38a9f2d30$var$U(b, 0, null, c, !1, !1);
    c.parentFlushed = !0;
    a = $e88270f38a9f2d30$var$Bb(b, a, null, c, n, $e88270f38a9f2d30$var$Ya, null, $e88270f38a9f2d30$var$fb);
    m.push(a);
    return b;
}
function $e88270f38a9f2d30$var$Bb(a, b, c, d, f, e, g, h) {
    a.allPendingTasks++;
    null === c ? a.pendingRootTasks++ : c.pendingTasks++;
    var k = {
        node: b,
        ping: function() {
            var b = a.pingedTasks;
            b.push(k);
            1 === b.length && $e88270f38a9f2d30$var$Cb(a);
        },
        blockedBoundary: c,
        blockedSegment: d,
        abortSet: f,
        legacyContext: e,
        context: g,
        treeContext: h
    };
    f.add(k);
    return k;
}
function $e88270f38a9f2d30$var$U(a, b, c, d, f, e) {
    return {
        status: 0,
        id: -1,
        index: b,
        parentFlushed: !1,
        chunks: [],
        children: [],
        formatContext: d,
        boundary: c,
        lastPushedText: f,
        textEmbedded: e
    };
}
function $e88270f38a9f2d30$var$V(a, b) {
    a = a.onError(b);
    if (null != a && "string" !== typeof a) throw Error('onError returned something with a type other than "string". onError should return a string and may return null or undefined but must not return anything else. It received something of type "' + typeof a + '" instead');
    return a;
}
function $e88270f38a9f2d30$var$W(a, b) {
    var c = a.onShellError;
    c(b);
    c = a.onFatalError;
    c(b);
    null !== a.destination ? (a.status = 2, a.destination.destroy(b)) : (a.status = 1, a.fatalError = b);
}
function $e88270f38a9f2d30$var$Db(a, b, c, d, f) {
    $e88270f38a9f2d30$var$I = {};
    $e88270f38a9f2d30$var$ob = b;
    $e88270f38a9f2d30$var$N = 0;
    for(a = c(d, f); $e88270f38a9f2d30$var$M;)$e88270f38a9f2d30$var$M = !1, $e88270f38a9f2d30$var$N = 0, $e88270f38a9f2d30$var$P += 1, $e88270f38a9f2d30$var$K = null, a = c(d, f);
    $e88270f38a9f2d30$var$rb();
    return a;
}
function $e88270f38a9f2d30$var$Eb(a, b, c, d) {
    var f = c.render(), e = d.childContextTypes;
    if (null !== e && void 0 !== e) {
        var g = b.legacyContext;
        if ("function" !== typeof c.getChildContext) d = g;
        else {
            c = c.getChildContext();
            for(var h in c)if (!(h in e)) throw Error($e88270f38a9f2d30$var$l(108, $e88270f38a9f2d30$var$Xa(d) || "Unknown", h));
            d = $e88270f38a9f2d30$var$B({}, g, c);
        }
        b.legacyContext = d;
        $e88270f38a9f2d30$var$X(a, b, f);
        b.legacyContext = g;
    } else $e88270f38a9f2d30$var$X(a, b, f);
}
function $e88270f38a9f2d30$var$Fb(a, b) {
    if (a && a.defaultProps) {
        b = $e88270f38a9f2d30$var$B({}, b);
        a = a.defaultProps;
        for(var c in a)void 0 === b[c] && (b[c] = a[c]);
        return b;
    }
    return b;
}
function $e88270f38a9f2d30$var$Gb(a, b, c, d, f) {
    if ("function" === typeof c) {
        if (c.prototype && c.prototype.isReactComponent) {
            f = $e88270f38a9f2d30$var$Za(c, b.legacyContext);
            var e = c.contextType;
            e = new c(d, "object" === typeof e && null !== e ? e._currentValue2 : f);
            $e88270f38a9f2d30$var$eb(e, c, d, f);
            $e88270f38a9f2d30$var$Eb(a, b, e, c);
        } else {
            e = $e88270f38a9f2d30$var$Za(c, b.legacyContext);
            f = $e88270f38a9f2d30$var$Db(a, b, c, d, e);
            var g = 0 !== $e88270f38a9f2d30$var$N;
            if ("object" === typeof f && null !== f && "function" === typeof f.render && void 0 === f.$$typeof) $e88270f38a9f2d30$var$eb(f, c, d, e), $e88270f38a9f2d30$var$Eb(a, b, f, c);
            else if (g) {
                d = b.treeContext;
                b.treeContext = $e88270f38a9f2d30$var$gb(d, 1, 0);
                try {
                    $e88270f38a9f2d30$var$X(a, b, f);
                } finally{
                    b.treeContext = d;
                }
            } else $e88270f38a9f2d30$var$X(a, b, f);
        }
    } else if ("string" === typeof c) {
        f = b.blockedSegment;
        e = $e88270f38a9f2d30$var$ya(f.chunks, c, d, a.responseState, f.formatContext);
        f.lastPushedText = !1;
        g = f.formatContext;
        f.formatContext = $e88270f38a9f2d30$var$ra(g, c, d);
        $e88270f38a9f2d30$var$Hb(a, b, e);
        f.formatContext = g;
        switch(c){
            case "area":
            case "base":
            case "br":
            case "col":
            case "embed":
            case "hr":
            case "img":
            case "input":
            case "keygen":
            case "link":
            case "meta":
            case "param":
            case "source":
            case "track":
            case "wbr":
                break;
            default:
                f.chunks.push("</", c, ">");
        }
        f.lastPushedText = !1;
    } else {
        switch(c){
            case $e88270f38a9f2d30$var$Ua:
            case $e88270f38a9f2d30$var$Ta:
            case $e88270f38a9f2d30$var$Ja:
            case $e88270f38a9f2d30$var$Ka:
            case $e88270f38a9f2d30$var$Ia:
                $e88270f38a9f2d30$var$X(a, b, d.children);
                return;
            case $e88270f38a9f2d30$var$Pa:
                $e88270f38a9f2d30$var$X(a, b, d.children);
                return;
            case $e88270f38a9f2d30$var$Sa:
                throw Error($e88270f38a9f2d30$var$l(343));
            case $e88270f38a9f2d30$var$Oa:
                a: {
                    c = b.blockedBoundary;
                    f = b.blockedSegment;
                    e = d.fallback;
                    d = d.children;
                    g = new Set;
                    var h = {
                        id: null,
                        rootSegmentID: -1,
                        parentFlushed: !1,
                        pendingTasks: 0,
                        forceClientRender: !1,
                        completedSegments: [],
                        byteSize: 0,
                        fallbackAbortableTasks: g,
                        errorDigest: null
                    }, k = $e88270f38a9f2d30$var$U(a, f.chunks.length, h, f.formatContext, !1, !1);
                    f.children.push(k);
                    f.lastPushedText = !1;
                    var m = $e88270f38a9f2d30$var$U(a, 0, null, f.formatContext, !1, !1);
                    m.parentFlushed = !0;
                    b.blockedBoundary = h;
                    b.blockedSegment = m;
                    try {
                        if ($e88270f38a9f2d30$var$Hb(a, b, d), a.responseState.generateStaticMarkup || m.lastPushedText && m.textEmbedded && m.chunks.push("<!-- -->"), m.status = 1, $e88270f38a9f2d30$var$Y(h, m), 0 === h.pendingTasks) break a;
                    } catch (n) {
                        m.status = 4, h.forceClientRender = !0, h.errorDigest = $e88270f38a9f2d30$var$V(a, n);
                    } finally{
                        b.blockedBoundary = c, b.blockedSegment = f;
                    }
                    b = $e88270f38a9f2d30$var$Bb(a, e, c, k, g, b.legacyContext, b.context, b.treeContext);
                    a.pingedTasks.push(b);
                }
                return;
        }
        if ("object" === typeof c && null !== c) switch(c.$$typeof){
            case $e88270f38a9f2d30$var$Na:
                d = $e88270f38a9f2d30$var$Db(a, b, c.render, d, f);
                if (0 !== $e88270f38a9f2d30$var$N) {
                    c = b.treeContext;
                    b.treeContext = $e88270f38a9f2d30$var$gb(c, 1, 0);
                    try {
                        $e88270f38a9f2d30$var$X(a, b, d);
                    } finally{
                        b.treeContext = c;
                    }
                } else $e88270f38a9f2d30$var$X(a, b, d);
                return;
            case $e88270f38a9f2d30$var$Qa:
                c = c.type;
                d = $e88270f38a9f2d30$var$Fb(c, d);
                $e88270f38a9f2d30$var$Gb(a, b, c, d, f);
                return;
            case $e88270f38a9f2d30$var$La:
                f = d.children;
                c = c._context;
                d = d.value;
                e = c._currentValue2;
                c._currentValue2 = d;
                g = $e88270f38a9f2d30$var$E;
                $e88270f38a9f2d30$var$E = d = {
                    parent: g,
                    depth: null === g ? 0 : g.depth + 1,
                    context: c,
                    parentValue: e,
                    value: d
                };
                b.context = d;
                $e88270f38a9f2d30$var$X(a, b, f);
                a = $e88270f38a9f2d30$var$E;
                if (null === a) throw Error($e88270f38a9f2d30$var$l(403));
                d = a.parentValue;
                a.context._currentValue2 = d === $e88270f38a9f2d30$var$Va ? a.context._defaultValue : d;
                a = $e88270f38a9f2d30$var$E = a.parent;
                b.context = a;
                return;
            case $e88270f38a9f2d30$var$Ma:
                d = d.children;
                d = d(c._currentValue2);
                $e88270f38a9f2d30$var$X(a, b, d);
                return;
            case $e88270f38a9f2d30$var$Ra:
                f = c._init;
                c = f(c._payload);
                d = $e88270f38a9f2d30$var$Fb(c, d);
                $e88270f38a9f2d30$var$Gb(a, b, c, d, void 0);
                return;
        }
        throw Error($e88270f38a9f2d30$var$l(130, null == c ? c : typeof c, ""));
    }
}
function $e88270f38a9f2d30$var$X(a, b, c) {
    b.node = c;
    if ("object" === typeof c && null !== c) {
        switch(c.$$typeof){
            case $e88270f38a9f2d30$var$Ga:
                $e88270f38a9f2d30$var$Gb(a, b, c.type, c.props, c.ref);
                return;
            case $e88270f38a9f2d30$var$Ha:
                throw Error($e88270f38a9f2d30$var$l(257));
            case $e88270f38a9f2d30$var$Ra:
                var d = c._init;
                c = d(c._payload);
                $e88270f38a9f2d30$var$X(a, b, c);
                return;
        }
        if ($e88270f38a9f2d30$var$qa(c)) {
            $e88270f38a9f2d30$var$Ib(a, b, c);
            return;
        }
        null === c || "object" !== typeof c ? d = null : (d = $e88270f38a9f2d30$var$Wa && c[$e88270f38a9f2d30$var$Wa] || c["@@iterator"], d = "function" === typeof d ? d : null);
        if (d && (d = d.call(c))) {
            c = d.next();
            if (!c.done) {
                var f = [];
                do f.push(c.value), c = d.next();
                while (!c.done);
                $e88270f38a9f2d30$var$Ib(a, b, f);
            }
            return;
        }
        a = Object.prototype.toString.call(c);
        throw Error($e88270f38a9f2d30$var$l(31, "[object Object]" === a ? "object with keys {" + Object.keys(c).join(", ") + "}" : a));
    }
    "string" === typeof c ? (d = b.blockedSegment, d.lastPushedText = $e88270f38a9f2d30$var$Fa(b.blockedSegment.chunks, c, a.responseState, d.lastPushedText)) : "number" === typeof c && (d = b.blockedSegment, d.lastPushedText = $e88270f38a9f2d30$var$Fa(b.blockedSegment.chunks, "" + c, a.responseState, d.lastPushedText));
}
function $e88270f38a9f2d30$var$Ib(a, b, c) {
    for(var d = c.length, f = 0; f < d; f++){
        var e = b.treeContext;
        b.treeContext = $e88270f38a9f2d30$var$gb(e, d, f);
        try {
            $e88270f38a9f2d30$var$Hb(a, b, c[f]);
        } finally{
            b.treeContext = e;
        }
    }
}
function $e88270f38a9f2d30$var$Hb(a, b, c) {
    var d = b.blockedSegment.formatContext, f = b.legacyContext, e = b.context;
    try {
        return $e88270f38a9f2d30$var$X(a, b, c);
    } catch (k) {
        if ($e88270f38a9f2d30$var$rb(), "object" === typeof k && null !== k && "function" === typeof k.then) {
            c = k;
            var g = b.blockedSegment, h = $e88270f38a9f2d30$var$U(a, g.chunks.length, null, g.formatContext, g.lastPushedText, !0);
            g.children.push(h);
            g.lastPushedText = !1;
            a = $e88270f38a9f2d30$var$Bb(a, b.node, b.blockedBoundary, h, b.abortSet, b.legacyContext, b.context, b.treeContext).ping;
            c.then(a, a);
            b.blockedSegment.formatContext = d;
            b.legacyContext = f;
            b.context = e;
            $e88270f38a9f2d30$var$G(e);
        } else throw b.blockedSegment.formatContext = d, b.legacyContext = f, b.context = e, $e88270f38a9f2d30$var$G(e), k;
    }
}
function $e88270f38a9f2d30$var$Jb(a) {
    var b = a.blockedBoundary;
    a = a.blockedSegment;
    a.status = 3;
    $e88270f38a9f2d30$var$Kb(this, b, a);
}
function $e88270f38a9f2d30$var$Lb(a, b, c) {
    var d = a.blockedBoundary;
    a.blockedSegment.status = 3;
    null === d ? (b.allPendingTasks--, 2 !== b.status && (b.status = 2, null !== b.destination && b.destination.push(null))) : (d.pendingTasks--, d.forceClientRender || (d.forceClientRender = !0, a = void 0 === c ? Error($e88270f38a9f2d30$var$l(432)) : c, d.errorDigest = b.onError(a), d.parentFlushed && b.clientRenderedBoundaries.push(d)), d.fallbackAbortableTasks.forEach(function(a) {
        return $e88270f38a9f2d30$var$Lb(a, b, c);
    }), d.fallbackAbortableTasks.clear(), b.allPendingTasks--, 0 === b.allPendingTasks && (d = b.onAllReady, d()));
}
function $e88270f38a9f2d30$var$Y(a, b) {
    if (0 === b.chunks.length && 1 === b.children.length && null === b.children[0].boundary) {
        var c = b.children[0];
        c.id = b.id;
        c.parentFlushed = !0;
        1 === c.status && $e88270f38a9f2d30$var$Y(a, c);
    } else a.completedSegments.push(b);
}
function $e88270f38a9f2d30$var$Kb(a, b, c) {
    if (null === b) {
        if (c.parentFlushed) {
            if (null !== a.completedRootSegment) throw Error($e88270f38a9f2d30$var$l(389));
            a.completedRootSegment = c;
        }
        a.pendingRootTasks--;
        0 === a.pendingRootTasks && (a.onShellError = $e88270f38a9f2d30$var$T, b = a.onShellReady, b());
    } else b.pendingTasks--, b.forceClientRender || (0 === b.pendingTasks ? (c.parentFlushed && 1 === c.status && $e88270f38a9f2d30$var$Y(b, c), b.parentFlushed && a.completedBoundaries.push(b), b.fallbackAbortableTasks.forEach($e88270f38a9f2d30$var$Jb, a), b.fallbackAbortableTasks.clear()) : c.parentFlushed && 1 === c.status && ($e88270f38a9f2d30$var$Y(b, c), 1 === b.completedSegments.length && b.parentFlushed && a.partialBoundaries.push(b)));
    a.allPendingTasks--;
    0 === a.allPendingTasks && (a = a.onAllReady, a());
}
function $e88270f38a9f2d30$var$Cb(a) {
    if (2 !== a.status) {
        var b = $e88270f38a9f2d30$var$E, c = $e88270f38a9f2d30$var$yb.current;
        $e88270f38a9f2d30$var$yb.current = $e88270f38a9f2d30$var$xb;
        var d = $e88270f38a9f2d30$var$S;
        $e88270f38a9f2d30$var$S = a.responseState;
        try {
            var f = a.pingedTasks, e;
            for(e = 0; e < f.length; e++){
                var g = f[e];
                var h = a, k = g.blockedSegment;
                if (0 === k.status) {
                    $e88270f38a9f2d30$var$G(g.context);
                    try {
                        $e88270f38a9f2d30$var$X(h, g, g.node), h.responseState.generateStaticMarkup || k.lastPushedText && k.textEmbedded && k.chunks.push("<!-- -->"), g.abortSet.delete(g), k.status = 1, $e88270f38a9f2d30$var$Kb(h, g.blockedBoundary, k);
                    } catch (z) {
                        if ($e88270f38a9f2d30$var$rb(), "object" === typeof z && null !== z && "function" === typeof z.then) {
                            var m = g.ping;
                            z.then(m, m);
                        } else {
                            g.abortSet.delete(g);
                            k.status = 4;
                            var n = g.blockedBoundary, q = z, C = $e88270f38a9f2d30$var$V(h, q);
                            null === n ? $e88270f38a9f2d30$var$W(h, q) : (n.pendingTasks--, n.forceClientRender || (n.forceClientRender = !0, n.errorDigest = C, n.parentFlushed && h.clientRenderedBoundaries.push(n)));
                            h.allPendingTasks--;
                            if (0 === h.allPendingTasks) {
                                var D = h.onAllReady;
                                D();
                            }
                        }
                    } finally{}
                }
            }
            f.splice(0, e);
            null !== a.destination && $e88270f38a9f2d30$var$Mb(a, a.destination);
        } catch (z) {
            $e88270f38a9f2d30$var$V(a, z), $e88270f38a9f2d30$var$W(a, z);
        } finally{
            $e88270f38a9f2d30$var$S = d, $e88270f38a9f2d30$var$yb.current = c, c === $e88270f38a9f2d30$var$xb && $e88270f38a9f2d30$var$G(b);
        }
    }
}
function $e88270f38a9f2d30$var$Z(a, b, c) {
    c.parentFlushed = !0;
    switch(c.status){
        case 0:
            var d = c.id = a.nextSegmentId++;
            c.lastPushedText = !1;
            c.textEmbedded = !1;
            a = a.responseState;
            b.push('<template id="');
            b.push(a.placeholderPrefix);
            a = d.toString(16);
            b.push(a);
            return b.push('"></template>');
        case 1:
            c.status = 2;
            var f = !0;
            d = c.chunks;
            var e = 0;
            c = c.children;
            for(var g = 0; g < c.length; g++){
                for(f = c[g]; e < f.index; e++)b.push(d[e]);
                f = $e88270f38a9f2d30$var$Nb(a, b, f);
            }
            for(; e < d.length - 1; e++)b.push(d[e]);
            e < d.length && (f = b.push(d[e]));
            return f;
        default:
            throw Error($e88270f38a9f2d30$var$l(390));
    }
}
function $e88270f38a9f2d30$var$Nb(a, b, c) {
    var d = c.boundary;
    if (null === d) return $e88270f38a9f2d30$var$Z(a, b, c);
    d.parentFlushed = !0;
    if (d.forceClientRender) return a.responseState.generateStaticMarkup || (d = d.errorDigest, b.push("<!--$!-->"), b.push("<template"), d && (b.push(' data-dgst="'), d = $e88270f38a9f2d30$var$v(d), b.push(d), b.push('"')), b.push("></template>")), $e88270f38a9f2d30$var$Z(a, b, c), a = a.responseState.generateStaticMarkup ? !0 : b.push("<!--/$-->"), a;
    if (0 < d.pendingTasks) {
        d.rootSegmentID = a.nextSegmentId++;
        0 < d.completedSegments.length && a.partialBoundaries.push(d);
        var f = a.responseState;
        var e = f.nextSuspenseID++;
        f = f.boundaryPrefix + e.toString(16);
        d = d.id = f;
        $e88270f38a9f2d30$var$za(b, a.responseState, d);
        $e88270f38a9f2d30$var$Z(a, b, c);
        return b.push("<!--/$-->");
    }
    if (d.byteSize > a.progressiveChunkSize) return d.rootSegmentID = a.nextSegmentId++, a.completedBoundaries.push(d), $e88270f38a9f2d30$var$za(b, a.responseState, d.id), $e88270f38a9f2d30$var$Z(a, b, c), b.push("<!--/$-->");
    a.responseState.generateStaticMarkup || b.push("<!--$-->");
    c = d.completedSegments;
    if (1 !== c.length) throw Error($e88270f38a9f2d30$var$l(391));
    $e88270f38a9f2d30$var$Nb(a, b, c[0]);
    a = a.responseState.generateStaticMarkup ? !0 : b.push("<!--/$-->");
    return a;
}
function $e88270f38a9f2d30$var$Ob(a, b, c) {
    $e88270f38a9f2d30$var$Aa(b, a.responseState, c.formatContext, c.id);
    $e88270f38a9f2d30$var$Nb(a, b, c);
    return $e88270f38a9f2d30$var$Ba(b, c.formatContext);
}
function $e88270f38a9f2d30$var$Pb(a, b, c) {
    for(var d = c.completedSegments, f = 0; f < d.length; f++)$e88270f38a9f2d30$var$Qb(a, b, c, d[f]);
    d.length = 0;
    a = a.responseState;
    d = c.id;
    c = c.rootSegmentID;
    b.push(a.startInlineScript);
    a.sentCompleteBoundaryFunction ? b.push('$RC("') : (a.sentCompleteBoundaryFunction = !0, b.push('function $RC(a,b){a=document.getElementById(a);b=document.getElementById(b);b.parentNode.removeChild(b);if(a){a=a.previousSibling;var f=a.parentNode,c=a.nextSibling,e=0;do{if(c&&8===c.nodeType){var d=c.data;if("/$"===d)if(0===e)break;else e--;else"$"!==d&&"$?"!==d&&"$!"!==d||e++}d=c.nextSibling;f.removeChild(c);c=d}while(c);for(;b.firstChild;)f.insertBefore(b.firstChild,c);a.data="$";a._reactRetry&&a._reactRetry()}};$RC("'));
    if (null === d) throw Error($e88270f38a9f2d30$var$l(395));
    c = c.toString(16);
    b.push(d);
    b.push('","');
    b.push(a.segmentPrefix);
    b.push(c);
    return b.push('")</script>');
}
function $e88270f38a9f2d30$var$Qb(a, b, c, d) {
    if (2 === d.status) return !0;
    var f = d.id;
    if (-1 === f) {
        if (-1 === (d.id = c.rootSegmentID)) throw Error($e88270f38a9f2d30$var$l(392));
        return $e88270f38a9f2d30$var$Ob(a, b, d);
    }
    $e88270f38a9f2d30$var$Ob(a, b, d);
    a = a.responseState;
    b.push(a.startInlineScript);
    a.sentCompleteSegmentFunction ? b.push('$RS("') : (a.sentCompleteSegmentFunction = !0, b.push('function $RS(a,b){a=document.getElementById(a);b=document.getElementById(b);for(a.parentNode.removeChild(a);a.firstChild;)b.parentNode.insertBefore(a.firstChild,b);b.parentNode.removeChild(b)};$RS("'));
    b.push(a.segmentPrefix);
    f = f.toString(16);
    b.push(f);
    b.push('","');
    b.push(a.placeholderPrefix);
    b.push(f);
    return b.push('")</script>');
}
function $e88270f38a9f2d30$var$Mb(a, b) {
    try {
        var c = a.completedRootSegment;
        if (null !== c && 0 === a.pendingRootTasks) {
            $e88270f38a9f2d30$var$Nb(a, b, c);
            a.completedRootSegment = null;
            var d = a.responseState.bootstrapChunks;
            for(c = 0; c < d.length - 1; c++)b.push(d[c]);
            c < d.length && b.push(d[c]);
        }
        var f = a.clientRenderedBoundaries, e;
        for(e = 0; e < f.length; e++){
            var g = f[e];
            d = b;
            var h = a.responseState, k = g.id, m = g.errorDigest, n = g.errorMessage, q = g.errorComponentStack;
            d.push(h.startInlineScript);
            h.sentClientRenderFunction ? d.push('$RX("') : (h.sentClientRenderFunction = !0, d.push('function $RX(b,c,d,e){var a=document.getElementById(b);a&&(b=a.previousSibling,b.data="$!",a=a.dataset,c&&(a.dgst=c),d&&(a.msg=d),e&&(a.stck=e),b._reactRetry&&b._reactRetry())};$RX("'));
            if (null === k) throw Error($e88270f38a9f2d30$var$l(395));
            d.push(k);
            d.push('"');
            if (m || n || q) {
                d.push(",");
                var C = $e88270f38a9f2d30$var$Da(m || "");
                d.push(C);
            }
            if (n || q) {
                d.push(",");
                var D = $e88270f38a9f2d30$var$Da(n || "");
                d.push(D);
            }
            if (q) {
                d.push(",");
                var z = $e88270f38a9f2d30$var$Da(q);
                d.push(z);
            }
            if (!d.push(")</script>")) {
                a.destination = null;
                e++;
                f.splice(0, e);
                return;
            }
        }
        f.splice(0, e);
        var ba = a.completedBoundaries;
        for(e = 0; e < ba.length; e++)if (!$e88270f38a9f2d30$var$Pb(a, b, ba[e])) {
            a.destination = null;
            e++;
            ba.splice(0, e);
            return;
        }
        ba.splice(0, e);
        var ca = a.partialBoundaries;
        for(e = 0; e < ca.length; e++){
            var mb = ca[e];
            a: {
                f = a;
                g = b;
                var da = mb.completedSegments;
                for(h = 0; h < da.length; h++)if (!$e88270f38a9f2d30$var$Qb(f, g, mb, da[h])) {
                    h++;
                    da.splice(0, h);
                    var nb = !1;
                    break a;
                }
                da.splice(0, h);
                nb = !0;
            }
            if (!nb) {
                a.destination = null;
                e++;
                ca.splice(0, e);
                return;
            }
        }
        ca.splice(0, e);
        var ea = a.completedBoundaries;
        for(e = 0; e < ea.length; e++)if (!$e88270f38a9f2d30$var$Pb(a, b, ea[e])) {
            a.destination = null;
            e++;
            ea.splice(0, e);
            return;
        }
        ea.splice(0, e);
    } finally{
        0 === a.allPendingTasks && 0 === a.pingedTasks.length && 0 === a.clientRenderedBoundaries.length && 0 === a.completedBoundaries.length && b.push(null);
    }
}
function $e88270f38a9f2d30$var$Rb(a, b) {
    try {
        var c = a.abortableTasks;
        c.forEach(function(c) {
            return $e88270f38a9f2d30$var$Lb(c, a, b);
        });
        c.clear();
        null !== a.destination && $e88270f38a9f2d30$var$Mb(a, a.destination);
    } catch (d) {
        $e88270f38a9f2d30$var$V(a, d), $e88270f38a9f2d30$var$W(a, d);
    }
}
function $e88270f38a9f2d30$var$Sb() {}
function $e88270f38a9f2d30$var$Tb(a, b, c, d) {
    var f = !1, e = null, g = "", h = {
        push: function(a) {
            null !== a && (g += a);
            return !0;
        },
        destroy: function(a) {
            f = !0;
            e = a;
        }
    }, k = !1;
    a = $e88270f38a9f2d30$var$Ab(a, $e88270f38a9f2d30$var$Ea(c, b ? b.identifierPrefix : void 0), {
        insertionMode: 1,
        selectedValue: null
    }, Infinity, $e88270f38a9f2d30$var$Sb, void 0, function() {
        k = !0;
    }, void 0, void 0);
    $e88270f38a9f2d30$var$Cb(a);
    $e88270f38a9f2d30$var$Rb(a, d);
    if (1 === a.status) a.status = 2, h.destroy(a.fatalError);
    else if (2 !== a.status && null === a.destination) {
        a.destination = h;
        try {
            $e88270f38a9f2d30$var$Mb(a, h);
        } catch (m) {
            $e88270f38a9f2d30$var$V(a, m), $e88270f38a9f2d30$var$W(a, m);
        }
    }
    if (f) throw e;
    if (!k) throw Error($e88270f38a9f2d30$var$l(426));
    return g;
}
$e88270f38a9f2d30$export$307591e98609eddd = function() {
    throw Error($e88270f38a9f2d30$var$l(207));
};
$e88270f38a9f2d30$export$eb3a06aef9e6ee51 = function(a, b) {
    return $e88270f38a9f2d30$var$Tb(a, b, !0, 'The server used "renderToStaticMarkup" which does not support Suspense. If you intended to have the server wait for the suspended component please switch to "renderToReadableStream" which supports Suspense on the server');
};
$e88270f38a9f2d30$export$b23711c915539651 = function() {
    throw Error($e88270f38a9f2d30$var$l(208));
};
$e88270f38a9f2d30$export$80e7718417253a51 = function(a, b) {
    return $e88270f38a9f2d30$var$Tb(a, b, !1, 'The server used "renderToString" which does not support Suspense. If you intended for this Suspense boundary to render the fallback content on the server consider throwing an Error somewhere within the Suspense boundary. If you intended to have the server wait for the suspended component please switch to "renderToReadableStream" which supports Suspense on the server');
};
$e88270f38a9f2d30$export$83d89fbfd8236492 = "18.3.1";

});

parcelRegister("ejyO0", function(module, exports) {

$parcel$export(module.exports, "renderToReadableStream", () => $a6bdd6b0637ea6ad$export$7020a3240b287705, (v) => $a6bdd6b0637ea6ad$export$7020a3240b287705 = v);
$parcel$export(module.exports, "version", () => $a6bdd6b0637ea6ad$export$83d89fbfd8236492, (v) => $a6bdd6b0637ea6ad$export$83d89fbfd8236492 = v);
/**
 * @license React
 * react-dom-server.browser.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $a6bdd6b0637ea6ad$export$7020a3240b287705;
var $a6bdd6b0637ea6ad$export$83d89fbfd8236492;
"use strict";

var $cWbtJ = parcelRequire("cWbtJ");
function $a6bdd6b0637ea6ad$var$k(a) {
    for(var b = "https://reactjs.org/docs/error-decoder.html?invariant=" + a, c = 1; c < arguments.length; c++)b += "&args[]=" + encodeURIComponent(arguments[c]);
    return "Minified React error #" + a + "; visit " + b + " for the full message or use the non-minified dev environment for full errors and additional helpful warnings.";
}
var $a6bdd6b0637ea6ad$var$l = null, $a6bdd6b0637ea6ad$var$n = 0;
function $a6bdd6b0637ea6ad$var$p(a, b) {
    if (0 !== b.length) {
        if (512 < b.length) 0 < $a6bdd6b0637ea6ad$var$n && (a.enqueue(new Uint8Array($a6bdd6b0637ea6ad$var$l.buffer, 0, $a6bdd6b0637ea6ad$var$n)), $a6bdd6b0637ea6ad$var$l = new Uint8Array(512), $a6bdd6b0637ea6ad$var$n = 0), a.enqueue(b);
        else {
            var c = $a6bdd6b0637ea6ad$var$l.length - $a6bdd6b0637ea6ad$var$n;
            c < b.length && (0 === c ? a.enqueue($a6bdd6b0637ea6ad$var$l) : ($a6bdd6b0637ea6ad$var$l.set(b.subarray(0, c), $a6bdd6b0637ea6ad$var$n), a.enqueue($a6bdd6b0637ea6ad$var$l), b = b.subarray(c)), $a6bdd6b0637ea6ad$var$l = new Uint8Array(512), $a6bdd6b0637ea6ad$var$n = 0);
            $a6bdd6b0637ea6ad$var$l.set(b, $a6bdd6b0637ea6ad$var$n);
            $a6bdd6b0637ea6ad$var$n += b.length;
        }
    }
}
function $a6bdd6b0637ea6ad$var$t(a, b) {
    $a6bdd6b0637ea6ad$var$p(a, b);
    return !0;
}
function $a6bdd6b0637ea6ad$var$ba(a) {
    $a6bdd6b0637ea6ad$var$l && 0 < $a6bdd6b0637ea6ad$var$n && (a.enqueue(new Uint8Array($a6bdd6b0637ea6ad$var$l.buffer, 0, $a6bdd6b0637ea6ad$var$n)), $a6bdd6b0637ea6ad$var$l = null, $a6bdd6b0637ea6ad$var$n = 0);
}
var $a6bdd6b0637ea6ad$var$ca = new TextEncoder;
function $a6bdd6b0637ea6ad$var$u(a) {
    return $a6bdd6b0637ea6ad$var$ca.encode(a);
}
function $a6bdd6b0637ea6ad$var$w(a) {
    return $a6bdd6b0637ea6ad$var$ca.encode(a);
}
function $a6bdd6b0637ea6ad$var$da(a, b) {
    "function" === typeof a.error ? a.error(b) : a.close();
}
var $a6bdd6b0637ea6ad$var$x = Object.prototype.hasOwnProperty, $a6bdd6b0637ea6ad$var$ea = /^[:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD][:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD\-.0-9\u00B7\u0300-\u036F\u203F-\u2040]*$/, $a6bdd6b0637ea6ad$var$fa = {}, $a6bdd6b0637ea6ad$var$ha = {};
function $a6bdd6b0637ea6ad$var$ia(a) {
    if ($a6bdd6b0637ea6ad$var$x.call($a6bdd6b0637ea6ad$var$ha, a)) return !0;
    if ($a6bdd6b0637ea6ad$var$x.call($a6bdd6b0637ea6ad$var$fa, a)) return !1;
    if ($a6bdd6b0637ea6ad$var$ea.test(a)) return $a6bdd6b0637ea6ad$var$ha[a] = !0;
    $a6bdd6b0637ea6ad$var$fa[a] = !0;
    return !1;
}
function $a6bdd6b0637ea6ad$var$y(a, b, c, d, f, e, g) {
    this.acceptsBooleans = 2 === b || 3 === b || 4 === b;
    this.attributeName = d;
    this.attributeNamespace = f;
    this.mustUseProperty = c;
    this.propertyName = a;
    this.type = b;
    this.sanitizeURL = e;
    this.removeEmptyString = g;
}
var $a6bdd6b0637ea6ad$var$z = {};
"children dangerouslySetInnerHTML defaultValue defaultChecked innerHTML suppressContentEditableWarning suppressHydrationWarning style".split(" ").forEach(function(a) {
    $a6bdd6b0637ea6ad$var$z[a] = new $a6bdd6b0637ea6ad$var$y(a, 0, !1, a, null, !1, !1);
});
[
    [
        "acceptCharset",
        "accept-charset"
    ],
    [
        "className",
        "class"
    ],
    [
        "htmlFor",
        "for"
    ],
    [
        "httpEquiv",
        "http-equiv"
    ]
].forEach(function(a) {
    var b = a[0];
    $a6bdd6b0637ea6ad$var$z[b] = new $a6bdd6b0637ea6ad$var$y(b, 1, !1, a[1], null, !1, !1);
});
[
    "contentEditable",
    "draggable",
    "spellCheck",
    "value"
].forEach(function(a) {
    $a6bdd6b0637ea6ad$var$z[a] = new $a6bdd6b0637ea6ad$var$y(a, 2, !1, a.toLowerCase(), null, !1, !1);
});
[
    "autoReverse",
    "externalResourcesRequired",
    "focusable",
    "preserveAlpha"
].forEach(function(a) {
    $a6bdd6b0637ea6ad$var$z[a] = new $a6bdd6b0637ea6ad$var$y(a, 2, !1, a, null, !1, !1);
});
"allowFullScreen async autoFocus autoPlay controls default defer disabled disablePictureInPicture disableRemotePlayback formNoValidate hidden loop noModule noValidate open playsInline readOnly required reversed scoped seamless itemScope".split(" ").forEach(function(a) {
    $a6bdd6b0637ea6ad$var$z[a] = new $a6bdd6b0637ea6ad$var$y(a, 3, !1, a.toLowerCase(), null, !1, !1);
});
[
    "checked",
    "multiple",
    "muted",
    "selected"
].forEach(function(a) {
    $a6bdd6b0637ea6ad$var$z[a] = new $a6bdd6b0637ea6ad$var$y(a, 3, !0, a, null, !1, !1);
});
[
    "capture",
    "download"
].forEach(function(a) {
    $a6bdd6b0637ea6ad$var$z[a] = new $a6bdd6b0637ea6ad$var$y(a, 4, !1, a, null, !1, !1);
});
[
    "cols",
    "rows",
    "size",
    "span"
].forEach(function(a) {
    $a6bdd6b0637ea6ad$var$z[a] = new $a6bdd6b0637ea6ad$var$y(a, 6, !1, a, null, !1, !1);
});
[
    "rowSpan",
    "start"
].forEach(function(a) {
    $a6bdd6b0637ea6ad$var$z[a] = new $a6bdd6b0637ea6ad$var$y(a, 5, !1, a.toLowerCase(), null, !1, !1);
});
var $a6bdd6b0637ea6ad$var$ja = /[\-:]([a-z])/g;
function $a6bdd6b0637ea6ad$var$ka(a) {
    return a[1].toUpperCase();
}
"accent-height alignment-baseline arabic-form baseline-shift cap-height clip-path clip-rule color-interpolation color-interpolation-filters color-profile color-rendering dominant-baseline enable-background fill-opacity fill-rule flood-color flood-opacity font-family font-size font-size-adjust font-stretch font-style font-variant font-weight glyph-name glyph-orientation-horizontal glyph-orientation-vertical horiz-adv-x horiz-origin-x image-rendering letter-spacing lighting-color marker-end marker-mid marker-start overline-position overline-thickness paint-order panose-1 pointer-events rendering-intent shape-rendering stop-color stop-opacity strikethrough-position strikethrough-thickness stroke-dasharray stroke-dashoffset stroke-linecap stroke-linejoin stroke-miterlimit stroke-opacity stroke-width text-anchor text-decoration text-rendering underline-position underline-thickness unicode-bidi unicode-range units-per-em v-alphabetic v-hanging v-ideographic v-mathematical vector-effect vert-adv-y vert-origin-x vert-origin-y word-spacing writing-mode xmlns:xlink x-height".split(" ").forEach(function(a) {
    var b = a.replace($a6bdd6b0637ea6ad$var$ja, $a6bdd6b0637ea6ad$var$ka);
    $a6bdd6b0637ea6ad$var$z[b] = new $a6bdd6b0637ea6ad$var$y(b, 1, !1, a, null, !1, !1);
});
"xlink:actuate xlink:arcrole xlink:role xlink:show xlink:title xlink:type".split(" ").forEach(function(a) {
    var b = a.replace($a6bdd6b0637ea6ad$var$ja, $a6bdd6b0637ea6ad$var$ka);
    $a6bdd6b0637ea6ad$var$z[b] = new $a6bdd6b0637ea6ad$var$y(b, 1, !1, a, "http://www.w3.org/1999/xlink", !1, !1);
});
[
    "xml:base",
    "xml:lang",
    "xml:space"
].forEach(function(a) {
    var b = a.replace($a6bdd6b0637ea6ad$var$ja, $a6bdd6b0637ea6ad$var$ka);
    $a6bdd6b0637ea6ad$var$z[b] = new $a6bdd6b0637ea6ad$var$y(b, 1, !1, a, "http://www.w3.org/XML/1998/namespace", !1, !1);
});
[
    "tabIndex",
    "crossOrigin"
].forEach(function(a) {
    $a6bdd6b0637ea6ad$var$z[a] = new $a6bdd6b0637ea6ad$var$y(a, 1, !1, a.toLowerCase(), null, !1, !1);
});
$a6bdd6b0637ea6ad$var$z.xlinkHref = new $a6bdd6b0637ea6ad$var$y("xlinkHref", 1, !1, "xlink:href", "http://www.w3.org/1999/xlink", !0, !1);
[
    "src",
    "href",
    "action",
    "formAction"
].forEach(function(a) {
    $a6bdd6b0637ea6ad$var$z[a] = new $a6bdd6b0637ea6ad$var$y(a, 1, !1, a.toLowerCase(), null, !0, !0);
});
var $a6bdd6b0637ea6ad$var$B = {
    animationIterationCount: !0,
    aspectRatio: !0,
    borderImageOutset: !0,
    borderImageSlice: !0,
    borderImageWidth: !0,
    boxFlex: !0,
    boxFlexGroup: !0,
    boxOrdinalGroup: !0,
    columnCount: !0,
    columns: !0,
    flex: !0,
    flexGrow: !0,
    flexPositive: !0,
    flexShrink: !0,
    flexNegative: !0,
    flexOrder: !0,
    gridArea: !0,
    gridRow: !0,
    gridRowEnd: !0,
    gridRowSpan: !0,
    gridRowStart: !0,
    gridColumn: !0,
    gridColumnEnd: !0,
    gridColumnSpan: !0,
    gridColumnStart: !0,
    fontWeight: !0,
    lineClamp: !0,
    lineHeight: !0,
    opacity: !0,
    order: !0,
    orphans: !0,
    tabSize: !0,
    widows: !0,
    zIndex: !0,
    zoom: !0,
    fillOpacity: !0,
    floodOpacity: !0,
    stopOpacity: !0,
    strokeDasharray: !0,
    strokeDashoffset: !0,
    strokeMiterlimit: !0,
    strokeOpacity: !0,
    strokeWidth: !0
}, $a6bdd6b0637ea6ad$var$la = [
    "Webkit",
    "ms",
    "Moz",
    "O"
];
Object.keys($a6bdd6b0637ea6ad$var$B).forEach(function(a) {
    $a6bdd6b0637ea6ad$var$la.forEach(function(b) {
        b = b + a.charAt(0).toUpperCase() + a.substring(1);
        $a6bdd6b0637ea6ad$var$B[b] = $a6bdd6b0637ea6ad$var$B[a];
    });
});
var $a6bdd6b0637ea6ad$var$oa = /["'&<>]/;
function $a6bdd6b0637ea6ad$var$C(a) {
    if ("boolean" === typeof a || "number" === typeof a) return "" + a;
    a = "" + a;
    var b = $a6bdd6b0637ea6ad$var$oa.exec(a);
    if (b) {
        var c = "", d, f = 0;
        for(d = b.index; d < a.length; d++){
            switch(a.charCodeAt(d)){
                case 34:
                    b = "&quot;";
                    break;
                case 38:
                    b = "&amp;";
                    break;
                case 39:
                    b = "&#x27;";
                    break;
                case 60:
                    b = "&lt;";
                    break;
                case 62:
                    b = "&gt;";
                    break;
                default:
                    continue;
            }
            f !== d && (c += a.substring(f, d));
            f = d + 1;
            c += b;
        }
        a = f !== d ? c + a.substring(f, d) : c;
    }
    return a;
}
var $a6bdd6b0637ea6ad$var$pa = /([A-Z])/g, $a6bdd6b0637ea6ad$var$qa = /^ms-/, $a6bdd6b0637ea6ad$var$ra = Array.isArray, $a6bdd6b0637ea6ad$var$sa = $a6bdd6b0637ea6ad$var$w("<script>"), $a6bdd6b0637ea6ad$var$ta = $a6bdd6b0637ea6ad$var$w("</script>"), $a6bdd6b0637ea6ad$var$ua = $a6bdd6b0637ea6ad$var$w('<script src="'), $a6bdd6b0637ea6ad$var$va = $a6bdd6b0637ea6ad$var$w('<script type="module" src="'), $a6bdd6b0637ea6ad$var$wa = $a6bdd6b0637ea6ad$var$w('" async=""></script>'), $a6bdd6b0637ea6ad$var$xa = /(<\/|<)(s)(cript)/gi;
function $a6bdd6b0637ea6ad$var$ya(a, b, c, d) {
    return "" + b + ("s" === c ? "\\u0073" : "\\u0053") + d;
}
function $a6bdd6b0637ea6ad$var$za(a, b, c, d, f) {
    a = void 0 === a ? "" : a;
    b = void 0 === b ? $a6bdd6b0637ea6ad$var$sa : $a6bdd6b0637ea6ad$var$w('<script nonce="' + $a6bdd6b0637ea6ad$var$C(b) + '">');
    var e = [];
    void 0 !== c && e.push(b, $a6bdd6b0637ea6ad$var$u(("" + c).replace($a6bdd6b0637ea6ad$var$xa, $a6bdd6b0637ea6ad$var$ya)), $a6bdd6b0637ea6ad$var$ta);
    if (void 0 !== d) for(c = 0; c < d.length; c++)e.push($a6bdd6b0637ea6ad$var$ua, $a6bdd6b0637ea6ad$var$u($a6bdd6b0637ea6ad$var$C(d[c])), $a6bdd6b0637ea6ad$var$wa);
    if (void 0 !== f) for(d = 0; d < f.length; d++)e.push($a6bdd6b0637ea6ad$var$va, $a6bdd6b0637ea6ad$var$u($a6bdd6b0637ea6ad$var$C(f[d])), $a6bdd6b0637ea6ad$var$wa);
    return {
        bootstrapChunks: e,
        startInlineScript: b,
        placeholderPrefix: $a6bdd6b0637ea6ad$var$w(a + "P:"),
        segmentPrefix: $a6bdd6b0637ea6ad$var$w(a + "S:"),
        boundaryPrefix: a + "B:",
        idPrefix: a,
        nextSuspenseID: 0,
        sentCompleteSegmentFunction: !1,
        sentCompleteBoundaryFunction: !1,
        sentClientRenderFunction: !1
    };
}
function $a6bdd6b0637ea6ad$var$D(a, b) {
    return {
        insertionMode: a,
        selectedValue: b
    };
}
function $a6bdd6b0637ea6ad$var$Aa(a) {
    return $a6bdd6b0637ea6ad$var$D("http://www.w3.org/2000/svg" === a ? 2 : "http://www.w3.org/1998/Math/MathML" === a ? 3 : 0, null);
}
function $a6bdd6b0637ea6ad$var$Ba(a, b, c) {
    switch(b){
        case "select":
            return $a6bdd6b0637ea6ad$var$D(1, null != c.value ? c.value : c.defaultValue);
        case "svg":
            return $a6bdd6b0637ea6ad$var$D(2, null);
        case "math":
            return $a6bdd6b0637ea6ad$var$D(3, null);
        case "foreignObject":
            return $a6bdd6b0637ea6ad$var$D(1, null);
        case "table":
            return $a6bdd6b0637ea6ad$var$D(4, null);
        case "thead":
        case "tbody":
        case "tfoot":
            return $a6bdd6b0637ea6ad$var$D(5, null);
        case "colgroup":
            return $a6bdd6b0637ea6ad$var$D(7, null);
        case "tr":
            return $a6bdd6b0637ea6ad$var$D(6, null);
    }
    return 4 <= a.insertionMode || 0 === a.insertionMode ? $a6bdd6b0637ea6ad$var$D(1, null) : a;
}
var $a6bdd6b0637ea6ad$var$Ca = $a6bdd6b0637ea6ad$var$w("<!-- -->");
function $a6bdd6b0637ea6ad$var$Da(a, b, c, d) {
    if ("" === b) return d;
    d && a.push($a6bdd6b0637ea6ad$var$Ca);
    a.push($a6bdd6b0637ea6ad$var$u($a6bdd6b0637ea6ad$var$C(b)));
    return !0;
}
var $a6bdd6b0637ea6ad$var$Ea = new Map, $a6bdd6b0637ea6ad$var$Fa = $a6bdd6b0637ea6ad$var$w(' style="'), $a6bdd6b0637ea6ad$var$Ga = $a6bdd6b0637ea6ad$var$w(":"), $a6bdd6b0637ea6ad$var$Ha = $a6bdd6b0637ea6ad$var$w(";");
function $a6bdd6b0637ea6ad$var$Ia(a, b, c) {
    if ("object" !== typeof c) throw Error($a6bdd6b0637ea6ad$var$k(62));
    b = !0;
    for(var d in c)if ($a6bdd6b0637ea6ad$var$x.call(c, d)) {
        var f = c[d];
        if (null != f && "boolean" !== typeof f && "" !== f) {
            if (0 === d.indexOf("--")) {
                var e = $a6bdd6b0637ea6ad$var$u($a6bdd6b0637ea6ad$var$C(d));
                f = $a6bdd6b0637ea6ad$var$u($a6bdd6b0637ea6ad$var$C(("" + f).trim()));
            } else {
                e = d;
                var g = $a6bdd6b0637ea6ad$var$Ea.get(e);
                void 0 !== g ? e = g : (g = $a6bdd6b0637ea6ad$var$w($a6bdd6b0637ea6ad$var$C(e.replace($a6bdd6b0637ea6ad$var$pa, "-$1").toLowerCase().replace($a6bdd6b0637ea6ad$var$qa, "-ms-"))), $a6bdd6b0637ea6ad$var$Ea.set(e, g), e = g);
                f = "number" === typeof f ? 0 === f || $a6bdd6b0637ea6ad$var$x.call($a6bdd6b0637ea6ad$var$B, d) ? $a6bdd6b0637ea6ad$var$u("" + f) : $a6bdd6b0637ea6ad$var$u(f + "px") : $a6bdd6b0637ea6ad$var$u($a6bdd6b0637ea6ad$var$C(("" + f).trim()));
            }
            b ? (b = !1, a.push($a6bdd6b0637ea6ad$var$Fa, e, $a6bdd6b0637ea6ad$var$Ga, f)) : a.push($a6bdd6b0637ea6ad$var$Ha, e, $a6bdd6b0637ea6ad$var$Ga, f);
        }
    }
    b || a.push($a6bdd6b0637ea6ad$var$E);
}
var $a6bdd6b0637ea6ad$var$H = $a6bdd6b0637ea6ad$var$w(" "), $a6bdd6b0637ea6ad$var$I = $a6bdd6b0637ea6ad$var$w('="'), $a6bdd6b0637ea6ad$var$E = $a6bdd6b0637ea6ad$var$w('"'), $a6bdd6b0637ea6ad$var$Ja = $a6bdd6b0637ea6ad$var$w('=""');
function $a6bdd6b0637ea6ad$var$J(a, b, c, d) {
    switch(c){
        case "style":
            $a6bdd6b0637ea6ad$var$Ia(a, b, d);
            return;
        case "defaultValue":
        case "defaultChecked":
        case "innerHTML":
        case "suppressContentEditableWarning":
        case "suppressHydrationWarning":
            return;
    }
    if (!(2 < c.length) || "o" !== c[0] && "O" !== c[0] || "n" !== c[1] && "N" !== c[1]) {
        if (b = $a6bdd6b0637ea6ad$var$z.hasOwnProperty(c) ? $a6bdd6b0637ea6ad$var$z[c] : null, null !== b) {
            switch(typeof d){
                case "function":
                case "symbol":
                    return;
                case "boolean":
                    if (!b.acceptsBooleans) return;
            }
            c = $a6bdd6b0637ea6ad$var$u(b.attributeName);
            switch(b.type){
                case 3:
                    d && a.push($a6bdd6b0637ea6ad$var$H, c, $a6bdd6b0637ea6ad$var$Ja);
                    break;
                case 4:
                    !0 === d ? a.push($a6bdd6b0637ea6ad$var$H, c, $a6bdd6b0637ea6ad$var$Ja) : !1 !== d && a.push($a6bdd6b0637ea6ad$var$H, c, $a6bdd6b0637ea6ad$var$I, $a6bdd6b0637ea6ad$var$u($a6bdd6b0637ea6ad$var$C(d)), $a6bdd6b0637ea6ad$var$E);
                    break;
                case 5:
                    isNaN(d) || a.push($a6bdd6b0637ea6ad$var$H, c, $a6bdd6b0637ea6ad$var$I, $a6bdd6b0637ea6ad$var$u($a6bdd6b0637ea6ad$var$C(d)), $a6bdd6b0637ea6ad$var$E);
                    break;
                case 6:
                    !isNaN(d) && 1 <= d && a.push($a6bdd6b0637ea6ad$var$H, c, $a6bdd6b0637ea6ad$var$I, $a6bdd6b0637ea6ad$var$u($a6bdd6b0637ea6ad$var$C(d)), $a6bdd6b0637ea6ad$var$E);
                    break;
                default:
                    b.sanitizeURL && (d = "" + d), a.push($a6bdd6b0637ea6ad$var$H, c, $a6bdd6b0637ea6ad$var$I, $a6bdd6b0637ea6ad$var$u($a6bdd6b0637ea6ad$var$C(d)), $a6bdd6b0637ea6ad$var$E);
            }
        } else if ($a6bdd6b0637ea6ad$var$ia(c)) {
            switch(typeof d){
                case "function":
                case "symbol":
                    return;
                case "boolean":
                    if (b = c.toLowerCase().slice(0, 5), "data-" !== b && "aria-" !== b) return;
            }
            a.push($a6bdd6b0637ea6ad$var$H, $a6bdd6b0637ea6ad$var$u(c), $a6bdd6b0637ea6ad$var$I, $a6bdd6b0637ea6ad$var$u($a6bdd6b0637ea6ad$var$C(d)), $a6bdd6b0637ea6ad$var$E);
        }
    }
}
var $a6bdd6b0637ea6ad$var$K = $a6bdd6b0637ea6ad$var$w(">"), $a6bdd6b0637ea6ad$var$Ka = $a6bdd6b0637ea6ad$var$w("/>");
function $a6bdd6b0637ea6ad$var$L(a, b, c) {
    if (null != b) {
        if (null != c) throw Error($a6bdd6b0637ea6ad$var$k(60));
        if ("object" !== typeof b || !("__html" in b)) throw Error($a6bdd6b0637ea6ad$var$k(61));
        b = b.__html;
        null !== b && void 0 !== b && a.push($a6bdd6b0637ea6ad$var$u("" + b));
    }
}
function $a6bdd6b0637ea6ad$var$La(a) {
    var b = "";
    $cWbtJ.Children.forEach(a, function(a) {
        null != a && (b += a);
    });
    return b;
}
var $a6bdd6b0637ea6ad$var$Ma = $a6bdd6b0637ea6ad$var$w(' selected=""');
function $a6bdd6b0637ea6ad$var$Na(a, b, c, d) {
    a.push($a6bdd6b0637ea6ad$var$M(c));
    var f = c = null, e;
    for(e in b)if ($a6bdd6b0637ea6ad$var$x.call(b, e)) {
        var g = b[e];
        if (null != g) switch(e){
            case "children":
                c = g;
                break;
            case "dangerouslySetInnerHTML":
                f = g;
                break;
            default:
                $a6bdd6b0637ea6ad$var$J(a, d, e, g);
        }
    }
    a.push($a6bdd6b0637ea6ad$var$K);
    $a6bdd6b0637ea6ad$var$L(a, f, c);
    return "string" === typeof c ? (a.push($a6bdd6b0637ea6ad$var$u($a6bdd6b0637ea6ad$var$C(c))), null) : c;
}
var $a6bdd6b0637ea6ad$var$Oa = $a6bdd6b0637ea6ad$var$w("\n"), $a6bdd6b0637ea6ad$var$Pa = /^[a-zA-Z][a-zA-Z:_\.\-\d]*$/, $a6bdd6b0637ea6ad$var$Qa = new Map;
function $a6bdd6b0637ea6ad$var$M(a) {
    var b = $a6bdd6b0637ea6ad$var$Qa.get(a);
    if (void 0 === b) {
        if (!$a6bdd6b0637ea6ad$var$Pa.test(a)) throw Error($a6bdd6b0637ea6ad$var$k(65, a));
        b = $a6bdd6b0637ea6ad$var$w("<" + a);
        $a6bdd6b0637ea6ad$var$Qa.set(a, b);
    }
    return b;
}
var $a6bdd6b0637ea6ad$var$Ra = $a6bdd6b0637ea6ad$var$w("<!DOCTYPE html>");
function $a6bdd6b0637ea6ad$var$Sa(a, b, c, d, f) {
    switch(b){
        case "select":
            a.push($a6bdd6b0637ea6ad$var$M("select"));
            var e = null, g = null;
            for(r in c)if ($a6bdd6b0637ea6ad$var$x.call(c, r)) {
                var h = c[r];
                if (null != h) switch(r){
                    case "children":
                        e = h;
                        break;
                    case "dangerouslySetInnerHTML":
                        g = h;
                        break;
                    case "defaultValue":
                    case "value":
                        break;
                    default:
                        $a6bdd6b0637ea6ad$var$J(a, d, r, h);
                }
            }
            a.push($a6bdd6b0637ea6ad$var$K);
            $a6bdd6b0637ea6ad$var$L(a, g, e);
            return e;
        case "option":
            g = f.selectedValue;
            a.push($a6bdd6b0637ea6ad$var$M("option"));
            var m = h = null, q = null;
            var r = null;
            for(e in c)if ($a6bdd6b0637ea6ad$var$x.call(c, e)) {
                var v = c[e];
                if (null != v) switch(e){
                    case "children":
                        h = v;
                        break;
                    case "selected":
                        q = v;
                        break;
                    case "dangerouslySetInnerHTML":
                        r = v;
                        break;
                    case "value":
                        m = v;
                    default:
                        $a6bdd6b0637ea6ad$var$J(a, d, e, v);
                }
            }
            if (null != g) {
                if (c = null !== m ? "" + m : $a6bdd6b0637ea6ad$var$La(h), $a6bdd6b0637ea6ad$var$ra(g)) {
                    for(d = 0; d < g.length; d++)if ("" + g[d] === c) {
                        a.push($a6bdd6b0637ea6ad$var$Ma);
                        break;
                    }
                } else "" + g === c && a.push($a6bdd6b0637ea6ad$var$Ma);
            } else q && a.push($a6bdd6b0637ea6ad$var$Ma);
            a.push($a6bdd6b0637ea6ad$var$K);
            $a6bdd6b0637ea6ad$var$L(a, r, h);
            return h;
        case "textarea":
            a.push($a6bdd6b0637ea6ad$var$M("textarea"));
            r = g = e = null;
            for(h in c)if ($a6bdd6b0637ea6ad$var$x.call(c, h) && (m = c[h], null != m)) switch(h){
                case "children":
                    r = m;
                    break;
                case "value":
                    e = m;
                    break;
                case "defaultValue":
                    g = m;
                    break;
                case "dangerouslySetInnerHTML":
                    throw Error($a6bdd6b0637ea6ad$var$k(91));
                default:
                    $a6bdd6b0637ea6ad$var$J(a, d, h, m);
            }
            null === e && null !== g && (e = g);
            a.push($a6bdd6b0637ea6ad$var$K);
            if (null != r) {
                if (null != e) throw Error($a6bdd6b0637ea6ad$var$k(92));
                if ($a6bdd6b0637ea6ad$var$ra(r) && 1 < r.length) throw Error($a6bdd6b0637ea6ad$var$k(93));
                e = "" + r;
            }
            "string" === typeof e && "\n" === e[0] && a.push($a6bdd6b0637ea6ad$var$Oa);
            null !== e && a.push($a6bdd6b0637ea6ad$var$u($a6bdd6b0637ea6ad$var$C("" + e)));
            return null;
        case "input":
            a.push($a6bdd6b0637ea6ad$var$M("input"));
            m = r = h = e = null;
            for(g in c)if ($a6bdd6b0637ea6ad$var$x.call(c, g) && (q = c[g], null != q)) switch(g){
                case "children":
                case "dangerouslySetInnerHTML":
                    throw Error($a6bdd6b0637ea6ad$var$k(399, "input"));
                case "defaultChecked":
                    m = q;
                    break;
                case "defaultValue":
                    h = q;
                    break;
                case "checked":
                    r = q;
                    break;
                case "value":
                    e = q;
                    break;
                default:
                    $a6bdd6b0637ea6ad$var$J(a, d, g, q);
            }
            null !== r ? $a6bdd6b0637ea6ad$var$J(a, d, "checked", r) : null !== m && $a6bdd6b0637ea6ad$var$J(a, d, "checked", m);
            null !== e ? $a6bdd6b0637ea6ad$var$J(a, d, "value", e) : null !== h && $a6bdd6b0637ea6ad$var$J(a, d, "value", h);
            a.push($a6bdd6b0637ea6ad$var$Ka);
            return null;
        case "menuitem":
            a.push($a6bdd6b0637ea6ad$var$M("menuitem"));
            for(var A in c)if ($a6bdd6b0637ea6ad$var$x.call(c, A) && (e = c[A], null != e)) switch(A){
                case "children":
                case "dangerouslySetInnerHTML":
                    throw Error($a6bdd6b0637ea6ad$var$k(400));
                default:
                    $a6bdd6b0637ea6ad$var$J(a, d, A, e);
            }
            a.push($a6bdd6b0637ea6ad$var$K);
            return null;
        case "title":
            a.push($a6bdd6b0637ea6ad$var$M("title"));
            e = null;
            for(v in c)if ($a6bdd6b0637ea6ad$var$x.call(c, v) && (g = c[v], null != g)) switch(v){
                case "children":
                    e = g;
                    break;
                case "dangerouslySetInnerHTML":
                    throw Error($a6bdd6b0637ea6ad$var$k(434));
                default:
                    $a6bdd6b0637ea6ad$var$J(a, d, v, g);
            }
            a.push($a6bdd6b0637ea6ad$var$K);
            return e;
        case "listing":
        case "pre":
            a.push($a6bdd6b0637ea6ad$var$M(b));
            g = e = null;
            for(m in c)if ($a6bdd6b0637ea6ad$var$x.call(c, m) && (h = c[m], null != h)) switch(m){
                case "children":
                    e = h;
                    break;
                case "dangerouslySetInnerHTML":
                    g = h;
                    break;
                default:
                    $a6bdd6b0637ea6ad$var$J(a, d, m, h);
            }
            a.push($a6bdd6b0637ea6ad$var$K);
            if (null != g) {
                if (null != e) throw Error($a6bdd6b0637ea6ad$var$k(60));
                if ("object" !== typeof g || !("__html" in g)) throw Error($a6bdd6b0637ea6ad$var$k(61));
                c = g.__html;
                null !== c && void 0 !== c && ("string" === typeof c && 0 < c.length && "\n" === c[0] ? a.push($a6bdd6b0637ea6ad$var$Oa, $a6bdd6b0637ea6ad$var$u(c)) : a.push($a6bdd6b0637ea6ad$var$u("" + c)));
            }
            "string" === typeof e && "\n" === e[0] && a.push($a6bdd6b0637ea6ad$var$Oa);
            return e;
        case "area":
        case "base":
        case "br":
        case "col":
        case "embed":
        case "hr":
        case "img":
        case "keygen":
        case "link":
        case "meta":
        case "param":
        case "source":
        case "track":
        case "wbr":
            a.push($a6bdd6b0637ea6ad$var$M(b));
            for(var F in c)if ($a6bdd6b0637ea6ad$var$x.call(c, F) && (e = c[F], null != e)) switch(F){
                case "children":
                case "dangerouslySetInnerHTML":
                    throw Error($a6bdd6b0637ea6ad$var$k(399, b));
                default:
                    $a6bdd6b0637ea6ad$var$J(a, d, F, e);
            }
            a.push($a6bdd6b0637ea6ad$var$Ka);
            return null;
        case "annotation-xml":
        case "color-profile":
        case "font-face":
        case "font-face-src":
        case "font-face-uri":
        case "font-face-format":
        case "font-face-name":
        case "missing-glyph":
            return $a6bdd6b0637ea6ad$var$Na(a, c, b, d);
        case "html":
            return 0 === f.insertionMode && a.push($a6bdd6b0637ea6ad$var$Ra), $a6bdd6b0637ea6ad$var$Na(a, c, b, d);
        default:
            if (-1 === b.indexOf("-") && "string" !== typeof c.is) return $a6bdd6b0637ea6ad$var$Na(a, c, b, d);
            a.push($a6bdd6b0637ea6ad$var$M(b));
            g = e = null;
            for(q in c)if ($a6bdd6b0637ea6ad$var$x.call(c, q) && (h = c[q], null != h)) switch(q){
                case "children":
                    e = h;
                    break;
                case "dangerouslySetInnerHTML":
                    g = h;
                    break;
                case "style":
                    $a6bdd6b0637ea6ad$var$Ia(a, d, h);
                    break;
                case "suppressContentEditableWarning":
                case "suppressHydrationWarning":
                    break;
                default:
                    $a6bdd6b0637ea6ad$var$ia(q) && "function" !== typeof h && "symbol" !== typeof h && a.push($a6bdd6b0637ea6ad$var$H, $a6bdd6b0637ea6ad$var$u(q), $a6bdd6b0637ea6ad$var$I, $a6bdd6b0637ea6ad$var$u($a6bdd6b0637ea6ad$var$C(h)), $a6bdd6b0637ea6ad$var$E);
            }
            a.push($a6bdd6b0637ea6ad$var$K);
            $a6bdd6b0637ea6ad$var$L(a, g, e);
            return e;
    }
}
var $a6bdd6b0637ea6ad$var$Ta = $a6bdd6b0637ea6ad$var$w("</"), $a6bdd6b0637ea6ad$var$Ua = $a6bdd6b0637ea6ad$var$w(">"), $a6bdd6b0637ea6ad$var$Va = $a6bdd6b0637ea6ad$var$w('<template id="'), $a6bdd6b0637ea6ad$var$Wa = $a6bdd6b0637ea6ad$var$w('"></template>'), $a6bdd6b0637ea6ad$var$Xa = $a6bdd6b0637ea6ad$var$w("<!--$-->"), $a6bdd6b0637ea6ad$var$Ya = $a6bdd6b0637ea6ad$var$w('<!--$?--><template id="'), $a6bdd6b0637ea6ad$var$Za = $a6bdd6b0637ea6ad$var$w('"></template>'), $a6bdd6b0637ea6ad$var$$a = $a6bdd6b0637ea6ad$var$w("<!--$!-->"), $a6bdd6b0637ea6ad$var$ab = $a6bdd6b0637ea6ad$var$w("<!--/$-->"), $a6bdd6b0637ea6ad$var$bb = $a6bdd6b0637ea6ad$var$w("<template"), $a6bdd6b0637ea6ad$var$cb = $a6bdd6b0637ea6ad$var$w('"'), $a6bdd6b0637ea6ad$var$db = $a6bdd6b0637ea6ad$var$w(' data-dgst="');
$a6bdd6b0637ea6ad$var$w(' data-msg="');
$a6bdd6b0637ea6ad$var$w(' data-stck="');
var $a6bdd6b0637ea6ad$var$eb = $a6bdd6b0637ea6ad$var$w("></template>");
function $a6bdd6b0637ea6ad$var$fb(a, b, c) {
    $a6bdd6b0637ea6ad$var$p(a, $a6bdd6b0637ea6ad$var$Ya);
    if (null === c) throw Error($a6bdd6b0637ea6ad$var$k(395));
    $a6bdd6b0637ea6ad$var$p(a, c);
    return $a6bdd6b0637ea6ad$var$t(a, $a6bdd6b0637ea6ad$var$Za);
}
var $a6bdd6b0637ea6ad$var$gb = $a6bdd6b0637ea6ad$var$w('<div hidden id="'), $a6bdd6b0637ea6ad$var$hb = $a6bdd6b0637ea6ad$var$w('">'), $a6bdd6b0637ea6ad$var$ib = $a6bdd6b0637ea6ad$var$w("</div>"), $a6bdd6b0637ea6ad$var$jb = $a6bdd6b0637ea6ad$var$w('<svg aria-hidden="true" style="display:none" id="'), $a6bdd6b0637ea6ad$var$kb = $a6bdd6b0637ea6ad$var$w('">'), $a6bdd6b0637ea6ad$var$lb = $a6bdd6b0637ea6ad$var$w("</svg>"), $a6bdd6b0637ea6ad$var$mb = $a6bdd6b0637ea6ad$var$w('<math aria-hidden="true" style="display:none" id="'), $a6bdd6b0637ea6ad$var$nb = $a6bdd6b0637ea6ad$var$w('">'), $a6bdd6b0637ea6ad$var$ob = $a6bdd6b0637ea6ad$var$w("</math>"), $a6bdd6b0637ea6ad$var$pb = $a6bdd6b0637ea6ad$var$w('<table hidden id="'), $a6bdd6b0637ea6ad$var$qb = $a6bdd6b0637ea6ad$var$w('">'), $a6bdd6b0637ea6ad$var$rb = $a6bdd6b0637ea6ad$var$w("</table>"), $a6bdd6b0637ea6ad$var$sb = $a6bdd6b0637ea6ad$var$w('<table hidden><tbody id="'), $a6bdd6b0637ea6ad$var$tb = $a6bdd6b0637ea6ad$var$w('">'), $a6bdd6b0637ea6ad$var$ub = $a6bdd6b0637ea6ad$var$w("</tbody></table>"), $a6bdd6b0637ea6ad$var$vb = $a6bdd6b0637ea6ad$var$w('<table hidden><tr id="'), $a6bdd6b0637ea6ad$var$wb = $a6bdd6b0637ea6ad$var$w('">'), $a6bdd6b0637ea6ad$var$xb = $a6bdd6b0637ea6ad$var$w("</tr></table>"), $a6bdd6b0637ea6ad$var$yb = $a6bdd6b0637ea6ad$var$w('<table hidden><colgroup id="'), $a6bdd6b0637ea6ad$var$zb = $a6bdd6b0637ea6ad$var$w('">'), $a6bdd6b0637ea6ad$var$Ab = $a6bdd6b0637ea6ad$var$w("</colgroup></table>");
function $a6bdd6b0637ea6ad$var$Bb(a, b, c, d) {
    switch(c.insertionMode){
        case 0:
        case 1:
            return $a6bdd6b0637ea6ad$var$p(a, $a6bdd6b0637ea6ad$var$gb), $a6bdd6b0637ea6ad$var$p(a, b.segmentPrefix), $a6bdd6b0637ea6ad$var$p(a, $a6bdd6b0637ea6ad$var$u(d.toString(16))), $a6bdd6b0637ea6ad$var$t(a, $a6bdd6b0637ea6ad$var$hb);
        case 2:
            return $a6bdd6b0637ea6ad$var$p(a, $a6bdd6b0637ea6ad$var$jb), $a6bdd6b0637ea6ad$var$p(a, b.segmentPrefix), $a6bdd6b0637ea6ad$var$p(a, $a6bdd6b0637ea6ad$var$u(d.toString(16))), $a6bdd6b0637ea6ad$var$t(a, $a6bdd6b0637ea6ad$var$kb);
        case 3:
            return $a6bdd6b0637ea6ad$var$p(a, $a6bdd6b0637ea6ad$var$mb), $a6bdd6b0637ea6ad$var$p(a, b.segmentPrefix), $a6bdd6b0637ea6ad$var$p(a, $a6bdd6b0637ea6ad$var$u(d.toString(16))), $a6bdd6b0637ea6ad$var$t(a, $a6bdd6b0637ea6ad$var$nb);
        case 4:
            return $a6bdd6b0637ea6ad$var$p(a, $a6bdd6b0637ea6ad$var$pb), $a6bdd6b0637ea6ad$var$p(a, b.segmentPrefix), $a6bdd6b0637ea6ad$var$p(a, $a6bdd6b0637ea6ad$var$u(d.toString(16))), $a6bdd6b0637ea6ad$var$t(a, $a6bdd6b0637ea6ad$var$qb);
        case 5:
            return $a6bdd6b0637ea6ad$var$p(a, $a6bdd6b0637ea6ad$var$sb), $a6bdd6b0637ea6ad$var$p(a, b.segmentPrefix), $a6bdd6b0637ea6ad$var$p(a, $a6bdd6b0637ea6ad$var$u(d.toString(16))), $a6bdd6b0637ea6ad$var$t(a, $a6bdd6b0637ea6ad$var$tb);
        case 6:
            return $a6bdd6b0637ea6ad$var$p(a, $a6bdd6b0637ea6ad$var$vb), $a6bdd6b0637ea6ad$var$p(a, b.segmentPrefix), $a6bdd6b0637ea6ad$var$p(a, $a6bdd6b0637ea6ad$var$u(d.toString(16))), $a6bdd6b0637ea6ad$var$t(a, $a6bdd6b0637ea6ad$var$wb);
        case 7:
            return $a6bdd6b0637ea6ad$var$p(a, $a6bdd6b0637ea6ad$var$yb), $a6bdd6b0637ea6ad$var$p(a, b.segmentPrefix), $a6bdd6b0637ea6ad$var$p(a, $a6bdd6b0637ea6ad$var$u(d.toString(16))), $a6bdd6b0637ea6ad$var$t(a, $a6bdd6b0637ea6ad$var$zb);
        default:
            throw Error($a6bdd6b0637ea6ad$var$k(397));
    }
}
function $a6bdd6b0637ea6ad$var$Cb(a, b) {
    switch(b.insertionMode){
        case 0:
        case 1:
            return $a6bdd6b0637ea6ad$var$t(a, $a6bdd6b0637ea6ad$var$ib);
        case 2:
            return $a6bdd6b0637ea6ad$var$t(a, $a6bdd6b0637ea6ad$var$lb);
        case 3:
            return $a6bdd6b0637ea6ad$var$t(a, $a6bdd6b0637ea6ad$var$ob);
        case 4:
            return $a6bdd6b0637ea6ad$var$t(a, $a6bdd6b0637ea6ad$var$rb);
        case 5:
            return $a6bdd6b0637ea6ad$var$t(a, $a6bdd6b0637ea6ad$var$ub);
        case 6:
            return $a6bdd6b0637ea6ad$var$t(a, $a6bdd6b0637ea6ad$var$xb);
        case 7:
            return $a6bdd6b0637ea6ad$var$t(a, $a6bdd6b0637ea6ad$var$Ab);
        default:
            throw Error($a6bdd6b0637ea6ad$var$k(397));
    }
}
var $a6bdd6b0637ea6ad$var$Db = $a6bdd6b0637ea6ad$var$w('function $RS(a,b){a=document.getElementById(a);b=document.getElementById(b);for(a.parentNode.removeChild(a);a.firstChild;)b.parentNode.insertBefore(a.firstChild,b);b.parentNode.removeChild(b)};$RS("'), $a6bdd6b0637ea6ad$var$Eb = $a6bdd6b0637ea6ad$var$w('$RS("'), $a6bdd6b0637ea6ad$var$Gb = $a6bdd6b0637ea6ad$var$w('","'), $a6bdd6b0637ea6ad$var$Hb = $a6bdd6b0637ea6ad$var$w('")</script>'), $a6bdd6b0637ea6ad$var$Ib = $a6bdd6b0637ea6ad$var$w('function $RC(a,b){a=document.getElementById(a);b=document.getElementById(b);b.parentNode.removeChild(b);if(a){a=a.previousSibling;var f=a.parentNode,c=a.nextSibling,e=0;do{if(c&&8===c.nodeType){var d=c.data;if("/$"===d)if(0===e)break;else e--;else"$"!==d&&"$?"!==d&&"$!"!==d||e++}d=c.nextSibling;f.removeChild(c);c=d}while(c);for(;b.firstChild;)f.insertBefore(b.firstChild,c);a.data="$";a._reactRetry&&a._reactRetry()}};$RC("'), $a6bdd6b0637ea6ad$var$Jb = $a6bdd6b0637ea6ad$var$w('$RC("'), $a6bdd6b0637ea6ad$var$Kb = $a6bdd6b0637ea6ad$var$w('","'), $a6bdd6b0637ea6ad$var$Lb = $a6bdd6b0637ea6ad$var$w('")</script>'), $a6bdd6b0637ea6ad$var$Mb = $a6bdd6b0637ea6ad$var$w('function $RX(b,c,d,e){var a=document.getElementById(b);a&&(b=a.previousSibling,b.data="$!",a=a.dataset,c&&(a.dgst=c),d&&(a.msg=d),e&&(a.stck=e),b._reactRetry&&b._reactRetry())};$RX("'), $a6bdd6b0637ea6ad$var$Nb = $a6bdd6b0637ea6ad$var$w('$RX("'), $a6bdd6b0637ea6ad$var$Ob = $a6bdd6b0637ea6ad$var$w('"'), $a6bdd6b0637ea6ad$var$Pb = $a6bdd6b0637ea6ad$var$w(")</script>"), $a6bdd6b0637ea6ad$var$Qb = $a6bdd6b0637ea6ad$var$w(","), $a6bdd6b0637ea6ad$var$Rb = /[<\u2028\u2029]/g;
function $a6bdd6b0637ea6ad$var$Sb(a) {
    return JSON.stringify(a).replace($a6bdd6b0637ea6ad$var$Rb, function(a) {
        switch(a){
            case "<":
                return "\\u003c";
            case "\u2028":
                return "\\u2028";
            case "\u2029":
                return "\\u2029";
            default:
                throw Error("escapeJSStringsForInstructionScripts encountered a match it does not know how to replace. this means the match regex and the replacement characters are no longer in sync. This is a bug in React");
        }
    });
}
var $a6bdd6b0637ea6ad$var$N = Object.assign, $a6bdd6b0637ea6ad$var$Tb = Symbol.for("react.element"), $a6bdd6b0637ea6ad$var$Ub = Symbol.for("react.portal"), $a6bdd6b0637ea6ad$var$Vb = Symbol.for("react.fragment"), $a6bdd6b0637ea6ad$var$Wb = Symbol.for("react.strict_mode"), $a6bdd6b0637ea6ad$var$Xb = Symbol.for("react.profiler"), $a6bdd6b0637ea6ad$var$Yb = Symbol.for("react.provider"), $a6bdd6b0637ea6ad$var$Zb = Symbol.for("react.context"), $a6bdd6b0637ea6ad$var$$b = Symbol.for("react.forward_ref"), $a6bdd6b0637ea6ad$var$ac = Symbol.for("react.suspense"), $a6bdd6b0637ea6ad$var$bc = Symbol.for("react.suspense_list"), $a6bdd6b0637ea6ad$var$cc = Symbol.for("react.memo"), $a6bdd6b0637ea6ad$var$dc = Symbol.for("react.lazy"), $a6bdd6b0637ea6ad$var$ec = Symbol.for("react.scope"), $a6bdd6b0637ea6ad$var$fc = Symbol.for("react.debug_trace_mode"), $a6bdd6b0637ea6ad$var$gc = Symbol.for("react.legacy_hidden"), $a6bdd6b0637ea6ad$var$hc = Symbol.for("react.default_value"), $a6bdd6b0637ea6ad$var$ic = Symbol.iterator;
function $a6bdd6b0637ea6ad$var$jc(a) {
    if (null == a) return null;
    if ("function" === typeof a) return a.displayName || a.name || null;
    if ("string" === typeof a) return a;
    switch(a){
        case $a6bdd6b0637ea6ad$var$Vb:
            return "Fragment";
        case $a6bdd6b0637ea6ad$var$Ub:
            return "Portal";
        case $a6bdd6b0637ea6ad$var$Xb:
            return "Profiler";
        case $a6bdd6b0637ea6ad$var$Wb:
            return "StrictMode";
        case $a6bdd6b0637ea6ad$var$ac:
            return "Suspense";
        case $a6bdd6b0637ea6ad$var$bc:
            return "SuspenseList";
    }
    if ("object" === typeof a) switch(a.$$typeof){
        case $a6bdd6b0637ea6ad$var$Zb:
            return (a.displayName || "Context") + ".Consumer";
        case $a6bdd6b0637ea6ad$var$Yb:
            return (a._context.displayName || "Context") + ".Provider";
        case $a6bdd6b0637ea6ad$var$$b:
            var b = a.render;
            a = a.displayName;
            a || (a = b.displayName || b.name || "", a = "" !== a ? "ForwardRef(" + a + ")" : "ForwardRef");
            return a;
        case $a6bdd6b0637ea6ad$var$cc:
            return b = a.displayName || null, null !== b ? b : $a6bdd6b0637ea6ad$var$jc(a.type) || "Memo";
        case $a6bdd6b0637ea6ad$var$dc:
            b = a._payload;
            a = a._init;
            try {
                return $a6bdd6b0637ea6ad$var$jc(a(b));
            } catch (c) {}
    }
    return null;
}
var $a6bdd6b0637ea6ad$var$kc = {};
function $a6bdd6b0637ea6ad$var$lc(a, b) {
    a = a.contextTypes;
    if (!a) return $a6bdd6b0637ea6ad$var$kc;
    var c = {}, d;
    for(d in a)c[d] = b[d];
    return c;
}
var $a6bdd6b0637ea6ad$var$O = null;
function $a6bdd6b0637ea6ad$var$P(a, b) {
    if (a !== b) {
        a.context._currentValue = a.parentValue;
        a = a.parent;
        var c = b.parent;
        if (null === a) {
            if (null !== c) throw Error($a6bdd6b0637ea6ad$var$k(401));
        } else {
            if (null === c) throw Error($a6bdd6b0637ea6ad$var$k(401));
            $a6bdd6b0637ea6ad$var$P(a, c);
        }
        b.context._currentValue = b.value;
    }
}
function $a6bdd6b0637ea6ad$var$mc(a) {
    a.context._currentValue = a.parentValue;
    a = a.parent;
    null !== a && $a6bdd6b0637ea6ad$var$mc(a);
}
function $a6bdd6b0637ea6ad$var$nc(a) {
    var b = a.parent;
    null !== b && $a6bdd6b0637ea6ad$var$nc(b);
    a.context._currentValue = a.value;
}
function $a6bdd6b0637ea6ad$var$oc(a, b) {
    a.context._currentValue = a.parentValue;
    a = a.parent;
    if (null === a) throw Error($a6bdd6b0637ea6ad$var$k(402));
    a.depth === b.depth ? $a6bdd6b0637ea6ad$var$P(a, b) : $a6bdd6b0637ea6ad$var$oc(a, b);
}
function $a6bdd6b0637ea6ad$var$pc(a, b) {
    var c = b.parent;
    if (null === c) throw Error($a6bdd6b0637ea6ad$var$k(402));
    a.depth === c.depth ? $a6bdd6b0637ea6ad$var$P(a, c) : $a6bdd6b0637ea6ad$var$pc(a, c);
    b.context._currentValue = b.value;
}
function $a6bdd6b0637ea6ad$var$Q(a) {
    var b = $a6bdd6b0637ea6ad$var$O;
    b !== a && (null === b ? $a6bdd6b0637ea6ad$var$nc(a) : null === a ? $a6bdd6b0637ea6ad$var$mc(b) : b.depth === a.depth ? $a6bdd6b0637ea6ad$var$P(b, a) : b.depth > a.depth ? $a6bdd6b0637ea6ad$var$oc(b, a) : $a6bdd6b0637ea6ad$var$pc(b, a), $a6bdd6b0637ea6ad$var$O = a);
}
var $a6bdd6b0637ea6ad$var$qc = {
    isMounted: function() {
        return !1;
    },
    enqueueSetState: function(a, b) {
        a = a._reactInternals;
        null !== a.queue && a.queue.push(b);
    },
    enqueueReplaceState: function(a, b) {
        a = a._reactInternals;
        a.replace = !0;
        a.queue = [
            b
        ];
    },
    enqueueForceUpdate: function() {}
};
function $a6bdd6b0637ea6ad$var$rc(a, b, c, d) {
    var f = void 0 !== a.state ? a.state : null;
    a.updater = $a6bdd6b0637ea6ad$var$qc;
    a.props = c;
    a.state = f;
    var e = {
        queue: [],
        replace: !1
    };
    a._reactInternals = e;
    var g = b.contextType;
    a.context = "object" === typeof g && null !== g ? g._currentValue : d;
    g = b.getDerivedStateFromProps;
    "function" === typeof g && (g = g(c, f), f = null === g || void 0 === g ? f : $a6bdd6b0637ea6ad$var$N({}, f, g), a.state = f);
    if ("function" !== typeof b.getDerivedStateFromProps && "function" !== typeof a.getSnapshotBeforeUpdate && ("function" === typeof a.UNSAFE_componentWillMount || "function" === typeof a.componentWillMount)) {
        if (b = a.state, "function" === typeof a.componentWillMount && a.componentWillMount(), "function" === typeof a.UNSAFE_componentWillMount && a.UNSAFE_componentWillMount(), b !== a.state && $a6bdd6b0637ea6ad$var$qc.enqueueReplaceState(a, a.state, null), null !== e.queue && 0 < e.queue.length) {
            if (b = e.queue, g = e.replace, e.queue = null, e.replace = !1, g && 1 === b.length) a.state = b[0];
            else {
                e = g ? b[0] : a.state;
                f = !0;
                for(g = g ? 1 : 0; g < b.length; g++){
                    var h = b[g];
                    h = "function" === typeof h ? h.call(a, e, c, d) : h;
                    null != h && (f ? (f = !1, e = $a6bdd6b0637ea6ad$var$N({}, e, h)) : $a6bdd6b0637ea6ad$var$N(e, h));
                }
                a.state = e;
            }
        } else e.queue = null;
    }
}
var $a6bdd6b0637ea6ad$var$sc = {
    id: 1,
    overflow: ""
};
function $a6bdd6b0637ea6ad$var$tc(a, b, c) {
    var d = a.id;
    a = a.overflow;
    var f = 32 - $a6bdd6b0637ea6ad$var$uc(d) - 1;
    d &= ~(1 << f);
    c += 1;
    var e = 32 - $a6bdd6b0637ea6ad$var$uc(b) + f;
    if (30 < e) {
        var g = f - f % 5;
        e = (d & (1 << g) - 1).toString(32);
        d >>= g;
        f -= g;
        return {
            id: 1 << 32 - $a6bdd6b0637ea6ad$var$uc(b) + f | c << f | d,
            overflow: e + a
        };
    }
    return {
        id: 1 << e | c << f | d,
        overflow: a
    };
}
var $a6bdd6b0637ea6ad$var$uc = Math.clz32 ? Math.clz32 : $a6bdd6b0637ea6ad$var$vc, $a6bdd6b0637ea6ad$var$wc = Math.log, $a6bdd6b0637ea6ad$var$xc = Math.LN2;
function $a6bdd6b0637ea6ad$var$vc(a) {
    a >>>= 0;
    return 0 === a ? 32 : 31 - ($a6bdd6b0637ea6ad$var$wc(a) / $a6bdd6b0637ea6ad$var$xc | 0) | 0;
}
function $a6bdd6b0637ea6ad$var$yc(a, b) {
    return a === b && (0 !== a || 1 / a === 1 / b) || a !== a && b !== b;
}
var $a6bdd6b0637ea6ad$var$zc = "function" === typeof Object.is ? Object.is : $a6bdd6b0637ea6ad$var$yc, $a6bdd6b0637ea6ad$var$R = null, $a6bdd6b0637ea6ad$var$Ac = null, $a6bdd6b0637ea6ad$var$Bc = null, $a6bdd6b0637ea6ad$var$S = null, $a6bdd6b0637ea6ad$var$T = !1, $a6bdd6b0637ea6ad$var$Cc = !1, $a6bdd6b0637ea6ad$var$U = 0, $a6bdd6b0637ea6ad$var$V = null, $a6bdd6b0637ea6ad$var$Dc = 0;
function $a6bdd6b0637ea6ad$var$W() {
    if (null === $a6bdd6b0637ea6ad$var$R) throw Error($a6bdd6b0637ea6ad$var$k(321));
    return $a6bdd6b0637ea6ad$var$R;
}
function $a6bdd6b0637ea6ad$var$Ec() {
    if (0 < $a6bdd6b0637ea6ad$var$Dc) throw Error($a6bdd6b0637ea6ad$var$k(312));
    return {
        memoizedState: null,
        queue: null,
        next: null
    };
}
function $a6bdd6b0637ea6ad$var$Fc() {
    null === $a6bdd6b0637ea6ad$var$S ? null === $a6bdd6b0637ea6ad$var$Bc ? ($a6bdd6b0637ea6ad$var$T = !1, $a6bdd6b0637ea6ad$var$Bc = $a6bdd6b0637ea6ad$var$S = $a6bdd6b0637ea6ad$var$Ec()) : ($a6bdd6b0637ea6ad$var$T = !0, $a6bdd6b0637ea6ad$var$S = $a6bdd6b0637ea6ad$var$Bc) : null === $a6bdd6b0637ea6ad$var$S.next ? ($a6bdd6b0637ea6ad$var$T = !1, $a6bdd6b0637ea6ad$var$S = $a6bdd6b0637ea6ad$var$S.next = $a6bdd6b0637ea6ad$var$Ec()) : ($a6bdd6b0637ea6ad$var$T = !0, $a6bdd6b0637ea6ad$var$S = $a6bdd6b0637ea6ad$var$S.next);
    return $a6bdd6b0637ea6ad$var$S;
}
function $a6bdd6b0637ea6ad$var$Gc() {
    $a6bdd6b0637ea6ad$var$Ac = $a6bdd6b0637ea6ad$var$R = null;
    $a6bdd6b0637ea6ad$var$Cc = !1;
    $a6bdd6b0637ea6ad$var$Bc = null;
    $a6bdd6b0637ea6ad$var$Dc = 0;
    $a6bdd6b0637ea6ad$var$S = $a6bdd6b0637ea6ad$var$V = null;
}
function $a6bdd6b0637ea6ad$var$Hc(a, b) {
    return "function" === typeof b ? b(a) : b;
}
function $a6bdd6b0637ea6ad$var$Ic(a, b, c) {
    $a6bdd6b0637ea6ad$var$R = $a6bdd6b0637ea6ad$var$W();
    $a6bdd6b0637ea6ad$var$S = $a6bdd6b0637ea6ad$var$Fc();
    if ($a6bdd6b0637ea6ad$var$T) {
        var d = $a6bdd6b0637ea6ad$var$S.queue;
        b = d.dispatch;
        if (null !== $a6bdd6b0637ea6ad$var$V && (c = $a6bdd6b0637ea6ad$var$V.get(d), void 0 !== c)) {
            $a6bdd6b0637ea6ad$var$V.delete(d);
            d = $a6bdd6b0637ea6ad$var$S.memoizedState;
            do d = a(d, c.action), c = c.next;
            while (null !== c);
            $a6bdd6b0637ea6ad$var$S.memoizedState = d;
            return [
                d,
                b
            ];
        }
        return [
            $a6bdd6b0637ea6ad$var$S.memoizedState,
            b
        ];
    }
    a = a === $a6bdd6b0637ea6ad$var$Hc ? "function" === typeof b ? b() : b : void 0 !== c ? c(b) : b;
    $a6bdd6b0637ea6ad$var$S.memoizedState = a;
    a = $a6bdd6b0637ea6ad$var$S.queue = {
        last: null,
        dispatch: null
    };
    a = a.dispatch = $a6bdd6b0637ea6ad$var$Jc.bind(null, $a6bdd6b0637ea6ad$var$R, a);
    return [
        $a6bdd6b0637ea6ad$var$S.memoizedState,
        a
    ];
}
function $a6bdd6b0637ea6ad$var$Kc(a, b) {
    $a6bdd6b0637ea6ad$var$R = $a6bdd6b0637ea6ad$var$W();
    $a6bdd6b0637ea6ad$var$S = $a6bdd6b0637ea6ad$var$Fc();
    b = void 0 === b ? null : b;
    if (null !== $a6bdd6b0637ea6ad$var$S) {
        var c = $a6bdd6b0637ea6ad$var$S.memoizedState;
        if (null !== c && null !== b) {
            var d = c[1];
            a: if (null === d) d = !1;
            else {
                for(var f = 0; f < d.length && f < b.length; f++)if (!$a6bdd6b0637ea6ad$var$zc(b[f], d[f])) {
                    d = !1;
                    break a;
                }
                d = !0;
            }
            if (d) return c[0];
        }
    }
    a = a();
    $a6bdd6b0637ea6ad$var$S.memoizedState = [
        a,
        b
    ];
    return a;
}
function $a6bdd6b0637ea6ad$var$Jc(a, b, c) {
    if (25 <= $a6bdd6b0637ea6ad$var$Dc) throw Error($a6bdd6b0637ea6ad$var$k(301));
    if (a === $a6bdd6b0637ea6ad$var$R) {
        if ($a6bdd6b0637ea6ad$var$Cc = !0, a = {
            action: c,
            next: null
        }, null === $a6bdd6b0637ea6ad$var$V && ($a6bdd6b0637ea6ad$var$V = new Map), c = $a6bdd6b0637ea6ad$var$V.get(b), void 0 === c) $a6bdd6b0637ea6ad$var$V.set(b, a);
        else {
            for(b = c; null !== b.next;)b = b.next;
            b.next = a;
        }
    }
}
function $a6bdd6b0637ea6ad$var$Lc() {
    throw Error($a6bdd6b0637ea6ad$var$k(394));
}
function $a6bdd6b0637ea6ad$var$Mc() {}
var $a6bdd6b0637ea6ad$var$Oc = {
    readContext: function(a) {
        return a._currentValue;
    },
    useContext: function(a) {
        $a6bdd6b0637ea6ad$var$W();
        return a._currentValue;
    },
    useMemo: $a6bdd6b0637ea6ad$var$Kc,
    useReducer: $a6bdd6b0637ea6ad$var$Ic,
    useRef: function(a) {
        $a6bdd6b0637ea6ad$var$R = $a6bdd6b0637ea6ad$var$W();
        $a6bdd6b0637ea6ad$var$S = $a6bdd6b0637ea6ad$var$Fc();
        var b = $a6bdd6b0637ea6ad$var$S.memoizedState;
        return null === b ? (a = {
            current: a
        }, $a6bdd6b0637ea6ad$var$S.memoizedState = a) : b;
    },
    useState: function(a) {
        return $a6bdd6b0637ea6ad$var$Ic($a6bdd6b0637ea6ad$var$Hc, a);
    },
    useInsertionEffect: $a6bdd6b0637ea6ad$var$Mc,
    useLayoutEffect: function() {},
    useCallback: function(a, b) {
        return $a6bdd6b0637ea6ad$var$Kc(function() {
            return a;
        }, b);
    },
    useImperativeHandle: $a6bdd6b0637ea6ad$var$Mc,
    useEffect: $a6bdd6b0637ea6ad$var$Mc,
    useDebugValue: $a6bdd6b0637ea6ad$var$Mc,
    useDeferredValue: function(a) {
        $a6bdd6b0637ea6ad$var$W();
        return a;
    },
    useTransition: function() {
        $a6bdd6b0637ea6ad$var$W();
        return [
            !1,
            $a6bdd6b0637ea6ad$var$Lc
        ];
    },
    useId: function() {
        var a = $a6bdd6b0637ea6ad$var$Ac.treeContext;
        var b = a.overflow;
        a = a.id;
        a = (a & ~(1 << 32 - $a6bdd6b0637ea6ad$var$uc(a) - 1)).toString(32) + b;
        var c = $a6bdd6b0637ea6ad$var$Nc;
        if (null === c) throw Error($a6bdd6b0637ea6ad$var$k(404));
        b = $a6bdd6b0637ea6ad$var$U++;
        a = ":" + c.idPrefix + "R" + a;
        0 < b && (a += "H" + b.toString(32));
        return a + ":";
    },
    useMutableSource: function(a, b) {
        $a6bdd6b0637ea6ad$var$W();
        return b(a._source);
    },
    useSyncExternalStore: function(a, b, c) {
        if (void 0 === c) throw Error($a6bdd6b0637ea6ad$var$k(407));
        return c();
    }
}, $a6bdd6b0637ea6ad$var$Nc = null, $a6bdd6b0637ea6ad$var$Pc = $cWbtJ.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentDispatcher;
function $a6bdd6b0637ea6ad$var$Qc(a) {
    console.error(a);
    return null;
}
function $a6bdd6b0637ea6ad$var$X() {}
function $a6bdd6b0637ea6ad$var$Rc(a, b, c, d, f, e, g, h, m) {
    var q = [], r = new Set;
    b = {
        destination: null,
        responseState: b,
        progressiveChunkSize: void 0 === d ? 12800 : d,
        status: 0,
        fatalError: null,
        nextSegmentId: 0,
        allPendingTasks: 0,
        pendingRootTasks: 0,
        completedRootSegment: null,
        abortableTasks: r,
        pingedTasks: q,
        clientRenderedBoundaries: [],
        completedBoundaries: [],
        partialBoundaries: [],
        onError: void 0 === f ? $a6bdd6b0637ea6ad$var$Qc : f,
        onAllReady: void 0 === e ? $a6bdd6b0637ea6ad$var$X : e,
        onShellReady: void 0 === g ? $a6bdd6b0637ea6ad$var$X : g,
        onShellError: void 0 === h ? $a6bdd6b0637ea6ad$var$X : h,
        onFatalError: void 0 === m ? $a6bdd6b0637ea6ad$var$X : m
    };
    c = $a6bdd6b0637ea6ad$var$Sc(b, 0, null, c, !1, !1);
    c.parentFlushed = !0;
    a = $a6bdd6b0637ea6ad$var$Tc(b, a, null, c, r, $a6bdd6b0637ea6ad$var$kc, null, $a6bdd6b0637ea6ad$var$sc);
    q.push(a);
    return b;
}
function $a6bdd6b0637ea6ad$var$Tc(a, b, c, d, f, e, g, h) {
    a.allPendingTasks++;
    null === c ? a.pendingRootTasks++ : c.pendingTasks++;
    var m = {
        node: b,
        ping: function() {
            var b = a.pingedTasks;
            b.push(m);
            1 === b.length && $a6bdd6b0637ea6ad$var$Uc(a);
        },
        blockedBoundary: c,
        blockedSegment: d,
        abortSet: f,
        legacyContext: e,
        context: g,
        treeContext: h
    };
    f.add(m);
    return m;
}
function $a6bdd6b0637ea6ad$var$Sc(a, b, c, d, f, e) {
    return {
        status: 0,
        id: -1,
        index: b,
        parentFlushed: !1,
        chunks: [],
        children: [],
        formatContext: d,
        boundary: c,
        lastPushedText: f,
        textEmbedded: e
    };
}
function $a6bdd6b0637ea6ad$var$Y(a, b) {
    a = a.onError(b);
    if (null != a && "string" !== typeof a) throw Error('onError returned something with a type other than "string". onError should return a string and may return null or undefined but must not return anything else. It received something of type "' + typeof a + '" instead');
    return a;
}
function $a6bdd6b0637ea6ad$var$Vc(a, b) {
    var c = a.onShellError;
    c(b);
    c = a.onFatalError;
    c(b);
    null !== a.destination ? (a.status = 2, $a6bdd6b0637ea6ad$var$da(a.destination, b)) : (a.status = 1, a.fatalError = b);
}
function $a6bdd6b0637ea6ad$var$Wc(a, b, c, d, f) {
    $a6bdd6b0637ea6ad$var$R = {};
    $a6bdd6b0637ea6ad$var$Ac = b;
    $a6bdd6b0637ea6ad$var$U = 0;
    for(a = c(d, f); $a6bdd6b0637ea6ad$var$Cc;)$a6bdd6b0637ea6ad$var$Cc = !1, $a6bdd6b0637ea6ad$var$U = 0, $a6bdd6b0637ea6ad$var$Dc += 1, $a6bdd6b0637ea6ad$var$S = null, a = c(d, f);
    $a6bdd6b0637ea6ad$var$Gc();
    return a;
}
function $a6bdd6b0637ea6ad$var$Xc(a, b, c, d) {
    var f = c.render(), e = d.childContextTypes;
    if (null !== e && void 0 !== e) {
        var g = b.legacyContext;
        if ("function" !== typeof c.getChildContext) d = g;
        else {
            c = c.getChildContext();
            for(var h in c)if (!(h in e)) throw Error($a6bdd6b0637ea6ad$var$k(108, $a6bdd6b0637ea6ad$var$jc(d) || "Unknown", h));
            d = $a6bdd6b0637ea6ad$var$N({}, g, c);
        }
        b.legacyContext = d;
        $a6bdd6b0637ea6ad$var$Z(a, b, f);
        b.legacyContext = g;
    } else $a6bdd6b0637ea6ad$var$Z(a, b, f);
}
function $a6bdd6b0637ea6ad$var$Yc(a, b) {
    if (a && a.defaultProps) {
        b = $a6bdd6b0637ea6ad$var$N({}, b);
        a = a.defaultProps;
        for(var c in a)void 0 === b[c] && (b[c] = a[c]);
        return b;
    }
    return b;
}
function $a6bdd6b0637ea6ad$var$Zc(a, b, c, d, f) {
    if ("function" === typeof c) {
        if (c.prototype && c.prototype.isReactComponent) {
            f = $a6bdd6b0637ea6ad$var$lc(c, b.legacyContext);
            var e = c.contextType;
            e = new c(d, "object" === typeof e && null !== e ? e._currentValue : f);
            $a6bdd6b0637ea6ad$var$rc(e, c, d, f);
            $a6bdd6b0637ea6ad$var$Xc(a, b, e, c);
        } else {
            e = $a6bdd6b0637ea6ad$var$lc(c, b.legacyContext);
            f = $a6bdd6b0637ea6ad$var$Wc(a, b, c, d, e);
            var g = 0 !== $a6bdd6b0637ea6ad$var$U;
            if ("object" === typeof f && null !== f && "function" === typeof f.render && void 0 === f.$$typeof) $a6bdd6b0637ea6ad$var$rc(f, c, d, e), $a6bdd6b0637ea6ad$var$Xc(a, b, f, c);
            else if (g) {
                d = b.treeContext;
                b.treeContext = $a6bdd6b0637ea6ad$var$tc(d, 1, 0);
                try {
                    $a6bdd6b0637ea6ad$var$Z(a, b, f);
                } finally{
                    b.treeContext = d;
                }
            } else $a6bdd6b0637ea6ad$var$Z(a, b, f);
        }
    } else if ("string" === typeof c) {
        f = b.blockedSegment;
        e = $a6bdd6b0637ea6ad$var$Sa(f.chunks, c, d, a.responseState, f.formatContext);
        f.lastPushedText = !1;
        g = f.formatContext;
        f.formatContext = $a6bdd6b0637ea6ad$var$Ba(g, c, d);
        $a6bdd6b0637ea6ad$var$$c(a, b, e);
        f.formatContext = g;
        switch(c){
            case "area":
            case "base":
            case "br":
            case "col":
            case "embed":
            case "hr":
            case "img":
            case "input":
            case "keygen":
            case "link":
            case "meta":
            case "param":
            case "source":
            case "track":
            case "wbr":
                break;
            default:
                f.chunks.push($a6bdd6b0637ea6ad$var$Ta, $a6bdd6b0637ea6ad$var$u(c), $a6bdd6b0637ea6ad$var$Ua);
        }
        f.lastPushedText = !1;
    } else {
        switch(c){
            case $a6bdd6b0637ea6ad$var$gc:
            case $a6bdd6b0637ea6ad$var$fc:
            case $a6bdd6b0637ea6ad$var$Wb:
            case $a6bdd6b0637ea6ad$var$Xb:
            case $a6bdd6b0637ea6ad$var$Vb:
                $a6bdd6b0637ea6ad$var$Z(a, b, d.children);
                return;
            case $a6bdd6b0637ea6ad$var$bc:
                $a6bdd6b0637ea6ad$var$Z(a, b, d.children);
                return;
            case $a6bdd6b0637ea6ad$var$ec:
                throw Error($a6bdd6b0637ea6ad$var$k(343));
            case $a6bdd6b0637ea6ad$var$ac:
                a: {
                    c = b.blockedBoundary;
                    f = b.blockedSegment;
                    e = d.fallback;
                    d = d.children;
                    g = new Set;
                    var h = {
                        id: null,
                        rootSegmentID: -1,
                        parentFlushed: !1,
                        pendingTasks: 0,
                        forceClientRender: !1,
                        completedSegments: [],
                        byteSize: 0,
                        fallbackAbortableTasks: g,
                        errorDigest: null
                    }, m = $a6bdd6b0637ea6ad$var$Sc(a, f.chunks.length, h, f.formatContext, !1, !1);
                    f.children.push(m);
                    f.lastPushedText = !1;
                    var q = $a6bdd6b0637ea6ad$var$Sc(a, 0, null, f.formatContext, !1, !1);
                    q.parentFlushed = !0;
                    b.blockedBoundary = h;
                    b.blockedSegment = q;
                    try {
                        if ($a6bdd6b0637ea6ad$var$$c(a, b, d), q.lastPushedText && q.textEmbedded && q.chunks.push($a6bdd6b0637ea6ad$var$Ca), q.status = 1, $a6bdd6b0637ea6ad$var$ad(h, q), 0 === h.pendingTasks) break a;
                    } catch (r) {
                        q.status = 4, h.forceClientRender = !0, h.errorDigest = $a6bdd6b0637ea6ad$var$Y(a, r);
                    } finally{
                        b.blockedBoundary = c, b.blockedSegment = f;
                    }
                    b = $a6bdd6b0637ea6ad$var$Tc(a, e, c, m, g, b.legacyContext, b.context, b.treeContext);
                    a.pingedTasks.push(b);
                }
                return;
        }
        if ("object" === typeof c && null !== c) switch(c.$$typeof){
            case $a6bdd6b0637ea6ad$var$$b:
                d = $a6bdd6b0637ea6ad$var$Wc(a, b, c.render, d, f);
                if (0 !== $a6bdd6b0637ea6ad$var$U) {
                    c = b.treeContext;
                    b.treeContext = $a6bdd6b0637ea6ad$var$tc(c, 1, 0);
                    try {
                        $a6bdd6b0637ea6ad$var$Z(a, b, d);
                    } finally{
                        b.treeContext = c;
                    }
                } else $a6bdd6b0637ea6ad$var$Z(a, b, d);
                return;
            case $a6bdd6b0637ea6ad$var$cc:
                c = c.type;
                d = $a6bdd6b0637ea6ad$var$Yc(c, d);
                $a6bdd6b0637ea6ad$var$Zc(a, b, c, d, f);
                return;
            case $a6bdd6b0637ea6ad$var$Yb:
                f = d.children;
                c = c._context;
                d = d.value;
                e = c._currentValue;
                c._currentValue = d;
                g = $a6bdd6b0637ea6ad$var$O;
                $a6bdd6b0637ea6ad$var$O = d = {
                    parent: g,
                    depth: null === g ? 0 : g.depth + 1,
                    context: c,
                    parentValue: e,
                    value: d
                };
                b.context = d;
                $a6bdd6b0637ea6ad$var$Z(a, b, f);
                a = $a6bdd6b0637ea6ad$var$O;
                if (null === a) throw Error($a6bdd6b0637ea6ad$var$k(403));
                d = a.parentValue;
                a.context._currentValue = d === $a6bdd6b0637ea6ad$var$hc ? a.context._defaultValue : d;
                a = $a6bdd6b0637ea6ad$var$O = a.parent;
                b.context = a;
                return;
            case $a6bdd6b0637ea6ad$var$Zb:
                d = d.children;
                d = d(c._currentValue);
                $a6bdd6b0637ea6ad$var$Z(a, b, d);
                return;
            case $a6bdd6b0637ea6ad$var$dc:
                f = c._init;
                c = f(c._payload);
                d = $a6bdd6b0637ea6ad$var$Yc(c, d);
                $a6bdd6b0637ea6ad$var$Zc(a, b, c, d, void 0);
                return;
        }
        throw Error($a6bdd6b0637ea6ad$var$k(130, null == c ? c : typeof c, ""));
    }
}
function $a6bdd6b0637ea6ad$var$Z(a, b, c) {
    b.node = c;
    if ("object" === typeof c && null !== c) {
        switch(c.$$typeof){
            case $a6bdd6b0637ea6ad$var$Tb:
                $a6bdd6b0637ea6ad$var$Zc(a, b, c.type, c.props, c.ref);
                return;
            case $a6bdd6b0637ea6ad$var$Ub:
                throw Error($a6bdd6b0637ea6ad$var$k(257));
            case $a6bdd6b0637ea6ad$var$dc:
                var d = c._init;
                c = d(c._payload);
                $a6bdd6b0637ea6ad$var$Z(a, b, c);
                return;
        }
        if ($a6bdd6b0637ea6ad$var$ra(c)) {
            $a6bdd6b0637ea6ad$var$bd(a, b, c);
            return;
        }
        null === c || "object" !== typeof c ? d = null : (d = $a6bdd6b0637ea6ad$var$ic && c[$a6bdd6b0637ea6ad$var$ic] || c["@@iterator"], d = "function" === typeof d ? d : null);
        if (d && (d = d.call(c))) {
            c = d.next();
            if (!c.done) {
                var f = [];
                do f.push(c.value), c = d.next();
                while (!c.done);
                $a6bdd6b0637ea6ad$var$bd(a, b, f);
            }
            return;
        }
        a = Object.prototype.toString.call(c);
        throw Error($a6bdd6b0637ea6ad$var$k(31, "[object Object]" === a ? "object with keys {" + Object.keys(c).join(", ") + "}" : a));
    }
    "string" === typeof c ? (d = b.blockedSegment, d.lastPushedText = $a6bdd6b0637ea6ad$var$Da(b.blockedSegment.chunks, c, a.responseState, d.lastPushedText)) : "number" === typeof c && (d = b.blockedSegment, d.lastPushedText = $a6bdd6b0637ea6ad$var$Da(b.blockedSegment.chunks, "" + c, a.responseState, d.lastPushedText));
}
function $a6bdd6b0637ea6ad$var$bd(a, b, c) {
    for(var d = c.length, f = 0; f < d; f++){
        var e = b.treeContext;
        b.treeContext = $a6bdd6b0637ea6ad$var$tc(e, d, f);
        try {
            $a6bdd6b0637ea6ad$var$$c(a, b, c[f]);
        } finally{
            b.treeContext = e;
        }
    }
}
function $a6bdd6b0637ea6ad$var$$c(a, b, c) {
    var d = b.blockedSegment.formatContext, f = b.legacyContext, e = b.context;
    try {
        return $a6bdd6b0637ea6ad$var$Z(a, b, c);
    } catch (m) {
        if ($a6bdd6b0637ea6ad$var$Gc(), "object" === typeof m && null !== m && "function" === typeof m.then) {
            c = m;
            var g = b.blockedSegment, h = $a6bdd6b0637ea6ad$var$Sc(a, g.chunks.length, null, g.formatContext, g.lastPushedText, !0);
            g.children.push(h);
            g.lastPushedText = !1;
            a = $a6bdd6b0637ea6ad$var$Tc(a, b.node, b.blockedBoundary, h, b.abortSet, b.legacyContext, b.context, b.treeContext).ping;
            c.then(a, a);
            b.blockedSegment.formatContext = d;
            b.legacyContext = f;
            b.context = e;
            $a6bdd6b0637ea6ad$var$Q(e);
        } else throw b.blockedSegment.formatContext = d, b.legacyContext = f, b.context = e, $a6bdd6b0637ea6ad$var$Q(e), m;
    }
}
function $a6bdd6b0637ea6ad$var$cd(a) {
    var b = a.blockedBoundary;
    a = a.blockedSegment;
    a.status = 3;
    $a6bdd6b0637ea6ad$var$dd(this, b, a);
}
function $a6bdd6b0637ea6ad$var$ed(a, b, c) {
    var d = a.blockedBoundary;
    a.blockedSegment.status = 3;
    null === d ? (b.allPendingTasks--, 2 !== b.status && (b.status = 2, null !== b.destination && b.destination.close())) : (d.pendingTasks--, d.forceClientRender || (d.forceClientRender = !0, a = void 0 === c ? Error($a6bdd6b0637ea6ad$var$k(432)) : c, d.errorDigest = b.onError(a), d.parentFlushed && b.clientRenderedBoundaries.push(d)), d.fallbackAbortableTasks.forEach(function(a) {
        return $a6bdd6b0637ea6ad$var$ed(a, b, c);
    }), d.fallbackAbortableTasks.clear(), b.allPendingTasks--, 0 === b.allPendingTasks && (d = b.onAllReady, d()));
}
function $a6bdd6b0637ea6ad$var$ad(a, b) {
    if (0 === b.chunks.length && 1 === b.children.length && null === b.children[0].boundary) {
        var c = b.children[0];
        c.id = b.id;
        c.parentFlushed = !0;
        1 === c.status && $a6bdd6b0637ea6ad$var$ad(a, c);
    } else a.completedSegments.push(b);
}
function $a6bdd6b0637ea6ad$var$dd(a, b, c) {
    if (null === b) {
        if (c.parentFlushed) {
            if (null !== a.completedRootSegment) throw Error($a6bdd6b0637ea6ad$var$k(389));
            a.completedRootSegment = c;
        }
        a.pendingRootTasks--;
        0 === a.pendingRootTasks && (a.onShellError = $a6bdd6b0637ea6ad$var$X, b = a.onShellReady, b());
    } else b.pendingTasks--, b.forceClientRender || (0 === b.pendingTasks ? (c.parentFlushed && 1 === c.status && $a6bdd6b0637ea6ad$var$ad(b, c), b.parentFlushed && a.completedBoundaries.push(b), b.fallbackAbortableTasks.forEach($a6bdd6b0637ea6ad$var$cd, a), b.fallbackAbortableTasks.clear()) : c.parentFlushed && 1 === c.status && ($a6bdd6b0637ea6ad$var$ad(b, c), 1 === b.completedSegments.length && b.parentFlushed && a.partialBoundaries.push(b)));
    a.allPendingTasks--;
    0 === a.allPendingTasks && (a = a.onAllReady, a());
}
function $a6bdd6b0637ea6ad$var$Uc(a) {
    if (2 !== a.status) {
        var b = $a6bdd6b0637ea6ad$var$O, c = $a6bdd6b0637ea6ad$var$Pc.current;
        $a6bdd6b0637ea6ad$var$Pc.current = $a6bdd6b0637ea6ad$var$Oc;
        var d = $a6bdd6b0637ea6ad$var$Nc;
        $a6bdd6b0637ea6ad$var$Nc = a.responseState;
        try {
            var f = a.pingedTasks, e;
            for(e = 0; e < f.length; e++){
                var g = f[e];
                var h = a, m = g.blockedSegment;
                if (0 === m.status) {
                    $a6bdd6b0637ea6ad$var$Q(g.context);
                    try {
                        $a6bdd6b0637ea6ad$var$Z(h, g, g.node), m.lastPushedText && m.textEmbedded && m.chunks.push($a6bdd6b0637ea6ad$var$Ca), g.abortSet.delete(g), m.status = 1, $a6bdd6b0637ea6ad$var$dd(h, g.blockedBoundary, m);
                    } catch (G) {
                        if ($a6bdd6b0637ea6ad$var$Gc(), "object" === typeof G && null !== G && "function" === typeof G.then) {
                            var q = g.ping;
                            G.then(q, q);
                        } else {
                            g.abortSet.delete(g);
                            m.status = 4;
                            var r = g.blockedBoundary, v = G, A = $a6bdd6b0637ea6ad$var$Y(h, v);
                            null === r ? $a6bdd6b0637ea6ad$var$Vc(h, v) : (r.pendingTasks--, r.forceClientRender || (r.forceClientRender = !0, r.errorDigest = A, r.parentFlushed && h.clientRenderedBoundaries.push(r)));
                            h.allPendingTasks--;
                            if (0 === h.allPendingTasks) {
                                var F = h.onAllReady;
                                F();
                            }
                        }
                    } finally{}
                }
            }
            f.splice(0, e);
            null !== a.destination && $a6bdd6b0637ea6ad$var$fd(a, a.destination);
        } catch (G) {
            $a6bdd6b0637ea6ad$var$Y(a, G), $a6bdd6b0637ea6ad$var$Vc(a, G);
        } finally{
            $a6bdd6b0637ea6ad$var$Nc = d, $a6bdd6b0637ea6ad$var$Pc.current = c, c === $a6bdd6b0637ea6ad$var$Oc && $a6bdd6b0637ea6ad$var$Q(b);
        }
    }
}
function $a6bdd6b0637ea6ad$var$gd(a, b, c) {
    c.parentFlushed = !0;
    switch(c.status){
        case 0:
            var d = c.id = a.nextSegmentId++;
            c.lastPushedText = !1;
            c.textEmbedded = !1;
            a = a.responseState;
            $a6bdd6b0637ea6ad$var$p(b, $a6bdd6b0637ea6ad$var$Va);
            $a6bdd6b0637ea6ad$var$p(b, a.placeholderPrefix);
            a = $a6bdd6b0637ea6ad$var$u(d.toString(16));
            $a6bdd6b0637ea6ad$var$p(b, a);
            return $a6bdd6b0637ea6ad$var$t(b, $a6bdd6b0637ea6ad$var$Wa);
        case 1:
            c.status = 2;
            var f = !0;
            d = c.chunks;
            var e = 0;
            c = c.children;
            for(var g = 0; g < c.length; g++){
                for(f = c[g]; e < f.index; e++)$a6bdd6b0637ea6ad$var$p(b, d[e]);
                f = $a6bdd6b0637ea6ad$var$hd(a, b, f);
            }
            for(; e < d.length - 1; e++)$a6bdd6b0637ea6ad$var$p(b, d[e]);
            e < d.length && (f = $a6bdd6b0637ea6ad$var$t(b, d[e]));
            return f;
        default:
            throw Error($a6bdd6b0637ea6ad$var$k(390));
    }
}
function $a6bdd6b0637ea6ad$var$hd(a, b, c) {
    var d = c.boundary;
    if (null === d) return $a6bdd6b0637ea6ad$var$gd(a, b, c);
    d.parentFlushed = !0;
    if (d.forceClientRender) d = d.errorDigest, $a6bdd6b0637ea6ad$var$t(b, $a6bdd6b0637ea6ad$var$$a), $a6bdd6b0637ea6ad$var$p(b, $a6bdd6b0637ea6ad$var$bb), d && ($a6bdd6b0637ea6ad$var$p(b, $a6bdd6b0637ea6ad$var$db), $a6bdd6b0637ea6ad$var$p(b, $a6bdd6b0637ea6ad$var$u($a6bdd6b0637ea6ad$var$C(d))), $a6bdd6b0637ea6ad$var$p(b, $a6bdd6b0637ea6ad$var$cb)), $a6bdd6b0637ea6ad$var$t(b, $a6bdd6b0637ea6ad$var$eb), $a6bdd6b0637ea6ad$var$gd(a, b, c);
    else if (0 < d.pendingTasks) {
        d.rootSegmentID = a.nextSegmentId++;
        0 < d.completedSegments.length && a.partialBoundaries.push(d);
        var f = a.responseState;
        var e = f.nextSuspenseID++;
        f = $a6bdd6b0637ea6ad$var$w(f.boundaryPrefix + e.toString(16));
        d = d.id = f;
        $a6bdd6b0637ea6ad$var$fb(b, a.responseState, d);
        $a6bdd6b0637ea6ad$var$gd(a, b, c);
    } else if (d.byteSize > a.progressiveChunkSize) d.rootSegmentID = a.nextSegmentId++, a.completedBoundaries.push(d), $a6bdd6b0637ea6ad$var$fb(b, a.responseState, d.id), $a6bdd6b0637ea6ad$var$gd(a, b, c);
    else {
        $a6bdd6b0637ea6ad$var$t(b, $a6bdd6b0637ea6ad$var$Xa);
        c = d.completedSegments;
        if (1 !== c.length) throw Error($a6bdd6b0637ea6ad$var$k(391));
        $a6bdd6b0637ea6ad$var$hd(a, b, c[0]);
    }
    return $a6bdd6b0637ea6ad$var$t(b, $a6bdd6b0637ea6ad$var$ab);
}
function $a6bdd6b0637ea6ad$var$id(a, b, c) {
    $a6bdd6b0637ea6ad$var$Bb(b, a.responseState, c.formatContext, c.id);
    $a6bdd6b0637ea6ad$var$hd(a, b, c);
    return $a6bdd6b0637ea6ad$var$Cb(b, c.formatContext);
}
function $a6bdd6b0637ea6ad$var$jd(a, b, c) {
    for(var d = c.completedSegments, f = 0; f < d.length; f++)$a6bdd6b0637ea6ad$var$kd(a, b, c, d[f]);
    d.length = 0;
    a = a.responseState;
    d = c.id;
    c = c.rootSegmentID;
    $a6bdd6b0637ea6ad$var$p(b, a.startInlineScript);
    a.sentCompleteBoundaryFunction ? $a6bdd6b0637ea6ad$var$p(b, $a6bdd6b0637ea6ad$var$Jb) : (a.sentCompleteBoundaryFunction = !0, $a6bdd6b0637ea6ad$var$p(b, $a6bdd6b0637ea6ad$var$Ib));
    if (null === d) throw Error($a6bdd6b0637ea6ad$var$k(395));
    c = $a6bdd6b0637ea6ad$var$u(c.toString(16));
    $a6bdd6b0637ea6ad$var$p(b, d);
    $a6bdd6b0637ea6ad$var$p(b, $a6bdd6b0637ea6ad$var$Kb);
    $a6bdd6b0637ea6ad$var$p(b, a.segmentPrefix);
    $a6bdd6b0637ea6ad$var$p(b, c);
    return $a6bdd6b0637ea6ad$var$t(b, $a6bdd6b0637ea6ad$var$Lb);
}
function $a6bdd6b0637ea6ad$var$kd(a, b, c, d) {
    if (2 === d.status) return !0;
    var f = d.id;
    if (-1 === f) {
        if (-1 === (d.id = c.rootSegmentID)) throw Error($a6bdd6b0637ea6ad$var$k(392));
        return $a6bdd6b0637ea6ad$var$id(a, b, d);
    }
    $a6bdd6b0637ea6ad$var$id(a, b, d);
    a = a.responseState;
    $a6bdd6b0637ea6ad$var$p(b, a.startInlineScript);
    a.sentCompleteSegmentFunction ? $a6bdd6b0637ea6ad$var$p(b, $a6bdd6b0637ea6ad$var$Eb) : (a.sentCompleteSegmentFunction = !0, $a6bdd6b0637ea6ad$var$p(b, $a6bdd6b0637ea6ad$var$Db));
    $a6bdd6b0637ea6ad$var$p(b, a.segmentPrefix);
    f = $a6bdd6b0637ea6ad$var$u(f.toString(16));
    $a6bdd6b0637ea6ad$var$p(b, f);
    $a6bdd6b0637ea6ad$var$p(b, $a6bdd6b0637ea6ad$var$Gb);
    $a6bdd6b0637ea6ad$var$p(b, a.placeholderPrefix);
    $a6bdd6b0637ea6ad$var$p(b, f);
    return $a6bdd6b0637ea6ad$var$t(b, $a6bdd6b0637ea6ad$var$Hb);
}
function $a6bdd6b0637ea6ad$var$fd(a, b) {
    $a6bdd6b0637ea6ad$var$l = new Uint8Array(512);
    $a6bdd6b0637ea6ad$var$n = 0;
    try {
        var c = a.completedRootSegment;
        if (null !== c && 0 === a.pendingRootTasks) {
            $a6bdd6b0637ea6ad$var$hd(a, b, c);
            a.completedRootSegment = null;
            var d = a.responseState.bootstrapChunks;
            for(c = 0; c < d.length - 1; c++)$a6bdd6b0637ea6ad$var$p(b, d[c]);
            c < d.length && $a6bdd6b0637ea6ad$var$t(b, d[c]);
        }
        var f = a.clientRenderedBoundaries, e;
        for(e = 0; e < f.length; e++){
            var g = f[e];
            d = b;
            var h = a.responseState, m = g.id, q = g.errorDigest, r = g.errorMessage, v = g.errorComponentStack;
            $a6bdd6b0637ea6ad$var$p(d, h.startInlineScript);
            h.sentClientRenderFunction ? $a6bdd6b0637ea6ad$var$p(d, $a6bdd6b0637ea6ad$var$Nb) : (h.sentClientRenderFunction = !0, $a6bdd6b0637ea6ad$var$p(d, $a6bdd6b0637ea6ad$var$Mb));
            if (null === m) throw Error($a6bdd6b0637ea6ad$var$k(395));
            $a6bdd6b0637ea6ad$var$p(d, m);
            $a6bdd6b0637ea6ad$var$p(d, $a6bdd6b0637ea6ad$var$Ob);
            if (q || r || v) $a6bdd6b0637ea6ad$var$p(d, $a6bdd6b0637ea6ad$var$Qb), $a6bdd6b0637ea6ad$var$p(d, $a6bdd6b0637ea6ad$var$u($a6bdd6b0637ea6ad$var$Sb(q || "")));
            if (r || v) $a6bdd6b0637ea6ad$var$p(d, $a6bdd6b0637ea6ad$var$Qb), $a6bdd6b0637ea6ad$var$p(d, $a6bdd6b0637ea6ad$var$u($a6bdd6b0637ea6ad$var$Sb(r || "")));
            v && ($a6bdd6b0637ea6ad$var$p(d, $a6bdd6b0637ea6ad$var$Qb), $a6bdd6b0637ea6ad$var$p(d, $a6bdd6b0637ea6ad$var$u($a6bdd6b0637ea6ad$var$Sb(v))));
            if (!$a6bdd6b0637ea6ad$var$t(d, $a6bdd6b0637ea6ad$var$Pb)) {
                a.destination = null;
                e++;
                f.splice(0, e);
                return;
            }
        }
        f.splice(0, e);
        var A = a.completedBoundaries;
        for(e = 0; e < A.length; e++)if (!$a6bdd6b0637ea6ad$var$jd(a, b, A[e])) {
            a.destination = null;
            e++;
            A.splice(0, e);
            return;
        }
        A.splice(0, e);
        $a6bdd6b0637ea6ad$var$ba(b);
        $a6bdd6b0637ea6ad$var$l = new Uint8Array(512);
        $a6bdd6b0637ea6ad$var$n = 0;
        var F = a.partialBoundaries;
        for(e = 0; e < F.length; e++){
            var G = F[e];
            a: {
                f = a;
                g = b;
                var ma = G.completedSegments;
                for(h = 0; h < ma.length; h++)if (!$a6bdd6b0637ea6ad$var$kd(f, g, G, ma[h])) {
                    h++;
                    ma.splice(0, h);
                    var Fb = !1;
                    break a;
                }
                ma.splice(0, h);
                Fb = !0;
            }
            if (!Fb) {
                a.destination = null;
                e++;
                F.splice(0, e);
                return;
            }
        }
        F.splice(0, e);
        var na = a.completedBoundaries;
        for(e = 0; e < na.length; e++)if (!$a6bdd6b0637ea6ad$var$jd(a, b, na[e])) {
            a.destination = null;
            e++;
            na.splice(0, e);
            return;
        }
        na.splice(0, e);
    } finally{
        $a6bdd6b0637ea6ad$var$ba(b), 0 === a.allPendingTasks && 0 === a.pingedTasks.length && 0 === a.clientRenderedBoundaries.length && 0 === a.completedBoundaries.length && b.close();
    }
}
function $a6bdd6b0637ea6ad$var$ld(a, b) {
    try {
        var c = a.abortableTasks;
        c.forEach(function(c) {
            return $a6bdd6b0637ea6ad$var$ed(c, a, b);
        });
        c.clear();
        null !== a.destination && $a6bdd6b0637ea6ad$var$fd(a, a.destination);
    } catch (d) {
        $a6bdd6b0637ea6ad$var$Y(a, d), $a6bdd6b0637ea6ad$var$Vc(a, d);
    }
}
$a6bdd6b0637ea6ad$export$7020a3240b287705 = function(a, b) {
    return new Promise(function(c, d) {
        var f, e, g = new Promise(function(a, b) {
            e = a;
            f = b;
        }), h = $a6bdd6b0637ea6ad$var$Rc(a, $a6bdd6b0637ea6ad$var$za(b ? b.identifierPrefix : void 0, b ? b.nonce : void 0, b ? b.bootstrapScriptContent : void 0, b ? b.bootstrapScripts : void 0, b ? b.bootstrapModules : void 0), $a6bdd6b0637ea6ad$var$Aa(b ? b.namespaceURI : void 0), b ? b.progressiveChunkSize : void 0, b ? b.onError : void 0, e, function() {
            var a = new ReadableStream({
                type: "bytes",
                pull: function(a) {
                    if (1 === h.status) h.status = 2, $a6bdd6b0637ea6ad$var$da(a, h.fatalError);
                    else if (2 !== h.status && null === h.destination) {
                        h.destination = a;
                        try {
                            $a6bdd6b0637ea6ad$var$fd(h, a);
                        } catch (A) {
                            $a6bdd6b0637ea6ad$var$Y(h, A), $a6bdd6b0637ea6ad$var$Vc(h, A);
                        }
                    }
                },
                cancel: function() {
                    $a6bdd6b0637ea6ad$var$ld(h);
                }
            }, {
                highWaterMark: 0
            });
            a.allReady = g;
            c(a);
        }, function(a) {
            g.catch(function() {});
            d(a);
        }, f);
        if (b && b.signal) {
            var m = b.signal, q = function() {
                $a6bdd6b0637ea6ad$var$ld(h, m.reason);
                m.removeEventListener("abort", q);
            };
            m.addEventListener("abort", q);
        }
        $a6bdd6b0637ea6ad$var$Uc(h);
    });
};
$a6bdd6b0637ea6ad$export$83d89fbfd8236492 = "18.3.1";

});

parcelRegister("loUMh", function(module, exports) {
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ "use strict";

var $gpYli = parcelRequire("gpYli");
function $f947e1c0007a1291$var$emptyFunction() {}
function $f947e1c0007a1291$var$emptyFunctionWithReset() {}
$f947e1c0007a1291$var$emptyFunctionWithReset.resetWarningCache = $f947e1c0007a1291$var$emptyFunction;
module.exports = function() {
    function shim(props, propName, componentName, location, propFullName, secret) {
        if (secret === $gpYli) // It is still safe when called from React.
        return;
        var err = new Error("Calling PropTypes validators directly is not supported by the `prop-types` package. Use PropTypes.checkPropTypes() to call them. Read more at http://fb.me/use-check-prop-types");
        err.name = "Invariant Violation";
        throw err;
    }
    shim.isRequired = shim;
    function getShim() {
        return shim;
    }
    // Important!
    // Keep this list in sync with production version in `./factoryWithTypeCheckers.js`.
    var ReactPropTypes = {
        array: shim,
        bigint: shim,
        bool: shim,
        func: shim,
        number: shim,
        object: shim,
        string: shim,
        symbol: shim,
        any: shim,
        arrayOf: getShim,
        element: shim,
        elementType: shim,
        instanceOf: getShim,
        node: shim,
        objectOf: getShim,
        oneOf: getShim,
        oneOfType: getShim,
        shape: getShim,
        exact: getShim,
        checkPropTypes: $f947e1c0007a1291$var$emptyFunctionWithReset,
        resetWarningCache: $f947e1c0007a1291$var$emptyFunction
    };
    ReactPropTypes.PropTypes = ReactPropTypes;
    return ReactPropTypes;
};

});
parcelRegister("gpYli", function(module, exports) {
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ "use strict";
var $bf3dc9e1acc43d11$var$ReactPropTypesSecret = "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED";
module.exports = $bf3dc9e1acc43d11$var$ReactPropTypesSecret;

});


parcelRegister("7gnIM", function(module, exports) {

$parcel$export(module.exports, "makeRender", () => makeRender);

var $1boHW = parcelRequire("1boHW");

var $60bvA = parcelRequire("60bvA");
const addPageId = (page, id)=>page.classList.add(`__profiler-page--${id}`);
const getPageId = (page)=>[
        ...page.classList.values()
    ].reduce((acc, cl)=>Number(cl.replace("__profiler-page--", "")) || acc, -1);
const newPage = (clone, cloneId)=>{
    const next = clone.cloneNode();
    next.classList.remove(`__profiler-page--${cloneId}`);
    addPageId(next, cloneId + 1);
    return next;
};
const isHeaderOrFooter = (el)=>[
        ...el.classList
    ].some((c)=>c === "PROFILER--PAGE-HEADER" || c === "PROFILER--PAGE-FOOTER");
const isPageBreak = (el)=>[
        ...el.classList
    ].includes("PROFILER--PAGE-BREAK");
const makeRender = (resolveAssetUrl)=>{
    let firstPageHeader;
    let pageHeader;
    let pageFooter;
    const handleCSSAssets = (t)=>t ? t.replace(/(?<=url\(\")(?!http).+(?=\")/g, resolveAssetUrl) : "";
    const handleHTMLAssets = (t)=>t ? t.replace(/(?<=\")\.?\/?assets.+?(?=(\\\"))/g, resolveAssetUrl) : "";
    const createStyleTag = (id, styles)=>{
        if (!styles) return undefined;
        const el = document.createElement("style");
        el.id = id;
        el.innerHTML = handleCSSAssets(styles);
        return el;
    };
    // prevent content from overlapping page, rather moving the content to the next (new) page
    const distributeContent = (o)=>{
        const pages = o.root.querySelectorAll(".__profiler-page");
        let rerun = false;
        pages.forEach((el, ix)=>{
            el.style.paddingTop = `${ix ? o.pagePaddingTop : o.firstPagePaddingTop}px`;
            const { height: pageHeight, top } = el.getBoundingClientRect();
            const { paddingBottom: pb, paddingTop: pt } = getComputedStyle(el);
            const paddingBottom = parseFloat(pb);
            const paddingTop = parseFloat(pt);
            const bottom = pageHeight + top - paddingBottom;
            const availableSpace = pageHeight - paddingTop - paddingBottom;
            const id = ix + 1;
            addPageId(el, id);
            [
                ...el.children
            ].reverse().forEach((child)=>{
                // don't measure and distribute content based on page footer
                if (isHeaderOrFooter(child)) return;
                const { top, height } = child.getBoundingClientRect();
                const childBottom = height + top;
                if (bottom < childBottom) {
                    // if element is longer than the available page, wrap it in overflow: hidden and make it ugly
                    if (!isPageBreak(child) && height > availableSpace) {
                        child.classList.add("__profiler-el-error");
                        child.style.height = `${availableSpace}px`;
                    }
                    const nextPage = [
                        ...o.root.querySelectorAll(".__profiler-page")
                    ].find((p)=>getPageId(p) === id + 1);
                    if (nextPage) nextPage.prepend(child);
                    else {
                        const nextPage = newPage(el, id);
                        nextPage.appendChild(child);
                        if (pageHeader) nextPage.appendChild(pageHeader.cloneNode(true));
                        if (pageFooter) nextPage.appendChild(pageFooter.cloneNode(true));
                        o.root.appendChild(nextPage);
                    }
                    rerun = true;
                }
            });
        });
        if (rerun) distributeContent(o);
    };
    const clean = (root, head)=>{
        root.querySelectorAll(".__profiler-page").forEach((el)=>el.remove());
        (head ?? root).querySelector(`#__profiler-styles`)?.remove();
        (head ?? root).querySelector(`#__profiler-theme`)?.remove();
    };
    const processPages = ({ size = "A4", orientation = "portrait", marginVertical = 15, marginHorizontal = 20 } = {}, markup, root)=>{
        root.style.position = "relative";
        root.classList.add("PROFILER--ROOT");
        const page = document.createElement("div");
        page.classList.add("__profiler-page", `__profiler-${size}`, `__profiler-${orientation}`);
        page.style.padding = `${marginVertical}mm ${marginHorizontal}mm`;
        page.innerHTML = markup;
        root.appendChild(page);
        firstPageHeader = page.querySelector(".PROFILER--FIRST-PAGE-HEADER");
        pageHeader = page.querySelector(".PROFILER--PAGE-HEADER");
        pageFooter = page.querySelector(".PROFILER--PAGE-FOOTER");
        const pagePaddingTop = pageHeader ? (0, $60bvA.getMesearements)(pageHeader).height : 0;
        const firstPagePaddingTop = firstPageHeader ? (0, $60bvA.getMesearements)(firstPageHeader).height : pagePaddingTop;
        if (pageFooter) page.style.paddingBottom = `${(0, $60bvA.getMesearements)(pageFooter).height}px`;
        distributeContent({
            root: root,
            pagePaddingTop: pagePaddingTop,
            firstPagePaddingTop: firstPagePaddingTop
        });
        // move page header and footer to bottom so it's the same as the generated pages
        if (firstPageHeader) {
            page.appendChild(firstPageHeader);
            pageHeader?.remove();
        } else if (pageHeader) page.appendChild(pageHeader);
        if (pageFooter) page.appendChild(pageFooter);
    };
    return {
        compile: (template)=>(0, $1boHW.default).template(eval("(" + handleHTMLAssets(template) + ")")),
        render: ({ styles, background, pageConfig, root, head, markup, theme })=>{
            clean(root, head);
            const rendererStyles = createStyleTag("__profiler-styles", styles);
            const themeStyles = createStyleTag("__profiler-theme", theme);
            if (rendererStyles) (head ?? root).appendChild(rendererStyles);
            (head ?? root).appendChild(themeStyles);
            root.style.backgroundColor = background ?? "inherit";
            processPages(pageConfig, markup, root);
            return root.querySelectorAll(".__profiler-page").length;
        }
    };
};

});
parcelRegister("1boHW", function(module, exports) {

$parcel$export(module.exports, "default", () => $b54ca28f40faa54e$export$2e2bcd8739ae039);

var $eb0Mz = parcelRequire("eb0Mz");
var $b54ca28f40faa54e$export$2e2bcd8739ae039 = (0, (/*@__PURE__*/$parcel$interopDefault($eb0Mz)));
/**
 * Tests to see two values are equal and evaluates block if true
 *
 * @param  {mixed} a      First value
 * @param  {mixed} b      Second value
 * @param  {html}  block  html block to evaluate if true
 */ (0, (/*@__PURE__*/$parcel$interopDefault($eb0Mz))).registerHelper("if_eq", function(a, b, block) {
    if (a === b) return block.fn(this);
    else return block.inverse(this);
});
(0, (/*@__PURE__*/$parcel$interopDefault($eb0Mz))).registerHelper("levelPrinter", (lvl, type)=>{
    const level = parseInt(lvl);
    const maxLevel = 10;
    let output = "";
    let count = 0;
    for(let i = 1; i <= maxLevel; i++){
        if (i % 2 === 0 && i <= level) {
            output += `<div class="filled"></div>`;
            count++;
        } else if (i % 2 === 1 && i === level) {
            output += `<div class="half-filled"></div>`;
            count++;
        } else if (i > level && count < maxLevel / 2) {
            output += `<div class="empty"></div>`;
            count++;
        }
    }
    return new (0, (/*@__PURE__*/$parcel$interopDefault($eb0Mz))).SafeString(`<div class="level--${type === "dots" ? "dot" : "line"}">${output}</div>`);
});
(0, (/*@__PURE__*/$parcel$interopDefault($eb0Mz))).registerHelper("mergeGroupContent", function(groups, options) {
    const { sortBy: sortBy = "", exclude: exclude = "" } = options.hash;
    const excludeArr = exclude.split(",");
    const list = groups.reduce((acc, list)=>excludeArr.includes(list.heading) ? acc : [
            ...acc,
            ...list.content
        ], []).sort((a, b)=>sortBy in a ? a[sortBy] > b[sortBy] ? 1 : -1 : 0);
    let ret = "";
    for(let i = 0, j = list.length; i < j; i++)ret = ret + options.fn(list[i]);
    return ret;
});

});
parcelRegister("eb0Mz", function(module, exports) {
// Create a simple path alias to allow browserify to resolve
// the runtime on a supported path.

module.exports = (parcelRequire("4lNcd")).default;

});
parcelRegister("4lNcd", function(module, exports) {
"use strict";
module.exports.__esModule = true;
// istanbul ignore next
function $32af48e92630645c$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        "default": obj
    };
}
// istanbul ignore next
function $32af48e92630645c$var$_interopRequireWildcard(obj) {
    if (obj && obj.__esModule) return obj;
    else {
        var newObj = {};
        if (obj != null) {
            for(var key in obj)if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key];
        }
        newObj["default"] = obj;
        return newObj;
    }
}

var $heAVb = parcelRequire("heAVb");
var $32af48e92630645c$var$base = $32af48e92630645c$var$_interopRequireWildcard($heAVb);

var $iGVj6 = parcelRequire("iGVj6");
var $32af48e92630645c$var$_handlebarsSafeString2 = $32af48e92630645c$var$_interopRequireDefault($iGVj6);

var $j2i8u = parcelRequire("j2i8u");
var $32af48e92630645c$var$_handlebarsException2 = $32af48e92630645c$var$_interopRequireDefault($j2i8u);

var $lhJk4 = parcelRequire("lhJk4");
var $32af48e92630645c$var$Utils = $32af48e92630645c$var$_interopRequireWildcard($lhJk4);

var $3VMM8 = parcelRequire("3VMM8");
var $32af48e92630645c$var$runtime = $32af48e92630645c$var$_interopRequireWildcard($3VMM8);

var $lykPt = parcelRequire("lykPt");
var $32af48e92630645c$var$_handlebarsNoConflict2 = $32af48e92630645c$var$_interopRequireDefault($lykPt);
// For compatibility and usage outside of module systems, make the Handlebars object a namespace
function $32af48e92630645c$var$create() {
    var hb = new $32af48e92630645c$var$base.HandlebarsEnvironment();
    $32af48e92630645c$var$Utils.extend(hb, $32af48e92630645c$var$base);
    hb.SafeString = $32af48e92630645c$var$_handlebarsSafeString2["default"];
    hb.Exception = $32af48e92630645c$var$_handlebarsException2["default"];
    hb.Utils = $32af48e92630645c$var$Utils;
    hb.escapeExpression = $32af48e92630645c$var$Utils.escapeExpression;
    hb.VM = $32af48e92630645c$var$runtime;
    hb.template = function(spec) {
        return $32af48e92630645c$var$runtime.template(spec, hb);
    };
    return hb;
}
var $32af48e92630645c$var$inst = $32af48e92630645c$var$create();
$32af48e92630645c$var$inst.create = $32af48e92630645c$var$create;
$32af48e92630645c$var$_handlebarsNoConflict2["default"]($32af48e92630645c$var$inst);
$32af48e92630645c$var$inst["default"] = $32af48e92630645c$var$inst;
module.exports["default"] = $32af48e92630645c$var$inst;
module.exports = module.exports["default"];

});
parcelRegister("heAVb", function(module, exports) {

$parcel$export(module.exports, "__esModule", () => $c8c06243179d3850$export$1e511d4a378977f5, (v) => $c8c06243179d3850$export$1e511d4a378977f5 = v);
$parcel$export(module.exports, "HandlebarsEnvironment", () => $c8c06243179d3850$export$5d1b9d3ad24c13f9, (v) => $c8c06243179d3850$export$5d1b9d3ad24c13f9 = v);
$parcel$export(module.exports, "VERSION", () => $c8c06243179d3850$export$a4ad2735b021c132, (v) => $c8c06243179d3850$export$a4ad2735b021c132 = v);
$parcel$export(module.exports, "COMPILER_REVISION", () => $c8c06243179d3850$export$682db5a6f2fa1046, (v) => $c8c06243179d3850$export$682db5a6f2fa1046 = v);
$parcel$export(module.exports, "LAST_COMPATIBLE_COMPILER_REVISION", () => $c8c06243179d3850$export$b416520f9fd5c520, (v) => $c8c06243179d3850$export$b416520f9fd5c520 = v);
$parcel$export(module.exports, "REVISION_CHANGES", () => $c8c06243179d3850$export$534648964353ca81, (v) => $c8c06243179d3850$export$534648964353ca81 = v);
$parcel$export(module.exports, "log", () => $c8c06243179d3850$export$bef1f36f5486a6a3, (v) => $c8c06243179d3850$export$bef1f36f5486a6a3 = v);
$parcel$export(module.exports, "createFrame", () => $c8c06243179d3850$export$52b3fe9f41f5650c, (v) => $c8c06243179d3850$export$52b3fe9f41f5650c = v);
$parcel$export(module.exports, "logger", () => $c8c06243179d3850$export$af88d00dbe7f521, (v) => $c8c06243179d3850$export$af88d00dbe7f521 = v);
var $c8c06243179d3850$export$1e511d4a378977f5;
var $c8c06243179d3850$export$5d1b9d3ad24c13f9;
var $c8c06243179d3850$export$a4ad2735b021c132;
var $c8c06243179d3850$export$682db5a6f2fa1046;
var $c8c06243179d3850$export$b416520f9fd5c520;
var $c8c06243179d3850$export$534648964353ca81;
var $c8c06243179d3850$export$bef1f36f5486a6a3;
var $c8c06243179d3850$export$52b3fe9f41f5650c;
var $c8c06243179d3850$export$af88d00dbe7f521;
"use strict";
$c8c06243179d3850$export$1e511d4a378977f5 = true;
$c8c06243179d3850$export$5d1b9d3ad24c13f9 = $c8c06243179d3850$var$HandlebarsEnvironment;
// istanbul ignore next
function $c8c06243179d3850$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        "default": obj
    };
}

var $lhJk4 = parcelRequire("lhJk4");

var $j2i8u = parcelRequire("j2i8u");
var $c8c06243179d3850$var$_exception2 = $c8c06243179d3850$var$_interopRequireDefault($j2i8u);

var $21FHm = parcelRequire("21FHm");

var $lHAua = parcelRequire("lHAua");

var $8fWxr = parcelRequire("8fWxr");
var $c8c06243179d3850$var$_logger2 = $c8c06243179d3850$var$_interopRequireDefault($8fWxr);

var $djL5T = parcelRequire("djL5T");
var $c8c06243179d3850$var$VERSION = "4.7.8";
$c8c06243179d3850$export$a4ad2735b021c132 = $c8c06243179d3850$var$VERSION;
var $c8c06243179d3850$var$COMPILER_REVISION = 8;
$c8c06243179d3850$export$682db5a6f2fa1046 = $c8c06243179d3850$var$COMPILER_REVISION;
var $c8c06243179d3850$var$LAST_COMPATIBLE_COMPILER_REVISION = 7;
$c8c06243179d3850$export$b416520f9fd5c520 = $c8c06243179d3850$var$LAST_COMPATIBLE_COMPILER_REVISION;
var $c8c06243179d3850$var$REVISION_CHANGES = {
    1: "<= 1.0.rc.2",
    2: "== 1.0.0-rc.3",
    3: "== 1.0.0-rc.4",
    4: "== 1.x.x",
    5: "== 2.0.0-alpha.x",
    6: ">= 2.0.0-beta.1",
    7: ">= 4.0.0 <4.3.0",
    8: ">= 4.3.0"
};
$c8c06243179d3850$export$534648964353ca81 = $c8c06243179d3850$var$REVISION_CHANGES;
var $c8c06243179d3850$var$objectType = "[object Object]";
function $c8c06243179d3850$var$HandlebarsEnvironment(helpers, partials, decorators) {
    this.helpers = helpers || {};
    this.partials = partials || {};
    this.decorators = decorators || {};
    $21FHm.registerDefaultHelpers(this);
    $lHAua.registerDefaultDecorators(this);
}
$c8c06243179d3850$var$HandlebarsEnvironment.prototype = {
    constructor: $c8c06243179d3850$var$HandlebarsEnvironment,
    logger: $c8c06243179d3850$var$_logger2["default"],
    log: $c8c06243179d3850$var$_logger2["default"].log,
    registerHelper: function registerHelper(name, fn) {
        if ($lhJk4.toString.call(name) === $c8c06243179d3850$var$objectType) {
            if (fn) throw new $c8c06243179d3850$var$_exception2["default"]("Arg not supported with multiple helpers");
            $lhJk4.extend(this.helpers, name);
        } else this.helpers[name] = fn;
    },
    unregisterHelper: function unregisterHelper(name) {
        delete this.helpers[name];
    },
    registerPartial: function registerPartial(name, partial) {
        if ($lhJk4.toString.call(name) === $c8c06243179d3850$var$objectType) $lhJk4.extend(this.partials, name);
        else {
            if (typeof partial === "undefined") throw new $c8c06243179d3850$var$_exception2["default"]('Attempting to register a partial called "' + name + '" as undefined');
            this.partials[name] = partial;
        }
    },
    unregisterPartial: function unregisterPartial(name) {
        delete this.partials[name];
    },
    registerDecorator: function registerDecorator(name, fn) {
        if ($lhJk4.toString.call(name) === $c8c06243179d3850$var$objectType) {
            if (fn) throw new $c8c06243179d3850$var$_exception2["default"]("Arg not supported with multiple decorators");
            $lhJk4.extend(this.decorators, name);
        } else this.decorators[name] = fn;
    },
    unregisterDecorator: function unregisterDecorator(name) {
        delete this.decorators[name];
    },
    /**
   * Reset the memory of illegal property accesses that have already been logged.
   * @deprecated should only be used in handlebars test-cases
   */ resetLoggedPropertyAccesses: function resetLoggedPropertyAccesses() {
        $djL5T.resetLoggedProperties();
    }
};
var $c8c06243179d3850$var$log = $c8c06243179d3850$var$_logger2["default"].log;
$c8c06243179d3850$export$bef1f36f5486a6a3 = $c8c06243179d3850$var$log;
$c8c06243179d3850$export$52b3fe9f41f5650c = $lhJk4.createFrame;
$c8c06243179d3850$export$af88d00dbe7f521 = $c8c06243179d3850$var$_logger2["default"];

});
parcelRegister("lhJk4", function(module, exports) {

$parcel$export(module.exports, "__esModule", () => $f7ee57a308ac3872$export$1e511d4a378977f5, (v) => $f7ee57a308ac3872$export$1e511d4a378977f5 = v);
$parcel$export(module.exports, "extend", () => $f7ee57a308ac3872$export$8b58be045bf06082, (v) => $f7ee57a308ac3872$export$8b58be045bf06082 = v);
$parcel$export(module.exports, "indexOf", () => $f7ee57a308ac3872$export$305f7d4e9d4624f2, (v) => $f7ee57a308ac3872$export$305f7d4e9d4624f2 = v);
$parcel$export(module.exports, "escapeExpression", () => $f7ee57a308ac3872$export$e6d4483b22f6b058, (v) => $f7ee57a308ac3872$export$e6d4483b22f6b058 = v);
$parcel$export(module.exports, "isEmpty", () => $f7ee57a308ac3872$export$dd1bc94b04021eeb, (v) => $f7ee57a308ac3872$export$dd1bc94b04021eeb = v);
$parcel$export(module.exports, "createFrame", () => $f7ee57a308ac3872$export$52b3fe9f41f5650c, (v) => $f7ee57a308ac3872$export$52b3fe9f41f5650c = v);
$parcel$export(module.exports, "blockParams", () => $f7ee57a308ac3872$export$b0cad7e592dd4356, (v) => $f7ee57a308ac3872$export$b0cad7e592dd4356 = v);
$parcel$export(module.exports, "appendContextPath", () => $f7ee57a308ac3872$export$e0253507f826725a, (v) => $f7ee57a308ac3872$export$e0253507f826725a = v);
$parcel$export(module.exports, "toString", () => $f7ee57a308ac3872$export$f84e8e69fd4488a5, (v) => $f7ee57a308ac3872$export$f84e8e69fd4488a5 = v);
$parcel$export(module.exports, "isFunction", () => $f7ee57a308ac3872$export$f6e2535fb5126e54, (v) => $f7ee57a308ac3872$export$f6e2535fb5126e54 = v);
$parcel$export(module.exports, "isArray", () => $f7ee57a308ac3872$export$43bee75e5e14138e, (v) => $f7ee57a308ac3872$export$43bee75e5e14138e = v);
var $f7ee57a308ac3872$export$1e511d4a378977f5;
var $f7ee57a308ac3872$export$8b58be045bf06082;
var $f7ee57a308ac3872$export$305f7d4e9d4624f2;
var $f7ee57a308ac3872$export$e6d4483b22f6b058;
var $f7ee57a308ac3872$export$dd1bc94b04021eeb;
var $f7ee57a308ac3872$export$52b3fe9f41f5650c;
var $f7ee57a308ac3872$export$b0cad7e592dd4356;
var $f7ee57a308ac3872$export$e0253507f826725a;
var $f7ee57a308ac3872$export$f84e8e69fd4488a5;
var $f7ee57a308ac3872$export$f6e2535fb5126e54;
var $f7ee57a308ac3872$export$43bee75e5e14138e;
"use strict";
$f7ee57a308ac3872$export$1e511d4a378977f5 = true;
$f7ee57a308ac3872$export$8b58be045bf06082 = $f7ee57a308ac3872$var$extend;
$f7ee57a308ac3872$export$305f7d4e9d4624f2 = $f7ee57a308ac3872$var$indexOf;
$f7ee57a308ac3872$export$e6d4483b22f6b058 = $f7ee57a308ac3872$var$escapeExpression;
$f7ee57a308ac3872$export$dd1bc94b04021eeb = $f7ee57a308ac3872$var$isEmpty;
$f7ee57a308ac3872$export$52b3fe9f41f5650c = $f7ee57a308ac3872$var$createFrame;
$f7ee57a308ac3872$export$b0cad7e592dd4356 = $f7ee57a308ac3872$var$blockParams;
$f7ee57a308ac3872$export$e0253507f826725a = $f7ee57a308ac3872$var$appendContextPath;
var $f7ee57a308ac3872$var$escape = {
    "&": "&amp;",
    "<": "&lt;",
    ">": "&gt;",
    '"': "&quot;",
    "'": "&#x27;",
    "`": "&#x60;",
    "=": "&#x3D;"
};
var $f7ee57a308ac3872$var$badChars = /[&<>"'`=]/g, $f7ee57a308ac3872$var$possible = /[&<>"'`=]/;
function $f7ee57a308ac3872$var$escapeChar(chr) {
    return $f7ee57a308ac3872$var$escape[chr];
}
function $f7ee57a308ac3872$var$extend(obj /* , ...source */ ) {
    for(var i = 1; i < arguments.length; i++){
        for(var key in arguments[i])if (Object.prototype.hasOwnProperty.call(arguments[i], key)) obj[key] = arguments[i][key];
    }
    return obj;
}
var $f7ee57a308ac3872$var$toString = Object.prototype.toString;
$f7ee57a308ac3872$export$f84e8e69fd4488a5 = $f7ee57a308ac3872$var$toString;
// Sourced from lodash
// https://github.com/bestiejs/lodash/blob/master/LICENSE.txt
/* eslint-disable func-style */ var $f7ee57a308ac3872$var$isFunction = function isFunction(value) {
    return typeof value === "function";
};
// fallback for older versions of Chrome and Safari
/* istanbul ignore next */ if ($f7ee57a308ac3872$var$isFunction(/x/)) $f7ee57a308ac3872$export$f6e2535fb5126e54 = $f7ee57a308ac3872$var$isFunction = function(value) {
    return typeof value === "function" && $f7ee57a308ac3872$var$toString.call(value) === "[object Function]";
};
$f7ee57a308ac3872$export$f6e2535fb5126e54 = $f7ee57a308ac3872$var$isFunction;
/* eslint-enable func-style */ /* istanbul ignore next */ var $f7ee57a308ac3872$var$isArray = Array.isArray || function(value) {
    return value && typeof value === "object" ? $f7ee57a308ac3872$var$toString.call(value) === "[object Array]" : false;
};
$f7ee57a308ac3872$export$43bee75e5e14138e = $f7ee57a308ac3872$var$isArray;
// Older IE versions do not directly support indexOf so we must implement our own, sadly.
function $f7ee57a308ac3872$var$indexOf(array, value) {
    for(var i = 0, len = array.length; i < len; i++){
        if (array[i] === value) return i;
    }
    return -1;
}
function $f7ee57a308ac3872$var$escapeExpression(string) {
    if (typeof string !== "string") {
        // don't escape SafeStrings, since they're already safe
        if (string && string.toHTML) return string.toHTML();
        else if (string == null) return "";
        else if (!string) return string + "";
        // Force a string conversion as this will be done by the append regardless and
        // the regex test will do this transparently behind the scenes, causing issues if
        // an object's to string has escaped characters in it.
        string = "" + string;
    }
    if (!$f7ee57a308ac3872$var$possible.test(string)) return string;
    return string.replace($f7ee57a308ac3872$var$badChars, $f7ee57a308ac3872$var$escapeChar);
}
function $f7ee57a308ac3872$var$isEmpty(value) {
    if (!value && value !== 0) return true;
    else if ($f7ee57a308ac3872$var$isArray(value) && value.length === 0) return true;
    else return false;
}
function $f7ee57a308ac3872$var$createFrame(object) {
    var frame = $f7ee57a308ac3872$var$extend({}, object);
    frame._parent = object;
    return frame;
}
function $f7ee57a308ac3872$var$blockParams(params, ids) {
    params.path = ids;
    return params;
}
function $f7ee57a308ac3872$var$appendContextPath(contextPath, id) {
    return (contextPath ? contextPath + "." : "") + id;
}

});

parcelRegister("j2i8u", function(module, exports) {
"use strict";
module.exports.__esModule = true;
var $ddbc45a4ef7413ce$var$errorProps = [
    "description",
    "fileName",
    "lineNumber",
    "endLineNumber",
    "message",
    "name",
    "number",
    "stack"
];
function $ddbc45a4ef7413ce$var$Exception(message, node) {
    var loc = node && node.loc, line = undefined, endLineNumber = undefined, column = undefined, endColumn = undefined;
    if (loc) {
        line = loc.start.line;
        endLineNumber = loc.end.line;
        column = loc.start.column;
        endColumn = loc.end.column;
        message += " - " + line + ":" + column;
    }
    var tmp = Error.prototype.constructor.call(this, message);
    // Unfortunately errors are not enumerable in Chrome (at least), so `for prop in tmp` doesn't work.
    for(var idx = 0; idx < $ddbc45a4ef7413ce$var$errorProps.length; idx++)this[$ddbc45a4ef7413ce$var$errorProps[idx]] = tmp[$ddbc45a4ef7413ce$var$errorProps[idx]];
    /* istanbul ignore else */ if (Error.captureStackTrace) Error.captureStackTrace(this, $ddbc45a4ef7413ce$var$Exception);
    try {
        if (loc) {
            this.lineNumber = line;
            this.endLineNumber = endLineNumber;
            // Work around issue under safari where we can't directly set the column value
            /* istanbul ignore next */ if (Object.defineProperty) {
                Object.defineProperty(this, "column", {
                    value: column,
                    enumerable: true
                });
                Object.defineProperty(this, "endColumn", {
                    value: endColumn,
                    enumerable: true
                });
            } else {
                this.column = column;
                this.endColumn = endColumn;
            }
        }
    } catch (nop) {
    /* Ignore if the browser is very particular */ }
}
$ddbc45a4ef7413ce$var$Exception.prototype = new Error();
module.exports["default"] = $ddbc45a4ef7413ce$var$Exception;
module.exports = module.exports["default"];

});

parcelRegister("21FHm", function(module, exports) {

$parcel$export(module.exports, "registerDefaultHelpers", () => $179c052ed08757fc$export$bdf7582f74746f6b, (v) => $179c052ed08757fc$export$bdf7582f74746f6b = v);
$parcel$export(module.exports, "moveHelperToHooks", () => $179c052ed08757fc$export$a8e22c3e8a03ea7e, (v) => $179c052ed08757fc$export$a8e22c3e8a03ea7e = v);
var $179c052ed08757fc$export$1e511d4a378977f5;
var $179c052ed08757fc$export$bdf7582f74746f6b;
var $179c052ed08757fc$export$a8e22c3e8a03ea7e;
"use strict";
$179c052ed08757fc$export$1e511d4a378977f5 = true;
$179c052ed08757fc$export$bdf7582f74746f6b = $179c052ed08757fc$var$registerDefaultHelpers;
$179c052ed08757fc$export$a8e22c3e8a03ea7e = $179c052ed08757fc$var$moveHelperToHooks;
// istanbul ignore next
function $179c052ed08757fc$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        "default": obj
    };
}

var $lfdKr = parcelRequire("lfdKr");
var $179c052ed08757fc$var$_helpersBlockHelperMissing2 = $179c052ed08757fc$var$_interopRequireDefault($lfdKr);

var $allAz = parcelRequire("allAz");
var $179c052ed08757fc$var$_helpersEach2 = $179c052ed08757fc$var$_interopRequireDefault($allAz);

var $IlMFs = parcelRequire("IlMFs");
var $179c052ed08757fc$var$_helpersHelperMissing2 = $179c052ed08757fc$var$_interopRequireDefault($IlMFs);

var $k4191 = parcelRequire("k4191");
var $179c052ed08757fc$var$_helpersIf2 = $179c052ed08757fc$var$_interopRequireDefault($k4191);

var $hPe7p = parcelRequire("hPe7p");
var $179c052ed08757fc$var$_helpersLog2 = $179c052ed08757fc$var$_interopRequireDefault($hPe7p);

var $520je = parcelRequire("520je");
var $179c052ed08757fc$var$_helpersLookup2 = $179c052ed08757fc$var$_interopRequireDefault($520je);

var $1BLRh = parcelRequire("1BLRh");
var $179c052ed08757fc$var$_helpersWith2 = $179c052ed08757fc$var$_interopRequireDefault($1BLRh);
function $179c052ed08757fc$var$registerDefaultHelpers(instance) {
    $179c052ed08757fc$var$_helpersBlockHelperMissing2["default"](instance);
    $179c052ed08757fc$var$_helpersEach2["default"](instance);
    $179c052ed08757fc$var$_helpersHelperMissing2["default"](instance);
    $179c052ed08757fc$var$_helpersIf2["default"](instance);
    $179c052ed08757fc$var$_helpersLog2["default"](instance);
    $179c052ed08757fc$var$_helpersLookup2["default"](instance);
    $179c052ed08757fc$var$_helpersWith2["default"](instance);
}
function $179c052ed08757fc$var$moveHelperToHooks(instance, helperName, keepHelper) {
    if (instance.helpers[helperName]) {
        instance.hooks[helperName] = instance.helpers[helperName];
        if (!keepHelper) delete instance.helpers[helperName];
    }
}

});
parcelRegister("lfdKr", function(module, exports) {
"use strict";
module.exports.__esModule = true;

var $lhJk4 = parcelRequire("lhJk4");
module.exports["default"] = function(instance) {
    instance.registerHelper("blockHelperMissing", function(context, options) {
        var inverse = options.inverse, fn = options.fn;
        if (context === true) return fn(this);
        else if (context === false || context == null) return inverse(this);
        else if ($lhJk4.isArray(context)) {
            if (context.length > 0) {
                if (options.ids) options.ids = [
                    options.name
                ];
                return instance.helpers.each(context, options);
            } else return inverse(this);
        } else {
            if (options.data && options.ids) {
                var data = $lhJk4.createFrame(options.data);
                data.contextPath = $lhJk4.appendContextPath(options.data.contextPath, options.name);
                options = {
                    data: data
                };
            }
            return fn(context, options);
        }
    });
};
module.exports = module.exports["default"];

});

parcelRegister("allAz", function(module, exports) {
"use strict";
module.exports.__esModule = true;
// istanbul ignore next
function $787c9c9fb8208135$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        "default": obj
    };
}

var $lhJk4 = parcelRequire("lhJk4");

var $j2i8u = parcelRequire("j2i8u");
var $787c9c9fb8208135$var$_exception2 = $787c9c9fb8208135$var$_interopRequireDefault($j2i8u);
module.exports["default"] = function(instance) {
    instance.registerHelper("each", function(context, options) {
        if (!options) throw new $787c9c9fb8208135$var$_exception2["default"]("Must pass iterator to #each");
        var fn = options.fn, inverse = options.inverse, i = 0, ret = "", data = undefined, contextPath = undefined;
        if (options.data && options.ids) contextPath = $lhJk4.appendContextPath(options.data.contextPath, options.ids[0]) + ".";
        if ($lhJk4.isFunction(context)) context = context.call(this);
        if (options.data) data = $lhJk4.createFrame(options.data);
        function execIteration(field, index, last) {
            if (data) {
                data.key = field;
                data.index = index;
                data.first = index === 0;
                data.last = !!last;
                if (contextPath) data.contextPath = contextPath + field;
            }
            ret = ret + fn(context[field], {
                data: data,
                blockParams: $lhJk4.blockParams([
                    context[field],
                    field
                ], [
                    contextPath + field,
                    null
                ])
            });
        }
        if (context && typeof context === "object") {
            if ($lhJk4.isArray(context)) {
                for(var j = context.length; i < j; i++)if (i in context) execIteration(i, i, i === context.length - 1);
            } else if (typeof Symbol === "function" && context[Symbol.iterator]) {
                var newContext = [];
                var iterator = context[Symbol.iterator]();
                for(var it = iterator.next(); !it.done; it = iterator.next())newContext.push(it.value);
                context = newContext;
                for(var j = context.length; i < j; i++)execIteration(i, i, i === context.length - 1);
            } else (function() {
                var priorKey = undefined;
                Object.keys(context).forEach(function(key) {
                    // We're running the iterations one step out of sync so we can detect
                    // the last iteration without have to scan the object twice and create
                    // an itermediate keys array.
                    if (priorKey !== undefined) execIteration(priorKey, i - 1);
                    priorKey = key;
                    i++;
                });
                if (priorKey !== undefined) execIteration(priorKey, i - 1, true);
            })();
        }
        if (i === 0) ret = inverse(this);
        return ret;
    });
};
module.exports = module.exports["default"];

});

parcelRegister("IlMFs", function(module, exports) {
"use strict";
module.exports.__esModule = true;
// istanbul ignore next
function $0855020440e9eb90$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        "default": obj
    };
}

var $j2i8u = parcelRequire("j2i8u");
var $0855020440e9eb90$var$_exception2 = $0855020440e9eb90$var$_interopRequireDefault($j2i8u);
module.exports["default"] = function(instance) {
    instance.registerHelper("helperMissing", function() /* [args, ]options */ {
        if (arguments.length === 1) // A missing field in a {{foo}} construct.
        return undefined;
        else // Someone is actually trying to call something, blow up.
        throw new $0855020440e9eb90$var$_exception2["default"]('Missing helper: "' + arguments[arguments.length - 1].name + '"');
    });
};
module.exports = module.exports["default"];

});

parcelRegister("k4191", function(module, exports) {
"use strict";
module.exports.__esModule = true;
// istanbul ignore next
function $e9b511a329409201$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        "default": obj
    };
}

var $lhJk4 = parcelRequire("lhJk4");

var $j2i8u = parcelRequire("j2i8u");
var $e9b511a329409201$var$_exception2 = $e9b511a329409201$var$_interopRequireDefault($j2i8u);
module.exports["default"] = function(instance) {
    instance.registerHelper("if", function(conditional, options) {
        if (arguments.length != 2) throw new $e9b511a329409201$var$_exception2["default"]("#if requires exactly one argument");
        if ($lhJk4.isFunction(conditional)) conditional = conditional.call(this);
        // Default behavior is to render the positive path if the value is truthy and not empty.
        // The `includeZero` option may be set to treat the condtional as purely not empty based on the
        // behavior of isEmpty. Effectively this determines if 0 is handled by the positive path or negative.
        if (!options.hash.includeZero && !conditional || $lhJk4.isEmpty(conditional)) return options.inverse(this);
        else return options.fn(this);
    });
    instance.registerHelper("unless", function(conditional, options) {
        if (arguments.length != 2) throw new $e9b511a329409201$var$_exception2["default"]("#unless requires exactly one argument");
        return instance.helpers["if"].call(this, conditional, {
            fn: options.inverse,
            inverse: options.fn,
            hash: options.hash
        });
    });
};
module.exports = module.exports["default"];

});

parcelRegister("hPe7p", function(module, exports) {
"use strict";
module.exports.__esModule = true;
module.exports["default"] = function(instance) {
    instance.registerHelper("log", function() /* message, options */ {
        var args = [
            undefined
        ], options = arguments[arguments.length - 1];
        for(var i = 0; i < arguments.length - 1; i++)args.push(arguments[i]);
        var level = 1;
        if (options.hash.level != null) level = options.hash.level;
        else if (options.data && options.data.level != null) level = options.data.level;
        args[0] = level;
        instance.log.apply(instance, args);
    });
};
module.exports = module.exports["default"];

});

parcelRegister("520je", function(module, exports) {
"use strict";
module.exports.__esModule = true;
module.exports["default"] = function(instance) {
    instance.registerHelper("lookup", function(obj, field, options) {
        if (!obj) // Note for 5.0: Change to "obj == null" in 5.0
        return obj;
        return options.lookupProperty(obj, field);
    });
};
module.exports = module.exports["default"];

});

parcelRegister("1BLRh", function(module, exports) {
"use strict";
module.exports.__esModule = true;
// istanbul ignore next
function $12be5ed6153460ee$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        "default": obj
    };
}

var $lhJk4 = parcelRequire("lhJk4");

var $j2i8u = parcelRequire("j2i8u");
var $12be5ed6153460ee$var$_exception2 = $12be5ed6153460ee$var$_interopRequireDefault($j2i8u);
module.exports["default"] = function(instance) {
    instance.registerHelper("with", function(context, options) {
        if (arguments.length != 2) throw new $12be5ed6153460ee$var$_exception2["default"]("#with requires exactly one argument");
        if ($lhJk4.isFunction(context)) context = context.call(this);
        var fn = options.fn;
        if (!$lhJk4.isEmpty(context)) {
            var data = options.data;
            if (options.data && options.ids) {
                data = $lhJk4.createFrame(options.data);
                data.contextPath = $lhJk4.appendContextPath(options.data.contextPath, options.ids[0]);
            }
            return fn(context, {
                data: data,
                blockParams: $lhJk4.blockParams([
                    context
                ], [
                    data && data.contextPath
                ])
            });
        } else return options.inverse(this);
    });
};
module.exports = module.exports["default"];

});


parcelRegister("lHAua", function(module, exports) {

$parcel$export(module.exports, "registerDefaultDecorators", () => $fcc9ea660fe6e757$export$7eaca4a3d56dbe6d, (v) => $fcc9ea660fe6e757$export$7eaca4a3d56dbe6d = v);
var $fcc9ea660fe6e757$export$1e511d4a378977f5;
var $fcc9ea660fe6e757$export$7eaca4a3d56dbe6d;
"use strict";
$fcc9ea660fe6e757$export$1e511d4a378977f5 = true;
$fcc9ea660fe6e757$export$7eaca4a3d56dbe6d = $fcc9ea660fe6e757$var$registerDefaultDecorators;
// istanbul ignore next
function $fcc9ea660fe6e757$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        "default": obj
    };
}

var $iDplC = parcelRequire("iDplC");
var $fcc9ea660fe6e757$var$_decoratorsInline2 = $fcc9ea660fe6e757$var$_interopRequireDefault($iDplC);
function $fcc9ea660fe6e757$var$registerDefaultDecorators(instance) {
    $fcc9ea660fe6e757$var$_decoratorsInline2["default"](instance);
}

});
parcelRegister("iDplC", function(module, exports) {
"use strict";
module.exports.__esModule = true;

var $lhJk4 = parcelRequire("lhJk4");
module.exports["default"] = function(instance) {
    instance.registerDecorator("inline", function(fn, props, container, options) {
        var ret = fn;
        if (!props.partials) {
            props.partials = {};
            ret = function(context, options) {
                // Create a new partials stack frame prior to exec.
                var original = container.partials;
                container.partials = $lhJk4.extend({}, original, props.partials);
                var ret = fn(context, options);
                container.partials = original;
                return ret;
            };
        }
        props.partials[options.args[0]] = options.fn;
        return ret;
    });
};
module.exports = module.exports["default"];

});


parcelRegister("8fWxr", function(module, exports) {
"use strict";
module.exports.__esModule = true;

var $lhJk4 = parcelRequire("lhJk4");
var $602d21f7af4ab2d1$var$logger = {
    methodMap: [
        "debug",
        "info",
        "warn",
        "error"
    ],
    level: "info",
    // Maps a given level value to the `methodMap` indexes above.
    lookupLevel: function lookupLevel(level) {
        if (typeof level === "string") {
            var levelMap = $lhJk4.indexOf($602d21f7af4ab2d1$var$logger.methodMap, level.toLowerCase());
            if (levelMap >= 0) level = levelMap;
            else level = parseInt(level, 10);
        }
        return level;
    },
    // Can be overridden in the host environment
    log: function log(level) {
        level = $602d21f7af4ab2d1$var$logger.lookupLevel(level);
        if (typeof console !== "undefined" && $602d21f7af4ab2d1$var$logger.lookupLevel($602d21f7af4ab2d1$var$logger.level) <= level) {
            var method = $602d21f7af4ab2d1$var$logger.methodMap[level];
            // eslint-disable-next-line no-console
            if (!console[method]) method = "log";
            for(var _len = arguments.length, message = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++)message[_key - 1] = arguments[_key];
            console[method].apply(console, message); // eslint-disable-line no-console
        }
    }
};
module.exports["default"] = $602d21f7af4ab2d1$var$logger;
module.exports = module.exports["default"];

});

parcelRegister("djL5T", function(module, exports) {

$parcel$export(module.exports, "createProtoAccessControl", () => $9b21949f691fcf53$export$9fc505f5102b04a5, (v) => $9b21949f691fcf53$export$9fc505f5102b04a5 = v);
$parcel$export(module.exports, "resultIsAllowed", () => $9b21949f691fcf53$export$8b633651c7cf59b9, (v) => $9b21949f691fcf53$export$8b633651c7cf59b9 = v);
$parcel$export(module.exports, "resetLoggedProperties", () => $9b21949f691fcf53$export$419dc2c4b2f2238b, (v) => $9b21949f691fcf53$export$419dc2c4b2f2238b = v);
var $9b21949f691fcf53$export$1e511d4a378977f5;
var $9b21949f691fcf53$export$9fc505f5102b04a5;
var $9b21949f691fcf53$export$8b633651c7cf59b9;
var $9b21949f691fcf53$export$419dc2c4b2f2238b;
"use strict";
$9b21949f691fcf53$export$1e511d4a378977f5 = true;
$9b21949f691fcf53$export$9fc505f5102b04a5 = $9b21949f691fcf53$var$createProtoAccessControl;
$9b21949f691fcf53$export$8b633651c7cf59b9 = $9b21949f691fcf53$var$resultIsAllowed;
$9b21949f691fcf53$export$419dc2c4b2f2238b = $9b21949f691fcf53$var$resetLoggedProperties;
// istanbul ignore next
function $9b21949f691fcf53$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        "default": obj
    };
}

var $jfeUV = parcelRequire("jfeUV");

var $8fWxr = parcelRequire("8fWxr");
var $9b21949f691fcf53$var$_logger2 = $9b21949f691fcf53$var$_interopRequireDefault($8fWxr);
var $9b21949f691fcf53$var$loggedProperties = Object.create(null);
function $9b21949f691fcf53$var$createProtoAccessControl(runtimeOptions) {
    var defaultMethodWhiteList = Object.create(null);
    defaultMethodWhiteList["constructor"] = false;
    defaultMethodWhiteList["__defineGetter__"] = false;
    defaultMethodWhiteList["__defineSetter__"] = false;
    defaultMethodWhiteList["__lookupGetter__"] = false;
    var defaultPropertyWhiteList = Object.create(null);
    // eslint-disable-next-line no-proto
    defaultPropertyWhiteList["__proto__"] = false;
    return {
        properties: {
            whitelist: $jfeUV.createNewLookupObject(defaultPropertyWhiteList, runtimeOptions.allowedProtoProperties),
            defaultValue: runtimeOptions.allowProtoPropertiesByDefault
        },
        methods: {
            whitelist: $jfeUV.createNewLookupObject(defaultMethodWhiteList, runtimeOptions.allowedProtoMethods),
            defaultValue: runtimeOptions.allowProtoMethodsByDefault
        }
    };
}
function $9b21949f691fcf53$var$resultIsAllowed(result, protoAccessControl, propertyName) {
    if (typeof result === "function") return $9b21949f691fcf53$var$checkWhiteList(protoAccessControl.methods, propertyName);
    else return $9b21949f691fcf53$var$checkWhiteList(protoAccessControl.properties, propertyName);
}
function $9b21949f691fcf53$var$checkWhiteList(protoAccessControlForType, propertyName) {
    if (protoAccessControlForType.whitelist[propertyName] !== undefined) return protoAccessControlForType.whitelist[propertyName] === true;
    if (protoAccessControlForType.defaultValue !== undefined) return protoAccessControlForType.defaultValue;
    $9b21949f691fcf53$var$logUnexpecedPropertyAccessOnce(propertyName);
    return false;
}
function $9b21949f691fcf53$var$logUnexpecedPropertyAccessOnce(propertyName) {
    if ($9b21949f691fcf53$var$loggedProperties[propertyName] !== true) {
        $9b21949f691fcf53$var$loggedProperties[propertyName] = true;
        $9b21949f691fcf53$var$_logger2["default"].log("error", 'Handlebars: Access has been denied to resolve the property "' + propertyName + '" because it is not an "own property" of its parent.\n' + "You can add a runtime option to disable the check or this warning:\n" + "See https://handlebarsjs.com/api-reference/runtime-options.html#options-to-control-prototype-access for details");
    }
}
function $9b21949f691fcf53$var$resetLoggedProperties() {
    Object.keys($9b21949f691fcf53$var$loggedProperties).forEach(function(propertyName) {
        delete $9b21949f691fcf53$var$loggedProperties[propertyName];
    });
}

});
parcelRegister("jfeUV", function(module, exports) {

$parcel$export(module.exports, "createNewLookupObject", () => $e02afd4b169ed652$export$ec2932ee0c0e8dcc, (v) => $e02afd4b169ed652$export$ec2932ee0c0e8dcc = v);
var $e02afd4b169ed652$export$1e511d4a378977f5;
var $e02afd4b169ed652$export$ec2932ee0c0e8dcc;
"use strict";
$e02afd4b169ed652$export$1e511d4a378977f5 = true;
$e02afd4b169ed652$export$ec2932ee0c0e8dcc = $e02afd4b169ed652$var$createNewLookupObject;

var $lhJk4 = parcelRequire("lhJk4");
/**
 * Create a new object with "null"-prototype to avoid truthy results on prototype properties.
 * The resulting object can be used with "object[property]" to check if a property exists
 * @param {...object} sources a varargs parameter of source objects that will be merged
 * @returns {object}
 */ function $e02afd4b169ed652$var$createNewLookupObject() {
    for(var _len = arguments.length, sources = Array(_len), _key = 0; _key < _len; _key++)sources[_key] = arguments[_key];
    return $lhJk4.extend.apply(undefined, [
        Object.create(null)
    ].concat(sources));
}

});



parcelRegister("iGVj6", function(module, exports) {
// Build out our basic SafeString type
"use strict";
module.exports.__esModule = true;
function $d9b89a36ca5fcb10$var$SafeString(string) {
    this.string = string;
}
$d9b89a36ca5fcb10$var$SafeString.prototype.toString = $d9b89a36ca5fcb10$var$SafeString.prototype.toHTML = function() {
    return "" + this.string;
};
module.exports["default"] = $d9b89a36ca5fcb10$var$SafeString;
module.exports = module.exports["default"];

});

parcelRegister("3VMM8", function(module, exports) {

$parcel$export(module.exports, "__esModule", () => $2dcc87becd96494d$export$1e511d4a378977f5, (v) => $2dcc87becd96494d$export$1e511d4a378977f5 = v);
$parcel$export(module.exports, "checkRevision", () => $2dcc87becd96494d$export$1a97de37fc44aecb, (v) => $2dcc87becd96494d$export$1a97de37fc44aecb = v);
$parcel$export(module.exports, "template", () => $2dcc87becd96494d$export$ce69bd05624d0c48, (v) => $2dcc87becd96494d$export$ce69bd05624d0c48 = v);
$parcel$export(module.exports, "wrapProgram", () => $2dcc87becd96494d$export$3976c39aa34be3b, (v) => $2dcc87becd96494d$export$3976c39aa34be3b = v);
$parcel$export(module.exports, "resolvePartial", () => $2dcc87becd96494d$export$ee54384c867bf98e, (v) => $2dcc87becd96494d$export$ee54384c867bf98e = v);
$parcel$export(module.exports, "invokePartial", () => $2dcc87becd96494d$export$6c4303200e44071a, (v) => $2dcc87becd96494d$export$6c4303200e44071a = v);
$parcel$export(module.exports, "noop", () => $2dcc87becd96494d$export$8793edee2d425525, (v) => $2dcc87becd96494d$export$8793edee2d425525 = v);
var $2dcc87becd96494d$export$1e511d4a378977f5;
var $2dcc87becd96494d$export$1a97de37fc44aecb;
var $2dcc87becd96494d$export$ce69bd05624d0c48;
var $2dcc87becd96494d$export$3976c39aa34be3b;
var $2dcc87becd96494d$export$ee54384c867bf98e;
var $2dcc87becd96494d$export$6c4303200e44071a;
var $2dcc87becd96494d$export$8793edee2d425525;
"use strict";
$2dcc87becd96494d$export$1e511d4a378977f5 = true;
$2dcc87becd96494d$export$1a97de37fc44aecb = $2dcc87becd96494d$var$checkRevision;
$2dcc87becd96494d$export$ce69bd05624d0c48 = $2dcc87becd96494d$var$template;
$2dcc87becd96494d$export$3976c39aa34be3b = $2dcc87becd96494d$var$wrapProgram;
$2dcc87becd96494d$export$ee54384c867bf98e = $2dcc87becd96494d$var$resolvePartial;
$2dcc87becd96494d$export$6c4303200e44071a = $2dcc87becd96494d$var$invokePartial;
$2dcc87becd96494d$export$8793edee2d425525 = $2dcc87becd96494d$var$noop;
// istanbul ignore next
function $2dcc87becd96494d$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        "default": obj
    };
}
// istanbul ignore next
function $2dcc87becd96494d$var$_interopRequireWildcard(obj) {
    if (obj && obj.__esModule) return obj;
    else {
        var newObj = {};
        if (obj != null) {
            for(var key in obj)if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key];
        }
        newObj["default"] = obj;
        return newObj;
    }
}

var $lhJk4 = parcelRequire("lhJk4");
var $2dcc87becd96494d$var$Utils = $2dcc87becd96494d$var$_interopRequireWildcard($lhJk4);

var $j2i8u = parcelRequire("j2i8u");
var $2dcc87becd96494d$var$_exception2 = $2dcc87becd96494d$var$_interopRequireDefault($j2i8u);

var $heAVb = parcelRequire("heAVb");

var $21FHm = parcelRequire("21FHm");

var $6B5q0 = parcelRequire("6B5q0");

var $djL5T = parcelRequire("djL5T");
function $2dcc87becd96494d$var$checkRevision(compilerInfo) {
    var compilerRevision = compilerInfo && compilerInfo[0] || 1, currentRevision = $heAVb.COMPILER_REVISION;
    if (compilerRevision >= $heAVb.LAST_COMPATIBLE_COMPILER_REVISION && compilerRevision <= $heAVb.COMPILER_REVISION) return;
    if (compilerRevision < $heAVb.LAST_COMPATIBLE_COMPILER_REVISION) {
        var runtimeVersions = $heAVb.REVISION_CHANGES[currentRevision], compilerVersions = $heAVb.REVISION_CHANGES[compilerRevision];
        throw new $2dcc87becd96494d$var$_exception2["default"]("Template was precompiled with an older version of Handlebars than the current runtime. Please update your precompiler to a newer version (" + runtimeVersions + ") or downgrade your runtime to an older version (" + compilerVersions + ").");
    } else // Use the embedded version info since the runtime doesn't know about this revision yet
    throw new $2dcc87becd96494d$var$_exception2["default"]("Template was precompiled with a newer version of Handlebars than the current runtime. Please update your runtime to a newer version (" + compilerInfo[1] + ").");
}
function $2dcc87becd96494d$var$template(templateSpec, env) {
    /* istanbul ignore next */ if (!env) throw new $2dcc87becd96494d$var$_exception2["default"]("No environment passed to template");
    if (!templateSpec || !templateSpec.main) throw new $2dcc87becd96494d$var$_exception2["default"]("Unknown template object: " + typeof templateSpec);
    templateSpec.main.decorator = templateSpec.main_d;
    // Note: Using env.VM references rather than local var references throughout this section to allow
    // for external users to override these as pseudo-supported APIs.
    env.VM.checkRevision(templateSpec.compiler);
    // backwards compatibility for precompiled templates with compiler-version 7 (<4.3.0)
    var templateWasPrecompiledWithCompilerV7 = templateSpec.compiler && templateSpec.compiler[0] === 7;
    function invokePartialWrapper(partial, context, options) {
        if (options.hash) {
            context = $2dcc87becd96494d$var$Utils.extend({}, context, options.hash);
            if (options.ids) options.ids[0] = true;
        }
        partial = env.VM.resolvePartial.call(this, partial, context, options);
        var extendedOptions = $2dcc87becd96494d$var$Utils.extend({}, options, {
            hooks: this.hooks,
            protoAccessControl: this.protoAccessControl
        });
        var result = env.VM.invokePartial.call(this, partial, context, extendedOptions);
        if (result == null && env.compile) {
            options.partials[options.name] = env.compile(partial, templateSpec.compilerOptions, env);
            result = options.partials[options.name](context, extendedOptions);
        }
        if (result != null) {
            if (options.indent) {
                var lines = result.split("\n");
                for(var i = 0, l = lines.length; i < l; i++){
                    if (!lines[i] && i + 1 === l) break;
                    lines[i] = options.indent + lines[i];
                }
                result = lines.join("\n");
            }
            return result;
        } else throw new $2dcc87becd96494d$var$_exception2["default"]("The partial " + options.name + " could not be compiled when running in runtime-only mode");
    }
    // Just add water
    var container = {
        strict: function strict(obj, name, loc) {
            if (!obj || !(name in obj)) throw new $2dcc87becd96494d$var$_exception2["default"]('"' + name + '" not defined in ' + obj, {
                loc: loc
            });
            return container.lookupProperty(obj, name);
        },
        lookupProperty: function lookupProperty(parent, propertyName) {
            var result = parent[propertyName];
            if (result == null) return result;
            if (Object.prototype.hasOwnProperty.call(parent, propertyName)) return result;
            if ($djL5T.resultIsAllowed(result, container.protoAccessControl, propertyName)) return result;
            return undefined;
        },
        lookup: function lookup(depths, name) {
            var len = depths.length;
            for(var i = 0; i < len; i++){
                var result = depths[i] && container.lookupProperty(depths[i], name);
                if (result != null) return depths[i][name];
            }
        },
        lambda: function lambda(current, context) {
            return typeof current === "function" ? current.call(context) : current;
        },
        escapeExpression: $2dcc87becd96494d$var$Utils.escapeExpression,
        invokePartial: invokePartialWrapper,
        fn: function fn(i) {
            var ret = templateSpec[i];
            ret.decorator = templateSpec[i + "_d"];
            return ret;
        },
        programs: [],
        program: function program(i, data, declaredBlockParams, blockParams, depths) {
            var programWrapper = this.programs[i], fn = this.fn(i);
            if (data || depths || blockParams || declaredBlockParams) programWrapper = $2dcc87becd96494d$var$wrapProgram(this, i, fn, data, declaredBlockParams, blockParams, depths);
            else if (!programWrapper) programWrapper = this.programs[i] = $2dcc87becd96494d$var$wrapProgram(this, i, fn);
            return programWrapper;
        },
        data: function data(value, depth) {
            while(value && depth--)value = value._parent;
            return value;
        },
        mergeIfNeeded: function mergeIfNeeded(param, common) {
            var obj = param || common;
            if (param && common && param !== common) obj = $2dcc87becd96494d$var$Utils.extend({}, common, param);
            return obj;
        },
        // An empty object to use as replacement for null-contexts
        nullContext: Object.seal({}),
        noop: env.VM.noop,
        compilerInfo: templateSpec.compiler
    };
    function ret(context) {
        var options = arguments.length <= 1 || arguments[1] === undefined ? {} : arguments[1];
        var data = options.data;
        ret._setup(options);
        if (!options.partial && templateSpec.useData) data = $2dcc87becd96494d$var$initData(context, data);
        var depths = undefined, blockParams = templateSpec.useBlockParams ? [] : undefined;
        if (templateSpec.useDepths) {
            if (options.depths) depths = context != options.depths[0] ? [
                context
            ].concat(options.depths) : options.depths;
            else depths = [
                context
            ];
        }
        function main(context /*, options*/ ) {
            return "" + templateSpec.main(container, context, container.helpers, container.partials, data, blockParams, depths);
        }
        main = $2dcc87becd96494d$var$executeDecorators(templateSpec.main, main, container, options.depths || [], data, blockParams);
        return main(context, options);
    }
    ret.isTop = true;
    ret._setup = function(options) {
        if (!options.partial) {
            var mergedHelpers = $2dcc87becd96494d$var$Utils.extend({}, env.helpers, options.helpers);
            $2dcc87becd96494d$var$wrapHelpersToPassLookupProperty(mergedHelpers, container);
            container.helpers = mergedHelpers;
            if (templateSpec.usePartial) // Use mergeIfNeeded here to prevent compiling global partials multiple times
            container.partials = container.mergeIfNeeded(options.partials, env.partials);
            if (templateSpec.usePartial || templateSpec.useDecorators) container.decorators = $2dcc87becd96494d$var$Utils.extend({}, env.decorators, options.decorators);
            container.hooks = {};
            container.protoAccessControl = $djL5T.createProtoAccessControl(options);
            var keepHelperInHelpers = options.allowCallsToHelperMissing || templateWasPrecompiledWithCompilerV7;
            $21FHm.moveHelperToHooks(container, "helperMissing", keepHelperInHelpers);
            $21FHm.moveHelperToHooks(container, "blockHelperMissing", keepHelperInHelpers);
        } else {
            container.protoAccessControl = options.protoAccessControl; // internal option
            container.helpers = options.helpers;
            container.partials = options.partials;
            container.decorators = options.decorators;
            container.hooks = options.hooks;
        }
    };
    ret._child = function(i, data, blockParams, depths) {
        if (templateSpec.useBlockParams && !blockParams) throw new $2dcc87becd96494d$var$_exception2["default"]("must pass block params");
        if (templateSpec.useDepths && !depths) throw new $2dcc87becd96494d$var$_exception2["default"]("must pass parent depths");
        return $2dcc87becd96494d$var$wrapProgram(container, i, templateSpec[i], data, 0, blockParams, depths);
    };
    return ret;
}
function $2dcc87becd96494d$var$wrapProgram(container, i, fn, data, declaredBlockParams, blockParams, depths) {
    function prog(context) {
        var options = arguments.length <= 1 || arguments[1] === undefined ? {} : arguments[1];
        var currentDepths = depths;
        if (depths && context != depths[0] && !(context === container.nullContext && depths[0] === null)) currentDepths = [
            context
        ].concat(depths);
        return fn(container, context, container.helpers, container.partials, options.data || data, blockParams && [
            options.blockParams
        ].concat(blockParams), currentDepths);
    }
    prog = $2dcc87becd96494d$var$executeDecorators(fn, prog, container, depths, data, blockParams);
    prog.program = i;
    prog.depth = depths ? depths.length : 0;
    prog.blockParams = declaredBlockParams || 0;
    return prog;
}
/**
 * This is currently part of the official API, therefore implementation details should not be changed.
 */ function $2dcc87becd96494d$var$resolvePartial(partial, context, options) {
    if (!partial) {
        if (options.name === "@partial-block") partial = options.data["partial-block"];
        else partial = options.partials[options.name];
    } else if (!partial.call && !options.name) {
        // This is a dynamic partial that returned a string
        options.name = partial;
        partial = options.partials[partial];
    }
    return partial;
}
function $2dcc87becd96494d$var$invokePartial(partial, context, options) {
    // Use the current closure context to save the partial-block if this partial
    var currentPartialBlock = options.data && options.data["partial-block"];
    options.partial = true;
    if (options.ids) options.data.contextPath = options.ids[0] || options.data.contextPath;
    var partialBlock = undefined;
    if (options.fn && options.fn !== $2dcc87becd96494d$var$noop) (function() {
        options.data = $heAVb.createFrame(options.data);
        // Wrapper function to get access to currentPartialBlock from the closure
        var fn = options.fn;
        partialBlock = options.data["partial-block"] = function partialBlockWrapper(context) {
            var options = arguments.length <= 1 || arguments[1] === undefined ? {} : arguments[1];
            // Restore the partial-block from the closure for the execution of the block
            // i.e. the part inside the block of the partial call.
            options.data = $heAVb.createFrame(options.data);
            options.data["partial-block"] = currentPartialBlock;
            return fn(context, options);
        };
        if (fn.partials) options.partials = $2dcc87becd96494d$var$Utils.extend({}, options.partials, fn.partials);
    })();
    if (partial === undefined && partialBlock) partial = partialBlock;
    if (partial === undefined) throw new $2dcc87becd96494d$var$_exception2["default"]("The partial " + options.name + " could not be found");
    else if (partial instanceof Function) return partial(context, options);
}
function $2dcc87becd96494d$var$noop() {
    return "";
}
function $2dcc87becd96494d$var$initData(context, data) {
    if (!data || !("root" in data)) {
        data = data ? $heAVb.createFrame(data) : {};
        data.root = context;
    }
    return data;
}
function $2dcc87becd96494d$var$executeDecorators(fn, prog, container, depths, data, blockParams) {
    if (fn.decorator) {
        var props = {};
        prog = fn.decorator(prog, props, container, depths && depths[0], data, blockParams, depths);
        $2dcc87becd96494d$var$Utils.extend(prog, props);
    }
    return prog;
}
function $2dcc87becd96494d$var$wrapHelpersToPassLookupProperty(mergedHelpers, container) {
    Object.keys(mergedHelpers).forEach(function(helperName) {
        var helper = mergedHelpers[helperName];
        mergedHelpers[helperName] = $2dcc87becd96494d$var$passLookupPropertyOption(helper, container);
    });
}
function $2dcc87becd96494d$var$passLookupPropertyOption(helper, container) {
    var lookupProperty = container.lookupProperty;
    return $6B5q0.wrapHelper(helper, function(options) {
        return $2dcc87becd96494d$var$Utils.extend({
            lookupProperty: lookupProperty
        }, options);
    });
}

});
parcelRegister("6B5q0", function(module, exports) {

$parcel$export(module.exports, "wrapHelper", () => $4cda66cb2e7b7bf1$export$34b84bc8884ca465, (v) => $4cda66cb2e7b7bf1$export$34b84bc8884ca465 = v);
var $4cda66cb2e7b7bf1$export$1e511d4a378977f5;
var $4cda66cb2e7b7bf1$export$34b84bc8884ca465;
"use strict";
$4cda66cb2e7b7bf1$export$1e511d4a378977f5 = true;
$4cda66cb2e7b7bf1$export$34b84bc8884ca465 = $4cda66cb2e7b7bf1$var$wrapHelper;
function $4cda66cb2e7b7bf1$var$wrapHelper(helper, transformOptionsFn) {
    if (typeof helper !== "function") // This should not happen, but apparently it does in https://github.com/wycats/handlebars.js/issues/1639
    // We try to make the wrapper least-invasive by not wrapping it, if the helper is not a function.
    return helper;
    var wrapper = function wrapper() /* dynamic arguments */ {
        var options = arguments[arguments.length - 1];
        arguments[arguments.length - 1] = transformOptionsFn(options);
        return helper.apply(this, arguments);
    };
    return wrapper;
}

});


parcelRegister("lykPt", function(module, exports) {
/* global globalThis */ "use strict";
module.exports.__esModule = true;
module.exports["default"] = function(Handlebars) {
    /* istanbul ignore next */ // https://mathiasbynens.be/notes/globalthis
    (function() {
        if (typeof globalThis === "object") return;
        Object.prototype.__defineGetter__("__magic__", function() {
            return this;
        });
        __magic__.globalThis = __magic__; // eslint-disable-line no-undef
        delete Object.prototype.__magic__;
    })();
    var $Handlebars = globalThis.Handlebars;
    /* istanbul ignore next */ Handlebars.noConflict = function() {
        if (globalThis.Handlebars === Handlebars) globalThis.Handlebars = $Handlebars;
        return Handlebars;
    };
};
module.exports = module.exports["default"];

});




parcelRegister("60bvA", function(module, exports) {

$parcel$export(module.exports, "getMesearements", () => $c8875c2ab8f81923$export$252afdd5319415fa);
$parcel$export(module.exports, "str2filename", () => $c8875c2ab8f81923$export$db457a54776c3a80);
$parcel$export(module.exports, "getDetailsByDoc", () => $c8875c2ab8f81923$export$23d53c1ab84b187a);
$parcel$export(module.exports, "capitalize", () => $c8875c2ab8f81923$export$9a00dee1beb8f576);
$parcel$export(module.exports, "getMemoizedTemplate", () => $c8875c2ab8f81923$export$8abd62dc0a2904d7);
$parcel$export(module.exports, "setTemplateWithFallback", () => $c8875c2ab8f81923$export$973757031bb02a03);

var $5piy6 = parcelRequire("5piy6");

var $jPSn7 = parcelRequire("jPSn7");
const $c8875c2ab8f81923$export$98fdc551f64e4aaf = (str)=>Math.round(window.parseFloat(str));
const $c8875c2ab8f81923$export$252afdd5319415fa = (el, withMargin = true)=>{
    const style = window.getComputedStyle(el);
    const margin = withMargin && {
        ver: $c8875c2ab8f81923$export$98fdc551f64e4aaf(style.marginBottom) + $c8875c2ab8f81923$export$98fdc551f64e4aaf(style.marginTop),
        hor: $c8875c2ab8f81923$export$98fdc551f64e4aaf(style.marginLeft) + $c8875c2ab8f81923$export$98fdc551f64e4aaf(style.marginRight)
    };
    return {
        height: el.clientHeight + (margin ? margin.ver : 0),
        width: el.clientWidth + (margin ? margin.hor : 0)
    };
};
const $c8875c2ab8f81923$export$db457a54776c3a80 = (s)=>s.toLowerCase().replace(" ", ".");
const $c8875c2ab8f81923$export$23d53c1ab84b187a = (doc, resources)=>resources?.reduce((acc, { id: id, name: name, profiles: profiles })=>{
        const profile = profiles.find((p)=>p.id === doc);
        return profile ? {
            id: id,
            name: name,
            profile: profile,
            profiles: profiles
        } : acc;
    }, undefined);
const $c8875c2ab8f81923$export$7a5d5c156e7dc406 = (list)=>list && [
        ...new Set(list)
    ];
const $c8875c2ab8f81923$export$abf0e2545164275f = (key, list)=>list?.reduce((acc, p)=>{
        const existing = acc.find((x)=>x[key] === p[key]);
        if (!existing) acc.push(p);
        return acc;
    }, []);
const $c8875c2ab8f81923$export$9a00dee1beb8f576 = (s)=>s?.charAt(0).toUpperCase() + s?.slice(1);
const $c8875c2ab8f81923$var$memoCache = new Map();
const $c8875c2ab8f81923$var$shallowCompare = (a, b)=>Boolean(a && b) && (0, $5piy6.shallowEqualArrays)(a, b);
const $c8875c2ab8f81923$export$7c73462e0d25e514 = (exec, deps)=>{
    const fStr = exec.toString();
    const cached = $c8875c2ab8f81923$var$memoCache.get(fStr);
    if ($c8875c2ab8f81923$var$shallowCompare(cached?.deps, deps)) return cached.result;
    const result = exec();
    if (result != null) $c8875c2ab8f81923$var$memoCache.set(fStr, {
        deps: deps,
        result: result
    });
    return result;
};
const $c8875c2ab8f81923$export$8abd62dc0a2904d7 = (templates, templateId)=>$c8875c2ab8f81923$export$7c73462e0d25e514(()=>{
        const id = templateId || (0, $jPSn7.getCurrentTemplate)()[0];
        if (!id) return undefined;
        return templates?.find((t)=>t.id === id);
    }, [
        templates,
        templateId
    ]);
const $c8875c2ab8f81923$export$973757031bb02a03 = (templates, templateId)=>{
    const templateInfo = $c8875c2ab8f81923$export$8abd62dc0a2904d7(templates, templateId);
    if (templateInfo && templateId) {
        const defaultTheme = templateInfo.themes[0]?.id;
        if (defaultTheme) (0, $jPSn7.setTemplate)([
            templateId,
            defaultTheme
        ]);
        else throw Error(`Template ${templateInfo.name} doesn't haev any available themes`);
    } else {
        const fallbackTemplate = templates?.[0];
        const fallbackTheme = fallbackTemplate?.themes[0];
        if (fallbackTemplate && fallbackTheme) (0, $jPSn7.setTemplate)([
            fallbackTemplate.id,
            fallbackTheme.id
        ]);
    }
};

});
parcelRegister("5piy6", function(module, exports) {

$parcel$export(module.exports, "shallowEqualArrays", () => $f0ffbd605cf24f5a$export$967a6b9924a689f7);
function $f0ffbd605cf24f5a$export$967a6b9924a689f7(arrA, arrB) {
    if (arrA === arrB) return true;
    if (!arrA || !arrB) return false;
    const len = arrA.length;
    if (arrB.length !== len) return false;
    for(let i = 0; i < len; i++){
        if (arrA[i] !== arrB[i]) return false;
    }
    return true;
}
function $f0ffbd605cf24f5a$export$3e67810a3f0e9f1c(objA, objB) {
    if (objA === objB) return true;
    if (!objA || !objB) return false;
    const aKeys = Object.keys(objA);
    const bKeys = Object.keys(objB);
    const len = aKeys.length;
    if (bKeys.length !== len) return false;
    for(let i = 0; i < len; i++){
        const key = aKeys[i];
        if (objA[key] !== objB[key] || !Object.prototype.hasOwnProperty.call(objB, key)) return false;
    }
    return true;
}
function $f0ffbd605cf24f5a$export$d36bdfa510afb180(a, b) {
    const aIsArr = Array.isArray(a);
    const bIsArr = Array.isArray(b);
    if (aIsArr !== bIsArr) return false;
    if (aIsArr && bIsArr) return $f0ffbd605cf24f5a$export$967a6b9924a689f7(a, b);
    return $f0ffbd605cf24f5a$export$3e67810a3f0e9f1c(a, b);
}

});

parcelRegister("jPSn7", function(module, exports) {

$parcel$export(module.exports, "useDocumentInfoStore", () => $e5da24f3c597ef94$export$f02b4c814dc222a3);
$parcel$export(module.exports, "setDocumentInfo", () => $e5da24f3c597ef94$export$c2e015c6d888ef46);
$parcel$export(module.exports, "useSidebarRightStore", () => $e5da24f3c597ef94$export$502ebf272b86c094);
$parcel$export(module.exports, "setSidebarRight", () => $e5da24f3c597ef94$export$362ba0790ee8c4b6);
$parcel$export(module.exports, "useSidebarLeftStore", () => $e5da24f3c597ef94$export$74bd41203e7c8892);
$parcel$export(module.exports, "useCacheBusterStore", () => $e5da24f3c597ef94$export$f707785df58d5a38);
$parcel$export(module.exports, "useTemplateStore", () => $e5da24f3c597ef94$export$4ed1643beefe2afd);
$parcel$export(module.exports, "setTemplate", () => $e5da24f3c597ef94$export$1704277140908755);
$parcel$export(module.exports, "getCurrentTemplate", () => $e5da24f3c597ef94$export$75d6b3eed6b86d7e);
$parcel$export(module.exports, "useDocStore", () => $e5da24f3c597ef94$export$de0278daa060d580);
$parcel$export(module.exports, "defaultMode", () => $e5da24f3c597ef94$export$de627736f8c8ffd7);
$parcel$export(module.exports, "useModeStore", () => $e5da24f3c597ef94$export$833d409a8140dc00);

var $gkklS = parcelRequire("gkklS");
const { useStore: $e5da24f3c597ef94$export$f02b4c814dc222a3, set: $e5da24f3c597ef94$export$c2e015c6d888ef46 } = (0, $gkklS.createStore)({
    chars: 0,
    words: 0,
    nPages: 0
});
const { useStore: $e5da24f3c597ef94$export$502ebf272b86c094, set: $e5da24f3c597ef94$export$362ba0790ee8c4b6 } = (0, $gkklS.createStore)(false);
const { useStore: $e5da24f3c597ef94$export$74bd41203e7c8892, set: $e5da24f3c597ef94$export$33ae8d70f54c17b4 } = (0, $gkklS.createStore)(false);
const { useStore: $e5da24f3c597ef94$export$f707785df58d5a38, set: $e5da24f3c597ef94$export$187282dc6f6dcce8 } = (0, $gkklS.createStore)(false);
const { useStore: $e5da24f3c597ef94$export$4ed1643beefe2afd, set: $e5da24f3c597ef94$export$1704277140908755, get: $e5da24f3c597ef94$export$75d6b3eed6b86d7e } = (0, $gkklS.createPersistentStore)("ProfilerTemplate", []);
const { useStore: $e5da24f3c597ef94$export$de0278daa060d580, set: $e5da24f3c597ef94$export$5ff77ddaff3c9e12 } = (0, $gkklS.createPersistentStore)("ProfilerProfile", undefined);
const $e5da24f3c597ef94$export$de627736f8c8ffd7 = JSON.parse(window.localStorage.getItem("ProfilerMode")) ?? (window.matchMedia?.("(prefers-color-scheme: dark)").matches ? "dark" : "light");
const { useStore: $e5da24f3c597ef94$export$833d409a8140dc00, set: $e5da24f3c597ef94$export$d4f039427a1beff1 } = (0, $gkklS.createPersistentStore)("ProfilerMode", $e5da24f3c597ef94$export$de627736f8c8ffd7);

});
parcelRegister("gkklS", function(module, exports) {

$parcel$export(module.exports, "createStore", () => $2f255c4e1b34bdee$export$f51a9068ac82ea43);
$parcel$export(module.exports, "createPersistentStore", () => $2f255c4e1b34bdee$export$d99bd77bbf4391ba);

var $cWbtJ = parcelRequire("cWbtJ");
const $2f255c4e1b34bdee$export$f51a9068ac82ea43 = (initialState)=>{
    let state = initialState;
    const listeners = new Set();
    const store = {
        getState: ()=>state,
        setState: (newState)=>{
            state = typeof newState === "function" ? newState(state) : newState;
            listeners.forEach((listener)=>listener(state));
            return state;
        },
        subscribe: (listener)=>{
            listeners.add(listener);
            return ()=>listeners.delete(listener);
        }
    };
    return {
        useStore: ()=>[
                (0, $cWbtJ.useSyncExternalStore)(store.subscribe, store.getState),
                store.setState
            ],
        set: store.setState,
        get: store.getState
    };
};
const $2f255c4e1b34bdee$export$d99bd77bbf4391ba = (key, defaultValue)=>{
    const storage = {
        get: ()=>JSON.parse(window.localStorage.getItem(key)),
        set: (value)=>window.localStorage.setItem(key, JSON.stringify(value))
    };
    const store = $2f255c4e1b34bdee$export$f51a9068ac82ea43(storage.get() ?? defaultValue);
    const set = (newState)=>{
        storage.set(store.set(newState));
    };
    return {
        ...store,
        useStore: ()=>[
                store.useStore()[0],
                set
            ],
        set: set
    };
};

});




var $9e48c988ecb997e2$exports = {};
"use strict";

$9e48c988ecb997e2$exports = (parcelRequire("btLjt"));



var $cWbtJ = parcelRequire("cWbtJ");
var $cf32b50829570373$export$882461b6382ed46c;
var $cf32b50829570373$export$757ceba2d55c277e;
"use strict";
var $2b43e780cf0f0f59$exports = {};
"use strict";
function $2b43e780cf0f0f59$var$checkDCE() {
    /* global __REACT_DEVTOOLS_GLOBAL_HOOK__ */ if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ === "undefined" || typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE !== "function") return;
    try {
        // Verify that the code above has been dead code eliminated (DCE'd).
        __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE($2b43e780cf0f0f59$var$checkDCE);
    } catch (err) {
        // DevTools shouldn't crash React, no matter what.
        // We should still report in case we break this code.
        console.error(err);
    }
}
// DCE check should happen before ReactDOM bundle executes so that
// DevTools can report bad minification during injection.
$2b43e780cf0f0f59$var$checkDCE();

$2b43e780cf0f0f59$exports = (parcelRequire("hd0Er"));


var $cf32b50829570373$var$i;
$cf32b50829570373$export$882461b6382ed46c = $2b43e780cf0f0f59$exports.createRoot;
$cf32b50829570373$export$757ceba2d55c277e = $2b43e780cf0f0f59$exports.hydrateRoot;



var $cWbtJ = parcelRequire("cWbtJ");

"use client";
var $5637d36f54c10878$export$da112d31b0149f31 = $cWbtJ.createContext(void 0);
var $5637d36f54c10878$export$22e77b9572c4fded = (queryClient)=>{
    const client = $cWbtJ.useContext($5637d36f54c10878$export$da112d31b0149f31);
    if (queryClient) return queryClient;
    if (!client) throw new Error("No QueryClient set, use QueryClientProvider to set one");
    return client;
};
var $5637d36f54c10878$export$45604f0cc8ae667b = ({ client: client, children: children })=>{
    $cWbtJ.useEffect(()=>{
        client.mount();
        return ()=>{
            client.unmount();
        };
    }, [
        client
    ]);
    return /* @__PURE__ */ (0, $9e48c988ecb997e2$exports.jsx)($5637d36f54c10878$export$da112d31b0149f31.Provider, {
        value: client,
        children: children
    });
};


let $8c050ffba58637bd$var$e = {
    data: ""
}, $8c050ffba58637bd$var$t = (t)=>"object" == typeof window ? ((t ? t.querySelector("#_goober") : window._goober) || Object.assign((t || document.head).appendChild(document.createElement("style")), {
        innerHTML: " ",
        id: "_goober"
    })).firstChild : t || $8c050ffba58637bd$var$e, $8c050ffba58637bd$export$54aba348a7896325 = (e)=>{
    let r = $8c050ffba58637bd$var$t(e), l = r.data;
    return r.data = "", l;
}, $8c050ffba58637bd$var$l = /(?:([\u0080-\uFFFF\w-%@]+) *:? *([^{;]+?);|([^;}{]*?) *{)|(}\s*)/g, $8c050ffba58637bd$var$a = /\/\*[^]*?\*\/|  +/g, $8c050ffba58637bd$var$n = /\n+/g, $8c050ffba58637bd$var$o = (e, t)=>{
    let r = "", l = "", a = "";
    for(let n in e){
        let c = e[n];
        "@" == n[0] ? "i" == n[1] ? r = n + " " + c + ";" : l += "f" == n[1] ? $8c050ffba58637bd$var$o(c, n) : n + "{" + $8c050ffba58637bd$var$o(c, "k" == n[1] ? "" : t) + "}" : "object" == typeof c ? l += $8c050ffba58637bd$var$o(c, t ? t.replace(/([^,])+/g, (e)=>n.replace(/(^:.*)|([^,])+/g, (t)=>/&/.test(t) ? t.replace(/&/g, e) : e ? e + " " + t : t)) : n) : null != c && (n = /^--/.test(n) ? n : n.replace(/[A-Z]/g, "-$&").toLowerCase(), a += $8c050ffba58637bd$var$o.p ? $8c050ffba58637bd$var$o.p(n, c) : n + ":" + c + ";");
    }
    return r + (t && a ? t + "{" + a + "}" : a) + l;
}, $8c050ffba58637bd$var$c = {}, $8c050ffba58637bd$var$s = (e)=>{
    if ("object" == typeof e) {
        let t = "";
        for(let r in e)t += r + $8c050ffba58637bd$var$s(e[r]);
        return t;
    }
    return e;
}, $8c050ffba58637bd$var$i = (e, t, r, i, p)=>{
    let u = $8c050ffba58637bd$var$s(e), d = $8c050ffba58637bd$var$c[u] || ($8c050ffba58637bd$var$c[u] = ((e)=>{
        let t = 0, r = 11;
        for(; t < e.length;)r = 101 * r + e.charCodeAt(t++) >>> 0;
        return "go" + r;
    })(u));
    if (!$8c050ffba58637bd$var$c[d]) {
        let t = u !== e ? e : ((e)=>{
            let t, r, o = [
                {}
            ];
            for(; t = $8c050ffba58637bd$var$l.exec(e.replace($8c050ffba58637bd$var$a, ""));)t[4] ? o.shift() : t[3] ? (r = t[3].replace($8c050ffba58637bd$var$n, " ").trim(), o.unshift(o[0][r] = o[0][r] || {})) : o[0][t[1]] = t[2].replace($8c050ffba58637bd$var$n, " ").trim();
            return o[0];
        })(e);
        $8c050ffba58637bd$var$c[d] = $8c050ffba58637bd$var$o(p ? {
            ["@keyframes " + d]: t
        } : t, r ? "" : "." + d);
    }
    let f = r && $8c050ffba58637bd$var$c.g ? $8c050ffba58637bd$var$c.g : null;
    return r && ($8c050ffba58637bd$var$c.g = $8c050ffba58637bd$var$c[d]), ((e, t, r, l)=>{
        l ? t.data = t.data.replace(l, e) : -1 === t.data.indexOf(e) && (t.data = r ? e + t.data : t.data + e);
    })($8c050ffba58637bd$var$c[d], t, i, f), d;
}, $8c050ffba58637bd$var$p = (e, t, r)=>e.reduce((e, l, a)=>{
        let n = t[a];
        if (n && n.call) {
            let e = n(r), t = e && e.props && e.props.className || /^go/.test(e) && e;
            n = t ? "." + t : e && "object" == typeof e ? e.props ? "" : $8c050ffba58637bd$var$o(e, "") : !1 === e ? "" : e;
        }
        return e + l + (null == n ? "" : n);
    }, "");
function $8c050ffba58637bd$export$dbf350e5966cf602(e) {
    let r = this || {}, l = e.call ? e(r.p) : e;
    return $8c050ffba58637bd$var$i(l.unshift ? l.raw ? $8c050ffba58637bd$var$p(l, [].slice.call(arguments, 1), r.p) : l.reduce((e, t)=>Object.assign(e, t && t.call ? t(r.p) : t), {}) : l, $8c050ffba58637bd$var$t(r.target), r.g, r.o, r.k);
}
let $8c050ffba58637bd$var$d, $8c050ffba58637bd$var$f, $8c050ffba58637bd$var$g, $8c050ffba58637bd$export$442f1a04865e4790 = $8c050ffba58637bd$export$dbf350e5966cf602.bind({
    g: 1
}), $8c050ffba58637bd$export$d25ddfdf17c3ad3e = $8c050ffba58637bd$export$dbf350e5966cf602.bind({
    k: 1
});
function $8c050ffba58637bd$export$de27182ff8187d6c(e, t, r, l) {
    $8c050ffba58637bd$var$o.p = t, $8c050ffba58637bd$var$d = e, $8c050ffba58637bd$var$f = r, $8c050ffba58637bd$var$g = l;
}
function $8c050ffba58637bd$export$3817b7a54a07cec7(e, t) {
    let r = this || {};
    return function() {
        let l = arguments;
        function a(n, o) {
            let c = Object.assign({}, n), s = c.className || a.className;
            r.p = Object.assign({
                theme: $8c050ffba58637bd$var$f && $8c050ffba58637bd$var$f()
            }, c), r.o = / *go\d+/.test(s), c.className = $8c050ffba58637bd$export$dbf350e5966cf602.apply(r, l) + (s ? " " + s : ""), t && (c.ref = o);
            let i = e;
            return e[0] && (i = c.as || e, delete c.as), $8c050ffba58637bd$var$g && i[0] && $8c050ffba58637bd$var$g(c), $8c050ffba58637bd$var$d(i, c);
        }
        return t ? t(a) : a;
    };
}


let $7fc8fcf516abead4$export$442f1a04865e4790 = (0, $8c050ffba58637bd$export$dbf350e5966cf602).bind({
    g: 1
});
function $7fc8fcf516abead4$export$44ca1bc323e2cb20() {
    const n = (0, $8c050ffba58637bd$export$3817b7a54a07cec7).call({
        g: 1
    }, "div").apply(null, arguments);
    return function(l) {
        return n(l), null;
    };
}






var $cWbtJ = parcelRequire("cWbtJ");


var $jPSn7 = parcelRequire("jPSn7");
const $8c53fefc62d3de5b$var$spinFrames = (0, $8c050ffba58637bd$export$d25ddfdf17c3ad3e)`
  from { transform: rotate(0deg); }
  to { transform: rotate(360deg); }
`;
const $8c53fefc62d3de5b$export$b5ef74bd35083b44 = (bp)=>`@media (${bp === "small" ? `max-width: 767px` : `min-width: 768px`})`;
const $8c53fefc62d3de5b$var$common = {
    radius: "3px",
    breakpoint: $8c53fefc62d3de5b$export$b5ef74bd35083b44,
    animation: {
        spin: `${$8c53fefc62d3de5b$var$spinFrames} linear 0.6s infinite`
    }
};
const $8c53fefc62d3de5b$var$light = {
    ...$8c53fefc62d3de5b$var$common,
    colors: {
        background: "#eee",
        darkerBackground: "rgba(221, 221, 221, 0.95)",
        contrast: "rgba(255,255,255,.4)",
        text: "#222",
        dimmed: "rgba(0,0,0,.6)",
        faint: "rgba(0,0,0,.4)",
        ghost: "rgba(0,0,0,.2)",
        primary: "#ff9e27",
        accent: "#4eaace",
        danger: "#ff4d4f"
    }
};
const $8c53fefc62d3de5b$var$dark = {
    ...$8c53fefc62d3de5b$var$common,
    colors: {
        background: "#57544e",
        darkerBackground: "rgba(60, 59, 59, 0.95)",
        contrast: "rgba(0,0,0,.4)",
        text: "#fff",
        dimmed: "rgba(255,255,255,.6)",
        faint: "rgba(255,255,255,.4)",
        ghost: "rgba(255,255,255,.2)",
        primary: "#ff9e27",
        accent: "#70deff",
        danger: "#c2292b"
    }
};
const $8c53fefc62d3de5b$export$2c657da244d00bd6 = /*#__PURE__*/ (0, $cWbtJ.createContext)((0, $jPSn7.defaultMode) === "dark" ? $8c53fefc62d3de5b$var$dark : $8c53fefc62d3de5b$var$light);
const $8c53fefc62d3de5b$export$93d4e7f90805808f = ()=>(0, $cWbtJ.useContext)($8c53fefc62d3de5b$export$2c657da244d00bd6);
const $8c53fefc62d3de5b$export$d8964aec282183a3 = ({ children: children })=>{
    const [mode] = (0, $jPSn7.useModeStore)();
    return /*#__PURE__*/ (0, $9e48c988ecb997e2$exports.jsx)($8c53fefc62d3de5b$export$2c657da244d00bd6.Provider, {
        value: mode === "dark" ? $8c53fefc62d3de5b$var$dark : $8c53fefc62d3de5b$var$light,
        children: children
    });
};
(0, $8c050ffba58637bd$export$de27182ff8187d6c)((0, (/*@__PURE__*/$parcel$interopDefault($cWbtJ))).createElement, undefined, $8c53fefc62d3de5b$export$93d4e7f90805808f);



var $cWbtJ = parcelRequire("cWbtJ");
var $b8a5f0ad122d1695$var$__accessCheck = (obj, member, msg)=>{
    if (!member.has(obj)) throw TypeError("Cannot " + msg);
};
var $b8a5f0ad122d1695$export$18a094aefa070634 = (obj, member, getter)=>{
    $b8a5f0ad122d1695$var$__accessCheck(obj, member, "read from private field");
    return getter ? getter.call(obj) : member.get(obj);
};
var $b8a5f0ad122d1695$export$addf369becd23283 = (obj, member, value1)=>{
    if (member.has(obj)) throw TypeError("Cannot add the same private member more than once");
    member instanceof WeakSet ? member.add(obj) : member.set(obj, value1);
};
var $b8a5f0ad122d1695$export$42432efe6614d3b4 = (obj, member, value1, setter)=>{
    $b8a5f0ad122d1695$var$__accessCheck(obj, member, "write to private field");
    setter ? setter.call(obj, value1) : member.set(obj, value1);
    return value1;
};
var $b8a5f0ad122d1695$export$b1fe7cbb4502036b = (obj, member, setter, getter)=>({
        set _ (value){
            $b8a5f0ad122d1695$export$42432efe6614d3b4(obj, member, value, setter);
        },
        get _ () {
            return $b8a5f0ad122d1695$export$18a094aefa070634(obj, member, getter);
        }
    });
var $b8a5f0ad122d1695$export$fa92d15b718fce20 = (obj, member, method)=>{
    $b8a5f0ad122d1695$var$__accessCheck(obj, member, "access private method");
    return method;
};



// src/utils.ts
var $aa7ba18d2eeda7da$export$6acf61af03e62db = typeof window === "undefined" || "Deno" in globalThis;
function $aa7ba18d2eeda7da$export$8793edee2d425525() {
    return void 0;
}
function $aa7ba18d2eeda7da$export$7f095f455ad5af3f(updater, input) {
    return typeof updater === "function" ? updater(input) : updater;
}
function $aa7ba18d2eeda7da$export$e539f754e934e270(value) {
    return typeof value === "number" && value >= 0 && value !== Infinity;
}
function $aa7ba18d2eeda7da$export$811b83d62bcf47f0(updatedAt, staleTime) {
    return Math.max(updatedAt + (staleTime || 0) - Date.now(), 0);
}
function $aa7ba18d2eeda7da$export$cb3145f011bda3ac(staleTime, query) {
    return typeof staleTime === "function" ? staleTime(query) : staleTime;
}
function $aa7ba18d2eeda7da$export$8c88ee6f2357230d(enabled, query) {
    return typeof enabled === "function" ? enabled(query) : enabled;
}
function $aa7ba18d2eeda7da$export$c5d1efe363797780(filters, query) {
    const { type: type = "all", exact: exact, fetchStatus: fetchStatus, predicate: predicate, queryKey: queryKey, stale: stale } = filters;
    if (queryKey) {
        if (exact) {
            if (query.queryHash !== $aa7ba18d2eeda7da$export$cc90ca97bc0d73fd(queryKey, query.options)) return false;
        } else if (!$aa7ba18d2eeda7da$export$2f07189bb9fa26a7(query.queryKey, queryKey)) return false;
    }
    if (type !== "all") {
        const isActive = query.isActive();
        if (type === "active" && !isActive) return false;
        if (type === "inactive" && isActive) return false;
    }
    if (typeof stale === "boolean" && query.isStale() !== stale) return false;
    if (fetchStatus && fetchStatus !== query.state.fetchStatus) return false;
    if (predicate && !predicate(query)) return false;
    return true;
}
function $aa7ba18d2eeda7da$export$a1ea5fb559f63ae3(filters, mutation) {
    const { exact: exact, status: status, predicate: predicate, mutationKey: mutationKey } = filters;
    if (mutationKey) {
        if (!mutation.options.mutationKey) return false;
        if (exact) {
            if ($aa7ba18d2eeda7da$export$1e87d19d4aab5805(mutation.options.mutationKey) !== $aa7ba18d2eeda7da$export$1e87d19d4aab5805(mutationKey)) return false;
        } else if (!$aa7ba18d2eeda7da$export$2f07189bb9fa26a7(mutation.options.mutationKey, mutationKey)) return false;
    }
    if (status && mutation.state.status !== status) return false;
    if (predicate && !predicate(mutation)) return false;
    return true;
}
function $aa7ba18d2eeda7da$export$cc90ca97bc0d73fd(queryKey, options) {
    const hashFn = (options == null ? void 0 : options.queryKeyHashFn) || $aa7ba18d2eeda7da$export$1e87d19d4aab5805;
    return hashFn(queryKey);
}
function $aa7ba18d2eeda7da$export$1e87d19d4aab5805(queryKey) {
    return JSON.stringify(queryKey, (_, val)=>$aa7ba18d2eeda7da$export$53b83ca8eaab0383(val) ? Object.keys(val).sort().reduce((result, key)=>{
            result[key] = val[key];
            return result;
        }, {}) : val);
}
function $aa7ba18d2eeda7da$export$2f07189bb9fa26a7(a, b) {
    if (a === b) return true;
    if (typeof a !== typeof b) return false;
    if (a && b && typeof a === "object" && typeof b === "object") return !Object.keys(b).some((key)=>!$aa7ba18d2eeda7da$export$2f07189bb9fa26a7(a[key], b[key]));
    return false;
}
function $aa7ba18d2eeda7da$export$77a71fc411098696(a, b) {
    if (a === b) return a;
    const array = $aa7ba18d2eeda7da$export$7a8558113332b71e(a) && $aa7ba18d2eeda7da$export$7a8558113332b71e(b);
    if (array || $aa7ba18d2eeda7da$export$53b83ca8eaab0383(a) && $aa7ba18d2eeda7da$export$53b83ca8eaab0383(b)) {
        const aItems = array ? a : Object.keys(a);
        const aSize = aItems.length;
        const bItems = array ? b : Object.keys(b);
        const bSize = bItems.length;
        const copy = array ? [] : {};
        let equalItems = 0;
        for(let i = 0; i < bSize; i++){
            const key = array ? i : bItems[i];
            if ((!array && aItems.includes(key) || array) && a[key] === void 0 && b[key] === void 0) {
                copy[key] = void 0;
                equalItems++;
            } else {
                copy[key] = $aa7ba18d2eeda7da$export$77a71fc411098696(a[key], b[key]);
                if (copy[key] === a[key] && a[key] !== void 0) equalItems++;
            }
        }
        return aSize === bSize && equalItems === aSize ? a : copy;
    }
    return b;
}
function $aa7ba18d2eeda7da$export$3e67810a3f0e9f1c(a, b) {
    if (!b || Object.keys(a).length !== Object.keys(b).length) return false;
    for(const key in a){
        if (a[key] !== b[key]) return false;
    }
    return true;
}
function $aa7ba18d2eeda7da$export$7a8558113332b71e(value) {
    return Array.isArray(value) && value.length === Object.keys(value).length;
}
function $aa7ba18d2eeda7da$export$53b83ca8eaab0383(o) {
    if (!$aa7ba18d2eeda7da$var$hasObjectPrototype(o)) return false;
    const ctor = o.constructor;
    if (ctor === void 0) return true;
    const prot = ctor.prototype;
    if (!$aa7ba18d2eeda7da$var$hasObjectPrototype(prot)) return false;
    if (!prot.hasOwnProperty("isPrototypeOf")) return false;
    if (Object.getPrototypeOf(o) !== Object.prototype) return false;
    return true;
}
function $aa7ba18d2eeda7da$var$hasObjectPrototype(o) {
    return Object.prototype.toString.call(o) === "[object Object]";
}
function $aa7ba18d2eeda7da$export$e772c8ff12451969(timeout) {
    return new Promise((resolve)=>{
        setTimeout(resolve, timeout);
    });
}
function $aa7ba18d2eeda7da$export$17619bac5b909b23(prevData, data, options) {
    if (typeof options.structuralSharing === "function") return options.structuralSharing(prevData, data);
    else if (options.structuralSharing !== false) {
        var error;
        return $aa7ba18d2eeda7da$export$77a71fc411098696(prevData, data);
    }
    return data;
}
function $aa7ba18d2eeda7da$export$f537417e7e421eac(previousData) {
    return previousData;
}
function $aa7ba18d2eeda7da$export$ccce65a22a26f2bc(items, item, max = 0) {
    const newItems = [
        ...items,
        item
    ];
    return max && newItems.length > max ? newItems.slice(1) : newItems;
}
function $aa7ba18d2eeda7da$export$8c6246b73dd61f4a(items, item, max = 0) {
    const newItems = [
        item,
        ...items
    ];
    return max && newItems.length > max ? newItems.slice(0, -1) : newItems;
}
var $aa7ba18d2eeda7da$export$1aa5a89531b7670d = Symbol();
function $aa7ba18d2eeda7da$export$c71c44209368a3bc(options, fetchOptions) {
    if (!options.queryFn && (fetchOptions == null ? void 0 : fetchOptions.initialPromise)) return ()=>fetchOptions.initialPromise;
    if (!options.queryFn || options.queryFn === $aa7ba18d2eeda7da$export$1aa5a89531b7670d) return ()=>Promise.reject(new Error(`Missing queryFn: '${options.queryHash}'`));
    return options.queryFn;
}







// src/notifyManager.ts
function $254c215b61de4d59$export$316a8efd03cd1458() {
    let queue = [];
    let transactions = 0;
    let notifyFn = (callback)=>{
        callback();
    };
    let batchNotifyFn = (callback)=>{
        callback();
    };
    let scheduleFn = (cb)=>setTimeout(cb, 0);
    const setScheduler = (fn)=>{
        scheduleFn = fn;
    };
    const batch = (callback)=>{
        let result;
        transactions++;
        try {
            result = callback();
        } finally{
            transactions--;
            if (!transactions) flush();
        }
        return result;
    };
    const schedule = (callback)=>{
        if (transactions) queue.push(callback);
        else scheduleFn(()=>{
            notifyFn(callback);
        });
    };
    const batchCalls = (callback)=>{
        return (...args)=>{
            schedule(()=>{
                callback(...args);
            });
        };
    };
    const flush = ()=>{
        const originalQueue = queue;
        queue = [];
        if (originalQueue.length) scheduleFn(()=>{
            batchNotifyFn(()=>{
                originalQueue.forEach((callback)=>{
                    notifyFn(callback);
                });
            });
        });
    };
    const setNotifyFunction = (fn)=>{
        notifyFn = fn;
    };
    const setBatchNotifyFunction = (fn)=>{
        batchNotifyFn = fn;
    };
    return {
        batch: batch,
        batchCalls: batchCalls,
        schedule: schedule,
        setNotifyFunction: setNotifyFunction,
        setBatchNotifyFunction: setBatchNotifyFunction,
        setScheduler: setScheduler
    };
}
var $254c215b61de4d59$export$520687f44db6e1ab = $254c215b61de4d59$export$316a8efd03cd1458();





// src/subscribable.ts
var $c0624571ef47c584$export$d26086b469ecdbcc = class {
    constructor(){
        this.listeners = /* @__PURE__ */ new Set();
        this.subscribe = this.subscribe.bind(this);
    }
    subscribe(listener) {
        this.listeners.add(listener);
        this.onSubscribe();
        return ()=>{
            this.listeners.delete(listener);
            this.onUnsubscribe();
        };
    }
    hasListeners() {
        return this.listeners.size > 0;
    }
    onSubscribe() {}
    onUnsubscribe() {}
};



var $941ede0c2ee4c5a4$var$_focused, $941ede0c2ee4c5a4$var$_cleanup, $941ede0c2ee4c5a4$var$_setup;
var $941ede0c2ee4c5a4$export$86f1af424b2ca4de = class extends (0, $c0624571ef47c584$export$d26086b469ecdbcc) {
    constructor(){
        super();
        (0, $b8a5f0ad122d1695$export$addf369becd23283)(this, $941ede0c2ee4c5a4$var$_focused, void 0);
        (0, $b8a5f0ad122d1695$export$addf369becd23283)(this, $941ede0c2ee4c5a4$var$_cleanup, void 0);
        (0, $b8a5f0ad122d1695$export$addf369becd23283)(this, $941ede0c2ee4c5a4$var$_setup, void 0);
        (0, $b8a5f0ad122d1695$export$42432efe6614d3b4)(this, $941ede0c2ee4c5a4$var$_setup, (onFocus)=>{
            if (!(0, $aa7ba18d2eeda7da$export$6acf61af03e62db) && window.addEventListener) {
                const listener = ()=>onFocus();
                window.addEventListener("visibilitychange", listener, false);
                return ()=>{
                    window.removeEventListener("visibilitychange", listener);
                };
            }
            return;
        });
    }
    onSubscribe() {
        if (!(0, $b8a5f0ad122d1695$export$18a094aefa070634)(this, $941ede0c2ee4c5a4$var$_cleanup)) this.setEventListener((0, $b8a5f0ad122d1695$export$18a094aefa070634)(this, $941ede0c2ee4c5a4$var$_setup));
    }
    onUnsubscribe() {
        var _a;
        if (!this.hasListeners()) {
            (_a = (0, $b8a5f0ad122d1695$export$18a094aefa070634)(this, $941ede0c2ee4c5a4$var$_cleanup)) == null || _a.call(this);
            (0, $b8a5f0ad122d1695$export$42432efe6614d3b4)(this, $941ede0c2ee4c5a4$var$_cleanup, void 0);
        }
    }
    setEventListener(setup) {
        var _a;
        (0, $b8a5f0ad122d1695$export$42432efe6614d3b4)(this, $941ede0c2ee4c5a4$var$_setup, setup);
        (_a = (0, $b8a5f0ad122d1695$export$18a094aefa070634)(this, $941ede0c2ee4c5a4$var$_cleanup)) == null || _a.call(this);
        (0, $b8a5f0ad122d1695$export$42432efe6614d3b4)(this, $941ede0c2ee4c5a4$var$_cleanup, setup((focused)=>{
            if (typeof focused === "boolean") this.setFocused(focused);
            else this.onFocus();
        }));
    }
    setFocused(focused) {
        const changed = (0, $b8a5f0ad122d1695$export$18a094aefa070634)(this, $941ede0c2ee4c5a4$var$_focused) !== focused;
        if (changed) {
            (0, $b8a5f0ad122d1695$export$42432efe6614d3b4)(this, $941ede0c2ee4c5a4$var$_focused, focused);
            this.onFocus();
        }
    }
    onFocus() {
        const isFocused = this.isFocused();
        this.listeners.forEach((listener)=>{
            listener(isFocused);
        });
    }
    isFocused() {
        var _a;
        if (typeof (0, $b8a5f0ad122d1695$export$18a094aefa070634)(this, $941ede0c2ee4c5a4$var$_focused) === "boolean") return (0, $b8a5f0ad122d1695$export$18a094aefa070634)(this, $941ede0c2ee4c5a4$var$_focused);
        return ((_a = globalThis.document) == null ? void 0 : _a.visibilityState) !== "hidden";
    }
};
$941ede0c2ee4c5a4$var$_focused = new WeakMap();
$941ede0c2ee4c5a4$var$_cleanup = new WeakMap();
$941ede0c2ee4c5a4$var$_setup = new WeakMap();
var $941ede0c2ee4c5a4$export$6bf54661be5b02cf = new $941ede0c2ee4c5a4$export$86f1af424b2ca4de();





var $51fd5b56382d0afc$var$_online, $51fd5b56382d0afc$var$_cleanup, $51fd5b56382d0afc$var$_setup;
var $51fd5b56382d0afc$export$58774fb55d5ff7fc = class extends (0, $c0624571ef47c584$export$d26086b469ecdbcc) {
    constructor(){
        super();
        (0, $b8a5f0ad122d1695$export$addf369becd23283)(this, $51fd5b56382d0afc$var$_online, true);
        (0, $b8a5f0ad122d1695$export$addf369becd23283)(this, $51fd5b56382d0afc$var$_cleanup, void 0);
        (0, $b8a5f0ad122d1695$export$addf369becd23283)(this, $51fd5b56382d0afc$var$_setup, void 0);
        (0, $b8a5f0ad122d1695$export$42432efe6614d3b4)(this, $51fd5b56382d0afc$var$_setup, (onOnline)=>{
            if (!(0, $aa7ba18d2eeda7da$export$6acf61af03e62db) && window.addEventListener) {
                const onlineListener = ()=>onOnline(true);
                const offlineListener = ()=>onOnline(false);
                window.addEventListener("online", onlineListener, false);
                window.addEventListener("offline", offlineListener, false);
                return ()=>{
                    window.removeEventListener("online", onlineListener);
                    window.removeEventListener("offline", offlineListener);
                };
            }
            return;
        });
    }
    onSubscribe() {
        if (!(0, $b8a5f0ad122d1695$export$18a094aefa070634)(this, $51fd5b56382d0afc$var$_cleanup)) this.setEventListener((0, $b8a5f0ad122d1695$export$18a094aefa070634)(this, $51fd5b56382d0afc$var$_setup));
    }
    onUnsubscribe() {
        var _a;
        if (!this.hasListeners()) {
            (_a = (0, $b8a5f0ad122d1695$export$18a094aefa070634)(this, $51fd5b56382d0afc$var$_cleanup)) == null || _a.call(this);
            (0, $b8a5f0ad122d1695$export$42432efe6614d3b4)(this, $51fd5b56382d0afc$var$_cleanup, void 0);
        }
    }
    setEventListener(setup) {
        var _a;
        (0, $b8a5f0ad122d1695$export$42432efe6614d3b4)(this, $51fd5b56382d0afc$var$_setup, setup);
        (_a = (0, $b8a5f0ad122d1695$export$18a094aefa070634)(this, $51fd5b56382d0afc$var$_cleanup)) == null || _a.call(this);
        (0, $b8a5f0ad122d1695$export$42432efe6614d3b4)(this, $51fd5b56382d0afc$var$_cleanup, setup(this.setOnline.bind(this)));
    }
    setOnline(online) {
        const changed = (0, $b8a5f0ad122d1695$export$18a094aefa070634)(this, $51fd5b56382d0afc$var$_online) !== online;
        if (changed) {
            (0, $b8a5f0ad122d1695$export$42432efe6614d3b4)(this, $51fd5b56382d0afc$var$_online, online);
            this.listeners.forEach((listener)=>{
                listener(online);
            });
        }
    }
    isOnline() {
        return (0, $b8a5f0ad122d1695$export$18a094aefa070634)(this, $51fd5b56382d0afc$var$_online);
    }
};
$51fd5b56382d0afc$var$_online = new WeakMap();
$51fd5b56382d0afc$var$_cleanup = new WeakMap();
$51fd5b56382d0afc$var$_setup = new WeakMap();
var $51fd5b56382d0afc$export$b113e788b2dd3fdc = new $51fd5b56382d0afc$export$58774fb55d5ff7fc();



function $53097cf0c56c3147$var$defaultRetryDelay(failureCount) {
    return Math.min(1e3 * 2 ** failureCount, 3e4);
}
function $53097cf0c56c3147$export$61b92f63f30245cf(networkMode) {
    return (networkMode ?? "online") === "online" ? (0, $51fd5b56382d0afc$export$b113e788b2dd3fdc).isOnline() : true;
}
var $53097cf0c56c3147$export$a8430ed4188f35a9 = class extends Error {
    constructor(options){
        super("CancelledError");
        this.revert = options == null ? void 0 : options.revert;
        this.silent = options == null ? void 0 : options.silent;
    }
};
function $53097cf0c56c3147$export$986cc6445c1d323(value) {
    return value instanceof $53097cf0c56c3147$export$a8430ed4188f35a9;
}
function $53097cf0c56c3147$export$2cbd00fe8a2c8d85(config) {
    let isRetryCancelled = false;
    let failureCount = 0;
    let isResolved = false;
    let continueFn;
    let promiseResolve;
    let promiseReject;
    const promise = new Promise((outerResolve, outerReject)=>{
        promiseResolve = outerResolve;
        promiseReject = outerReject;
    });
    const cancel = (cancelOptions)=>{
        var _a;
        if (!isResolved) {
            reject(new $53097cf0c56c3147$export$a8430ed4188f35a9(cancelOptions));
            (_a = config.abort) == null || _a.call(config);
        }
    };
    const cancelRetry = ()=>{
        isRetryCancelled = true;
    };
    const continueRetry = ()=>{
        isRetryCancelled = false;
    };
    const canContinue = ()=>(0, $941ede0c2ee4c5a4$export$6bf54661be5b02cf).isFocused() && (config.networkMode === "always" || (0, $51fd5b56382d0afc$export$b113e788b2dd3fdc).isOnline()) && config.canRun();
    const canStart = ()=>$53097cf0c56c3147$export$61b92f63f30245cf(config.networkMode) && config.canRun();
    const resolve = (value)=>{
        var _a;
        if (!isResolved) {
            isResolved = true;
            (_a = config.onSuccess) == null || _a.call(config, value);
            continueFn == null || continueFn();
            promiseResolve(value);
        }
    };
    const reject = (value)=>{
        var _a;
        if (!isResolved) {
            isResolved = true;
            (_a = config.onError) == null || _a.call(config, value);
            continueFn == null || continueFn();
            promiseReject(value);
        }
    };
    const pause = ()=>{
        return new Promise((continueResolve)=>{
            var _a;
            continueFn = (value)=>{
                if (isResolved || canContinue()) continueResolve(value);
            };
            (_a = config.onPause) == null || _a.call(config);
        }).then(()=>{
            var _a;
            continueFn = void 0;
            if (!isResolved) (_a = config.onContinue) == null || _a.call(config);
        });
    };
    const run = ()=>{
        if (isResolved) return;
        let promiseOrValue;
        const initialPromise = failureCount === 0 ? config.initialPromise : void 0;
        try {
            promiseOrValue = initialPromise ?? config.fn();
        } catch (error) {
            promiseOrValue = Promise.reject(error);
        }
        Promise.resolve(promiseOrValue).then(resolve).catch((error)=>{
            var _a;
            if (isResolved) return;
            const retry = config.retry ?? ((0, $aa7ba18d2eeda7da$export$6acf61af03e62db) ? 0 : 3);
            const retryDelay = config.retryDelay ?? $53097cf0c56c3147$var$defaultRetryDelay;
            const delay = typeof retryDelay === "function" ? retryDelay(failureCount, error) : retryDelay;
            const shouldRetry = retry === true || typeof retry === "number" && failureCount < retry || typeof retry === "function" && retry(failureCount, error);
            if (isRetryCancelled || !shouldRetry) {
                reject(error);
                return;
            }
            failureCount++;
            (_a = config.onFail) == null || _a.call(config, failureCount, error);
            (0, $aa7ba18d2eeda7da$export$e772c8ff12451969)(delay).then(()=>{
                return canContinue() ? void 0 : pause();
            }).then(()=>{
                if (isRetryCancelled) reject(error);
                else run();
            });
        });
    };
    return {
        promise: promise,
        cancel: cancel,
        continue: ()=>{
            continueFn == null || continueFn();
            return promise;
        },
        cancelRetry: cancelRetry,
        continueRetry: continueRetry,
        canStart: canStart,
        start: ()=>{
            if (canStart()) run();
            else pause().then(run);
            return promise;
        }
    };
}




var $45ae8e0d3b3a1fd0$var$_gcTimeout;
var $45ae8e0d3b3a1fd0$export$e09608847fcc8c59 = class {
    constructor(){
        (0, $b8a5f0ad122d1695$export$addf369becd23283)(this, $45ae8e0d3b3a1fd0$var$_gcTimeout, void 0);
    }
    destroy() {
        this.clearGcTimeout();
    }
    scheduleGc() {
        this.clearGcTimeout();
        if ((0, $aa7ba18d2eeda7da$export$e539f754e934e270)(this.gcTime)) (0, $b8a5f0ad122d1695$export$42432efe6614d3b4)(this, $45ae8e0d3b3a1fd0$var$_gcTimeout, setTimeout(()=>{
            this.optionalRemove();
        }, this.gcTime));
    }
    updateGcTime(newGcTime) {
        this.gcTime = Math.max(this.gcTime || 0, newGcTime ?? ((0, $aa7ba18d2eeda7da$export$6acf61af03e62db) ? Infinity : 300000));
    }
    clearGcTimeout() {
        if ((0, $b8a5f0ad122d1695$export$18a094aefa070634)(this, $45ae8e0d3b3a1fd0$var$_gcTimeout)) {
            clearTimeout((0, $b8a5f0ad122d1695$export$18a094aefa070634)(this, $45ae8e0d3b3a1fd0$var$_gcTimeout));
            (0, $b8a5f0ad122d1695$export$42432efe6614d3b4)(this, $45ae8e0d3b3a1fd0$var$_gcTimeout, void 0);
        }
    }
};
$45ae8e0d3b3a1fd0$var$_gcTimeout = new WeakMap();


var $93c68f86d0b6a255$var$_initialState, $93c68f86d0b6a255$var$_revertState, $93c68f86d0b6a255$var$_cache, $93c68f86d0b6a255$var$_retryer, $93c68f86d0b6a255$var$_defaultOptions, $93c68f86d0b6a255$var$_abortSignalConsumed, $93c68f86d0b6a255$var$_dispatch, $93c68f86d0b6a255$var$dispatch_fn;
var $93c68f86d0b6a255$export$62297b13309008b2 = class extends (0, $45ae8e0d3b3a1fd0$export$e09608847fcc8c59) {
    constructor(config){
        super();
        (0, $b8a5f0ad122d1695$export$addf369becd23283)(this, $93c68f86d0b6a255$var$_dispatch);
        (0, $b8a5f0ad122d1695$export$addf369becd23283)(this, $93c68f86d0b6a255$var$_initialState, void 0);
        (0, $b8a5f0ad122d1695$export$addf369becd23283)(this, $93c68f86d0b6a255$var$_revertState, void 0);
        (0, $b8a5f0ad122d1695$export$addf369becd23283)(this, $93c68f86d0b6a255$var$_cache, void 0);
        (0, $b8a5f0ad122d1695$export$addf369becd23283)(this, $93c68f86d0b6a255$var$_retryer, void 0);
        (0, $b8a5f0ad122d1695$export$addf369becd23283)(this, $93c68f86d0b6a255$var$_defaultOptions, void 0);
        (0, $b8a5f0ad122d1695$export$addf369becd23283)(this, $93c68f86d0b6a255$var$_abortSignalConsumed, void 0);
        (0, $b8a5f0ad122d1695$export$42432efe6614d3b4)(this, $93c68f86d0b6a255$var$_abortSignalConsumed, false);
        (0, $b8a5f0ad122d1695$export$42432efe6614d3b4)(this, $93c68f86d0b6a255$var$_defaultOptions, config.defaultOptions);
        this.setOptions(config.options);
        this.observers = [];
        (0, $b8a5f0ad122d1695$export$42432efe6614d3b4)(this, $93c68f86d0b6a255$var$_cache, config.cache);
        this.queryKey = config.queryKey;
        this.queryHash = config.queryHash;
        (0, $b8a5f0ad122d1695$export$42432efe6614d3b4)(this, $93c68f86d0b6a255$var$_initialState, $93c68f86d0b6a255$var$getDefaultState(this.options));
        this.state = config.state ?? (0, $b8a5f0ad122d1695$export$18a094aefa070634)(this, $93c68f86d0b6a255$var$_initialState);
        this.scheduleGc();
    }
    get meta() {
        return this.options.meta;
    }
    get promise() {
        var _a;
        return (_a = (0, $b8a5f0ad122d1695$export$18a094aefa070634)(this, $93c68f86d0b6a255$var$_retryer)) == null ? void 0 : _a.promise;
    }
    setOptions(options) {
        this.options = {
            ...(0, $b8a5f0ad122d1695$export$18a094aefa070634)(this, $93c68f86d0b6a255$var$_defaultOptions),
            ...options
        };
        this.updateGcTime(this.options.gcTime);
    }
    optionalRemove() {
        if (!this.observers.length && this.state.fetchStatus === "idle") (0, $b8a5f0ad122d1695$export$18a094aefa070634)(this, $93c68f86d0b6a255$var$_cache).remove(this);
    }
    setData(newData, options) {
        const data = (0, $aa7ba18d2eeda7da$export$17619bac5b909b23)(this.state.data, newData, this.options);
        (0, $b8a5f0ad122d1695$export$fa92d15b718fce20)(this, $93c68f86d0b6a255$var$_dispatch, $93c68f86d0b6a255$var$dispatch_fn).call(this, {
            data: data,
            type: "success",
            dataUpdatedAt: options == null ? void 0 : options.updatedAt,
            manual: options == null ? void 0 : options.manual
        });
        return data;
    }
    setState(state, setStateOptions) {
        (0, $b8a5f0ad122d1695$export$fa92d15b718fce20)(this, $93c68f86d0b6a255$var$_dispatch, $93c68f86d0b6a255$var$dispatch_fn).call(this, {
            type: "setState",
            state: state,
            setStateOptions: setStateOptions
        });
    }
    cancel(options) {
        var _a, _b;
        const promise = (_a = (0, $b8a5f0ad122d1695$export$18a094aefa070634)(this, $93c68f86d0b6a255$var$_retryer)) == null ? void 0 : _a.promise;
        (_b = (0, $b8a5f0ad122d1695$export$18a094aefa070634)(this, $93c68f86d0b6a255$var$_retryer)) == null || _b.cancel(options);
        return promise ? promise.then((0, $aa7ba18d2eeda7da$export$8793edee2d425525)).catch((0, $aa7ba18d2eeda7da$export$8793edee2d425525)) : Promise.resolve();
    }
    destroy() {
        super.destroy();
        this.cancel({
            silent: true
        });
    }
    reset() {
        this.destroy();
        this.setState((0, $b8a5f0ad122d1695$export$18a094aefa070634)(this, $93c68f86d0b6a255$var$_initialState));
    }
    isActive() {
        return this.observers.some((observer)=>(0, $aa7ba18d2eeda7da$export$8c88ee6f2357230d)(observer.options.enabled, this) !== false);
    }
    isDisabled() {
        return this.getObserversCount() > 0 && !this.isActive();
    }
    isStale() {
        if (this.state.isInvalidated) return true;
        if (this.getObserversCount() > 0) return this.observers.some((observer)=>observer.getCurrentResult().isStale);
        return this.state.data === void 0;
    }
    isStaleByTime(staleTime = 0) {
        return this.state.isInvalidated || this.state.data === void 0 || !(0, $aa7ba18d2eeda7da$export$811b83d62bcf47f0)(this.state.dataUpdatedAt, staleTime);
    }
    onFocus() {
        var _a;
        const observer = this.observers.find((x)=>x.shouldFetchOnWindowFocus());
        observer == null || observer.refetch({
            cancelRefetch: false
        });
        (_a = (0, $b8a5f0ad122d1695$export$18a094aefa070634)(this, $93c68f86d0b6a255$var$_retryer)) == null || _a.continue();
    }
    onOnline() {
        var _a;
        const observer = this.observers.find((x)=>x.shouldFetchOnReconnect());
        observer == null || observer.refetch({
            cancelRefetch: false
        });
        (_a = (0, $b8a5f0ad122d1695$export$18a094aefa070634)(this, $93c68f86d0b6a255$var$_retryer)) == null || _a.continue();
    }
    addObserver(observer) {
        if (!this.observers.includes(observer)) {
            this.observers.push(observer);
            this.clearGcTimeout();
            (0, $b8a5f0ad122d1695$export$18a094aefa070634)(this, $93c68f86d0b6a255$var$_cache).notify({
                type: "observerAdded",
                query: this,
                observer: observer
            });
        }
    }
    removeObserver(observer) {
        if (this.observers.includes(observer)) {
            this.observers = this.observers.filter((x)=>x !== observer);
            if (!this.observers.length) {
                if ((0, $b8a5f0ad122d1695$export$18a094aefa070634)(this, $93c68f86d0b6a255$var$_retryer)) {
                    if ((0, $b8a5f0ad122d1695$export$18a094aefa070634)(this, $93c68f86d0b6a255$var$_abortSignalConsumed)) (0, $b8a5f0ad122d1695$export$18a094aefa070634)(this, $93c68f86d0b6a255$var$_retryer).cancel({
                        revert: true
                    });
                    else (0, $b8a5f0ad122d1695$export$18a094aefa070634)(this, $93c68f86d0b6a255$var$_retryer).cancelRetry();
                }
                this.scheduleGc();
            }
            (0, $b8a5f0ad122d1695$export$18a094aefa070634)(this, $93c68f86d0b6a255$var$_cache).notify({
                type: "observerRemoved",
                query: this,
                observer: observer
            });
        }
    }
    getObserversCount() {
        return this.observers.length;
    }
    invalidate() {
        if (!this.state.isInvalidated) (0, $b8a5f0ad122d1695$export$fa92d15b718fce20)(this, $93c68f86d0b6a255$var$_dispatch, $93c68f86d0b6a255$var$dispatch_fn).call(this, {
            type: "invalidate"
        });
    }
    fetch(options, fetchOptions) {
        var _a, _b, _c;
        if (this.state.fetchStatus !== "idle") {
            if (this.state.data !== void 0 && (fetchOptions == null ? void 0 : fetchOptions.cancelRefetch)) this.cancel({
                silent: true
            });
            else if ((0, $b8a5f0ad122d1695$export$18a094aefa070634)(this, $93c68f86d0b6a255$var$_retryer)) {
                (0, $b8a5f0ad122d1695$export$18a094aefa070634)(this, $93c68f86d0b6a255$var$_retryer).continueRetry();
                return (0, $b8a5f0ad122d1695$export$18a094aefa070634)(this, $93c68f86d0b6a255$var$_retryer).promise;
            }
        }
        if (options) this.setOptions(options);
        if (!this.options.queryFn) {
            const observer = this.observers.find((x)=>x.options.queryFn);
            if (observer) this.setOptions(observer.options);
        }
        const abortController = new AbortController();
        const addSignalProperty = (object)=>{
            Object.defineProperty(object, "signal", {
                enumerable: true,
                get: ()=>{
                    (0, $b8a5f0ad122d1695$export$42432efe6614d3b4)(this, $93c68f86d0b6a255$var$_abortSignalConsumed, true);
                    return abortController.signal;
                }
            });
        };
        const fetchFn = ()=>{
            const queryFn = (0, $aa7ba18d2eeda7da$export$c71c44209368a3bc)(this.options, fetchOptions);
            const queryFnContext = {
                queryKey: this.queryKey,
                meta: this.meta
            };
            addSignalProperty(queryFnContext);
            (0, $b8a5f0ad122d1695$export$42432efe6614d3b4)(this, $93c68f86d0b6a255$var$_abortSignalConsumed, false);
            if (this.options.persister) return this.options.persister(queryFn, queryFnContext, this);
            return queryFn(queryFnContext);
        };
        const context = {
            fetchOptions: fetchOptions,
            options: this.options,
            queryKey: this.queryKey,
            state: this.state,
            fetchFn: fetchFn
        };
        addSignalProperty(context);
        (_a = this.options.behavior) == null || _a.onFetch(context, this);
        (0, $b8a5f0ad122d1695$export$42432efe6614d3b4)(this, $93c68f86d0b6a255$var$_revertState, this.state);
        if (this.state.fetchStatus === "idle" || this.state.fetchMeta !== ((_b = context.fetchOptions) == null ? void 0 : _b.meta)) (0, $b8a5f0ad122d1695$export$fa92d15b718fce20)(this, $93c68f86d0b6a255$var$_dispatch, $93c68f86d0b6a255$var$dispatch_fn).call(this, {
            type: "fetch",
            meta: (_c = context.fetchOptions) == null ? void 0 : _c.meta
        });
        const onError = (error)=>{
            var _a2, _b2, _c2, _d;
            if (!((0, $53097cf0c56c3147$export$986cc6445c1d323)(error) && error.silent)) (0, $b8a5f0ad122d1695$export$fa92d15b718fce20)(this, $93c68f86d0b6a255$var$_dispatch, $93c68f86d0b6a255$var$dispatch_fn).call(this, {
                type: "error",
                error: error
            });
            if (!(0, $53097cf0c56c3147$export$986cc6445c1d323)(error)) {
                (_b2 = (_a2 = (0, $b8a5f0ad122d1695$export$18a094aefa070634)(this, $93c68f86d0b6a255$var$_cache).config).onError) == null || _b2.call(_a2, error, this);
                (_d = (_c2 = (0, $b8a5f0ad122d1695$export$18a094aefa070634)(this, $93c68f86d0b6a255$var$_cache).config).onSettled) == null || _d.call(_c2, this.state.data, error, this);
            }
            if (!this.isFetchingOptimistic) this.scheduleGc();
            this.isFetchingOptimistic = false;
        };
        (0, $b8a5f0ad122d1695$export$42432efe6614d3b4)(this, $93c68f86d0b6a255$var$_retryer, (0, $53097cf0c56c3147$export$2cbd00fe8a2c8d85)({
            initialPromise: fetchOptions == null ? void 0 : fetchOptions.initialPromise,
            fn: context.fetchFn,
            abort: abortController.abort.bind(abortController),
            onSuccess: (data)=>{
                var _a2, _b2, _c2, _d;
                if (data === void 0) {
                    onError(new Error(`${this.queryHash} data is undefined`));
                    return;
                }
                try {
                    this.setData(data);
                } catch (error) {
                    onError(error);
                    return;
                }
                (_b2 = (_a2 = (0, $b8a5f0ad122d1695$export$18a094aefa070634)(this, $93c68f86d0b6a255$var$_cache).config).onSuccess) == null || _b2.call(_a2, data, this);
                (_d = (_c2 = (0, $b8a5f0ad122d1695$export$18a094aefa070634)(this, $93c68f86d0b6a255$var$_cache).config).onSettled) == null || _d.call(_c2, data, this.state.error, this);
                if (!this.isFetchingOptimistic) this.scheduleGc();
                this.isFetchingOptimistic = false;
            },
            onError: onError,
            onFail: (failureCount, error)=>{
                (0, $b8a5f0ad122d1695$export$fa92d15b718fce20)(this, $93c68f86d0b6a255$var$_dispatch, $93c68f86d0b6a255$var$dispatch_fn).call(this, {
                    type: "failed",
                    failureCount: failureCount,
                    error: error
                });
            },
            onPause: ()=>{
                (0, $b8a5f0ad122d1695$export$fa92d15b718fce20)(this, $93c68f86d0b6a255$var$_dispatch, $93c68f86d0b6a255$var$dispatch_fn).call(this, {
                    type: "pause"
                });
            },
            onContinue: ()=>{
                (0, $b8a5f0ad122d1695$export$fa92d15b718fce20)(this, $93c68f86d0b6a255$var$_dispatch, $93c68f86d0b6a255$var$dispatch_fn).call(this, {
                    type: "continue"
                });
            },
            retry: context.options.retry,
            retryDelay: context.options.retryDelay,
            networkMode: context.options.networkMode,
            canRun: ()=>true
        }));
        return (0, $b8a5f0ad122d1695$export$18a094aefa070634)(this, $93c68f86d0b6a255$var$_retryer).start();
    }
};
$93c68f86d0b6a255$var$_initialState = new WeakMap();
$93c68f86d0b6a255$var$_revertState = new WeakMap();
$93c68f86d0b6a255$var$_cache = new WeakMap();
$93c68f86d0b6a255$var$_retryer = new WeakMap();
$93c68f86d0b6a255$var$_defaultOptions = new WeakMap();
$93c68f86d0b6a255$var$_abortSignalConsumed = new WeakMap();
$93c68f86d0b6a255$var$_dispatch = new WeakSet();
$93c68f86d0b6a255$var$dispatch_fn = function(action) {
    const reducer = (state)=>{
        switch(action.type){
            case "failed":
                return {
                    ...state,
                    fetchFailureCount: action.failureCount,
                    fetchFailureReason: action.error
                };
            case "pause":
                return {
                    ...state,
                    fetchStatus: "paused"
                };
            case "continue":
                return {
                    ...state,
                    fetchStatus: "fetching"
                };
            case "fetch":
                return {
                    ...state,
                    ...$93c68f86d0b6a255$export$f3df9013f2b58bce(state.data, this.options),
                    fetchMeta: action.meta ?? null
                };
            case "success":
                return {
                    ...state,
                    data: action.data,
                    dataUpdateCount: state.dataUpdateCount + 1,
                    dataUpdatedAt: action.dataUpdatedAt ?? Date.now(),
                    error: null,
                    isInvalidated: false,
                    status: "success",
                    ...!action.manual && {
                        fetchStatus: "idle",
                        fetchFailureCount: 0,
                        fetchFailureReason: null
                    }
                };
            case "error":
                const error = action.error;
                if ((0, $53097cf0c56c3147$export$986cc6445c1d323)(error) && error.revert && (0, $b8a5f0ad122d1695$export$18a094aefa070634)(this, $93c68f86d0b6a255$var$_revertState)) return {
                    ...(0, $b8a5f0ad122d1695$export$18a094aefa070634)(this, $93c68f86d0b6a255$var$_revertState),
                    fetchStatus: "idle"
                };
                return {
                    ...state,
                    error: error,
                    errorUpdateCount: state.errorUpdateCount + 1,
                    errorUpdatedAt: Date.now(),
                    fetchFailureCount: state.fetchFailureCount + 1,
                    fetchFailureReason: error,
                    fetchStatus: "idle",
                    status: "error"
                };
            case "invalidate":
                return {
                    ...state,
                    isInvalidated: true
                };
            case "setState":
                return {
                    ...state,
                    ...action.state
                };
        }
    };
    this.state = reducer(this.state);
    (0, $254c215b61de4d59$export$520687f44db6e1ab).batch(()=>{
        this.observers.forEach((observer)=>{
            observer.onQueryUpdate();
        });
        (0, $b8a5f0ad122d1695$export$18a094aefa070634)(this, $93c68f86d0b6a255$var$_cache).notify({
            query: this,
            type: "updated",
            action: action
        });
    });
};
function $93c68f86d0b6a255$export$f3df9013f2b58bce(data, options) {
    return {
        fetchFailureCount: 0,
        fetchFailureReason: null,
        fetchStatus: (0, $53097cf0c56c3147$export$61b92f63f30245cf)(options.networkMode) ? "fetching" : "paused",
        ...data === void 0 && {
            error: null,
            status: "pending"
        }
    };
}
function $93c68f86d0b6a255$var$getDefaultState(options) {
    const data = typeof options.initialData === "function" ? options.initialData() : options.initialData;
    const hasData = data !== void 0;
    const initialDataUpdatedAt = hasData ? typeof options.initialDataUpdatedAt === "function" ? options.initialDataUpdatedAt() : options.initialDataUpdatedAt : 0;
    return {
        data: data,
        dataUpdateCount: 0,
        dataUpdatedAt: hasData ? initialDataUpdatedAt ?? Date.now() : 0,
        error: null,
        errorUpdateCount: 0,
        errorUpdatedAt: 0,
        fetchFailureCount: 0,
        fetchFailureReason: null,
        fetchMeta: null,
        isInvalidated: false,
        status: hasData ? "success" : "pending",
        fetchStatus: "idle"
    };
}




var $48b5bdec429016ca$var$_queries;
var $48b5bdec429016ca$export$5dde0cd941da8468 = class extends (0, $c0624571ef47c584$export$d26086b469ecdbcc) {
    constructor(config = {}){
        super();
        this.config = config;
        (0, $b8a5f0ad122d1695$export$addf369becd23283)(this, $48b5bdec429016ca$var$_queries, void 0);
        (0, $b8a5f0ad122d1695$export$42432efe6614d3b4)(this, $48b5bdec429016ca$var$_queries, /* @__PURE__ */ new Map());
    }
    build(client, options, state) {
        const queryKey = options.queryKey;
        const queryHash = options.queryHash ?? (0, $aa7ba18d2eeda7da$export$cc90ca97bc0d73fd)(queryKey, options);
        let query = this.get(queryHash);
        if (!query) {
            query = new (0, $93c68f86d0b6a255$export$62297b13309008b2)({
                cache: this,
                queryKey: queryKey,
                queryHash: queryHash,
                options: client.defaultQueryOptions(options),
                state: state,
                defaultOptions: client.getQueryDefaults(queryKey)
            });
            this.add(query);
        }
        return query;
    }
    add(query) {
        if (!(0, $b8a5f0ad122d1695$export$18a094aefa070634)(this, $48b5bdec429016ca$var$_queries).has(query.queryHash)) {
            (0, $b8a5f0ad122d1695$export$18a094aefa070634)(this, $48b5bdec429016ca$var$_queries).set(query.queryHash, query);
            this.notify({
                type: "added",
                query: query
            });
        }
    }
    remove(query) {
        const queryInMap = (0, $b8a5f0ad122d1695$export$18a094aefa070634)(this, $48b5bdec429016ca$var$_queries).get(query.queryHash);
        if (queryInMap) {
            query.destroy();
            if (queryInMap === query) (0, $b8a5f0ad122d1695$export$18a094aefa070634)(this, $48b5bdec429016ca$var$_queries).delete(query.queryHash);
            this.notify({
                type: "removed",
                query: query
            });
        }
    }
    clear() {
        (0, $254c215b61de4d59$export$520687f44db6e1ab).batch(()=>{
            this.getAll().forEach((query)=>{
                this.remove(query);
            });
        });
    }
    get(queryHash) {
        return (0, $b8a5f0ad122d1695$export$18a094aefa070634)(this, $48b5bdec429016ca$var$_queries).get(queryHash);
    }
    getAll() {
        return [
            ...(0, $b8a5f0ad122d1695$export$18a094aefa070634)(this, $48b5bdec429016ca$var$_queries).values()
        ];
    }
    find(filters) {
        const defaultedFilters = {
            exact: true,
            ...filters
        };
        return this.getAll().find((query)=>(0, $aa7ba18d2eeda7da$export$c5d1efe363797780)(defaultedFilters, query));
    }
    findAll(filters = {}) {
        const queries = this.getAll();
        return Object.keys(filters).length > 0 ? queries.filter((query)=>(0, $aa7ba18d2eeda7da$export$c5d1efe363797780)(filters, query)) : queries;
    }
    notify(event) {
        (0, $254c215b61de4d59$export$520687f44db6e1ab).batch(()=>{
            this.listeners.forEach((listener)=>{
                listener(event);
            });
        });
    }
    onFocus() {
        (0, $254c215b61de4d59$export$520687f44db6e1ab).batch(()=>{
            this.getAll().forEach((query)=>{
                query.onFocus();
            });
        });
    }
    onOnline() {
        (0, $254c215b61de4d59$export$520687f44db6e1ab).batch(()=>{
            this.getAll().forEach((query)=>{
                query.onOnline();
            });
        });
    }
};
$48b5bdec429016ca$var$_queries = new WeakMap();








var $90e2579c8dcb4e2d$var$_observers, $90e2579c8dcb4e2d$var$_mutationCache, $90e2579c8dcb4e2d$var$_retryer, $90e2579c8dcb4e2d$var$_dispatch, $90e2579c8dcb4e2d$var$dispatch_fn;
var $90e2579c8dcb4e2d$export$17b8b19c814bcf56 = class extends (0, $45ae8e0d3b3a1fd0$export$e09608847fcc8c59) {
    constructor(config){
        super();
        (0, $b8a5f0ad122d1695$export$addf369becd23283)(this, $90e2579c8dcb4e2d$var$_dispatch);
        (0, $b8a5f0ad122d1695$export$addf369becd23283)(this, $90e2579c8dcb4e2d$var$_observers, void 0);
        (0, $b8a5f0ad122d1695$export$addf369becd23283)(this, $90e2579c8dcb4e2d$var$_mutationCache, void 0);
        (0, $b8a5f0ad122d1695$export$addf369becd23283)(this, $90e2579c8dcb4e2d$var$_retryer, void 0);
        this.mutationId = config.mutationId;
        (0, $b8a5f0ad122d1695$export$42432efe6614d3b4)(this, $90e2579c8dcb4e2d$var$_mutationCache, config.mutationCache);
        (0, $b8a5f0ad122d1695$export$42432efe6614d3b4)(this, $90e2579c8dcb4e2d$var$_observers, []);
        this.state = config.state || $90e2579c8dcb4e2d$export$a1659b54bac3252a();
        this.setOptions(config.options);
        this.scheduleGc();
    }
    setOptions(options) {
        this.options = options;
        this.updateGcTime(this.options.gcTime);
    }
    get meta() {
        return this.options.meta;
    }
    addObserver(observer) {
        if (!(0, $b8a5f0ad122d1695$export$18a094aefa070634)(this, $90e2579c8dcb4e2d$var$_observers).includes(observer)) {
            (0, $b8a5f0ad122d1695$export$18a094aefa070634)(this, $90e2579c8dcb4e2d$var$_observers).push(observer);
            this.clearGcTimeout();
            (0, $b8a5f0ad122d1695$export$18a094aefa070634)(this, $90e2579c8dcb4e2d$var$_mutationCache).notify({
                type: "observerAdded",
                mutation: this,
                observer: observer
            });
        }
    }
    removeObserver(observer) {
        (0, $b8a5f0ad122d1695$export$42432efe6614d3b4)(this, $90e2579c8dcb4e2d$var$_observers, (0, $b8a5f0ad122d1695$export$18a094aefa070634)(this, $90e2579c8dcb4e2d$var$_observers).filter((x)=>x !== observer));
        this.scheduleGc();
        (0, $b8a5f0ad122d1695$export$18a094aefa070634)(this, $90e2579c8dcb4e2d$var$_mutationCache).notify({
            type: "observerRemoved",
            mutation: this,
            observer: observer
        });
    }
    optionalRemove() {
        if (!(0, $b8a5f0ad122d1695$export$18a094aefa070634)(this, $90e2579c8dcb4e2d$var$_observers).length) {
            if (this.state.status === "pending") this.scheduleGc();
            else (0, $b8a5f0ad122d1695$export$18a094aefa070634)(this, $90e2579c8dcb4e2d$var$_mutationCache).remove(this);
        }
    }
    continue() {
        var _a;
        return ((_a = (0, $b8a5f0ad122d1695$export$18a094aefa070634)(this, $90e2579c8dcb4e2d$var$_retryer)) == null ? void 0 : _a.continue()) ?? // continuing a mutation assumes that variables are set, mutation must have been dehydrated before
        this.execute(this.state.variables);
    }
    async execute(variables) {
        var _a, _b, _c, _d, _e, _f, _g, _h, _i, _j, _k, _l, _m, _n, _o, _p, _q, _r, _s, _t;
        (0, $b8a5f0ad122d1695$export$42432efe6614d3b4)(this, $90e2579c8dcb4e2d$var$_retryer, (0, $53097cf0c56c3147$export$2cbd00fe8a2c8d85)({
            fn: ()=>{
                if (!this.options.mutationFn) return Promise.reject(new Error("No mutationFn found"));
                return this.options.mutationFn(variables);
            },
            onFail: (failureCount, error)=>{
                (0, $b8a5f0ad122d1695$export$fa92d15b718fce20)(this, $90e2579c8dcb4e2d$var$_dispatch, $90e2579c8dcb4e2d$var$dispatch_fn).call(this, {
                    type: "failed",
                    failureCount: failureCount,
                    error: error
                });
            },
            onPause: ()=>{
                (0, $b8a5f0ad122d1695$export$fa92d15b718fce20)(this, $90e2579c8dcb4e2d$var$_dispatch, $90e2579c8dcb4e2d$var$dispatch_fn).call(this, {
                    type: "pause"
                });
            },
            onContinue: ()=>{
                (0, $b8a5f0ad122d1695$export$fa92d15b718fce20)(this, $90e2579c8dcb4e2d$var$_dispatch, $90e2579c8dcb4e2d$var$dispatch_fn).call(this, {
                    type: "continue"
                });
            },
            retry: this.options.retry ?? 0,
            retryDelay: this.options.retryDelay,
            networkMode: this.options.networkMode,
            canRun: ()=>(0, $b8a5f0ad122d1695$export$18a094aefa070634)(this, $90e2579c8dcb4e2d$var$_mutationCache).canRun(this)
        }));
        const restored = this.state.status === "pending";
        const isPaused = !(0, $b8a5f0ad122d1695$export$18a094aefa070634)(this, $90e2579c8dcb4e2d$var$_retryer).canStart();
        try {
            if (!restored) {
                (0, $b8a5f0ad122d1695$export$fa92d15b718fce20)(this, $90e2579c8dcb4e2d$var$_dispatch, $90e2579c8dcb4e2d$var$dispatch_fn).call(this, {
                    type: "pending",
                    variables: variables,
                    isPaused: isPaused
                });
                await ((_b = (_a = (0, $b8a5f0ad122d1695$export$18a094aefa070634)(this, $90e2579c8dcb4e2d$var$_mutationCache).config).onMutate) == null ? void 0 : _b.call(_a, variables, this));
                const context = await ((_d = (_c = this.options).onMutate) == null ? void 0 : _d.call(_c, variables));
                if (context !== this.state.context) (0, $b8a5f0ad122d1695$export$fa92d15b718fce20)(this, $90e2579c8dcb4e2d$var$_dispatch, $90e2579c8dcb4e2d$var$dispatch_fn).call(this, {
                    type: "pending",
                    context: context,
                    variables: variables,
                    isPaused: isPaused
                });
            }
            const data = await (0, $b8a5f0ad122d1695$export$18a094aefa070634)(this, $90e2579c8dcb4e2d$var$_retryer).start();
            await ((_f = (_e = (0, $b8a5f0ad122d1695$export$18a094aefa070634)(this, $90e2579c8dcb4e2d$var$_mutationCache).config).onSuccess) == null ? void 0 : _f.call(_e, data, variables, this.state.context, this));
            await ((_h = (_g = this.options).onSuccess) == null ? void 0 : _h.call(_g, data, variables, this.state.context));
            await ((_j = (_i = (0, $b8a5f0ad122d1695$export$18a094aefa070634)(this, $90e2579c8dcb4e2d$var$_mutationCache).config).onSettled) == null ? void 0 : _j.call(_i, data, null, this.state.variables, this.state.context, this));
            await ((_l = (_k = this.options).onSettled) == null ? void 0 : _l.call(_k, data, null, variables, this.state.context));
            (0, $b8a5f0ad122d1695$export$fa92d15b718fce20)(this, $90e2579c8dcb4e2d$var$_dispatch, $90e2579c8dcb4e2d$var$dispatch_fn).call(this, {
                type: "success",
                data: data
            });
            return data;
        } catch (error) {
            try {
                await ((_n = (_m = (0, $b8a5f0ad122d1695$export$18a094aefa070634)(this, $90e2579c8dcb4e2d$var$_mutationCache).config).onError) == null ? void 0 : _n.call(_m, error, variables, this.state.context, this));
                await ((_p = (_o = this.options).onError) == null ? void 0 : _p.call(_o, error, variables, this.state.context));
                await ((_r = (_q = (0, $b8a5f0ad122d1695$export$18a094aefa070634)(this, $90e2579c8dcb4e2d$var$_mutationCache).config).onSettled) == null ? void 0 : _r.call(_q, void 0, error, this.state.variables, this.state.context, this));
                await ((_t = (_s = this.options).onSettled) == null ? void 0 : _t.call(_s, void 0, error, variables, this.state.context));
                throw error;
            } finally{
                (0, $b8a5f0ad122d1695$export$fa92d15b718fce20)(this, $90e2579c8dcb4e2d$var$_dispatch, $90e2579c8dcb4e2d$var$dispatch_fn).call(this, {
                    type: "error",
                    error: error
                });
            }
        } finally{
            (0, $b8a5f0ad122d1695$export$18a094aefa070634)(this, $90e2579c8dcb4e2d$var$_mutationCache).runNext(this);
        }
    }
};
$90e2579c8dcb4e2d$var$_observers = new WeakMap();
$90e2579c8dcb4e2d$var$_mutationCache = new WeakMap();
$90e2579c8dcb4e2d$var$_retryer = new WeakMap();
$90e2579c8dcb4e2d$var$_dispatch = new WeakSet();
$90e2579c8dcb4e2d$var$dispatch_fn = function(action) {
    const reducer = (state)=>{
        switch(action.type){
            case "failed":
                return {
                    ...state,
                    failureCount: action.failureCount,
                    failureReason: action.error
                };
            case "pause":
                return {
                    ...state,
                    isPaused: true
                };
            case "continue":
                return {
                    ...state,
                    isPaused: false
                };
            case "pending":
                return {
                    ...state,
                    context: action.context,
                    data: void 0,
                    failureCount: 0,
                    failureReason: null,
                    error: null,
                    isPaused: action.isPaused,
                    status: "pending",
                    variables: action.variables,
                    submittedAt: Date.now()
                };
            case "success":
                return {
                    ...state,
                    data: action.data,
                    failureCount: 0,
                    failureReason: null,
                    error: null,
                    status: "success",
                    isPaused: false
                };
            case "error":
                return {
                    ...state,
                    data: void 0,
                    error: action.error,
                    failureCount: state.failureCount + 1,
                    failureReason: action.error,
                    isPaused: false,
                    status: "error"
                };
        }
    };
    this.state = reducer(this.state);
    (0, $254c215b61de4d59$export$520687f44db6e1ab).batch(()=>{
        (0, $b8a5f0ad122d1695$export$18a094aefa070634)(this, $90e2579c8dcb4e2d$var$_observers).forEach((observer)=>{
            observer.onMutationUpdate(action);
        });
        (0, $b8a5f0ad122d1695$export$18a094aefa070634)(this, $90e2579c8dcb4e2d$var$_mutationCache).notify({
            mutation: this,
            type: "updated",
            action: action
        });
    });
};
function $90e2579c8dcb4e2d$export$a1659b54bac3252a() {
    return {
        context: void 0,
        data: void 0,
        error: null,
        failureCount: 0,
        failureReason: null,
        isPaused: false,
        status: "idle",
        variables: void 0,
        submittedAt: 0
    };
}




var $503b9cf21ec599ee$var$_mutations, $503b9cf21ec599ee$var$_mutationId;
var $503b9cf21ec599ee$export$1fcfd9a244434844 = class extends (0, $c0624571ef47c584$export$d26086b469ecdbcc) {
    constructor(config = {}){
        super();
        this.config = config;
        (0, $b8a5f0ad122d1695$export$addf369becd23283)(this, $503b9cf21ec599ee$var$_mutations, void 0);
        (0, $b8a5f0ad122d1695$export$addf369becd23283)(this, $503b9cf21ec599ee$var$_mutationId, void 0);
        (0, $b8a5f0ad122d1695$export$42432efe6614d3b4)(this, $503b9cf21ec599ee$var$_mutations, /* @__PURE__ */ new Map());
        (0, $b8a5f0ad122d1695$export$42432efe6614d3b4)(this, $503b9cf21ec599ee$var$_mutationId, Date.now());
    }
    build(client, options, state) {
        const mutation = new (0, $90e2579c8dcb4e2d$export$17b8b19c814bcf56)({
            mutationCache: this,
            mutationId: ++(0, $b8a5f0ad122d1695$export$b1fe7cbb4502036b)(this, $503b9cf21ec599ee$var$_mutationId)._,
            options: client.defaultMutationOptions(options),
            state: state
        });
        this.add(mutation);
        return mutation;
    }
    add(mutation) {
        const scope = $503b9cf21ec599ee$var$scopeFor(mutation);
        const mutations = (0, $b8a5f0ad122d1695$export$18a094aefa070634)(this, $503b9cf21ec599ee$var$_mutations).get(scope) ?? [];
        mutations.push(mutation);
        (0, $b8a5f0ad122d1695$export$18a094aefa070634)(this, $503b9cf21ec599ee$var$_mutations).set(scope, mutations);
        this.notify({
            type: "added",
            mutation: mutation
        });
    }
    remove(mutation) {
        var _a;
        const scope = $503b9cf21ec599ee$var$scopeFor(mutation);
        if ((0, $b8a5f0ad122d1695$export$18a094aefa070634)(this, $503b9cf21ec599ee$var$_mutations).has(scope)) {
            const mutations = (_a = (0, $b8a5f0ad122d1695$export$18a094aefa070634)(this, $503b9cf21ec599ee$var$_mutations).get(scope)) == null ? void 0 : _a.filter((x)=>x !== mutation);
            if (mutations) {
                if (mutations.length === 0) (0, $b8a5f0ad122d1695$export$18a094aefa070634)(this, $503b9cf21ec599ee$var$_mutations).delete(scope);
                else (0, $b8a5f0ad122d1695$export$18a094aefa070634)(this, $503b9cf21ec599ee$var$_mutations).set(scope, mutations);
            }
        }
        this.notify({
            type: "removed",
            mutation: mutation
        });
    }
    canRun(mutation) {
        var _a;
        const firstPendingMutation = (_a = (0, $b8a5f0ad122d1695$export$18a094aefa070634)(this, $503b9cf21ec599ee$var$_mutations).get($503b9cf21ec599ee$var$scopeFor(mutation))) == null ? void 0 : _a.find((m)=>m.state.status === "pending");
        return !firstPendingMutation || firstPendingMutation === mutation;
    }
    runNext(mutation) {
        var _a;
        const foundMutation = (_a = (0, $b8a5f0ad122d1695$export$18a094aefa070634)(this, $503b9cf21ec599ee$var$_mutations).get($503b9cf21ec599ee$var$scopeFor(mutation))) == null ? void 0 : _a.find((m)=>m !== mutation && m.state.isPaused);
        return (foundMutation == null ? void 0 : foundMutation.continue()) ?? Promise.resolve();
    }
    clear() {
        (0, $254c215b61de4d59$export$520687f44db6e1ab).batch(()=>{
            this.getAll().forEach((mutation)=>{
                this.remove(mutation);
            });
        });
    }
    getAll() {
        return [
            ...(0, $b8a5f0ad122d1695$export$18a094aefa070634)(this, $503b9cf21ec599ee$var$_mutations).values()
        ].flat();
    }
    find(filters) {
        const defaultedFilters = {
            exact: true,
            ...filters
        };
        return this.getAll().find((mutation)=>(0, $aa7ba18d2eeda7da$export$a1ea5fb559f63ae3)(defaultedFilters, mutation));
    }
    findAll(filters = {}) {
        return this.getAll().filter((mutation)=>(0, $aa7ba18d2eeda7da$export$a1ea5fb559f63ae3)(filters, mutation));
    }
    notify(event) {
        (0, $254c215b61de4d59$export$520687f44db6e1ab).batch(()=>{
            this.listeners.forEach((listener)=>{
                listener(event);
            });
        });
    }
    resumePausedMutations() {
        const pausedMutations = this.getAll().filter((x)=>x.state.isPaused);
        return (0, $254c215b61de4d59$export$520687f44db6e1ab).batch(()=>Promise.all(pausedMutations.map((mutation)=>mutation.continue().catch((0, $aa7ba18d2eeda7da$export$8793edee2d425525)))));
    }
};
$503b9cf21ec599ee$var$_mutations = new WeakMap();
$503b9cf21ec599ee$var$_mutationId = new WeakMap();
function $503b9cf21ec599ee$var$scopeFor(mutation) {
    var _a;
    return ((_a = mutation.options.scope) == null ? void 0 : _a.id) ?? String(mutation.mutationId);
}







function $e8a1d35a7609603a$export$84470d1367601e8d(pages) {
    return {
        onFetch: (context, query)=>{
            const fetchFn = async ()=>{
                var _a, _b, _c, _d, _e;
                const options = context.options;
                const direction = (_c = (_b = (_a = context.fetchOptions) == null ? void 0 : _a.meta) == null ? void 0 : _b.fetchMore) == null ? void 0 : _c.direction;
                const oldPages = ((_d = context.state.data) == null ? void 0 : _d.pages) || [];
                const oldPageParams = ((_e = context.state.data) == null ? void 0 : _e.pageParams) || [];
                const empty = {
                    pages: [],
                    pageParams: []
                };
                let cancelled = false;
                const addSignalProperty = (object)=>{
                    Object.defineProperty(object, "signal", {
                        enumerable: true,
                        get: ()=>{
                            if (context.signal.aborted) cancelled = true;
                            else context.signal.addEventListener("abort", ()=>{
                                cancelled = true;
                            });
                            return context.signal;
                        }
                    });
                };
                const queryFn = (0, $aa7ba18d2eeda7da$export$c71c44209368a3bc)(context.options, context.fetchOptions);
                const fetchPage = async (data, param, previous)=>{
                    if (cancelled) return Promise.reject();
                    if (param == null && data.pages.length) return Promise.resolve(data);
                    const queryFnContext = {
                        queryKey: context.queryKey,
                        pageParam: param,
                        direction: previous ? "backward" : "forward",
                        meta: context.options.meta
                    };
                    addSignalProperty(queryFnContext);
                    const page = await queryFn(queryFnContext);
                    const { maxPages: maxPages } = context.options;
                    const addTo = previous ? (0, $aa7ba18d2eeda7da$export$8c6246b73dd61f4a) : (0, $aa7ba18d2eeda7da$export$ccce65a22a26f2bc);
                    return {
                        pages: addTo(data.pages, page, maxPages),
                        pageParams: addTo(data.pageParams, param, maxPages)
                    };
                };
                let result;
                if (direction && oldPages.length) {
                    const previous = direction === "backward";
                    const pageParamFn = previous ? $e8a1d35a7609603a$var$getPreviousPageParam : $e8a1d35a7609603a$var$getNextPageParam;
                    const oldData = {
                        pages: oldPages,
                        pageParams: oldPageParams
                    };
                    const param = pageParamFn(options, oldData);
                    result = await fetchPage(oldData, param, previous);
                } else {
                    result = await fetchPage(empty, oldPageParams[0] ?? options.initialPageParam);
                    const remainingPages = pages ?? oldPages.length;
                    for(let i = 1; i < remainingPages; i++){
                        const param = $e8a1d35a7609603a$var$getNextPageParam(options, result);
                        if (param == null) break;
                        result = await fetchPage(result, param);
                    }
                }
                return result;
            };
            if (context.options.persister) context.fetchFn = ()=>{
                var _a, _b;
                return (_b = (_a = context.options).persister) == null ? void 0 : _b.call(_a, fetchFn, {
                    queryKey: context.queryKey,
                    meta: context.options.meta,
                    signal: context.signal
                }, query);
            };
            else context.fetchFn = fetchFn;
        }
    };
}
function $e8a1d35a7609603a$var$getNextPageParam(options, { pages: pages, pageParams: pageParams }) {
    const lastIndex = pages.length - 1;
    return pages.length > 0 ? options.getNextPageParam(pages[lastIndex], pages, pageParams[lastIndex], pageParams) : void 0;
}
function $e8a1d35a7609603a$var$getPreviousPageParam(options, { pages: pages, pageParams: pageParams }) {
    var _a;
    return pages.length > 0 ? (_a = options.getPreviousPageParam) == null ? void 0 : _a.call(options, pages[0], pages, pageParams[0], pageParams) : void 0;
}
function $e8a1d35a7609603a$export$b9c88add8b8b5e6a(options, data) {
    if (!data) return false;
    return $e8a1d35a7609603a$var$getNextPageParam(options, data) != null;
}
function $e8a1d35a7609603a$export$db1663b730a8e6e4(options, data) {
    if (!data || !options.getPreviousPageParam) return false;
    return $e8a1d35a7609603a$var$getPreviousPageParam(options, data) != null;
}


var $c7cf51e08e050678$var$_queryCache, $c7cf51e08e050678$var$_mutationCache, $c7cf51e08e050678$var$_defaultOptions, $c7cf51e08e050678$var$_queryDefaults, $c7cf51e08e050678$var$_mutationDefaults, $c7cf51e08e050678$var$_mountCount, $c7cf51e08e050678$var$_unsubscribeFocus, $c7cf51e08e050678$var$_unsubscribeOnline;
var $c7cf51e08e050678$export$405d0624ed55a03f = class {
    constructor(config = {}){
        (0, $b8a5f0ad122d1695$export$addf369becd23283)(this, $c7cf51e08e050678$var$_queryCache, void 0);
        (0, $b8a5f0ad122d1695$export$addf369becd23283)(this, $c7cf51e08e050678$var$_mutationCache, void 0);
        (0, $b8a5f0ad122d1695$export$addf369becd23283)(this, $c7cf51e08e050678$var$_defaultOptions, void 0);
        (0, $b8a5f0ad122d1695$export$addf369becd23283)(this, $c7cf51e08e050678$var$_queryDefaults, void 0);
        (0, $b8a5f0ad122d1695$export$addf369becd23283)(this, $c7cf51e08e050678$var$_mutationDefaults, void 0);
        (0, $b8a5f0ad122d1695$export$addf369becd23283)(this, $c7cf51e08e050678$var$_mountCount, void 0);
        (0, $b8a5f0ad122d1695$export$addf369becd23283)(this, $c7cf51e08e050678$var$_unsubscribeFocus, void 0);
        (0, $b8a5f0ad122d1695$export$addf369becd23283)(this, $c7cf51e08e050678$var$_unsubscribeOnline, void 0);
        (0, $b8a5f0ad122d1695$export$42432efe6614d3b4)(this, $c7cf51e08e050678$var$_queryCache, config.queryCache || new (0, $48b5bdec429016ca$export$5dde0cd941da8468)());
        (0, $b8a5f0ad122d1695$export$42432efe6614d3b4)(this, $c7cf51e08e050678$var$_mutationCache, config.mutationCache || new (0, $503b9cf21ec599ee$export$1fcfd9a244434844)());
        (0, $b8a5f0ad122d1695$export$42432efe6614d3b4)(this, $c7cf51e08e050678$var$_defaultOptions, config.defaultOptions || {});
        (0, $b8a5f0ad122d1695$export$42432efe6614d3b4)(this, $c7cf51e08e050678$var$_queryDefaults, /* @__PURE__ */ new Map());
        (0, $b8a5f0ad122d1695$export$42432efe6614d3b4)(this, $c7cf51e08e050678$var$_mutationDefaults, /* @__PURE__ */ new Map());
        (0, $b8a5f0ad122d1695$export$42432efe6614d3b4)(this, $c7cf51e08e050678$var$_mountCount, 0);
    }
    mount() {
        (0, $b8a5f0ad122d1695$export$b1fe7cbb4502036b)(this, $c7cf51e08e050678$var$_mountCount)._++;
        if ((0, $b8a5f0ad122d1695$export$18a094aefa070634)(this, $c7cf51e08e050678$var$_mountCount) !== 1) return;
        (0, $b8a5f0ad122d1695$export$42432efe6614d3b4)(this, $c7cf51e08e050678$var$_unsubscribeFocus, (0, $941ede0c2ee4c5a4$export$6bf54661be5b02cf).subscribe(async (focused)=>{
            if (focused) {
                await this.resumePausedMutations();
                (0, $b8a5f0ad122d1695$export$18a094aefa070634)(this, $c7cf51e08e050678$var$_queryCache).onFocus();
            }
        }));
        (0, $b8a5f0ad122d1695$export$42432efe6614d3b4)(this, $c7cf51e08e050678$var$_unsubscribeOnline, (0, $51fd5b56382d0afc$export$b113e788b2dd3fdc).subscribe(async (online)=>{
            if (online) {
                await this.resumePausedMutations();
                (0, $b8a5f0ad122d1695$export$18a094aefa070634)(this, $c7cf51e08e050678$var$_queryCache).onOnline();
            }
        }));
    }
    unmount() {
        var _a, _b;
        (0, $b8a5f0ad122d1695$export$b1fe7cbb4502036b)(this, $c7cf51e08e050678$var$_mountCount)._--;
        if ((0, $b8a5f0ad122d1695$export$18a094aefa070634)(this, $c7cf51e08e050678$var$_mountCount) !== 0) return;
        (_a = (0, $b8a5f0ad122d1695$export$18a094aefa070634)(this, $c7cf51e08e050678$var$_unsubscribeFocus)) == null || _a.call(this);
        (0, $b8a5f0ad122d1695$export$42432efe6614d3b4)(this, $c7cf51e08e050678$var$_unsubscribeFocus, void 0);
        (_b = (0, $b8a5f0ad122d1695$export$18a094aefa070634)(this, $c7cf51e08e050678$var$_unsubscribeOnline)) == null || _b.call(this);
        (0, $b8a5f0ad122d1695$export$42432efe6614d3b4)(this, $c7cf51e08e050678$var$_unsubscribeOnline, void 0);
    }
    isFetching(filters) {
        return (0, $b8a5f0ad122d1695$export$18a094aefa070634)(this, $c7cf51e08e050678$var$_queryCache).findAll({
            ...filters,
            fetchStatus: "fetching"
        }).length;
    }
    isMutating(filters) {
        return (0, $b8a5f0ad122d1695$export$18a094aefa070634)(this, $c7cf51e08e050678$var$_mutationCache).findAll({
            ...filters,
            status: "pending"
        }).length;
    }
    getQueryData(queryKey) {
        var _a;
        const options = this.defaultQueryOptions({
            queryKey: queryKey
        });
        return (_a = (0, $b8a5f0ad122d1695$export$18a094aefa070634)(this, $c7cf51e08e050678$var$_queryCache).get(options.queryHash)) == null ? void 0 : _a.state.data;
    }
    ensureQueryData(options) {
        const cachedData = this.getQueryData(options.queryKey);
        if (cachedData === void 0) return this.fetchQuery(options);
        else {
            const defaultedOptions = this.defaultQueryOptions(options);
            const query = (0, $b8a5f0ad122d1695$export$18a094aefa070634)(this, $c7cf51e08e050678$var$_queryCache).build(this, defaultedOptions);
            if (options.revalidateIfStale && query.isStaleByTime((0, $aa7ba18d2eeda7da$export$cb3145f011bda3ac)(defaultedOptions.staleTime, query))) this.prefetchQuery(defaultedOptions);
            return Promise.resolve(cachedData);
        }
    }
    getQueriesData(filters) {
        return (0, $b8a5f0ad122d1695$export$18a094aefa070634)(this, $c7cf51e08e050678$var$_queryCache).findAll(filters).map(({ queryKey: queryKey, state: state })=>{
            const data = state.data;
            return [
                queryKey,
                data
            ];
        });
    }
    setQueryData(queryKey, updater, options) {
        const defaultedOptions = this.defaultQueryOptions({
            queryKey: queryKey
        });
        const query = (0, $b8a5f0ad122d1695$export$18a094aefa070634)(this, $c7cf51e08e050678$var$_queryCache).get(defaultedOptions.queryHash);
        const prevData = query == null ? void 0 : query.state.data;
        const data = (0, $aa7ba18d2eeda7da$export$7f095f455ad5af3f)(updater, prevData);
        if (data === void 0) return void 0;
        return (0, $b8a5f0ad122d1695$export$18a094aefa070634)(this, $c7cf51e08e050678$var$_queryCache).build(this, defaultedOptions).setData(data, {
            ...options,
            manual: true
        });
    }
    setQueriesData(filters, updater, options) {
        return (0, $254c215b61de4d59$export$520687f44db6e1ab).batch(()=>(0, $b8a5f0ad122d1695$export$18a094aefa070634)(this, $c7cf51e08e050678$var$_queryCache).findAll(filters).map(({ queryKey: queryKey })=>[
                    queryKey,
                    this.setQueryData(queryKey, updater, options)
                ]));
    }
    getQueryState(queryKey) {
        var _a;
        const options = this.defaultQueryOptions({
            queryKey: queryKey
        });
        return (_a = (0, $b8a5f0ad122d1695$export$18a094aefa070634)(this, $c7cf51e08e050678$var$_queryCache).get(options.queryHash)) == null ? void 0 : _a.state;
    }
    removeQueries(filters) {
        const queryCache = (0, $b8a5f0ad122d1695$export$18a094aefa070634)(this, $c7cf51e08e050678$var$_queryCache);
        (0, $254c215b61de4d59$export$520687f44db6e1ab).batch(()=>{
            queryCache.findAll(filters).forEach((query)=>{
                queryCache.remove(query);
            });
        });
    }
    resetQueries(filters, options) {
        const queryCache = (0, $b8a5f0ad122d1695$export$18a094aefa070634)(this, $c7cf51e08e050678$var$_queryCache);
        const refetchFilters = {
            type: "active",
            ...filters
        };
        return (0, $254c215b61de4d59$export$520687f44db6e1ab).batch(()=>{
            queryCache.findAll(filters).forEach((query)=>{
                query.reset();
            });
            return this.refetchQueries(refetchFilters, options);
        });
    }
    cancelQueries(filters = {}, cancelOptions = {}) {
        const defaultedCancelOptions = {
            revert: true,
            ...cancelOptions
        };
        const promises = (0, $254c215b61de4d59$export$520687f44db6e1ab).batch(()=>(0, $b8a5f0ad122d1695$export$18a094aefa070634)(this, $c7cf51e08e050678$var$_queryCache).findAll(filters).map((query)=>query.cancel(defaultedCancelOptions)));
        return Promise.all(promises).then((0, $aa7ba18d2eeda7da$export$8793edee2d425525)).catch((0, $aa7ba18d2eeda7da$export$8793edee2d425525));
    }
    invalidateQueries(filters = {}, options = {}) {
        return (0, $254c215b61de4d59$export$520687f44db6e1ab).batch(()=>{
            (0, $b8a5f0ad122d1695$export$18a094aefa070634)(this, $c7cf51e08e050678$var$_queryCache).findAll(filters).forEach((query)=>{
                query.invalidate();
            });
            if (filters.refetchType === "none") return Promise.resolve();
            const refetchFilters = {
                ...filters,
                type: filters.refetchType ?? filters.type ?? "active"
            };
            return this.refetchQueries(refetchFilters, options);
        });
    }
    refetchQueries(filters = {}, options) {
        const fetchOptions = {
            ...options,
            cancelRefetch: (options == null ? void 0 : options.cancelRefetch) ?? true
        };
        const promises = (0, $254c215b61de4d59$export$520687f44db6e1ab).batch(()=>(0, $b8a5f0ad122d1695$export$18a094aefa070634)(this, $c7cf51e08e050678$var$_queryCache).findAll(filters).filter((query)=>!query.isDisabled()).map((query)=>{
                let promise = query.fetch(void 0, fetchOptions);
                if (!fetchOptions.throwOnError) promise = promise.catch((0, $aa7ba18d2eeda7da$export$8793edee2d425525));
                return query.state.fetchStatus === "paused" ? Promise.resolve() : promise;
            }));
        return Promise.all(promises).then((0, $aa7ba18d2eeda7da$export$8793edee2d425525));
    }
    fetchQuery(options) {
        const defaultedOptions = this.defaultQueryOptions(options);
        if (defaultedOptions.retry === void 0) defaultedOptions.retry = false;
        const query = (0, $b8a5f0ad122d1695$export$18a094aefa070634)(this, $c7cf51e08e050678$var$_queryCache).build(this, defaultedOptions);
        return query.isStaleByTime((0, $aa7ba18d2eeda7da$export$cb3145f011bda3ac)(defaultedOptions.staleTime, query)) ? query.fetch(defaultedOptions) : Promise.resolve(query.state.data);
    }
    prefetchQuery(options) {
        return this.fetchQuery(options).then((0, $aa7ba18d2eeda7da$export$8793edee2d425525)).catch((0, $aa7ba18d2eeda7da$export$8793edee2d425525));
    }
    fetchInfiniteQuery(options) {
        options.behavior = (0, $e8a1d35a7609603a$export$84470d1367601e8d)(options.pages);
        return this.fetchQuery(options);
    }
    prefetchInfiniteQuery(options) {
        return this.fetchInfiniteQuery(options).then((0, $aa7ba18d2eeda7da$export$8793edee2d425525)).catch((0, $aa7ba18d2eeda7da$export$8793edee2d425525));
    }
    resumePausedMutations() {
        if ((0, $51fd5b56382d0afc$export$b113e788b2dd3fdc).isOnline()) return (0, $b8a5f0ad122d1695$export$18a094aefa070634)(this, $c7cf51e08e050678$var$_mutationCache).resumePausedMutations();
        return Promise.resolve();
    }
    getQueryCache() {
        return (0, $b8a5f0ad122d1695$export$18a094aefa070634)(this, $c7cf51e08e050678$var$_queryCache);
    }
    getMutationCache() {
        return (0, $b8a5f0ad122d1695$export$18a094aefa070634)(this, $c7cf51e08e050678$var$_mutationCache);
    }
    getDefaultOptions() {
        return (0, $b8a5f0ad122d1695$export$18a094aefa070634)(this, $c7cf51e08e050678$var$_defaultOptions);
    }
    setDefaultOptions(options) {
        (0, $b8a5f0ad122d1695$export$42432efe6614d3b4)(this, $c7cf51e08e050678$var$_defaultOptions, options);
    }
    setQueryDefaults(queryKey, options) {
        (0, $b8a5f0ad122d1695$export$18a094aefa070634)(this, $c7cf51e08e050678$var$_queryDefaults).set((0, $aa7ba18d2eeda7da$export$1e87d19d4aab5805)(queryKey), {
            queryKey: queryKey,
            defaultOptions: options
        });
    }
    getQueryDefaults(queryKey) {
        const defaults = [
            ...(0, $b8a5f0ad122d1695$export$18a094aefa070634)(this, $c7cf51e08e050678$var$_queryDefaults).values()
        ];
        let result = {};
        defaults.forEach((queryDefault)=>{
            if ((0, $aa7ba18d2eeda7da$export$2f07189bb9fa26a7)(queryKey, queryDefault.queryKey)) result = {
                ...result,
                ...queryDefault.defaultOptions
            };
        });
        return result;
    }
    setMutationDefaults(mutationKey, options) {
        (0, $b8a5f0ad122d1695$export$18a094aefa070634)(this, $c7cf51e08e050678$var$_mutationDefaults).set((0, $aa7ba18d2eeda7da$export$1e87d19d4aab5805)(mutationKey), {
            mutationKey: mutationKey,
            defaultOptions: options
        });
    }
    getMutationDefaults(mutationKey) {
        const defaults = [
            ...(0, $b8a5f0ad122d1695$export$18a094aefa070634)(this, $c7cf51e08e050678$var$_mutationDefaults).values()
        ];
        let result = {};
        defaults.forEach((queryDefault)=>{
            if ((0, $aa7ba18d2eeda7da$export$2f07189bb9fa26a7)(mutationKey, queryDefault.mutationKey)) result = {
                ...result,
                ...queryDefault.defaultOptions
            };
        });
        return result;
    }
    defaultQueryOptions(options) {
        if (options._defaulted) return options;
        const defaultedOptions = {
            ...(0, $b8a5f0ad122d1695$export$18a094aefa070634)(this, $c7cf51e08e050678$var$_defaultOptions).queries,
            ...this.getQueryDefaults(options.queryKey),
            ...options,
            _defaulted: true
        };
        if (!defaultedOptions.queryHash) defaultedOptions.queryHash = (0, $aa7ba18d2eeda7da$export$cc90ca97bc0d73fd)(defaultedOptions.queryKey, defaultedOptions);
        if (defaultedOptions.refetchOnReconnect === void 0) defaultedOptions.refetchOnReconnect = defaultedOptions.networkMode !== "always";
        if (defaultedOptions.throwOnError === void 0) defaultedOptions.throwOnError = !!defaultedOptions.suspense;
        if (!defaultedOptions.networkMode && defaultedOptions.persister) defaultedOptions.networkMode = "offlineFirst";
        if (defaultedOptions.enabled !== true && defaultedOptions.queryFn === (0, $aa7ba18d2eeda7da$export$1aa5a89531b7670d)) defaultedOptions.enabled = false;
        return defaultedOptions;
    }
    defaultMutationOptions(options) {
        if (options == null ? void 0 : options._defaulted) return options;
        return {
            ...(0, $b8a5f0ad122d1695$export$18a094aefa070634)(this, $c7cf51e08e050678$var$_defaultOptions).mutations,
            ...(options == null ? void 0 : options.mutationKey) && this.getMutationDefaults(options.mutationKey),
            ...options,
            _defaulted: true
        };
    }
    clear() {
        (0, $b8a5f0ad122d1695$export$18a094aefa070634)(this, $c7cf51e08e050678$var$_queryCache).clear();
        (0, $b8a5f0ad122d1695$export$18a094aefa070634)(this, $c7cf51e08e050678$var$_mutationCache).clear();
    }
};
$c7cf51e08e050678$var$_queryCache = new WeakMap();
$c7cf51e08e050678$var$_mutationCache = new WeakMap();
$c7cf51e08e050678$var$_defaultOptions = new WeakMap();
$c7cf51e08e050678$var$_queryDefaults = new WeakMap();
$c7cf51e08e050678$var$_mutationDefaults = new WeakMap();
$c7cf51e08e050678$var$_mountCount = new WeakMap();
$c7cf51e08e050678$var$_unsubscribeFocus = new WeakMap();
$c7cf51e08e050678$var$_unsubscribeOnline = new WeakMap();







var $7ebcbc3bb087abe6$var$_client, $7ebcbc3bb087abe6$var$_currentQuery, $7ebcbc3bb087abe6$var$_currentQueryInitialState, $7ebcbc3bb087abe6$var$_currentResult, $7ebcbc3bb087abe6$var$_currentResultState, $7ebcbc3bb087abe6$var$_currentResultOptions, $7ebcbc3bb087abe6$var$_selectError, $7ebcbc3bb087abe6$var$_selectFn, $7ebcbc3bb087abe6$var$_selectResult, $7ebcbc3bb087abe6$var$_lastQueryWithDefinedData, $7ebcbc3bb087abe6$var$_staleTimeoutId, $7ebcbc3bb087abe6$var$_refetchIntervalId, $7ebcbc3bb087abe6$var$_currentRefetchInterval, $7ebcbc3bb087abe6$var$_trackedProps, $7ebcbc3bb087abe6$var$_executeFetch, $7ebcbc3bb087abe6$var$executeFetch_fn, $7ebcbc3bb087abe6$var$_updateStaleTimeout, $7ebcbc3bb087abe6$var$updateStaleTimeout_fn, $7ebcbc3bb087abe6$var$_computeRefetchInterval, $7ebcbc3bb087abe6$var$computeRefetchInterval_fn, $7ebcbc3bb087abe6$var$_updateRefetchInterval, $7ebcbc3bb087abe6$var$updateRefetchInterval_fn, $7ebcbc3bb087abe6$var$_updateTimers, $7ebcbc3bb087abe6$var$updateTimers_fn, $7ebcbc3bb087abe6$var$_clearStaleTimeout, $7ebcbc3bb087abe6$var$clearStaleTimeout_fn, $7ebcbc3bb087abe6$var$_clearRefetchInterval, $7ebcbc3bb087abe6$var$clearRefetchInterval_fn, $7ebcbc3bb087abe6$var$_updateQuery, $7ebcbc3bb087abe6$var$updateQuery_fn, $7ebcbc3bb087abe6$var$_notify, $7ebcbc3bb087abe6$var$notify_fn;
var $7ebcbc3bb087abe6$export$a06cf8c0066f0d4c = class extends (0, $c0624571ef47c584$export$d26086b469ecdbcc) {
    constructor(client, options){
        super();
        this.options = options;
        (0, $b8a5f0ad122d1695$export$addf369becd23283)(this, $7ebcbc3bb087abe6$var$_executeFetch);
        (0, $b8a5f0ad122d1695$export$addf369becd23283)(this, $7ebcbc3bb087abe6$var$_updateStaleTimeout);
        (0, $b8a5f0ad122d1695$export$addf369becd23283)(this, $7ebcbc3bb087abe6$var$_computeRefetchInterval);
        (0, $b8a5f0ad122d1695$export$addf369becd23283)(this, $7ebcbc3bb087abe6$var$_updateRefetchInterval);
        (0, $b8a5f0ad122d1695$export$addf369becd23283)(this, $7ebcbc3bb087abe6$var$_updateTimers);
        (0, $b8a5f0ad122d1695$export$addf369becd23283)(this, $7ebcbc3bb087abe6$var$_clearStaleTimeout);
        (0, $b8a5f0ad122d1695$export$addf369becd23283)(this, $7ebcbc3bb087abe6$var$_clearRefetchInterval);
        (0, $b8a5f0ad122d1695$export$addf369becd23283)(this, $7ebcbc3bb087abe6$var$_updateQuery);
        (0, $b8a5f0ad122d1695$export$addf369becd23283)(this, $7ebcbc3bb087abe6$var$_notify);
        (0, $b8a5f0ad122d1695$export$addf369becd23283)(this, $7ebcbc3bb087abe6$var$_client, void 0);
        (0, $b8a5f0ad122d1695$export$addf369becd23283)(this, $7ebcbc3bb087abe6$var$_currentQuery, void 0);
        (0, $b8a5f0ad122d1695$export$addf369becd23283)(this, $7ebcbc3bb087abe6$var$_currentQueryInitialState, void 0);
        (0, $b8a5f0ad122d1695$export$addf369becd23283)(this, $7ebcbc3bb087abe6$var$_currentResult, void 0);
        (0, $b8a5f0ad122d1695$export$addf369becd23283)(this, $7ebcbc3bb087abe6$var$_currentResultState, void 0);
        (0, $b8a5f0ad122d1695$export$addf369becd23283)(this, $7ebcbc3bb087abe6$var$_currentResultOptions, void 0);
        (0, $b8a5f0ad122d1695$export$addf369becd23283)(this, $7ebcbc3bb087abe6$var$_selectError, void 0);
        (0, $b8a5f0ad122d1695$export$addf369becd23283)(this, $7ebcbc3bb087abe6$var$_selectFn, void 0);
        (0, $b8a5f0ad122d1695$export$addf369becd23283)(this, $7ebcbc3bb087abe6$var$_selectResult, void 0);
        // This property keeps track of the last query with defined data.
        // It will be used to pass the previous data and query to the placeholder function between renders.
        (0, $b8a5f0ad122d1695$export$addf369becd23283)(this, $7ebcbc3bb087abe6$var$_lastQueryWithDefinedData, void 0);
        (0, $b8a5f0ad122d1695$export$addf369becd23283)(this, $7ebcbc3bb087abe6$var$_staleTimeoutId, void 0);
        (0, $b8a5f0ad122d1695$export$addf369becd23283)(this, $7ebcbc3bb087abe6$var$_refetchIntervalId, void 0);
        (0, $b8a5f0ad122d1695$export$addf369becd23283)(this, $7ebcbc3bb087abe6$var$_currentRefetchInterval, void 0);
        (0, $b8a5f0ad122d1695$export$addf369becd23283)(this, $7ebcbc3bb087abe6$var$_trackedProps, /* @__PURE__ */ new Set());
        (0, $b8a5f0ad122d1695$export$42432efe6614d3b4)(this, $7ebcbc3bb087abe6$var$_client, client);
        (0, $b8a5f0ad122d1695$export$42432efe6614d3b4)(this, $7ebcbc3bb087abe6$var$_selectError, null);
        this.bindMethods();
        this.setOptions(options);
    }
    bindMethods() {
        this.refetch = this.refetch.bind(this);
    }
    onSubscribe() {
        if (this.listeners.size === 1) {
            (0, $b8a5f0ad122d1695$export$18a094aefa070634)(this, $7ebcbc3bb087abe6$var$_currentQuery).addObserver(this);
            if ($7ebcbc3bb087abe6$var$shouldFetchOnMount((0, $b8a5f0ad122d1695$export$18a094aefa070634)(this, $7ebcbc3bb087abe6$var$_currentQuery), this.options)) (0, $b8a5f0ad122d1695$export$fa92d15b718fce20)(this, $7ebcbc3bb087abe6$var$_executeFetch, $7ebcbc3bb087abe6$var$executeFetch_fn).call(this);
            else this.updateResult();
            (0, $b8a5f0ad122d1695$export$fa92d15b718fce20)(this, $7ebcbc3bb087abe6$var$_updateTimers, $7ebcbc3bb087abe6$var$updateTimers_fn).call(this);
        }
    }
    onUnsubscribe() {
        if (!this.hasListeners()) this.destroy();
    }
    shouldFetchOnReconnect() {
        return $7ebcbc3bb087abe6$var$shouldFetchOn((0, $b8a5f0ad122d1695$export$18a094aefa070634)(this, $7ebcbc3bb087abe6$var$_currentQuery), this.options, this.options.refetchOnReconnect);
    }
    shouldFetchOnWindowFocus() {
        return $7ebcbc3bb087abe6$var$shouldFetchOn((0, $b8a5f0ad122d1695$export$18a094aefa070634)(this, $7ebcbc3bb087abe6$var$_currentQuery), this.options, this.options.refetchOnWindowFocus);
    }
    destroy() {
        this.listeners = /* @__PURE__ */ new Set();
        (0, $b8a5f0ad122d1695$export$fa92d15b718fce20)(this, $7ebcbc3bb087abe6$var$_clearStaleTimeout, $7ebcbc3bb087abe6$var$clearStaleTimeout_fn).call(this);
        (0, $b8a5f0ad122d1695$export$fa92d15b718fce20)(this, $7ebcbc3bb087abe6$var$_clearRefetchInterval, $7ebcbc3bb087abe6$var$clearRefetchInterval_fn).call(this);
        (0, $b8a5f0ad122d1695$export$18a094aefa070634)(this, $7ebcbc3bb087abe6$var$_currentQuery).removeObserver(this);
    }
    setOptions(options, notifyOptions) {
        const prevOptions = this.options;
        const prevQuery = (0, $b8a5f0ad122d1695$export$18a094aefa070634)(this, $7ebcbc3bb087abe6$var$_currentQuery);
        this.options = (0, $b8a5f0ad122d1695$export$18a094aefa070634)(this, $7ebcbc3bb087abe6$var$_client).defaultQueryOptions(options);
        if (this.options.enabled !== void 0 && typeof this.options.enabled !== "boolean" && typeof this.options.enabled !== "function" && typeof (0, $aa7ba18d2eeda7da$export$8c88ee6f2357230d)(this.options.enabled, (0, $b8a5f0ad122d1695$export$18a094aefa070634)(this, $7ebcbc3bb087abe6$var$_currentQuery)) !== "boolean") throw new Error("Expected enabled to be a boolean or a callback that returns a boolean");
        (0, $b8a5f0ad122d1695$export$fa92d15b718fce20)(this, $7ebcbc3bb087abe6$var$_updateQuery, $7ebcbc3bb087abe6$var$updateQuery_fn).call(this);
        (0, $b8a5f0ad122d1695$export$18a094aefa070634)(this, $7ebcbc3bb087abe6$var$_currentQuery).setOptions(this.options);
        if (prevOptions._defaulted && !(0, $aa7ba18d2eeda7da$export$3e67810a3f0e9f1c)(this.options, prevOptions)) (0, $b8a5f0ad122d1695$export$18a094aefa070634)(this, $7ebcbc3bb087abe6$var$_client).getQueryCache().notify({
            type: "observerOptionsUpdated",
            query: (0, $b8a5f0ad122d1695$export$18a094aefa070634)(this, $7ebcbc3bb087abe6$var$_currentQuery),
            observer: this
        });
        const mounted = this.hasListeners();
        if (mounted && $7ebcbc3bb087abe6$var$shouldFetchOptionally((0, $b8a5f0ad122d1695$export$18a094aefa070634)(this, $7ebcbc3bb087abe6$var$_currentQuery), prevQuery, this.options, prevOptions)) (0, $b8a5f0ad122d1695$export$fa92d15b718fce20)(this, $7ebcbc3bb087abe6$var$_executeFetch, $7ebcbc3bb087abe6$var$executeFetch_fn).call(this);
        this.updateResult(notifyOptions);
        if (mounted && ((0, $b8a5f0ad122d1695$export$18a094aefa070634)(this, $7ebcbc3bb087abe6$var$_currentQuery) !== prevQuery || (0, $aa7ba18d2eeda7da$export$8c88ee6f2357230d)(this.options.enabled, (0, $b8a5f0ad122d1695$export$18a094aefa070634)(this, $7ebcbc3bb087abe6$var$_currentQuery)) !== (0, $aa7ba18d2eeda7da$export$8c88ee6f2357230d)(prevOptions.enabled, (0, $b8a5f0ad122d1695$export$18a094aefa070634)(this, $7ebcbc3bb087abe6$var$_currentQuery)) || (0, $aa7ba18d2eeda7da$export$cb3145f011bda3ac)(this.options.staleTime, (0, $b8a5f0ad122d1695$export$18a094aefa070634)(this, $7ebcbc3bb087abe6$var$_currentQuery)) !== (0, $aa7ba18d2eeda7da$export$cb3145f011bda3ac)(prevOptions.staleTime, (0, $b8a5f0ad122d1695$export$18a094aefa070634)(this, $7ebcbc3bb087abe6$var$_currentQuery)))) (0, $b8a5f0ad122d1695$export$fa92d15b718fce20)(this, $7ebcbc3bb087abe6$var$_updateStaleTimeout, $7ebcbc3bb087abe6$var$updateStaleTimeout_fn).call(this);
        const nextRefetchInterval = (0, $b8a5f0ad122d1695$export$fa92d15b718fce20)(this, $7ebcbc3bb087abe6$var$_computeRefetchInterval, $7ebcbc3bb087abe6$var$computeRefetchInterval_fn).call(this);
        if (mounted && ((0, $b8a5f0ad122d1695$export$18a094aefa070634)(this, $7ebcbc3bb087abe6$var$_currentQuery) !== prevQuery || (0, $aa7ba18d2eeda7da$export$8c88ee6f2357230d)(this.options.enabled, (0, $b8a5f0ad122d1695$export$18a094aefa070634)(this, $7ebcbc3bb087abe6$var$_currentQuery)) !== (0, $aa7ba18d2eeda7da$export$8c88ee6f2357230d)(prevOptions.enabled, (0, $b8a5f0ad122d1695$export$18a094aefa070634)(this, $7ebcbc3bb087abe6$var$_currentQuery)) || nextRefetchInterval !== (0, $b8a5f0ad122d1695$export$18a094aefa070634)(this, $7ebcbc3bb087abe6$var$_currentRefetchInterval))) (0, $b8a5f0ad122d1695$export$fa92d15b718fce20)(this, $7ebcbc3bb087abe6$var$_updateRefetchInterval, $7ebcbc3bb087abe6$var$updateRefetchInterval_fn).call(this, nextRefetchInterval);
    }
    getOptimisticResult(options) {
        const query = (0, $b8a5f0ad122d1695$export$18a094aefa070634)(this, $7ebcbc3bb087abe6$var$_client).getQueryCache().build((0, $b8a5f0ad122d1695$export$18a094aefa070634)(this, $7ebcbc3bb087abe6$var$_client), options);
        const result = this.createResult(query, options);
        if ($7ebcbc3bb087abe6$var$shouldAssignObserverCurrentProperties(this, result)) {
            (0, $b8a5f0ad122d1695$export$42432efe6614d3b4)(this, $7ebcbc3bb087abe6$var$_currentResult, result);
            (0, $b8a5f0ad122d1695$export$42432efe6614d3b4)(this, $7ebcbc3bb087abe6$var$_currentResultOptions, this.options);
            (0, $b8a5f0ad122d1695$export$42432efe6614d3b4)(this, $7ebcbc3bb087abe6$var$_currentResultState, (0, $b8a5f0ad122d1695$export$18a094aefa070634)(this, $7ebcbc3bb087abe6$var$_currentQuery).state);
        }
        return result;
    }
    getCurrentResult() {
        return (0, $b8a5f0ad122d1695$export$18a094aefa070634)(this, $7ebcbc3bb087abe6$var$_currentResult);
    }
    trackResult(result, onPropTracked) {
        const trackedResult = {};
        Object.keys(result).forEach((key)=>{
            Object.defineProperty(trackedResult, key, {
                configurable: false,
                enumerable: true,
                get: ()=>{
                    this.trackProp(key);
                    onPropTracked == null || onPropTracked(key);
                    return result[key];
                }
            });
        });
        return trackedResult;
    }
    trackProp(key) {
        (0, $b8a5f0ad122d1695$export$18a094aefa070634)(this, $7ebcbc3bb087abe6$var$_trackedProps).add(key);
    }
    getCurrentQuery() {
        return (0, $b8a5f0ad122d1695$export$18a094aefa070634)(this, $7ebcbc3bb087abe6$var$_currentQuery);
    }
    refetch({ ...options } = {}) {
        return this.fetch({
            ...options
        });
    }
    fetchOptimistic(options) {
        const defaultedOptions = (0, $b8a5f0ad122d1695$export$18a094aefa070634)(this, $7ebcbc3bb087abe6$var$_client).defaultQueryOptions(options);
        const query = (0, $b8a5f0ad122d1695$export$18a094aefa070634)(this, $7ebcbc3bb087abe6$var$_client).getQueryCache().build((0, $b8a5f0ad122d1695$export$18a094aefa070634)(this, $7ebcbc3bb087abe6$var$_client), defaultedOptions);
        query.isFetchingOptimistic = true;
        return query.fetch().then(()=>this.createResult(query, defaultedOptions));
    }
    fetch(fetchOptions) {
        return (0, $b8a5f0ad122d1695$export$fa92d15b718fce20)(this, $7ebcbc3bb087abe6$var$_executeFetch, $7ebcbc3bb087abe6$var$executeFetch_fn).call(this, {
            ...fetchOptions,
            cancelRefetch: fetchOptions.cancelRefetch ?? true
        }).then(()=>{
            this.updateResult();
            return (0, $b8a5f0ad122d1695$export$18a094aefa070634)(this, $7ebcbc3bb087abe6$var$_currentResult);
        });
    }
    createResult(query, options) {
        var _a;
        const prevQuery = (0, $b8a5f0ad122d1695$export$18a094aefa070634)(this, $7ebcbc3bb087abe6$var$_currentQuery);
        const prevOptions = this.options;
        const prevResult = (0, $b8a5f0ad122d1695$export$18a094aefa070634)(this, $7ebcbc3bb087abe6$var$_currentResult);
        const prevResultState = (0, $b8a5f0ad122d1695$export$18a094aefa070634)(this, $7ebcbc3bb087abe6$var$_currentResultState);
        const prevResultOptions = (0, $b8a5f0ad122d1695$export$18a094aefa070634)(this, $7ebcbc3bb087abe6$var$_currentResultOptions);
        const queryChange = query !== prevQuery;
        const queryInitialState = queryChange ? query.state : (0, $b8a5f0ad122d1695$export$18a094aefa070634)(this, $7ebcbc3bb087abe6$var$_currentQueryInitialState);
        const { state: state } = query;
        let newState = {
            ...state
        };
        let isPlaceholderData = false;
        let data;
        if (options._optimisticResults) {
            const mounted = this.hasListeners();
            const fetchOnMount = !mounted && $7ebcbc3bb087abe6$var$shouldFetchOnMount(query, options);
            const fetchOptionally = mounted && $7ebcbc3bb087abe6$var$shouldFetchOptionally(query, prevQuery, options, prevOptions);
            if (fetchOnMount || fetchOptionally) newState = {
                ...newState,
                ...(0, $93c68f86d0b6a255$export$f3df9013f2b58bce)(state.data, query.options)
            };
            if (options._optimisticResults === "isRestoring") newState.fetchStatus = "idle";
        }
        let { error: error, errorUpdatedAt: errorUpdatedAt, status: status } = newState;
        if (options.select && newState.data !== void 0) {
            if (prevResult && newState.data === (prevResultState == null ? void 0 : prevResultState.data) && options.select === (0, $b8a5f0ad122d1695$export$18a094aefa070634)(this, $7ebcbc3bb087abe6$var$_selectFn)) data = (0, $b8a5f0ad122d1695$export$18a094aefa070634)(this, $7ebcbc3bb087abe6$var$_selectResult);
            else try {
                (0, $b8a5f0ad122d1695$export$42432efe6614d3b4)(this, $7ebcbc3bb087abe6$var$_selectFn, options.select);
                data = options.select(newState.data);
                data = (0, $aa7ba18d2eeda7da$export$17619bac5b909b23)(prevResult == null ? void 0 : prevResult.data, data, options);
                (0, $b8a5f0ad122d1695$export$42432efe6614d3b4)(this, $7ebcbc3bb087abe6$var$_selectResult, data);
                (0, $b8a5f0ad122d1695$export$42432efe6614d3b4)(this, $7ebcbc3bb087abe6$var$_selectError, null);
            } catch (selectError) {
                (0, $b8a5f0ad122d1695$export$42432efe6614d3b4)(this, $7ebcbc3bb087abe6$var$_selectError, selectError);
            }
        } else data = newState.data;
        if (options.placeholderData !== void 0 && data === void 0 && status === "pending") {
            let placeholderData;
            if ((prevResult == null ? void 0 : prevResult.isPlaceholderData) && options.placeholderData === (prevResultOptions == null ? void 0 : prevResultOptions.placeholderData)) placeholderData = prevResult.data;
            else {
                placeholderData = typeof options.placeholderData === "function" ? options.placeholderData((_a = (0, $b8a5f0ad122d1695$export$18a094aefa070634)(this, $7ebcbc3bb087abe6$var$_lastQueryWithDefinedData)) == null ? void 0 : _a.state.data, (0, $b8a5f0ad122d1695$export$18a094aefa070634)(this, $7ebcbc3bb087abe6$var$_lastQueryWithDefinedData)) : options.placeholderData;
                if (options.select && placeholderData !== void 0) try {
                    placeholderData = options.select(placeholderData);
                    (0, $b8a5f0ad122d1695$export$42432efe6614d3b4)(this, $7ebcbc3bb087abe6$var$_selectError, null);
                } catch (selectError) {
                    (0, $b8a5f0ad122d1695$export$42432efe6614d3b4)(this, $7ebcbc3bb087abe6$var$_selectError, selectError);
                }
            }
            if (placeholderData !== void 0) {
                status = "success";
                data = (0, $aa7ba18d2eeda7da$export$17619bac5b909b23)(prevResult == null ? void 0 : prevResult.data, placeholderData, options);
                isPlaceholderData = true;
            }
        }
        if ((0, $b8a5f0ad122d1695$export$18a094aefa070634)(this, $7ebcbc3bb087abe6$var$_selectError)) {
            error = (0, $b8a5f0ad122d1695$export$18a094aefa070634)(this, $7ebcbc3bb087abe6$var$_selectError);
            data = (0, $b8a5f0ad122d1695$export$18a094aefa070634)(this, $7ebcbc3bb087abe6$var$_selectResult);
            errorUpdatedAt = Date.now();
            status = "error";
        }
        const isFetching = newState.fetchStatus === "fetching";
        const isPending = status === "pending";
        const isError = status === "error";
        const isLoading = isPending && isFetching;
        const hasData = data !== void 0;
        const result = {
            status: status,
            fetchStatus: newState.fetchStatus,
            isPending: isPending,
            isSuccess: status === "success",
            isError: isError,
            isInitialLoading: isLoading,
            isLoading: isLoading,
            data: data,
            dataUpdatedAt: newState.dataUpdatedAt,
            error: error,
            errorUpdatedAt: errorUpdatedAt,
            failureCount: newState.fetchFailureCount,
            failureReason: newState.fetchFailureReason,
            errorUpdateCount: newState.errorUpdateCount,
            isFetched: newState.dataUpdateCount > 0 || newState.errorUpdateCount > 0,
            isFetchedAfterMount: newState.dataUpdateCount > queryInitialState.dataUpdateCount || newState.errorUpdateCount > queryInitialState.errorUpdateCount,
            isFetching: isFetching,
            isRefetching: isFetching && !isPending,
            isLoadingError: isError && !hasData,
            isPaused: newState.fetchStatus === "paused",
            isPlaceholderData: isPlaceholderData,
            isRefetchError: isError && hasData,
            isStale: $7ebcbc3bb087abe6$var$isStale(query, options),
            refetch: this.refetch
        };
        return result;
    }
    updateResult(notifyOptions) {
        const prevResult = (0, $b8a5f0ad122d1695$export$18a094aefa070634)(this, $7ebcbc3bb087abe6$var$_currentResult);
        const nextResult = this.createResult((0, $b8a5f0ad122d1695$export$18a094aefa070634)(this, $7ebcbc3bb087abe6$var$_currentQuery), this.options);
        (0, $b8a5f0ad122d1695$export$42432efe6614d3b4)(this, $7ebcbc3bb087abe6$var$_currentResultState, (0, $b8a5f0ad122d1695$export$18a094aefa070634)(this, $7ebcbc3bb087abe6$var$_currentQuery).state);
        (0, $b8a5f0ad122d1695$export$42432efe6614d3b4)(this, $7ebcbc3bb087abe6$var$_currentResultOptions, this.options);
        if ((0, $b8a5f0ad122d1695$export$18a094aefa070634)(this, $7ebcbc3bb087abe6$var$_currentResultState).data !== void 0) (0, $b8a5f0ad122d1695$export$42432efe6614d3b4)(this, $7ebcbc3bb087abe6$var$_lastQueryWithDefinedData, (0, $b8a5f0ad122d1695$export$18a094aefa070634)(this, $7ebcbc3bb087abe6$var$_currentQuery));
        if ((0, $aa7ba18d2eeda7da$export$3e67810a3f0e9f1c)(nextResult, prevResult)) return;
        (0, $b8a5f0ad122d1695$export$42432efe6614d3b4)(this, $7ebcbc3bb087abe6$var$_currentResult, nextResult);
        const defaultNotifyOptions = {};
        const shouldNotifyListeners = ()=>{
            if (!prevResult) return true;
            const { notifyOnChangeProps: notifyOnChangeProps } = this.options;
            const notifyOnChangePropsValue = typeof notifyOnChangeProps === "function" ? notifyOnChangeProps() : notifyOnChangeProps;
            if (notifyOnChangePropsValue === "all" || !notifyOnChangePropsValue && !(0, $b8a5f0ad122d1695$export$18a094aefa070634)(this, $7ebcbc3bb087abe6$var$_trackedProps).size) return true;
            const includedProps = new Set(notifyOnChangePropsValue ?? (0, $b8a5f0ad122d1695$export$18a094aefa070634)(this, $7ebcbc3bb087abe6$var$_trackedProps));
            if (this.options.throwOnError) includedProps.add("error");
            return Object.keys((0, $b8a5f0ad122d1695$export$18a094aefa070634)(this, $7ebcbc3bb087abe6$var$_currentResult)).some((key)=>{
                const typedKey = key;
                const changed = (0, $b8a5f0ad122d1695$export$18a094aefa070634)(this, $7ebcbc3bb087abe6$var$_currentResult)[typedKey] !== prevResult[typedKey];
                return changed && includedProps.has(typedKey);
            });
        };
        if ((notifyOptions == null ? void 0 : notifyOptions.listeners) !== false && shouldNotifyListeners()) defaultNotifyOptions.listeners = true;
        (0, $b8a5f0ad122d1695$export$fa92d15b718fce20)(this, $7ebcbc3bb087abe6$var$_notify, $7ebcbc3bb087abe6$var$notify_fn).call(this, {
            ...defaultNotifyOptions,
            ...notifyOptions
        });
    }
    onQueryUpdate() {
        this.updateResult();
        if (this.hasListeners()) (0, $b8a5f0ad122d1695$export$fa92d15b718fce20)(this, $7ebcbc3bb087abe6$var$_updateTimers, $7ebcbc3bb087abe6$var$updateTimers_fn).call(this);
    }
};
$7ebcbc3bb087abe6$var$_client = new WeakMap();
$7ebcbc3bb087abe6$var$_currentQuery = new WeakMap();
$7ebcbc3bb087abe6$var$_currentQueryInitialState = new WeakMap();
$7ebcbc3bb087abe6$var$_currentResult = new WeakMap();
$7ebcbc3bb087abe6$var$_currentResultState = new WeakMap();
$7ebcbc3bb087abe6$var$_currentResultOptions = new WeakMap();
$7ebcbc3bb087abe6$var$_selectError = new WeakMap();
$7ebcbc3bb087abe6$var$_selectFn = new WeakMap();
$7ebcbc3bb087abe6$var$_selectResult = new WeakMap();
$7ebcbc3bb087abe6$var$_lastQueryWithDefinedData = new WeakMap();
$7ebcbc3bb087abe6$var$_staleTimeoutId = new WeakMap();
$7ebcbc3bb087abe6$var$_refetchIntervalId = new WeakMap();
$7ebcbc3bb087abe6$var$_currentRefetchInterval = new WeakMap();
$7ebcbc3bb087abe6$var$_trackedProps = new WeakMap();
$7ebcbc3bb087abe6$var$_executeFetch = new WeakSet();
$7ebcbc3bb087abe6$var$executeFetch_fn = function(fetchOptions) {
    (0, $b8a5f0ad122d1695$export$fa92d15b718fce20)(this, $7ebcbc3bb087abe6$var$_updateQuery, $7ebcbc3bb087abe6$var$updateQuery_fn).call(this);
    let promise = (0, $b8a5f0ad122d1695$export$18a094aefa070634)(this, $7ebcbc3bb087abe6$var$_currentQuery).fetch(this.options, fetchOptions);
    if (!(fetchOptions == null ? void 0 : fetchOptions.throwOnError)) promise = promise.catch((0, $aa7ba18d2eeda7da$export$8793edee2d425525));
    return promise;
};
$7ebcbc3bb087abe6$var$_updateStaleTimeout = new WeakSet();
$7ebcbc3bb087abe6$var$updateStaleTimeout_fn = function() {
    (0, $b8a5f0ad122d1695$export$fa92d15b718fce20)(this, $7ebcbc3bb087abe6$var$_clearStaleTimeout, $7ebcbc3bb087abe6$var$clearStaleTimeout_fn).call(this);
    const staleTime = (0, $aa7ba18d2eeda7da$export$cb3145f011bda3ac)(this.options.staleTime, (0, $b8a5f0ad122d1695$export$18a094aefa070634)(this, $7ebcbc3bb087abe6$var$_currentQuery));
    if ((0, $aa7ba18d2eeda7da$export$6acf61af03e62db) || (0, $b8a5f0ad122d1695$export$18a094aefa070634)(this, $7ebcbc3bb087abe6$var$_currentResult).isStale || !(0, $aa7ba18d2eeda7da$export$e539f754e934e270)(staleTime)) return;
    const time = (0, $aa7ba18d2eeda7da$export$811b83d62bcf47f0)((0, $b8a5f0ad122d1695$export$18a094aefa070634)(this, $7ebcbc3bb087abe6$var$_currentResult).dataUpdatedAt, staleTime);
    const timeout = time + 1;
    (0, $b8a5f0ad122d1695$export$42432efe6614d3b4)(this, $7ebcbc3bb087abe6$var$_staleTimeoutId, setTimeout(()=>{
        if (!(0, $b8a5f0ad122d1695$export$18a094aefa070634)(this, $7ebcbc3bb087abe6$var$_currentResult).isStale) this.updateResult();
    }, timeout));
};
$7ebcbc3bb087abe6$var$_computeRefetchInterval = new WeakSet();
$7ebcbc3bb087abe6$var$computeRefetchInterval_fn = function() {
    return (typeof this.options.refetchInterval === "function" ? this.options.refetchInterval((0, $b8a5f0ad122d1695$export$18a094aefa070634)(this, $7ebcbc3bb087abe6$var$_currentQuery)) : this.options.refetchInterval) ?? false;
};
$7ebcbc3bb087abe6$var$_updateRefetchInterval = new WeakSet();
$7ebcbc3bb087abe6$var$updateRefetchInterval_fn = function(nextInterval) {
    (0, $b8a5f0ad122d1695$export$fa92d15b718fce20)(this, $7ebcbc3bb087abe6$var$_clearRefetchInterval, $7ebcbc3bb087abe6$var$clearRefetchInterval_fn).call(this);
    (0, $b8a5f0ad122d1695$export$42432efe6614d3b4)(this, $7ebcbc3bb087abe6$var$_currentRefetchInterval, nextInterval);
    if ((0, $aa7ba18d2eeda7da$export$6acf61af03e62db) || (0, $aa7ba18d2eeda7da$export$8c88ee6f2357230d)(this.options.enabled, (0, $b8a5f0ad122d1695$export$18a094aefa070634)(this, $7ebcbc3bb087abe6$var$_currentQuery)) === false || !(0, $aa7ba18d2eeda7da$export$e539f754e934e270)((0, $b8a5f0ad122d1695$export$18a094aefa070634)(this, $7ebcbc3bb087abe6$var$_currentRefetchInterval)) || (0, $b8a5f0ad122d1695$export$18a094aefa070634)(this, $7ebcbc3bb087abe6$var$_currentRefetchInterval) === 0) return;
    (0, $b8a5f0ad122d1695$export$42432efe6614d3b4)(this, $7ebcbc3bb087abe6$var$_refetchIntervalId, setInterval(()=>{
        if (this.options.refetchIntervalInBackground || (0, $941ede0c2ee4c5a4$export$6bf54661be5b02cf).isFocused()) (0, $b8a5f0ad122d1695$export$fa92d15b718fce20)(this, $7ebcbc3bb087abe6$var$_executeFetch, $7ebcbc3bb087abe6$var$executeFetch_fn).call(this);
    }, (0, $b8a5f0ad122d1695$export$18a094aefa070634)(this, $7ebcbc3bb087abe6$var$_currentRefetchInterval)));
};
$7ebcbc3bb087abe6$var$_updateTimers = new WeakSet();
$7ebcbc3bb087abe6$var$updateTimers_fn = function() {
    (0, $b8a5f0ad122d1695$export$fa92d15b718fce20)(this, $7ebcbc3bb087abe6$var$_updateStaleTimeout, $7ebcbc3bb087abe6$var$updateStaleTimeout_fn).call(this);
    (0, $b8a5f0ad122d1695$export$fa92d15b718fce20)(this, $7ebcbc3bb087abe6$var$_updateRefetchInterval, $7ebcbc3bb087abe6$var$updateRefetchInterval_fn).call(this, (0, $b8a5f0ad122d1695$export$fa92d15b718fce20)(this, $7ebcbc3bb087abe6$var$_computeRefetchInterval, $7ebcbc3bb087abe6$var$computeRefetchInterval_fn).call(this));
};
$7ebcbc3bb087abe6$var$_clearStaleTimeout = new WeakSet();
$7ebcbc3bb087abe6$var$clearStaleTimeout_fn = function() {
    if ((0, $b8a5f0ad122d1695$export$18a094aefa070634)(this, $7ebcbc3bb087abe6$var$_staleTimeoutId)) {
        clearTimeout((0, $b8a5f0ad122d1695$export$18a094aefa070634)(this, $7ebcbc3bb087abe6$var$_staleTimeoutId));
        (0, $b8a5f0ad122d1695$export$42432efe6614d3b4)(this, $7ebcbc3bb087abe6$var$_staleTimeoutId, void 0);
    }
};
$7ebcbc3bb087abe6$var$_clearRefetchInterval = new WeakSet();
$7ebcbc3bb087abe6$var$clearRefetchInterval_fn = function() {
    if ((0, $b8a5f0ad122d1695$export$18a094aefa070634)(this, $7ebcbc3bb087abe6$var$_refetchIntervalId)) {
        clearInterval((0, $b8a5f0ad122d1695$export$18a094aefa070634)(this, $7ebcbc3bb087abe6$var$_refetchIntervalId));
        (0, $b8a5f0ad122d1695$export$42432efe6614d3b4)(this, $7ebcbc3bb087abe6$var$_refetchIntervalId, void 0);
    }
};
$7ebcbc3bb087abe6$var$_updateQuery = new WeakSet();
$7ebcbc3bb087abe6$var$updateQuery_fn = function() {
    const query = (0, $b8a5f0ad122d1695$export$18a094aefa070634)(this, $7ebcbc3bb087abe6$var$_client).getQueryCache().build((0, $b8a5f0ad122d1695$export$18a094aefa070634)(this, $7ebcbc3bb087abe6$var$_client), this.options);
    if (query === (0, $b8a5f0ad122d1695$export$18a094aefa070634)(this, $7ebcbc3bb087abe6$var$_currentQuery)) return;
    const prevQuery = (0, $b8a5f0ad122d1695$export$18a094aefa070634)(this, $7ebcbc3bb087abe6$var$_currentQuery);
    (0, $b8a5f0ad122d1695$export$42432efe6614d3b4)(this, $7ebcbc3bb087abe6$var$_currentQuery, query);
    (0, $b8a5f0ad122d1695$export$42432efe6614d3b4)(this, $7ebcbc3bb087abe6$var$_currentQueryInitialState, query.state);
    if (this.hasListeners()) {
        prevQuery == null || prevQuery.removeObserver(this);
        query.addObserver(this);
    }
};
$7ebcbc3bb087abe6$var$_notify = new WeakSet();
$7ebcbc3bb087abe6$var$notify_fn = function(notifyOptions) {
    (0, $254c215b61de4d59$export$520687f44db6e1ab).batch(()=>{
        if (notifyOptions.listeners) this.listeners.forEach((listener)=>{
            listener((0, $b8a5f0ad122d1695$export$18a094aefa070634)(this, $7ebcbc3bb087abe6$var$_currentResult));
        });
        (0, $b8a5f0ad122d1695$export$18a094aefa070634)(this, $7ebcbc3bb087abe6$var$_client).getQueryCache().notify({
            query: (0, $b8a5f0ad122d1695$export$18a094aefa070634)(this, $7ebcbc3bb087abe6$var$_currentQuery),
            type: "observerResultsUpdated"
        });
    });
};
function $7ebcbc3bb087abe6$var$shouldLoadOnMount(query, options) {
    return (0, $aa7ba18d2eeda7da$export$8c88ee6f2357230d)(options.enabled, query) !== false && query.state.data === void 0 && !(query.state.status === "error" && options.retryOnMount === false);
}
function $7ebcbc3bb087abe6$var$shouldFetchOnMount(query, options) {
    return $7ebcbc3bb087abe6$var$shouldLoadOnMount(query, options) || query.state.data !== void 0 && $7ebcbc3bb087abe6$var$shouldFetchOn(query, options, options.refetchOnMount);
}
function $7ebcbc3bb087abe6$var$shouldFetchOn(query, options, field) {
    if ((0, $aa7ba18d2eeda7da$export$8c88ee6f2357230d)(options.enabled, query) !== false) {
        const value = typeof field === "function" ? field(query) : field;
        return value === "always" || value !== false && $7ebcbc3bb087abe6$var$isStale(query, options);
    }
    return false;
}
function $7ebcbc3bb087abe6$var$shouldFetchOptionally(query, prevQuery, options, prevOptions) {
    return (query !== prevQuery || (0, $aa7ba18d2eeda7da$export$8c88ee6f2357230d)(prevOptions.enabled, query) === false) && (!options.suspense || query.state.status !== "error") && $7ebcbc3bb087abe6$var$isStale(query, options);
}
function $7ebcbc3bb087abe6$var$isStale(query, options) {
    return (0, $aa7ba18d2eeda7da$export$8c88ee6f2357230d)(options.enabled, query) !== false && query.isStaleByTime((0, $aa7ba18d2eeda7da$export$cb3145f011bda3ac)(options.staleTime, query));
}
function $7ebcbc3bb087abe6$var$shouldAssignObserverCurrentProperties(observer, optimisticResult) {
    if (!(0, $aa7ba18d2eeda7da$export$3e67810a3f0e9f1c)(observer.getCurrentResult(), optimisticResult)) return true;
    return false;
}



var $cWbtJ = parcelRequire("cWbtJ");


var $cWbtJ = parcelRequire("cWbtJ");

"use client";
function $197e2e4af8c8175c$var$createValue() {
    let isReset = false;
    return {
        clearReset: ()=>{
            isReset = false;
        },
        reset: ()=>{
            isReset = true;
        },
        isReset: ()=>{
            return isReset;
        }
    };
}
var $197e2e4af8c8175c$var$QueryErrorResetBoundaryContext = $cWbtJ.createContext($197e2e4af8c8175c$var$createValue());
var $197e2e4af8c8175c$export$50dfac555130cafd = ()=>$cWbtJ.useContext($197e2e4af8c8175c$var$QueryErrorResetBoundaryContext);
var $197e2e4af8c8175c$export$ddb9962d870f2330 = ({ children: children })=>{
    const [value] = $cWbtJ.useState(()=>$197e2e4af8c8175c$var$createValue());
    return /* @__PURE__ */ (0, $9e48c988ecb997e2$exports.jsx)($197e2e4af8c8175c$var$QueryErrorResetBoundaryContext.Provider, {
        value: value,
        children: typeof children === "function" ? children(value) : children
    });
};




var $cWbtJ = parcelRequire("cWbtJ");
"use client";
var $b94677cb67accd29$var$IsRestoringContext = $cWbtJ.createContext(false);
var $b94677cb67accd29$export$4da0178d6b5f553 = ()=>$cWbtJ.useContext($b94677cb67accd29$var$IsRestoringContext);
var $b94677cb67accd29$export$593807d4e94f9621 = $b94677cb67accd29$var$IsRestoringContext.Provider;



var $cWbtJ = parcelRequire("cWbtJ");
// src/utils.ts
function $090ef198ef64b3ba$export$2072f68e6c3507cf(throwError, params) {
    if (typeof throwError === "function") return throwError(...params);
    return !!throwError;
}
function $090ef198ef64b3ba$export$8793edee2d425525() {}


"use client";
var $9a0f6fed568ab9e5$export$ae8adb3de3d77633 = (options, errorResetBoundary)=>{
    if (options.suspense || options.throwOnError) {
        if (!errorResetBoundary.isReset()) options.retryOnMount = false;
    }
};
var $9a0f6fed568ab9e5$export$b2b17ca3a1fb0229 = (errorResetBoundary)=>{
    $cWbtJ.useEffect(()=>{
        errorResetBoundary.clearReset();
    }, [
        errorResetBoundary
    ]);
};
var $9a0f6fed568ab9e5$export$1fbcf724762d607 = ({ result: result, errorResetBoundary: errorResetBoundary, throwOnError: throwOnError, query: query })=>{
    return result.isError && !errorResetBoundary.isReset() && !result.isFetching && query && (0, $090ef198ef64b3ba$export$2072f68e6c3507cf)(throwOnError, [
        result.error,
        query
    ]);
};


// src/suspense.ts
var $e5eba60ed8ead138$export$8bed2f8d02206063 = (_error, query)=>query.state.data === void 0;
var $e5eba60ed8ead138$export$274d2a1db5a20c09 = (defaultedOptions)=>{
    if (defaultedOptions.suspense) {
        if (typeof defaultedOptions.staleTime !== "number") defaultedOptions.staleTime = 1e3;
        if (typeof defaultedOptions.gcTime === "number") defaultedOptions.gcTime = Math.max(defaultedOptions.gcTime, 1e3);
    }
};
var $e5eba60ed8ead138$export$e0a3f29513afe430 = (result, isRestoring)=>result.isLoading && result.isFetching && !isRestoring;
var $e5eba60ed8ead138$export$88d3586dfed64df9 = (defaultedOptions, result)=>(defaultedOptions == null ? void 0 : defaultedOptions.suspense) && result.isPending;
var $e5eba60ed8ead138$export$defdc11a9c9acfcf = (defaultedOptions, observer, errorResetBoundary)=>observer.fetchOptimistic(defaultedOptions).catch(()=>{
        errorResetBoundary.clearReset();
    });


"use client";
function $4a85f9537a5796b3$export$fff0865807e996c5(options, Observer, queryClient) {
    var _a, _b, _c, _d;
    const client = (0, $5637d36f54c10878$export$22e77b9572c4fded)(queryClient);
    const isRestoring = (0, $b94677cb67accd29$export$4da0178d6b5f553)();
    const errorResetBoundary = (0, $197e2e4af8c8175c$export$50dfac555130cafd)();
    const defaultedOptions = client.defaultQueryOptions(options);
    (_b = (_a = client.getDefaultOptions().queries) == null ? void 0 : _a._experimental_beforeQuery) == null || _b.call(_a, defaultedOptions);
    defaultedOptions._optimisticResults = isRestoring ? "isRestoring" : "optimistic";
    (0, $e5eba60ed8ead138$export$274d2a1db5a20c09)(defaultedOptions);
    (0, $9a0f6fed568ab9e5$export$ae8adb3de3d77633)(defaultedOptions, errorResetBoundary);
    (0, $9a0f6fed568ab9e5$export$b2b17ca3a1fb0229)(errorResetBoundary);
    const [observer] = $cWbtJ.useState(()=>new Observer(client, defaultedOptions));
    const result = observer.getOptimisticResult(defaultedOptions);
    $cWbtJ.useSyncExternalStore($cWbtJ.useCallback((onStoreChange)=>{
        const unsubscribe = isRestoring ? ()=>void 0 : observer.subscribe((0, $254c215b61de4d59$export$520687f44db6e1ab).batchCalls(onStoreChange));
        observer.updateResult();
        return unsubscribe;
    }, [
        observer,
        isRestoring
    ]), ()=>observer.getCurrentResult(), ()=>observer.getCurrentResult());
    $cWbtJ.useEffect(()=>{
        observer.setOptions(defaultedOptions, {
            listeners: false
        });
    }, [
        defaultedOptions,
        observer
    ]);
    if ((0, $e5eba60ed8ead138$export$88d3586dfed64df9)(defaultedOptions, result)) throw (0, $e5eba60ed8ead138$export$defdc11a9c9acfcf)(defaultedOptions, observer, errorResetBoundary);
    if ((0, $9a0f6fed568ab9e5$export$1fbcf724762d607)({
        result: result,
        errorResetBoundary: errorResetBoundary,
        throwOnError: defaultedOptions.throwOnError,
        query: client.getQueryCache().get(defaultedOptions.queryHash)
    })) throw result.error;
    (_d = (_c = client.getDefaultOptions().queries) == null ? void 0 : _c._experimental_afterQuery) == null || _d.call(_c, defaultedOptions, result);
    return !defaultedOptions.notifyOnChangeProps ? observer.trackResult(result) : result;
}


"use client";
function $d62fc5415cb51285$export$dd0a697e1782aedd(options, queryClient) {
    return (0, $4a85f9537a5796b3$export$fff0865807e996c5)(options, (0, $7ebcbc3bb087abe6$export$a06cf8c0066f0d4c), queryClient);
}



var $jPSn7 = parcelRequire("jPSn7");
const $219aaf946aa87db5$export$2c4e825dc9120f87 = "";
const $219aaf946aa87db5$export$7c07b633a151f9c5 = new (0, $c7cf51e08e050678$export$405d0624ed55a03f)({
    defaultOptions: {
        queries: {
            retry: false
        }
    }
});
let $219aaf946aa87db5$var$busting = false;
let $219aaf946aa87db5$var$bustPromise;
const $219aaf946aa87db5$export$106117e41163122c = ()=>{
    if (!$219aaf946aa87db5$var$busting) {
        $219aaf946aa87db5$var$busting = true;
        $219aaf946aa87db5$var$bustPromise = $219aaf946aa87db5$export$7c07b633a151f9c5.invalidateQueries().finally(()=>{
            $219aaf946aa87db5$var$busting = false;
        });
    }
    // if a bust is currenctly in motion, return the same promise
    return $219aaf946aa87db5$var$bustPromise;
};
const $219aaf946aa87db5$export$7055e077554d4167 = ()=>{
    const [fetching, setFetching] = (0, $jPSn7.useCacheBusterStore)();
    (0, $cWbtJ.useEffect)(()=>{
        if (fetching) $219aaf946aa87db5$export$106117e41163122c().finally(()=>setFetching(false));
    }, [
        fetching
    ]);
    return [
        fetching,
        ()=>setFetching(true)
    ];
};
const $219aaf946aa87db5$var$request = (url, init = {})=>fetch(`${$219aaf946aa87db5$export$2c4e825dc9120f87}${url}`, {
        ...init,
        headers: {
            ...init.headers,
            cache: $219aaf946aa87db5$var$busting ? "reload" : "default"
        }
    }).then((res)=>{
        if (!res.ok) throw res;
        return res.headers.get("Content-Type")?.startsWith("text/plain") ? res.text() : res.json();
    });
const $219aaf946aa87db5$export$eb2799109db70ffd = (query, url, config)=>(0, $d62fc5415cb51285$export$dd0a697e1782aedd)({
        queryKey: [
            query,
            url ?? ""
        ],
        queryFn: ()=>$219aaf946aa87db5$var$request(url),
        enabled: Boolean(url),
        staleTime: Infinity,
        ...config || {}
    });




var $cWbtJ = parcelRequire("cWbtJ");


var $cWbtJ = parcelRequire("cWbtJ");


"use client";
function $eddad5578f9bcec5$export$625b2ff71316bcd3(filters, queryClient) {
    const client = (0, $5637d36f54c10878$export$22e77b9572c4fded)(queryClient);
    const queryCache = client.getQueryCache();
    return $cWbtJ.useSyncExternalStore($cWbtJ.useCallback((onStoreChange)=>queryCache.subscribe((0, $254c215b61de4d59$export$520687f44db6e1ab).batchCalls(onStoreChange)), [
        queryCache
    ]), ()=>client.isFetching(filters), ()=>client.isFetching(filters));
}


const $bafd6085c2106d22$var$Container = (0, $8c050ffba58637bd$export$3817b7a54a07cec7)("div")`
  position: fixed;
  z-index: 100;
  height: 2px;
  width: 100%;
  display: flex;
  top: 0;

  @media print {
    display: none;
  }
`;
const $bafd6085c2106d22$var$Bar = (0, $8c050ffba58637bd$export$3817b7a54a07cec7)("div", (0, (/*@__PURE__*/$parcel$interopDefault($cWbtJ))).forwardRef)`
  height: 100%;
  width: 0;
  opacity: 0;
  background: ${(p)=>p.theme.colors.accent};
`;
const $bafd6085c2106d22$var$TRANSITION_TIME = 400;
const $bafd6085c2106d22$var$BASE_TRANSITION = {
    transition: `all ${$bafd6085c2106d22$var$TRANSITION_TIME}ms ease-in-out`
};
// transition for the end state, make a smooth delayed fade out
const $bafd6085c2106d22$var$END_TRANSITION = {
    transition: `width ${$bafd6085c2106d22$var$TRANSITION_TIME}ms ease-in-out, opacity ${$bafd6085c2106d22$var$TRANSITION_TIME * 2}ms ${$bafd6085c2106d22$var$TRANSITION_TIME}ms`
};
const $bafd6085c2106d22$export$3b0d6d7590275603 = ()=>{
    const count = (0, $eddad5578f9bcec5$export$625b2ff71316bcd3)(); // returns the number of queries currently in flight
    const [active, setActive] = (0, $cWbtJ.useState)(false);
    const progress = count ? Math.round((1 - count / (count + 3)) * 100) : 100;
    let style = {
        ...$bafd6085c2106d22$var$BASE_TRANSITION,
        opacity: 1,
        width: `${progress}%`
    };
    // no active queries, set the loader to 100% or 0 when inactive
    if (!count) style = {
        ...$bafd6085c2106d22$var$END_TRANSITION,
        opacity: 0,
        width: active ? "100%" : 0
    };
    (0, $cWbtJ.useEffect)(()=>{
        let t;
        // if the loader is inactive and there is active queries, set it to active
        if (count && !active) setActive(true);
        if (!count && active) // after finishing, set the loader to inactive when fade-out is done
        t = window.setTimeout(()=>setActive(false), $bafd6085c2106d22$var$TRANSITION_TIME * 3);
        return ()=>window.clearTimeout(t);
    }, [
        count,
        active
    ]);
    return /*#__PURE__*/ (0, $9e48c988ecb997e2$exports.jsx)($bafd6085c2106d22$var$Container, {
        children: /*#__PURE__*/ (0, $9e48c988ecb997e2$exports.jsx)($bafd6085c2106d22$var$Bar, {
            style: style
        })
    });
};




var $cWbtJ = parcelRequire("cWbtJ");


var $jPSn7 = parcelRequire("jPSn7");


var $cWbtJ = parcelRequire("cWbtJ");


var $jPSn7 = parcelRequire("jPSn7");

const $774ae458d41d9a89$export$b3611e87cd5ba6ce = ()=>{
    const { data: data, error: error } = (0, $219aaf946aa87db5$export$eb2799109db70ffd)("config", "/config");
    // make it possible to directly destructure templates and resources from useConfig
    const { templates: templates, resources: resources } = data ?? {};
    return {
        templates: templates,
        resources: resources,
        error: error
    };
};



var $60bvA = parcelRequire("60bvA");
const $7dd950946054eea5$export$3a5ae2edeb8648ad = ()=>{
    const ref = (0, $cWbtJ.useRef)(null);
    (0, $cWbtJ.useEffect)(()=>{
        if (!ref.current) return;
        const el = ref.current;
        let resizeTimer;
        let size = el.getBoundingClientRect();
        let prevY = window.scrollY;
        let y = prevY;
        let elY = 0;
        const loop = ()=>{
            y = Math.round(window.scrollY);
            if (y === prevY) return;
            const dir = prevY > y ? "up" : "down";
            if (dir === "down" && elY <= size.height && y > 0) {
                elY = elY + (y - prevY);
                el.style.transform = `translateY(-${Math.round(elY)}px)`;
            }
            if (dir === "up" && elY >= 0) {
                if (elY > size.height) elY = size.height;
                elY = elY - (prevY - y);
                el.style.transform = `translateY(-${Math.round(elY > 0 ? elY : 0)}px)`;
            }
            prevY = y;
            window.requestAnimationFrame(loop);
        };
        const scroll = ()=>window.requestAnimationFrame(loop);
        const getRect = ()=>{
            window.clearTimeout(resizeTimer);
            resizeTimer = window.setTimeout(()=>{
                size = el.getBoundingClientRect();
            }, 250);
        };
        window.addEventListener("scroll", scroll);
        window.addEventListener("resize", getRect);
        const observer = new MutationObserver(()=>{
            getRect();
        });
        observer.observe(el, {
            subtree: true,
            childList: true
        });
        return ()=>{
            window.removeEventListener("scroll", scroll);
            window.removeEventListener("resize", getRect);
            window.clearTimeout(resizeTimer);
            observer.disconnect();
        };
    }, []);
    return ref;
};
const $7dd950946054eea5$export$54c70f22f548bff8 = (active, close)=>{
    const ref = (0, $cWbtJ.useRef)(null);
    const cb = (0, $cWbtJ.useRef)();
    cb.current = close;
    (0, $cWbtJ.useEffect)(()=>{
        const listener = (e)=>{
            const t = e.target;
            if (!(t && ref.current?.contains(t))) cb.current?.();
        };
        if (active) setTimeout(()=>document.addEventListener("click", listener));
        return ()=>{
            document.removeEventListener("click", listener);
        };
    }, [
        active
    ]);
    return ref;
};
const $7dd950946054eea5$export$dd42f485803cd57d = (...args)=>{
    const [bp] = args;
    const getMql = ()=>window.matchMedia((0, $8c53fefc62d3de5b$export$b5ef74bd35083b44)(bp).replace("@media ", ""));
    const [matches, setMatches] = (0, $cWbtJ.useState)(()=>getMql().matches);
    const [, setSidebar] = (0, $jPSn7.useSidebarLeftStore)();
    (0, $cWbtJ.useEffect)(()=>{
        const mql = window.matchMedia((0, $8c53fefc62d3de5b$export$b5ef74bd35083b44)(bp).replace("@media ", ""));
        const listener = ({ matches: matches })=>{
            setMatches(matches);
            if (!matches) setSidebar(false);
        };
        mql.addEventListener("change", listener);
        return ()=>{
            mql.removeEventListener("change", listener);
        };
    }, [
        bp
    ]);
    return matches;
};
const $7dd950946054eea5$export$519e1c3cd05586c0 = ()=>{
    const { templates: templates } = (0, $774ae458d41d9a89$export$b3611e87cd5ba6ce)();
    return (customId)=>(0, $60bvA.getMemoizedTemplate)(templates, customId);
};
const $7dd950946054eea5$export$e8b771555dc4a003 = (cb)=>{
    const f = (0, $cWbtJ.useRef)(cb);
    f.current = cb;
    (0, $cWbtJ.useEffect)(()=>{
        f.current();
        const listener = (e)=>f.current(e);
        window.addEventListener("resize", listener);
        return ()=>window.removeEventListener("resize", listener);
    }, [
        cb
    ]);
};



parcelRequire("cWbtJ");

/**
 * Most icons here are taken from the Feather icon set at icomoon.io
 */ const $f6506ab558833d48$var$SvgRoot = (0, $8c050ffba58637bd$export$3817b7a54a07cec7)("svg")`
  path {
    fill: ${(p)=>p.theme.colors.text};
  }
`;
const $f6506ab558833d48$var$Svg = ({ children: children, ...props })=>/*#__PURE__*/ (0, $9e48c988ecb997e2$exports.jsx)($f6506ab558833d48$var$SvgRoot, {
        version: "1.1",
        xmlns: "http://www.w3.org/2000/svg",
        width: "32",
        height: "32",
        viewBox: "0 0 24 24",
        ...props,
        children: children
    });
const $f6506ab558833d48$export$6d234affb3eeb911 = /*#__PURE__*/ (0, $9e48c988ecb997e2$exports.jsx)($f6506ab558833d48$var$Svg, {
    id: "icon-sun",
    viewBox: "0 0 1101 750",
    children: /*#__PURE__*/ (0, $9e48c988ecb997e2$exports.jsx)("path", {
        d: "M1101 199L551 750 0 199 198 0l353 353L904 0z"
    })
});
const $f6506ab558833d48$export$10942cc2688901b9 = /*#__PURE__*/ (0, $9e48c988ecb997e2$exports.jsx)($f6506ab558833d48$var$Svg, {
    id: "icon-sun",
    children: /*#__PURE__*/ (0, $9e48c988ecb997e2$exports.jsx)("path", {
        d: "M18 12c0-1.657-0.673-3.158-1.757-4.243s-2.586-1.757-4.243-1.757-3.158 0.673-4.243 1.757-1.757 2.586-1.757 4.243 0.673 3.158 1.757 4.243 2.586 1.757 4.243 1.757 3.158-0.673 4.243-1.757 1.757-2.586 1.757-4.243zM16 12c0 1.105-0.447 2.103-1.172 2.828s-1.723 1.172-2.828 1.172-2.103-0.447-2.828-1.172-1.172-1.723-1.172-2.828 0.447-2.103 1.172-2.828 1.723-1.172 2.828-1.172 2.103 0.447 2.828 1.172 1.172 1.723 1.172 2.828zM11 1v2c0 0.552 0.448 1 1 1s1-0.448 1-1v-2c0-0.552-0.448-1-1-1s-1 0.448-1 1zM11 21v2c0 0.552 0.448 1 1 1s1-0.448 1-1v-2c0-0.552-0.448-1-1-1s-1 0.448-1 1zM3.513 4.927l1.42 1.42c0.391 0.391 1.024 0.391 1.414 0s0.391-1.024 0-1.414l-1.42-1.42c-0.391-0.391-1.024-0.391-1.414 0s-0.391 1.024 0 1.414zM17.653 19.067l1.42 1.42c0.391 0.391 1.024 0.391 1.414 0s0.391-1.024 0-1.414l-1.42-1.42c-0.391-0.391-1.024-0.391-1.414 0s-0.391 1.024 0 1.414zM1 13h2c0.552 0 1-0.448 1-1s-0.448-1-1-1h-2c-0.552 0-1 0.448-1 1s0.448 1 1 1zM21 13h2c0.552 0 1-0.448 1-1s-0.448-1-1-1h-2c-0.552 0-1 0.448-1 1s0.448 1 1 1zM4.927 20.487l1.42-1.42c0.391-0.391 0.391-1.024 0-1.414s-1.024-0.391-1.414 0l-1.42 1.42c-0.391 0.391-0.391 1.024 0 1.414s1.024 0.391 1.414 0zM19.067 6.347l1.42-1.42c0.391-0.391 0.391-1.024 0-1.414s-1.024-0.391-1.414 0l-1.42 1.42c-0.391 0.391-0.391 1.024 0 1.414s1.024 0.391 1.414 0z"
    })
});
const $f6506ab558833d48$export$71180a2f62733d6f = /*#__PURE__*/ (0, $9e48c988ecb997e2$exports.jsx)($f6506ab558833d48$var$Svg, {
    id: "icon-moon",
    children: /*#__PURE__*/ (0, $9e48c988ecb997e2$exports.jsx)("path", {
        d: "M21.996 12.882c0.022-0.233-0.038-0.476-0.188-0.681-0.325-0.446-0.951-0.544-1.397-0.219-0.95 0.693-2.060 1.086-3.188 1.162-1.368 0.092-2.765-0.283-3.95-1.158-1.333-0.985-2.139-2.415-2.367-3.935s0.124-3.124 1.109-4.456c0.142-0.191 0.216-0.435 0.191-0.691-0.053-0.55-0.542-0.952-1.092-0.898-2.258 0.22-4.314 1.18-5.895 2.651-1.736 1.615-2.902 3.847-3.137 6.386-0.254 2.749 0.631 5.343 2.266 7.311s4.022 3.313 6.772 3.567 5.343-0.631 7.311-2.266 3.313-4.022 3.567-6.772zM19.567 14.674c-0.49 1.363-1.335 2.543-2.416 3.441-1.576 1.309-3.648 2.016-5.848 1.813s-4.108-1.278-5.417-2.854-2.016-3.648-1.813-5.848c0.187-2.032 1.117-3.814 2.507-5.106 0.782-0.728 1.71-1.3 2.731-1.672-0.456 1.264-0.577 2.606-0.384 3.899 0.303 2.023 1.38 3.934 3.156 5.247 1.578 1.167 3.448 1.668 5.272 1.545 0.752-0.050 1.496-0.207 2.21-0.465z"
    })
});
const $f6506ab558833d48$export$cd267689a473783a = /*#__PURE__*/ (0, $9e48c988ecb997e2$exports.jsx)($f6506ab558833d48$var$Svg, {
    id: "icon-reload",
    children: /*#__PURE__*/ (0, $9e48c988ecb997e2$exports.jsx)("path", {
        d: "M4.453 9.334c0.737-2.083 2.247-3.669 4.096-4.552s4.032-1.059 6.114-0.322c1.186 0.42 2.206 1.088 2.983 1.88l2.83 2.66h-3.476c-0.552 0-1 0.448-1 1s0.448 1 1 1h5.997c0.005 0 0.009 0 0.014 0 0.137-0.001 0.268-0.031 0.386-0.082 0.119-0.051 0.229-0.126 0.324-0.225 0.012-0.013 0.024-0.026 0.036-0.039 0.075-0.087 0.133-0.183 0.173-0.285s0.064-0.211 0.069-0.326c0.001-0.015 0.001-0.029 0.001-0.043v-6c0-0.552-0.448-1-1-1s-1 0.448-1 1v3.689l-2.926-2.749c-0.992-1.010-2.271-1.843-3.743-2.364-2.603-0.921-5.335-0.699-7.643 0.402s-4.199 3.086-5.12 5.689c-0.185 0.52 0.088 1.091 0.608 1.276s1.092-0.088 1.276-0.609zM2 16.312l2.955 2.777c1.929 1.931 4.49 2.908 7.048 2.909s5.119-0.975 7.072-2.927c1.104-1.104 1.901-2.407 2.361-3.745 0.18-0.522-0.098-1.091-0.621-1.271s-1.091 0.098-1.271 0.621c-0.361 1.050-0.993 2.091-1.883 2.981-1.563 1.562-3.609 2.342-5.657 2.342s-4.094-0.782-5.679-2.366l-2.8-2.633h3.475c0.552 0 1-0.448 1-1s-0.448-1-1-1h-5.997c-0.005 0-0.009 0-0.014 0-0.137 0.001-0.268 0.031-0.386 0.082-0.119 0.051-0.229 0.126-0.324 0.225-0.012 0.013-0.024 0.026-0.036 0.039-0.075 0.087-0.133 0.183-0.173 0.285s-0.064 0.211-0.069 0.326c-0.001 0.015-0.001 0.029-0.001 0.043v6c0 0.552 0.448 1 1 1s1-0.448 1-1z"
    })
});
const $f6506ab558833d48$export$7e6f996a3a398378 = /*#__PURE__*/ (0, $9e48c988ecb997e2$exports.jsxs)($f6506ab558833d48$var$Svg, {
    id: "icon-download",
    viewBox: "0 0 512 512",
    children: [
        /*#__PURE__*/ (0, $9e48c988ecb997e2$exports.jsx)("path", {
            d: "M243.591,309.362c3.272,4.317,7.678,6.692,12.409,6.692c4.73,0,9.136-2.376,12.409-6.689l89.594-118.094   c3.348-4.414,4.274-8.692,2.611-12.042c-1.666-3.35-5.631-5.198-11.168-5.198H315.14c-9.288,0-16.844-7.554-16.844-16.84V59.777   c0-11.04-8.983-20.027-20.024-20.027h-44.546c-11.04,0-20.022,8.987-20.022,20.027v97.415c0,9.286-7.556,16.84-16.844,16.84   h-34.305c-5.538,0-9.503,1.848-11.168,5.198c-1.665,3.35-0.738,7.628,2.609,12.046L243.591,309.362z"
        }),
        /*#__PURE__*/ (0, $9e48c988ecb997e2$exports.jsx)("path", {
            d: "M445.218,294.16v111.304H66.782V294.16H0v152.648c0,14.03,11.413,25.443,25.441,25.443h461.118   c14.028,0,25.441-11.413,25.441-25.443V294.16H445.218z"
        })
    ]
});
const $f6506ab558833d48$export$bcef9c3524fbd93f = /*#__PURE__*/ (0, $9e48c988ecb997e2$exports.jsx)($f6506ab558833d48$var$Svg, {
    id: "icon-user",
    children: /*#__PURE__*/ (0, $9e48c988ecb997e2$exports.jsx)("path", {
        d: "M21 21v-2c0-1.38-0.561-2.632-1.464-3.536s-2.156-1.464-3.536-1.464h-8c-1.38 0-2.632 0.561-3.536 1.464s-1.464 2.156-1.464 3.536v2c0 0.552 0.448 1 1 1s1-0.448 1-1v-2c0-0.829 0.335-1.577 0.879-2.121s1.292-0.879 2.121-0.879h8c0.829 0 1.577 0.335 2.121 0.879s0.879 1.292 0.879 2.121v2c0 0.552 0.448 1 1 1s1-0.448 1-1zM17 7c0-1.38-0.561-2.632-1.464-3.536s-2.156-1.464-3.536-1.464-2.632 0.561-3.536 1.464-1.464 2.156-1.464 3.536 0.561 2.632 1.464 3.536 2.156 1.464 3.536 1.464 2.632-0.561 3.536-1.464 1.464-2.156 1.464-3.536zM15 7c0 0.829-0.335 1.577-0.879 2.121s-1.292 0.879-2.121 0.879-1.577-0.335-2.121-0.879-0.879-1.292-0.879-2.121 0.335-1.577 0.879-2.121 1.292-0.879 2.121-0.879 1.577 0.335 2.121 0.879 0.879 1.292 0.879 2.121z"
    })
});
const $f6506ab558833d48$export$d43c550b8e4c2ed9 = /*#__PURE__*/ (0, $9e48c988ecb997e2$exports.jsx)($f6506ab558833d48$var$Svg, {
    id: "icon-variant",
    children: /*#__PURE__*/ (0, $9e48c988ecb997e2$exports.jsx)("path", {
        d: "M12 3.118l7.764 3.882-7.764 3.882-7.764-3.882zM11.553 1.106l-10 5c-0.494 0.247-0.694 0.847-0.447 1.341 0.101 0.203 0.261 0.356 0.447 0.447l10 5c0.292 0.146 0.62 0.136 0.894 0l10-5c0.494-0.247 0.694-0.848 0.447-1.342-0.101-0.202-0.262-0.355-0.447-0.447l-10-5c-0.292-0.146-0.62-0.136-0.894 0zM1.553 17.894l10 5c0.292 0.146 0.62 0.136 0.894 0l10-5c0.494-0.247 0.694-0.848 0.447-1.342s-0.848-0.694-1.342-0.447l-9.552 4.777-9.553-4.776c-0.494-0.247-1.095-0.047-1.342 0.447s-0.047 1.095 0.447 1.342zM1.553 12.894l10 5c0.292 0.146 0.62 0.136 0.894 0l10-5c0.494-0.247 0.694-0.848 0.447-1.342s-0.848-0.694-1.342-0.447l-9.552 4.777-9.553-4.776c-0.494-0.247-1.095-0.047-1.342 0.447s-0.047 1.095 0.447 1.342z"
    })
});
const $f6506ab558833d48$export$f0653e69c94e26a4 = /*#__PURE__*/ (0, $9e48c988ecb997e2$exports.jsx)($f6506ab558833d48$var$Svg, {
    id: "icon-role",
    children: /*#__PURE__*/ (0, $9e48c988ecb997e2$exports.jsx)("path", {
        d: "M18 21v-2c0-1.38-0.561-2.632-1.464-3.536s-2.156-1.464-3.536-1.464h-8c-1.38 0-2.632 0.561-3.536 1.464s-1.464 2.156-1.464 3.536v2c0 0.552 0.448 1 1 1s1-0.448 1-1v-2c0-0.829 0.335-1.577 0.879-2.121s1.292-0.879 2.121-0.879h8c0.829 0 1.577 0.335 2.121 0.879s0.879 1.292 0.879 2.121v2c0 0.552 0.448 1 1 1s1-0.448 1-1zM14 7c0-1.38-0.561-2.632-1.464-3.536s-2.156-1.464-3.536-1.464-2.632 0.561-3.536 1.464-1.464 2.156-1.464 3.536 0.561 2.632 1.464 3.536 2.156 1.464 3.536 1.464 2.632-0.561 3.536-1.464 1.464-2.156 1.464-3.536zM12 7c0 0.829-0.335 1.577-0.879 2.121s-1.292 0.879-2.121 0.879-1.577-0.335-2.121-0.879-0.879-1.292-0.879-2.121 0.335-1.577 0.879-2.121 1.292-0.879 2.121-0.879 1.577 0.335 2.121 0.879 0.879 1.292 0.879 2.121zM24 21v-2c-0.001-1.245-0.457-2.385-1.215-3.261-0.652-0.753-1.528-1.311-2.529-1.576-0.534-0.141-1.081 0.177-1.222 0.711s0.177 1.081 0.711 1.222c0.607 0.161 1.136 0.498 1.528 0.952 0.454 0.526 0.726 1.206 0.727 1.952v2c0 0.552 0.448 1 1 1s1-0.448 1-1zM15.752 4.099c0.803 0.206 1.445 0.715 1.837 1.377s0.531 1.47 0.325 2.273c-0.176 0.688-0.575 1.256-1.105 1.652-0.314 0.235-0.675 0.409-1.063 0.511-0.534 0.14-0.854 0.687-0.713 1.221s0.687 0.854 1.221 0.713c0.637-0.167 1.232-0.455 1.752-0.844 0.884-0.66 1.552-1.613 1.845-2.758 0.342-1.337 0.11-2.689-0.542-3.788s-1.725-1.953-3.062-2.296c-0.535-0.137-1.080 0.186-1.217 0.721s0.186 1.080 0.721 1.217z"
    })
});
const $f6506ab558833d48$export$a22c1fe0e4ab6fe0 = /*#__PURE__*/ (0, $9e48c988ecb997e2$exports.jsx)($f6506ab558833d48$var$Svg, {
    id: "icon-role",
    children: /*#__PURE__*/ (0, $9e48c988ecb997e2$exports.jsx)("path", {
        d: "M16.951 11c-0.214-2.69-1.102-5.353-2.674-7.71 1.57 0.409 2.973 1.232 4.087 2.346 1.408 1.408 2.351 3.278 2.581 5.364zM14.279 20.709c1.483-2.226 2.437-4.853 2.669-7.709h3.997c-0.23 2.086-1.173 3.956-2.581 5.364-1.113 1.113-2.516 1.936-4.085 2.345zM7.049 13c0.214 2.69 1.102 5.353 2.674 7.71-1.57-0.409-2.973-1.232-4.087-2.346-1.408-1.408-2.351-3.278-2.581-5.364zM9.721 3.291c-1.482 2.226-2.436 4.853-2.669 7.709h-3.997c0.23-2.086 1.173-3.956 2.581-5.364 1.114-1.113 2.516-1.936 4.085-2.345zM12.004 1c0 0 0 0 0 0-3.044 0.001-5.794 1.233-7.782 3.222-1.99 1.989-3.222 4.741-3.222 7.778s1.232 5.789 3.222 7.778c1.988 1.989 4.738 3.221 7.774 3.222 0 0 0 0 0 0 3.044-0.001 5.793-1.233 7.782-3.222 1.99-1.989 3.222-4.741 3.222-7.778s-1.232-5.789-3.222-7.778c-1.988-1.989-4.738-3.221-7.774-3.222zM14.946 13c-0.252 2.788-1.316 5.36-2.945 7.451-1.729-2.221-2.706-4.818-2.945-7.451zM11.999 3.549c1.729 2.221 2.706 4.818 2.945 7.451h-5.89c0.252-2.788 1.316-5.36 2.945-7.451z"
    })
});
const $f6506ab558833d48$export$90833123e146f015 = /*#__PURE__*/ (0, $9e48c988ecb997e2$exports.jsx)($f6506ab558833d48$var$Svg, {
    id: "icon-template",
    children: /*#__PURE__*/ (0, $9e48c988ecb997e2$exports.jsx)("path", {
        d: "M5 2c-0.828 0-1.58 0.337-2.121 0.879s-0.879 1.293-0.879 2.121v14c0 0.828 0.337 1.58 0.879 2.121s1.293 0.879 2.121 0.879h14c0.828 0 1.58-0.337 2.121-0.879s0.879-1.293 0.879-2.121v-14c0-0.828-0.337-1.58-0.879-2.121s-1.293-0.879-2.121-0.879zM5 4h14c0.276 0 0.525 0.111 0.707 0.293s0.293 0.431 0.293 0.707v14c0 0.276-0.111 0.525-0.293 0.707s-0.431 0.293-0.707 0.293h-14c-0.276 0-0.525-0.111-0.707-0.293s-0.293-0.431-0.293-0.707v-14c0-0.276 0.111-0.525 0.293-0.707s0.431-0.293 0.707-0.293zM7 6c-0.552 0-1 0.448-1 1v9c0 0.552 0.448 1 1 1h3c0.552 0 1-0.448 1-1v-9c0-0.552-0.448-1-1-1zM8 8h1v7h-1zM14 6c-0.552 0-1 0.448-1 1v5c0 0.552 0.448 1 1 1h3c0.552 0 1-0.448 1-1v-5c0-0.552-0.448-1-1-1zM15 8h1v3h-1z"
    })
});
const $f6506ab558833d48$export$f170a4153afb9244 = /*#__PURE__*/ (0, $9e48c988ecb997e2$exports.jsx)($f6506ab558833d48$var$Svg, {
    id: "icon-theme",
    children: /*#__PURE__*/ (0, $9e48c988ecb997e2$exports.jsx)("path", {
        d: "M5 2c-0.828 0-1.58 0.337-2.121 0.879s-0.879 1.293-0.879 2.121v14c0 0.828 0.337 1.58 0.879 2.121s1.293 0.879 2.121 0.879h14c0.828 0 1.58-0.337 2.121-0.879s0.879-1.293 0.879-2.121v-14c0-0.828-0.337-1.58-0.879-2.121s-1.293-0.879-2.121-0.879zM11 8.5c0-0.69-0.281-1.316-0.732-1.768s-1.078-0.732-1.768-0.732-1.316 0.281-1.768 0.732-0.732 1.078-0.732 1.768 0.281 1.316 0.732 1.768 1.078 0.732 1.768 0.732 1.316-0.281 1.768-0.732 0.732-1.078 0.732-1.768zM9 8.5c0 0.138-0.055 0.262-0.146 0.354s-0.216 0.146-0.354 0.146-0.262-0.055-0.354-0.146-0.146-0.216-0.146-0.354 0.055-0.262 0.146-0.354 0.216-0.146 0.354-0.146 0.262 0.055 0.354 0.146 0.146 0.216 0.146 0.354zM7.414 20l8.586-8.586 4 4v3.586c0 0.276-0.111 0.525-0.293 0.707s-0.431 0.293-0.707 0.293zM20 12.586l-3.293-3.293c-0.391-0.391-1.024-0.391-1.414 0l-10.644 10.644c-0.135-0.050-0.255-0.129-0.356-0.23-0.182-0.182-0.293-0.431-0.293-0.707v-14c0-0.276 0.111-0.525 0.293-0.707s0.431-0.293 0.707-0.293h14c0.276 0 0.525 0.111 0.707 0.293s0.293 0.431 0.293 0.707z"
    })
});
const $f6506ab558833d48$export$db7947882cecde5c = /*#__PURE__*/ (0, $9e48c988ecb997e2$exports.jsx)($f6506ab558833d48$var$Svg, {
    id: "icon-theme",
    children: /*#__PURE__*/ (0, $9e48c988ecb997e2$exports.jsx)("path", {
        d: "M12 4h7c0.276 0 0.525 0.111 0.707 0.293s0.293 0.431 0.293 0.707v14c0 0.276-0.111 0.525-0.293 0.707s-0.431 0.293-0.707 0.293h-7c-0.552 0-1 0.448-1 1s0.448 1 1 1h7c0.828 0 1.58-0.337 2.121-0.879s0.879-1.293 0.879-2.121v-14c0-0.828-0.337-1.58-0.879-2.121s-1.293-0.879-2.121-0.879h-7c-0.552 0-1 0.448-1 1s0.448 1 1 1zM12 2h-7c-0.828 0-1.58 0.337-2.121 0.879s-0.879 1.293-0.879 2.121v14c0 0.828 0.337 1.58 0.879 2.121s1.293 0.879 2.121 0.879h7c0.552 0 1-0.448 1-1s-0.448-1-1-1h-7c-0.276 0-0.525-0.111-0.707-0.293s-0.293-0.431-0.293-0.707v-14c0-0.276 0.111-0.525 0.293-0.707s0.431-0.293 0.707-0.293h7c0.552 0 1-0.448 1-1s-0.448-1-1-1zM11 3v18c0 0.552 0.448 1 1 1s1-0.448 1-1v-18c0-0.552-0.448-1-1-1s-1 0.448-1 1z"
    })
});




var $cWbtJ = parcelRequire("cWbtJ");


var $jPSn7 = parcelRequire("jPSn7");




var $cWbtJ = parcelRequire("cWbtJ");

// wraps promise to never throw, return tuple with error/data instead
const $3c44f2d420ce32e0$export$73477385132b4766 = (p)=>(typeof p === "function" ? p() : p).then((res)=>{
        if (res instanceof Response && !res.ok) throw Error(`${res.status}: ${res.statusText}`);
        return [
            null,
            res
        ];
    }).catch((err)=>{
        let msg = "";
        if (err instanceof Error) msg = err.message;
        try {
            msg = msg || JSON.stringify(err);
        } catch (error) {
            msg = String(err);
        }
        return [
            msg,
            null
        ];
    });


const $eeaae3a09ba9e481$var$Button = (0, $8c050ffba58637bd$export$3817b7a54a07cec7)("button")`
  position: absolute;
  right: 10px;
  bottom: calc(100% + 10px);
  padding: 12px;
  display: flex;
  border-radius: 50%;
  background: ${(p)=>p.color};
  color: inherit;
  cursor: pointer;

  svg {
    width: 24px;
    height: 24px;
    position: relative;
    top: -2px;

    path {
      fill: currentColor;
    }
  }

  ${(p)=>p.loading ? `

          pointer-events: none;
          cursor: default;

          > svg path:nth-child(1) {
            display: none;
          }
        ` : `
          &:hover svg path {
            fill: ${p.theme.colors.text};
          }
        `}
`;
const $eeaae3a09ba9e481$var$arrowAnimation = (0, $8c050ffba58637bd$export$d25ddfdf17c3ad3e)`
  from {
    transform: translate(-50%, -25px);
  } to {
    transform: translate(-50%, 20px);
  }
`;
const $eeaae3a09ba9e481$var$AnimatedArrow = (0, $8c050ffba58637bd$export$3817b7a54a07cec7)("span")`
  display: block;
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 29px;
  overflow: hidden;

  svg {
    position: absolute;
    left: 50%;
    top: 10px;
    animation: ${$eeaae3a09ba9e481$var$arrowAnimation} linear 1s infinite;
    animation-delay: -0.55s;

    path:nth-child(2) {
      display: none;
    }
  }
`;
const $eeaae3a09ba9e481$var$Progress = (0, $8c050ffba58637bd$export$3817b7a54a07cec7)("span", (0, (/*@__PURE__*/$parcel$interopDefault($cWbtJ))).forwardRef)`
  position: absolute;
  z-index: -1;
  top: -4px;
  left: -4px;
  width: calc(100% + 8px);
  height: calc(100% + 8px);
  border-radius: 50%;
  background: conic-gradient(
    #fff var(--download-progress),
    transparent var(--download-progress)
  );
  transition: --download-progress 0.3s ease-in-out;
`;
// chunks are seperated by ;json; if json string, otherwise it's a pdf chunk
const $eeaae3a09ba9e481$var$isJson = (str)=>str.startsWith(";json;");
const $eeaae3a09ba9e481$var$parse = (str)=>str.split(";json;").filter(Boolean).map((s)=>JSON.parse(s));
const $eeaae3a09ba9e481$export$fc9722a813484b48 = ({ url: url, color: color, filename: filename })=>{
    const [loading, setLoading] = (0, $cWbtJ.useState)(false);
    const [progress, setProgress] = (0, $cWbtJ.useState)(0);
    const finish = (error)=>{
        setLoading(false);
        setProgress(0);
        if (error) alert(error);
    };
    const download = async ()=>{
        setLoading(true);
        const decoder = new TextDecoder();
        const [error, res] = await (0, $3c44f2d420ce32e0$export$73477385132b4766)(fetch(url));
        if (error) return finish(error);
        let chunks = [];
        let errorMessage = "";
        try {
            for await (const chunk of res.body){
                // decode chunk as text
                const text = decoder.decode(chunk);
                if (!$eeaae3a09ba9e481$var$isJson(text)) {
                    // if it's not json, it's a pdf chunk, push it into array to be combined later
                    chunks.push(chunk);
                    setProgress((p)=>p < 90 ? p + 5 : p);
                    continue;
                }
                for (const data of $eeaae3a09ba9e481$var$parse(text))if ("progress" in data) setProgress(Math.round(data.progress * 100));
                else {
                    errorMessage = data.error;
                    break;
                }
            }
        } catch (err) {
            errorMessage = err instanceof Error ? err.message : "Something went wrong...";
        }
        if (errorMessage) return finish(errorMessage);
        setProgress(100);
        // let animation play out to 100%
        setTimeout(()=>{
            finish();
            // make a new pdf blob of pdf chunks, craete a link to download it and click it
            const objectUrl = URL.createObjectURL(new Blob(chunks, {
                type: "application/pdf"
            }));
            const link = document.createElement("a");
            link.href = objectUrl;
            link.download = filename;
            link.click();
            // revoke the object url to free up memory
            URL.revokeObjectURL(objectUrl);
        }, 300);
    };
    return /*#__PURE__*/ (0, $9e48c988ecb997e2$exports.jsxs)($eeaae3a09ba9e481$var$Button, {
        color: color,
        loading: loading ? 1 : 0,
        disabled: loading,
        onClick: download,
        children: [
            (0, $f6506ab558833d48$export$7e6f996a3a398378),
            loading && /*#__PURE__*/ (0, $9e48c988ecb997e2$exports.jsxs)((0, $9e48c988ecb997e2$exports.Fragment), {
                children: [
                    /*#__PURE__*/ (0, $9e48c988ecb997e2$exports.jsx)($eeaae3a09ba9e481$var$AnimatedArrow, {
                        children: (0, $f6506ab558833d48$export$7e6f996a3a398378)
                    }),
                    /*#__PURE__*/ (0, $9e48c988ecb997e2$exports.jsx)($eeaae3a09ba9e481$var$Progress, {
                        style: // set the download progress as a css variable to use in the gradient animation
                        {
                            "--download-progress": `${progress}%`
                        }
                    })
                ]
            })
        ]
    });
};



var $60bvA = parcelRequire("60bvA");

const $e2ccd29707c15da5$var$Container = (0, $8c050ffba58637bd$export$3817b7a54a07cec7)("div")`
  position: fixed;
  left: 0;
  bottom: 0;
  width: 100%;
  display: flex;
  background: ${(p)=>p.background ?? p.theme.colors.contrast};
  z-index: 1;
  justify-content: space-between;
  align-items: center;
  padding: 4px 6px;
  font-size: 1.4rem;
  color: ${(p)=>p.theme.colors.dimmed};

  @media print {
    display: none;
  }
`;
const $e2ccd29707c15da5$export$3ae18a2a755cc9c8 = (p)=>{
    const { resources: resources } = (0, $774ae458d41d9a89$export$b3611e87cd5ba6ce)();
    const [[template, templateTheme]] = (0, $jPSn7.useTemplateStore)();
    const [{ chars: chars, words: words, nPages: nPages }] = (0, $jPSn7.useDocumentInfoStore)();
    const [doc] = (0, $jPSn7.useDocStore)();
    const url = `${(0, $219aaf946aa87db5$export$2c4e825dc9120f87)}/download/pdf/${doc}?template=${template}&theme=${templateTheme}`;
    const selectedProfileName = (0, $cWbtJ.useMemo)(()=>resources?.reduce((acc, r)=>r.profiles.find((p)=>p.id === doc) ? r.name : acc, undefined), [
        doc,
        resources
    ]);
    return /*#__PURE__*/ (0, $9e48c988ecb997e2$exports.jsxs)($e2ccd29707c15da5$var$Container, {
        ...p,
        children: [
            /*#__PURE__*/ (0, $9e48c988ecb997e2$exports.jsxs)("span", {
                children: [
                    /*#__PURE__*/ (0, $9e48c988ecb997e2$exports.jsx)("em", {
                        children: chars
                    }),
                    " characters, ",
                    /*#__PURE__*/ (0, $9e48c988ecb997e2$exports.jsx)("em", {
                        children: words
                    }),
                    " words,",
                    " ",
                    /*#__PURE__*/ (0, $9e48c988ecb997e2$exports.jsxs)("em", {
                        children: [
                            nPages,
                            " pages"
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $9e48c988ecb997e2$exports.jsx)((0, $eeaae3a09ba9e481$export$fc9722a813484b48), {
                color: p.background,
                url: url,
                filename: `${(0, $60bvA.str2filename)(selectedProfileName ?? "pdf")}.pdf`
            })
        ]
    });
};





var $cWbtJ = parcelRequire("cWbtJ");


var $jPSn7 = parcelRequire("jPSn7");

parcelRequire("cWbtJ");


const $7efa6822ec7605e5$var$Container = (0, $8c050ffba58637bd$export$3817b7a54a07cec7)("label")`
  color: ${({ disabled: disabled, theme: theme })=>disabled ? theme.colors.faint : theme.colors.text};
  display: flex;
  ${(p)=>`
    align-items: ${p.labelabove ? "flex-start" : "center"};
    flex-direction: ${p.labelabove ? "column" : "row"};
    gap: ${p.labelabove ? "0.5rem" : "0.7rem"};
    `}

  .title,
  .icon {
    color: ${(p)=>p.theme.colors.text};
    display: inline-block;
  }

  .title {
    font-size: 1.4rem;
  }

  .icon svg {
    width: 2rem;
    height: 2rem;
  }

  .select {
    background: ${(p)=>p.theme.colors.contrast};
    border-radius: ${(p)=>p.theme.radius};
    position: relative;
    display: inline-block;

    & > img {
      position: absolute;
      height: calc(100% - 8px);
      width: auto;
      left: 4px;
      top: 4px;
      filter: ${(p)=>p.disabled ? "brightness(0.7)" : "none"};
    }
  }

  select {
    appearance: none;
    border: 0;
    outline: none;
    background-color: transparent;
    padding: 0.6rem 1rem;
    padding-right: 3.7rem;
    font-size: 1.4rem;
    color: currentColor;
  }

  .arrow {
    position: absolute;
    right: 0;
    top: 0;
    height: 100%;
    width: 3rem;
    pointer-events: none;

    svg {
      position: absolute;
      transform: translate(-50%, -50%);
      top: 50%;
      left: 50%;
      width: 1rem;
      color: inherit;
    }

    path {
      fill: currentColor;
    }
  }
`;
const $7efa6822ec7605e5$export$931cbfb6bfb85fc = ({ children: children, disabled: disabled, label: label, labelabove: labelabove, icon: icon, img: img, onChange: onChange, value: value })=>/*#__PURE__*/ (0, $9e48c988ecb997e2$exports.jsxs)($7efa6822ec7605e5$var$Container, {
        disabled: disabled,
        labelabove: !icon && labelabove ? 1 : 0,
        children: [
            label && !icon && /*#__PURE__*/ (0, $9e48c988ecb997e2$exports.jsxs)("span", {
                className: "title",
                children: [
                    label,
                    ":"
                ]
            }),
            icon && /*#__PURE__*/ (0, $9e48c988ecb997e2$exports.jsx)("span", {
                className: "icon",
                title: icon ? label || "" : undefined,
                children: icon
            }),
            /*#__PURE__*/ (0, $9e48c988ecb997e2$exports.jsxs)("span", {
                className: "select",
                children: [
                    /*#__PURE__*/ (0, $9e48c988ecb997e2$exports.jsx)("select", {
                        disabled: disabled,
                        onChange: onChange,
                        value: value,
                        children: children
                    }),
                    img ? /*#__PURE__*/ (0, $9e48c988ecb997e2$exports.jsx)("img", {
                        src: img
                    }) : null,
                    /*#__PURE__*/ (0, $9e48c988ecb997e2$exports.jsx)("span", {
                        className: "arrow",
                        children: (0, $f6506ab558833d48$export$6d234affb3eeb911)
                    })
                ]
            })
        ]
    });




parcelRequire("cWbtJ");

const $af4b48e88a4444e2$var$Container = (0, $8c050ffba58637bd$export$3817b7a54a07cec7)("label")`
  position: relative;
  font-size: 0;
  cursor: pointer;
  display: inline-flex;
  ${(p)=>`
    align-items: ${p.labelabove ? "flex-start" : "center"};
    flex-direction: ${p.labelabove ? "column" : "row"};
    gap: ${p.labelabove ? "0.5rem" : "0.7rem"};
    `}

  input {
    position: absolute;
    width: 0;
    height: 0;
    opacity: 0;

    &:checked + .toggle-slider {
      svg {
        opacity: 1;
      }

      &:before {
        translate: calc(100% + 0.8rem);
        background: ${(p)=>p.theme.colors.accent};
      }
    }
  }

  svg {
    height: 2.2rem;
    width: auto;
  }

  .toggle-label {
    font-size: 1.4rem;
  }

  .toggle-slider {
    position: relative;
    display: inline-flex;
    padding: 0.4rem;
    gap: 0.8rem;
    background: ${(p)=>p.theme.colors.contrast};
    border-radius: ${(p)=>p.theme.radius};

    &:before {
      position: absolute;
      z-index: 1;
      content: "0";
      background: ${(p)=>p.theme.colors.background};
      border-radius: ${(p)=>p.theme.radius};
      height: calc(100% - 0.8rem);
      width: calc(50% - 0.8rem);
      top: 0.4rem;
      left: 0.4rem;
      transition:
        translate 0.1s ease-in-out,
        background-color 0.25s ease-in;
    }
  }

  .toggle-off {
    opacity: 0.5;
  }
`;
const $af4b48e88a4444e2$export$bea8ebba691c5813 = ({ label: label, labelabove: labelabove, offIcon: offIcon, onIcon: onIcon, toggled: toggled, onChange: onChange })=>/*#__PURE__*/ (0, $9e48c988ecb997e2$exports.jsxs)($af4b48e88a4444e2$var$Container, {
        labelabove: labelabove ? 1 : 0,
        children: [
            label ? /*#__PURE__*/ (0, $9e48c988ecb997e2$exports.jsxs)("span", {
                className: "toggle-label",
                children: [
                    label,
                    ":"
                ]
            }) : null,
            /*#__PURE__*/ (0, $9e48c988ecb997e2$exports.jsx)("input", {
                type: "checkbox",
                checked: toggled,
                onChange: (e)=>onChange?.(e.target.checked)
            }),
            /*#__PURE__*/ (0, $9e48c988ecb997e2$exports.jsxs)("span", {
                className: "toggle-slider",
                children: [
                    /*#__PURE__*/ (0, $9e48c988ecb997e2$exports.jsx)("span", {
                        className: "toggle-on",
                        children: onIcon
                    }),
                    /*#__PURE__*/ (0, $9e48c988ecb997e2$exports.jsx)("span", {
                        className: "toggle-off",
                        children: offIcon
                    })
                ]
            })
        ]
    });




const $626a13381375817b$export$d7a54cba636a8cd6 = (0, $8c050ffba58637bd$export$3817b7a54a07cec7)("div")(({ type: type, size: size = "2rem" })=>type === "hor" ? `
        display: inline-block;
        width: ${size};
      ` : `
        height: ${size};
      `);
const $626a13381375817b$export$801795dd2d9d1bc2 = (0, $8c050ffba58637bd$export$3817b7a54a07cec7)("h3")`
  font-size: 1.4rem;
  color: ${(p)=>p.theme.colors.faint};
  font-weight: 600;
  letter-spacing: 1px;
  margin-bottom: 1rem;
  margin-top: 2.5rem;
  text-transform: uppercase;

  &:first-child {
    margin-top: 0;
  }
`;




parcelRequire("cWbtJ");


var $jPSn7 = parcelRequire("jPSn7");
const $88f1d54fa905ddda$var$ButtonEl = (0, $8c050ffba58637bd$export$3817b7a54a07cec7)("button")((p)=>`
  background: ${p.theme.colors.contrast};
  border-radius: ${p.theme.radius};
  outline: solid 0.2rem ${p.theme.colors.contrast};
  border: solid 1px ${p.theme.colors.ghost};
  display: inline-flex;
  padding: 1rem;
  font-size: 1.2rem;
  cursor: pointer;
  text-transform: uppercase;
  font-weight: 600;
  position: relative;

  ${p.mode === "dark" ? `
    border-right-color: transparent;
  border-bottom-color: transparent;
    ` : `
    border-top-color: transparent;
  border-left-color: transparent;
    `}

  &:hover {
    color: ${p.theme.colors.dimmed};
  }

  &:active {
    color: ${p.theme.colors.faint};
    border-color: transparent;
  }

  ${p.withicon && `
    padding-left: 3.4rem;
    `}

  svg {
    position: absolute;
    left: 0;
    top: 50%;
    height: 1.8rem;
    translate: 0 -50%;
    animation: ${p.loading ? p.theme.animation.spin : "none"};

    path {
      fill: currentColor;
    }
  }

  &:disabled {
    color: ${p.theme.colors.faint};
    cursor: default;
  }
`);
const $88f1d54fa905ddda$export$353f5b6fc5456de1 = ({ children: children, icon: icon, loading: loading, type: type = "button", ...props })=>{
    const [mode] = (0, $jPSn7.useModeStore)();
    return /*#__PURE__*/ (0, $9e48c988ecb997e2$exports.jsxs)($88f1d54fa905ddda$var$ButtonEl, {
        ...props,
        type: type,
        disabled: loading,
        loading: loading ? 1 : 0,
        withicon: icon ? 1 : 0,
        mode: mode,
        children: [
            icon,
            children
        ]
    });
};




var $60bvA = parcelRequire("60bvA");
const $f9a78a383b8ee277$var$Container = (0, $8c050ffba58637bd$export$3817b7a54a07cec7)("div", (0, (/*@__PURE__*/$parcel$interopDefault($cWbtJ))).forwardRef)`
  position: absolute;
  display: flex;
  align-items: flex-start;
  flex-direction: column;
  gap: 1rem;
  padding: 2rem;
  padding-right: 4rem;
  padding-bottom: 4rem;
  overflow: auto;
  left: 100%;
  top: 100%;
  background: ${(p)=>p.background ?? p.theme.colors.darkerBackground};
  height: 100vh;
  translate: ${(p)=>p.active ? `-100%` : "0"} 0;
  transition: translate 0.1s ease-in-out;
`;
const $f9a78a383b8ee277$export$454b6381af1e7d46 = ({ background: background })=>{
    const { templates: templates } = (0, $774ae458d41d9a89$export$b3611e87cd5ba6ce)();
    const [sidebar, setSidebar] = (0, $jPSn7.useSidebarRightStore)();
    const [[templateId, templateTheme], setTemplate] = (0, $jPSn7.useTemplateStore)();
    const [mode, setMode] = (0, $jPSn7.useModeStore)();
    const sidebarRef = (0, $7dd950946054eea5$export$54c70f22f548bff8)(sidebar, ()=>setSidebar(false));
    const [busting, bust] = (0, $219aaf946aa87db5$export$7055e077554d4167)();
    const currentTemplate = (0, $60bvA.getMemoizedTemplate)(templates, templateId);
    (0, $cWbtJ.useEffect)(()=>{
        if (!templateId) (0, $60bvA.setTemplateWithFallback)(templates);
    }, [
        templates,
        templateId
    ]);
    return /*#__PURE__*/ (0, $9e48c988ecb997e2$exports.jsxs)($f9a78a383b8ee277$var$Container, {
        active: sidebar ? 1 : 0,
        background: background,
        id: "sidebar",
        ref: sidebarRef,
        children: [
            templates && /*#__PURE__*/ (0, $9e48c988ecb997e2$exports.jsxs)((0, $9e48c988ecb997e2$exports.Fragment), {
                children: [
                    /*#__PURE__*/ (0, $9e48c988ecb997e2$exports.jsx)((0, $626a13381375817b$export$801795dd2d9d1bc2), {
                        children: "Layout"
                    }),
                    /*#__PURE__*/ (0, $9e48c988ecb997e2$exports.jsx)((0, $7efa6822ec7605e5$export$931cbfb6bfb85fc), {
                        disabled: templates.length < 2,
                        label: "Template",
                        value: templateId,
                        onChange: (e)=>(0, $60bvA.setTemplateWithFallback)(templates, e.target.value),
                        labelabove: true,
                        children: templates.map(({ id: id, name: name })=>/*#__PURE__*/ (0, $9e48c988ecb997e2$exports.jsx)("option", {
                                value: id,
                                children: name
                            }, id))
                    }),
                    /*#__PURE__*/ (0, $9e48c988ecb997e2$exports.jsx)((0, $7efa6822ec7605e5$export$931cbfb6bfb85fc), {
                        disabled: !currentTemplate || currentTemplate.themes.length < 2,
                        label: "Theme",
                        value: templateTheme,
                        onChange: (e)=>setTemplate([
                                templateId,
                                e.target.value
                            ]),
                        labelabove: true,
                        children: currentTemplate?.themes.map(({ id: id, name: name })=>/*#__PURE__*/ (0, $9e48c988ecb997e2$exports.jsx)("option", {
                                value: id,
                                children: name
                            }, id))
                    })
                ]
            }),
            /*#__PURE__*/ (0, $9e48c988ecb997e2$exports.jsx)((0, $626a13381375817b$export$801795dd2d9d1bc2), {
                children: "Settings"
            }),
            /*#__PURE__*/ (0, $9e48c988ecb997e2$exports.jsx)((0, $88f1d54fa905ddda$export$353f5b6fc5456de1), {
                loading: busting,
                icon: (0, $f6506ab558833d48$export$cd267689a473783a),
                onClick: ()=>bust(),
                children: "Reload"
            }),
            /*#__PURE__*/ (0, $9e48c988ecb997e2$exports.jsx)((0, $626a13381375817b$export$801795dd2d9d1bc2), {
                children: "Settings"
            }),
            /*#__PURE__*/ (0, $9e48c988ecb997e2$exports.jsx)((0, $af4b48e88a4444e2$export$bea8ebba691c5813), {
                label: "Mode",
                offIcon: (0, $f6506ab558833d48$export$71180a2f62733d6f),
                onIcon: (0, $f6506ab558833d48$export$10942cc2688901b9),
                toggled: mode === "light",
                onChange: (toggled)=>setMode(toggled ? "light" : "dark"),
                labelabove: true
            })
        ]
    });
};




var $cWbtJ = parcelRequire("cWbtJ");



var $60bvA = parcelRequire("60bvA");


var $jPSn7 = parcelRequire("jPSn7");




const $07799fce208f2acd$var$FilterDropdown = ({ onChange: onChange, options: options, type: type, icon: icon, isSmallScreen: isSmallScreen, ...props })=>{
    const img = (0, $cWbtJ.useMemo)(()=>type === "language" && options?.find((o)=>o.id === props.value)?.language, [
        type,
        options,
        props.value
    ]);
    return Boolean(options?.length) && /*#__PURE__*/ (0, $9e48c988ecb997e2$exports.jsx)((0, $7efa6822ec7605e5$export$931cbfb6bfb85fc), {
        disabled: options.length === 1,
        onChange: (e)=>onChange(e.target.value),
        img: img && `${0, $219aaf946aa87db5$export$2c4e825dc9120f87}/assets/${img}.png`,
        icon: isSmallScreen ? undefined : icon,
        labelabove: isSmallScreen,
        ...props,
        children: options.map((o)=>/*#__PURE__*/ (0, $9e48c988ecb997e2$exports.jsx)("option", {
                value: o.id,
                children: (0, $60bvA.capitalize)(o[type])
            }, o.id))
    });
};
const $07799fce208f2acd$var$Info = (0, $8c050ffba58637bd$export$3817b7a54a07cec7)("button")`
  display: flex;
  font-size: 1.3rem;
  background: ${(p)=>p.theme.colors.contrast};
  border-radius: ${(p)=>p.theme.radius};
  text-transform: capitalize;
  cursor: pointer;

  ${(p)=>p.theme.breakpoint("normal")} {
    display: none;
  }
`;
const $07799fce208f2acd$var$InfoSectionSpan = (0, $8c050ffba58637bd$export$3817b7a54a07cec7)("span")`
  display: flex;
  align-items: center;
  max-width: 80px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  padding: 0.5rem;
  padding-right: 0;

  &.with-icon {
    padding: 0;
    padding-left: 0.5rem;
    padding-right: 0.5rem;
  }

  &:first-child {
    max-width: 100px;
    padding-left: 0.7rem;
  }

  &:last-child:not(.with-icon) {
    padding-right: 0.7rem;
  }

  svg {
    rotate: -90deg;
    width: 1rem;
    height: 1rem;
    margin-right: 0.5rem;
  }

  img {
    height: 1.6rem;
  }
`;
const $07799fce208f2acd$var$Container = (0, $8c050ffba58637bd$export$3817b7a54a07cec7)("div", (0, (/*@__PURE__*/$parcel$interopDefault($cWbtJ))).forwardRef)`
  display: flex;
  gap: 1.5rem;

  option.default {
    color: red;
    font-style: italic;
  }

  ${(p)=>p.theme.breakpoint("normal")} {
    & > h3 {
      display: none;
    }
  }

  ${(p)=>p.theme.breakpoint("small")} {
    position: absolute;
    flex-direction: column;
    gap: 1rem;
    padding: 2rem;
    padding-right: 4rem;
    padding-bottom: 4rem;
    overflow: auto;
    top: 100%;
    right: 100%;
    height: 100vh;
    background: ${(p)=>p.background ?? p.theme.colors.darkerBackground};
    transition: translate 0.1s ease-in-out;
    translate: ${(p)=>p.sidebar ? "100%" : "0"} 0;
  }
`;
const $07799fce208f2acd$var$InfoSection = ({ children: children, isLanguage: isLanguage })=>children && children !== "default" ? /*#__PURE__*/ (0, $9e48c988ecb997e2$exports.jsxs)($07799fce208f2acd$var$InfoSectionSpan, {
        className: isLanguage ? "with-icon" : undefined,
        children: [
            (0, $f6506ab558833d48$export$6d234affb3eeb911),
            isLanguage ? /*#__PURE__*/ (0, $9e48c988ecb997e2$exports.jsx)("img", {
                src: `${(0, $219aaf946aa87db5$export$2c4e825dc9120f87)}/assets/${children}.png`
            }) : children
        ]
    }) : null;
const $07799fce208f2acd$export$e78d617fcc83eef2 = ({ sidebarBgColor: sidebarBgColor })=>{
    const { resources: resources } = (0, $774ae458d41d9a89$export$b3611e87cd5ba6ce)();
    const [doc, setDoc] = (0, $jPSn7.useDocStore)();
    const [sidebar, setSidebar] = (0, $jPSn7.useSidebarLeftStore)();
    const sidebarRef = (0, $7dd950946054eea5$export$54c70f22f548bff8)(sidebar, ()=>setSidebar(false));
    const isSmallScreen = (0, $7dd950946054eea5$export$dd42f485803cd57d)("small");
    (0, $cWbtJ.useEffect)(()=>{
        // if there's no doc selected, select the first one
        if (!doc && resources) setDoc(resources[0]?.profiles[0]?.id);
    }, [
        doc,
        resources
    ]);
    const selectedResource = (0, $cWbtJ.useMemo)(()=>(0, $60bvA.getDetailsByDoc)(doc, resources), [
        doc,
        resources
    ]);
    // strip duplicate keys from dropdown options, i.e we don't want to show the same language twice
    const stripDuplicates = (key, list)=>list?.reduce((acc, p)=>{
            const existing = acc.find((x)=>x[key] === p[key]);
            if (!existing) acc.push(p);
            return acc;
        }, list.filter((x)=>x.id === doc)).toSorted((a, b)=>a[key] > b[key] ? 1 : -1);
    // get all (unique) available roles for the selected resource
    const roles = (0, $cWbtJ.useMemo)(()=>stripDuplicates("role", selectedResource?.profiles), [
        selectedResource
    ]);
    // get all (unique) available variants for the selected resource and current role
    const variants = (0, $cWbtJ.useMemo)(()=>stripDuplicates("variant", selectedResource?.profiles.filter((p)=>p.role === selectedResource?.profile.role)), [
        selectedResource
    ]);
    // get all (unique) available languages for the selected resource and current variant
    const languages = (0, $cWbtJ.useMemo)(()=>stripDuplicates("language", selectedResource?.profiles?.filter((p)=>p.variant === selectedResource?.profile.variant)), [
        selectedResource
    ]);
    const profile = selectedResource?.profile;
    if (!resources) return null;
    return /*#__PURE__*/ (0, $9e48c988ecb997e2$exports.jsxs)((0, $9e48c988ecb997e2$exports.Fragment), {
        children: [
            selectedResource?.name && profile && /*#__PURE__*/ (0, $9e48c988ecb997e2$exports.jsxs)($07799fce208f2acd$var$Info, {
                type: "button",
                onClick: ()=>setSidebar((s)=>!s),
                children: [
                    /*#__PURE__*/ (0, $9e48c988ecb997e2$exports.jsx)($07799fce208f2acd$var$InfoSectionSpan, {
                        children: selectedResource.name
                    }),
                    /*#__PURE__*/ (0, $9e48c988ecb997e2$exports.jsx)($07799fce208f2acd$var$InfoSection, {
                        children: profile.role
                    }),
                    /*#__PURE__*/ (0, $9e48c988ecb997e2$exports.jsx)($07799fce208f2acd$var$InfoSection, {
                        children: profile.variant
                    }),
                    /*#__PURE__*/ (0, $9e48c988ecb997e2$exports.jsx)($07799fce208f2acd$var$InfoSection, {
                        isLanguage: true,
                        children: profile.language
                    })
                ]
            }),
            /*#__PURE__*/ (0, $9e48c988ecb997e2$exports.jsxs)($07799fce208f2acd$var$Container, {
                sidebar: sidebar ? 1 : 0,
                background: sidebarBgColor,
                ref: sidebarRef,
                children: [
                    /*#__PURE__*/ (0, $9e48c988ecb997e2$exports.jsx)((0, $626a13381375817b$export$801795dd2d9d1bc2), {
                        children: "Profile"
                    }),
                    /*#__PURE__*/ (0, $9e48c988ecb997e2$exports.jsx)((0, $7efa6822ec7605e5$export$931cbfb6bfb85fc), {
                        disabled: resources.length < 2,
                        icon: isSmallScreen ? undefined : (0, $f6506ab558833d48$export$bcef9c3524fbd93f),
                        value: selectedResource?.id,
                        label: "Resource",
                        labelabove: isSmallScreen,
                        onChange: (e)=>setDoc(resources.find((r)=>r.id === e.target.value)?.profiles[0]?.id),
                        children: resources.filter((r)=>r.profiles.length).map(({ id: id, name: name })=>/*#__PURE__*/ (0, $9e48c988ecb997e2$exports.jsx)("option", {
                                value: id,
                                children: name
                            }, id))
                    }),
                    doc && /*#__PURE__*/ (0, $9e48c988ecb997e2$exports.jsxs)((0, $9e48c988ecb997e2$exports.Fragment), {
                        children: [
                            /*#__PURE__*/ (0, $9e48c988ecb997e2$exports.jsx)($07799fce208f2acd$var$FilterDropdown, {
                                icon: (0, $f6506ab558833d48$export$f0653e69c94e26a4),
                                onChange: setDoc,
                                options: roles,
                                type: "role",
                                value: doc,
                                label: "Role",
                                isSmallScreen: isSmallScreen
                            }),
                            /*#__PURE__*/ (0, $9e48c988ecb997e2$exports.jsx)($07799fce208f2acd$var$FilterDropdown, {
                                icon: (0, $f6506ab558833d48$export$d43c550b8e4c2ed9),
                                onChange: setDoc,
                                options: variants,
                                type: "variant",
                                value: doc,
                                label: "Variant",
                                isSmallScreen: isSmallScreen
                            }),
                            /*#__PURE__*/ (0, $9e48c988ecb997e2$exports.jsx)($07799fce208f2acd$var$FilterDropdown, {
                                icon: (0, $f6506ab558833d48$export$a22c1fe0e4ab6fe0),
                                onChange: setDoc,
                                options: languages,
                                type: "language",
                                value: doc,
                                label: "Language",
                                isSmallScreen: isSmallScreen
                            })
                        ]
                    })
                ]
            })
        ]
    });
};



var $60bvA = parcelRequire("60bvA");
const $6e05d0f25c307f81$var$Container = (0, $8c050ffba58637bd$export$3817b7a54a07cec7)("div", (0, (/*@__PURE__*/$parcel$interopDefault($cWbtJ))).forwardRef)`
  background: ${(p)=>p.background ?? p.theme.colors.contrast};
  padding: 1rem;
  display: flex;
  align-items: center;
  width: 100%;
  position: fixed;
  top: 0;
  z-index: 1;

  @media print {
    display: none;
  }
`;
const $6e05d0f25c307f81$var$Logo = (0, $8c050ffba58637bd$export$3817b7a54a07cec7)("img")`
  width: 22px;
  margin-right: 1.5rem;
  filter: grayscale(1)
    ${(p)=>p.mode === "dark" ? "brightness(100)" : "brightness(0)"};

  ${(p)=>p.theme.breakpoint("small")} {
    display: none;
  }
`;
const $6e05d0f25c307f81$var$Right = (0, $8c050ffba58637bd$export$3817b7a54a07cec7)("div")`
  margin-left: auto;
`;
const $6e05d0f25c307f81$var$Button = (0, $8c050ffba58637bd$export$3817b7a54a07cec7)("button")((p)=>`
margin: 0 0.3rem;

&:hover, &:disabled {
  opacity: 0.5;
  cursor: pointer;
}

& svg {
  width: 20px;
  height: 20px;
  margin-left: 1rem;
}

& #icon-reload {
  animation: ${p.spin ? p.theme.animation.spin : "none"};
}
`);
// BustButton is hidden on small screens
const $6e05d0f25c307f81$var$BustButton = (0, $8c050ffba58637bd$export$3817b7a54a07cec7)($6e05d0f25c307f81$var$Button)`
  ${(p)=>p.theme.breakpoint("small")} {
    display: none;
  }
`;
const $6e05d0f25c307f81$export$c72f6eaae7b9adff = ()=>{
    const { templates: templates } = (0, $774ae458d41d9a89$export$b3611e87cd5ba6ce)();
    const stickyRef = (0, $7dd950946054eea5$export$3a5ae2edeb8648ad)();
    const [[templateId]] = (0, $jPSn7.useTemplateStore)();
    const [mode] = (0, $jPSn7.useModeStore)();
    const [busting, bustCache] = (0, $219aaf946aa87db5$export$7055e077554d4167)();
    // since this is memoized we don't need to use useMemo
    const currentTemplate = (0, $60bvA.getMemoizedTemplate)(templates, templateId);
    const { settingsBgColor: settingsBgColor, sidebarBgColor: sidebarBgColor } = currentTemplate?.app?.mode?.[mode] ?? {};
    return /*#__PURE__*/ (0, $9e48c988ecb997e2$exports.jsxs)((0, $9e48c988ecb997e2$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $9e48c988ecb997e2$exports.jsxs)($6e05d0f25c307f81$var$Container, {
                ref: stickyRef,
                id: "settings",
                background: settingsBgColor,
                children: [
                    /*#__PURE__*/ (0, $9e48c988ecb997e2$exports.jsx)($6e05d0f25c307f81$var$Logo, {
                        src: `${(0, $219aaf946aa87db5$export$2c4e825dc9120f87)}/assets/logo.svg`,
                        mode: mode
                    }),
                    /*#__PURE__*/ (0, $9e48c988ecb997e2$exports.jsx)((0, $07799fce208f2acd$export$e78d617fcc83eef2), {
                        sidebarBgColor: sidebarBgColor
                    }),
                    /*#__PURE__*/ (0, $9e48c988ecb997e2$exports.jsxs)($6e05d0f25c307f81$var$Right, {
                        children: [
                            /*#__PURE__*/ (0, $9e48c988ecb997e2$exports.jsx)($6e05d0f25c307f81$var$BustButton, {
                                disabled: Boolean(busting),
                                onClick: ()=>bustCache(),
                                spin: busting ? 1 : 0,
                                children: (0, $f6506ab558833d48$export$cd267689a473783a)
                            }),
                            /*#__PURE__*/ (0, $9e48c988ecb997e2$exports.jsx)($6e05d0f25c307f81$var$Button, {
                                onClick: ()=>(0, $jPSn7.setSidebarRight)((s)=>!s),
                                children: (0, $f6506ab558833d48$export$db7947882cecde5c)
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $9e48c988ecb997e2$exports.jsx)((0, $f9a78a383b8ee277$export$454b6381af1e7d46), {
                        background: sidebarBgColor
                    })
                ]
            }),
            /*#__PURE__*/ (0, $9e48c988ecb997e2$exports.jsx)((0, $e2ccd29707c15da5$export$3ae18a2a755cc9c8), {
                background: settingsBgColor
            })
        ]
    });
};




var $cWbtJ = parcelRequire("cWbtJ");

var $cWbtJ = parcelRequire("cWbtJ");

var $48183eeaa92e30e7$export$83d89fbfd8236492;
var $48183eeaa92e30e7$export$80e7718417253a51;
var $48183eeaa92e30e7$export$eb3a06aef9e6ee51;
var $48183eeaa92e30e7$export$307591e98609eddd;
var $48183eeaa92e30e7$export$b23711c915539651;
var $48183eeaa92e30e7$export$7020a3240b287705;
"use strict";
var $48183eeaa92e30e7$var$l, $48183eeaa92e30e7$var$s;

$48183eeaa92e30e7$var$l = (parcelRequire("jXDQW"));

$48183eeaa92e30e7$var$s = (parcelRequire("ejyO0"));
$48183eeaa92e30e7$export$83d89fbfd8236492 = $48183eeaa92e30e7$var$l.version;
$48183eeaa92e30e7$export$80e7718417253a51 = $48183eeaa92e30e7$var$l.renderToString;
$48183eeaa92e30e7$export$eb3a06aef9e6ee51 = $48183eeaa92e30e7$var$l.renderToStaticMarkup;
$48183eeaa92e30e7$export$307591e98609eddd = $48183eeaa92e30e7$var$l.renderToNodeStream;
$48183eeaa92e30e7$export$b23711c915539651 = $48183eeaa92e30e7$var$l.renderToStaticNodeStream;
$48183eeaa92e30e7$export$7020a3240b287705 = $48183eeaa92e30e7$var$s.renderToReadableStream;


var $970d0a11275e32bc$exports = {};
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $970d0a11275e32bc$var$ReactIs, $970d0a11275e32bc$var$throwOnDirectAccess;

// By explicitly using `prop-types` you are opting into new production behavior.
// http://fb.me/prop-types-in-prod
$970d0a11275e32bc$exports = (parcelRequire("loUMh"))();


var $704512515d355f57$var$f = "undefined" != typeof globalThis ? globalThis : "undefined" != typeof window ? window : "undefined" != typeof $parcel$global ? $parcel$global : "undefined" != typeof self ? self : {};
function $704512515d355f57$var$p(e, r) {
    return e(r = {
        exports: {}
    }, r.exports), r.exports;
}
var $704512515d355f57$var$d = $704512515d355f57$var$p(function(e) {
    !function(r) {
        var t = function(e, r, n) {
            if (!u(r) || s(r) || f(r) || p(r) || i(r)) return r;
            var o, a = 0, c = 0;
            if (l(r)) for(o = [], c = r.length; a < c; a++)o.push(t(e, r[a], n));
            else for(var d in o = {}, r)Object.prototype.hasOwnProperty.call(r, d) && (o[e(d, n)] = t(e, r[d], n));
            return o;
        }, n = function(e) {
            return d(e) ? e : (e = e.replace(/[\-_\s]+(.)?/g, function(e, r) {
                return r ? r.toUpperCase() : "";
            })).substr(0, 1).toLowerCase() + e.substr(1);
        }, o = function(e) {
            var r = n(e);
            return r.substr(0, 1).toUpperCase() + r.substr(1);
        }, a = function(e, r) {
            return (function(e, r) {
                var t = (r = r || {}).separator || "_", n = r.split || /(?=[A-Z])/;
                return e.split(n).join(t);
            })(e, r).toLowerCase();
        }, c = Object.prototype.toString, i = function(e) {
            return "function" == typeof e;
        }, u = function(e) {
            return e === Object(e);
        }, l = function(e) {
            return "[object Array]" == c.call(e);
        }, s = function(e) {
            return "[object Date]" == c.call(e);
        }, f = function(e) {
            return "[object RegExp]" == c.call(e);
        }, p = function(e) {
            return "[object Boolean]" == c.call(e);
        }, d = function(e) {
            return (e -= 0) == e;
        }, y = function(e, r) {
            var t = r && "process" in r ? r.process : r;
            return "function" != typeof t ? e : function(r, n) {
                return t(r, e, n);
            };
        }, h = {
            camelize: n,
            decamelize: a,
            pascalize: o,
            depascalize: a,
            camelizeKeys: function(e, r) {
                return t(y(n, r), e);
            },
            decamelizeKeys: function(e, r) {
                return t(y(a, r), e, r);
            },
            pascalizeKeys: function(e, r) {
                return t(y(o, r), e);
            },
            depascalizeKeys: function() {
                return this.decamelizeKeys.apply(this, arguments);
            }
        };
        e.exports ? e.exports = h : r.humps = h;
    }($704512515d355f57$var$f);
}).decamelize;
var $704512515d355f57$var$y = function(e) {
    if (Array.isArray(e)) return e;
};
var $704512515d355f57$var$h = function(e, r) {
    if ("undefined" != typeof Symbol && Symbol.iterator in Object(e)) {
        var t = [], n = !0, o = !1, a = void 0;
        try {
            for(var c, i = e[Symbol.iterator](); !(n = (c = i.next()).done) && (t.push(c.value), !r || t.length !== r); n = !0);
        } catch (e) {
            o = !0, a = e;
        } finally{
            try {
                n || null == i.return || i.return();
            } finally{
                if (o) throw a;
            }
        }
        return t;
    }
};
var $704512515d355f57$var$v = function(e, r) {
    (null == r || r > e.length) && (r = e.length);
    for(var t = 0, n = new Array(r); t < r; t++)n[t] = e[t];
    return n;
};
var $704512515d355f57$var$m = function(e, r) {
    if (e) {
        if ("string" == typeof e) return $704512515d355f57$var$v(e, r);
        var t = Object.prototype.toString.call(e).slice(8, -1);
        return "Object" === t && e.constructor && (t = e.constructor.name), "Map" === t || "Set" === t ? Array.from(e) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? $704512515d355f57$var$v(e, r) : void 0;
    }
};
var $704512515d355f57$var$b = function() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
};
var $704512515d355f57$var$g = function(e, r) {
    return $704512515d355f57$var$y(e) || $704512515d355f57$var$h(e, r) || $704512515d355f57$var$m(e, r) || $704512515d355f57$var$b();
}, $704512515d355f57$var$S = $704512515d355f57$var$p(function(e) {
    function r() {
        return e.exports = r = Object.assign || function(e) {
            for(var r = 1; r < arguments.length; r++){
                var t = arguments[r];
                for(var n in t)Object.prototype.hasOwnProperty.call(t, n) && (e[n] = t[n]);
            }
            return e;
        }, r.apply(this, arguments);
    }
    e.exports = r;
});
var $704512515d355f57$var$w = function(e, r) {
    if (null == e) return {};
    var t, n, o = {}, a = Object.keys(e);
    for(n = 0; n < a.length; n++)t = a[n], r.indexOf(t) >= 0 || (o[t] = e[t]);
    return o;
};
var $704512515d355f57$var$O = function(e, r) {
    if (null == e) return {};
    var t, n, o = $704512515d355f57$var$w(e, r);
    if (Object.getOwnPropertySymbols) {
        var a = Object.getOwnPropertySymbols(e);
        for(n = 0; n < a.length; n++)t = a[n], r.indexOf(t) >= 0 || Object.prototype.propertyIsEnumerable.call(e, t) && (o[t] = e[t]);
    }
    return o;
};
var $704512515d355f57$var$j = (0, $cWbtJ.createContext)(null);
function $704512515d355f57$var$x(r) {
    var t = r.children, n = void 0 === t ? "" : t, o = $704512515d355f57$var$O(r, [
        "children"
    ]);
    return "string" != typeof n && (n = (0, $48183eeaa92e30e7$export$80e7718417253a51)(n)), (0, (/*@__PURE__*/$parcel$interopDefault($cWbtJ))).createElement("template", $704512515d355f57$var$S({}, o, {
        dangerouslySetInnerHTML: {
            __html: n
        }
    }));
}
function $704512515d355f57$var$z(e) {
    var r = e.root, t = e.children;
    return (0, $2b43e780cf0f0f59$exports.createPortal)(void 0 === t ? null : t, r);
}
function $704512515d355f57$var$E(n) {
    var i = (0, $cWbtJ.forwardRef)(function(o, i) {
        var u, l, s = o.mode, f = void 0 === s ? "open" : s, p = o.delegatesFocus, d = void 0 !== p && p, y = o.styleSheets, h = void 0 === y ? [] : y, v = o.ssr, m = void 0 !== v && v, b = o.children, w = $704512515d355f57$var$O(o, [
            "mode",
            "delegatesFocus",
            "styleSheets",
            "ssr",
            "children"
        ]), E = (l = (0, $cWbtJ.useRef)((u = i) && u.current), (0, $cWbtJ.useEffect)(function() {
            u && (u.current = l.current);
        }, [
            u
        ]), l), T = (0, $cWbtJ.useState)(null), A = $704512515d355f57$var$g(T, 2), C = A[0], P = A[1], F = "node_".concat(f).concat(d);
        return (0, $cWbtJ.useLayoutEffect)(function() {
            if (E.current) try {
                if ("function" == typeof i && i(E.current), m) {
                    var e = E.current.shadowRoot;
                    return void P(e);
                }
                var r = E.current.attachShadow({
                    mode: f,
                    delegatesFocus: d
                });
                h.length > 0 && (r.adoptedStyleSheets = h), P(r);
            } catch (e) {
                !function(e) {
                    var r = e.error, t = e.styleSheets, n = e.root;
                    switch(r.name){
                        case "NotSupportedError":
                            t.length > 0 && (n.adoptedStyleSheets = t);
                            break;
                        default:
                            throw r;
                    }
                }({
                    error: e,
                    styleSheets: h,
                    root: C
                });
            }
        }, [
            i,
            E,
            h
        ]), (0, (/*@__PURE__*/$parcel$interopDefault($cWbtJ))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cWbtJ))).Fragment, null, (0, (/*@__PURE__*/$parcel$interopDefault($cWbtJ))).createElement(n.tag, $704512515d355f57$var$S({
            key: F,
            ref: E
        }, w), (C || m) && (0, (/*@__PURE__*/$parcel$interopDefault($cWbtJ))).createElement($704512515d355f57$var$j.Provider, {
            value: C
        }, m ? (0, (/*@__PURE__*/$parcel$interopDefault($cWbtJ))).createElement($704512515d355f57$var$x, {
            shadowroot: f,
            shadowrootmode: f
        }, n.render({
            root: C,
            ssr: m,
            children: b
        })) : (0, (/*@__PURE__*/$parcel$interopDefault($cWbtJ))).createElement($704512515d355f57$var$z, {
            root: C
        }, n.render({
            root: C,
            ssr: m,
            children: b
        })))));
    });
    return i.propTypes = {
        mode: (0, (/*@__PURE__*/$parcel$interopDefault($970d0a11275e32bc$exports))).oneOf([
            "open",
            "closed"
        ]),
        delegatesFocus: (0, (/*@__PURE__*/$parcel$interopDefault($970d0a11275e32bc$exports))).bool,
        styleSheets: (0, (/*@__PURE__*/$parcel$interopDefault($970d0a11275e32bc$exports))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($970d0a11275e32bc$exports))).instanceOf(globalThis.CSSStyleSheet)),
        ssr: (0, (/*@__PURE__*/$parcel$interopDefault($970d0a11275e32bc$exports))).bool,
        children: (0, (/*@__PURE__*/$parcel$interopDefault($970d0a11275e32bc$exports))).node
    }, i;
}
$704512515d355f57$var$x.propTypes = {
    children: (0, (/*@__PURE__*/$parcel$interopDefault($970d0a11275e32bc$exports))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($970d0a11275e32bc$exports))).string,
        (0, (/*@__PURE__*/$parcel$interopDefault($970d0a11275e32bc$exports))).node
    ])
}, $704512515d355f57$var$z.propTypes = {
    root: (0, (/*@__PURE__*/$parcel$interopDefault($970d0a11275e32bc$exports))).object.isRequired,
    children: (0, (/*@__PURE__*/$parcel$interopDefault($970d0a11275e32bc$exports))).node
};
var $704512515d355f57$var$T = new Map;
function $704512515d355f57$export$64d45095031fa749() {
    return (0, $cWbtJ.useContext)($704512515d355f57$var$j);
}
function $704512515d355f57$export$7865d0c7f908de6b() {
    var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {}, r = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : "core", t = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : function(e) {
        return e.children;
    };
    return new Proxy(e, {
        get: function(e, n) {
            var o = $704512515d355f57$var$d(n, {
                separator: "-"
            }), a = "".concat(r, "-").concat(o);
            return $704512515d355f57$var$T.has(a) || $704512515d355f57$var$T.set(a, $704512515d355f57$var$E({
                tag: o,
                render: t
            })), $704512515d355f57$var$T.get(a);
        }
    });
}
var $704512515d355f57$var$P = $704512515d355f57$export$7865d0c7f908de6b();
var $704512515d355f57$export$2e2bcd8739ae039 = $704512515d355f57$var$P;




var $7gnIM = parcelRequire("7gnIM");

var $jPSn7 = parcelRequire("jPSn7");


var $60bvA = parcelRequire("60bvA");


const $84bc173fc0167c43$var$RootDiv = (0, $704512515d355f57$export$2e2bcd8739ae039).div;
const $84bc173fc0167c43$var$ErrorMessage = ({ msg: msg })=>{
    const theme = (0, $8c53fefc62d3de5b$export$93d4e7f90805808f)();
    return /*#__PURE__*/ (0, $9e48c988ecb997e2$exports.jsx)("div", {
        className: "PROFILER--ERROR",
        children: /*#__PURE__*/ (0, $9e48c988ecb997e2$exports.jsx)("p", {
            dangerouslySetInnerHTML: {
                __html: msg
            },
            style: {
                background: theme.colors.danger
            }
        })
    });
};
const $84bc173fc0167c43$export$bceacc74c2212615 = ()=>{
    const rootEl = (0, $cWbtJ.useRef)(null);
    const [mode] = (0, $jPSn7.useModeStore)();
    const [[templateId, themeId]] = (0, $jPSn7.useTemplateStore)();
    const { resources: resources, templates: templates, error: configError } = (0, $774ae458d41d9a89$export$b3611e87cd5ba6ce)();
    const [doc] = (0, $jPSn7.useDocStore)();
    const [error, setError] = (0, $cWbtJ.useState)(null);
    const { compile: compile, render: render } = (0, $cWbtJ.useMemo)(()=>(0, $7gnIM.makeRender)((s)=>`${0, $219aaf946aa87db5$export$2c4e825dc9120f87}/${s.replace("assets/", `assets/${templateId}/`)}`), [
        templateId
    ]);
    const templateInfo = (0, $60bvA.getMemoizedTemplate)(templates, templateId);
    const themeInfo = (0, $cWbtJ.useMemo)(()=>templateInfo && templateInfo.themes.find((t)=>t.id === themeId), [
        templateInfo,
        themeId
    ]);
    const resource = (0, $cWbtJ.useMemo)(()=>(0, $60bvA.getDetailsByDoc)(doc, resources), [
        resources,
        doc
    ]);
    // set background color
    const background = templateInfo?.app?.mode?.[mode]?.documentBgColor;
    (0, $cWbtJ.useLayoutEffect)(()=>{
        if (background) document.body.style.backgroundColor = background;
    }, [
        background
    ]);
    // load renderer styles, template, theme and profile -->
    const { data: rendererStyles, error: stylesError } = (0, $219aaf946aa87db5$export$eb2799109db70ffd)("rendererStyles", "/styles");
    const { data: template, error: e1 } = (0, $219aaf946aa87db5$export$eb2799109db70ffd)("template", templateInfo?.url);
    const { data: theme, error: e2 } = (0, $219aaf946aa87db5$export$eb2799109db70ffd)("theme", themeInfo?.url);
    const { data: profile, error: e3 } = (0, $219aaf946aa87db5$export$eb2799109db70ffd)("profile", resource?.profile.url);
    // <-- load renderer styles, template, theme and profile
    // compile and generate markup from template and profile data
    const markup = (0, $cWbtJ.useMemo)(()=>template && profile ? compile(template)(profile.data) : undefined, [
        template,
        profile
    ]);
    (0, $cWbtJ.useEffect)(()=>{
        if (profile) {
            const { data: _, ...info } = profile;
            // save document info for statusbar stats
            (0, $jPSn7.setDocumentInfo)((state)=>({
                    ...state,
                    ...info
                }));
        }
    }, [
        document,
        profile
    ]);
    // error checker
    (0, $cWbtJ.useEffect)(()=>{
        let e = null;
        if (configError) e ??= "config";
        if (stylesError) e ??= "styles";
        if (e1) e ??= "template";
        if (e2) e ??= "theme";
        if (e3) e ??= "profile";
        if (e) setError(`Error loading <b>${e}</b>. Try reloading the page.`);
    }, [
        configError,
        stylesError,
        template,
        e1,
        theme,
        e2,
        profile,
        e3
    ]);
    const pageWidthRef = (0, $cWbtJ.useRef)();
    (0, $cWbtJ.useEffect)(()=>{
        if (rendererStyles && templateInfo && markup && rootEl.current && theme) {
            // render document in rootEl
            const nPages = render({
                styles: rendererStyles,
                markup: markup,
                pageConfig: templateInfo.page,
                background: background,
                root: rootEl.current,
                theme: theme
            });
            // save document info for statusbar stats
            (0, $jPSn7.setDocumentInfo)((state)=>({
                    ...state,
                    nPages: nPages
                }));
            pageWidthRef.current = rootEl.current.querySelector(".__profiler-page").offsetWidth;
        }
    }, [
        rendererStyles,
        templateInfo,
        markup,
        rootEl.current,
        theme,
        mode
    ]);
    // zoom document to fit page width -->
    const isZoomed = (0, $cWbtJ.useRef)(false);
    (0, $7dd950946054eea5$export$e8b771555dc4a003)(()=>{
        const winWidth = window.innerWidth;
        if (!pageWidthRef.current || !rootEl.current) return;
        const pageWidth = pageWidthRef.current + 50; // offset for some page margin
        if (winWidth < pageWidth) {
            const ratio = winWidth / pageWidth;
            rootEl.current.style.zoom = `${ratio}`;
            isZoomed.current = true;
        } else if (isZoomed.current) {
            rootEl.current.style.zoom = "1";
            isZoomed.current = false;
        }
    });
    // <-- zoom document to fit page width
    return /*#__PURE__*/ (0, $9e48c988ecb997e2$exports.jsxs)($84bc173fc0167c43$var$RootDiv, {
        children: [
            error && /*#__PURE__*/ (0, $9e48c988ecb997e2$exports.jsx)($84bc173fc0167c43$var$ErrorMessage, {
                msg: error
            }),
            /*#__PURE__*/ (0, $9e48c988ecb997e2$exports.jsx)("div", {
                id: "document",
                ref: rootEl
            })
        ]
    });
};


const $08559cd5eea5b121$var$BaseStyles = (0, $7fc8fcf516abead4$export$44ca1bc323e2cb20)`
  html {
    font-size: 55%;
  }

  html, #app {
    box-sizing: border-box;
    font-family: Helvetica, Arial, sans-serif;
  }
  
  *, *:before, *:after {
    box-sizing: inherit;
    font: inherit;
  }

  body {
      background: ${(p)=>p.theme.colors.background};
      color: ${(p)=>p.theme.colors.text};
      height: 100%;
  }

  #app {
    height: 100%;
    max-height: 100%;
  }

  @property --download-progress {
    syntax: '<percentage>';
    inherits: false;
    initial-value: 0%;
  }

  @media print {
    @page {
      margin: 0;
    }

    #app {
      margin: 0;
    }
  }
`;
const $08559cd5eea5b121$var$Container = (0, $8c050ffba58637bd$export$3817b7a54a07cec7)("div")`
  position: relative;
`;
const $08559cd5eea5b121$var$printVersion = (v)=>console.log("%cProfiler", "font-weight: bold", `v${v}`);
const $08559cd5eea5b121$var$App = ()=>{
    (0, $cWbtJ.useEffect)(()=>{
        const version = "1.3.0 \uD83D\uDE80 Thu, 21 May 2026 18:24:00 GMT";
        if (version) $08559cd5eea5b121$var$printVersion(version);
        else var pkg;
    }, []);
    return /*#__PURE__*/ (0, $9e48c988ecb997e2$exports.jsxs)((0, $8c53fefc62d3de5b$export$d8964aec282183a3), {
        children: [
            /*#__PURE__*/ (0, $9e48c988ecb997e2$exports.jsx)($08559cd5eea5b121$var$BaseStyles, {}),
            /*#__PURE__*/ (0, $9e48c988ecb997e2$exports.jsxs)($08559cd5eea5b121$var$Container, {
                children: [
                    /*#__PURE__*/ (0, $9e48c988ecb997e2$exports.jsx)((0, $bafd6085c2106d22$export$3b0d6d7590275603), {}),
                    /*#__PURE__*/ (0, $9e48c988ecb997e2$exports.jsx)((0, $6e05d0f25c307f81$export$c72f6eaae7b9adff), {}),
                    /*#__PURE__*/ (0, $9e48c988ecb997e2$exports.jsx)((0, $84bc173fc0167c43$export$bceacc74c2212615), {})
                ]
            })
        ]
    });
};
const $08559cd5eea5b121$var$root = (0, $cf32b50829570373$export$882461b6382ed46c)(document.getElementById("app"));
$08559cd5eea5b121$var$root.render(/*#__PURE__*/ (0, $9e48c988ecb997e2$exports.jsx)((0, $5637d36f54c10878$export$45604f0cc8ae667b), {
    client: (0, $219aaf946aa87db5$export$7c07b633a151f9c5),
    children: /*#__PURE__*/ (0, $9e48c988ecb997e2$exports.jsx)($08559cd5eea5b121$var$App, {})
}));


//# sourceMappingURL=index.d4d6c74e.js.map
